import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';

var SvgActions16X16 = function SvgActions16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -actions",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm0 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    clipRule: "evenodd"
  }));
};

var SvgActions24X24 = function SvgActions24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -actions",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 20a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0-10a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0-10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }));
};

var SvgAgency104X104 = function SvgAgency104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -agency",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.073 35.219a.96.96 0 0 0 .024 0h76.662v50.792H72.666V49.257c0-.658-.538-1.193-1.2-1.193H32.534c-.663 0-1.2.535-1.2 1.193v36.754H9.24V35.219h8.832zm6.755-17.23-5.336 15.24h81.997a.51.51 0 0 0 .511-.507V18.497a.51.51 0 0 0-.511-.508h-76.66zm-2.117 0-5.337 15.24H2.51a.51.51 0 0 1-.51-.507V18.497a.51.51 0 0 1 .51-.508h20.2zM24.094 16H2.51A2.504 2.504 0 0 0 0 18.497v14.225a2.504 2.504 0 0 0 2.51 2.497h4.73v50.99c0 .99.806 1.79 1.8 1.79h42.935a1.036 1.036 0 0 0 .05 0h42.934c.994 0 1.8-.8 1.8-1.79V35.22h4.73A2.505 2.505 0 0 0 104 32.722V18.497A2.505 2.505 0 0 0 101.489 16H24.141a.901.901 0 0 0-.047 0zm46.572 70.01H53V50.054h17.666v35.958zM51 86.01V50.054H33.334v35.958H51z",
    clipRule: "evenodd"
  }));
};

var SvgAgency16X16 = function SvgAgency16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -agency",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 5.438H13.936v6.302c0 .16-.134.291-.3.291H11.39V7.272a.69.69 0 0 0-.699-.678H5.307a.689.689 0 0 0-.699.678v4.759H2.365c-.166 0-.3-.13-.3-.29V5.437H3zm1.255-2.469-.539 1.5h10.72a.54.54 0 0 1 .02 0H15v-1.5H4.255zm-1.06 0-.538 1.5H1.564a.54.54 0 0 0-.02 0H1v-1.5h2.196zM3.889 2H.722C.322 2 0 2.314 0 2.7v2.038c0 .387.323.7.722.7h.343v6.302c0 .696.581 1.26 1.3 1.26h11.269c.719 0 1.301-.564 1.301-1.26V5.438h.342a.711.711 0 0 0 .723-.7V2.7c0-.387-.324-.7-.723-.7H3.911a.53.53 0 0 0-.023 0zm6.503 10.031H8.5V7.563h1.891v4.468zm-2.891 0V7.563H5.608v4.468H7.5z",
    clipRule: "evenodd"
  }));
};

var SvgAgency24X24 = function SvgAgency24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -agency",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.056 6.936H23V4.008H6.068L5.056 6.936Zm-.047-2.928L3.997 6.936H1V4.008h4.009ZM5.7 3H.84A.844.844 0 0 0 0 3.847v3.25c0 .468.376.846.841.846h.791V18.69c0 .724.583 1.31 1.3 1.31H21.067c.718 0 1.3-.586 1.3-1.31V7.943h.792A.844.844 0 0 0 24 7.096V3.847A.845.845 0 0 0 23.159 3H5.701Zm11.233 15.993h4.133c.166 0 .3-.136.3-.303V7.944H2.632V18.69c0 .167.135.303.3.303h4.133V11.03c0-.39.314-.705.7-.705h4.212a.564.564 0 0 1 .045 0h4.212c.386 0 .7.315.7.705v7.963Zm-8.869-7.66H11.5v7.66H8.065v-7.66Zm7.87 7.66H12.5v-7.66h3.434v7.66Z",
    fill: "currentColor"
  }));
};

var SvgAgriculture104X104 = function SvgAgriculture104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -agriculture",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M104 7.044A7.044 7.044 0 0 0 96.955 0H7.045A7.044 7.044 0 0 0 0 7.044v27.973c.695 30.35 20.982 57.398 51.636 68.919.227.085.477.085.704 0C83.002 92.42 103.298 65.372 104 35.04V7.044zm-2 0v27.973c-.679 29.355-20.292 55.604-50.012 66.914C22.276 90.616 2.672 64.367 2 34.994V7.044A5.044 5.044 0 0 1 7.045 2h89.91A5.044 5.044 0 0 1 102 7.044zM72.122 55.07H57.01a22.136 22.136 0 0 0-6.508-12.796h32.01L80.227 55.07h-8.105zm5.399 2h3.544a1 1 0 0 0 .984-.824L84.69 41.45a1 1 0 0 0-.984-1.176h-15.91V26.16a2.911 2.911 0 0 1 2.91-2.911h.318a1 1 0 1 0 0-2h-.317a4.911 4.911 0 0 0-4.911 4.91v14.114H54.948l-4.077-22.43a1 1 0 0 0-.984-.821H26.635a1 1 0 0 0-1 1v20.12a22.106 22.106 0 0 0-6.041 4.214 1 1 0 1 0 1.4 1.428 20.1 20.1 0 0 1 5.74-3.947.997.997 0 0 0 .564-.247c6.347-2.66 13.771-1.92 19.508 2.192.134.227.356.396.618.461a20.136 20.136 0 0 1 7.804 15.939 1 1 0 1 0 2 .002c0-.373-.009-.745-.027-1.115h9.44a8.398 8.398 0 1 0 10.88 0zm-5.476 0h.072a6.398 6.398 0 0 1 6.361 6.398 6.397 6.397 0 1 1-12.795 0 6.398 6.398 0 0 1 6.362-6.398zM48.132 40.274c-5.998-4.383-13.715-5.378-20.497-2.958V19.023h21.417l3.863 21.25h-4.783zM35.09 44.5c7.557 0 13.683 6.126 13.683 13.683 0 7.557-6.126 13.683-13.683 13.683-7.557 0-13.683-6.127-13.683-13.684 0-7.556 6.126-13.681 13.683-13.681zm0 2c-6.452 0-11.683 5.231-11.683 11.683s5.23 11.683 11.683 11.683c6.452 0 11.683-5.23 11.683-11.684 0-6.451-5.23-11.681-11.683-11.681z",
    clipRule: "evenodd"
  }));
};

var SvgAgriculture16X16 = function SvgAgriculture16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -agriculture",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 5.491c-.096 4.137-2.837 7.836-7.002 9.474C3.834 13.326 1.095 9.627 1 5.503V1.389A.39.39 0 0 1 1.389 1h13.222a.39.39 0 0 1 .389.389v4.102zM14.611 0H1.389A1.39 1.39 0 0 0 0 1.389v4.125c.105 4.604 3.176 8.708 7.822 10.455a.506.506 0 0 0 .352 0c4.647-1.746 7.72-5.85 7.826-10.466V1.389A1.39 1.39 0 0 0 14.611 0zM5.514 10.275a1.366 1.366 0 0 1 0-2.73 1.366 1.366 0 0 1 0 2.73zm0-3.73A2.368 2.368 0 0 0 3.149 8.91a2.368 2.368 0 0 0 2.365 2.365A2.367 2.367 0 0 0 7.878 8.91a2.367 2.367 0 0 0-2.364-2.365zm4.851 3.142a.589.589 0 0 0 1.176 0 .589.589 0 0 0-1.176 0zM4.77 3.504v1.874c.246-.052.495-.077.744-.077a3.6 3.6 0 0 1 2.007.622h.192l-.44-2.42H4.77zm7.086 4.595.21-1.176h-3.54c.237.359.4.757.496 1.176h2.834zm-1.179-2.176h1.987a.502.502 0 0 1 .492.588l-.389 2.176a.496.496 0 0 1-.349.387 1.59 1.59 0 0 1-1.464 2.201 1.59 1.59 0 0 1-1.588-1.588c0-.208.043-.406.115-.588h-.396a.5.5 0 0 1-.962-.19 2.611 2.611 0 0 0-3.587-2.421.472.472 0 0 1-.136.06 2.635 2.635 0 0 0-.713.497.5.5 0 0 1-.699-.714c.238-.235.503-.43.782-.583V3.004a.5.5 0 0 1 .5-.5h3.42a.5.5 0 0 1 .493.41l.546 3.009h.948V4.2c0-.593.482-1.075 1.075-1.075.276 0 .523.223.523.5 0 .276-.2.5-.476.5-.088 0-.122.033-.122.075v1.722z",
    clipRule: "evenodd"
  }));
};

var SvgAgriculture24X24 = function SvgAgriculture24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -agriculture",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M17.4 13.258a1.877 1.877 0 1 1-3.32 0h-.804a.5.5 0 0 1-.989-.106c0-.112-.005-.224-.016-.334a.502.502 0 0 1-.001-.02 3.444 3.444 0 0 0-1.276-2.337.501.501 0 0 1-.184-.137 3.445 3.445 0 0 0-3.252-.362.497.497 0 0 1-.172.075c-.34.16-.66.379-.943.656a.5.5 0 1 1-.7-.714c.314-.308.663-.56 1.032-.755V5.671a.5.5 0 0 1 .5-.5h4.331a.5.5 0 0 1 .492.41l.713 3.921h1.445V7.187c0-.678.55-1.228 1.229-1.228h.059a.5.5 0 1 1 0 1h-.06a.228.228 0 0 0-.228.228v2.315h2.65a.5.5 0 0 1 .492.588l-.492 2.756a.5.5 0 0 1-.492.412H17.4zm-5.606-3.756-.605-3.33H7.775v2.67a4.444 4.444 0 0 1 3.605.66h.414zm.618 1c.387.522.655 1.122.785 1.756h3.798l.314-1.756h-4.897zM20.374 2C21.272 2 22 2.728 22 3.626v5.222c-.134 5.782-3.998 10.931-9.826 13.12a.5.5 0 0 1-.352 0C5.995 19.778 2.132 14.628 2 8.836v-5.21C2 2.728 2.728 2 3.626 2h16.748zM21 8.836v-5.21A.626.626 0 0 0 20.374 3H3.626A.626.626 0 0 0 3 3.626v5.199c.122 5.304 3.642 10.054 8.998 12.14 5.357-2.086 8.88-6.835 9.002-12.129zm-5.26 4.422a.878.878 0 1 0 0 1.756.878.878 0 0 0 0-1.756zM8.85 10.29a2.862 2.862 0 1 1 .001 5.724 2.862 2.862 0 0 1-.001-5.724zm0 1a1.862 1.862 0 1 0 0 3.724 1.862 1.862 0 0 0 0-3.724z"
  }));
};

var SvgAlert104X104 = function SvgAlert104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -alert",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M86.894 104H19.1C5.66 104-3.083 89.849 2.928 77.823L36.825 9.999c6.664-13.332 25.681-13.332 32.344 0l33.898 67.824C109.078 89.849 100.335 104 86.895 104zM67.38 10.894c-5.925-11.857-22.84-11.857-28.766 0L4.717 78.717C-.63 89.415 7.147 102 19.1 102h67.793c11.955 0 19.73-12.585 14.384-23.282L67.38 10.895zM53.997 69.138V34.862a1 1 0 1 0-2 0v34.276a1 1 0 1 0 2 0zm-1 16.465a2.292 2.292 0 1 1 0-4.587 2.292 2.292 0 0 1 0 4.587z",
    clipRule: "evenodd"
  }));
};

var SvgAlert16X16 = function SvgAlert16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -alert",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.016 16C.776 16-.679 13.642.322 11.639l4.985-9.974c1.11-2.22 4.277-2.22 5.387 0l4.985 9.974C16.68 13.642 15.224 16 12.985 16H3.016zM6.201 2.113l-4.985 9.973C.547 13.424 1.52 15 3.016 15h9.97c1.494 0 2.468-1.576 1.799-2.914L9.8 2.113C9.058.63 6.943.63 6.2 2.113zm2.3 8.407V5.48a.5.5 0 1 0-1 0v5.04a.5.5 0 1 0 1 0zM8 13.23a.625.625 0 1 1 0-1.251.625.625 0 0 1 0 1.25z",
    clipRule: "evenodd"
  }));
};

var SvgAlert24X24 = function SvgAlert24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -alert",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M9.601 4.483 3.287 17.117C2.395 18.901 3.692 21 5.686 21h12.628c1.993 0 3.29-2.098 2.399-3.882L14.399 4.483c-.99-1.977-3.81-1.977-4.798 0zM5.686 22c-2.737 0-4.518-2.882-3.293-5.33L8.707 4.036c1.357-2.715 5.229-2.715 6.586 0l6.314 12.634c1.224 2.448-.556 5.33-3.293 5.33H5.686zm6.814-6.807a.5.5 0 1 1-1 0V8.807a.5.5 0 1 1 1 0v6.386zm-1.165 2.64a.665.665 0 1 1 1.331 0 .665.665 0 0 1-1.331 0z"
  }));
};

var SvgApps104X104 = function SvgApps104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -apps",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M35.756 0H7.045A7.044 7.044 0 0 0 0 7.045v28.711A7.044 7.044 0 0 0 7.045 42.8h28.711a7.044 7.044 0 0 0 7.044-7.044V7.045A7.044 7.044 0 0 0 35.756 0zM2 7.045A5.044 5.044 0 0 1 7.045 2h28.711A5.044 5.044 0 0 1 40.8 7.045v28.711a5.044 5.044 0 0 1-5.044 5.044H7.045A5.044 5.044 0 0 1 2 35.756V7.045zM96.955 0h-28.71A7.044 7.044 0 0 0 61.2 7.045v28.711a7.044 7.044 0 0 0 7.044 7.044h28.711A7.044 7.044 0 0 0 104 35.756V7.045A7.045 7.045 0 0 0 96.955 0zM63.2 7.045A5.044 5.044 0 0 1 68.244 2h28.711A5.044 5.044 0 0 1 102 7.045v28.711a5.044 5.044 0 0 1-5.045 5.044h-28.71a5.044 5.044 0 0 1-5.045-5.044V7.045zM7.045 61.2h28.711a7.044 7.044 0 0 1 7.044 7.044v28.711A7.044 7.044 0 0 1 35.756 104H7.046A7.045 7.045 0 0 1 0 96.955V68.244A7.044 7.044 0 0 1 7.045 61.2zM2 68.244A5.044 5.044 0 0 1 7.045 63.2h28.711a5.044 5.044 0 0 1 5.044 5.044v28.711A5.044 5.044 0 0 1 35.756 102H7.046A5.044 5.044 0 0 1 2 96.955V68.244zM68.244 61.2h28.711A7.044 7.044 0 0 1 104 68.244v28.711A7.045 7.045 0 0 1 96.955 104h-28.71a7.044 7.044 0 0 1-7.045-7.045v-28.71a7.044 7.044 0 0 1 7.044-7.045zm0 2a5.044 5.044 0 0 0-5.044 5.044v28.711A5.044 5.044 0 0 0 68.244 102h28.711A5.044 5.044 0 0 0 102 96.955v-28.71a5.044 5.044 0 0 0-5.045-5.045h-28.71z",
    clipRule: "evenodd"
  }));
};

var SvgApps16X16 = function SvgApps16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -apps",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.612 0H1.389A1.39 1.39 0 0 0 0 1.389v4.222A1.39 1.39 0 0 0 1.389 7h4.223C6.378 7 7 6.378 7 5.611V1.389C7 .622 6.378 0 5.612 0zM1 1.389A.39.39 0 0 1 1.389 1h4.223c.214 0 .388.174.388.389v4.222A.389.389 0 0 1 5.612 6H1.389A.39.39 0 0 1 1 5.611V1.389zM14.612 0h-4.223A1.39 1.39 0 0 0 9 1.389v4.222A1.39 1.39 0 0 0 10.389 7h4.223C15.378 7 16 6.378 16 5.611V1.389C16 .622 15.378 0 14.612 0zM10 1.389A.39.39 0 0 1 10.389 1h4.223c.214 0 .388.174.388.389v4.222a.389.389 0 0 1-.388.389h-4.223A.39.39 0 0 1 10 5.611V1.389zM1.389 9h4.223C6.378 9 7 9.622 7 10.389v4.222C7 15.378 6.378 16 5.612 16H1.389A1.39 1.39 0 0 1 0 14.611v-4.222A1.39 1.39 0 0 1 1.389 9zM1 10.389A.39.39 0 0 1 1.389 10h4.223c.214 0 .388.174.388.389v4.222a.389.389 0 0 1-.388.389H1.389A.39.39 0 0 1 1 14.611v-4.222zM10.389 9h4.223C15.378 9 16 9.622 16 10.389v4.222c0 .767-.622 1.389-1.388 1.389h-4.223A1.39 1.39 0 0 1 9 14.611v-4.222A1.39 1.39 0 0 1 10.389 9zm0 1a.39.39 0 0 0-.389.389v4.222a.39.39 0 0 0 .389.389h4.223a.389.389 0 0 0 .388-.389v-4.222a.389.389 0 0 0-.388-.389h-4.223z",
    clipRule: "evenodd"
  }));
};

var SvgApps24X24 = function SvgApps24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    role: "img",
    className: "icon -apps"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M3.626 2h5.348c.898 0 1.626.728 1.626 1.626v5.348c0 .898-.728 1.626-1.626 1.626H3.626A1.626 1.626 0 0 1 2 8.974V3.626C2 2.728 2.728 2 3.626 2zm0 1A.626.626 0 0 0 3 3.626v5.348c0 .346.28.626.626.626h5.348c.346 0 .626-.28.626-.626V3.626A.626.626 0 0 0 8.974 3H3.626zm11.4-1h5.348C21.273 2 22 2.728 22 3.626v5.348c0 .898-.727 1.626-1.626 1.626h-5.348A1.626 1.626 0 0 1 13.4 8.974V3.626c0-.898.728-1.626 1.626-1.626zm0 1a.626.626 0 0 0-.626.626v5.348c0 .346.28.626.626.626h5.348c.346 0 .626-.28.626-.626V3.626A.626.626 0 0 0 20.374 3h-5.348zm-11.4 10.4h5.347c.899 0 1.626.728 1.626 1.626v5.348c0 .898-.727 1.626-1.626 1.626H3.626A1.626 1.626 0 0 1 2 20.374v-5.348c0-.898.728-1.626 1.626-1.626zm0 1a.626.626 0 0 0-.626.626v5.348c0 .346.28.626.626.626h5.347c.346 0 .626-.28.626-.626v-5.348a.626.626 0 0 0-.626-.626H3.626zm11.4-1h5.348c.899 0 1.626.728 1.626 1.626v5.348c0 .899-.727 1.626-1.626 1.626h-5.348a1.626 1.626 0 0 1-1.626-1.626v-5.348c0-.898.728-1.626 1.626-1.626zm0 1a.626.626 0 0 0-.626.626v5.348c0 .346.28.626.626.626h5.348c.346 0 .626-.28.626-.626v-5.348a.626.626 0 0 0-.626-.626h-5.348z"
  }));
};

var SvgArrowDownRight104X104 = function SvgArrowDownRight104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-down-right",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M102.01 41.917a.99.99 0 0 1 .99.99v59.103a.99.99 0 0 1-.99.99H42.907a.99.99 0 1 1 0-1.981H99.62L1.29 2.691a.99.99 0 1 1 1.4-1.401l98.329 98.329V42.907a.99.99 0 0 1 .991-.99z",
    clipRule: "evenodd"
  }));
};

var SvgArrowDownRight16X16 = function SvgArrowDownRight16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-down-right",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.844 1.146a.503.503 0 0 0-.693-.015.46.46 0 0 0-.015.669l12.168 12.254h-6.42c-.27 0-.49.212-.49.473s.22.473.49.473h7.626c.27 0 .49-.212.49-.473v-7.84a.482.482 0 0 0-.49-.474c-.27 0-.49.212-.49.473v6.721L1.844 1.146z",
    clipRule: "evenodd"
  }));
};

var SvgArrowDownRight24X24 = function SvgArrowDownRight24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    className: "icon -arrow-down-right",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.85 22a.579.579 0 0 1-.093-1.151l.094-.008 14.197.001-.065-.056L2.173 2.975a.574.574 0 0 1-.01-.811.574.574 0 0 1 .812.008l17.763 17.764.103.12V5.85a.58.58 0 0 1 .475-.57l.104-.01c.288 0 .527.21.572.486l.007.093L22 21.42c0 .088-.02.172-.055.247-.004.005-.006.01-.009.016-.01.02-.02.04-.033.06l-.02.027-.033.039a.575.575 0 0 1-.157.123c-.005.001-.01.004-.016.007a.553.553 0 0 1-.166.054l-.09.007H5.85z"
  }));
};

var SvgArrowDownUp104X104 = function SvgArrowDownUp104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    className: "icon-arrow-down-up",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m50.237 74.376-23.23 25.998V.994c0-.549-.451-.994-1.008-.994-.556 0-1.007.445-1.007.995v99.495L1.742 76a1.016 1.016 0 0 0-1.424-.046.986.986 0 0 0-.046 1.406l24.993 26.326a1.016 1.016 0 0 0 1.49-.023l24.993-27.97a.986.986 0 0 0-.089-1.404 1.016 1.016 0 0 0-1.422.087Zm3.526-44.752 23.23-25.999v99.38A1 1 0 0 0 78 104a1 1 0 0 0 1.008-.995V3.51L102.258 28c.38.401 1.018.422 1.424.046a.986.986 0 0 0 .045-1.406L78.735.314a1.016 1.016 0 0 0-1.49.022L52.252 28.307a.986.986 0 0 0 .089 1.404 1.016 1.016 0 0 0 1.422-.087Z",
    fill: "currentColor"
  }));
};

var SvgArrowDownUp16X16 = function SvgArrowDownUp16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    className: "icon-arrow-down-up",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.421 11.056-2.769 3.122V.5a.501.501 0 0 0-1.005 0v13.735L.87 11.287a.504.504 0 0 0-.71-.023.498.498 0 0 0-.023.707l3.647 3.87c.203.216.547.21.743-.01l3.649-4.113a.498.498 0 0 0-.045-.706.504.504 0 0 0-.709.044Zm.449-6.069a.504.504 0 0 0 .709-.044l2.769-3.121v13.677a.501.501 0 0 0 1.005 0V1.764l2.778 2.948c.19.202.508.212.71.023a.498.498 0 0 0 .023-.707L12.217.158a.504.504 0 0 0-.743.01L7.825 4.282a.498.498 0 0 0 .045.705Z",
    fill: "currentColor"
  }));
};

var SvgArrowDownUp24X24 = function SvgArrowDownUp24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    className: "icon-arrow-down-up",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.946 16.696 6.599 21.77V.605A.603.603 0 0 0 6 0c-.33 0-.6.27-.6.605v21.236l-4.357-4.788a.597.597 0 0 0-.848-.037.609.609 0 0 0-.036.855l5.4 5.933c.242.267.66.26.895-.013l5.401-6.304a.609.609 0 0 0-.062-.853.596.596 0 0 0-.846.062Zm1.262-9.33c.25.219.63.19.846-.062l4.347-5.073v21.164c0 .334.268.605.6.605.33 0 .6-.27.6-.605V2.159l4.357 4.788a.597.597 0 0 0 .848.037.609.609 0 0 0 .036-.855l-5.4-5.933a.597.597 0 0 0-.895.013l-5.401 6.304a.609.609 0 0 0 .062.853Z",
    fill: "currentColor"
  }));
};

var SvgArrowLeft104X104 = function SvgArrowLeft104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-left",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m3.645 53 36.55 32.25a1 1 0 1 1-1.324 1.5l-38.533-34a1 1 0 0 1-.022-1.48l36.266-34a1 1 0 1 1 1.368 1.46L3.529 51H103a1 1 0 0 1 0 2H3.645z"
  }));
};

var SvgArrowLeft16X16 = function SvgArrowLeft16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m1.822 8.5 4.676 4.125a.5.5 0 1 1-.662.75l-5.667-5a.5.5 0 0 1-.01-.74l5.333-5a.5.5 0 0 1 .684.73L1.765 7.5H15.5a.5.5 0 0 1 0 1H1.822z"
  }));
};

var SvgArrowLeft24X24 = function SvgArrowLeft24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-left",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.822 11.51 9.52 4.857a.483.483 0 0 0 .044-.691.507.507 0 0 0-.706-.043L.17 11.633a.483.483 0 0 0-.011.724l8.178 7.51a.507.507 0 0 0 .707-.022.483.483 0 0 0-.023-.692L1.764 12.49H23.5c.276 0 .5-.22.5-.49s-.224-.49-.5-.49H1.822z"
  }));
};

var SvgArrowLeftRight104X104 = function SvgArrowLeftRight104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-left-right",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.624 50.237 3.626 27.007h99.379c.55 0 .995-.451.995-1.008a1 1 0 0 0-.995-1.007H3.51L28 1.742c.401-.38.422-1.018.046-1.424A.986.986 0 0 0 26.64.272L.314 25.265a1.016 1.016 0 0 0 .023 1.49l27.97 24.993a.986.986 0 0 0 1.404-.089 1.016 1.016 0 0 0-.087-1.422zm44.752 3.526 25.999 23.23H.995C.445 76.993 0 77.444 0 78s.445 1.008.995 1.008h99.495L76 102.258c-.401.38-.422 1.018-.046 1.424a.986.986 0 0 0 1.406.045l26.326-24.992a1.016 1.016 0 0 0-.022-1.49L75.693 52.252a.986.986 0 0 0-1.404.089 1.016 1.016 0 0 0 .087 1.422z",
    clipRule: "evenodd"
  }));
};

var SvgArrowLeftRight16X16 = function SvgArrowLeftRight16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-left-right",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.944 7.42 1.822 4.653H15.5c.276 0 .5-.225.5-.503a.501.501 0 0 0-.5-.502H1.764L4.713.869a.504.504 0 0 0 .023-.71.498.498 0 0 0-.707-.024L.158 3.783a.504.504 0 0 0 .011.743l4.113 3.648a.498.498 0 0 0 .706-.044.504.504 0 0 0-.044-.71zm6.069.45a.504.504 0 0 0 .043.708l3.122 2.77H.5a.501.501 0 0 0 0 1.005h13.736l-2.949 2.777a.504.504 0 0 0-.022.71.498.498 0 0 0 .706.024l3.871-3.648a.504.504 0 0 0-.01-.743l-4.114-3.648a.498.498 0 0 0-.706.044z",
    clipRule: "evenodd"
  }));
};

var SvgArrowLeftRight24X24 = function SvgArrowLeftRight24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-left-right",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.304 10.946 2.23 6.599h21.164A.603.603 0 0 0 24 6c0-.33-.27-.6-.605-.6H2.159l4.788-4.357a.596.596 0 0 0 .037-.848.609.609 0 0 0-.855-.036l-5.933 5.4a.597.597 0 0 0 .013.895l6.304 5.401a.609.609 0 0 0 .853-.062.597.597 0 0 0-.062-.846Zm9.33 1.262c-.219.25-.19.63.062.846l5.073 4.347H.605A.603.603 0 0 0 0 18c0 .33.27.6.605.6h21.236l-4.788 4.357a.597.597 0 0 0-.037.848c.226.244.609.26.855.036l5.933-5.4a.597.597 0 0 0-.013-.895l-6.304-5.401a.609.609 0 0 0-.853.062Z",
    fill: "currentColor"
  }));
};

var SvgArrowRight104X104 = function SvgArrowRight104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-right",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m100.355 53-36.55 32.25a1 1 0 1 0 1.324 1.5l38.533-34a1 1 0 0 0 .022-1.48l-36.266-34a1 1 0 1 0-1.368 1.46L100.471 51H1a1 1 0 1 0 0 2h99.355z"
  }));
};

var SvgArrowRight16X16 = function SvgArrowRight16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-right",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.178 8.5-4.676 4.125a.5.5 0 1 0 .662.75l5.667-5a.5.5 0 0 0 .01-.74l-5.333-5a.5.5 0 1 0-.684.73L14.236 7.5H.5a.5.5 0 0 0 0 1h13.678z"
  }));
};

var SvgArrowRight24X24 = function SvgArrowRight24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-right",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m22.073 12.594-7.697 6.653a.483.483 0 0 0-.044.691.507.507 0 0 0 .706.044l8.689-7.51a.483.483 0 0 0 .01-.725l-8.177-7.51a.507.507 0 0 0-.707.022.483.483 0 0 0 .023.692l7.255 6.663H.396c-.276 0-.5.22-.5.49s.224.49.5.49h21.677z"
  }));
};

var SvgArrowUpLeft104X104 = function SvgArrowUpLeft104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-up-left",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.99 62.083a.99.99 0 0 1-.99-.99V1.99A.99.99 0 0 1 1.99 1h59.103a.99.99 0 0 1 0 1.98H4.38l98.329 98.329a.99.99 0 1 1-1.401 1.401L2.981 4.381v56.712a.99.99 0 0 1-.99.99z",
    clipRule: "evenodd"
  }));
};

var SvgArrowUpLeft16X16 = function SvgArrowUpLeft16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -arrow-up-left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 9.314c0 .261.22.473.49.473s.49-.212.49-.473V2.593l12.175 12.261a.503.503 0 0 0 .693.015.46.46 0 0 0 .016-.669L2.695 1.946h6.42c.27 0 .49-.212.49-.473A.482.482 0 0 0 9.115 1H1.49c-.27 0-.49.212-.49.473v7.84z",
    clipRule: "evenodd"
  }));
};

var SvgArrowUpLeft24X24 = function SvgArrowUpLeft24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    role: "img",
    className: "icon -info-up-left"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.15 2a.579.579 0 0 1 .093 1.151l-.094.008-14.197-.001.065.056 17.81 17.811c.227.226.23.59.01.811a.574.574 0 0 1-.812-.008L3.262 4.064l-.103-.12V18.15a.58.58 0 0 1-.475.57l-.104.01a.579.579 0 0 1-.572-.486l-.007-.093L2 2.58c0-.088.02-.172.055-.247.004-.005.006-.01.009-.016.01-.02.02-.04.033-.06l.02-.027.033-.039a.575.575 0 0 1 .157-.123c.005-.001.01-.004.016-.007a.553.553 0 0 1 .166-.054L2.58 2h15.57z"
  }));
};

var SvgAssembly104X104 = function SvgAssembly104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -assembly",
    width: 105,
    height: 104,
    viewBox: "0 0 105 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m103.916 7.785-13.462 95.331c-.08.564-.587.955-1.133.873-.547-.082-.925-.607-.846-1.172L101.941 7.46c.382-2.293-1.109-4.473-3.253-4.858l-4.742-.466c-2.22-.394-4.33 1.146-4.712 3.442l-7.396 43.753c-.857 5.188-5.208 8.982-10.302 8.982H46.242a4.062 4.062 0 0 1-.573-.06l-.007-.001a2.33 2.33 0 0 0-.356-.04 2.33 2.33 0 0 0-.355.04 4.086 4.086 0 0 1-.605.061h-.647c.007 0 0 .002-.031.011l-.062.018-.013.004c-.178.051-.27.074-.487.1C20.106 59.66 2 79.159 2 102.966c0 .571-.448 1.034-1 1.034s-1-.463-1-1.034c0-24.912 18.945-45.314 42.93-46.578.012-.002.04-.008.124-.033l.014-.004a2.03 2.03 0 0 1 .631-.104h.623c.075-.002.148-.01.336-.04.294-.045.44-.062.648-.062.21 0 .355.017.658.064.178.027.253.036.303.038h25.269c4.119 0 7.637-3.069 8.33-7.268l7.397-43.754c.57-3.419 3.714-5.713 6.946-5.136l4.743.466c3.308.589 5.529 3.838 4.964 7.23Zm-58.61 38.287c11.428 0 20.692-9.573 20.692-21.383 0-11.81-9.264-21.384-20.692-21.384-11.427 0-20.691 9.574-20.691 21.384s9.264 21.383 20.69 21.383Zm0-2.067c-10.323 0-18.691-8.648-18.691-19.316s8.368-19.317 18.69-19.317c10.325 0 18.693 8.648 18.693 19.317 0 10.668-8.368 19.316-18.692 19.316Z"
  }));
};

var SvgAssembly16X16 = function SvgAssembly16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -assembly",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.016 8.245c.055 0 .101.006.156.015h3.701a.898.898 0 0 0 .878-.765l1.087-6.423c.117-.7.762-1.17 1.403-1.055l.724.073c.678.12 1.134.785 1.019 1.473l-1.98 13.995a.503.503 0 0 1-.566.437.514.514 0 0 1-.423-.585L14.996 1.4c.023-.139-.067-.27-.163-.29l-.724-.072a.248.248 0 0 0-.286.21L12.736 7.67c-.155.937-.941 1.622-1.863 1.622H7.147a.866.866 0 0 1-.131-.014.902.902 0 0 1-.142.014h-.046a1.815 1.815 0 0 1-.117.018C3.515 9.481 1 12.183 1 15.484A.508.508 0 0 1 .5 16c-.276 0-.5-.231-.5-.516 0-3.846 2.925-6.997 6.606-7.199a.62.62 0 0 1 .174-.024h.074l.011-.002h.003a.845.845 0 0 1 .148-.014Zm0-.75c1.875 0 3.395-1.568 3.395-3.504 0-1.935-1.52-3.504-3.396-3.504S3.62 2.057 3.62 3.991c0 1.936 1.52 3.504 3.396 3.504Zm0-1.032c-1.325 0-2.397-1.106-2.397-2.472 0-1.365 1.073-2.472 2.396-2.472 1.324 0 2.396 1.107 2.396 2.472 0 1.366-1.072 2.472-2.396 2.472Z",
    fill: "currentColor"
  }));
};

var SvgAssembly24X24 = function SvgAssembly24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -assembly",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 22a.508.508 0 0 1-.5-.516c0-4.804 3.653-8.738 8.26-8.987a.626.626 0 0 1 .195-.03h.107l.016-.002.01-.001a.95.95 0 0 1 .331 0l.017.002.008.001h4.696c.614 0 1.139-.457 1.242-1.083l1.377-8.14c.136-.813.885-1.359 1.633-1.223l.907.09c.788.14 1.317.911 1.183 1.71l-2.508 17.737a.503.503 0 0 1-.567.436.514.514 0 0 1-.423-.585l2.51-17.75c.042-.25-.12-.488-.327-.526l-.907-.09a.449.449 0 0 0-.516.377l-1.376 8.14c-.185 1.12-1.127 1.94-2.228 1.94h-4.716a.956.956 0 0 1-.129-.012l-.022-.003-.009-.002-.01-.001a.396.396 0 0 1-.012.002h-.007l-.011.002a.997.997 0 0 1-.149.014h-.077c-.024.007-.04.009-.138.024C6.24 13.74 3 17.227 3 21.484a.508.508 0 0 1-.5.516Zm8.254-10.778c2.302 0 4.168-1.926 4.168-4.302 0-2.376-1.866-4.302-4.168-4.302S6.586 4.544 6.586 6.92c0 2.376 1.866 4.302 4.168 4.302Zm0-1.032c-1.75 0-3.168-1.464-3.168-3.27s1.419-3.27 3.168-3.27c1.75 0 3.168 1.464 3.168 3.27s-1.418 3.27-3.168 3.27Z",
    fill: "currentColor"
  }));
};

var SvgAt104X104 = function SvgAt104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -at",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.103 62.254c0 9.361 7.25 15.63 15.582 14.503 8.977-1.214 15.312-10.242 15.315-24.694v-.006a51.986 51.986 0 0 0-6.009-24.319C84.591 2.344 53.138-7.38 27.741 6.018 2.344 19.418-7.38 50.868 6.02 76.263c13.401 25.394 44.853 35.119 70.25 21.72a1 1 0 1 0-.933-1.77c-24.42 12.885-54.662 3.534-67.548-20.883C-5.097 50.91 4.254 20.67 28.674 7.787c24.42-12.884 54.663-3.533 67.548 20.885A49.987 49.987 0 0 1 102 52.047v.009c0 13.532-5.697 21.653-13.583 22.72-7.136.965-13.314-4.377-13.314-12.522V28.26a1 1 0 0 0-2 0v14.023C69.31 33.449 60.53 27.261 50.306 27.261c-13.696 0-24.798 11.1-24.798 24.795 0 13.694 11.102 24.795 24.798 24.795 10.225 0 19.004-6.188 22.797-15.023v.426Zm0-10.18v-.038c-.01-12.58-10.213-22.775-22.797-22.775-12.592 0-22.798 10.205-22.798 22.795 0 12.59 10.206 22.796 22.798 22.796 12.584 0 22.787-10.196 22.797-22.777Z",
    fill: "currentColor"
  }));
};

var SvgAt16X16 = function SvgAt16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -at",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.913 10.458c.385 1.05 1.402 1.686 2.529 1.534 1.513-.205 2.557-1.693 2.558-3.983A8.001 8.001 0 0 0 4.268.925a8 8 0 1 0 7.466 14.15.5.5 0 1 0-.467-.883A6.999 6.999 0 1 1 4.734 1.81 7.001 7.001 0 0 1 15 8.01c0 1.827-.725 2.861-1.692 2.992-.839.113-1.558-.509-1.558-1.492v-5a.5.5 0 0 0-1 0v.854a4 4 0 1 0 .163 5.095Zm-.163-2.45a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z",
    fill: "currentColor"
  }));
};

var SvgAt24X24 = function SvgAt24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -at",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.739 14.824c.392 1.417 1.688 2.296 3.137 2.1 1.843-.25 3.123-2.073 3.124-4.912A10 10 0 0 0 7.335 3.158C2.451 5.735.58 11.784 3.158 16.668c2.576 4.884 8.625 6.754 13.51 4.177a.5.5 0 1 0-.467-.884A8.998 8.998 0 0 1 4.042 16.2a8.999 8.999 0 0 1 3.76-12.159A8.998 8.998 0 0 1 21 12.012c0 2.376-.961 3.746-2.258 3.921-1.142.155-2.124-.695-2.124-2.021V7.579a.5.5 0 0 0-1 0v1.455a4.934 4.934 0 0 0-8.867 2.979 4.933 4.933 0 0 0 8.988 2.81Zm-.121-2.809v-.005a3.934 3.934 0 1 0 0 .005Z",
    fill: "currentColor"
  }));
};

var SvgAtm104X104 = function SvgAtm104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -atm",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.513 104H9.487C8.113 104 7 102.876 7 101.489V2.511C7 1.124 8.113 0 9.487 0h23.779a2.49 2.49 0 0 1 2.347 1.682l17.331 49.987c.037.107.056.219.056.331v49.489c0 1.386-1.114 2.511-2.487 2.511Zm.506-51.83L33.743 2.344A.507.507 0 0 0 33.267 2H9.486a.509.509 0 0 0-.506.511v98.978c0 .282.227.511.506.511h41.027a.509.509 0 0 0 .506-.511V52.17ZM93 13.5C93 7.7 88.3 3 82.5 3 76.701 3 72 7.7 72 13.5 72 19.299 76.701 24 82.5 24 88.3 24 93 19.299 93 13.5Zm-18.973 0a8.472 8.472 0 1 1 16.944 0 8.472 8.472 0 0 1-16.944 0ZM68 45.434c0-.145.01-.24.038-.418l.002-.014c.005-.03.008-.047.01-.052a2.047 2.047 0 0 0-.014-.096v-.008a2.533 2.533 0 0 1-.036-.408C68 36.464 74.492 30 82.5 30S97 36.464 97 44.438c0 .092-.006.156-.02.248.014.095.02.156.02.249v21.371c0 2.906-2.366 5.261-5.284 5.261h-.527V98.74c0 2.905-2.366 5.26-5.284 5.26h-6.81c-2.918 0-5.284-2.355-5.284-5.26V71.567h-.527c-2.918 0-5.284-2.355-5.284-5.26V45.433Zm26.982-1.017v.007-.007ZM82.5 32.01c6.886 0 12.47 5.554 12.482 12.408l-.002.004a1.717 1.717 0 0 0-.023.242 1.804 1.804 0 0 0 .025.297v21.346a3.26 3.26 0 0 1-3.266 3.252h-1.537c-.557 0-1.009.45-1.009 1.005V98.74a3.258 3.258 0 0 1-3.266 3.251h-6.81a3.258 3.258 0 0 1-3.265-3.251V70.563c0-.555-.452-1.005-1.009-1.005h-1.536a3.26 3.26 0 0 1-3.267-3.252V45.434c0-.01.003-.032.015-.11.023-.146.032-.225.036-.341a2.772 2.772 0 0 0-.035-.416l-.001-.008a1.15 1.15 0 0 1-.014-.121c0-6.864 5.588-12.429 12.482-12.429Z",
    fill: "currentColor"
  }));
};

var SvgAtm16X16 = function SvgAtm16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -atm",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.002 15h5.545V8.085L5.063 1H2.002v14ZM5.259 0c.308 0 .582.194.683.484L8.52 7.835A.489.489 0 0 1 8.548 8v7.278a.724.724 0 0 1-.723.722H1.723A.724.724 0 0 1 1 15.278V.722C1 .324 1.324 0 1.723 0H5.26Zm7.24 1.066a.934.934 0 1 1-.001 1.869.934.934 0 0 1 .002-1.869ZM12.5 4c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2Zm1.487 3v3.129a.124.124 0 0 1-.125.123h-.227a.503.503 0 0 0-.507.5v4.124a.125.125 0 0 1-.124.125h-1.007a.125.125 0 0 1-.124-.124V10.75c0-.275-.227-.5-.507-.5h-.227a.124.124 0 0 1-.125-.122l-.002-3.02.002-.181c0-.808.667-1.466 1.487-1.466A1.478 1.478 0 0 1 13.987 7ZM15 6.929c0-1.36-1.121-2.466-2.5-2.466a2.478 2.478 0 0 0-2.49 2.499c-.004.025-.01.088-.01.113v3.055c0 .524.366.966.858 1.088v3.66c0 .62.511 1.123 1.139 1.123h1.006c.628 0 1.139-.504 1.139-1.123v-3.66c.492-.123.858-.565.858-1.088l-.008-3.107A.714.714 0 0 0 15 6.928Z",
    fill: "currentColor"
  }));
};

var SvgAtm24X24 = function SvgAtm24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -atm",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.505 22H3.783A.782.782 0 0 1 3 21.219V2.781C3 2.349 3.35 2 3.783 2h4.476c.332 0 .629.21.737.523l3.264 9.312.028.165v9.219c0 .432-.35.781-.783.781Zm-.218-1v-8.915L8.103 3H4.001v18h7.286ZM20.2 4.75a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0Zm-3.498 0a1.247 1.247 0 1 1 2.493 0 1.247 1.247 0 0 1-2.493 0ZM15 14.875v-3.776l.006-.09c-.003-.02-.003-.034-.006-.09C15 9.306 16.343 8 18 8s3 1.307 3 2.918l-.002.046.002.044v3.867c0 .623-.465 1.14-1.076 1.24v4.627c0 .695-.58 1.258-1.293 1.258h-1.262c-.714 0-1.293-.563-1.293-1.258v-4.627A1.268 1.268 0 0 1 15 14.875Zm4.996-3.842a1.112 1.112 0 0 1-.004-.07l.003-.068c-.012-1.062-.902-1.92-1.997-1.92-1.096 0-1.987.862-1.996 1.927.004.03.004.031.009.125-.005.061-.005.063-.009.09v3.758c0 .156.13.282.29.282h.285c.277 0 .501.218.501.487v5.098c0 .156.13.282.29.282h1.261c.16 0 .29-.126.29-.282v-5.098c0-.269.225-.487.502-.487h.285c.16 0 .29-.126.29-.282v-3.842Z",
    fill: "currentColor"
  }));
};

var SvgBadge104X104 = function SvgBadge104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -badge",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M46.686 0h10.628a2.518 2.518 0 0 1 2.523 2.511v7.69h27.085c3.91 0 7.078 3.153 7.078 7.043v79.711c0 3.891-3.169 7.045-7.078 7.045H17.078c-3.91 0-7.078-3.154-7.078-7.045v-79.71c0-3.891 3.169-7.045 7.078-7.045h27.085V2.511A2.518 2.518 0 0 1 46.686 0zm-2.523 12.2H17.078c-2.8 0-5.068 2.259-5.068 5.044v79.711c0 2.787 2.268 5.045 5.068 5.045h69.844c2.8 0 5.068-2.258 5.068-5.045v-79.71c0-2.787-2.269-5.045-5.068-5.045H59.837v4.289A2.518 2.518 0 0 1 57.314 19H46.686a2.518 2.518 0 0 1-2.523-2.511V12.2zm13.665-1.014v5.303c0 .282-.23.511-.514.511H46.686a.513.513 0 0 1-.514-.511V2.511c0-.282.23-.511.514-.511h10.628c.283 0 .514.23.514.511v8.675zm-5.87 38.8c5.388-.067 9.701-4.468 9.633-9.83-.068-5.362-4.489-9.654-9.876-9.587-5.388.066-9.701 4.467-9.633 9.83.067 5.36 4.488 9.652 9.875 9.586zm-.218-17.418c4.277-.053 7.788 3.355 7.841 7.613.054 4.257-3.37 7.751-7.649 7.805-4.277.052-7.787-3.356-7.84-7.613-.055-4.257 3.37-7.752 7.648-7.805zm.3 24.025c-10.318.129-18.579 8.557-18.45 18.826a1.002 1.002 0 0 1-.992 1.012 1.003 1.003 0 0 1-1.017-.987c-.143-11.373 9.006-20.708 20.434-20.85 11.428-.142 20.808 8.964 20.95 20.337a1.002 1.002 0 0 1-.992 1.012 1.003 1.003 0 0 1-1.017-.987c-.129-10.269-8.598-18.49-18.915-18.363z",
    clipRule: "evenodd"
  }));
};

var SvgBadge16X16 = function SvgBadge16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -badge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.223 0h1.555c.399 0 .722.324.722.722V1.5h3.611c.767 0 1.389.622 1.389 1.389v11.722c0 .767-.622 1.389-1.389 1.389H2.889A1.389 1.389 0 0 1 1.5 14.611V2.889c0-.767.622-1.389 1.389-1.389h3.61V.722C6.5.323 6.825 0 7.224 0zM7.5 2.017a.507.507 0 0 0 0-.034V1h1v1.5h-1v-.483zm-1 .483H2.889a.389.389 0 0 0-.389.389v11.722c0 .215.174.389.389.389h10.222a.389.389 0 0 0 .389-.389V2.889a.389.389 0 0 0-.389-.389H9.5v.278a.722.722 0 0 1-.722.722H7.223a.723.723 0 0 1-.723-.722V2.5zm1.244 5.541a1.781 1.781 0 1 1 .51-.006 3.382 3.382 0 0 1 3.167 3.333.5.5 0 0 1-1 .012 2.381 2.381 0 0 0-4.763.06.5.5 0 0 1-1 .012 3.382 3.382 0 0 1 3.086-3.41zm-.55-1.755a.782.782 0 1 1 1.564-.018.782.782 0 0 1-1.563.018z",
    clipRule: "evenodd"
  }));
};

var SvgBadge24X24 = function SvgBadge24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -badge",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.332 0h2.335c.455 0 .824.376.824.841V2.3h5.684C21.183 2.3 22 3.134 22 4.163v17.974C22 23.166 21.183 24 20.175 24H4.825C3.817 24 3 23.166 3 22.137V4.163C3 3.133 3.817 2.3 4.825 2.3h5.683V.84c0-.465.369-.841.824-.841Zm.155 2.829a.566.566 0 0 0 0-.058V1h2.025V3.833h-2.024V2.829Zm-.979.47H4.825a.854.854 0 0 0-.846.864v17.974c0 .477.379.863.846.863h15.35a.854.854 0 0 0 .846-.863V4.163a.854.854 0 0 0-.846-.863h-5.684v.693c0 .464-.37.84-.824.84h-2.335a.832.832 0 0 1-.824-.84V3.3Zm1.986 8.521c1.332-.016 2.4-1.134 2.382-2.494-.017-1.361-1.11-2.45-2.443-2.433-1.331.016-2.398 1.133-2.382 2.494.016 1.36 1.11 2.45 2.442 2.433Zm-.049-3.927c.792-.01 1.442.637 1.452 1.445.01.809-.624 1.472-1.415 1.482-.792.01-1.442-.638-1.452-1.445-.01-.809.624-1.472 1.415-1.482Zm.066 5.418c-2.118.026-3.815 1.803-3.79 3.966a.495.495 0 0 1-.483.507.495.495 0 0 1-.496-.494c-.032-2.716 2.098-4.946 4.757-4.98 2.66-.034 4.845 2.141 4.877 4.857a.495.495 0 0 1-.483.507.495.495 0 0 1-.496-.494c-.026-2.164-1.766-3.897-3.886-3.87Z",
    fill: "currentColor"
  }));
};

var SvgBarChart104X104 = function SvgBarChart104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -bar-chart",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M79 7.045v89.911c0 3.89 3.096 7.044 6.916 7.044h11.167c3.821 0 6.917-3.154 6.917-7.044V7.045C104 3.154 100.904 0 97.083 0H85.916C82.096 0 79 3.154 79 7.045zM85.916 102c-2.735 0-4.952-2.258-4.952-5.044V7.045C80.964 4.258 83.18 2 85.916 2h11.167c2.736 0 4.953 2.258 4.953 5.045v89.911c0 2.786-2.217 5.044-4.953 5.044H85.916zM39 41.016v55.968c0 3.874 3.097 7.016 6.916 7.016h11.168c3.819 0 6.916-3.142 6.916-7.016V41.016C64 37.142 60.903 34 57.084 34H45.916C42.097 34 39 37.142 39 41.016zm6.916 60.992c-2.735 0-4.952-2.25-4.952-5.024V41.016c0-2.774 2.217-5.024 4.952-5.024h11.168c2.735 0 4.953 2.25 4.953 5.024v55.968c0 2.774-2.218 5.024-4.953 5.024H45.916zM0 96.87V74.13C0 70.192 3.096 67 6.917 67h11.167C21.904 67 25 70.192 25 74.13v22.74c0 3.938-3.096 7.13-6.916 7.13H6.917C3.097 104 0 100.808 0 96.87zm1.964 0c0 2.82 2.217 5.105 4.953 5.105h11.167c2.735 0 4.952-2.286 4.952-5.105V74.13c0-2.82-2.217-5.105-4.952-5.105H6.917c-2.736 0-4.953 2.285-4.953 5.105v22.74z",
    clipRule: "evenodd"
  }));
};

var SvgBarChart16X16 = function SvgBarChart16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -bar-chart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 14.611a.39.39 0 0 1-.39.389h-1.672a.39.39 0 0 1-.388-.389V1.388c0-.214.175-.388.388-.388h1.673a.39.39 0 0 1 .389.388v13.223zM14.61 0h-1.672a1.39 1.39 0 0 0-1.388 1.388v13.223A1.39 1.39 0 0 0 12.938 16h1.673A1.39 1.39 0 0 0 16 14.611V1.388A1.39 1.39 0 0 0 14.61 0zM9.226 14.611a.39.39 0 0 1-.39.389H7.163a.39.39 0 0 1-.389-.389V6.348a.39.39 0 0 1 .39-.389h1.671a.39.39 0 0 1 .39.389v8.263zm-.39-9.652H7.163a1.39 1.39 0 0 0-1.389 1.389v8.263A1.39 1.39 0 0 0 7.164 16h1.671a1.39 1.39 0 0 0 1.39-1.389V6.348a1.39 1.39 0 0 0-1.39-1.389zM3.061 15a.39.39 0 0 0 .389-.389v-3.304a.39.39 0 0 0-.389-.388H1.388a.389.389 0 0 0-.388.388v3.304a.39.39 0 0 0 .388.389h1.673zM1.388 9.919h1.673a1.39 1.39 0 0 1 1.389 1.388v3.304A1.39 1.39 0 0 1 3.061 16H1.388A1.39 1.39 0 0 1 0 14.611v-3.304a1.39 1.39 0 0 1 1.388-1.388z",
    clipRule: "evenodd"
  }));
};

var SvgBarChart24X24 = function SvgBarChart24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -bar-chart",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.63 3.626v16.748c0 .898.727 1.626 1.625 1.626h2.12c.898 0 1.625-.728 1.625-1.626V3.626C22 2.728 21.273 2 20.374 2h-2.119c-.898 0-1.626.728-1.626 1.626ZM18.254 21a.626.626 0 0 1-.626-.626V3.626c0-.346.28-.626.626-.626h2.12c.345 0 .625.28.625.626v16.748c0 .346-.28.626-.626.626h-2.119ZM9.315 9.908v10.466c0 .898.727 1.626 1.626 1.626h2.118c.899 0 1.627-.728 1.627-1.626V9.908c0-.898-.728-1.626-1.627-1.626h-2.118c-.899 0-1.627.728-1.627 1.626ZM10.94 21a.626.626 0 0 1-.627-.626V9.908c0-.346.28-.626.627-.626h2.118c.346 0 .627.28.627.626v10.466c0 .346-.28.626-.627.626h-2.118ZM2 20.374v-4.185c0-.897.728-1.626 1.626-1.626h2.119c.898 0 1.626.729 1.626 1.626v4.185c0 .898-.728 1.626-1.626 1.626H3.626A1.626 1.626 0 0 1 2 20.374Zm1 0c0 .346.28.626.626.626h2.119c.346 0 .626-.28.626-.626v-4.185a.626.626 0 0 0-.626-.626H3.626a.626.626 0 0 0-.626.626v4.185Z",
    fill: "currentColor"
  }));
};

var SvgBarCode104X104 = function SvgBarCode104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -bar-code",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.714 1.714h15.429a.857.857 0 0 0 0-1.714H.857A.857.857 0 0 0 0 .857v16.286a.857.857 0 0 0 1.714 0V1.714Zm100.572 0H86.857a.857.857 0 0 1 0-1.714h16.286c.473 0 .857.384.857.857v16.286a.857.857 0 0 1-1.714 0V1.714ZM17.143 102.286H1.714V86.857a.857.857 0 0 0-1.714 0v16.286c0 .473.384.857.857.857h16.286a.857.857 0 0 0 0-1.714Zm85.143 0H86.857a.857.857 0 1 0 0 1.714h16.286a.857.857 0 0 0 .857-.857V86.857a.857.857 0 0 0-1.714 0v15.429ZM82 12a2 2 0 0 0-2 2v76a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2h-6Zm-35.032 2a2 2 0 0 1 2-2h4.646a2 2 0 0 1 2 2v76a2 2 0 0 1-2 2h-4.646a2 2 0 0 1-2-2V14Zm20.146-2a1.5 1.5 0 0 0-1.5 1.5v77a1.5 1.5 0 0 0 1.5 1.5h1.322a1.5 1.5 0 0 0 1.5-1.5v-77a1.5 1.5 0 0 0-1.5-1.5h-1.322ZM14 14a2 2 0 0 1 2-2h4.645a2 2 0 0 1 2 2v76a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2V14Zm20.145-2a1.5 1.5 0 0 0-1.5 1.5v77a1.5 1.5 0 0 0 1.5 1.5h1.323a1.5 1.5 0 0 0 1.5-1.5v-77a1.5 1.5 0 0 0-1.5-1.5h-1.323Z",
    fill: "currentColor"
  }));
};

var SvgBarCode16X16 = function SvgBarCode16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -bar-code",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.517 0a.483.483 0 1 1 0 .966H.966v2.551a.483.483 0 1 1-.966 0V.483C0 .216.216 0 .483 0h3.034ZM12 .483c0-.267.216-.483.483-.483h3.034c.267 0 .483.216.483.483v3.034a.483.483 0 1 1-.966 0V.966h-2.551A.483.483 0 0 1 12 .483Zm0 15.034c0 .267.216.483.483.483h3.034a.483.483 0 0 0 .483-.483v-3.034a.483.483 0 1 0-.966 0v2.551h-2.551a.483.483 0 0 0-.483.483Zm-8 0a.483.483 0 0 1-.483.483H.483A.483.483 0 0 1 0 15.517v-3.034a.483.483 0 1 1 .966 0v2.551h2.551c.267 0 .483.217.483.483ZM5.645 2.5a.125.125 0 0 0-.125.125v10.75c0 .069.056.125.125.125h.25a.125.125 0 0 0 .125-.125V2.625a.125.125 0 0 0-.125-.125h-.25Zm4.335.125c0-.069.056-.125.125-.125h.25c.07 0 .125.056.125.125v10.75a.125.125 0 0 1-.125.125h-.25a.125.125 0 0 1-.125-.125V2.625ZM3.04 2.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25h-1Zm4.21.25a.25.25 0 0 1 .25-.25h1a.25.25 0 0 1 .25.25v10.5a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25V2.75Zm4.71-.25a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25h-1Z",
    fill: "currentColor"
  }));
};

var SvgBarCode24X24 = function SvgBarCode24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -bar-code",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91 2.91h3.18a.455.455 0 0 0 0-.91H2.456A.455.455 0 0 0 2 2.455V6.09a.455.455 0 0 0 .91 0V2.909ZM5 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-13Zm6 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-13Zm3.75-.5a.25.25 0 0 0-.25.25v13.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25V5.25a.25.25 0 0 0-.25-.25h-.5Zm-6.25.25A.25.25 0 0 1 8.75 5h.5a.25.25 0 0 1 .25.25v13.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25V5.25Zm9-.25a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-1Zm.41-2.09h3.18v3.18a.455.455 0 0 0 .91 0V2.456A.455.455 0 0 0 21.546 2h-3.637a.455.455 0 0 0 0 .91Zm-15 18.18h3.18a.455.455 0 0 1 0 .91H2.456A.455.455 0 0 1 2 21.546v-3.637a.455.455 0 0 1 .91 0v3.182Zm15 0h3.18v-3.18a.455.455 0 0 1 .91 0v3.636a.455.455 0 0 1-.454.454h-3.637a.455.455 0 0 1 0-.91Z",
    fill: "currentColor"
  }));
};

var SvgBarCode64X64 = function SvgBarCode64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -bar-code",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.517 0a.483.483 0 1 1 0 .966H.966v11.551a.483.483 0 1 1-.966 0V.483C0 .216.216 0 .483 0h12.034ZM51 .483c0-.267.216-.483.483-.483h12.034c.267 0 .483.216.483.483v12.034a.483.483 0 1 1-.965 0V.966H51.483A.483.483 0 0 1 51 .483Zm0 63.034c0 .267.216.483.483.483h12.034a.483.483 0 0 0 .483-.483V51.483a.483.483 0 1 0-.965 0v11.552H51.483a.483.483 0 0 0-.483.482Zm-38 0a.483.483 0 0 1-.483.483H.483A.483.483 0 0 1 0 63.517V51.483a.483.483 0 1 1 .966 0v11.552h11.551c.267 0 .483.216.483.482ZM50.5 8a1 1 0 0 0-1 1v46a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-3Zm-21 1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v46a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V9Zm-19-1a1 1 0 0 0-1 1v46a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-3Zm10 1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v46a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V9Zm21-1a1 1 0 0 0-1 1v46a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-1Z",
    fill: "currentColor"
  }));
};

var SvgBasket104X104 = function SvgBasket104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -basket",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.676 8.053 53.883 40.79a4.502 4.502 0 0 1-1.329 6.224 4.496 4.496 0 0 1-6.22-1.328L25.126 12.95a4.502 4.502 0 0 1 1.329-6.224 4.496 4.496 0 0 1 6.22 1.328Zm-9.228 5.984a6.503 6.503 0 0 1 1.92-8.99 6.495 6.495 0 0 1 8.986 1.918l20.75 32.03h39.898c5.722 0 9.991 5.27 8.805 10.867l-9.329 44.004a9 9 0 0 1-8.804 7.133H18.336a9 9 0 0 1-8.805-7.133L.203 49.862c-1.187-5.597 3.083-10.867 8.804-10.867h30.61L23.447 14.037Zm17.464 26.958H9.007c-4.45 0-7.77 4.099-6.848 8.452L3.337 55h97.336l1.177-5.553c.923-4.353-2.397-8.452-6.848-8.452H56.21a6.506 6.506 0 0 1-2.567 7.698 6.495 6.495 0 0 1-8.987-1.918l-3.743-5.78ZM11.488 93.451 3.761 57h96.488l-7.727 36.451A7 7 0 0 1 85.674 99H18.336a7 7 0 0 1-6.848-5.549ZM30.25 69a1 1 0 1 0-2 0v20a1 1 0 1 0 2 0V69ZM52 68a1 1 0 0 1 1 1v20a1 1 0 1 1-2 0V69a1 1 0 0 1 1-1Zm24 1a1 1 0 1 0-2 0v20a1 1 0 1 0 2 0V69Z",
    clipRule: "evenodd"
  }));
};

var SvgBasket16X16 = function SvgBasket16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -basket",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.038 2.036A.998.998 0 0 1 5.718.96l2.907 4.536h5.918c.939 0 1.632.901 1.418 1.842l-1.366 7a1.466 1.466 0 0 1-1.418 1.158H2.824c-.677 0-1.264-.48-1.419-1.158l-1.365-7c-.214-.94.48-1.842 1.418-1.842h4.798l-2.217-3.46Zm2.858 4.46H1.457c-.313 0-.544.3-.473.614l.27 1.386h13.491l.27-1.386a.497.497 0 0 0-.472-.614H9.198a.998.998 0 0 1-1.812.764l-.49-.764ZM2.35 14.11l-.9-4.614h13.1l-.9 4.614a.489.489 0 0 1-.473.386H2.824a.489.489 0 0 1-.473-.386Zm3.15-3.163c0-.249-.224-.45-.5-.45s-.5.201-.5.45v2.098c0 .25.224.451.5.451s.5-.202.5-.45v-2.099Zm2.5-.45c.276 0 .5.201.5.45v2.098c0 .25-.224.451-.5.451s-.5-.202-.5-.45v-2.099c0-.249.224-.45.5-.45Zm3.5.45c0-.249-.224-.45-.5-.45s-.5.201-.5.45v2.098c0 .25.224.451.5.451s.5-.202.5-.45v-2.099Z",
    clipRule: "evenodd"
  }));
};

var SvgBasket24X24 = function SvgBasket24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -basket",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.979 3.222 3.775 5.941a.48.48 0 0 1-.812.516L8.168 3.738a.48.48 0 0 1 .811-.516ZM7.324 4.274a1.48 1.48 0 0 1 2.499-1.588L12.563 7h6.943a2.498 2.498 0 0 1 2.438 3.024l-2.137 10A2.495 2.495 0 0 1 17.369 22H6.63a2.495 2.495 0 0 1-2.438-1.976l-2.137-10A2.498 2.498 0 0 1 4.494 7h4.561L7.324 4.274ZM9.69 8H4.494c-.952 0-1.662.88-1.463 1.814L3.5 12H20.5l.467-2.186c.2-.933-.51-1.814-1.462-1.814h-6.307l.399.627a1.48 1.48 0 1 1-2.5 1.588L9.691 8ZM5.169 19.814 3.712 13h16.576l-1.457 6.814A1.497 1.497 0 0 1 17.37 21H6.63a1.497 1.497 0 0 1-1.462-1.186ZM9 15.4c0-.22-.224-.4-.5-.4s-.5.18-.5.4v3.2c0 .22.224.4.5.4s.5-.18.5-.4v-3.2Zm3.5-.4c.276 0 .5.18.5.4v3.2c0 .22-.224.4-.5.4s-.5-.18-.5-.4v-3.2c0-.22.224-.4.5-.4Zm4.5.4c0-.22-.224-.4-.5-.4s-.5.18-.5.4v3.2c0 .22.224.4.5.4s.5-.18.5-.4v-3.2Z",
    clipRule: "evenodd"
  }));
};

var SvgBasket64X64 = function SvgBasket64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -basket",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.21 4.921 33.158 25.13a2 2 0 1 1-3.368 2.158L16.842 7.08A2 2 0 0 1 20.21 4.92ZM15.158 8.16a4 4 0 0 1 6.736-4.317L34.169 23h24.828c3.19 0 5.564 2.968 4.886 6.107l-6.25 28.928A5.008 5.008 0 0 1 52.747 62H11.251a5.008 5.008 0 0 1-4.885-3.965L.116 29.107C-.562 25.967 1.812 23 5.002 23h19.666l-9.51-14.841Zm10.8 16.856H5.003c-1.914 0-3.338 1.78-2.931 3.664l1.49 6.902h56.876l1.491-6.902c.407-1.884-1.017-3.664-2.931-3.664H35.293a4.002 4.002 0 0 1-7.187 3.351l-2.147-3.351ZM8.32 57.606 3.994 37.581h56.011L55.68 57.606a3.005 3.005 0 0 1-2.932 2.38H11.251a3.005 3.005 0 0 1-2.931-2.38ZM19 43.572c0-.547-.448-.99-1-.99s-1 .443-1 .99V54.59c0 .547.448.991 1 .991s1-.444 1-.991V43.572Zm13-.99c.552 0 1 .443 1 .99V54.59c0 .547-.448.991-1 .991s-1-.444-1-.991V43.572a.996.996 0 0 1 1-.99Zm15 .99c0-.547-.448-.99-1-.99s-1 .443-1 .99V54.59c0 .547.448.991 1 .991s1-.444 1-.991V43.572Z",
    clipRule: "evenodd"
  }));
};

var SvgBinoculars104X104 = function SvgBinoculars104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -binoculars",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M44.2 27.92v31.644c-3.604-8.043-11.696-13.649-21.1-13.649a23.046 23.046 0 0 0-15.357 5.83l13.72-30.368.491-.981c2.056-3.877 6.09-6.34 10.51-6.401 6.475 0 11.737 5.248 11.737 11.72V27.92zm2 21.02v19.88l.001.138C46.201 81.683 35.858 92 23.1 92 10.343 92 0 81.683 0 68.958a22.9 22.9 0 0 1 2.385-10.209l17.27-38.227.52-1.038A14.103 14.103 0 0 1 32.452 12c7.593 0 13.75 6.141 13.75 13.716v.757a18.045 18.045 0 0 1 11.6.058v-.815C57.8 18.14 63.957 12 71.565 12a14.103 14.103 0 0 1 12.27 7.504l.527 1.054 17.259 38.201a22.911 22.911 0 0 1 2.38 10.199c0 12.725-10.343 23.042-23.1 23.042C68.143 92 57.8 81.683 57.8 68.958V49.007a16.04 16.04 0 0 0-11.6-.066zm13.6 20.057v-.224c.1-11.539 9.51-20.863 21.1-20.863 8.293 0 15.468 4.772 18.917 11.714l.572 1.265c.01.022.021.045.033.066a20.93 20.93 0 0 1 1.579 8.003c0 11.623-9.447 21.047-21.1 21.047-11.64 0-21.08-9.402-21.101-21.008zm36.458-17.252a23.046 23.046 0 0 0-15.357-5.83c-9.404 0-17.496 5.605-21.1 13.649V25.716c0-6.473 5.26-11.721 11.75-11.721a12.09 12.09 0 0 1 10.506 6.421l.5.998 13.701 30.331zM44.201 68.957v-.13C44.13 57.263 34.71 47.91 23.1 47.91c-8.289 0-15.461 4.768-18.912 11.704l-.576 1.275c-.01.024-.022.047-.035.07A20.939 20.939 0 0 0 2 68.957c0 11.623 9.447 21.047 21.1 21.047 11.644 0 21.086-9.409 21.101-21.02v-.028zm13.6-40.3V46.88a18.045 18.045 0 0 0-11.6-.058v-18.23a16.04 16.04 0 0 1 11.6.066z",
    clipRule: "evenodd"
  }));
};

var SvgBinoculars16X16 = function SvgBinoculars16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -binoculars",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.5 4.439V7.95a3.74 3.74 0 0 0-2.75-1.2c-.517 0-1.01.104-1.457.293L3.831 3.63l.066-.131c.239-.45.714-.742 1.235-.749.752 0 1.368.616 1.368 1.375v.314zm1 6.061v.012A3.75 3.75 0 1 1 .388 8.837l2.54-5.636.08-.16A2.428 2.428 0 0 1 5.125 1.75c1.198 0 2.19.887 2.352 2.04.346-.06.7-.058 1.046.005a2.378 2.378 0 0 1 2.36-2.045 2.43 2.43 0 0 1 2.114 1.301l.084.169 2.534 5.623A3.75 3.75 0 1 1 8.5 10.469V7.813a2 2 0 0 0-1-.006V10.5zm2 .01v-.036a2.75 2.75 0 0 1 5.214-1.198l.08.18A2.742 2.742 0 0 1 15 10.5a2.75 2.75 0 0 1-5.5.01zm4.208-3.466a3.739 3.739 0 0 0-1.458-.294 3.74 3.74 0 0 0-2.75 1.2V4.125c0-.76.616-1.375 1.375-1.375.514.007.99.298 1.233.759l.07.14 1.53 3.395zM1 10.5c0-.365.071-.713.2-1.032l.006-.013.083-.184A2.75 2.75 0 1 1 1 10.5zm7.5-5.687v1.978a3.001 3.001 0 0 0-1-.004v-1.98a2 2 0 0 1 1 .006z",
    clipRule: "evenodd"
  }));
};

var SvgBinoculars24X24 = function SvgBinoculars24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -binoculars",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.966 6.568v6.107a5.48 5.48 0 0 0-4.483-2.322c-1.017 0-1.97.277-2.787.76l2.667-5.91.107-.21a2.45 2.45 0 0 1 2.129-1.295 2.372 2.372 0 0 1 2.367 2.37v.5Zm1 9.258v.022A5.478 5.478 0 0 1 5.483 21.3a5.478 5.478 0 0 1-4.917-7.897l3.895-8.63.12-.238A3.457 3.457 0 0 1 7.591 2.7c1.8 0 3.27 1.407 3.37 3.178a4.337 4.337 0 0 1 2.076.01A3.375 3.375 0 0 1 16.415 2.7a3.458 3.458 0 0 1 3.009 1.845l.123.248 3.882 8.602a5.477 5.477 0 0 1-4.913 7.905 5.477 5.477 0 0 1-5.484-5.474v-4.31a3.335 3.335 0 0 0-2.066-.012v4.322Zm3.066-3.15a5.48 5.48 0 0 1 4.484-2.322c1.018 0 1.97.276 2.787.758l-2.659-5.891-.11-.22a2.451 2.451 0 0 0-2.127-1.303 2.374 2.374 0 0 0-2.375 2.37v6.608Zm8.496 1.152a4.484 4.484 0 0 0-4.012-2.476 4.479 4.479 0 0 0-4.483 4.475 4.478 4.478 0 0 0 4.483 4.475 4.478 4.478 0 0 0 4.144-6.183l-.132-.291ZM1 15.827a4.456 4.456 0 0 1 .34-1.708l.127-.283a4.484 4.484 0 0 1 4.016-2.484 4.479 4.479 0 0 1 4.483 4.475 4.478 4.478 0 0 1-4.483 4.475A4.478 4.478 0 0 1 1 15.827Zm12.032-8.902v3.553a4.338 4.338 0 0 0-2.066-.01V6.914a3.335 3.335 0 0 1 2.066.012Z",
    fill: "currentColor"
  }));
};

var SvgBiometry104X104 = function SvgBiometry104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -biometry",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52 0C32.269 0 16.083 15.38 15.094 34.854a.99.99 0 0 0-.093.42v5.446c0 .552.451 1 1.008 1s1.007-.448 1.007-1v-5.068a.99.99 0 0 0 .074-.338C17.842 16.731 33.223 2 52 2c18.776 0 34.157 14.73 34.91 33.314a.99.99 0 0 0 .074.338v31.622C86.985 86.453 71.322 102 52.001 102c-19.323 0-34.986-15.547-34.986-34.726v-3.995c0-.552-.451-1-1.007-1s-1.008.448-1.008 1v3.995C15 87.557 31.566 104 52 104c20.435 0 37-16.442 37-36.726v-32a.99.99 0 0 0-.093-.42C87.917 15.38 71.732 0 52.001 0zm22 39.987C74 27.844 64.15 18 52 18s-22 9.844-22 21.987v24.025C30 76.156 39.85 86 52 86s22-9.844 22-21.987a1.017 1.017 0 0 0-2.036 0c0 11.02-8.938 19.953-19.964 19.953-11.026 0-19.964-8.934-19.964-19.953V39.986c0-11.02 8.938-19.953 19.964-19.953 11.026 0 19.964 8.934 19.964 19.953a1.017 1.017 0 0 0 2.036 0zm-22-2.953c-3.217 0-5.826 2.44-5.826 5.451 0 .562-.487 1.017-1.087 1.017S44 43.047 44 42.485C44 38.351 47.582 35 52 35c4.419 0 8 3.35 8 7.485v19.03C60 65.649 56.419 69 52 69c-4.418 0-8-3.351-8-7.485v-5.02c0-.562.487-1.017 1.087-1.017s1.087.455 1.087 1.017v5.02c0 3.01 2.609 5.451 5.826 5.451 3.218 0 5.826-2.44 5.826-5.451v-19.03c0-3.01-2.608-5.451-5.826-5.451z",
    clipRule: "evenodd"
  }));
};

var SvgBiometry16X16 = function SvgBiometry16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -biometry",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.75 0a5.747 5.747 0 0 0-5.733 5.41.501.501 0 0 0-.017.13v.801a.5.5 0 1 0 1 0v-.696a.503.503 0 0 0 .01-.085A4.747 4.747 0 0 1 7.75 1a4.748 4.748 0 0 1 4.74 4.56.51.51 0 0 0 .01.085v4.601A4.753 4.753 0 0 1 7.75 15 4.753 4.753 0 0 1 3 10.246v-.587a.5.5 0 1 0-1 0v.587A5.753 5.753 0 0 0 7.75 16a5.753 5.753 0 0 0 5.75-5.754V5.54a.5.5 0 0 0-.017-.13A5.747 5.747 0 0 0 7.75 0zm3.53 6.263a3.53 3.53 0 1 0-7.059 0v3.473a3.53 3.53 0 0 0 3.529 3.532 3.53 3.53 0 0 0 3.53-3.532.5.5 0 1 0-1 0 2.53 2.53 0 1 1-5.06 0V6.263a2.53 2.53 0 1 1 5.06 0 .5.5 0 1 0 1 0zm-3.522-.06a.436.436 0 0 0-.435.436.5.5 0 1 1-1 0 1.435 1.435 0 1 1 2.87 0V9.39a1.435 1.435 0 1 1-2.87 0v-.726a.5.5 0 1 1 1 0v.726a.436.436 0 1 0 .87 0V6.64a.436.436 0 0 0-.435-.437z",
    clipRule: "evenodd"
  }));
};

var SvgBiometry24X24 = function SvgBiometry24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -biometry",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.5 0C6.982 0 3.273 3.56 3.024 8.076A.503.503 0 0 0 3 8.23v1.228c0 .276.222.5.497.5a.498.498 0 0 0 .497-.5V8.359a.504.504 0 0 0 .016-.11C4.17 4.206 7.471 1 11.5 1s7.33 3.206 7.491 7.25a.503.503 0 0 0 .015.105v7.089c0 4.174-3.36 7.556-7.505 7.556-4.147 0-7.507-3.382-7.507-7.556v-.901c0-.276-.223-.5-.497-.5a.498.498 0 0 0-.497.5v.901C3 20.17 6.805 24 11.5 24s8.5-3.83 8.5-8.556V8.229a.501.501 0 0 0-.022-.149C19.73 3.563 16.02 0 11.5 0Zm5.116 9.337c0-2.843-2.291-5.148-5.116-5.148-2.825 0-5.115 2.305-5.115 5.148v5.326c0 2.844 2.29 5.149 5.115 5.149s5.116-2.305 5.116-5.15a.5.5 0 0 0-.497-.5.498.498 0 0 0-.497.5c0 2.292-1.845 4.15-4.122 4.15-2.276 0-4.122-1.858-4.122-4.15V9.338c0-2.29 1.846-4.148 4.122-4.148s4.122 1.857 4.122 4.148c0 .276.223.5.497.5a.498.498 0 0 0 .497-.5Zm-5.104-.358a.932.932 0 0 0-.928.935c0 .276-.222.5-.496.5a.498.498 0 0 1-.497-.5c0-1.068.86-1.935 1.921-1.935s1.922.867 1.922 1.935v4.22c0 1.067-.86 1.933-1.922 1.933a1.928 1.928 0 0 1-1.921-1.934V13.02c0-.276.222-.5.497-.5.274 0 .496.224.496.5v1.114a.93.93 0 0 0 .928.934.931.931 0 0 0 .928-.934v-4.22a.932.932 0 0 0-.928-.935Z",
    clipRule: "evenodd"
  }));
};

var SvgBook104X104 = function SvgBook104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -book",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M65.6 7h31.355C100.84 7 104 10.146 104 14.014v62.433c0 3.866-3.16 7.012-7.045 7.012H65.6c-6.948 0-12.6 5.627-12.6 12.545 0 .55-.447.996-1 .996-.553 0-1-.446-1-.996 0-6.918-5.652-12.545-12.6-12.545H7.045C3.16 83.46 0 80.313 0 76.447V14.014C0 10.146 3.16 7 7.045 7H38.4c6.191 0 11.48 3.863 13.6 9.288C54.12 10.863 59.409 7 65.6 7zM38.4 81.468H7.045C4.263 81.468 2 79.215 2 76.447V14.014c0-2.77 2.263-5.023 5.045-5.023H38.4c6.948 0 12.6 5.627 12.6 12.545v67.13a14.62 14.62 0 0 0-12.6-7.198zm63.6-5.021c0 2.768-2.263 5.021-5.045 5.021H65.6c-5.373 0-10.065 2.913-12.6 7.228v-67.16c0-6.918 5.652-12.545 12.6-12.545h31.355c2.782 0 5.045 2.253 5.045 5.023v62.433z",
    clipRule: "evenodd"
  }));
};

var SvgBook16X16 = function SvgBook16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -book",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 1h4.611A1.39 1.39 0 0 1 16 2.388v9.223A1.39 1.39 0 0 1 14.611 13H10c-.827 0-1.5.673-1.5 1.5a.5.5 0 0 1-1 0c0-.827-.673-1.5-1.5-1.5H1.389A1.39 1.39 0 0 1 0 11.611V2.388A1.39 1.39 0 0 1 1.389 1H6a2.49 2.49 0 0 1 2 1.014A2.49 2.49 0 0 1 10 1zM6 12H1.389A.39.39 0 0 1 1 11.611V2.388A.39.39 0 0 1 1.389 2H6c.827 0 1.5.673 1.5 1.5v9.001A2.485 2.485 0 0 0 6 12zm9-.389a.39.39 0 0 1-.389.389H10c-.565 0-1.081.195-1.5.512V3.5c0-.827.673-1.5 1.5-1.5h4.611a.39.39 0 0 1 .389.388v9.223z",
    clipRule: "evenodd"
  }));
};

var SvgBook24X24 = function SvgBook24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -book",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.066 1.5h7.071C23.164 1.5 24 2.339 24 3.369v14.186c0 1.03-.836 1.868-1.863 1.868h-7.071a2.574 2.574 0 0 0-2.566 2.575.501.501 0 1 1-1 0 2.574 2.574 0 0 0-2.566-2.575H1.863A1.868 1.868 0 0 1 0 17.555V3.369C0 2.339.836 1.5 1.863 1.5h7.071c1.311 0 2.447.721 3.066 1.78.619-1.059 1.755-1.78 3.066-1.78ZM8.934 18.42H1.863A.866.866 0 0 1 1 17.554V3.37c0-.477.388-.866.863-.866h7.071A2.573 2.573 0 0 1 11.5 5.077v14.44a3.548 3.548 0 0 0-2.566-1.097ZM23 17.554a.866.866 0 0 1-.863.866h-7.071a3.544 3.544 0 0 0-2.566 1.105V5.077a2.573 2.573 0 0 1 2.566-2.574h7.071c.475 0 .863.39.863.866v14.186Z",
    fill: "currentColor"
  }));
};

var SvgBuilding104X104 = function SvgBuilding104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -building",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.781 104H83.22A1.79 1.79 0 0 0 85 102.2V1.8c0-.994-.797-1.8-1.781-1.8H20.78A1.79 1.79 0 0 0 19 1.8v100.4c0 .994.797 1.8 1.781 1.8zm32.209-2h15.564V80.625H52.99V102zm-1.98-21.375V102H35.447V80.625H51.01zm.99-2H34.654c-.656 0-1.187.537-1.187 1.2V102H20.979V2h62.042v100H70.533V79.825c0-.663-.53-1.2-1.187-1.2H52zm17.322-51.717H57.69a1.194 1.194 0 0 1-1.188-1.2v-11.69c0-.664.533-1.2 1.188-1.2h11.632c.655 0 1.187.537 1.187 1.2v11.69c0 .663-.532 1.2-1.187 1.2zm-.792-12.09H58.48v10.09h10.05v-10.09zM57.69 47.957h11.632c.655 0 1.187-.538 1.187-1.2v-11.69c0-.663-.532-1.2-1.187-1.2H57.69c-.655 0-1.188.536-1.188 1.2v11.69c0 .663.533 1.2 1.188 1.2zm10.84-12.09v10.09H58.48v-10.09h10.05zm.792 33.137H57.69a1.194 1.194 0 0 1-1.188-1.2v-11.69c0-.664.533-1.2 1.188-1.2h11.632c.655 0 1.187.537 1.187 1.2v11.69c0 .664-.532 1.2-1.187 1.2zm-.792-2v-10.09H58.48v10.09h10.05zM34.679 26.908h11.632c.655 0 1.187-.537 1.187-1.2v-11.69c0-.663-.532-1.2-1.187-1.2H34.679c-.655 0-1.188.536-1.188 1.2v11.69c0 .664.533 1.2 1.188 1.2zm.79-12.09h10.05v10.09h-10.05v-10.09zm10.842 33.138H34.679a1.195 1.195 0 0 1-1.188-1.2v-11.69c0-.664.533-1.2 1.188-1.2h11.632c.655 0 1.187.537 1.187 1.2v11.69c0 .662-.532 1.2-1.187 1.2zm-.792-12.09h-10.05v10.09h10.05v-10.09zm-10.84 33.137h11.632c.655 0 1.187-.536 1.187-1.2v-11.69c0-.663-.532-1.2-1.187-1.2H34.679c-.655 0-1.188.536-1.188 1.2v11.69c0 .664.533 1.2 1.188 1.2zm.79-12.09h10.05v10.09h-10.05v-10.09z",
    clipRule: "evenodd"
  }));
};

var SvgBuilding16X16 = function SvgBuilding16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -building",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.236 16H7.98a.499.499 0 0 0 .042 0h3.743c.683 0 1.236-.582 1.236-1.3V1.3c0-.718-.553-1.3-1.236-1.3H4.236C3.553 0 3 .582 3 1.3v13.4c0 .718.553 1.3 1.236 1.3zm4.24-1h1.526v-2.438H8.476V15zm-.952-2.438h-1.53V15h1.53v-2.438zM4.236 15h.808v-2.737c0-.387.297-.701.666-.701h4.579c.368 0 .665.314.665.701V15h.809a.293.293 0 0 0 .285-.3V1.3c0-.166-.127-.3-.285-.3H4.236a.293.293 0 0 0-.285.3v13.4c0 .166.127.3.285.3zm6.05-10.337H8.967c-.368 0-.666-.314-.666-.7V2.585c0-.386.298-.7.666-.7h1.32c.368 0 .665.314.665.7v1.378c0 .386-.297.7-.666.7zm-.284-1.778h-.749v.778h.749v-.778zM8.967 7.758h1.32c.368 0 .665-.314.665-.7V5.68c0-.386-.297-.7-.666-.7H8.967c-.368 0-.666.314-.666.7v1.378c0 .386.298.7.666.7zm.286-1.778h.749v.778h-.749V5.98zm1.033 4.873H8.967c-.368 0-.666-.313-.666-.7V8.775c0-.386.298-.7.666-.7h1.32c.368 0 .665.314.665.7v1.378c0 .386-.297.7-.666.7zm-.284-1.778h-.749v.778h.749v-.778zM5.714 4.663h1.319c.367 0 .666-.314.666-.7V2.585c0-.386-.299-.7-.666-.7h-1.32c-.367 0-.665.314-.665.7v1.378c0 .386.298.7.666.7zm.285-1.778h.748v.778h-.748v-.778zm1.034 4.873h-1.32c-.367 0-.665-.314-.665-.7V5.68c0-.386.298-.7.666-.7h1.319c.367 0 .666.314.666.7v1.378c0 .386-.299.7-.666.7zM6.747 5.98h-.748v.778h.748V5.98zm-1.033 4.873h1.319c.367 0 .666-.313.666-.7V8.775c0-.386-.299-.7-.666-.7h-1.32c-.367 0-.665.314-.665.7v1.378c0 .386.298.7.666.7zm.285-1.778h.748v.778h-.748v-.778z",
    clipRule: "evenodd"
  }));
};

var SvgBuilding24X24 = function SvgBuilding24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -building",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M12.5 23h3v-4.271h-3V23zm-1 0v-4.271h-3V23h3zm5 0H18.5a.3.3 0 0 0 .3-.3V1.3a.3.3 0 0 0-.3-.3H5.501a.3.3 0 0 0-.3.3v21.4a.3.3 0 0 0 .3.3h1.998v-4.571a.7.7 0 0 1 .7-.7H15.8a.7.7 0 0 1 .7.7V23zm1.999 1H5.501A1.3 1.3 0 0 1 4.2 22.7V1.3A1.3 1.3 0 0 1 5.501 0h12.998A1.3 1.3 0 0 1 19.8 1.3v21.4a1.3 1.3 0 0 1-1.301 1.3zM15.795 6.616h-2.343a.7.7 0 0 1-.7-.7V3.59a.7.7 0 0 1 .7-.7h2.343a.7.7 0 0 1 .7.7v2.326a.7.7 0 0 1-.7.7zm-.3-2.726h-1.743v1.726h1.743V3.89zm.3 7.472h-2.343a.7.7 0 0 1-.7-.7V8.336a.7.7 0 0 1 .7-.7h2.343a.7.7 0 0 1 .7.7v2.326a.7.7 0 0 1-.7.7zm-.3-2.726h-1.743v1.726h1.743V8.636zm.3 7.472h-2.343a.7.7 0 0 1-.7-.7v-2.326a.7.7 0 0 1 .7-.7h2.343a.7.7 0 0 1 .7.7v2.326a.7.7 0 0 1-.7.7zm-.3-2.726h-1.743v1.726h1.743v-1.726zm-4.947-6.766H8.205a.7.7 0 0 1-.7-.7V3.59a.7.7 0 0 1 .7-.7h2.343a.7.7 0 0 1 .7.7v2.326a.7.7 0 0 1-.7.7zm-.3-2.726H8.504v1.726h1.742V3.89zm.3 7.472H8.205a.7.7 0 0 1-.7-.7V8.336a.7.7 0 0 1 .7-.7h2.343a.7.7 0 0 1 .7.7v2.326a.7.7 0 0 1-.7.7zm-.3-2.726H8.504v1.726h1.742V8.636zm.3 7.472H8.205a.7.7 0 0 1-.7-.7v-2.326a.7.7 0 0 1 .7-.7h2.343a.7.7 0 0 1 .7.7v2.326a.7.7 0 0 1-.7.7zm-.3-2.726H8.504v1.726h1.742v-1.726z"
  }));
};

var SvgBusiness104X104 = function SvgBusiness104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -business",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.2 27.31H34v-5.774C34 13.508 40.537 7 48.6 7h6.8C63.464 7 70 13.508 70 21.536v5.774h26.955c3.891 0 7.045 3.14 7.045 7.013v55.663C104 93.86 100.846 97 96.955 97H7.045C3.154 97 0 93.86 0 89.986V34.323c0-3.873 3.154-7.013 7.045-7.013H28.2zm-1 1.992H7.045C4.258 29.302 2 31.55 2 34.323v55.663c0 2.775 2.258 5.023 5.045 5.023H27.2V29.302zm2 65.707V29.302h45.6v65.707H29.2zm47.6 0h20.155c2.787 0 5.045-2.248 5.045-5.023V34.323c0-2.773-2.258-5.021-5.045-5.021H76.8v65.707zM68 27.31H36v-5.774c0-6.928 5.641-12.545 12.6-12.545h6.8c6.959 0 12.6 5.617 12.6 12.545v5.774z",
    clipRule: "evenodd"
  }));
};

var SvgBusiness16X16 = function SvgBusiness16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -business",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.5 5.001A.51.51 0 0 1 5.468 5H5v9h6V5H5.532a.51.51 0 0 1-.032.001zM12 5v9h2.612a.389.389 0 0 0 .388-.389V5.389A.389.389 0 0 0 14.612 5H12zm-.5 10h3.112c.766 0 1.388-.622 1.388-1.389V5.389C16 4.622 15.378 4 14.612 4H11v-.5A2.5 2.5 0 0 0 8.5 1h-1A2.5 2.5 0 0 0 5 3.5V4H1.39A1.39 1.39 0 0 0 0 5.389v8.222A1.39 1.39 0 0 0 1.389 15H11.5zM4 14V5H1.39A.39.39 0 0 0 1 5.389v8.222a.39.39 0 0 0 .389.389H4zM6 4v-.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5V4H6z",
    clipRule: "evenodd"
  }));
};

var SvgBusiness24X24 = function SvgBusiness24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -business",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.833 7.946h-.767V19.97h7.867V7.946h-7.1Zm8.1 0V19.97h3.441a.636.636 0 0 0 .626-.645V8.591a.636.636 0 0 0-.626-.645h-3.44ZM16.433 21h3.941c.898 0 1.626-.75 1.626-1.676V8.592c0-.926-.728-1.676-1.626-1.676h-4.707v-.79C15.667 4.4 14.309 3 12.634 3h-1.268C9.692 3 8.333 4.4 8.333 6.126v.79H3.626C2.728 6.916 2 7.666 2 8.592v10.732C2 20.25 2.728 21 3.626 21h12.807Zm-9.367-1.03V7.945h-3.44A.636.636 0 0 0 3 8.591v10.733c0 .357.28.645.626.645h3.44ZM9.333 6.915v-.79c0-1.157.91-2.095 2.033-2.095h1.268c1.122 0 2.033.938 2.033 2.095v.79H9.333Z",
    fill: "currentColor"
  }));
};

var SvgCake104X104 = function SvgCake104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cake",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M51.973 22.238H52.026a5.22 5.22 0 0 1 5.198 5.218 5.22 5.22 0 0 1-5.192 5.216h-.065a5.22 5.22 0 0 1-5.19-5.216 5.22 5.22 0 0 1 5.196-5.218zm1.804-3.53a5.125 5.125 0 0 0-.661 1.618 7.22 7.22 0 0 1 6.108 7.13 7.188 7.188 0 0 1-2.235 5.216h33.168c3.89 0 7.044 3.15 7.044 7.035v16.492a.997.997 0 0 1 0 .191v30.608H103a1 1 0 1 1 0 1.997h-6.7a1.027 1.027 0 0 1-.199 0H7.898a1.026 1.026 0 0 1-.199 0H1a1 1 0 1 1 0-1.997h5.799V45.864a13.137 13.137 0 0 1-.004-.306c0-.029.001-.057.004-.085v-5.766c0-3.885 3.154-7.035 7.044-7.035H47.01a7.19 7.19 0 0 1-2.234-5.216 7.22 7.22 0 0 1 6.307-7.158 7.122 7.122 0 0 1 1-2.654c.666-1.056 1.616-1.928 2.877-2.543a.998.998 0 1 1 .878 1.795c-.92.448-1.59 1.064-2.062 1.812zM52 34.67H13.843a5.04 5.04 0 0 0-5.044 5.037v6.132c.15 5.881 4.97 10.603 10.896 10.604 6.469 0 10.901-3.552 10.901-9.187a1 1 0 0 1 1-.999 1 1 0 0 1 1.003.999c0 5.634 4.435 9.187 10.901 9.187 6.469 0 10.9-3.552 10.9-9.187a1 1 0 0 1 2 0c0 5.634 4.434 9.187 10.901 9.187 6.469 0 10.9-3.552 10.9-9.187a1 1 0 0 1 2 0c0 5.634 4.434 9.187 10.901 9.187 1.408.002 2.799-.27 4.099-.797v-15.94a5.04 5.04 0 0 0-5.044-5.036H52zM8.799 52.455a12.896 12.896 0 0 0 10.896 5.985c5.581 0 10.01-2.41 11.903-6.471C33.492 56.03 37.92 58.44 43.5 58.44c5.58 0 10.006-2.408 11.9-6.468 1.895 4.06 6.323 6.468 11.901 6.468 5.58 0 10.006-2.408 11.9-6.468 1.895 4.06 6.323 6.468 11.9 6.468a12.871 12.871 0 0 0 4.1-.665v29.223H8.799V52.455z",
    clipRule: "evenodd"
  }));
};

var SvgCake16X16 = function SvgCake16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cake",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.576 3.037a1.415 1.415 0 0 0-.93 1.765H2.39C1.621 4.802 1 5.424 1 6.192v.83l-.001.031.001.068v5.681H.5a.5.5 0 0 0 0 1h.968a.482.482 0 0 0 .064 0h12.936a.483.483 0 0 0 .064 0h.968a.5.5 0 1 0 0-1H15V8.667a.494.494 0 0 0 0-.066V6.19c0-.767-.621-1.389-1.389-1.389H9.353a1.415 1.415 0 0 0-.65-1.644 1.369 1.369 0 0 0-1.126-.121zm.839 1.35a.415.415 0 1 1-.83 0 .415.415 0 0 1 .83 0zM2.389 5.802h11.222c.215 0 .389.174.389.39v2.086a1.253 1.253 0 0 1-.25.025c-.77 0-1.25-.384-1.25-1a.5.5 0 0 0-1 0c0 .616-.479 1-1.25 1-.77 0-1.25-.384-1.25-1a.5.5 0 0 0-1 0c0 .616-.478 1-1.25 1s-1.25-.384-1.25-1a.5.5 0 1 0-1.001 0c0 .616-.478 1-1.25 1A1.251 1.251 0 0 1 2 7.103v-.912c0-.215.174-.389.389-.389zM2 8.924c.357.24.787.379 1.248.38.723 0 1.345-.247 1.751-.681.407.434 1.03.68 1.751.68.722 0 1.344-.246 1.75-.68.406.434 1.029.68 1.75.68.722 0 1.344-.246 1.75-.68.406.434 1.029.68 1.75.68.084 0 .167-.004.25-.014v3.513H2V8.924z",
    clipRule: "evenodd"
  }));
};

var SvgCake24X24 = function SvgCake24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cake",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.467 19.514H23.5c.276 0 .5.22.5.492a.496.496 0 0 1-.5.493H21.97a.006.006 0 0 1-.005 0H2.036a.006.006 0 0 1-.006 0H.5c-.277 0-.5-.22-.5-.493 0-.271.223-.492.5-.492h1.033V10.57l-.001-.004v-.003l.001-.002V9.265c0-1.011.835-1.835 1.862-1.835h6.94a1.82 1.82 0 0 1-.239-.89c0-.886.628-1.626 1.468-1.821.111-.403.387-.884.984-1.17a.506.506 0 0 1 .668.227.488.488 0 0 1-.231.658.792.792 0 0 0-.362.342c.743.256 1.28.945 1.28 1.764 0 .325-.091.624-.238.89h6.939c1.028 0 1.863.824 1.863 1.835v10.249ZM11.096 6.54c0-.491.406-.89.904-.89s.903.399.903.89c0 .49-.405.89-.903.89a.899.899 0 0 1-.904-.89Zm9.508 1.875H3.395a.857.857 0 0 0-.862.85v1.31c.006 1.182.981 2.142 2.183 2.142 1.006 0 2.183-.465 2.183-1.773 0-.272.224-.493.5-.493.277 0 .5.221.5.493 0 1.308 1.177 1.773 2.184 1.773 1.007 0 2.183-.465 2.183-1.773 0-.272.224-.493.5-.493.277 0 .5.221.5.493 0 1.308 1.177 1.773 2.184 1.773 1.007 0 2.184-.465 2.184-1.773 0-.272.223-.493.5-.493.276 0 .5.221.5.493 0 1.308 1.176 1.773 2.183 1.773h.005c.22 0 .435-.045.645-.109V9.265a.857.857 0 0 0-.863-.85ZM4.716 13.703a3.187 3.187 0 0 1-2.183-.865v6.676h18.934v-5.882c-.212.043-.428.07-.644.07h-.007c-1.18 0-2.137-.45-2.682-1.189-.546.74-1.503 1.19-2.684 1.19-1.18 0-2.138-.45-2.684-1.19-.545.74-1.503 1.19-2.683 1.19s-2.138-.45-2.684-1.19c-.546.74-1.503 1.19-2.683 1.19Z",
    fill: "currentColor"
  }));
};

var SvgCalculator104X104 = function SvgCalculator104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calculator",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.97 0h62.06C86.88 0 90 3.154 90 7.044v89.912c0 3.89-3.12 7.044-6.97 7.044H20.97c-3.85 0-6.97-3.154-6.97-7.044V7.044C14 3.154 17.12 0 20.97 0zm0 2c-2.756 0-4.99 2.258-4.99 5.044v89.912c0 2.786 2.234 5.044 4.99 5.044h62.06c2.756 0 4.99-2.258 4.99-5.044V7.044C88.02 4.258 85.787 2 83.03 2H20.97zm17.104 86.55c0-2.087-1.674-3.778-3.738-3.778-2.065 0-3.74 1.691-3.74 3.777 0 2.087 1.675 3.778 3.74 3.778 2.064 0 3.738-1.69 3.738-3.777zM52 84.771c2.064 0 3.739 1.691 3.739 3.777 0 2.087-1.675 3.778-3.739 3.778s-3.739-1.69-3.739-3.777 1.675-3.778 3.739-3.778zm21.403 3.777c0-2.086-1.674-3.777-3.739-3.777-2.064 0-3.738 1.691-3.738 3.777 0 2.087 1.674 3.778 3.738 3.778 2.065 0 3.74-1.69 3.74-3.777zM34.336 66.072c2.064 0 3.738 1.691 3.738 3.778 0 2.086-1.674 3.778-3.738 3.778-2.065 0-3.74-1.692-3.74-3.778 0-2.087 1.675-3.778 3.74-3.778zm21.403 3.778c0-2.087-1.675-3.778-3.739-3.778s-3.739 1.691-3.739 3.778c0 2.086 1.675 3.778 3.739 3.778s3.739-1.692 3.739-3.778zm13.925-3.778c2.065 0 3.74 1.691 3.74 3.778 0 2.086-1.675 3.778-3.74 3.778-2.064 0-3.738-1.692-3.738-3.778 0-2.087 1.674-3.778 3.738-3.778zM38.074 51.15c0-2.087-1.674-3.778-3.738-3.778-2.065 0-3.74 1.691-3.74 3.778 0 2.086 1.675 3.778 3.74 3.778 2.064 0 3.738-1.692 3.738-3.778zM52 47.372c2.064 0 3.739 1.691 3.739 3.778 0 2.086-1.675 3.778-3.739 3.778s-3.739-1.692-3.739-3.778c0-2.087 1.675-3.778 3.739-3.778zm21.403 3.778c0-2.087-1.674-3.778-3.739-3.778-2.064 0-3.738 1.691-3.738 3.778 0 2.086 1.674 3.778 3.738 3.778 2.065 0 3.74-1.692 3.74-3.778zm4.019-40.95H26.578c-1.372 0-2.485 1.124-2.485 2.511V33.49c0 1.386 1.113 2.511 2.485 2.511h50.844c1.372 0 2.485-1.125 2.485-2.51V12.71c0-1.387-1.113-2.51-2.485-2.51zm-51.35 2.511c0-.282.227-.51.506-.51h50.844c.279 0 .505.228.505.51V33.49a.509.509 0 0 1-.505.511H26.578a.509.509 0 0 1-.505-.51V12.71zM66.54 25.538v-4.877c0-.552.443-1 .99-1 .546 0 .989.448.989 1v4.877c0 .552-.443 1-.99 1a.995.995 0 0 1-.99-1z",
    clipRule: "evenodd"
  }));
};

var SvgCalculator16X16 = function SvgCalculator16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calculator",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.396 0h9.209C13.375 0 14 .625 14 1.396v13.208c0 .77-.625 1.396-1.395 1.396H3.396C2.626 16 2 15.375 2 14.604V1.396C2 .626 2.626 0 3.396 0zm.001 1.017a.38.38 0 0 0-.38.379v13.208c0 .209.17.38.38.38h9.209a.38.38 0 0 0 .379-.38V1.396a.38.38 0 0 0-.38-.38H3.398zm2.537 12.352a.556.556 0 1 0-1.111.002.556.556 0 0 0 1.111-.002zm2.067-.555A.556.556 0 1 1 8 13.926a.556.556 0 0 1 .002-1.112zm3.175.555a.555.555 0 1 0-1.11 0 .555.555 0 0 0 1.11 0zm-5.797-3.302a.556.556 0 1 1-.001 1.111.556.556 0 0 1 .001-1.11zm3.177.555a.556.556 0 1 0-1.111.001.556.556 0 0 0 1.11 0zm2.065-.555a.555.555 0 1 1 0 1.11.555.555 0 0 1 0-1.11zM5.934 7.875a.555.555 0 1 0-1.11.001.555.555 0 0 0 1.11-.001zm2.067-.554a.555.555 0 1 1 0 1.11.555.555 0 0 1 0-1.11zm3.175.554a.554.554 0 1 0-1.109 0 .554.554 0 0 0 1.109 0zm.597-6.377H4.23a.73.73 0 0 0-.73.73v3.053c0 .403.327.73.73.73h7.544a.73.73 0 0 0 .73-.73V2.228a.73.73 0 0 0-.73-.73zM4.516 4.994v-2.48h6.971v2.48h-6.97zm5.28-.88v-.718a.508.508 0 0 1 1.017 0v.717a.508.508 0 0 1-1.017 0z",
    clipRule: "evenodd"
  }));
};

var SvgCalculator24X24 = function SvgCalculator24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calculator",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M4.917 0h14.167c1.031 0 1.866.834 1.866 1.863v20.274c0 1.03-.835 1.863-1.866 1.863H4.917a1.864 1.864 0 0 1-1.867-1.863V1.863C3.05.833 3.885 0 4.917 0zm0 1a.864.864 0 0 0-.865.863v20.274c0 .477.387.863.865.863h14.167a.863.863 0 0 0 .864-.863V1.863A.863.863 0 0 0 19.084 1H4.917zm3.05 18.39a.853.853 0 1 1 .002 1.705.853.853 0 0 1-.001-1.705zm4.033 0a.852.852 0 1 1 0 1.704.853.853 0 1 1 0-1.704zm4.033 0a.852.852 0 1 1 0 1.704.853.853 0 1 1 0-1.704zm-8.065-4.217a.853.853 0 1 1 .001 1.706.853.853 0 0 1-.001-1.706zm4.032 0a.852.852 0 1 1 0 1.704.853.853 0 1 1 0-1.704zm4.033 0a.852.852 0 1 1 0 1.704.853.853 0 1 1 0-1.704zm-8.065-4.216a.853.853 0 1 1 .001 1.705.853.853 0 0 1-.001-1.705zm4.032 0a.852.852 0 1 1 0 1.704.853.853 0 1 1 0-1.704zm4.033 0a.852.852 0 1 1 0 1.704.853.853 0 1 1 0-1.704zM6.197 2.3h11.607c.465 0 .843.377.843.84v4.686a.842.842 0 0 1-.843.84H6.197a.842.842 0 0 1-.843-.84V3.14c0-.464.378-.841.843-.841zm.16 1v4.367h11.288V3.3H6.356zm8.688 1.634a.5.5 0 0 1 1.002 0v1.1a.5.5 0 0 1-1.002 0v-1.1z"
  }));
};

var SvgCalendar104X104 = function SvgCalendar104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calendar",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.17 23.087V13.043H51v10.044a1 1 0 1 0 2 0V13.043h21.83v10.044a1 1 0 1 0 2 0V13.043H102v30.59H2v-30.59h25.17v10.044a1 1 0 1 0 2 0zM0 44.654V102.2a1.8 1.8 0 0 0 1.8 1.8h100.4a1.8 1.8 0 0 0 1.8-1.8V12.844a1.8 1.8 0 0 0-1.8-1.8H76.83V1a1 1 0 1 0-2 0v10.043H53V1a1 1 0 1 0-2 0v10.043H29.17V1a1 1 0 1 0-2 0v10.043H1.8A1.8 1.8 0 0 0 0 12.844v31.77a1.022 1.022 0 0 0 0 .04zm2 .98h100V102H2V45.634zm25.785 15.513a7.529 7.529 0 1 1-15.057-.002 7.529 7.529 0 0 1 15.057.002zM52 68.675A7.529 7.529 0 1 0 52 53.617 7.529 7.529 0 0 0 52 68.675zm39.271-7.528a7.529 7.529 0 1 1-15.057-.002 7.529 7.529 0 0 1 15.058.002zM20.258 92.81a7.528 7.528 0 1 0-7.529-7.528 7.528 7.528 0 0 0 7.53 7.528zm39.271-7.528a7.528 7.528 0 1 1-15.057 0 7.528 7.528 0 0 1 15.057 0zm24.215 7.528a7.528 7.528 0 1 0-7.528-7.528 7.528 7.528 0 0 0 7.528 7.528z",
    clipRule: "evenodd"
  }));
};

var SvgCalendar16X16 = function SvgCalendar16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.996 3.748V2.624H7.5v1.124a.5.5 0 0 0 1 0V2.624h2.504v1.124a.5.5 0 0 0 1 0V2.624H14.7a.3.3 0 0 1 .3.3v3.493H1V2.924a.3.3 0 0 1 .3-.3h2.696v1.124a.5.5 0 0 0 1 0zM0 6.931V14.7A1.3 1.3 0 0 0 1.3 16h13.4a1.3 1.3 0 0 0 1.3-1.3V2.924a1.3 1.3 0 0 0-1.3-1.3h-2.696V.5a.5.5 0 0 0-1 0v1.124H8.5V.5a.5.5 0 0 0-1 0v1.124H4.996V.5a.5.5 0 0 0-1 0v1.124H1.3a1.3 1.3 0 0 0-1.3 1.3v3.979a.509.509 0 0 0 0 .028zm1 .486h14V14.7a.3.3 0 0 1-.3.3H1.3a.3.3 0 0 1-.3-.3V7.417zM4.44 9.345a1.107 1.107 0 1 1-2.215-.001 1.107 1.107 0 0 1 2.215 0zm3.56 1.107a1.107 1.107 0 1 0 0-2.215 1.107 1.107 0 0 0 0 2.215zm5.776-1.107a1.107 1.107 0 1 1-2.215-.001 1.107 1.107 0 0 1 2.215 0zM3.332 14a1.107 1.107 0 1 0-.001-2.214A1.107 1.107 0 0 0 3.332 14zm5.775-1.106a1.107 1.107 0 1 1-2.215-.001 1.107 1.107 0 0 1 2.215 0zm3.561 1.107a1.107 1.107 0 1 0 0-2.215 1.107 1.107 0 0 0 0 2.214z",
    clipRule: "evenodd"
  }));
};

var SvgCalendar24X24 = function SvgCalendar24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calendar",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M21 10V5.304a.3.3 0 0 0-.3-.3H17V6.51c0 .27-.224.49-.5.49s-.5-.22-.5-.49V5.003h-3.5v1.508c0 .27-.224.49-.5.49s-.5-.22-.5-.49V5.003H8v1.508c0 .27-.224.49-.5.49a.495.495 0 0 1-.5-.49V5.003H3.3a.3.3 0 0 0-.3.301V10h18zm0 1H3v9.696a.3.3 0 0 0 .3.3h17.4a.3.3 0 0 0 .3-.3V11zm-19-.486a.51.51 0 0 1 0-.014.51.51 0 0 1 0-.014V5.304C2 4.584 2.582 4 3.3 4H7V2.49c0-.27.224-.49.5-.49s.5.22.5.49V4h3.5V2.49c0-.27.224-.49.5-.49s.5.22.5.49V4H16V2.49c0-.27.224-.49.5-.49s.5.22.5.49V4h3.7c.718 0 1.3.584 1.3 1.304v15.392c0 .72-.582 1.304-1.3 1.304H3.3c-.718 0-1.3-.584-1.3-1.304V10.514zm5.49 3.19a1.402 1.402 0 1 1-2.805 0 1.402 1.402 0 0 1 2.804 0zm5.912 0a1.402 1.402 0 1 1-2.804 0 1.402 1.402 0 0 1 2.804 0zm5.913 0a1.402 1.402 0 1 1-2.804 0 1.402 1.402 0 0 1 2.804 0zM7.49 18.2a1.402 1.402 0 1 1-2.804 0 1.402 1.402 0 0 1 2.804 0zm5.913 0a1.402 1.402 0 1 1-2.804 0 1.402 1.402 0 0 1 2.804 0zm5.913 0a1.402 1.402 0 1 1-2.804 0 1.402 1.402 0 0 1 2.804 0z"
  }));
};

var SvgCalendarCash104X104 = function SvgCalendarCash104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calendar-cash",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.17 23.087V13.043H51v10.044a1 1 0 1 0 2 0V13.043h21.83v10.044a1 1 0 1 0 2 0V13.043H102v30.59H2v-30.59h25.17v10.044a1 1 0 1 0 2 0zM0 44.654V102.2a1.8 1.8 0 0 0 1.8 1.8h100.4a1.8 1.8 0 0 0 1.8-1.8V12.844a1.8 1.8 0 0 0-1.8-1.8H76.83V1a1 1 0 1 0-2 0v10.043H53V1a1 1 0 1 0-2 0v10.043H29.17V1a1 1 0 1 0-2 0v10.043H1.8A1.8 1.8 0 0 0 0 12.844v31.77a1.022 1.022 0 0 0 0 .04zm2 .98h100V102H2V45.634zm63.239 43.18c-3.992 0-7.239-3.283-7.239-7.318 0-.558-.448-1.011-1-1.011s-1 .453-1 1.01c0 4.798 3.597 8.763 8.239 9.282v3.212c0 .558.448 1.011 1 1.011s1-.453 1-1.01v-3.24c4.695-.656 8.243-4.694 8.239-9.587 0-4.287-3.03-7.196-9.006-8.646C60.445 71.297 58 69.113 58 65.838c0-3.916 2.977-6.651 7.232-6.651 3.544.025 6.528 2.61 7.094 6.146a1 1 0 0 0 1.147.837c.545-.09.915-.609.828-1.16-.669-4.176-3.982-7.307-8.062-7.778V54.01c0-.558-.448-1.01-1-1.01s-1 .452-1 1.01v3.197c-4.831.426-8.239 3.924-8.239 8.63 0 4.286 3.03 7.196 9.006 8.645 5.028 1.22 7.472 3.405 7.472 6.681.003 4.13-3.194 7.49-7.239 7.65zM49 61.5a1 1 0 0 0-1-1H30l-.117.007A1 1 0 0 0 30 62.5h18l.117-.007A1 1 0 0 0 49 61.5zm-3 13a1 1 0 0 0-1-1H30l-.117.007A1 1 0 0 0 30 75.5h15l.117-.007A1 1 0 0 0 46 74.5zm0 13a1 1 0 0 0-1-1H30l-.117.007A1 1 0 0 0 30 88.5h15l.117-.007A1 1 0 0 0 46 87.5z",
    clipRule: "evenodd"
  }));
};

var SvgCalendarCash16X16 = function SvgCalendarCash16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calendar-cash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.996 3.748V2.624H7.5v1.124a.5.5 0 0 0 1 0V2.624h2.504v1.124a.5.5 0 0 0 1 0V2.624H14.7a.3.3 0 0 1 .3.3v3.493H1V2.924a.3.3 0 0 1 .3-.3h2.696v1.124a.5.5 0 0 0 1 0zM0 6.931V14.7A1.3 1.3 0 0 0 1.3 16h13.4a1.3 1.3 0 0 0 1.3-1.3V2.924a1.3 1.3 0 0 0-1.3-1.3h-2.696V.5a.5.5 0 0 0-1 0v1.124H8.5V.5a.5.5 0 0 0-1 0v1.124H4.996V.5a.5.5 0 0 0-1 0v1.124H1.3a1.3 1.3 0 0 0-1.3 1.3v3.979a.509.509 0 0 0 0 .028zm1 .486h14V14.7a.3.3 0 0 1-.3.3H1.3a.3.3 0 0 1-.3-.3V7.417zM7.14 8.5a.5.5 0 0 1 .09.992l-.09.008H4.5a.5.5 0 0 1-.09-.992L4.5 8.5h2.639zm-.314 2a.5.5 0 0 1 .09.992l-.09.008h-2.25a.5.5 0 0 1-.09-.992l.09-.008h2.25zm.5 2.5a.5.5 0 0 0-.5-.5h-2.25l-.09.008a.5.5 0 0 0 .09.992h2.25l.09-.008a.5.5 0 0 0 .41-.492zm2.103-.71c0 .374.318.679.71.679a.736.736 0 0 0 .713-.725c0-.123 0-.41-.83-.6-1.318-.301-1.594-.997-1.594-1.527 0-.732.49-1.293 1.212-1.472v-.168c0-.263.224-.477.5-.477s.5.214.5.477v.189c.605.18 1.075.659 1.18 1.282a.48.48 0 0 1-.412.548.498.498 0 0 1-.574-.394.7.7 0 0 0-.697-.57c-.325 0-.708.153-.708.585 0 .123 0 .41.828.6 1.318.302 1.595.997 1.595 1.527 0 .745-.504 1.377-1.212 1.597v.182c0 .263-.224.477-.5.477s-.5-.214-.5-.477v-.175c-.706-.207-1.211-.828-1.211-1.558 0-.264.223-.477.5-.477.276 0 .5.213.5.477z",
    clipRule: "evenodd"
  }));
};

var SvgCalendarCash24X24 = function SvgCalendarCash24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calendar-cash",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.489v1.51h3.5V2.49c0-.27.224-.489.5-.489s.5.219.5.489v1.51H16V2.49c0-.27.224-.489.5-.489s.5.219.5.489v1.51h3.7c.718 0 1.3.585 1.3 1.305v15.392c0 .72-.582 1.304-1.3 1.304H3.3c-.718 0-1.3-.584-1.3-1.304V10.514a.525.525 0 0 1 0-.029V5.304C2 4.584 2.582 4 3.3 4H7V2.489c0-.27.224-.489.5-.489s.5.219.5.489Zm-5 8.51v9.697a.3.3 0 0 0 .3.3h17.4a.3.3 0 0 0 .3-.3V11H3Zm18-1H3V5.305a.3.3 0 0 1 .3-.301H7V6.51c0 .27.224.489.5.489s.5-.219.5-.489V5.003h3.5V6.51c0 .27.224.489.5.489s.5-.219.5-.489V5.003H16V6.51c0 .27.224.489.5.489s.5-.219.5-.489V5.003h3.7a.3.3 0 0 1 .3.3V10Zm-9.5 2.5a.5.5 0 0 1 .09.993l-.09.008h-4a.5.5 0 0 1-.09-.992l.09-.008h4Zm3.946.884V13a.5.5 0 0 0-1 0v.374c-.84.194-1.446.873-1.446 1.77 0 .993.73 1.56 1.835 1.813.705.16 1.057.435 1.057.837 0 .48-.376.818-.927.826a.41.41 0 0 0-.037 0 .945.945 0 0 1-.928-.946.5.5 0 0 0-1 0c0 .902.613 1.661 1.446 1.881v.384a.5.5 0 0 0 1 0v-.375c.84-.194 1.446-.873 1.446-1.77 0-.993-.73-1.56-1.835-1.812-.705-.161-1.057-.435-1.057-.838 0-.485.385-.826.946-.826.462 0 .856.334.933.789a.5.5 0 1 0 .986-.167 1.948 1.948 0 0 0-1.419-1.557ZM11 16a.5.5 0 0 0-.5-.5h-3l-.09.008a.5.5 0 0 0 .09.992h3l.09-.008A.5.5 0 0 0 11 16Zm-.5 2.5a.5.5 0 0 1 .09.992l-.09.008h-3a.5.5 0 0 1-.09-.992l.09-.008h3Z",
    fill: "currentColor"
  }));
};

var SvgCalendarChecked104X104 = function SvgCalendarChecked104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calendar-checked",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.17 1v10.043H51V1a1 1 0 1 1 2 0v10.043h21.83V1a1 1 0 1 1 2 0v10.043h25.37a1.8 1.8 0 0 1 1.8 1.801V102.2a1.8 1.8 0 0 1-1.8 1.8H1.8a1.8 1.8 0 0 1-1.8-1.8V44.654a1.022 1.022 0 0 1 0-.04v-31.77a1.8 1.8 0 0 1 1.8-1.8h25.37V1a1 1 0 1 1 2 0zM2 45.634V102h100V45.634H2zm100-2H2v-30.59h25.17v10.043a1 1 0 1 0 2 0V13.043H51v10.044a1 1 0 1 0 2 0V13.043h21.83v10.044a1 1 0 1 0 2 0V13.043H102v30.59zm-38.707 22.77 8.235 8.234 15.029-17.175a1 1 0 0 1 1.505 1.317L72.33 76.76a1 1 0 0 1-1.46.048l-8.99-8.99a1 1 0 0 1 1.414-1.414z",
    clipRule: "evenodd"
  }));
};

var SvgCalendarChecked16X16 = function SvgCalendarChecked16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calendar-checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.996.5v1.124H7.5V.5a.5.5 0 0 1 1 0v1.124h2.504V.5a.5.5 0 0 1 1 0v1.124H14.7a1.3 1.3 0 0 1 1.3 1.3V14.7a1.3 1.3 0 0 1-1.3 1.3H1.3A1.3 1.3 0 0 1 0 14.7V6.931a.509.509 0 0 1 0-.028V2.924a1.3 1.3 0 0 1 1.3-1.3h2.696V.5a.5.5 0 0 1 1 0zM1 7.417V14.7a.3.3 0 0 0 .3.3h13.4a.3.3 0 0 0 .3-.3V7.417H1zm14-1H1V2.924a.3.3 0 0 1 .3-.3h2.696v1.124a.5.5 0 0 0 1 0V2.624H7.5v1.124a.5.5 0 0 0 1 0V2.624h2.504v1.124a.5.5 0 0 0 1 0V2.624H14.7a.3.3 0 0 1 .3.3v3.493zM9.91 9.869l.945.944 1.961-2.242a.5.5 0 1 1 .753.659l-2.313 2.644a.5.5 0 0 1-.73.024l-1.323-1.322a.5.5 0 0 1 .707-.707z",
    clipRule: "evenodd"
  }));
};

var SvgCalendarChecked24X24 = function SvgCalendarChecked24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -calendar-checked",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M21 10V5.304a.3.3 0 0 0-.3-.3H17V6.51c0 .27-.224.49-.5.49s-.5-.22-.5-.49V5.003h-3.5v1.508c0 .27-.224.49-.5.49s-.5-.22-.5-.49V5.003H8v1.508c0 .27-.224.49-.5.49a.495.495 0 0 1-.5-.49V5.003H3.3a.3.3 0 0 0-.3.301V10h18zm0 1H3v9.696a.3.3 0 0 0 .3.3h17.4a.3.3 0 0 0 .3-.3V11zm-19-.486a.51.51 0 0 1 0-.014.51.51 0 0 1 0-.014V5.304C2 4.584 2.582 4 3.3 4H7V2.49c0-.27.224-.49.5-.49s.5.22.5.49V4h3.5V2.49c0-.27.224-.49.5-.49s.5.22.5.49V4H16V2.49c0-.27.224-.49.5-.49s.5.22.5.49V4h3.7c.718 0 1.3.584 1.3 1.304v15.392c0 .72-.582 1.304-1.3 1.304H3.3c-.718 0-1.3-.584-1.3-1.304V10.514zm11.838 4.308 1.271 1.296 2.531-2.947a.484.484 0 0 1 .692-.047.507.507 0 0 1 .047.705l-2.876 3.35a.484.484 0 0 1-.717.024l-1.642-1.675a.507.507 0 0 1 0-.707.484.484 0 0 1 .694 0z"
  }));
};

var SvgCameraDefault104X104 = function SvgCameraDefault104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -camera-default",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M96.956 25.383H79.199a5.033 5.033 0 0 1-3.612-1.53l-7.491-7.718A7.028 7.028 0 0 0 63.052 14H40.949c-1.9 0-3.718.77-5.044 2.135l-7.491 7.718a5.033 5.033 0 0 1-3.612 1.53H7.045C3.154 25.383 0 28.551 0 32.459v50.466C0 86.832 3.154 90 7.045 90h89.911c3.89 0 7.044-3.168 7.044-7.075V32.459c0-3.908-3.154-7.076-7.044-7.076zm0 2.009c2.786 0 5.044 2.268 5.044 5.067v50.466c0 2.798-2.258 5.066-5.044 5.066H7.045C4.258 87.991 2 85.723 2 82.925V32.459c0-2.799 2.258-5.067 5.045-5.067h17.757c1.9 0 3.718-.77 5.044-2.136l7.491-7.718a5.032 5.032 0 0 1 3.612-1.53h22.103c1.36 0 2.663.552 3.612 1.53l7.491 7.718a7.03 7.03 0 0 0 5.044 2.136h17.757zM52 31.075c11.507 0 20.833 9.368 20.833 20.925S63.507 72.925 52 72.925c-11.506 0-20.833-9.368-20.833-20.925S40.494 31.075 52 31.075zm0 2.009C41.6 33.084 33.167 41.552 33.167 52S41.6 70.916 52 70.916c10.402 0 18.833-8.468 18.833-18.916S62.403 33.084 52 33.084z",
    clipRule: "evenodd"
  }));
};

var SvgCameraDefault16X16 = function SvgCameraDefault16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -camera-default",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.611 3.69H12a.385.385 0 0 1-.278-.119l-1.103-1.145A1.377 1.377 0 0 0 9.625 2h-3.25c-.375 0-.735.154-.996.427L4.28 3.57A.386.386 0 0 1 4 3.69H1.388C.622 3.69 0 4.321 0 5.1v7.491C0 13.37.621 14 1.388 14h13.223c.767 0 1.389-.63 1.389-1.41V5.1c0-.778-.622-1.409-1.389-1.409zm0 1.002c.215 0 .389.177.389.396V12.6c0 .219-.174.396-.389.396H1.388A.392.392 0 0 1 1 12.6V5.089c0-.219.174-.396.388-.396H4c.374 0 .734-.154.995-.428l1.1-1.147a.386.386 0 0 1 .28-.12h3.25c.104 0 .205.043.277.12l1.103 1.148c.26.273.62.427.995.427h2.611zM8 4.492A3.413 3.413 0 0 1 11.417 7.9 3.413 3.413 0 0 1 8 11.307c-1.887 0-3.417-1.526-3.417-3.407S6.113 4.493 8 4.493zm0 .998c-1.335 0-2.417 1.08-2.417 2.41S6.665 10.31 8 10.31a2.414 2.414 0 0 0 2.417-2.41c0-1.33-1.083-2.41-2.417-2.41z",
    clipRule: "evenodd"
  }));
};

var SvgCameraDefault24X24 = function SvgCameraDefault24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    role: "img",
    className: "icon -camera-default"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M22.137 5.754c1.029 0 1.863.834 1.863 1.862v11.321a1.864 1.864 0 0 1-1.863 1.863H1.863A1.863 1.863 0 0 1 0 18.937V7.616c0-1.028.834-1.862 1.863-1.862h4.004a.865.865 0 0 0 .618-.26l1.69-1.733c.35-.358.831-.561 1.333-.561h4.984c.501 0 .982.203 1.334.562l1.69 1.733c.161.166.384.26.617.26h4.004zm0 1h-4.004c-.503 0-.984-.203-1.334-.562L15.111 4.46a.87.87 0 0 0-.619-.26H9.508a.865.865 0 0 0-.618.259L7.2 6.192c-.35.36-.831.562-1.333.562H1.863A.862.862 0 0 0 1 7.616v11.321c0 .477.387.864.863.864h20.274a.864.864 0 0 0 .863-.864V7.616a.863.863 0 0 0-.863-.862zM12 7.03A4.97 4.97 0 0 1 16.972 12 4.97 4.97 0 0 1 12 16.968 4.97 4.97 0 0 1 7.028 12 4.97 4.97 0 0 1 12 7.03zm0 1A3.971 3.971 0 0 0 8.028 12 3.971 3.971 0 0 0 12 15.97 3.971 3.971 0 0 0 15.972 12 3.971 3.971 0 0 0 12 8.03z"
  }));
};

var SvgCameraUpdate104X104 = function SvgCameraUpdate104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -camera-update",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M79.199 25.383h17.757c3.89 0 7.044 3.168 7.044 7.076v50.466c0 3.907-3.154 7.075-7.044 7.075H7.045C3.154 90 0 86.832 0 82.925V32.459c0-3.908 3.154-7.076 7.045-7.076h17.757c1.36 0 2.662-.551 3.612-1.53l7.491-7.718A7.028 7.028 0 0 1 40.95 14h22.103c1.9 0 3.718.77 5.044 2.135l7.49 7.718a5.033 5.033 0 0 0 3.613 1.53zM102 32.459c0-2.799-2.258-5.067-5.044-5.067H79.199a7.03 7.03 0 0 1-5.044-2.136l-7.49-7.718a5.032 5.032 0 0 0-3.613-1.53H40.949c-1.36 0-2.663.552-3.612 1.53l-7.491 7.718a7.029 7.029 0 0 1-5.044 2.136H7.045C4.258 27.392 2 29.66 2 32.459v50.466c0 2.798 2.258 5.066 5.045 5.066h89.911c2.786 0 5.044-2.268 5.044-5.066V32.459zM34.118 48.63c4.974-17.268 27.485-19.088 34.836-3.167l.86-2.27a1 1 0 0 1 1.178-.617l.111.035a1 1 0 0 1 .616 1.178l-.035.111-1.661 4.39a1 1 0 0 1-1.083.635l-.115-.025-4.818-1.312a1 1 0 0 1 .403-1.955l.123.025 2.64.719c-6.549-14.317-26.663-12.71-31.133 2.806a1 1 0 0 1-1.922-.553zm36.102 8.933a1 1 0 1 0-1.922-.554C63.84 72.476 43.845 74.122 37.23 59.955l2.515.545.124.019a1 1 0 0 0 .3-1.974l-4.88-1.058-.116-.018a1 1 0 0 0-1.048.69l-1.43 4.47-.029.114a1 1 0 0 0 .677 1.144l.113.03a1 1 0 0 0 1.144-.678l.795-2.485c7.363 15.894 29.85 14.069 34.825-3.192z",
    clipRule: "evenodd"
  }));
};

var SvgCameraUpdate16X16 = function SvgCameraUpdate16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -camera-update",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.611 3.69H12a.385.385 0 0 1-.278-.119l-1.103-1.145A1.377 1.377 0 0 0 9.625 2h-3.25c-.375 0-.735.154-.996.427L4.28 3.57A.386.386 0 0 1 4 3.69H1.388C.622 3.69 0 4.321 0 5.1v7.491C0 13.37.621 14 1.388 14h13.223c.767 0 1.389-.63 1.389-1.41V5.1c0-.778-.622-1.409-1.389-1.409zm0 1.014c.215 0 .389.177.389.395v7.491a.392.392 0 0 1-.389.396H1.388A.392.392 0 0 1 1 12.59V5.1c0-.218.174-.395.388-.395H4c.374 0 .734-.154.995-.426l1.1-1.144a.386.386 0 0 1 .28-.12h3.25c.104 0 .205.043.277.119l1.103 1.146c.26.272.62.425.995.425h2.611zm-2.735 3.577a.566.566 0 0 0 .02-.682l-.061-.07a.464.464 0 0 0-.63-.02l-.105.089C10.907 4.8 7.753 3.39 5.715 5.518a.564.564 0 0 0-.013.752c.189.212.5.218.696.014C7.8 4.82 9.915 5.724 10.11 7.599l-.115-.09-.076-.049a.47.47 0 0 0-.61.169c-.16.238-.11.57.11.743l.927.727.08.05a.462.462 0 0 0 .512-.062l.873-.74.065-.066zm-1.623 1.24a.564.564 0 0 1-.013.752c-2.007 2.093-5.095.76-5.374-1.95l-.026.028a.464.464 0 0 1-.628.062l-.068-.061a.566.566 0 0 1-.057-.68l.057-.073.784-.85a.466.466 0 0 1 .5-.13l.085.04 1.003.6a.556.556 0 0 1 .192.723.476.476 0 0 1-.586.247L6.04 8.19l-.206-.123c.112 1.959 2.289 2.936 3.724 1.44a.466.466 0 0 1 .695.013z",
    clipRule: "evenodd"
  }));
};

var SvgCameraUpdate24X24 = function SvgCameraUpdate24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -camera-update",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.137 5.612h-4.004a.852.852 0 0 1-.618-.265l-1.689-1.772A1.85 1.85 0 0 0 14.492 3H9.508c-.502 0-.983.207-1.334.574l-1.69 1.773a.855.855 0 0 1-.617.265H1.863C.833 5.612 0 6.465 0 7.516v11.579C0 20.147.834 21 1.863 21h20.274C23.165 21 24 20.146 24 19.095V7.516c0-1.051-.835-1.904-1.863-1.904Zm-4.28 6.94a.59.59 0 0 0 .05-.703l-.059-.075a.47.47 0 0 0-.64-.053l-.696.542c.225-4.568-4.699-7.051-7.828-3.749a.588.588 0 0 0-.013.778c.192.219.51.225.71.014 2.466-2.602 6.286-.687 6.128 2.884l-.627-.595-.074-.058a.472.472 0 0 0-.635.114.587.587 0 0 0 .051.776l1.42 1.347.07.055a.466.466 0 0 0 .55-.023l1.525-1.19.069-.064Zm-2.573 2.156a.588.588 0 0 1-.014.778c-2.995 3.159-7.63 1.023-7.828-3.166l-.602.602a.47.47 0 0 1-.642.032l-.067-.066a.59.59 0 0 1-.03-.704l.062-.073 1.38-1.384a.47.47 0 0 1 .544-.096l.075.046 1.561 1.148c.23.169.292.51.137.763a.478.478 0 0 1-.617.197l-.08-.047-.72-.529c.131 3.31 3.757 4.988 6.13 2.485.2-.211.518-.204.71.014ZM23 7.504a.874.874 0 0 0-.863-.884h-4.004a1.84 1.84 0 0 1-1.334-.577L15.11 4.268A.859.859 0 0 0 14.492 4H9.508a.855.855 0 0 0-.618.266L7.2 6.044c-.35.368-.831.576-1.333.576H1.863A.874.874 0 0 0 1 7.504v11.61c0 .49.386.886.863.886h20.274a.875.875 0 0 0 .863-.886V7.505Z",
    fill: "currentColor"
  }));
};

var SvgCar104X104 = function SvgCar104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -car",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.01 67.993h8.264C11.42 62.848 16.011 59 21.5 59c5.493 0 10.086 3.851 11.227 9h36.546c1.141-5.149 5.735-9 11.227-9 5.49 0 10.082 3.848 11.226 8.993h4.984c2.14 0 3.782-2.086 4.211-5.268.093-.695.2-1.577.316-2.616a453.392 453.392 0 0 0 .581-5.616l.129-1.35.032-.332.017-.185.001-.021a3.435 3.435 0 0 0-.481-1.899c-.65-1.097-1.918-1.832-4.093-2.003-1.95-.15-5.884-.618-11.234-1.314l-1.263-.166a1406.066 1406.066 0 0 1-10.29-1.394l-.94-.13a1 1 0 0 1-.721-.482l-12.57-21.21H16.38a5.754 5.754 0 0 0-3.9 2.254c-3.507 6.195-8.535 20.872-9.848 28.397-.12 1.216-.222 2.58-.308 4.066a201.63 201.63 0 0 0-.274 7.067c-.018.793-.031 1.532-.04 2.202zM91.99 70h4.72c3.33 0 5.645-2.941 6.193-7.006.096-.713.204-1.608.321-2.66a462.172 462.172 0 0 0 .714-7.001l.034-.36.015-.156.007-.099a5.372 5.372 0 0 0-.759-3.037c-.995-1.68-2.855-2.759-5.657-2.98-1.904-.146-5.82-.611-11.132-1.303l-1.26-.165a1390.808 1390.808 0 0 1-10.276-1.392l-.462-.064L61.832 22.49a1 1 0 0 0-.859-.491H16.322l-.111.006a7.752 7.752 0 0 0-5.374 3.107l-.064.1C7.145 31.587 2.016 46.546.652 54.387c-.132 1.319-.237 2.71-.325 4.22a203.6 203.6 0 0 0-.277 7.138A232.207 232.207 0 0 0 0 68.992 1.002 1.002 0 0 0 1 70h9.01c-.006.166-.01.333-.01.5C10 76.85 15.15 82 21.5 82 27.852 82 33 76.851 33 70.5c0-.17-.004-.338-.01-.505h36.02c-.006.167-.01.336-.01.505C69 76.85 74.15 82 80.5 82S92 76.85 92 70.5c0-.168-.004-.334-.01-.5zm-79.968.5c0-5.234 4.244-9.478 9.478-9.478s9.477 4.244 9.477 9.478-4.243 9.478-9.477 9.478-9.478-4.244-9.478-9.478zm68.477-9.478a9.478 9.478 0 1 0 .001 18.955 9.478 9.478 0 0 0 0-18.955z",
    clipRule: "evenodd"
  }));
};

var SvgCar16X16 = function SvgCar16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -car",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.73 6.734c.549.044.85.284 1.007.478.293.363.267.77.259.848 0 0-.093 1.037-.161 1.548-.107.82-.614 1.372-1.26 1.372h-.36c-.036 1.12-.924 2.02-2.018 2.02-1.095 0-1.983-.9-2.019-2.02H5.573C5.536 12.1 4.649 13 3.554 13c-1.095 0-1.982-.9-2.019-2.02H.5a.493.493 0 0 1-.354-.152.521.521 0 0 1-.146-.366c0-.052.007-1.296.096-2.229.199-1.183.943-3.496 1.535-4.565.278-.393.655-.617 1.067-.665L9.32 3c.176 0 .339.096.429.252l1.769 3.065c.678.097 2.61.368 3.212.417zm-.155 3.215c.134 0 .239-.248.27-.48.065-.498.156-1.51.156-1.51.001-.109-.116-.179-.348-.197-.691-.055-2.931-.374-3.42-.444l-.091-.013a.497.497 0 0 1-.36-.246L9.035 4.03H2.753a.503.503 0 0 0-.285.2c-.489.89-1.206 3.11-1.382 4.141a24.487 24.487 0 0 0-.078 1.577h.759c.339-.666 1.009-1.126 1.787-1.126s1.448.46 1.787 1.126h5.068c.339-.666 1.009-1.126 1.788-1.126.778 0 1.448.46 1.787 1.126h.591zm-3.404.963c0 .582.46 1.057 1.026 1.057.565 0 1.025-.474 1.025-1.057 0-.584-.46-1.058-1.025-1.058-.566 0-1.026.474-1.026 1.058zm-7.617 1.057c-.565 0-1.025-.474-1.025-1.057 0-.584.46-1.058 1.025-1.058s1.025.474 1.025 1.058c0 .582-.46 1.057-1.025 1.057z",
    clipRule: "evenodd"
  }));
};

var SvgCar24X24 = function SvgCar24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -car",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 16h1.844a3 3 0 0 0 6 0h7.252a3 3 0 0 0 6 0h.486c.915 0 1.53-.755 1.668-1.759a25.334 25.334 0 0 0 .112-.921 97.89 97.89 0 0 0 .134-1.309l.002-.03a1.392 1.392 0 0 0-.208-.814c-.272-.444-.773-.725-1.491-.78a63.705 63.705 0 0 1-2.497-.282l-.283-.036a327.167 327.167 0 0 1-2.29-.3l-2.775-4.532a.503.503 0 0 0-.43-.237H3.955c-.614.064-1.122.348-1.457.786-.867 1.468-2.034 4.76-2.347 6.497-.033.31-.056.616-.076.948A43.058 43.058 0 0 0 0 15.512.493.493 0 0 0 .5 16Zm20.935-.97h.647c.32 0 .598-.342.678-.919a24.604 24.604 0 0 0 .107-.894A90.711 90.711 0 0 0 23 11.925a.478.478 0 0 0-.07-.263c-.1-.161-.304-.276-.708-.307a63.78 63.78 0 0 1-2.548-.288l-.285-.036a334.55 334.55 0 0 1-2.535-.333.501.501 0 0 1-.36-.232L13.738 5.97 4.01 5.968c-.282.03-.538.174-.676.348-.774 1.317-1.904 4.503-2.192 6.098-.027.26-.05.554-.07.874a42.128 42.128 0 0 0-.065 1.742h1.497a3 3 0 0 1 5.67-.03h7.592a3 3 0 0 1 5.67.03ZM3.4 16a1.943 1.943 0 1 1 3.886 0A1.943 1.943 0 0 1 3.4 16Zm15.196-1.944a1.943 1.943 0 1 0-.001 3.886 1.943 1.943 0 0 0 0-3.886Z",
    fill: "currentColor"
  }));
};

var SvgCard104X104 = function SvgCard104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -card",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 25.193C0 21.22 3.154 18 7.044 18h89.912c3.89 0 7.044 3.22 7.044 7.193v53.615C104 82.78 100.846 86 96.956 86H7.044C3.154 86 0 82.78 0 78.808V25.193zm2 43.472v10.178C2 81.691 4.258 84 7.044 84h89.912c2.786 0 5.044-2.309 5.044-5.157V25.158c0-2.85-2.258-5.158-5.044-5.158H7.044C4.258 20 2 22.309 2 25.158V66.62h38.231c.552 0 1 .457 1 1.022s-.448 1.023-1 1.023H2zm59.547-32.396h26.906c1.407 0 2.547 1.175 2.547 2.623v14.036c0 1.45-1.14 2.624-2.547 2.624H61.547c-1.407 0-2.547-1.175-2.547-2.624V38.892c0-1.448 1.14-2.623 2.547-2.623zm0 2.09a.527.527 0 0 0-.519.533v14.036c0 .295.233.535.519.535h26.906c.287 0 .519-.24.519-.535V38.892a.526.526 0 0 0-.519-.534H61.547z",
    clipRule: "evenodd"
  }));
};

var SvgCard16X16 = function SvgCard16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -card",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 4.323C0 3.593.622 3 1.389 3h13.222C15.378 3 16 3.592 16 4.323v7.354c0 .73-.622 1.323-1.389 1.323H1.389C.622 13 0 12.408 0 11.677V4.323zm1 6.296v1.058c0 .205.174.37.389.37h13.222a.38.38 0 0 0 .389-.37V4.323a.38.38 0 0 0-.389-.37H1.389a.38.38 0 0 0-.389.37v5.344h5.269c.276 0 .5.213.5.476a.489.489 0 0 1-.5.476H1zm8.376-5.162h3.902c.398 0 .722.309.722.688v1.882c0 .379-.324.687-.722.687H9.376c-.399 0-.722-.308-.722-.687V6.145c0-.38.323-.688.722-.688zm.278 2.305H13V6.409H9.654v1.353z",
    clipRule: "evenodd"
  }));
};

var SvgCard24X24 = function SvgCard24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -card",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.914C0 4.856.834 4 1.863 4h20.274C23.167 4 24 4.856 24 5.914v12.172C24 19.142 23.166 20 22.137 20H1.863C.833 20 0 19.143 0 18.085V5.914ZM1 16.06v2.025c0 .49.386.887.863.887h20.274a.875.875 0 0 0 .863-.887V5.914a.874.874 0 0 0-.863-.886H1.863A.874.874 0 0 0 1 5.914v9.118h8.346c.276 0 .5.23.5.514a.507.507 0 0 1-.5.514H1Zm13.11-7.995h5.983c.465 0 .84.388.84.865v3.113a.852.852 0 0 1-.84.865h-5.982a.853.853 0 0 1-.841-.865V8.93c0-.477.376-.865.84-.865Zm.16 1.028v2.787h5.663V9.093H14.27Z",
    fill: "currentColor"
  }));
};

var SvgCardAdd104X104 = function SvgCardAdd104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -card-add",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M102 27.121V14.033a5.04 5.04 0 0 0-5.044-5.036H20.645a5.04 5.04 0 0 0-5.045 5.036v9.17H85.74c3.89 0 7.044 3.15 7.044 7.034V44.42c0 .202-.06.39-.163.546A29.082 29.082 0 0 1 102 57.395V27.12zM90.785 43.668V30.237a5.04 5.04 0 0 0-5.044-5.036H7.044A5.04 5.04 0 0 0 2 30.237v35.266h33.917a1 1 0 1 1 0 1.997H2v8.074a5.04 5.04 0 0 0 5.044 5.036h41.834A28.885 28.885 0 0 1 46 68c0-16.017 12.984-29 29-29a28.864 28.864 0 0 1 15.785 4.668zM49.942 82.607C54.972 91.216 64.311 97 75.001 97 91.016 97 104 84.016 104 68c0-.68-.023-1.353-.069-2.02.044-.113.069-.236.069-.365V14.033C104 10.149 100.846 7 96.956 7H20.645c-3.891 0-7.045 3.148-7.045 7.033v9.17H7.044c-3.89 0-7.044 3.15-7.044 7.034v45.337c0 3.884 3.154 7.033 7.044 7.033h42.898zm25.059-41.6c14.907 0 26.991 12.085 26.991 26.993 0 14.907-12.084 26.992-26.991 26.992-14.908 0-26.994-12.085-26.994-26.993 0-14.907 12.086-26.991 26.994-26.991zM62.985 67H74V55.985c0-.544.447-.985 1-.985s1 .441 1 .985V67h11.015c.544 0 .985.447.985.998a.992.992 0 0 1-.985.999H76v11.018c0 .544-.448.985-1 .985s-1-.441-1-.985V68.997H62.985a.992.992 0 0 1-.985-.999c0-.551.44-.998.985-.998z",
    clipRule: "evenodd"
  }));
};

var SvgCardAdd16X16 = function SvgCardAdd16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -card-add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 4.413V2.487a.389.389 0 0 0-.389-.388H3.39A.389.389 0 0 0 3 2.487v.997h9.962c.767 0 1.389.62 1.389 1.387v1.906c.238.199.456.422.65.664V4.413zm-1.649 1.726V4.87a.389.389 0 0 0-.389-.388H1.389A.389.389 0 0 0 1 4.87v4.836h4.635a.5.5 0 1 1 0 .999H1v.836c0 .215.174.389.389.389h5.705a4.6 4.6 0 0 1 6.257-5.792zm-5.004 6.076a.497.497 0 0 0-.052-.086 3.6 3.6 0 0 1 3.103-5.425A3.6 3.6 0 0 1 15 10.304a3.6 3.6 0 0 1-3.602 3.598 3.6 3.6 0 0 1-3.05-1.686zm-.725.715a4.597 4.597 0 0 0 3.776 1.97 4.6 4.6 0 0 0 4.6-4.767.518.518 0 0 0 .002-.056v-7.59c0-.766-.622-1.387-1.389-1.387H3.39C2.623 1.1 2 1.721 2 2.487v.997H1.39C.622 3.484 0 4.104 0 4.87v6.671c0 .766.622 1.388 1.389 1.388h6.233zm1.983-3.127h1.294V8.511a.5.5 0 0 1 1 0v1.292h1.294a.5.5 0 1 1 0 1h-1.294v1.292a.5.5 0 0 1-1 0v-1.292H9.605a.5.5 0 0 1 0-1z",
    clipRule: "evenodd"
  }));
};

var SvgCardAdd24X24 = function SvgCardAdd24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -card-add",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6.507V3.558a.862.862 0 0 0-.863-.86H4.93a.862.862 0 0 0-.863.86v1.793h15.541a1.86 1.86 0 0 1 1.863 1.859v3.043A6.814 6.814 0 0 1 23 11.987v-5.48ZM20.47 9.584V7.21a.862.862 0 0 0-.863-.861H3.577a.566.566 0 0 1-.02 0H1.863a.862.862 0 0 0-.863.86v7.672h7.373a.5.5 0 1 1 0 .998H1v1.545c0 .476.386.86.863.86h9.144a6.734 6.734 0 0 1-.586-2.757c0-3.74 3.04-6.773 6.79-6.773a6.77 6.77 0 0 1 3.26.83Zm-8.174 9a.498.498 0 0 0-.069-.114 5.736 5.736 0 0 1-.807-2.943c0-3.19 2.592-5.776 5.79-5.776 3.197 0 5.789 2.586 5.789 5.776s-2.592 5.775-5.79 5.775a5.79 5.79 0 0 1-4.913-2.719Zm-.738.698a6.788 6.788 0 0 0 5.652 3.018C20.96 22.3 24 19.267 24 15.527c0-.091-.002-.182-.006-.273A.497.497 0 0 0 24 15.18V3.558A1.861 1.861 0 0 0 22.137 1.7H4.93a1.861 1.861 0 0 0-1.863 1.858v1.793H1.863A1.86 1.86 0 0 0 0 7.21v10.214a1.86 1.86 0 0 0 1.863 1.858h9.696Zm2.901-4.254h2.25v-2.245a.5.5 0 0 1 1 0v2.245h2.251a.5.5 0 0 1 0 1h-2.25v2.243a.5.5 0 0 1-1 0V16.03h-2.25a.5.5 0 0 1 0-1Z",
    fill: "currentColor"
  }));
};

var SvgCardMachine104X104 = function SvgCardMachine104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -card-machine",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.783 84.674h-3.981a1.801 1.801 0 0 1-1.802-1.8V1.799A1.8 1.8 0 0 1 24.802 0h54.395C80.192 0 81 .806 81 1.799v81.075c0 .994-.808 1.8-1.803 1.8h-3.98v12.39c0 3.831-3.11 6.936-6.947 6.936H35.728c-3.835 0-6.945-3.105-6.945-6.935V84.674zm.977-2h-4.757V2h53.994v80.674H74.24a1.048 1.048 0 0 0-.05 0H29.81a1.036 1.036 0 0 0-.05 0zm1.026 2v12.39A4.939 4.939 0 0 0 35.728 102H68.27c2.73 0 4.943-2.21 4.943-4.935V84.674H30.786zm37.025-37.977H36.189a1.2 1.2 0 0 1-1.202-1.2V13.924a1.2 1.2 0 0 1 1.202-1.2H67.81c.663 0 1.202.538 1.202 1.2v31.573a1.2 1.2 0 0 1-1.202 1.2zm-.801-2V14.724H36.99v29.973h30.02zM35.989 60.712h32.435a1 1 0 1 0 0-2H35.989a1 1 0 1 0 0 2z",
    clipRule: "evenodd"
  }));
};

var SvgCardMachine16X16 = function SvgCardMachine16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -card-machine",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.243 13.158v1.47c0 .205.167.372.372.372h4.767a.373.373 0 0 0 .372-.373v-1.469H5.243zm6.508-.08a1.3 1.3 0 0 0 .847-1.22V1.3c0-.717-.58-1.3-1.297-1.3H4.696C3.98 0 3.398.583 3.398 1.3v10.558a1.3 1.3 0 0 0 .847 1.22v1.55c0 .757.614 1.372 1.37 1.372h4.767c.756 0 1.37-.615 1.37-1.373v-1.55zm-.45-.92a.3.3 0 0 0 .3-.3V1.3a.3.3 0 0 0-.3-.3H4.696a.3.3 0 0 0-.299.3v10.558a.3.3 0 0 0 .3.3h6.606zm-1.157-4.585H5.852a.7.7 0 0 1-.698-.7V2.571a.7.7 0 0 1 .698-.7h4.292a.7.7 0 0 1 .698.7v4.302a.7.7 0 0 1-.698.7zm-.3-1V2.871H6.153v3.702h3.693zM5.654 9.635h4.752a.5.5 0 0 0 0-1H5.653a.5.5 0 0 0 0 1z",
    clipRule: "evenodd"
  }));
};

var SvgCardMachine24X24 = function SvgCardMachine24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -card-machine",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.503 19.642h-.004a1.3 1.3 0 0 1-1.3-1.3V1.3A1.3 1.3 0 0 1 6.5 0h11a1.3 1.3 0 0 1 1.3 1.3v17.042a1.3 1.3 0 0 1-1.299 1.3v2.52A1.838 1.838 0 0 1 15.662 24H8.34a1.837 1.837 0 0 1-1.837-1.838v-2.52Zm.487-1H6.5a.3.3 0 0 1-.3-.3V1.3a.3.3 0 0 1 .3-.3H17.5a.3.3 0 0 1 .3.3v17.042a.3.3 0 0 1-.3.3h-.488a.53.53 0 0 0-.013 0H7.015a.523.523 0 0 0-.025 0Zm.512 1v2.52c0 .463.375.838.838.838h7.322a.839.839 0 0 0 .839-.838v-2.52H7.502Zm7.901-8.564H8.597a.7.7 0 0 1-.7-.7V3.57a.7.7 0 0 1 .7-.7h6.806a.7.7 0 0 1 .7.7v6.81a.7.7 0 0 1-.7.7Zm-.298-7.209H8.898v6.21h6.207v-6.21ZM8.396 14.24h7.3a.5.5 0 0 0 0-1h-7.3a.5.5 0 0 0 0 1Z",
    fill: "currentColor"
  }));
};

var SvgCards104X104 = function SvgCards104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cards",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M102.009 23.085c0-2.802-2.248-5.073-5.022-5.073H21.014c-2.774 0-5.023 2.27-5.023 5.073v6.593h66.996c3.873 0 7.013 3.172 7.013 7.086V72.31h6.987c2.774 0 5.022-2.271 5.022-5.074V23.085zm-88.009 0v6.593H7.014C3.14 29.678 0 32.85 0 36.764v44.151C0 84.828 3.14 88 7.014 88h75.973C86.86 88 90 84.828 90 80.915v-6.593h6.987c3.873 0 7.013-3.172 7.013-7.086V23.085c0-3.913-3.14-7.085-7.013-7.085H21.014C17.14 16 14 19.172 14 23.085zM1.991 80.915v-7.734h32.854a1 1 0 0 0 .996-1.005 1 1 0 0 0-.996-1.006H1.991V36.764c0-2.803 2.248-5.075 5.023-5.075h75.973c2.774 0 5.022 2.272 5.022 5.075v44.151c0 2.802-2.248 5.073-5.022 5.073H7.014c-2.774 0-5.023-2.27-5.023-5.073zm51.52-35.944h22.591a2.518 2.518 0 0 1 2.511 2.526v11.305a2.519 2.519 0 0 1-2.51 2.526H53.51a2.519 2.519 0 0 1-2.51-2.526V47.497a2.518 2.518 0 0 1 2.51-2.526zm0 2.012a.513.513 0 0 0-.51.514v11.305c0 .283.229.514.51.514h22.591c.282 0 .511-.23.511-.514V47.497a.513.513 0 0 0-.51-.514H53.51z",
    clipRule: "evenodd"
  }));
};

var SvgCards16X16 = function SvgCards16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cards",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 3.853a.383.383 0 0 0-.389-.378H3.389A.383.383 0 0 0 3 3.853V4.5h9.611c.767 0 1.389.605 1.389 1.353v4.672h.611c.215 0 .389-.17.389-.38V3.854zm-13 0V4.5h-.611C.622 4.5 0 5.105 0 5.853v6.293c0 .748.622 1.354 1.389 1.354h11.222c.767 0 1.389-.606 1.389-1.354V11.5h.611c.767 0 1.389-.606 1.389-1.354V3.853c0-.748-.622-1.353-1.389-1.353H3.389C2.622 2.5 2 3.105 2 3.853zm11 7.048v1.245c0 .21-.174.38-.389.38H1.389a.384.384 0 0 1-.389-.38v-.758h4.5c.276 0 .5-.218.5-.487s-.224-.487-.5-.487H1v-4.56c0-.21.174-.38.389-.38h11.222c.215 0 .389.17.389.38V10.9zM8.222 6.623h3.322c.4 0 .722.323.722.72v1.648c0 .398-.322.721-.722.721H8.222a.721.721 0 0 1-.722-.72V7.343c0-.398.323-.721.722-.721zM8.5 8.715h2.766V7.62H8.5v1.095z",
    clipRule: "evenodd"
  }));
};

var SvgCards24X24 = function SvgCards24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cards",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.997 7.647v-1.87c0-.454-.388-.823-.866-.823H4.869c-.478 0-.866.369-.866.824V7h15.128C20.163 7 21 7.796 21 8.778v7.268h1.131c.478 0 .866-.369.866-.823V7.647ZM3 5.777V7H1.869C.837 7 0 7.796 0 8.778v9.445C0 19.204.837 20 1.869 20h17.262C20.163 20 21 19.204 21 18.223V17h1.131C23.163 17 24 16.204 24 15.223V5.777C24 4.797 23.163 4 22.131 4H4.869C3.837 4 3 4.796 3 5.778ZM1.004 18.223V16.83h7.189a.49.49 0 0 0 .501-.477.49.49 0 0 0-.501-.477h-7.19V8.778c0-.455.389-.824.867-.824h17.262c.478 0 .865.37.865.824v9.445c0 .454-.387.823-.865.823H1.87c-.479 0-.866-.369-.866-.824Zm11.337-7.724h5.094c.464 0 .84.377.84.842v2.535a.842.842 0 0 1-.84.842H12.34a.842.842 0 0 1-.841-.842V11.34c0-.465.376-.841.84-.841Zm.159 3.218h4.776V11.5H12.5v2.217Z",
    fill: "currentColor"
  }));
};

var SvgCart104X104 = function SvgCart104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cart",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.607 58.098A2.502 2.502 0 0 0 31.03 60h43.924a2.5 2.5 0 0 0 2.372-1.717l6.316-19.037h13.401c2.758 0 4.933 2.243 4.933 5.07l.008 2.03v.086l.006 1.345.002.604v48.53c0 2.8-2.258 5.07-5.041 5.07H7.047c-2.784 0-5.04-2.27-5.04-5.07V44.09c0-2.801 2.256-5.071 5.04-5.071h16.812l4.748 19.079zM23.357 37 20.24 24.468a1.014 1.014 0 0 1-.012-.047L14.745 2.387a.505.505 0 0 0-.49-.383H.998A1 1 0 0 1 0 1.002 1 1 0 0 1 .997 0h13.258c1.147 0 2.148.785 2.425 1.902L21.979 23.2h63.52c1.706 0 2.91 1.678 2.371 3.304l-3.558 10.724h12.732c3.878 0 6.94 3.158 6.94 7.09l.008 2.02v.086l.005 1.346.003.608v48.534c0 3.915-3.156 7.089-7.048 7.089H7.047C3.155 104 0 100.826 0 96.911V44.09C0 40.174 3.155 37 7.047 37h16.31zm-.88-11.797H85.5c.345 0 .588.339.479.668L75.435 57.649a.505.505 0 0 1-.48.347H31.032a.506.506 0 0 1-.49-.385l-8.063-32.408zM37.782 66c3.746 0 6.782 3.067 6.782 6.85s-3.036 6.847-6.782 6.847c-3.745 0-6.781-3.066-6.781-6.848S34.036 66 37.781 66zm37.782 6.85c0-3.783-3.036-6.85-6.782-6.85C65.036 66 62 69.067 62 72.85s3.036 6.847 6.781 6.847c3.746 0 6.782-3.066 6.782-6.848z",
    clipRule: "evenodd"
  }));
};

var SvgCart16X16 = function SvgCart16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m2.238 1.01.752 3.038.008.033.335 1.353H1.438c-.766 0-1.386.626-1.386 1.4V14.6c0 .772.62 1.399 1.386 1.399h13.177C15.38 16 16 15.373 16 14.6V7.464l-.001-.288v-.012l-.001-.296c0-.774-.605-1.4-1.37-1.4h-1.336l.353-1.07a.727.727 0 0 0-.684-.96H3.87L3.155.552a.72.72 0 0 0-.7-.552H.5C.224 0 0 .226 0 .505c0 .278.224.504.5.504h1.738zm9.888 4.796-.005.013-.916 2.773H5.146L4.12 4.447h8.455l-.45 1.359zm.832.671h1.67c.207 0 .37.168.37.39v.311l.002.287v7.136c0 .215-.173.39-.385.39H1.438a.388.388 0 0 1-.386-.39V6.833c0-.216.172-.39.386-.39h2.145l.646 2.608c.082.325.37.55.7.55h6.477a.72.72 0 0 0 .685-.498l.867-2.626zm-7.022 3.54c.551 0 .997.45.997 1.007s-.446 1.007-.997 1.007c-.55 0-.998-.451-.998-1.007s.447-1.007.998-1.007zm5.457 1.007c0-.556-.447-1.007-.998-1.007-.55 0-.996.45-.996 1.007s.446 1.007.997 1.007c.55 0 .996-.451.996-1.007z",
    clipRule: "evenodd"
  }));
};

var SvgCart24X24 = function SvgCart24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cart",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.804 3 .977 3.946.015.06.465 1.881H3.688c-.897 0-1.622.733-1.622 1.634v9.846c0 .9.725 1.633 1.622 1.633h16.69c.897 0 1.622-.732 1.622-1.633V11.32L22 10.955v-.016l-.002-.376c0-.902-.706-1.634-1.602-1.634h-1.88l.51-1.543a.783.783 0 0 0-.741-1.03H6.665l-.93-3.761A.78.78 0 0 0 4.976 2H2.5a.5.5 0 0 0 0 1h2.304Zm13.382 6.93-1.13 3.423a.78.78 0 0 1-.742.538H8.11a.78.78 0 0 1-.757-.595l-.844-3.409h-2.82a.628.628 0 0 0-.623.634v9.846c0 .35.28.633.622.633h16.69a.628.628 0 0 0 .622-.633v-9.045L21 10.96v-.016l-.002-.38c0-.357-.267-.634-.602-.634h-2.21ZM6.913 7.355h11.069l-1.827 5.535H8.283l-1.37-5.535Zm2.473 7.201a1.27 1.27 0 0 1 1.264 1.276 1.27 1.27 0 0 1-1.264 1.276 1.27 1.27 0 0 1-1.263-1.276 1.27 1.27 0 0 1 1.263-1.276Zm6.912 1.276a1.27 1.27 0 0 0-1.264-1.276 1.27 1.27 0 0 0-1.263 1.276 1.27 1.27 0 0 0 1.263 1.276 1.27 1.27 0 0 0 1.264-1.276Z",
    fill: "currentColor"
  }));
};

var SvgCash104X104 = function SvgCash104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M96.955 18H7.044C3.154 18 0 21.194 0 25.133v53.734C0 82.807 3.154 86 7.044 86h89.911c3.891 0 7.045-3.193 7.045-7.133V25.133c0-3.94-3.154-7.133-7.045-7.133zM2 25.133c0-2.82 2.258-5.108 5.044-5.108h89.911c2.787 0 5.045 2.287 5.045 5.108v53.734c0 2.82-2.258 5.108-5.045 5.108H7.044C4.258 83.975 2 81.688 2 78.867V25.133zm49.002 12.378v-3.217c0-.56.448-1.012 1-1.012s1 .453 1 1.012v3.228c3.6.443 6.55 3.232 7.17 6.93a1.011 1.011 0 0 1-.817 1.169 1.001 1.001 0 0 1-1.154-.829c-.514-3.063-3.133-5.304-6.201-5.306-3.628 0-6.285 2.382-6.285 5.75 0 2.964 2.345 4.812 6.508 5.777 4.965 1.15 8.063 3.59 8.063 7.751 0 4.217-3.1 7.301-7.284 7.727v3.215c0 .56-.448 1.013-1 1.013s-1-.454-1-1.013V66.48c-4.105-.5-7.287-4.039-7.287-8.33 0-.56.448-1.013 1-1.013s1 .453 1 1.012c0 3.497 2.783 6.335 6.228 6.366a1.045 1.045 0 0 1 .118 0c3.598-.027 6.225-2.4 6.225-5.752 0-2.966-2.344-4.812-6.51-5.776-4.963-1.151-8.061-3.592-8.061-7.752 0-4.217 3.1-7.301 7.287-7.725z",
    clipRule: "evenodd"
  }));
};

var SvgCash16X16 = function SvgCash16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.612 3H1.389C.622 3 0 3.622 0 4.389v7.222C0 12.378.622 13 1.389 13h13.223c.766 0 1.388-.622 1.388-1.389V4.389C16 3.622 15.378 3 14.612 3zM1 4.389C1 4.174 1.174 4 1.389 4h13.223c.214 0 .388.174.388.389v7.222a.389.389 0 0 1-.388.389H1.389A.389.389 0 0 1 1 11.611V4.389zm6.5 1.218v-.179a.5.5 0 0 1 1 0v.19c.537.18.951.643 1.05 1.228a.5.5 0 1 1-.986.166A.571.571 0 0 0 8 6.536c-.347 0-.571.198-.571.482 0 .222.212.387.683.494.872.2 1.46.658 1.46 1.47 0 .693-.446 1.226-1.072 1.411v.178a.5.5 0 0 1-1 0v-.187A1.573 1.573 0 0 1 6.43 8.893a.5.5 0 0 1 1 0 .572.572 0 0 0 .587.572c.339-.007.556-.203.556-.482 0-.223-.212-.388-.683-.496-.871-.198-1.46-.657-1.46-1.47 0-.69.446-1.224 1.071-1.41z",
    clipRule: "evenodd"
  }));
};

var SvgCash24X24 = function SvgCash24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M12.5 15.461v.481a.5.5 0 1 1-1 0v-.489a2.143 2.143 0 0 1-1.643-2.083.5.5 0 1 1 1 0c0 .63.511 1.142 1.143 1.142.674 0 1.143-.415 1.143-1.006 0-.498-.426-.83-1.255-1.019-1.23-.281-2.031-.905-2.031-1.993 0-1.004.691-1.76 1.644-1.956v-.48a.5.5 0 1 1 1 0v.489c.819.196 1.466.865 1.613 1.726a.5.5 0 1 1-.986.167A1.144 1.144 0 0 0 12 9.488c-.674 0-1.143.415-1.143 1.006 0 .497.425.829 1.254 1.018 1.23.282 2.032.906 2.032 1.994 0 1.003-.69 1.759-1.643 1.955zM1.864 4.6h20.274C23.166 4.6 24 5.434 24 6.463v11.074a1.863 1.863 0 0 1-1.863 1.863H1.863A1.864 1.864 0 0 1 0 17.537V6.463C0 5.434.834 4.6 1.863 4.6zm0 1A.863.863 0 0 0 1 6.463v11.074c0 .476.387.863.863.863h20.274a.863.863 0 0 0 .863-.863V6.463a.863.863 0 0 0-.863-.863H1.863z"
  }));
};

var SvgCashCoins104X104 = function SvgCashCoins104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash-coins",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M63.2 91.196c0 2.74 8.296 5.803 19.4 5.803s19.4-3.064 19.4-5.803V81.033c-3.642 2.85-11.698 4.36-19.4 4.36-7.702 0-15.758-1.51-19.4-4.36v10.163zm19.4-46.627c-11.104 0-19.4 3.064-19.4 5.804s8.296 5.803 19.4 5.803 19.4-3.064 19.4-5.803c0-2.74-8.296-5.804-19.4-5.804zm0 25.214c11.104 0 19.4-3.063 19.4-5.803V53.818c-3.642 2.85-11.698 4.359-19.4 4.359-7.702 0-15.758-1.509-19.4-4.36V63.98c0 2.74 8.296 5.804 19.4 5.804zm0 13.608c11.104 0 19.4-3.064 19.4-5.803V67.425c-3.642 2.85-11.698 4.36-19.4 4.36-7.702 0-15.758-1.51-19.4-4.36v10.163c0 2.74 8.296 5.803 19.4 5.803zM2 61.187a5.052 5.052 0 0 0 5.044 5.048H61.2V50.372c0-5.07 11.026-7.805 21.4-7.805 7.702 0 15.758 1.509 19.4 4.36v-34.88a5.051 5.051 0 0 0-5.045-5.047H7.044A5.05 5.05 0 0 0 2 12.048v49.139zM7.044 5h89.911C100.84 5 104 8.162 104 12.048v79.148C104 96.265 92.974 99 82.6 99c-10.374 0-21.4-2.736-21.4-7.804v-22.96H7.044C3.16 68.236 0 65.074 0 61.186V12.049C0 8.162 3.16 5 7.044 5zm38.67 24.934c0 2.799 2.19 4.72 6.509 5.708 6.664 1.525 8.063 5.006 8.063 7.659 0 4.135-3.009 7.214-7.285 7.631v3.18a1 1 0 1 1-2 0v-3.194c-4.098-.495-7.287-3.991-7.287-8.224a1 1 0 0 1 2 0c0 3.466 2.818 6.287 6.281 6.289h.003l.003-.001.006.001c3.638-.003 6.278-2.391 6.278-5.682 0-2.799-2.189-4.719-6.508-5.708-6.664-1.525-8.063-5.007-8.063-7.659 0-4.065 3.07-7.197 7.287-7.627v-3.184a1 1 0 0 1 2 0v3.197a8.268 8.268 0 0 1 7.171 6.84 1 1 0 1 1-1.971.335 6.28 6.28 0 0 0-6.202-5.242c-3.641 0-6.285 2.39-6.285 5.681z",
    clipRule: "evenodd"
  }));
};

var SvgCashCoins16X16 = function SvgCashCoins16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash-coins",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.389.75h13.222A1.39 1.39 0 0 1 16 2.136v11.616c0 1.035-1.758 1.498-3.5 1.498S9 14.787 9 13.752v-3.017H1.389A1.39 1.39 0 0 1 0 9.348V2.136A1.39 1.39 0 0 1 1.389.75zM1 2.136v7.212c0 .214.174.389.389.389H9V7.873a1.542 1.542 0 0 1-.5.252v.185a.5.5 0 0 1-1 0v-.196a1.566 1.566 0 0 1-1.071-1.48.5.5 0 0 1 1 0c0 .315.256.57.571.57.284 0 .571-.148.571-.48 0-.085 0-.34-.682-.495-1.271-.29-1.46-1.044-1.46-1.468 0-.676.437-1.213 1.071-1.402v-.185a.5.5 0 0 1 1 0v.197c.537.18.95.633 1.05 1.218a.499.499 0 0 1-.41.576.504.504 0 0 1-.577-.409A.57.57 0 0 0 8 4.28c-.284 0-.571.149-.571.481 0 .084 0 .339.682.494 1.271.291 1.46 1.045 1.46 1.468 0 .051-.007.1-.014.148l-.004.032c.654-.433 1.799-.64 2.947-.64.918 0 1.833.133 2.5.405V2.136a.388.388 0 0 0-.389-.387H1.389A.388.388 0 0 0 1 2.136zm9 11.616c.088.104.955.5 2.5.5s2.412-.396 2.513-.562l-.002-.848c-.668.276-1.588.41-2.511.41-.918 0-1.833-.132-2.5-.405v.905zm.045-5.991c.235-.185 1.073-.5 2.455-.5 1.382 0 2.22.315 2.455.5-.235.185-1.073.5-2.455.5-1.382 0-2.22-.315-2.455-.5zm4.957 1.09c-.667.275-1.583.408-2.502.408-.918 0-1.833-.133-2.5-.406v.905c.088.104.955.5 2.5.5 1.521 0 2.382-.384 2.504-.553l-.002-.854zm.007 2.846c-.112.168-.976.557-2.509.557-1.545 0-2.412-.395-2.5-.499v-.905c.667.273 1.582.406 2.5.406.921 0 1.839-.134 2.507-.41l.002.851z",
    clipRule: "evenodd"
  }));
};

var SvgCashCoins24X24 = function SvgCashCoins24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash-coins",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M17.7 20.007c-2.112 0-3.218-.558-3.3-.762v-1.35c.842.396 2.092.59 3.3.59 1.21 0 2.46-.194 3.302-.59v1.333c-.084.22-1.19.779-3.302.779zM3.626 14.32A.625.625 0 0 1 3 13.7V4.615c0-.343.281-.622.626-.622h16.748c.345 0 .626.279.626.622v5.918c-.842-.394-2.092-.588-3.3-.588-1.574 0-3.233.319-3.942 1 .06-.173.1-.357.1-.553 0-.495-.228-1.374-1.747-1.72-.968-.22-.968-.62-.968-.75 0-.51.444-.74.856-.74.42 0 .776.3.847.71.046.27.306.453.577.406a.495.495 0 0 0 .408-.572 1.84 1.84 0 0 0-1.33-1.462v-.342a.498.498 0 0 0-.5-.496c-.277 0-.5.222-.5.496v.333c-.799.195-1.358.843-1.358 1.666 0 .494.226 1.375 1.745 1.72.97.22.97.62.97.75 0 .508-.446.74-.858.74a.854.854 0 0 1-.857-.851c0-.274-.224-.497-.5-.497s-.5.223-.5.497c0 .844.577 1.549 1.357 1.767v.344c0 .274.224.496.5.496.277 0 .5-.222.5-.496v-.334c.387-.094.714-.295.95-.572v.006a.485.485 0 0 0-.05.209v2.62H3.626zM21 11.686c-.09.223-1.19.774-3.3.774s-3.21-.55-3.3-.742v-.005c.09-.224 1.19-.775 3.3-.775s3.21.551 3.3.742v.006zm.001 2.512c-.09.223-1.195.778-3.3.778-2.113 0-3.219-.558-3.3-.761v-1.35c.841.396 2.091.588 3.3.588 1.207 0 2.457-.192 3.3-.588v1.333zm0 2.515c-.087.223-1.193.779-3.3.779-2.113 0-3.219-.558-3.3-.762v-1.35c.841.396 2.091.59 3.3.59 1.208 0 2.458-.194 3.3-.59v1.333zM20.374 3H3.626C2.73 3 2 3.724 2 4.615v9.084c0 .89.73 1.614 1.626 1.614H13.4v3.932c0 1.206 2.23 1.755 4.3 1.755 2.071 0 4.3-.55 4.3-1.755V4.615C22 3.724 21.27 3 20.374 3z"
  }));
};

var SvgCashHome104X104 = function SvgCashHome104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash-home",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m91 38.303 11.326 10.433a.993.993 0 0 0 1.413-.065 1.017 1.017 0 0 0-.065-1.427L90.742 35.332a1.012 1.012 0 0 0-.138-.127L52.674.264a.993.993 0 0 0-1.348 0l-51 46.98a1.017 1.017 0 0 0-.065 1.427.993.993 0 0 0 1.413.065L14 37.382v65.615c0 .554.449 1.003 1.003 1.003h23.862c.754 0 .948-.771.993-.762.023.004.01.197.01.762h25.264c0-.565-.013-.758.01-.762.045-.009.24.762.993.762h23.862c.554 0 1.003-.449 1.003-1.003V38.303Zm-2.005-1.847L52 2.376l-36.127 33.28a1 1 0 0 1 .132.498v65.839h21.858c0 .565-.014.758.009.762.046.009.24-.762.993-.762h27.27c.753 0 .947.771.993.762.022-.004.01-.197.01-.762h21.857V36.456Zm-37.183-6.44a1.015 1.015 0 1 1 2.026 0v6.627l.419.069c5.584.921 10.086 5.195 11.06 10.787a1.016 1.016 0 0 1-.855 1.166c-.577.096-1.112-.284-1.207-.83-.935-5.364-5.694-9.28-11.255-9.283-6.504 0-11.408 4.156-11.408 10.126 0 2.645 1.09 4.797 3.112 6.48 2.002 1.668 4.903 2.865 8.53 3.674 4.169.93 7.492 2.368 9.765 4.364 2.257 1.981 3.501 4.53 3.501 7.764 0 6.368-4.696 11.105-11.23 12.001l-.431.06v6.963c0 .565-.458 1.016-1.013 1.016a1.015 1.015 0 0 1-1.014-1.016V83.12l-.476-.023c-7.154-.337-12.836-6.102-12.836-13.15 0-.552.46-1.012 1.046-1.012.585 0 1.046.46 1.046 1.012 0 6.16 5.115 11.14 11.408 11.14 6.506 0 11.408-4.155 11.408-10.128 0-2.645-1.09-4.797-3.11-6.48-2.002-1.667-4.903-2.864-8.533-3.674-4.166-.93-7.489-2.367-9.763-4.363-2.257-1.982-3.502-4.532-3.502-7.765 0-6.868 5.475-11.852 12.832-12.138l.48-.019v-6.505Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  }))));
};

var SvgCashHome16X16 = function SvgCashHome16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash-home",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.163 7.711a.5.5 0 0 0 .674-.738L8.337.13a.5.5 0 0 0-.674 0l-7.5 6.842a.5.5 0 0 0 .674.738L2 6.651v8.848a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V6.65l1.163 1.061ZM3 15V5.74l5-4.562 5 4.561V15H3ZM7.995 5.5a.35.35 0 0 0-.35.35v.19c-.73.159-1.247.808-1.247 1.649 0 .445.149.81.423 1.094.27.278.647.464 1.09.58.34.09.586.215.744.37.153.15.234.336.234.578 0 .562-.38.938-.895.938-.47 0-.894-.447-.894-1.057 0-.18-.133-.373-.351-.373-.218 0-.35.193-.35.373 0 .841.518 1.58 1.246 1.761v.197a.35.35 0 1 0 .7 0v-.19c.73-.16 1.245-.808 1.245-1.649 0-.445-.148-.81-.422-1.094-.269-.278-.647-.463-1.09-.58-.34-.09-.586-.215-.744-.37a.769.769 0 0 1-.234-.578c0-.562.38-.938.894-.938.416 0 .805.35.883.877.027.181.191.352.41.31.208-.042.309-.25.282-.427-.106-.72-.59-1.303-1.224-1.463V5.85a.35.35 0 0 0-.35-.35Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
};

var SvgCashHome24X24 = function SvgCashHome24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash-home",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.163 11.536a.5.5 0 0 0 .674-.738l-9.5-8.667a.5.5 0 0 0-.674 0l-9.5 8.667a.5.5 0 0 0 .674.738l1.698-1.549v11.514a.5.5 0 0 0 .5.5H18.97a.5.5 0 0 0 .5-.5V9.991l1.694 1.545ZM5.535 9.092v-.017L12 3.177l6.47 5.902V21H5.534V9.092Zm6.466-.792a.497.497 0 0 0-.493.5v.273c-1.03.225-1.758 1.152-1.758 2.354 0 .636.21 1.158.595 1.562.38.398.913.663 1.536.829.481.128.827.308 1.05.53.215.213.33.48.33.825 0 .803-.535 1.34-1.261 1.34-.662 0-1.261-.638-1.261-1.51 0-.257-.187-.534-.495-.534-.307 0-.494.277-.494.534 0 1.201.731 2.257 1.758 2.516v.281c0 .276.22.5.493.5a.497.497 0 0 0 .494-.5v-.273c1.028-.226 1.755-1.153 1.755-2.354 0-.636-.21-1.158-.595-1.562-.38-.398-.913-.663-1.536-.83-.48-.127-.827-.307-1.05-.528a1.106 1.106 0 0 1-.33-.826c0-.803.535-1.34 1.26-1.34.587 0 1.135.5 1.245 1.253.038.259.27.502.578.441.293-.058.435-.354.398-.608-.15-1.03-.833-1.862-1.725-2.09V8.8c0-.276-.221-.5-.494-.5Z",
    fill: "currentColor"
  }));
};

var SvgCashHome64X64 = function SvgCashHome64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash-home",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.377.144a.567.567 0 0 0-.756 0L.184 28.377a.546.546 0 0 0-.037.78.567.567 0 0 0 .793.035l6.421-5.766 1.024-.92v40.942c0 .305.25.552.56.552h46.11c.31 0 .561-.247.561-.552V22.506l1.024.919 6.422 5.767c.23.206.584.19.792-.036a.546.546 0 0 0-.036-.78L32.377.145ZM32 1.3l.412.37 21.894 19.66.237.213-.043.314a.554.554 0 0 0-.005.076v40.964H9.505V22.023a.548.548 0 0 0-.012-.113l-.07-.337.257-.23L31.587 1.668 32 1.3ZM32.465 17a.534.534 0 0 0-.531.536v4.051l-.383.016c-4.47.194-7.781 3.277-7.781 7.518 0 2.001.756 3.575 2.128 4.8 1.385 1.238 3.416 2.134 5.974 2.714 2.245.51 4.048 1.265 5.298 2.323 1.264 1.071 1.948 2.444 1.948 4.13 0 3.8-3.07 6.437-7.122 6.437-3.93 0-7.121-3.163-7.121-7.072a.549.549 0 0 0-.553-.545.549.549 0 0 0-.552.545c0 4.359 3.444 7.924 7.785 8.151l.379.02v4.04c0 .298.24.536.53.536a.534.534 0 0 0 .532-.536v-4.091l.346-.047c4.006-.542 6.881-3.482 6.881-7.439 0-2.002-.756-3.576-2.127-4.8-1.385-1.237-3.416-2.133-5.976-2.715-2.243-.508-4.046-1.263-5.296-2.322-1.265-1.071-1.95-2.445-1.95-4.13 0-3.797 3.071-6.436 7.122-6.436 3.473.002 6.443 2.49 7.026 5.894.05.295.334.498.638.447a.546.546 0 0 0 .451-.629c-.596-3.481-3.36-6.137-6.78-6.694l-.335-.055v-4.111a.534.534 0 0 0-.531-.536Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  }))));
};

var SvgCashOut104X104 = function SvgCashOut104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash-out",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M80.327 90.995c2.91 0 5.277-2.373 5.277-5.29v-73.7H18.397v73.7c0 2.917 2.367 5.29 5.277 5.29h56.653zM7.277 10h89.447c4.012 0 7.276 3.273 7.276 7.296v9.455a1 1 0 1 1-2 0v-9.455c0-2.917-2.367-5.291-5.276-5.291h-9.12v73.7c0 4.023-3.264 7.295-7.277 7.295H23.674c-4.013 0-7.277-3.272-7.277-7.295v-73.7h-9.12C4.368 12.005 2 14.379 2 17.295v9.456a1 1 0 1 1-2 0v-9.455C0 13.273 3.265 10 7.277 10zm57.962 58.813c-3.992 0-7.239-3.282-7.239-7.317 0-.558-.448-1.011-1-1.011s-1 .453-1 1.01c0 4.798 3.597 8.763 8.24 9.282v3.212c0 .558.447 1.011 1 1.011s1-.453 1-1.01v-3.24c4.694-.656 8.242-4.694 8.238-9.587 0-4.287-3.03-7.196-9.005-8.646C60.444 51.297 58 49.112 58 45.838c0-3.916 2.977-6.651 7.232-6.651 3.545.025 6.529 2.61 7.095 6.146a1 1 0 0 0 1.146.837c.546-.09.916-.609.829-1.16-.67-4.176-3.983-7.307-8.063-7.778V34.01c0-.558-.447-1.011-1-1.011s-1 .453-1 1.01v3.198c-4.83.426-8.238 3.924-8.238 8.63 0 4.286 3.03 7.196 9.006 8.645 5.027 1.22 7.471 3.405 7.471 6.681.004 4.13-3.193 7.49-7.238 7.65zM30.975 41.005h16.051c.538 0 .974-.45.974-1.003 0-.553-.436-1.002-.974-1.002H30.975c-.538 0-.975.45-.975 1.002 0 .554.437 1.003.975 1.003zm.013 14h13.025c.545 0 .987-.45.987-1.003A.996.996 0 0 0 44.013 53H30.988A.996.996 0 0 0 30 54.002a.996.996 0 0 0 .988 1.003zm13.025 13H30.988A.996.996 0 0 1 30 67.002.996.996 0 0 1 30.988 66h13.025c.545 0 .988.45.988 1.002a.996.996 0 0 1-.988 1.003z",
    clipRule: "evenodd"
  }));
};

var SvgCashOut16X16 = function SvgCashOut16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash-out",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.166 13.49a.426.426 0 0 0 .423-.426V2.509H3.411v10.555c0 .235.19.427.424.427h8.331zM1.423 1.5h13.154A1.43 1.43 0 0 1 16 2.936v1.4a.502.502 0 0 1-.5.505.503.503 0 0 1-.5-.505v-1.4a.424.424 0 0 0-.423-.427h-.988v10.555c0 .792-.639 1.436-1.423 1.436H3.835a1.432 1.432 0 0 1-1.424-1.436V2.509h-.988A.425.425 0 0 0 1 2.936v1.4c0 .279-.224.505-.5.505S0 4.615 0 4.336v-1.4A1.43 1.43 0 0 1 1.423 1.5zm8.516 8.631a.715.715 0 0 1-.711-.718.503.503 0 0 0-.5-.505c-.277 0-.5.226-.5.505 0 .773.505 1.43 1.21 1.649v.185c0 .279.225.505.5.505s.5-.226.5-.505v-.192a1.772 1.772 0 0 0 1.213-1.69c0-.562-.277-1.297-1.595-1.617-.828-.2-.828-.504-.828-.634 0-.458.383-.62.708-.62a.712.712 0 0 1 .697.603.5.5 0 0 0 .574.417.504.504 0 0 0 .413-.579 1.705 1.705 0 0 0-1.181-1.357v-.2c0-.279-.224-.505-.5-.505s-.5.226-.5.505v.177c-.722.19-1.211.783-1.211 1.559 0 .56.276 1.296 1.594 1.615.829.201.829.505.829.635a.76.76 0 0 1-.712.767zm-5.09-3.27h2.424c.277 0 .5-.226.5-.505a.502.502 0 0 0-.5-.505H4.85c-.276 0-.5.226-.5.505s.224.505.5.505zm0 1.956h1.94c.276 0 .5-.226.5-.505a.503.503 0 0 0-.5-.504h-1.94c-.275 0-.5.226-.5.504 0 .279.225.505.5.505zm1.94 1.956h-1.94a.503.503 0 0 1-.5-.504c0-.279.225-.505.5-.505h1.94c.276 0 .5.226.5.505a.503.503 0 0 1-.5.504z",
    clipRule: "evenodd"
  }));
};

var SvgCashOut24X24 = function SvgCashOut24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cash-out",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M7.17 10.004a.5.5 0 1 1 0-.999h3.715a.5.5 0 1 1 0 1H7.17zm0 2.97a.5.5 0 1 1 0-1h2.972a.5.5 0 1 1 0 1H7.17zm0 2.969a.5.5 0 1 1 0-.999h2.972a.5.5 0 1 1 0 .999H7.17zm7.803-.442a1.423 1.423 0 0 0 1.357-1.43c0-.373-.152-.906-1.474-1.222-1.487-.357-2.241-1.094-2.241-2.194 0-1.117.756-1.965 1.858-2.163v-.473a.5.5 0 0 1 1 0v.491a2.345 2.345 0 0 1 1.814 1.916.5.5 0 0 1-.987.16 1.355 1.355 0 0 0-1.331-1.139c-.672 0-1.354.374-1.354 1.208 0 .372.153.906 1.475 1.222 1.487.356 2.24 1.095 2.24 2.193a2.422 2.422 0 0 1-1.857 2.364v.495a.5.5 0 0 1-1 0v-.485a2.358 2.358 0 0 1-1.858-2.3.5.5 0 0 1 1 0c0 .749.609 1.357 1.358 1.357zm4.33 4.185V3.399H4.698v16.287c0 .504.41.915.915.915h12.774c.505 0 .916-.41.916-.915zM22.085 2.4C23.14 2.4 24 3.258 24 4.313v2.125a.5.5 0 1 1-1 0V4.313a.915.915 0 0 0-.915-.914h-1.782v16.287a1.917 1.917 0 0 1-1.916 1.914H5.613a1.917 1.917 0 0 1-1.915-1.914V3.399H1.916A.916.916 0 0 0 1 4.313v2.125a.5.5 0 1 1-1 0V4.313C0 3.258.86 2.4 1.916 2.4h20.169z"
  }));
};

var SvgCheck104X104 = function SvgCheck104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -check",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M103.688 14.274a1 1 0 0 1 .038 1.414l-70.157 74a1 1 0 0 1-1.429.023L.297 58.199a1 1 0 0 1 1.406-1.422l31.118 30.794 69.453-73.259a1 1 0 0 1 1.414-.038z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h104v104H0z"
  }))));
};

var SvgCheck16X16 = function SvgCheck16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -check",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.847 2.143c.199.196.205.52.013.724L5.543 13.843a.494.494 0 0 1-.709.012L.151 9.18a.521.521 0 0 1-.01-.724.492.492 0 0 1 .708-.01l4.323 4.314L15.14 2.157a.492.492 0 0 1 .707-.014z",
    clipRule: "evenodd"
  }));
};

var SvgCheck24X24 = function SvgCheck24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    role: "img",
    className: "icon -check"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2 11.577 9.489 19 22 5"
  }));
};

var SvgCheck64X64 = function SvgCheck64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    className: "icon -check",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M63.843 8.636a.5.5 0 0 1 .021.707l-43.332 46a.5.5 0 0 1-.717.011L.147 35.766a.5.5 0 0 1 .706-.709l19.304 19.226 42.98-45.626a.5.5 0 0 1 .706-.021Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  }))));
};

var SvgCheckbook104X104 = function SvgCheckbook104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checkbook",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 25.193C0 21.22 3.154 18 7.044 18h89.912c3.89 0 7.044 3.22 7.044 7.193v53.615C104 82.78 100.846 86 96.956 86H7.044C3.154 86 0 82.78 0 78.808V25.193zm2 11.43v42.22C2 81.691 4.258 84 7.044 84h89.912c2.786 0 5.044-2.309 5.044-5.157V25.158c0-2.85-2.258-5.158-5.044-5.158H7.044C4.258 20 2 22.309 2 25.158v9.42h49.231c.552 0 1 .457 1 1.022s-.448 1.022-1 1.022H2zM71 68a1 1 0 1 0 0 2h23a1 1 0 1 0 0-2H71z",
    clipRule: "evenodd"
  }));
};

var SvgCheckbook16X16 = function SvgCheckbook16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checkbook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 4.323C0 3.593.622 3 1.389 3h13.222C15.378 3 16 3.592 16 4.323v7.354c0 .73-.622 1.323-1.389 1.323H1.389C.622 13 0 12.408 0 11.677V4.323zm1 2.296v5.058c0 .205.174.37.389.37h13.222a.38.38 0 0 0 .389-.37V4.323a.38.38 0 0 0-.389-.37H1.389a.38.38 0 0 0-.389.37v1.344h7.269c.276 0 .5.213.5.476a.489.489 0 0 1-.5.476H1zM10.5 9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3z",
    clipRule: "evenodd"
  }));
};

var SvgCheckbook24X24 = function SvgCheckbook24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checkbook",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6.154C24 4.964 23.105 4 22 4H2C.895 4 0 4.964 0 6.154v11.692C0 19.036.895 20 2 20h20c1.105 0 2-.964 2-2.154V6.154ZM1 9h10.5a.5.5 0 0 0 0-1H1V6.154c0-.595.448-1.077 1-1.077h20c.552 0 1 .482 1 1.077v11.692c0 .595-.448 1.077-1 1.077H2c-.552 0-1-.482-1-1.077V9Zm14 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 1 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  }));
};

var SvgCheckbookHand104X104 = function SvgCheckbookHand104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checkbook-hand",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.731 3.66c0-1.954 1.52-3.554 3.438-3.655L42.364 0H78.38c1.939 0 3.515 1.537 3.614 3.466l.005.195v72.958c0 1.954-1.513 3.554-3.426 3.655l-.193.006H64.15c.077 5.3-1.38 9.776-4.574 14.6l-.416.672c-2.398 3.91-3.02 5.695-3.044 7.223V103a.999.999 0 0 1-1.988.117L54.12 103l.001-.248c.03-2.024.842-4.263 3.78-8.956 3-4.533 4.33-8.627 4.254-13.516H53.14a1 1 0 0 1-.209-.022c-.721 2.887-2.215 5.842-4.71 8.706a28.104 28.104 0 0 1-3.704 3.517c-.432.343-1.059.27-1.402-.162s-.27-1.061.161-1.405a26.118 26.118 0 0 0 3.441-3.265c4.3-4.936 5.307-10.089 4.49-14.547l-.062-.318a6.286 6.286 0 0 0-.152-.604 1.002 1.002 0 0 1 .163-.929l.083-.093 11.52-11.437c2.172-2.202 2.172-5.715.015-7.898a5.745 5.745 0 0 0-7.805-.18l-.187.175-21.046 20.763a.996.996 0 0 1-1.41-.011 1.002 1.002 0 0 1-.073-1.32l.084-.094 6.394-6.309V48.802l-10.75 10.575c-2.928 2.92-3.986 6.709-3.986 14.333l.022 9.939.043 8.995.065 10.349a.999.999 0 0 1-1.988.131l-.01-.55-.076-12.565-.046-12.014C22.002 76.46 22 75.026 22 73.71c0-7.94 1.145-12.205 4.375-15.548l.204-.208 11.774-11.582a.993.993 0 0 1 .378-.233V3.66zm1.995 59.219 12.66-12.49c2.993-2.915 7.786-2.915 10.791.013a7.624 7.624 0 0 1 .182 10.535l-.188.198-11.12 11.038.005.011c.024.11.05.228.075.357l.038.2a17.72 17.72 0 0 1 .14 5.539H78.38c.848 0 1.547-.665 1.618-1.517l.006-.144V3.661c0-.872-.654-1.583-1.484-1.655L78.38 2H42.363c-.856 0-1.559.665-1.63 1.517l-.007.144v59.218zm5.778-44.629c-1.213 0-2.222.907-2.304 2.073l-.005.153v3.18a.86.86 0 0 0 0 .04V35.652c0 1.093.976 1.915 2.148 1.985l.16.005h28.11c1.19 0 2.219-.775 2.306-1.843l.006-.147V20.476c0-1.187-.96-2.143-2.155-2.22l-.157-.006h-28.11zm-.813 2.226v2.455l18.695-.18a.749.749 0 0 1 .116 1.491l-.101.008-18.71.181v11.222l.008.062c.053.211.366.428.805.428h28.109l.128-.007c.414-.04.687-.276.687-.484V20.477l-.007-.096c-.053-.348-.386-.63-.808-.63h-28.11l-.111.007c-.403.05-.7.362-.7.72zm26.681 12.418a.75.75 0 0 0-.748-.75h-7.23l-.102.007a.75.75 0 0 0 .102 1.493h7.23l.102-.007a.75.75 0 0 0 .646-.743z",
    clipRule: "evenodd"
  }));
};

var SvgCheckbookHand24X24 = function SvgCheckbookHand24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checkbook-hand",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72 14.735v-2.91l-2.157 2.062c-.604.585-.85 1.353-.85 3.052l.005 2.236.025 4.353a.475.475 0 0 1-.478.472.477.477 0 0 1-.481-.411l-.002-.013-.003-.14-.017-2.827-.01-2.705c-.002-.346-.002-.668-.002-.965 0-1.805.267-2.846 1.084-3.668l.002-.002.05-.05 2.729-2.606a.484.484 0 0 1 .106-.077V1.068c0-.57.456-1.037 1.034-1.066h.007L9.813 0h8.348c.585 0 1.058.45 1.087 1.011v.007l.002.05v16.419c0 .568-.453 1.036-1.032 1.066h-.006l-.051.002h-3.049c-.03 1.14-.386 2.128-1.098 3.173l-.095.148-.022.035c-.317.503-.644 1.02-.644 1.62a.476.476 0 0 1-.484.469.476.476 0 0 1-.483-.468c0-.857.46-1.6.916-2.31l.004-.005c.62-.908.914-1.722.943-2.662H12.45c-.192.625-.543 1.259-1.092 1.87a6.691 6.691 0 0 1-.892.823.49.49 0 0 1-.676-.076.46.46 0 0 1 .077-.659c.293-.226.547-.462.765-.704.947-1.055 1.158-2.14.983-3.068l-.014-.068a1.141 1.141 0 0 0-.027-.109.459.459 0 0 1 .078-.435l.005-.006.03-.033 2.675-2.578a.999.999 0 0 0 .004-1.432 1.105 1.105 0 0 0-1.465-.033l-.038.035-4.875 4.67a.49.49 0 0 1-.681-.005.46.46 0 0 1-.035-.62l.005-.006.03-.032 1.413-1.354Zm.964-.923 2.509-2.403a2.088 2.088 0 0 1 2.85.003l.003.003a1.92 1.92 0 0 1 .049 2.708l-.003.003-.049.05-2.48 2.39v.004c.064.338.087.688.063 1.047h5.535c.06 0 .117-.046.125-.114V1.068a.128.128 0 0 0-.11-.13H9.812a.13.13 0 0 0-.128.114v12.76Zm.57-9.26c.025-.32.315-.553.644-.553h6.027l.039.001c.324.02.602.267.602.593v3.059l-.001.036c-.028.314-.338.504-.644.504h-6.066c-.302-.018-.602-.223-.602-.546V4.588l.002-.037Zm.649.041h-.014a.034.034 0 0 0-.014.007v.409l3.39-.035a.295.295 0 0 1 .296.294.296.296 0 0 1-.25.297l-.01.002-.03.002-3.397.034v1.993a.128.128 0 0 0 .024.002h6.039l.008-.002V4.6a.041.041 0 0 0-.024-.007h-6.018Zm3.378 1.844h1.66c.163 0 .322.12.322.297 0 .163-.134.277-.28.295h-.01l-.032.002h-1.66c-.163 0-.322-.12-.322-.297 0-.163.135-.277.28-.295h.01l.032-.002Z",
    fill: "currentColor"
  }));
};

var SvgCheckbooks104X104 = function SvgCheckbooks104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checkbooks",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.014 16C17.14 16 14 19.172 14 23.086v6.592H7.013C3.14 29.678 0 32.85 0 36.764v44.151C0 84.828 3.14 88 7.013 88h75.973C86.86 88 90 84.828 90 80.915v-6.593h6.987c3.873 0 7.013-3.172 7.013-7.085V23.086c0-3.914-3.14-7.086-7.013-7.086H21.014zm66.995 58.322H21.014C17.14 74.322 14 71.15 14 67.237V31.69H7.013c-2.774 0-5.022 2.271-5.022 5.074v44.151c0 2.802 2.248 5.073 5.022 5.073h75.973c2.774 0 5.023-2.27 5.023-5.073v-6.593zM60 36H15.991v31.237c0 2.802 2.249 5.073 5.023 5.073h75.973c2.774 0 5.022-2.271 5.022-5.073V23.086c0-2.803-2.248-5.074-5.022-5.074H21.014c-2.775 0-5.023 2.27-5.023 5.074V34H60l.117.007A1 1 0 0 1 60 36zm10 22h24l.117.007A1 1 0 0 1 94 60H70l-.117-.007A1 1 0 0 1 70 58z",
    clipRule: "evenodd"
  }));
};

var SvgCheckbooks16X16 = function SvgCheckbooks16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checkbooks",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.37 2.5h11.26c.757 0 1.37.627 1.37 1.401V10.1c0 .773-.613 1.4-1.37 1.4H14v.6c0 .773-.613 1.4-1.368 1.4H1.369C.613 13.5 0 12.873 0 12.1V5.9C0 5.127.613 4.5 1.37 4.5H2v-.599C2 3.127 2.613 2.5 3.37 2.5zM2 5.509h-.63a.388.388 0 0 0-.384.392V12.1c0 .215.172.391.383.391h11.263c.21 0 .382-.176.382-.391v-.6H3.37C2.613 11.5 2 10.873 2 10.1V5.509zM8.5 6H2.986v4.1c0 .215.172.391.384.391H14.63a.388.388 0 0 0 .384-.392V3.901a.388.388 0 0 0-.384-.392H3.37a.388.388 0 0 0-.384.392V5H8.5a.5.5 0 0 1 0 1zM10 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  }));
};

var SvgCheckbooks24X24 = function SvgCheckbooks24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checkbooks",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.842 4h17.316C23.176 4 24 4.825 24 5.842v9.316A1.842 1.842 0 0 1 22.158 17H21v1.157A1.841 1.841 0 0 1 19.16 20H1.84A1.842 1.842 0 0 1 0 18.157V8.842C0 7.825.824 7 1.84 7H3V5.842C3 4.825 3.825 4 4.842 4ZM3 7.989H1.84a.853.853 0 0 0-.851.853v9.315c0 .472.381.854.852.854h17.318a.852.852 0 0 0 .852-.854V17H4.841A1.842 1.842 0 0 1 3 15.158V7.989ZM13.5 9H3.988v6.158c0 .47.383.853.853.853h17.317a.853.853 0 0 0 .853-.853V5.841a.853.853 0 0 0-.853-.853H4.84a.854.854 0 0 0-.853.853V8H13.5a.5.5 0 0 1 0 1Zm4 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z",
    fill: "currentColor"
  }));
};

var SvgCheckbox24X24 = function SvgCheckbox24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checkbox",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2H2v20h20V2ZM3 21V3h18v18H3Z",
    fill: "currentColor"
  }));
};

var SvgCheckboxFilled24X24 = function SvgCheckboxFilled24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checkbox-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    className: "filling",
    d: "M5 5h14v14H5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "outline",
    d: "M2 2h20v20H2V2zm1 1v18h18V3H3z"
  })));
};

var SvgChecked104X104 = function SvgChecked104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checked",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M96.956 0A7.044 7.044 0 0 1 104 7.044V35.04c-.702 30.332-20.997 57.38-51.66 68.896a1.002 1.002 0 0 1-.703 0C20.982 92.415.696 65.368 0 35.017V7.044A7.044 7.044 0 0 1 7.045 0h89.911zM102 35.017V7.044A5.044 5.044 0 0 0 96.956 2H7.045A5.044 5.044 0 0 0 2 7.044v27.95c.673 29.374 20.276 55.622 49.99 66.937C81.707 90.621 101.32 64.372 102 35.017zM34.733 51.293a1 1 0 0 1 1.415 0l11.287 11.288 20.373-23.283a1 1 0 0 1 1.505 1.317L48.236 64.703a1 1 0 0 1-1.46.048L34.733 52.707a1 1 0 0 1 0-1.414z",
    clipRule: "evenodd"
  }));
};

var SvgChecked16X16 = function SvgChecked16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.998 14.965c4.165-1.637 6.906-5.337 7.002-9.474V1.389A.39.39 0 0 0 14.611 1H1.389A.39.39 0 0 0 1 1.389v4.114c.095 4.125 2.835 7.824 6.998 9.462zM1.389 0h13.222A1.39 1.39 0 0 1 16 1.389v4.114c-.107 4.617-3.179 8.72-7.826 10.466a.506.506 0 0 1-.352 0C3.176 14.222.106 10.118 0 5.514V1.389A1.39 1.39 0 0 1 1.389 0zm5.922 9.04L10.06 5.9a.5.5 0 1 1 .753.658l-3.1 3.542a.498.498 0 0 1-.36.171h-.016a.505.505 0 0 1-.354-.146l-1.77-1.77a.5.5 0 0 1 .706-.708L7.311 9.04z",
    clipRule: "evenodd"
  }));
};

var SvgChecked24X24 = function SvgChecked24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -checked",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m9.268 11.647 1.867 1.865 3.574-4.085a.5.5 0 1 1 .752.659l-3.926 4.487a.5.5 0 0 1-.73.024l-2.243-2.243a.5.5 0 0 1 .706-.707zM20.374 2C21.272 2 22 2.728 22 3.626v5.222c-.134 5.782-3.998 10.931-9.826 13.12a.5.5 0 0 1-.352 0C5.995 19.778 2.132 14.628 2 8.836v-5.21C2 2.728 2.728 2 3.626 2h16.748zM21 8.836v-5.21A.626.626 0 0 0 20.374 3H3.626A.626.626 0 0 0 3 3.626v5.199c.122 5.304 3.642 10.054 8.998 12.14 5.357-2.086 8.88-6.835 9.002-12.129z"
  }));
};

var SvgChevronDown104X104 = function SvgChevronDown104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-down",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.691 25.296a.978.978 0 0 0-1.4 0 1.022 1.022 0 0 0-.001 1.426l51.008 51.982a.978.978 0 0 0 1.402 0l51.01-51.982a1.021 1.021 0 0 0 0-1.427.978.978 0 0 0-1.401 0l-50.31 51.27-50.308-51.27z"
  }));
};

var SvgChevronDown16X16 = function SvgChevronDown16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.865 3.158a.5.5 0 0 0-.73.684l7.5 8a.5.5 0 0 0 .73 0l7.5-8a.5.5 0 0 0-.73-.684L8 10.768.865 3.159z"
  }));
};

var SvgChevronDown24X24 = function SvgChevronDown24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-down",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M12 16.044 2.854 6.896a.5.5 0 0 0-.708.707l9.5 9.5a.5.5 0 0 0 .708 0l9.5-9.5a.5.5 0 1 0-.708-.707L12 16.044z"
  }));
};

var SvgChevronDown8X8 = function SvgChevronDown8X8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-down",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 8",
    width: 8,
    height: 8
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.146 2.448a.6.6 0 0 1 0-.785.463.463 0 0 1 .638-.065l.07.065L4 5.159l3.146-3.496a.463.463 0 0 1 .638-.065l.07.065a.603.603 0 0 1 .057.708l-.057.077-3.5 3.89a.463.463 0 0 1-.638.064l-.07-.065-3.5-3.889z"
  }));
};

var SvgChevronLeft104X104 = function SvgChevronLeft104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-left",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M76.704 1.691a.978.978 0 0 0 0-1.4A1.022 1.022 0 0 0 75.28.29L23.296 51.298a.978.978 0 0 0 0 1.402l51.982 51.01a1.021 1.021 0 0 0 1.427 0 .978.978 0 0 0 0-1.401l-51.27-50.31 51.27-50.308z"
  }));
};

var SvgChevronLeft16X16 = function SvgChevronLeft16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m3.231 8 7.611 7.135a.5.5 0 0 1-.684.73l-8-7.5a.5.5 0 0 1 0-.73l8-7.5a.5.5 0 0 1 .684.73L3.232 8z"
  }));
};

var SvgChevronLeft24X24 = function SvgChevronLeft24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-left",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.956 12 9.148-9.146a.5.5 0 0 0-.707-.708l-9.5 9.5a.5.5 0 0 0 0 .708l9.5 9.5a.5.5 0 1 0 .707-.708L7.956 12z"
  }));
};

var SvgChevronLeft8X8 = function SvgChevronLeft8X8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-left",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 8",
    width: 8,
    height: 8
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.052.146a.6.6 0 0 1 .785 0 .463.463 0 0 1 .065.638l-.065.07L2.341 4l3.496 3.146a.463.463 0 0 1 .065.638l-.065.07a.603.603 0 0 1-.708.057l-.077-.057-3.89-3.5a.463.463 0 0 1-.064-.638l.065-.07 3.889-3.5z"
  }));
};

var SvgChevronLeftRight24X24 = function SvgChevronLeftRight24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-left-right",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.948 15.854a.6.6 0 0 1-.785 0 .464.464 0 0 1-.065-.638l.065-.07L19.659 12l-3.496-3.146a.463.463 0 0 1-.065-.638l.065-.07a.603.603 0 0 1 .709-.057l.076.057 3.89 3.5a.464.464 0 0 1 .064.638l-.065.07-3.889 3.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.052 8.146a.6.6 0 0 1 .785 0 .463.463 0 0 1 .065.638l-.065.07L4.341 12l3.496 3.146a.463.463 0 0 1 .065.638l-.065.07a.603.603 0 0 1-.708.057l-.077-.057-3.89-3.5a.463.463 0 0 1-.064-.638l.065-.07 3.889-3.5Z",
    fill: "currentColor"
  }));
};

var SvgChevronRight104X104 = function SvgChevronRight104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-right",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.296 1.691a.978.978 0 0 1 0-1.4A1.022 1.022 0 0 1 28.721.29l51.982 51.008a.978.978 0 0 1 0 1.402l-51.982 51.01a1.021 1.021 0 0 1-1.427 0 .978.978 0 0 1 0-1.401l51.27-50.31-51.27-50.308z"
  }));
};

var SvgChevronRight16X16 = function SvgChevronRight16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-right",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.769 8-7.611 7.135a.5.5 0 0 0 .684.73l8-7.5a.5.5 0 0 0 0-.73l-8-7.5a.5.5 0 0 0-.684.73L12.768 8z"
  }));
};

var SvgChevronRight24X24 = function SvgChevronRight24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-right",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.044 12-9.148 9.146a.5.5 0 0 0 .707.708l9.5-9.5a.5.5 0 0 0 0-.708l-9.5-9.5a.5.5 0 1 0-.707.708L16.044 12z"
  }));
};

var SvgChevronRight8X8 = function SvgChevronRight8X8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-right",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 8",
    width: 8,
    height: 8
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.948 7.854a.6.6 0 0 1-.785 0 .463.463 0 0 1-.065-.638l.065-.07L5.659 4 2.163.854a.463.463 0 0 1-.065-.638l.065-.07A.603.603 0 0 1 2.87.09l.077.057 3.89 3.5a.463.463 0 0 1 .064.638l-.065.07-3.889 3.5z"
  }));
};

var SvgChevronUp104X104 = function SvgChevronUp104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-up",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.691 78.704a.978.978 0 0 1-1.4 0A1.022 1.022 0 0 1 .29 77.28l51.008-51.983a.978.978 0 0 1 1.402 0l51.01 51.982a1.021 1.021 0 0 1 0 1.427.978.978 0 0 1-1.401 0l-50.31-51.27-50.308 51.27z"
  }));
};

var SvgChevronUp16X16 = function SvgChevronUp16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-up",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.865 12.342a.5.5 0 0 1-.73-.684l7.5-8a.5.5 0 0 1 .73 0l7.5 8a.5.5 0 0 1-.73.684L8 4.732l-7.135 7.61z"
  }));
};

var SvgChevronUp24X24 = function SvgChevronUp24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-up",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 7.956 9.146 9.148a.5.5 0 0 0 .708-.707l-9.5-9.5a.5.5 0 0 0-.708 0l-9.5 9.5a.5.5 0 1 0 .708.707L12 7.956z"
  }));
};

var SvgChevronUp8X8 = function SvgChevronUp8X8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -chevron-up",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 8",
    width: 8,
    height: 8
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.854 5.052a.6.6 0 0 1 0 .785.463.463 0 0 1-.638.065l-.07-.065L4 2.341.854 5.837a.463.463 0 0 1-.638.065l-.07-.065A.603.603 0 0 1 .09 5.13l.057-.077 3.5-3.89a.463.463 0 0 1 .638-.064l.07.065 3.5 3.889z"
  }));
};

var SvgCircle24X24 = function SvgCircle24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cy: 12,
    cx: 12,
    r: 9.5,
    fill: "none",
    stroke: "currentColor"
  }));
};

var SvgCircleFilled24X24 = function SvgCircleFilled24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -circle-filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var SvgClipboard104X104 = function SvgClipboard104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -clipboard",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 59.556A7.044 7.044 0 0 0 7.045 66.6H51v27.282l-16.447 8.223a1 1 0 0 0 .894 1.789L52 95.618l16.553 8.276a1 1 0 1 0 .894-1.789L53 93.882V66.6h43.955A7.044 7.044 0 0 0 104 59.556V7.044A7.044 7.044 0 0 0 96.955 0H7.045A7.044 7.044 0 0 0 0 7.044v52.512zM7.045 64.6h89.91A5.044 5.044 0 0 0 102 59.556V7.044A5.044 5.044 0 0 0 96.955 2H7.045A5.044 5.044 0 0 0 2 7.044v52.512A5.044 5.044 0 0 0 7.045 64.6zm44.854-15.613-14.88-14.88-17.113 17.114a1 1 0 0 1-1.414-1.414l17.82-17.82a1 1 0 0 1 1.414 0l14.88 14.878L84.094 15.38a1 1 0 0 1 1.414 1.415L53.313 48.987a1 1 0 0 1-1.414 0z",
    clipRule: "evenodd"
  }));
};

var SvgClipboard16X16 = function SvgClipboard16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -clipboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 9.111A1.39 1.39 0 0 0 1.389 10.5H7.5v3.441l-2.223 1.112a.5.5 0 1 0 .447.894L8 14.81l2.277 1.138a.5.5 0 1 0 .447-.894L8.5 13.94V10.5h6.112c.766 0 1.388-.622 1.388-1.389V1.389C16 .622 15.378 0 14.612 0H1.389A1.39 1.39 0 0 0 0 1.389v7.722zm14.612.389H1.389A.39.39 0 0 1 1 9.111V1.389A.39.39 0 0 1 1.389 1h13.223c.214 0 .388.174.388.389v7.722a.389.389 0 0 1-.388.389zM7.735 7.807l-1.938-1.94-2.266 2.268a.5.5 0 1 1-.708-.707l2.62-2.621a.5.5 0 0 1 .708 0l1.938 1.94 4.38-4.381a.5.5 0 0 1 .708.707L8.443 7.807a.5.5 0 0 1-.708 0z",
    clipRule: "evenodd"
  }));
};

var SvgClipboard24X24 = function SvgClipboard24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -clipboard",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.407c0 .898.728 1.626 1.626 1.626H11.5v4.574l-2.89 1.445a.5.5 0 1 0 .447.895L12 20.474l2.943 1.471a.5.5 0 1 0 .448-.894L12.5 19.607v-4.574h7.874c.898 0 1.626-.728 1.626-1.626V3.626C22 2.728 21.272 2 20.374 2H3.626C2.728 2 2 2.728 2 3.626v9.781Zm18.374.626H3.626A.626.626 0 0 1 3 13.407V3.626C3 3.28 3.28 3 3.626 3h16.748c.346 0 .626.28.626.626v9.781c0 .346-.28.626-.626.626Zm-8.614-2.372L9.21 9.11l-2.966 2.965a.5.5 0 0 1-.707-.707L8.856 8.05a.5.5 0 0 1 .707 0l2.55 2.55 5.643-5.644a.5.5 0 0 1 .707.707l-5.996 5.997a.5.5 0 0 1-.707 0Z",
    fill: "currentColor"
  }));
};

var SvgClips104X104 = function SvgClips104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -clips",
    width: 106,
    height: 107,
    viewBox: "0 0 106 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M74.619 25.198 27.97 66.608c-5.499 4.882-5.404 12.719.213 17.499 5.635 4.796 14.681 4.688 20.163-.241l49.53-44.528c9.973-8.966 9.402-23.341-1.26-31.687C86.46-.302 70.879.193 61.414 8.769L10.427 54.967c-12.7 11.507-12.438 29.578 0 41.3 12.842 12.101 34.005 13.053 48.122 2.077l20.393-18.331",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }));
};

var SvgClips16X16 = function SvgClips16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -clips",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m12.326 4.569-7.177 6.37c-.846.75-.831 1.956.033 2.69.867.738 2.259.722 3.102-.036l7.62-6.85c1.534-1.379 1.447-3.59-.194-4.873-1.562-1.224-3.96-1.147-5.416.172L2.45 9.148c-1.953 1.77-1.913 4.55 0 6.352 1.976 1.861 5.232 2.008 7.404.32L12.99 13",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
};

var SvgClips24X24 = function SvgClips24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -clips",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.989 6.35 7.224 15.908c-1.269 1.127-1.247 2.935.05 4.038 1.3 1.107 3.387 1.082 4.652-.055l11.43-10.276c2.302-2.07 2.17-5.387-.29-7.313-2.345-1.835-5.94-1.72-8.124.258L3.175 13.221c-2.93 2.655-2.87 6.825 0 9.53 2.964 2.793 7.848 3.012 11.105.48L18.988 19",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
};

var SvgClips64X64 = function SvgClips64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -clips",
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M46.304 16.274 17.598 41.757c-3.384 3.005-3.326 7.827.13 10.769 3.469 2.951 9.035 2.885 12.409-.148l30.48-27.402c6.137-5.518 5.785-14.364-.775-19.5-6.252-4.894-15.84-4.59-21.665.688L6.801 34.594c-7.815 7.08-7.654 18.202 0 25.415 7.903 7.447 20.926 8.033 29.614 1.279l12.549-11.281",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }));
};

var SvgClock104X104 = function SvgClock104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -clock",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52 0c28.72 0 52 23.28 52 52s-23.28 52-52 52c-12.226 0-23.803-4.233-33.044-11.846a52.257 52.257 0 0 1-12.6-15.22C2.207 69.351 0 60.834 0 52 0 23.28 23.28 0 52 0zm0 2C24.385 2 2 24.385 2 52c0 8.496 2.121 16.684 6.111 23.974A50.257 50.257 0 0 0 20.228 90.61C29.114 97.931 40.243 102 52 102c27.615 0 50-22.385 50-50S79.615 2 52 2zm0 21.8a1 1 0 0 1 1 1v28.334l16.515 9.91a1 1 0 0 1-1.03 1.714l-17-10.2A1 1 0 0 1 51 53.7V24.8a1 1 0 0 1 1-1z",
    clipRule: "evenodd"
  }));
};

var SvgClock16X16 = function SvgClock16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -clock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0a8 8 0 0 1 8 8A8 8 0 1 1 0 8a8 8 0 0 1 8-8zm0 1a7 7 0 0 0-4.448 12.405A7 7 0 0 0 15 8a7 7 0 0 0-7-7zm0 2.5a.5.5 0 0 1 .5.5v3.967l2.257 1.354a.5.5 0 1 1-.514.858l-2.5-1.5A.5.5 0 0 1 7.5 8.25V4a.5.5 0 0 1 .5-.5z",
    clipRule: "evenodd"
  }));
};

var SvgClock24X24 = function SvgClock24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    role: "img",
    className: "icon -clock"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.5 7.26v5.413l3.003 1.837"
  })));
};

var SvgClose104X104 = function SvgClose104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -close",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m53.414 52 50.293 50.293a.999.999 0 1 1-1.414 1.414L52 53.414 1.707 103.707a1 1 0 1 1-1.414-1.414L50.586 52 .293 1.707A1 1 0 0 1 1.707.293L52 50.586 102.293.293a1 1 0 1 1 1.414 1.414L53.414 52z",
    clipRule: "evenodd"
  }));
};

var SvgClose16X16 = function SvgClose16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.716 8 7.133 7.122a.52.52 0 0 1 .009.724.492.492 0 0 1-.707.009L8 8.715.862 15.852a.506.506 0 1 1-.715-.715L7.284 8 .151.878A.52.52 0 0 1 .142.154.492.492 0 0 1 .85.145L8 7.285 15.138.148a.506.506 0 0 1 .715.715L8.716 8z",
    clipRule: "evenodd"
  }));
};

var SvgClose24X24 = function SvgClose24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -times",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 2 20 20m0-20L2 22"
  })));
};

var SvgClose8X8 = function SvgClose8X8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -close",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 8",
    width: 8,
    height: 8
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m.089.216.057-.07A.5.5 0 0 1 .784.09l.07.057L4 3.293 7.146.146a.5.5 0 1 1 .708.708L4.707 4l3.147 3.146a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057L4 4.707.854 7.854a.5.5 0 1 1-.708-.708L3.293 4 .146.854A.5.5 0 0 1 .09.216l.057-.07-.057.07z"
  }));
};

var SvgCloud104X104 = function SvgCloud104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cloud",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.986 44.582c1.832-9.656 8.218-17.842 17.153-21.9 14.922-6.78 32.438-.261 39.446 14.558h.215c12.814 0 23.2 10.468 23.2 23.38C104 73.534 93.614 84 80.8 84H19.3a19.64 19.64 0 0 1-4.774-.713C3.992 80.357-2.189 69.377.718 58.762c2.81-10.255 13.077-16.417 23.268-14.18zm-4.663 37.402H80.8c11.71 0 21.2-9.564 21.2-21.363 0-11.8-9.49-21.365-21.2-21.365h-.854a1 1 0 0 1-.911-.594C72.673 24.44 56.075 18.107 41.96 24.52c-8.65 3.93-14.74 12.003-16.184 21.454a1 1 0 0 1-1.255.818C15.055 44.158 5.26 49.757 2.646 59.299.032 68.84 5.59 78.71 15.057 81.345c1.399.389 2.84.604 4.266.64z",
    clipRule: "evenodd"
  }));
};

var SvgCloud16X16 = function SvgCloud16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cloud",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.61 6.521a4.752 4.752 0 0 1 2.649-3.1 4.779 4.779 0 0 1 6.163 2.087A3.756 3.756 0 0 1 16 9.251a3.757 3.757 0 0 1-3.765 3.75L3.181 13a3.285 3.285 0 0 1-.785-.116A3.247 3.247 0 0 1 .119 8.887 3.264 3.264 0 0 1 3.61 6.52zm-.416 5.48h9.041A2.757 2.757 0 0 0 15 9.25a2.757 2.757 0 0 0-2.765-2.747h-.126a.5.5 0 0 1-.455-.294 3.777 3.777 0 0 0-4.986-1.877 3.748 3.748 0 0 0-2.175 2.845.5.5 0 0 1-.627.406 2.265 2.265 0 0 0-2.784 1.57 2.247 2.247 0 0 0 1.58 2.765c.177.05.36.076.532.081z",
    clipRule: "evenodd"
  }));
};

var SvgCloud24X24 = function SvgCloud24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cloud",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M9.438 5.13a7.09 7.09 0 0 0-3.967 4.874C3.123 9.63.82 11.087.17 13.454c-.695 2.543.785 5.173 3.306 5.875.375.104.758.16 1.143.17l13.875.001c3.04 0 5.506-2.487 5.506-5.554 0-3.027-2.399-5.487-5.383-5.553-1.693-3.37-5.731-4.831-9.18-3.263zm9.057 13.361H4.633a3.77 3.77 0 0 1-.892-.134c-1.987-.554-3.154-2.629-2.605-4.635.55-2.007 2.607-3.185 4.596-2.63a.5.5 0 0 0 .627-.41 6.09 6.09 0 0 1 3.49-4.632c3.044-1.385 6.624-.018 7.998 3.053a.5.5 0 0 0 .456.297h.192C20.984 9.4 23 11.435 23 13.946c0 2.51-2.017 4.545-4.506 4.545z"
  }));
};

var SvgCollaboration104X104 = function SvgCollaboration104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -collaboration",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M72.91 10.822C67.155 5.774 59.864 3 51.998 3c-7.865 0-15.16 2.776-20.915 7.825a1.006 1.006 0 0 0-.095 1.416.998.998 0 0 0 1.411.095c5.393-4.73 12.22-7.33 19.599-7.33 7.38 0 14.203 2.596 19.594 7.326a.998.998 0 0 0 1.41-.095 1.005 1.005 0 0 0-.094-1.415zm-.289 70.017c11.054-4.419 18.88-14.26 20.66-26.174a1 1 0 1 0-1.978-.297c-1.674 11.205-9.027 20.451-19.422 24.607a1.004 1.004 0 0 0-.56 1.304.999.999 0 0 0 1.3.56zm-43.967-3.547c-9.603-3.775-16.39-12.281-17.936-22.626a1 1 0 1 1 1.978-.298c1.44 9.634 7.75 17.542 16.687 21.056.514.202.768.785.566 1.3a.999.999 0 0 1-1.296.568zM18.468 26.911c4.909-.061 8.839-4.103 8.778-9.028-.06-4.926-4.09-8.869-9-8.807-4.91.062-8.84 4.104-8.778 9.03.06 4.924 4.09 8.867 9 8.805zm-7-8.83c-.048-3.818 2.998-6.951 6.804-7 3.804-.046 6.927 3.01 6.974 6.826.047 3.818-2.999 6.95-6.803 6.998-3.805.048-6.928-3.008-6.975-6.825zm7.074 14.836C9.293 33.033 1.886 40.651 2 49.932a1.002 1.002 0 0 1-.987 1.015A1.001 1.001 0 0 1 0 49.957C-.127 39.567 8.163 31.04 18.518 30.91c10.356-.13 18.855 8.187 18.983 18.577a1.002 1.002 0 0 1-.987 1.016 1.001 1.001 0 0 1-1.012-.99c-.116-9.283-7.708-16.712-16.96-16.597zm66.424-6.006c4.909-.061 8.839-4.103 8.778-9.028-.06-4.926-4.09-8.869-9-8.807-4.91.062-8.84 4.104-8.778 9.03.06 4.924 4.09 8.867 9 8.805zm-.196-15.83c3.804-.046 6.927 3.01 6.974 6.826.047 3.818-2.999 6.95-6.803 6.998-3.805.048-6.928-3.008-6.975-6.825-.048-3.817 2.998-6.95 6.804-6.998zm.246 19.83C95.372 30.783 103.87 39.1 104 49.489a1.002 1.002 0 0 1-.988 1.016 1.001 1.001 0 0 1-1.012-.991c-.115-9.28-7.708-16.71-16.959-16.595-9.25.115-16.657 7.733-16.541 17.013a1.002 1.002 0 0 1-.987 1.016 1.001 1.001 0 0 1-1.013-.99c-.13-10.389 8.16-18.916 18.517-19.045zM51.677 73.58c5.523-.07 9.944-4.616 9.875-10.157-.07-5.541-4.602-9.977-10.125-9.908-5.523.07-9.944 4.616-9.875 10.157.069 5.542 4.601 9.977 10.124 9.908zm-.225-18.058c4.418-.056 8.045 3.493 8.1 7.926.055 4.433-3.482 8.07-7.9 8.125-4.42.056-8.045-3.492-8.1-7.926-.055-4.433 3.481-8.07 7.9-8.125zm.309 24.91c-10.632.133-19.143 8.887-19.01 19.553a1.002 1.002 0 0 1-.988 1.016 1.002 1.002 0 0 1-1.012-.991C30.605 88.235 40 78.571 51.736 78.425c11.736-.147 21.369 9.279 21.514 21.054a1 1 0 1 1-2 .025c-.132-10.667-8.858-19.206-19.49-19.073z",
    clipRule: "evenodd"
  }));
};

var SvgCollaboration16X16 = function SvgCollaboration16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -collaboration",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.824 2.382a.66.66 0 0 0-.652.666.642.642 0 0 0 .668.648.653.653 0 0 0 .652-.665.647.647 0 0 0-.199-.462.655.655 0 0 0-.461-.187h-.008zm1.197 1.811c-.2.203-.445.342-.71.421 1.499.205 2.67 1.465 2.69 3.016a.5.5 0 0 1-.494.504h-.006a.498.498 0 0 1-.5-.492c-.015-1.158-.946-2.072-2.138-2.074a2.106 2.106 0 0 0-2.083 2.126.5.5 0 0 1-.494.504h-.006a.498.498 0 0 1-.5-.491c-.02-1.549 1.118-2.839 2.609-3.083a1.64 1.64 0 0 1-.716-.402 1.642 1.642 0 0 1-.501-1.162 1.642 1.642 0 0 1 .1-.567.494.494 0 0 1-.622-.015c-1.476-1.285-3.823-1.285-5.299 0a.499.499 0 0 1-.329.123.497.497 0 0 1-.329-.872A4.96 4.96 0 0 1 8.001.5c1.24 0 2.384.425 3.307 1.228a.493.493 0 0 1 .166.368 1.66 1.66 0 0 1 2.518-.24c.317.308.495.721.5 1.163.006.44-.161.858-.471 1.174zM2.393 3.047a.66.66 0 0 1 .651-.665h.01c.36 0 .654.29.66.648a.657.657 0 0 1-.652.666.68.68 0 0 1-.47-.187.649.649 0 0 1-.199-.462zm.691 2.52c.604.007 1.097.205 1.501.597.403.392.63.917.636 1.477.004.276.22.468.506.492a.498.498 0 0 0 .494-.504 3.065 3.065 0 0 0-.938-2.177c-.487-.473-1.098-.74-1.764-.834A1.635 1.635 0 0 0 4.713 3.02v-.002c-.01-.91-.772-1.608-1.68-1.63a1.647 1.647 0 0 0-1.168.498c-.31.315-.478.732-.472 1.173A1.635 1.635 0 0 0 2.61 4.625C1.118 4.868-.019 6.157 0 7.706a.5.5 0 0 0 .5.492h.006A.498.498 0 0 0 1 7.694a2.109 2.109 0 0 1 2.084-2.127zm10.347 2.726a.502.502 0 0 1 .57-.418c.272.041.46.294.42.567a5.194 5.194 0 0 1-3.257 4.092.5.5 0 0 1-.65-.279.497.497 0 0 1 .28-.645 4.207 4.207 0 0 0 2.637-3.317zM4.803 11.09a.497.497 0 1 1-.365.927 4.52 4.52 0 0 1-2.857-3.576.5.5 0 0 1 .989-.147 3.533 3.533 0 0 0 2.233 2.796zm2.542-1.978a.819.819 0 0 1 .58-.247h.01c.216 0 .42.082.575.233a.816.816 0 0 1 .249.576.823.823 0 0 1-1.648.021.82.82 0 0 1 .234-.583zm.589 2.388h.024a1.822 1.822 0 0 0 1.8-1.838 1.803 1.803 0 0 0-.55-1.276c-.35-.34-.83-.539-1.296-.516a1.816 1.816 0 0 0-1.251 3.114c.344.334.795.516 1.273.516zm.023.004h.044c1.898 0 3.454 1.525 3.478 3.419a.499.499 0 0 1-.494.503h-.006a.498.498 0 0 1-.5-.491c-.018-1.36-1.17-2.481-2.509-2.436a2.466 2.466 0 0 0-1.743.745 2.442 2.442 0 0 0-.705 1.752.497.497 0 0 1-.493.504h-.007a.5.5 0 0 1-.5-.492 3.432 3.432 0 0 1 .99-2.46 3.462 3.462 0 0 1 2.445-1.044z",
    clipRule: "evenodd"
  }));
};

var SvgCollaboration24X24 = function SvgCollaboration24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -collaboration",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.101 4.044a6.145 6.145 0 0 0-4.1-1.544 6.144 6.144 0 0 0-4.104 1.544.508.508 0 0 0-.047.712c.182.21.498.231.705.048A5.15 5.15 0 0 1 12 3.509a5.15 5.15 0 0 1 3.443 1.295.497.497 0 0 0 .706-.048.508.508 0 0 0-.048-.712Zm-.144 13.655A6.554 6.554 0 0 0 20 12.547a.5.5 0 1 0-.989-.15 5.547 5.547 0 0 1-3.424 4.364.506.506 0 0 0-.28.656.498.498 0 0 0 .65.282Zm-8.42-.664C5.643 16.287 4.304 14.597 4 12.546a.5.5 0 1 1 .989-.15c.25 1.694 1.352 3.082 2.913 3.699a.506.506 0 0 1 .283.654c-.1.26-.39.387-.648.286Zm-1.78-9.42a1.98 1.98 0 0 0 1.946-2.013 1.978 1.978 0 0 0-1.994-1.964 1.979 1.979 0 0 0-1.945 2.013 1.978 1.978 0 0 0 1.993 1.963Zm-.036-2.967a.973.973 0 0 1 .982.966.975.975 0 0 1-.958.991.973.973 0 0 1-.981-.966.974.974 0 0 1 .957-.991Zm.05 4.092c-1.55.02-2.79 1.304-2.77 2.868a.502.502 0 0 1-.494.511.502.502 0 0 1-.507-.498c-.026-2.122 1.657-3.864 3.76-3.89 2.101-.026 3.827 1.673 3.853 3.794a.502.502 0 0 1-.493.511.502.502 0 0 1-.507-.498c-.02-1.564-1.292-2.817-2.841-2.798Zm12.374-1.126a1.98 1.98 0 0 0 1.945-2.012 1.978 1.978 0 0 0-1.995-1.964 1.98 1.98 0 0 0-1.944 2.013 1.978 1.978 0 0 0 1.994 1.963Zm-.037-2.966a.973.973 0 0 1 .982.966.975.975 0 0 1-.958.991.973.973 0 0 1-.982-.966.975.975 0 0 1 .958-.991Zm.038 3.082c2.102-.025 3.827 1.673 3.854 3.795a.502.502 0 0 1-.494.511.502.502 0 0 1-.506-.498c-.02-1.565-1.291-2.817-2.842-2.798-1.55.02-2.79 1.304-2.771 2.868a.503.503 0 0 1-.494.511.502.502 0 0 1-.506-.498c-.027-2.122 1.656-3.864 3.759-3.89ZM9.74 14.191a2.186 2.186 0 0 0 2.204 2.17 2.186 2.186 0 0 0 2.148-2.224 2.186 2.186 0 0 0-2.202-2.17 2.189 2.189 0 0 0-2.15 2.224Zm2.162-1.215a1.182 1.182 0 0 1 1.19 1.173 1.18 1.18 0 0 1-1.16 1.202 1.181 1.181 0 0 1-1.193-1.172 1.184 1.184 0 0 1 1.163-1.203Zm.057 4.669c-1.807.023-3.254 1.52-3.231 3.344a.502.502 0 0 1-.494.51.502.502 0 0 1-.506-.497c-.03-2.382 1.86-4.337 4.219-4.366 2.36-.03 4.295 1.876 4.325 4.258a.502.502 0 0 1-.494.511.502.502 0 0 1-.506-.498c-.023-1.825-1.505-3.285-3.313-3.262Z",
    fill: "currentColor"
  }));
};

var SvgCompass104X104 = function SvgCompass104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -compass",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52 0c28.72 0 52 23.28 52 52s-23.28 52-52 52S0 80.72 0 52 23.28 0 52 0zm0 2C24.385 2 2 24.385 2 52s22.385 50 50 50 50-22.385 50-50S79.615 2 52 2zM33.18 70.82l9.057-27.169L60.35 61.763 33.18 70.82zm29.336-7.671a.99.99 0 0 0 .643-.664l10.19-30.569a1 1 0 0 0-1.264-1.265l-30.601 10.2a.99.99 0 0 0-.643.664l-10.19 30.569a1 1 0 0 0 1.264 1.265l30.601-10.2z",
    clipRule: "evenodd"
  }));
};

var SvgCompass16X16 = function SvgCompass16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -compass",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0a8 8 0 0 1 8 8c0 4.42-3.58 8-8 8s-8-3.58-8-8a8 8 0 0 1 8-8zm0 1a7 7 0 0 0-7 7c0 3.867 3.133 7 7 7s7-3.133 7-7a7 7 0 0 0-7-7zm-2.21 9.21.929-2.784L8.574 9.28l-2.783.928zm-.632 1.264 4.495-1.498a.507.507 0 0 0 .285-.234.507.507 0 0 0 .038-.089l1.498-4.495a.5.5 0 0 0-.632-.632L6.347 6.024a.505.505 0 0 0-.285.234.505.505 0 0 0-.038.089l-1.498 4.495a.5.5 0 0 0 .632.632z",
    clipRule: "evenodd"
  }));
};

var SvgCompass24X24 = function SvgCompass24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -compass",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12c0 4.963 4.037 9 9 9s9-4.037 9-9c0-4.962-4.037-9-9-9s-9 4.038-9 9Zm-1 0C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10S2 17.514 2 12Zm9.646.354-1.328-1.328L8.99 15.01l3.984-1.328-1.328-1.328ZM9.941 9.626l5.7-1.9a.502.502 0 0 1 .633.633l-1.899 5.7c-.007.021-.02.039-.034.056a.382.382 0 0 0-.038.058c-.015.028-.03.055-.053.077-.022.022-.047.036-.074.051l-.029.017a.366.366 0 0 0-.031.022.216.216 0 0 1-.058.035l-5.7 1.9a.499.499 0 0 1-.633-.633l1.9-5.7c.007-.022.02-.04.035-.057.008-.01.017-.021.023-.033a.676.676 0 0 0 .019-.032c.014-.025.027-.05.048-.07a.328.328 0 0 1 .082-.056l.024-.013.032-.022c.016-.013.033-.026.053-.033Z",
    fill: "currentColor"
  }));
};

var SvgContrastDay104X104 = function SvgContrastDay104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -contrast-day",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 0c.552 0 1 .434 1 .969v13.063c0 .534-.448.968-1 .968s-1-.434-1-.969V.97C51 .434 51.448 0 52 0ZM16.625 15.211a.987.987 0 0 0-1.395.02c-.39.39-.399 1.015-.019 1.395l9.23 9.23a.987.987 0 0 0 1.396-.019c.39-.39.4-1.015.02-1.395l-9.232-9.23ZM52 78.065c14.395 0 26.065-11.67 26.065-26.064 0-14.396-11.67-26.065-26.065-26.065-14.395 0-26.065 11.67-26.065 26.065 0 14.395 11.67 26.064 26.065 26.064Zm0 1.936c15.464 0 28-12.537 28-28 0-15.465-12.536-28-28-28S24 36.535 24 52c0 15.464 12.536 28 28 28ZM0 52c0-.552.436-1 .973-1h13.054c.537 0 .973.448.973 1s-.436 1-.973 1H.973A.987.987 0 0 1 0 52Zm89 0c0-.552.436-1 .973-1h13.054c.537 0 .973.448.973 1s-.436 1-.973 1H89.973A.987.987 0 0 1 89 52Zm-9.443 26.144a.987.987 0 0 0-1.395.02.987.987 0 0 0-.02 1.394l9.232 9.23a.987.987 0 0 0 1.395-.018c.39-.39.399-1.015.019-1.395l-9.23-9.231Zm9.235-61.522c.378-.378.368-1-.022-1.392-.39-.39-1.014-.4-1.392-.022l-9.237 9.237c-.379.378-.369 1.002.022 1.392.39.39 1.014.4 1.392.022l9.237-9.237ZM52 89c.552 0 1 .434 1 .969v13.062c0 .535-.448.969-1 .969s-1-.434-1-.969V89.968c0-.534.448-.968 1-.968Zm-26.14-9.445c.378-.378.369-1.001-.022-1.392-.39-.39-1.014-.4-1.392-.022l-9.237 9.237c-.378.378-.368 1.001.022 1.392.39.39 1.014.4 1.392.022l9.237-9.237Z",
    fill: "currentColor"
  }));
};

var SvgContrastDay16X16 = function SvgContrastDay16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -contrast-day",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0c.276 0 .5.215.5.48v2.04A.49.49 0 0 1 8 3a.49.49 0 0 1-.5-.48V.48A.49.49 0 0 1 8 0Zm0 13c.276 0 .5.215.5.48v2.04A.49.49 0 0 1 8 16a.49.49 0 0 1-.5-.48v-2.04A.49.49 0 0 1 8 13Zm6.368-9.954a.49.49 0 0 0-.014-.692.49.49 0 0 0-.693-.015l-1.443 1.443a.49.49 0 0 0 .014.693.49.49 0 0 0 .693.014l1.443-1.443ZM16 8a.49.49 0 0 1-.48.5h-2.04A.49.49 0 0 1 13 8c0-.276.215-.5.48-.5h2.04A.49.49 0 0 1 16 8Zm-13.48.5A.49.49 0 0 0 3 8a.49.49 0 0 0-.48-.5H.48A.49.49 0 0 0 0 8c0 .276.215.5.48.5h2.04Zm11.834 5.146a.49.49 0 0 0 .014-.693l-1.443-1.442a.49.49 0 0 0-.693.014.49.49 0 0 0-.014.693l1.443 1.443a.49.49 0 0 0 .693-.015ZM1.632 3.046a.49.49 0 0 1 .014-.692.49.49 0 0 1 .693-.015l1.443 1.443a.49.49 0 0 1-.014.693.49.49 0 0 1-.693.014L1.632 3.046Zm.014 10.6a.49.49 0 0 1-.014-.693l1.443-1.442a.49.49 0 0 1 .693.014.49.49 0 0 1 .014.693l-1.443 1.443a.49.49 0 0 1-.693-.015ZM11.123 8a3.123 3.123 0 1 1-6.246 0 3.123 3.123 0 0 1 6.246 0ZM12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    fill: "currentColor"
  }));
};

var SvgContrastDay24X24 = function SvgContrastDay24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -contrast-day",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4.557C11.4.25 11.669 0 12 0c.331 0 .6.25.6.557v3.086c0 .307-.269.557-.6.557-.331 0-.6-.25-.6-.557V.557Zm8.266 2.927c.218-.217.584-.204.818.03.235.235.248.601.03.819l-2.181 2.182c-.218.217-.584.204-.818-.03-.235-.235-.248-.601-.03-.819l2.181-2.182ZM12 24c.331 0 .6-.25.6-.557v-3.086c0-.308-.269-.557-.6-.557-.331 0-.6.25-.6.557v3.086c0 .307.269.557.6.557Zm-7.666-3.484c-.218.217-.584.204-.818-.03-.235-.235-.248-.601-.03-.819l2.181-2.182c.218-.217.584-.204.818.03.235.235.248.601.03.819l-2.181 2.182ZM16.984 12a4.983 4.983 0 1 1-9.967 0 4.983 4.983 0 0 1 9.966 0ZM18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0ZM0 12a.6.6 0 0 1 .6-.6h3a.6.6 0 1 1 0 1.2h-3A.6.6 0 0 1 0 12Zm4.364-8.486a.6.6 0 1 0-.848.849l2.12 2.121a.6.6 0 0 0 .85-.848L4.363 3.514ZM19.8 12a.6.6 0 0 1 .6-.6h3a.6.6 0 1 1 0 1.2h-3a.6.6 0 0 1-.6-.6Zm-1.437 5.515a.6.6 0 0 0-.848.849l2.121 2.121a.6.6 0 0 0 .849-.848l-2.122-2.122Z",
    fill: "currentColor"
  }));
};

var SvgContrastDay64X64 = function SvgContrastDay64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -contrast-day",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0c.276 0 .5.217.5.485v8.03A.493.493 0 0 1 32 9a.493.493 0 0 1-.5-.485V.485c0-.268.224-.485.5-.485Zm16.021 32c0 8.879-7.192 16.042-16.021 16.042S15.979 40.879 15.979 32c0-8.879 7.192-16.042 16.021-16.042S48.021 23.121 48.021 32ZM49 32c0 9.389-7.611 17-17 17s-17-7.611-17-17 7.611-17 17-17 17 7.611 17 17ZM0 32c0-.276.223-.5.497-.5h8.006c.274 0 .497.224.497.5s-.223.5-.497.5H.497A.499.499 0 0 1 0 32Zm55 0c0-.276.222-.5.497-.5h8.006c.275 0 .497.224.497.5s-.222.5-.497.5h-8.006A.499.499 0 0 1 55 32ZM32.5 55.486A.493.493 0 0 0 32 55c-.276 0-.5.217-.5.486v8.029c0 .268.224.485.5.485s.5-.217.5-.486v-8.029Zm15.764-7.223a.499.499 0 0 1 .705-.002l5.66 5.661a.498.498 0 0 1-.001.705.499.499 0 0 1-.705.002l-5.662-5.66a.499.499 0 0 1 .003-.706ZM10.078 9.371a.498.498 0 0 0-.705.002.499.499 0 0 0-.002.705l5.661 5.66a.499.499 0 0 0 .707-.707l-5.661-5.66Zm44.549.002c.195.195.2.507.01.696l-5.677 5.678a.493.493 0 0 1-.697-.01.493.493 0 0 1-.01-.697l5.677-5.678a.493.493 0 0 1 .697.01ZM15.747 48.96a.493.493 0 0 0-.01-.697.493.493 0 0 0-.697-.01L9.361 53.93a.493.493 0 0 0 .01.697c.196.195.508.2.697.01l5.678-5.677Z",
    fill: "currentColor"
  }));
};

var SvgContrastNight104X104 = function SvgContrastNight104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -contrast-night",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.598 2.02C24.653 2.02 2.02 24.406 2.02 52c0 27.592 22.634 49.98 50.58 49.98 23.6 0 43.418-15.972 49.004-37.56a40.176 40.176 0 0 1-10.313 1.337c-21.916 0-39.702-17.563-39.702-39.252 0-9.028 3.084-17.345 8.264-23.976a51.615 51.615 0 0 0-7.254-.51ZM0 52C0 23.27 23.56 0 52.598 0c3.181 0 6.297.28 9.324.815a1.01 1.01 0 0 1 .591 1.65c-5.557 6.489-8.905 14.877-8.905 24.04 0 20.552 16.86 37.233 37.682 37.233 3.974 0 7.804-.608 11.398-1.734a1.01 1.01 0 0 1 1.288 1.182C98.798 86.536 77.756 104 52.598 104 23.56 104 0 80.73 0 52Z",
    fill: "currentColor"
  }));
};

var SvgContrastNight16X16 = function SvgContrastNight16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -contrast-night",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.707 8.873c.237.214.34.537.272.847C15.184 13.31 11.952 16 8.083 16 3.62 16 0 12.418 0 8s3.619-8 8.083-8c.488 0 .967.043 1.433.125a.896.896 0 0 1 .687.574c.108.3.047.633-.16.876a4.396 4.396 0 0 0-1.062 2.87c0 2.454 2.011 4.444 4.491 4.444.475 0 .931-.073 1.359-.207a.905.905 0 0 1 .876.191Zm-.905 1.654a7.186 7.186 0 0 1-6.719 4.584C4.115 15.111.898 11.927.898 8 .898 4.073 4.115.889 8.083.889A7.392 7.392 0 0 1 9.357 1a5.267 5.267 0 0 0-1.274 3.444c0 2.946 2.413 5.334 5.39 5.334a5.5 5.5 0 0 0 1.629-.248 7 7 0 0 1-.3.997Z",
    fill: "currentColor"
  }));
};

var SvgContrastNight24X24 = function SvgContrastNight24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -contrast-night",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.674 13.207c.264.238.38.598.303.943-.995 4.49-5.035 7.85-9.871 7.85C6.524 22 2 17.523 2 12S6.524 2 12.106 2c.61 0 1.209.054 1.79.157a.997.997 0 0 1 .765.639.981.981 0 0 1-.178.974 5.706 5.706 0 0 0-1.377 3.725c0 3.186 2.61 5.768 5.829 5.768.616 0 1.208-.094 1.763-.268.34-.107.712-.026.976.212Zm-.997 1.842c-1.264 3.476-4.624 5.962-8.571 5.962C7.076 21.01 3 16.976 3 12c0-4.976 4.077-9.01 9.106-9.01a9.364 9.364 0 0 1 1.614.14 6.673 6.673 0 0 0-1.615 4.364c0 3.733 3.058 6.759 6.83 6.759A6.96 6.96 0 0 0 21 13.938c-.084.38-.193.751-.323 1.111Z",
    fill: "currentColor"
  }));
};

var SvgContrastNight64X64 = function SvgContrastNight64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -contrast-night",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.66 37.899c.275.248.396.623.316.983C60.79 53.247 47.848 64 32.363 64 14.49 64 0 49.673 0 32 0 14.327 14.49 0 32.363 0c1.957 0 3.875.172 5.738.502.367.065.672.319.798.666.127.347.056.735-.185 1.017-3.311 3.867-5.307 8.867-5.307 14.331 0 12.257 10.05 22.194 22.446 22.194 2.367 0 4.647-.363 6.788-1.033a1.053 1.053 0 0 1 1.019.222Zm-.986 1.925c-3.505 13.315-15.747 23.144-30.31 23.144-17.298 0-31.32-13.865-31.32-30.968S15.066 1.032 32.364 1.032a31.947 31.947 0 0 1 5.553.486 22.956 22.956 0 0 0-5.554 14.998c0 12.827 10.517 23.226 23.49 23.226a23.78 23.78 0 0 0 7.103-1.081c-.087.39-.18.778-.282 1.163Z",
    fill: "currentColor"
  }));
};

var SvgCoop104X104 = function SvgCoop104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -coop",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M104 52c0-28.72-23.28-52-52-52S0 23.28 0 52s23.28 52 52 52 52-23.28 52-52zM2 52C2 24.385 24.385 2 52 2s50 22.385 50 50c0 20.618-12.479 38.32-30.295 45.968V79.163h12.24a1 1 0 0 0 .977-1.213l-13.24-60.602c-.23-1.049-1.725-1.049-1.954 0L56.488 77.95a1 1 0 0 0 .977 1.213h12.24v19.612A49.894 49.894 0 0 1 52 102a49.894 49.894 0 0 1-17.705-3.225V79.163h12.24a1 1 0 0 0 .977-1.213l-13.24-60.602c-.229-1.049-1.724-1.049-1.954 0L19.078 77.95a1 1 0 0 0 .977 1.213h12.24v18.805C14.48 90.32 2 72.618 2 52zm68.733 25.163a.892.892 0 0 0-.057 0h-11.97l11.999-54.916 11.998 54.916h-11.97zm-37.41 0a.892.892 0 0 0-.056 0h-11.97l11.998-54.916 11.998 54.917h-11.97z",
    clipRule: "evenodd"
  }));
};

var SvgCoop16X16 = function SvgCoop16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -coop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 8c0-4.411 3.588-8 8-8 4.411 0 8 3.589 8 8 0 3.359-2.084 6.236-5.025 7.42a.628.628 0 0 1-.086.031A7.95 7.95 0 0 1 8 16a7.964 7.964 0 0 1-2.896-.551.493.493 0 0 1-.076-.028C2.085 14.238 0 11.36 0 8zm11.25 4.347v1.847A7.006 7.006 0 0 0 15 8c0-3.86-3.141-7-7-7-3.86 0-7 3.14-7 7a7.005 7.005 0 0 0 3.749 6.194v-1.847H3.302a.5.5 0 0 1-.489-.606l1.948-8.912a.5.5 0 0 1 .976 0l1.947 8.912a.498.498 0 0 1-.488.606H5.749v2.275A6.962 6.962 0 0 0 8 15a6.96 6.96 0 0 0 2.25-.378v-2.275H8.803a.499.499 0 0 1-.488-.606l1.947-8.912a.5.5 0 0 1 .976 0l1.948 8.912a.5.5 0 0 1-.489.606H11.25zm-.5-7.069-1.326 6.069h2.652L10.75 5.278zm-6.827 6.069 1.326-6.069 1.326 6.069H3.923z",
    clipRule: "evenodd"
  }));
};

var SvgCoop24X24 = function SvgCoop24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -coop",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10a9.975 9.975 0 0 0 3.682-.7A10.003 10.003 0 0 0 22 12Zm-6.016 8.072A9 9 0 0 0 21 12a9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 5.016 8.072v-2.699H6.05a.5.5 0 0 1-.489-.607L8.027 5.478c.115-.524.863-.524.977 0l2.466 11.288a.5.5 0 0 1-.488.607H9.016v3.12A8.987 8.987 0 0 0 12 21c1.046 0 2.05-.178 2.984-.506v-3.121h-1.966a.5.5 0 0 1-.488-.607l2.466-11.288c.114-.524.862-.524.977 0l2.466 11.288a.5.5 0 0 1-.489.607h-1.966v2.7Zm-.5-3.699h1.845l-1.845-8.445-1.845 8.445h1.845Zm-6.968 0h1.845L8.516 7.928 6.67 16.373h1.845Z",
    fill: "currentColor"
  }));
};

var SvgCopy104X104 = function SvgCopy104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -copy",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23 0h68a7 7 0 0 1 7 7v80a7 7 0 0 1-7 7h-3v3a7 7 0 0 1-7 7H13a7 7 0 0 1-7-7V17a7 7 0 0 1 7-7h3V7a7 7 0 0 1 7-7zm-5 12h-5a5 5 0 0 0-5 5v80a5 5 0 0 0 5 5h68a5 5 0 0 0 5-5V17a5 5 0 0 0-5-5H18zm70 80V17a7 7 0 0 0-7-7H18V7a5 5 0 0 1 5-5h68a5 5 0 0 1 5 5v80a5 5 0 0 1-5 5h-3z",
    clipRule: "evenodd"
  }));
};

var SvgCopy16X16 = function SvgCopy16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 0h9A1.5 1.5 0 0 1 15 1.5v11a1.5 1.5 0 0 1-1.5 1.5H13v.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 14.5v-11A1.5 1.5 0 0 1 2.5 2H3v-.5A1.5 1.5 0 0 1 4.5 0zM4 3H2.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5H4zm9 10V3.5A1.5 1.5 0 0 0 11.5 2H4v-.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H13z",
    clipRule: "evenodd"
  }));
};

var SvgCopy24X24 = function SvgCopy24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    role: "img",
    className: "icon -copy"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M20 1a2 2 0 0 1 1.995 1.85L22 3v15a2 2 0 0 1-1.85 1.995L20 20h-1v1a2 2 0 0 1-1.85 1.995L17 23H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V3a2 2 0 0 1 1.85-1.995L7 1h13zm-3 4H4a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm3-3H7a1 1 0 0 0-.993.883L6 3v1h11a2 2 0 0 1 1.995 1.85L19 6v13h1a1 1 0 0 0 .993-.883L21 18V3a1 1 0 0 0-.883-.993L20 2z"
  }));
};

var SvgCup104X104 = function SvgCup104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cup",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M70.365 14.632c-4.153 5.806-5.728 9.17-5.728 13.979a1 1 0 1 1-2 0c0-5.342 1.723-9.022 6.101-15.143l.42-.586.375-.522c.305-.427.547-.767.775-1.094C73.23 7.09 74.467 4.319 74.467 1a1 1 0 1 1 2 0c0 3.83-1.382 6.93-4.52 11.413a128.845 128.845 0 0 1-1.167 1.64l-.415.579zm-25.72 17.415c0-4.81 1.575-8.174 5.728-13.98l.415-.578.38-.53c.309-.432.553-.777.787-1.11 3.137-4.483 4.52-7.583 4.52-11.413a1 1 0 1 0-2 0c0 3.318-1.237 6.09-4.159 10.265-.229.327-.47.667-.775 1.094l-.376.525-.419.584c-4.378 6.12-6.102 9.801-6.102 15.143a1 1 0 1 0 2 0zM17.36 41.262h69.259c-.021.608-.053 1.3-.097 2.07a128.774 128.774 0 0 1-.897 9.41c-1.053 8.052-2.807 16.075-5.42 23.579-1.472 4.23-3.173 8.16-5.115 11.748a1.005 1.005 0 0 0-.107.196c-2.948 5.406-6.446 10.03-10.535 13.735H39.556a28.56 28.56 0 0 1-.66-.646 46.546 46.546 0 0 1-2.529-2.786c-2.632-3.126-5.268-6.916-7.73-11.38-6.922-12.547-11.128-27.823-11.277-45.926zM76.632 89.42c-2.647 4.816-5.73 9.04-9.282 12.58H103a1 1 0 1 1 0 2H1a1 1 0 0 1 0-2h35.74a51.96 51.96 0 0 1-1.903-2.144c-2.714-3.223-5.424-7.12-7.952-11.701-7.208-13.066-11.53-29.005-11.53-47.893a1 1 0 0 1 1-1h71.29a1 1 0 0 1 1 1.008c-.002.15-.007.433-.02.84a91.108 91.108 0 0 1-.106 2.336 130.704 130.704 0 0 1-.753 8.308l-.01.083c10.569.228 16.127 3.71 16.127 11.295 0 8.787-9.948 18.806-27.25 26.288zm1.485-2.856c15.226-7.057 23.766-16.002 23.766-23.432 0-6.271-4.637-9.14-14.386-9.3-1.08 7.898-2.83 15.76-5.402 23.146-1.18 3.386-2.503 6.587-3.978 9.586z",
    clipRule: "evenodd"
  }));
};

var SvgCup16X16 = function SvgCup16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cup",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.988 2.71c-.571.799-.777 1.237-.777 1.85a.5.5 0 0 1-1 0c0-.879.28-1.476.964-2.432.117-.163.173-.241.228-.32.392-.56.548-.91.548-1.308a.5.5 0 0 1 1 0c0 .654-.229 1.168-.729 1.882l-.234.328zM7.272 5.065c0-.613.205-1.051.776-1.85l.234-.328c.5-.715.728-1.228.728-1.883a.5.5 0 0 0-1 0c0 .399-.156.75-.548 1.31-.054.078-.11.156-.228.32-.683.955-.963 1.552-.963 2.431a.5.5 0 0 0 1 0zm5.448 1.708a18.708 18.708 0 0 1-.126 1.298 17.155 17.155 0 0 1-.78 3.39 11.391 11.391 0 0 1-.744 1.703c-.392.718-.85 1.335-1.378 1.836h-3.38a6.723 6.723 0 0 1-.34-.379 10.045 10.045 0 0 1-1.098-1.617c-.945-1.713-1.537-3.784-1.608-6.231h9.454zm-.848 7.007c-.249.44-.523.848-.823 1.22H15.5a.5.5 0 0 1 0 1H.5a.5.5 0 1 1 0-1h4.491c-.34-.435-.676-.939-.993-1.513-1.088-1.973-1.74-4.375-1.74-7.214a.5.5 0 0 1 .5-.5h10.484a.5.5 0 0 1 .5.504 19.022 19.022 0 0 1-.09 1.365c1.486.12 2.331.743 2.331 1.995 0 1.447-1.517 2.997-4.11 4.142zm.691-1.462c1.572-.89 2.42-1.892 2.42-2.68 0-.624-.423-.94-1.459-1.004a17.752 17.752 0 0 1-.765 3.155c-.063.18-.128.356-.196.529z",
    clipRule: "evenodd"
  }));
};

var SvgCup24X24 = function SvgCup24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -cup",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.676 5.222c-.738 1.033-1.008 1.61-1.008 2.422a.5.5 0 0 1-1 0c0-1.078.344-1.814 1.195-3.003.149-.208.22-.309.29-.409.511-.729.718-1.194.718-1.732a.5.5 0 0 1 1 0c0 .794-.28 1.422-.898 2.306l-.297.416Zm-4.732 3.062c0-.813.27-1.39 1.008-2.422.148-.206.223-.312.297-.417.618-.883.898-1.512.898-2.305a.5.5 0 0 0-1 0c0 .538-.207 1.003-.718 1.732l-.29.408c-.851 1.19-1.195 1.925-1.195 3.004a.5.5 0 0 0 1 0Zm7.176 2.03-.003.053c-.026.453-.07.96-.136 1.504-.19 1.556-.52 3.111-1.024 4.557a14.586 14.586 0 0 1-.96 2.193c-.51.931-1.108 1.732-1.8 2.38h-4.39a8.23 8.23 0 0 1-.479-.528 12.858 12.858 0 0 1-1.405-2.07c-1.225-2.22-1.985-4.91-2.057-8.09H18.12Zm-1.309 8.901A11.005 11.005 0 0 1 15.578 21H21.5a.5.5 0 0 1 0 1h-19a.5.5 0 0 1 0-1h5.966a13.982 13.982 0 0 1-1.419-2.114c-1.368-2.479-2.187-5.5-2.187-9.073a.5.5 0 0 1 .5-.5h13.28a.5.5 0 0 1 .5.505c-.002.114-.008.32-.024.607-.022.382-.057.8-.105 1.245 1.904.118 2.967.868 2.967 2.404 0 1.775-1.901 3.708-5.167 5.141Zm.704-1.45c2.24-1.19 3.463-2.58 3.463-3.691 0-.9-.63-1.341-2.095-1.41a22.469 22.469 0 0 1-.981 4.092c-.12.347-.25.683-.387 1.01Z",
    fill: "currentColor"
  }));
};

var SvgCurrency104X104 = function SvgCurrency104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -currency",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M103.677 51.521a1 1 0 0 0-1.413.06L90.475 64.392c3.193-13.893-.847-30.359-10.197-39.845-12.013-12.28-30.929-15.099-45.999-6.85a1 1 0 1 0 .96 1.754c14.289-7.82 32.22-5.148 43.612 6.497 9.43 9.568 13.177 26.616 9.065 40.315l-10.182-10.18a.999.999 0 1 0-1.414 1.413l11.356 11.355c.003.004.007.006.01.008l.01.005c.029.029.064.05.1.07a1.16 1.16 0 0 1 .079.05l.012.01a.717.717 0 0 0 .153.086.983.983 0 0 0 .345.065h.02a.06.06 0 0 0 .018-.005.07.07 0 0 1 .019-.005.973.973 0 0 0 .358-.093l.023-.012a1 1 0 0 0 .239-.168.152.152 0 0 1 .026-.018c.01-.006.021-.013.03-.023l14.618-15.888a1 1 0 0 0-.059-1.413zM52.509 66.287h-.016c-4.117-.003-7.465-3.294-7.465-7.339 0-.55-.454-.996-1.014-.996S43 58.398 43 58.948c0 4.81 3.723 8.779 8.487 9.277v3.779c0 .55.454.996 1.014.996s1.014-.446 1.014-.996v-3.766C58.49 67.82 62 64.334 62 59.641c0-2.978-1.61-6.89-9.274-8.612-5.108-1.149-7.698-3.393-7.698-6.672 0-3.85 3.142-6.644 7.47-6.644 3.66.002 6.76 2.575 7.372 6.117.094.543.618.908 1.17.816a.998.998 0 0 0 .83-1.148c-.721-4.172-4.157-7.28-8.355-7.718v-3.784c0-.55-.454-.996-1.014-.996s-1.014.445-1.014.996v3.767C46.51 36.179 43 39.665 43 44.357c0 2.98 1.608 6.891 9.274 8.614 5.107 1.147 7.698 3.392 7.698 6.67 0 3.849-3.138 6.642-7.463 6.646zM26.891 78.182c11.314 11.465 29.12 14.136 43.3 6.493a1 1 0 1 1 .949 1.76A38.291 38.291 0 0 1 52.958 91c-10.1 0-20.106-3.93-27.49-11.414-9.599-9.734-13.817-26.37-10.588-40.166L1.707 52.59a.997.997 0 0 1-1.414 0 .998.998 0 0 1 0-1.414l15.888-15.883a.265.265 0 0 1 .062-.043.386.386 0 0 0 .045-.027l.01-.008c.063-.049.124-.096.196-.127.026-.01.053-.016.08-.022a.827.827 0 0 0 .044-.01.98.98 0 0 1 .252-.05.07.07 0 0 0 .02-.003c.006-.001.012-.003.02-.003.03 0 .06.01.09.018a.505.505 0 0 0 .122.023.35.35 0 0 1 .097.016c.008.003.014.007.02.011.005.004.01.008.017.01.049.02.09.048.133.077a2.22 2.22 0 0 0 .07.046c.046.029.091.058.13.096.005.005.011.01.017.013.006.004.013.007.018.013l11.54 12.539a1 1 0 1 1-1.473 1.353L17.333 37.96c-3.986 13.5-.039 30.49 9.558 40.222z",
    clipRule: "evenodd"
  }));
};

var SvgCurrency16X16 = function SvgCurrency16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -currency",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.839 7.642a.503.503 0 0 0-.707.03l-.97 1.052c.092-1.855-.55-3.809-1.751-5.025A6.048 6.048 0 0 0 5.225 2.63a.498.498 0 1 0 .48.875 5.043 5.043 0 0 1 5.993.892c1.169 1.183 1.703 3.201 1.388 4.971l-1.051-1.048a.501.501 0 0 0-.707 0 .496.496 0 0 0 0 .705l1.67 1.666a.022.022 0 0 0 .005.003.06.06 0 0 1 .004.003.276.276 0 0 0 .05.035.455.455 0 0 1 .051.033c.02.014.042.028.066.036l.004.003a.48.48 0 0 0 .173.033h.01a.49.49 0 0 0 .297-.117c.008-.007.016-.012.025-.017.013-.008.025-.016.036-.027l2.15-2.33a.498.498 0 0 0-.03-.705zm-7.837 2.11H8a.73.73 0 0 1-.729-.728.5.5 0 0 0-1 0c0 .777.521 1.428 1.231 1.644v.278a.499.499 0 0 0 1 0v-.267c.725-.194 1.23-.793 1.23-1.553 0-.464-.21-1.29-1.62-1.611-.84-.192-.84-.529-.84-.64 0-.431.365-.626.73-.626a.731.731 0 0 1 .72.609.5.5 0 0 0 .986-.168 1.72 1.72 0 0 0-1.206-1.358v-.275a.499.499 0 0 0-1 0v.267c-.726.192-1.23.792-1.23 1.552 0 .463.21 1.29 1.618 1.61.842.193.842.529.842.64 0 .433-.366.626-.729.626zM4.56 11.621a5.05 5.05 0 0 0 5.949.89.498.498 0 1 1 .475.877 6.005 6.005 0 0 1-2.842.712 6.044 6.044 0 0 1-4.294-1.78c-1.249-1.264-1.908-3.274-1.798-5.15L.854 8.36a.5.5 0 0 1-.707-.705l2.336-2.33c.01-.01.023-.017.035-.024l.024-.014.017-.013a.36.36 0 0 1 .079-.05.246.246 0 0 1 .051-.015l.026-.006.02-.005a.384.384 0 0 1 .093-.015l.01-.002a.03.03 0 0 1 .009-.002c.014 0 .028.005.042.009l.031.008c.01.002.02.003.031.003.017.001.034.003.051.009a.035.035 0 0 1 .01.005l.009.005a.396.396 0 0 1 .082.05l.014.008c.025.016.05.031.071.053a.044.044 0 0 0 .008.005l.008.006 1.698 1.84a.496.496 0 0 1-.03.704.497.497 0 0 1-.706-.03l-1.062-1.15c-.266 1.726.297 3.744 1.455 4.916z",
    clipRule: "evenodd"
  }));
};

var SvgCurrency24X24 = function SvgCurrency24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -currency",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.352 4.873a.498.498 0 1 1-.48-.875 8.968 8.968 0 0 1 10.7 1.588c1.982 2.007 2.922 5.303 2.545 8.275l2.015-2.186a.5.5 0 0 1 .706-.03.498.498 0 0 1 .03.705l-3.295 3.575a.5.5 0 0 1-.727.01l-2.556-2.55a.498.498 0 0 1 0-.705.501.501 0 0 1 .708 0l1.964 1.96c.684-2.881-.142-6.369-2.104-8.355a7.967 7.967 0 0 0-9.506-1.412Zm7.62 14.278a.498.498 0 1 1 .475.878 8.97 8.97 0 0 1-10.625-1.59c-2.03-2.054-3.02-5.425-2.624-8.412L.854 12.365a.5.5 0 0 1-.708 0 .498.498 0 0 1 0-.705l3.571-3.562a.5.5 0 0 1 .753.024l2.583 2.8a.498.498 0 0 1-.03.705.5.5 0 0 1-.706-.029L4.318 9.431c-.64 2.841.243 6.31 2.216 8.308a7.968 7.968 0 0 0 9.438 1.412ZM12.501 8.103v-.62a.5.5 0 0 0-1 0v.612c-1.092.198-1.888 1.046-1.888 2.18 0 1.202.893 1.896 2.276 2.211.982.225 1.498.625 1.498 1.24 0 .714-.565 1.219-1.368 1.226h-.036a1.386 1.386 0 0 1-1.37-1.383.5.5 0 0 0-1 0c0 1.144.81 2.1 1.888 2.329v.62a.5.5 0 0 0 1 0v-.613c1.09-.199 1.886-1.046 1.886-2.179 0-1.204-.892-1.896-2.275-2.212-.982-.224-1.499-.625-1.499-1.24 0-.72.575-1.226 1.387-1.226.677 0 1.255.487 1.368 1.153a.5.5 0 0 0 .986-.167 2.385 2.385 0 0 0-1.853-1.931Z",
    fill: "currentColor"
  }));
};

var SvgCutlery104X104 = function SvgCutlery104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -cutlery"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.705 16.425a1.01 1.01 0 0 0-1.427 0L87.963 30.733a12.244 12.244 0 0 1-.365.295c-.263.206-.65.494-1.14.818-.981.652-2.353 1.438-3.932 1.999-3.144 1.117-6.977 1.319-10.342-2.045-3.36-3.36-3.16-7.19-2.043-10.334.562-1.579 1.347-2.95 1.999-3.933a18.637 18.637 0 0 1 1.055-1.436l.057-.068L87.567 1.721A1.008 1.008 0 1 0 86.14.295L71.775 14.653l-.022.025.76.665-.76-.665-.001.002-.002.003-.007.008-.022.026a14.42 14.42 0 0 0-.355.439c-.232.296-.55.726-.907 1.263-.711 1.071-1.586 2.592-2.219 4.372-1.27 3.575-1.59 8.33 2.518 12.435 4.11 4.108 8.867 3.79 12.443 2.519 1.781-.633 3.303-1.508 4.374-2.219a20.626 20.626 0 0 0 1.608-1.184l.094-.079.026-.022.008-.007.002-.002h.001c0-.001.001-.001-.664-.76l.664.76.026-.023 14.365-14.358a1.01 1.01 0 0 0 0-1.426Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.636 8.36a1.008 1.008 0 0 1 0 1.426L80.002 25.413a1.009 1.009 0 0 1-1.426-1.426L94.21 8.36a1.009 1.009 0 0 1 1.426 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.184 31.8a1.008 1.008 0 0 1 0 1.426L1.83 103.547a1.008 1.008 0 1 1-1.427-1.426l70.355-70.32a1.01 1.01 0 0 1 1.426 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.189 1.348.998.144-.998-.144v.005l-.002.008-.004.03a15.936 15.936 0 0 0-.055.495A27.3 27.3 0 0 0 .03 3.342a41.773 41.773 0 0 0 .135 5.285C.55 13.075 1.713 19.201 4.833 25.95c3.181 6.88 10.47 13.18 16.813 17.706a113.412 113.412 0 0 0 8.394 5.429 99.045 99.045 0 0 0 3.36 1.884l.192.1.05.027.014.007.004.002h.001l.444-.861-.444.861a1.008 1.008 0 1 0 .923-1.793l-.014-.006-.045-.024-.182-.095c-.16-.086-.399-.213-.705-.38a97.4 97.4 0 0 1-2.577-1.461 111.473 111.473 0 0 1-8.243-5.331C16.506 37.511 9.608 31.47 6.664 25.104c-3.004-6.5-4.121-12.39-4.488-16.649a40.378 40.378 0 0 1-.142-4.681l43.791 44.044a1.009 1.009 0 0 0 1.431-1.422L1.903.782a1.009 1.009 0 0 0-1.714.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.16 57.788a1.008 1.008 0 0 0-.004 1.426l44.218 44.488a1.008 1.008 0 1 0 1.431-1.421L58.587 57.793a1.009 1.009 0 0 0-1.426-.005Z"
  }));
};

var SvgCutlery16X16 = function SvgCutlery16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -cutlery"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.428 3.518a.495.495 0 0 0-.727 0l-1.97 2.08a1.552 1.552 0 0 1-.162.125c-.12.084-.282.181-.463.25-.355.133-.714.14-1.041-.207-.327-.345-.321-.724-.195-1.099a2.35 2.35 0 0 1 .354-.66l1.97-2.08c.2-.212.2-.556 0-.768a.495.495 0 0 0-.727 0L10.47 3.268l-.011.013.386.358-.386-.358-.002.002-.001.002-.005.006-.014.018a3.409 3.409 0 0 0-.188.27c-.11.173-.247.425-.348.725-.204.607-.27 1.484.437 2.23.707.747 1.537.677 2.113.461a3.14 3.14 0 0 0 .941-.566l.017-.015.006-.005.002-.002s.001-.001-.338-.409l.339.409.013-.013 1.997-2.109c.201-.211.201-.555 0-.767Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.311 2.338c.201.212.201.556 0 .768l-2.164 2.285a.495.495 0 0 1-.727 0 .564.564 0 0 1 0-.767l2.164-2.286a.495.495 0 0 1 .727 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.065 5.766c.2.212.2.556 0 .768l-9.74 10.284a.495.495 0 0 1-.727 0 .564.564 0 0 1 0-.768l9.74-10.284a.495.495 0 0 1 .727 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.46 1.533.5.069-.5-.069v.005l-.001.006-.003.02a4.588 4.588 0 0 0-.026.297c-.01.196-.014.472.008.81.046.676.2 1.602.631 2.615.462 1.082 1.513 2.023 2.374 2.665a15.105 15.105 0 0 0 1.629 1.054l.028.015.008.004.002.001.24-.478-.24.479c.248.13.554.023.686-.242s.039-.585-.208-.716l-.001-.001-.005-.003-.023-.012a12.24 12.24 0 0 1-.43-.25 14.142 14.142 0 0 1-1.085-.731c-.846-.63-1.703-1.437-2.05-2.249a7.035 7.035 0 0 1-.51-1.894l5.2 5.527a.488.488 0 0 0 .716-.01.556.556 0 0 0 .014-.755l-6.09-6.47a.478.478 0 0 0-.515-.123.55.55 0 0 0-.349.436Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.456 9.566a.564.564 0 0 0-.002.768l6.121 6.506c.2.212.526.214.727.002a.564.564 0 0 0 .003-.767L9.183 9.569a.495.495 0 0 0-.727-.003Z"
  }));
};

var SvgCutlery24X24 = function SvgCutlery24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -cutlery"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.85 5.15c-.2-.2-.526-.2-.726 0l-2.653 2.652-.048.039a3.1 3.1 0 0 1-.853.474c-.515.182-1.079.201-1.585-.304-.505-.505-.486-1.068-.303-1.584a3.102 3.102 0 0 1 .512-.9l2.653-2.652a.513.513 0 1 0-.725-.725l-2.68 2.679-.012.012.386.338-.386-.338-.001.002-.002.002-.006.007-.017.02a4.148 4.148 0 0 0-.24.327c-.143.214-.32.521-.45.885-.26.734-.339 1.768.546 2.652.885.884 1.919.806 2.654.545a4.123 4.123 0 0 0 1.212-.69l.02-.017.007-.006.003-.002-.337-.386.337.386.014-.012 2.68-2.678c.2-.2.2-.525 0-.725Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.349 3.65c.2.2.2.525 0 .726l-2.91 2.906a.513.513 0 0 1-.725-.725l2.909-2.907c.2-.2.525-.2.726 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.985 8.01c.2.2.2.526 0 .726L2.896 21.816a.513.513 0 0 1-.726-.725l13.09-13.08c.2-.2.525-.2.725 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.039 2.53.507.073-.507-.074v.002l-.001.003-.001.007-.003.024-.009.08a5.403 5.403 0 0 0-.019.289c-.01.246-.01.595.026 1.024.074.858.298 2.035.897 3.33.63 1.364 2.05 2.577 3.235 3.423a21.424 21.424 0 0 0 2.223 1.383l.038.02.01.005.003.001h.001l.235-.455-.235.456a.514.514 0 0 0 .47-.912l-.002-.001-.008-.004-.032-.017a17.703 17.703 0 0 1-.598-.336 20.387 20.387 0 0 1-1.51-.975C5.59 9.042 4.37 7.96 3.862 6.859a8.987 8.987 0 0 1-.809-3.02l7.568 7.61a.513.513 0 0 0 .728-.723L2.91 2.241a.513.513 0 0 0-.871.288Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.73 12.844a.513.513 0 0 0-.002.725l8.227 8.275a.513.513 0 0 0 .728-.722l-8.226-8.276a.513.513 0 0 0-.726-.002Z"
  }));
};

var SvgCutlery64X64 = function SvgCutlery64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -cutlery"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.818 10.107a.62.62 0 0 0-.878 0l-8.809 8.805-.042.036a11.429 11.429 0 0 1-.884.65c-.604.4-1.448.884-2.42 1.229-1.935.688-4.293.811-6.364-1.258-2.068-2.067-1.944-4.425-1.257-6.36a11.33 11.33 0 0 1 1.23-2.42 11.407 11.407 0 0 1 .684-.925l8.81-8.805a.62.62 0 1 0-.878-.877l-8.84 8.835-.014.016.467.409-.467-.41v.002l-.002.001-.004.005-.014.016a8.737 8.737 0 0 0-.219.27c-.142.183-.338.447-.558.778-.437.659-.976 1.595-1.365 2.69-.782 2.2-.978 5.126 1.55 7.652 2.529 2.528 5.456 2.332 7.657 1.55a12.564 12.564 0 0 0 2.691-1.365 12.723 12.723 0 0 0 .99-.729l.058-.048.016-.014.005-.004.001-.002-.408-.467.408.467.016-.014 8.84-8.835a.62.62 0 0 0 0-.877Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.853 5.145a.62.62 0 0 1 0 .877l-9.621 9.616a.621.621 0 0 1-.878-.877l9.621-9.616a.62.62 0 0 1 .878 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.421 19.569a.62.62 0 0 1 0 .877L1.126 63.72a.62.62 0 0 1-.878-.877l43.295-43.273a.62.62 0 0 1 .878 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.116.83.615.088L.116.83V.838L.112.856a5.488 5.488 0 0 0-.034.304 16.8 16.8 0 0 0-.06.897c-.032.773-.035 1.884.083 3.252.236 2.737.952 6.507 2.872 10.66 1.958 4.234 6.443 8.11 10.347 10.896a69.805 69.805 0 0 0 6.784 4.258 40.656 40.656 0 0 0 .567.304l.031.016.009.004.002.001.274-.53-.274.53a.62.62 0 1 0 .569-1.103l-.009-.004-.028-.015a31.674 31.674 0 0 1-.546-.292 68.63 68.63 0 0 1-6.658-4.18c-3.885-2.77-8.13-6.489-9.941-10.406-1.849-4-2.536-7.624-2.762-10.245a24.848 24.848 0 0 1-.087-2.88L28.2 29.424a.621.621 0 0 0 .88-.874L1.17.48A.62.62 0 0 0 .117.829Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.176 35.561a.62.62 0 0 0-.003.877l27.211 27.377a.621.621 0 0 0 .88-.875l-27.21-27.376a.62.62 0 0 0-.878-.003Z"
  }));
};

var SvgDataSafety104X104 = function SvgDataSafety104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -data-safety",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 35h12.003V19.959C32.003 8.936 40.958 0 52.003 0s20 8.936 20 19.959V35H84c3.866 0 7 3.168 7 7.076v54.848c0 3.908-3.134 7.076-7 7.076H20c-3.866 0-7-3.168-7-7.076V42.076C13 38.168 16.134 35 20 35Zm50.016-15.041V35H33.99V19.959c0-9.927 8.065-17.976 18.012-17.976 9.948 0 18.013 8.049 18.013 17.976Zm-55.03 22.117c0-2.799 2.244-5.067 5.012-5.067h64c2.77 0 5.014 2.268 5.014 5.067v54.848c0 2.799-2.244 5.067-5.013 5.067h-64c-2.769 0-5.013-2.268-5.013-5.067V42.076Zm52.93 38.655c-3.401.46-6.427-1.703-7.172-5.137a11.245 11.245 0 0 1-9.477 5.183c-6.215 0-11.253-5.038-11.253-11.252 0-6.215 5.038-11.253 11.253-11.253 3.866 0 7.276 1.95 9.302 4.918v-3.942a.976.976 0 1 1 1.953 0v14.68c0 3.187 2.375 5.24 5.132 4.868 3.107-.42 5.394-3.68 5.394-9.272v-.006a21.047 21.047 0 0 0-2.433-9.839c-5.424-10.278-18.154-14.214-28.433-8.79-10.28 5.424-14.217 18.153-8.793 28.431 5.424 10.279 18.154 14.215 28.434 8.791a.976.976 0 0 1 .911 1.727c-11.233 5.926-25.144 1.626-31.071-9.607C25.735 69 30.036 55.09 41.27 49.162c11.233-5.926 25.145-1.626 31.072 9.606A22.999 22.999 0 0 1 75 69.525c-.002 6.495-2.911 10.641-7.085 11.206ZM51.27 78.824a9.3 9.3 0 0 0 9.3-9.178v-.243a9.3 9.3 0 0 0-9.3-9.178 9.3 9.3 0 1 0 0 18.6Z",
    fill: "currentColor"
  }));
};

var SvgDataSafety16X16 = function SvgDataSafety16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -data-safety",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.64 15c.21 0 .38-.175.38-.389v-8.03a.385.385 0 0 0-.38-.389H3.36a.385.385 0 0 0-.38.389v8.03c0 .214.17.389.38.389h9.28zM8 1C6.751 1 5.735 2.037 5.735 3.312v1.88h4.53v-1.88C10.265 2.037 9.249 1 8 1zm3.245 4.192h1.394c.75 0 1.361.623 1.361 1.389v8.03c0 .766-.61 1.389-1.36 1.389H3.36C2.61 16 2 15.377 2 14.611v-8.03c0-.766.61-1.389 1.36-1.389h1.395v-1.88C4.755 1.486 6.21 0 8 0s3.245 1.486 3.245 3.312v1.88zM6.865 10.6c0 .578.46 1.048 1.027 1.048.566 0 1.026-.47 1.026-1.048 0-.578-.46-1.048-1.026-1.048-.566 0-1.027.47-1.027 1.048zM4.428 9.468A3.772 3.772 0 0 1 6.255 7.22c1.823-.982 4.09-.268 5.053 1.595.283.548.433 1.166.432 1.786 0 .612-.152 1.13-.437 1.495-.275.352-.67.554-1.085.554-.422 0-.77-.208-1.005-.522-.353.32-.813.52-1.321.52-1.106 0-2.006-.92-2.006-2.048 0-1.13.9-2.048 2.006-2.048.39 0 .754.119 1.063.318a.487.487 0 0 1 .453-.318c.272 0 .49.223.49.5v2.21c.001.463.427.483.639.21.102-.13.223-.387.223-.872v-.004c0-.456-.11-.91-.318-1.314-.71-1.374-2.384-1.903-3.73-1.177-1.346.725-1.863 2.432-1.153 3.806a2.762 2.762 0 0 0 1.626 1.377 2.685 2.685 0 0 0 2.103-.2.487.487 0 0 1 .662.209.506.506 0 0 1-.205.676 3.658 3.658 0 0 1-2.85.27 3.735 3.735 0 0 1-2.202-1.866 3.867 3.867 0 0 1-.265-2.91z",
    clipRule: "evenodd"
  }));
};

var SvgDataSafety24X24 = function SvgDataSafety24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -data-safety",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.968 9a.44.44 0 0 1-.047-.002H4.838a.856.856 0 0 0-.852.86v12.284c0 .474.382.86.852.86h14.325c.47 0 .85-.385.85-.86V9.857c0-.475-.38-.86-.85-.86h-3.084a.442.442 0 0 1-.093 0H8.014A.44.44 0 0 1 7.968 9Zm11.195-1H16.5V4.833C16.5 2.163 14.485 0 12 0S7.5 2.164 7.5 4.833V8H4.837A1.848 1.848 0 0 0 3 9.858v12.284C3 23.166 3.823 24 4.837 24h14.326A1.848 1.848 0 0 0 21 22.142V9.857A1.848 1.848 0 0 0 19.163 8Zm-3.598-3.167V8h-7.13V4.833c0-2.115 1.596-3.829 3.564-3.829 1.97 0 3.566 1.714 3.566 3.829Zm-.242 13.732a1.55 1.55 0 0 1-1.549-.733 2.556 2.556 0 0 1-1.915.865c-1.424 0-2.577-1.169-2.577-2.612s1.153-2.613 2.576-2.613c.636 0 1.218.234 1.668.62v-.211a.447.447 0 1 1 .895 0v1.924a2.681 2.681 0 0 1 0 .56v.55c0 .51.36.82.782.763.508-.069.902-.63.902-1.673a4.106 4.106 0 1 0-7.735 1.91 4.105 4.105 0 0 0 5.546 1.715.447.447 0 1 1 .417.791A5 5 0 1 1 17 16.006v.001c0 1.455-.68 2.423-1.677 2.558Zm-1.797-2.264v-.432a1.688 1.688 0 0 0-1.667-1.487c-.928 0-1.68.762-1.68 1.703 0 .94.752 1.703 1.68 1.703.856 0 1.562-.648 1.667-1.487Z",
    fill: "currentColor"
  }));
};

var SvgDateChecked104X104 = function SvgDateChecked104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -date-checked",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M96.955 102A5.05 5.05 0 0 0 102 96.956V44.445a5.05 5.05 0 0 0-5.045-5.045H86.944v21.366c0 5.031-4.548 9.124-10.138 9.124H27.194c-5.59 0-10.138-4.093-10.138-9.124V39.4H7.045A5.05 5.05 0 0 0 2 44.445v52.511A5.05 5.05 0 0 0 7.045 102h89.91zM27.194 9.351c-4.487 0-8.138 3.195-8.138 7.124v44.291c0 3.928 3.651 7.124 8.138 7.124h49.612c4.487 0 8.138-3.196 8.138-7.124V16.475c0-3.929-3.651-7.124-8.138-7.124h-7.945v6.35a1 1 0 1 1-2 0v-6.35H53v6.35a1 1 0 1 1-2 0v-6.35H37.139v6.35a1 1 0 0 1-2 0v-6.35h-7.945zM86.944 37.4h10.011A7.052 7.052 0 0 1 104 44.445v52.511c0 3.884-3.16 7.044-7.045 7.044H7.045C3.16 104 0 100.84 0 96.956V44.445A7.052 7.052 0 0 1 7.045 37.4h10.011V16.475c0-5.031 4.548-9.124 10.138-9.124h7.945V1a1 1 0 1 1 2 0v6.351H51V1a1 1 0 1 1 2 0v6.351h13.861V1a1 1 0 0 1 2 0v6.351h7.945c5.59 0 10.138 4.093 10.138 9.124V37.4zm-39.46 16.659a.997.997 0 0 1-.708-.293L34.732 41.722a.999.999 0 1 1 1.414-1.414l11.288 11.288 20.373-23.284a1 1 0 0 1 1.506 1.318L48.236 53.718a1.002 1.002 0 0 1-.72.34l-.033.001z",
    clipRule: "evenodd"
  }));
};

var SvgDateChecked16X16 = function SvgDateChecked16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -date-checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.606 15c.21 0 .382-.175.382-.389V6.888a.386.386 0 0 0-.382-.388h-1.113v2.789c0 .934-.829 1.695-1.849 1.695h-7.29c-1.02 0-1.848-.761-1.848-1.695V6.5H1.393a.385.385 0 0 0-.381.388v7.723c0 .214.17.389.381.389h13.213zM4.355 2.081c-.462 0-.837.311-.837.694v6.514c0 .383.375.695.837.695h7.29c.46 0 .836-.312.836-.695V2.775c0-.383-.375-.694-.837-.694h-.808v.58c0 .277-.226.5-.506.5a.502.502 0 0 1-.506-.5v-.58H8.506v.58c0 .277-.227.5-.506.5a.502.502 0 0 1-.506-.5v-.58h-1.32v.58c0 .277-.226.5-.505.5s-.506-.223-.506-.5v-.58h-.808zM13.493 5.5h1.113c.769 0 1.394.623 1.394 1.388v7.723c0 .766-.625 1.389-1.394 1.389H1.393A1.393 1.393 0 0 1 0 14.611V6.888C0 6.123.625 5.5 1.393 5.5h1.113V2.775c0-.934.829-1.694 1.849-1.694h.808V.5c0-.277.227-.5.506-.5s.506.223.506.5v.581h1.32V.5c0-.277.225-.5.505-.5s.506.223.506.5v.581h1.318V.5c0-.277.227-.5.506-.5.28 0 .506.223.506.5v.581h.808c1.02 0 1.849.76 1.849 1.694V5.5zM7.335 8.655a.505.505 0 0 1-.359-.148l-1.77-1.771a.497.497 0 0 1 .005-.708.511.511 0 0 1 .715.005L7.31 7.42l2.74-3.134a.51.51 0 0 1 .713-.051.496.496 0 0 1 .052.706L7.718 8.482a.499.499 0 0 1-.383.172z",
    clipRule: "evenodd"
  }));
};

var SvgDateChecked24X24 = function SvgDateChecked24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -date-checked",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M21 20.374v-9.781a.627.627 0 0 0-.626-.626h-1.551v3.666c0 1.11-.988 2.013-2.202 2.013H7.379c-1.214 0-2.202-.903-2.202-2.013V9.967H3.626a.627.627 0 0 0-.626.626v9.781c0 .345.281.626.626.626h16.748a.627.627 0 0 0 .626-.626zM6.177 5.382v8.251c0 .558.539 1.013 1.202 1.013h9.242c.663 0 1.202-.455 1.202-1.013V5.382c0-.558-.539-1.013-1.202-1.013h-1.167v.869a.5.5 0 1 1-1 0v-.869H12.5v.869a.5.5 0 1 1-1 0v-.869H9.546v.869a.5.5 0 1 1-1 0v-.869H7.379c-.663 0-1.202.455-1.202 1.013zm14.197 3.585c.897 0 1.626.729 1.626 1.626v9.781C22 21.27 21.271 22 20.374 22H3.626C2.729 22 2 21.27 2 20.374v-9.781c0-.897.729-1.626 1.626-1.626h1.551V5.382c0-1.11.988-2.013 2.202-2.013h1.167V2.5a.5.5 0 0 1 1 0v.869H11.5V2.5a.5.5 0 0 1 1 0v.869h1.954V2.5a.5.5 0 0 1 1 0v.869h1.167c1.214 0 2.202.903 2.202 2.013v3.585h1.551zm-9.568 3.584-2.244-2.244a.5.5 0 0 1 .707-.707l1.866 1.866 3.574-4.084a.5.5 0 1 1 .752.658l-3.926 4.487a.493.493 0 0 1-.36.17h-.015a.5.5 0 0 1-.354-.146z"
  }));
};

var SvgDialogInfo16X16 = function SvgDialogInfo16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dialog-info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.889 15.27v-2.285H1.393C.623 12.985 0 12.357 0 11.58V1.406A1.4 1.4 0 0 1 1.393 0h13.214A1.4 1.4 0 0 1 16 1.406V11.58c0 .777-.624 1.405-1.393 1.405H9.052l-4.019 2.876c-.478.348-1.144 0-1.144-.591zm1-2.789v2.247l3.715-2.658a.497.497 0 0 1 .289-.093h5.714A.394.394 0 0 0 15 11.58V1.406a.395.395 0 0 0-.393-.397H1.393A.395.395 0 0 0 1 1.406V11.58c0 .22.176.397.393.397h2.996c.276 0 .5.226.5.504zM7.5 5.324v5.105c0 .279.224.504.5.504s.5-.225.5-.504V5.324c0-.279-.224-.505-.5-.505s-.5.226-.5.505zM8 2.579a.63.63 0 0 1 .628.633c0 .35-.281.633-.628.633s-.628-.283-.628-.633A.63.63 0 0 1 8 2.579z",
    clipRule: "evenodd"
  }));
};

var SvgDialogChat104X104 = function SvgDialogChat104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dialog-chat",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.445 101.455V83.498H7.073C3.167 83.498 0 80.302 0 76.36V7.136C0 3.196 3.167 0 7.073 0h89.854C100.833 0 104 3.195 104 7.136V76.36c0 3.94-3.167 7.137-7.073 7.137H58.391l-27.97 20.029c-1.668 1.194-3.976-.01-3.976-2.072zM102 7.135c0-2.825-2.271-5.117-5.073-5.117H7.073C4.271 2.018 2 4.31 2 7.136V76.36c0 2.826 2.272 5.119 5.073 5.119h20.372c.552 0 1 .451 1 1.009v18.966c0 .424.475.672.818.426l28.23-20.215a.994.994 0 0 1 .579-.186h38.855c2.801 0 5.073-2.293 5.073-5.12V7.137z",
    clipRule: "evenodd"
  }));
};

var SvgDialogChat16X16 = function SvgDialogChat16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dialog-chat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.889 15.27v-2.285H1.393C.623 12.985 0 12.357 0 11.58V1.406A1.4 1.4 0 0 1 1.393 0h13.214A1.4 1.4 0 0 1 16 1.406V11.58c0 .777-.624 1.405-1.393 1.405H9.052l-4.019 2.876c-.478.348-1.144 0-1.144-.591zm1-2.789v2.247l3.715-2.658a.497.497 0 0 1 .289-.093h5.714A.394.394 0 0 0 15 11.58V1.406a.395.395 0 0 0-.393-.397H1.393A.395.395 0 0 0 1 1.406V11.58c0 .22.176.397.393.397h2.996c.276 0 .5.226.5.504z",
    clipRule: "evenodd"
  }));
};

var SvgDialogChat24X24 = function SvgDialogChat24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -dialog-chat"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M6.926 18.182v3.028a.783.783 0 0 0 1.236.643l5.128-3.67h7.079c.901 0 1.631-.738 1.631-1.647V3.646C22 2.736 21.27 2 20.369 2H3.632C2.732 2 2 2.737 2 3.645v12.891c0 .91.73 1.646 1.632 1.646h3.294zm1-.504a.502.502 0 0 0-.5-.504H3.632A.635.635 0 0 1 3 16.536V3.646c0-.352.283-.637.632-.637h16.737c.348 0 .631.285.631.636v12.891a.634.634 0 0 1-.631.638h-7.238a.497.497 0 0 0-.29.093l-4.915 3.518v-3.107z"
  }));
};

var SvgDialogInfo104X104 = function SvgDialogInfo104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dialog-info",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.445 101.455V83.498H7.073C3.167 83.498 0 80.302 0 76.36V7.136C0 3.196 3.167 0 7.073 0h89.854C100.833 0 104 3.195 104 7.136V76.36c0 3.94-3.167 7.137-7.073 7.137H58.391l-27.97 20.029c-1.668 1.194-3.976-.01-3.976-2.072zM102 7.135c0-2.825-2.271-5.117-5.073-5.117H7.073C4.271 2.018 2 4.31 2 7.136V76.36c0 2.826 2.272 5.119 5.073 5.119h20.372c.552 0 1 .451 1 1.009v18.966c0 .424.475.672.818.426l28.23-20.215a.994.994 0 0 1 .579-.186h38.855c2.801 0 5.073-2.293 5.073-5.12V7.137zM51 33.793v34.736c0 .557.448 1.009 1 1.009s1-.452 1-1.009V33.792c0-.557-.448-1.01-1-1.01s-1 .453-1 1.01zm1-16.676a2.302 2.302 0 0 1 2.292 2.314A2.302 2.302 0 0 1 52 21.743a2.302 2.302 0 0 1-2.292-2.313A2.302 2.302 0 0 1 52 17.116z",
    clipRule: "evenodd"
  }));
};

var SvgDialogInfo24X24 = function SvgDialogInfo24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dialog-info",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.926 21.21v-3.028H3.632A1.64 1.64 0 0 1 2 16.536V3.646A1.64 1.64 0 0 1 3.632 2h16.737c.9 0 1.631.737 1.631 1.645v12.891c0 .91-.73 1.646-1.631 1.646H13.29l-5.128 3.671a.783.783 0 0 1-1.236-.643Zm.5-4.036c.276 0 .5.225.5.504v3.107l4.916-3.518a.497.497 0 0 1 .289-.093h7.238a.634.634 0 0 0 .631-.638V3.646a.634.634 0 0 0-.631-.637H3.632A.635.635 0 0 0 3 3.645v12.891c0 .352.283.638.632.638h3.794ZM11.5 8.609v6.468c0 .279.224.505.5.505s.5-.226.5-.505V8.61a.502.502 0 0 0-.5-.504c-.276 0-.5.225-.5.504Zm.5-3.345c.367 0 .665.3.665.67 0 .37-.298.671-.665.671a.668.668 0 0 1-.665-.67c0-.37.298-.671.665-.671Z",
    fill: "currentColor"
  }));
};

var SvgDialogQuestion104X104 = function SvgDialogQuestion104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dialog-question",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.445 101.455V83.498H7.073C3.167 83.498 0 80.302 0 76.36V7.136C0 3.196 3.167 0 7.073 0h89.854C100.833 0 104 3.195 104 7.136V76.36c0 3.94-3.167 7.137-7.073 7.137H58.391l-27.97 20.029c-1.668 1.194-3.976-.01-3.976-2.072zM102 7.135c0-2.825-2.271-5.117-5.073-5.117H7.073C4.271 2.018 2 4.31 2 7.136V76.36c0 2.826 2.272 5.119 5.073 5.119h20.372c.552 0 1 .451 1 1.009v18.966c0 .424.475.672.818.426l28.23-20.215a.994.994 0 0 1 .579-.186h38.855c2.801 0 5.073-2.293 5.073-5.12V7.137zM49.708 65.66A2.302 2.302 0 0 0 52 67.973a2.302 2.302 0 0 0 2.292-2.313A2.302 2.302 0 0 0 52 63.347a2.302 2.302 0 0 0-2.292 2.313zm2.293-49.359c-6.03 0-10.916 4.93-10.916 11.014 0 .557-.448 1.009-1 1.009s-1-.452-1-1.01c0-7.197 5.782-13.03 12.916-13.03 7.133 0 12.915 5.833 12.915 13.03 0 5.25-3.106 9.926-7.8 11.97-2.502 1.09-4.115 3.509-4.115 6.199v7.231c0 .558-.448 1.01-1 1.01s-1-.452-1-1.01v-7.231c0-3.504 2.095-6.645 5.322-8.052 3.968-1.728 6.593-5.679 6.593-10.116C62.916 21.232 58.029 16.3 52 16.3z",
    clipRule: "evenodd"
  }));
};

var SvgDialogQuestion16X16 = function SvgDialogQuestion16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dialog-question",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.889 15.27v-2.285H1.393C.623 12.985 0 12.357 0 11.58V1.406A1.4 1.4 0 0 1 1.393 0h13.214A1.4 1.4 0 0 1 16 1.406V11.58c0 .777-.624 1.405-1.393 1.405H9.052l-4.019 2.876c-.478.348-1.144 0-1.144-.591zm1-2.789v2.247l3.715-2.658a.497.497 0 0 1 .289-.093h5.714A.394.394 0 0 0 15 11.58V1.406a.395.395 0 0 0-.393-.397H1.393A.395.395 0 0 0 1 1.406V11.58c0 .22.176.397.393.397h2.996c.276 0 .5.226.5.504zm2.488-2.473c0 .347.28.628.623.628s.623-.281.623-.628c0-.348-.279-.628-.623-.628s-.623.28-.623.628zM8 3.108c-.692 0-1.252.566-1.252 1.263 0 .279-.224.504-.5.504s-.5-.225-.5-.504A2.262 2.262 0 0 1 8 2.1a2.262 2.262 0 0 1 2.253 2.271 2.27 2.27 0 0 1-1.36 2.086.642.642 0 0 0-.393.585v1.063c0 .278-.224.504-.5.504s-.5-.226-.5-.504V7.042c0-.658.393-1.247.996-1.511.456-.198.757-.65.757-1.16 0-.697-.561-1.263-1.253-1.263z",
    clipRule: "evenodd"
  }));
};

var SvgDialogQuestion24X24 = function SvgDialogQuestion24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dialog-question",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.926 21.21v-3.028H3.632A1.64 1.64 0 0 1 2 16.536V3.646A1.64 1.64 0 0 1 3.632 2h16.737c.9 0 1.631.737 1.631 1.645v12.891c0 .91-.73 1.646-1.631 1.646H13.29l-5.128 3.671a.783.783 0 0 1-1.236-.643Zm.5-4.036c.276 0 .5.225.5.504v3.107l4.916-3.518a.497.497 0 0 1 .289-.093h7.238a.634.634 0 0 0 .631-.638V3.646a.634.634 0 0 0-.631-.637H3.632A.635.635 0 0 0 3 3.645v12.891c0 .352.283.638.632.638h3.794Zm3.91-2.63c0 .37.297.67.664.67.367 0 .665-.3.665-.67 0-.37-.298-.671-.665-.671-.367 0-.665.3-.665.67ZM12 5.667c-.95 0-1.72.777-1.72 1.735a.502.502 0 0 1-.5.505.502.502 0 0 1-.5-.505c0-1.515 1.217-2.744 2.72-2.744 1.502 0 2.719 1.229 2.719 2.744a2.744 2.744 0 0 1-1.642 2.519.946.946 0 0 0-.577.865v1.345a.502.502 0 0 1-.5.505.502.502 0 0 1-.5-.505v-1.345c0-.78.465-1.479 1.18-1.791a1.735 1.735 0 0 0 1.039-1.593c0-.958-.77-1.735-1.72-1.735Z",
    fill: "currentColor"
  }));
};

var SvgDialogWarning104X104 = function SvgDialogWarning104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dialog-warning",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.445 101.455V83.498H7.073C3.167 83.498 0 80.302 0 76.36V7.136C0 3.196 3.167 0 7.073 0h89.854C100.833 0 104 3.195 104 7.136V76.36c0 3.94-3.167 7.137-7.073 7.137H58.391l-27.97 20.029c-1.668 1.194-3.976-.01-3.976-2.072zM102 7.135c0-2.825-2.271-5.117-5.073-5.117H7.073C4.271 2.018 2 4.31 2 7.136V76.36c0 2.826 2.272 5.119 5.073 5.119h20.372c.552 0 1 .451 1 1.009v18.966c0 .424.475.672.818.426l28.23-20.215a.994.994 0 0 1 .579-.186h38.855c2.801 0 5.073-2.293 5.073-5.12V7.137zM53 49.544v-35.9c0-.557-.448-1.01-1-1.01s-1 .453-1 1.01v35.9c0 .558.448 1.01 1 1.01s1-.452 1-1.01zm-1 17.158a2.302 2.302 0 0 1-2.292-2.314A2.302 2.302 0 0 1 52 62.075a2.302 2.302 0 0 1 2.292 2.312A2.302 2.302 0 0 1 52 66.701z",
    clipRule: "evenodd"
  }));
};

var SvgDialogWarning16X16 = function SvgDialogWarning16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dialog-warning",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.889 15.27v-2.285H1.393C.623 12.985 0 12.357 0 11.58V1.406A1.4 1.4 0 0 1 1.393 0h13.214A1.4 1.4 0 0 1 16 1.406V11.58c0 .777-.624 1.405-1.393 1.405H9.052l-4.019 2.876c-.478.348-1.144 0-1.144-.591zm1-2.789v2.247l3.715-2.658a.497.497 0 0 1 .289-.093h5.714A.394.394 0 0 0 15 11.58V1.406a.395.395 0 0 0-.393-.397H1.393A.395.395 0 0 0 1 1.406V11.58c0 .22.176.397.393.397h2.996c.276 0 .5.226.5.504zM8.5 7.638V2.362c0-.278-.224-.504-.5-.504s-.5.226-.5.504v5.276c0 .279.224.505.5.505s.5-.226.5-.505zM8 10.45a.626.626 0 0 1-.623-.628c0-.347.28-.629.623-.629s.623.282.623.629a.626.626 0 0 1-.623.628z",
    clipRule: "evenodd"
  }));
};

var SvgDialogWarning24X24 = function SvgDialogWarning24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dialog-warning",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.926 21.21v-3.028H3.632A1.64 1.64 0 0 1 2 16.536V3.646A1.64 1.64 0 0 1 3.632 2h16.737c.9 0 1.631.737 1.631 1.645v12.891c0 .91-.73 1.646-1.631 1.646H13.29l-5.128 3.671a.783.783 0 0 1-1.236-.643Zm.5-4.036c.276 0 .5.225.5.504v3.107l4.916-3.518a.497.497 0 0 1 .289-.093h7.238a.634.634 0 0 0 .631-.638V3.646a.634.634 0 0 0-.631-.637H3.632A.635.635 0 0 0 3 3.645v12.891c0 .352.283.638.632.638h3.794Zm5.074-5.631V4.857a.502.502 0 0 0-.5-.505c-.276 0-.5.226-.5.505v6.686c0 .278.224.504.5.504s.5-.226.5-.504Zm-.5 3.435a.668.668 0 0 1-.665-.671c0-.37.298-.67.665-.67.367 0 .665.3.665.67 0 .37-.298.67-.665.67Z",
    fill: "currentColor"
  }));
};

var SvgDigitalWallet104X104 = function SvgDigitalWallet104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -digital-wallet",
    width: 105,
    height: 104,
    viewBox: "0 0 105 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M81.5 27V7c0-2-1.2-6-6-6H29c-2 0-5.5 1.964-5.5 5.5V97c0 2.5 2 6 6 6h46c3 0 6-2.625 6-6V57",
    stroke: "#3FA110",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.447 88.472c0 2.724-2.216 4.932-4.949 4.932-2.732 0-4.947-2.208-4.947-4.932s2.215-4.932 4.947-4.932c2.733 0 4.949 2.208 4.949 4.932Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 30.132a3.728 3.728 0 0 1 3.726-3.732h40.548a3.728 3.728 0 0 1 3.726 3.732v23.733a3.73 3.73 0 0 1-3.726 3.735H44.226a3.73 3.73 0 0 1-3.726-3.734V30.132Zm2 19.785v3.949c0 .956.772 1.73 1.726 1.73h40.548c.954 0 1.726-.774 1.726-1.73V30.132c0-.955-.772-1.728-1.726-1.728H44.226c-.954 0-1.726.773-1.726 1.728v17.78h16.692a1.001 1.001 0 0 1 0 2.005H42.5Zm26.22-15.59h11.966c.929 0 1.68.756 1.68 1.686v6.071c0 .932-.751 1.686-1.68 1.686H68.72a1.683 1.683 0 0 1-1.682-1.686v-6.07c0-.931.754-1.687 1.682-1.687Zm.318 2.005v5.434h11.328v-5.434H69.038Z",
    fill: "currentColor"
  }));
};

var SvgDigitalWallet64X64 = function SvgDigitalWallet64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -digital-wallet",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M50.126 16.804V4.647c0-1.216-.73-3.647-3.647-3.647H18.214C17 1 14.871 2.194 14.871 4.343v55.01c0 1.52 1.216 3.647 3.647 3.647h27.96c1.825 0 3.648-1.596 3.648-3.647V35.039",
    stroke: "#3FA110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.507 54.17a3.003 3.003 0 0 1-3.008 2.997 3.003 3.003 0 0 1-3.007-2.998 3.003 3.003 0 0 1 3.007-2.998 3.003 3.003 0 0 1 3.008 2.998Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.48 18.708a2.266 2.266 0 0 1 2.265-2.268h24.647a2.266 2.266 0 0 1 2.265 2.268v14.427a2.267 2.267 0 0 1-2.265 2.27H29.745a2.267 2.267 0 0 1-2.265-2.27V18.707Zm1.216 12.026v2.4c0 .581.47 1.052 1.05 1.052h24.646c.58 0 1.05-.47 1.05-1.052V18.708c0-.58-.47-1.05-1.05-1.05H29.745c-.58 0-1.049.47-1.049 1.05v10.808h10.146a.608.608 0 0 1 0 1.218H28.696Zm15.938-9.476h7.273c.565 0 1.021.46 1.021 1.025v3.69c0 .566-.456 1.025-1.02 1.025h-7.274a1.023 1.023 0 0 1-1.023-1.025v-3.69c0-.566.458-1.025 1.023-1.025Zm.193 1.219v3.302h6.886v-3.302h-6.886Z",
    fill: "currentColor"
  }));
};

var SvgDigitalWalletPayment104X104 = function SvgDigitalWalletPayment104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -digital-wallet-payment",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.602 39V29c0-1 0-3.5 3.5-3.5h17c2.609 0 3 1.719 3 3.5v10",
    stroke: "#3FA110",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.102 86.5c6 .4 7.7-3.167 7.8-5V20c0-1.5 0-6-6.439-6H32.102c-3.5 0-6 2.5-6 4.844V82c.166 1.5 1.8 4.5 7 4.5",
    stroke: "#3FA110",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.918 99.559A4.448 4.448 0 0 1 66.46 104H37.543a4.449 4.449 0 0 1-4.457-4.441V42.867a4.45 4.45 0 0 1 4.457-4.442H66.46a4.449 4.449 0 0 1 4.457 4.442V99.56Zm-1.266-56.692a3.186 3.186 0 0 0-3.19-3.18H37.542a3.186 3.186 0 0 0-3.192 3.18V99.56a3.186 3.186 0 0 0 3.192 3.18h28.918a3.186 3.186 0 0 0 3.191-3.18V42.867ZM52.002 97.32a3.115 3.115 0 0 0 3.12-3.11 3.115 3.115 0 0 0-3.12-3.11 3.115 3.115 0 0 0-3.12 3.11 3.115 3.115 0 0 0 3.12 3.11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.461 104.5c2.736 0 4.957-2.211 4.957-4.941h-1a3.949 3.949 0 0 1-3.957 3.941v1Zm-28.918 0H66.46v-1H37.543v1Zm-4.957-4.941c0 2.731 2.22 4.941 4.957 4.941v-1a3.949 3.949 0 0 1-3.957-3.941h-1Zm0-56.692V99.56h1V42.867h-1Zm4.957-4.942c-2.736 0-4.957 2.211-4.957 4.942h1a3.95 3.95 0 0 1 3.957-3.942v-1Zm28.918 0H37.543v1H66.46v-1Zm4.957 4.942a4.949 4.949 0 0 0-4.957-4.942v1a3.95 3.95 0 0 1 3.957 3.942h1Zm0 56.692V42.867h-1V99.56h1ZM66.46 40.186a2.686 2.686 0 0 1 2.691 2.681h1a3.686 3.686 0 0 0-3.69-3.68v1Zm-28.918 0h28.918v-1H37.543v1Zm-2.692 2.681a2.686 2.686 0 0 1 2.692-2.68v-1a3.686 3.686 0 0 0-3.692 3.68h1Zm0 56.692V42.867h-1V99.56h1Zm2.692 2.68a2.685 2.685 0 0 1-2.692-2.68h-1a3.686 3.686 0 0 0 3.692 3.68v-1Zm28.918 0H37.543v1h28.918v-1Zm2.691-2.68c0 1.479-1.203 2.68-2.69 2.68v1a3.686 3.686 0 0 0 3.69-3.68h-1Zm0-56.692V99.56h1V42.867h-1ZM54.622 94.21c0 1.44-1.172 2.61-2.62 2.61v1a3.615 3.615 0 0 0 3.62-3.61h-1Zm-2.62-2.61c1.448 0 2.62 1.17 2.62 2.61h1a3.615 3.615 0 0 0-3.62-3.61v1Zm-2.62 2.61c0-1.44 1.171-2.61 2.62-2.61v-1a3.615 3.615 0 0 0-3.62 3.61h1Zm2.62 2.61a2.615 2.615 0 0 1-2.62-2.61h-1a3.615 3.615 0 0 0 3.62 3.61v-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.71 76.905a2.281 2.281 0 0 1-2.292-2.27V49.92a2.281 2.281 0 0 1 2.293-2.271H59.29a2.282 2.282 0 0 1 2.295 2.27v24.715a2.282 2.282 0 0 1-2.294 2.271H44.71Zm12.156-1.219h2.426c.587 0 1.063-.47 1.063-1.052V49.92c0-.581-.476-1.052-1.063-1.052H44.71c-.586 0-1.06.47-1.06 1.052v24.714c0 .582.474 1.052 1.06 1.052h10.925V65.512c0-.336.275-.61.615-.61.34 0 .616.274.616.61v10.174ZM47.21 59.964v-7.482c0-.58.484-1.05 1.08-1.05h3.892c.598 0 1.081.47 1.081 1.05v7.482c0 .58-.483 1.052-1.08 1.052H48.29c-.597 0-1.081-.471-1.081-1.052Zm1.285-.199h3.483v-7.083h-3.483v7.083Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.866 75.686h-.116v.116h.116v-.116Zm-1.231 0v.116h.115v-.116h-.115Zm-3.657-15.92v.115h.116v-.116h-.116Zm-3.483 0h-.116v.115h.116v-.116Zm3.483-7.084h.116v-.115h-.116v.115Zm-3.483 0v-.115h-.116v.115h.116Zm-6.193 21.952a2.397 2.397 0 0 0 2.409 2.387v-.231a2.166 2.166 0 0 1-2.177-2.156h-.232Zm0-24.714v24.714h.232V49.92h-.232Zm2.409-2.387a2.397 2.397 0 0 0-2.409 2.387h.232c0-1.19.973-2.156 2.177-2.156v-.23Zm11.54 0H44.71v.231h11.54v-.23Zm3.04 0h-3.04v.231h3.04v-.23Zm2.41 2.387c0-1.32-1.079-2.387-2.41-2.387v.231c1.205 0 2.18.966 2.18 2.156h.23Zm0 24.714V49.92h-.23v24.714h.23Zm-2.41 2.387c1.331 0 2.41-1.067 2.41-2.387h-.23c0 1.19-.975 2.156-2.18 2.156v.231Zm-3.04 0h3.04v-.231h-3.04v.231Zm-11.54 0h11.54v-.231H44.71v.231Zm14.58-1.45h-2.425v.231h2.426v-.231Zm.948-.937a.941.941 0 0 1-.947.937v.231c.65 0 1.178-.521 1.178-1.168h-.231Zm0-24.714v24.714h.231V49.92h-.231Zm-.947-.936c.524 0 .947.42.947.936h.231c0-.646-.528-1.168-1.178-1.168v.232Zm-3.042 0h3.042v-.232H56.25v.232Zm-11.54 0h11.54v-.232H44.71v.232Zm-.945.936a.94.94 0 0 1 .946-.936v-.232c-.65 0-1.177.521-1.177 1.168h.231Zm0 24.714V49.92h-.231v24.714h.231Zm.946.937a.94.94 0 0 1-.946-.937h-.231c0 .647.527 1.168 1.177 1.168v-.231Zm10.924 0H44.71v.231h10.924v-.231Zm-.116-10.059v10.174h.231V65.512h-.231Zm.731-.725a.728.728 0 0 0-.731.725h.231c0-.271.223-.493.5-.493v-.232Zm.732.725a.728.728 0 0 0-.732-.725v.232c.278 0 .5.222.5.493h.232Zm0 10.174V65.512h-.232v10.174h.232Zm-9.888-23.204v7.482h.232v-7.482h-.232Zm1.197-1.166c-.657 0-1.197.519-1.197 1.166h.232c0-.513.43-.934.965-.934v-.232Zm3.891 0H48.29v.232h3.892v-.232Zm1.197 1.166c0-.648-.539-1.166-1.197-1.166v.232c.537 0 .965.42.965.934h.232Zm0 7.482v-7.482h-.232v7.482h.232Zm-1.197 1.168c.659 0 1.197-.52 1.197-1.168h-.232a.95.95 0 0 1-.965.936v.232Zm-3.892 0h3.892V60.9H48.29v.232Zm-1.196-1.168c0 .648.54 1.168 1.197 1.168V60.9c-.536 0-.965-.422-.965-.936h-.232Zm4.884-.314h-3.483v.231h3.483v-.231Zm-.116-6.968v7.083h.232v-7.083h-.232Zm-3.367.116h3.483v-.231h-3.483v.231Zm.115 6.967v-7.083h-.231v7.083h.231Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.718 4.286c5.943.358 9.877 5.393 8.786 11.246a.242.242 0 0 1-.246.192.18.18 0 0 1-.17-.217C89.138 9.88 85.355 5.04 79.642 4.695a.18.18 0 0 1-.17-.217.242.242 0 0 1 .246-.192Zm-.958 4.45c3.56.176 5.885 3.153 5.195 6.649a.253.253 0 0 1-.253.198.178.178 0 0 1-.17-.219c.644-3.266-1.53-6.047-4.854-6.212a.178.178 0 0 1-.171-.219.253.253 0 0 1 .253-.198Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.504 15.532.738.137-.738-.137ZM79.718 4.286l-.045.749.045-.75Zm8.54 11.438-.045.749.045-.749Zm-.17-.217.738.137-.737-.137ZM79.642 4.695l.045-.748-.045.748Zm-.17-.217.737.137-.737-.137Zm4.483 10.907.736.145-.736-.145Zm-5.195-6.65.037-.749-.037.75Zm4.942 6.848.038-.75-.038.75Zm-.17-.219-.736-.145.735.145Zm-4.854-6.212.037-.75-.037.75Zm-.171-.219.736.145-.736-.145Zm10.735 6.736c1.173-6.296-3.086-11.747-9.479-12.132l-.09 1.498c5.493.33 9.102 4.95 8.094 10.36l1.475.274Zm-1.029.804a.992.992 0 0 0 1.029-.804l-1.475-.274a.515.515 0 0 1 .188-.313.514.514 0 0 1 .348-.106l-.09 1.497Zm-.862-1.103a.93.93 0 0 0 .862 1.103l.09-1.497c.15.009.304.082.41.218.107.136.14.303.113.45l-1.475-.274Zm-7.754-9.926c5.263.317 8.72 4.742 7.754 9.926l1.475.274c1.13-6.07-2.976-11.326-9.14-11.697l-.09 1.497Zm-.862-1.103a.93.93 0 0 0 .862 1.103l.09-1.497c.15.009.304.082.41.218.106.136.14.303.112.45l-1.475-.274Zm1.028-.804a.992.992 0 0 0-1.029.804l1.475.274a.515.515 0 0 1-.188.313.514.514 0 0 1-.348.107l.09-1.498Zm4.928 11.993c.778-3.944-1.878-7.344-5.894-7.544l-.074 1.498c3.102.154 5.098 2.709 4.497 5.756l1.471.29Zm-1.026.802c.489.024.931-.322 1.026-.802l-1.471-.29a.505.505 0 0 1 .183-.302.505.505 0 0 1 .337-.104l-.075 1.498Zm-.87-1.113a.928.928 0 0 0 .87 1.113l.075-1.498a.568.568 0 0 1 .415.219c.11.14.14.31.112.456l-1.471-.29ZM78.642 9.9c2.868.142 4.71 2.5 4.154 5.318l1.472.29c.733-3.715-1.77-6.918-5.552-7.106L78.641 9.9Zm-.87-1.113a.928.928 0 0 0 .87 1.113l.074-1.498a.567.567 0 0 1 .416.219c.11.14.14.31.112.456l-1.472-.29Zm1.026-.802a1.003 1.003 0 0 0-1.026.802l1.472.29a.504.504 0 0 1-.183.302.504.504 0 0 1-.337.104l.074-1.498Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  }))));
};

var SvgDigitalWalletPayment64X64 = function SvgDigitalWalletPayment64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -digital-wallet-payment",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24.996 23.756V17.61c0-.615 0-2.151 2.15-2.151h10.447c1.604 0 1.844 1.056 1.844 2.15v6.146",
    stroke: "#3FA110",
    strokeWidth: 0.922
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.124 52.944c3.687.246 4.732-1.946 4.793-3.072V12.08c0-.922 0-3.687-3.956-3.687H19.773c-2.15 0-3.687 1.536-3.687 2.977v38.81c.102.92 1.106 2.764 4.301 2.764",
    stroke: "#3FA110",
    strokeWidth: 0.922
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.595 60.969a2.734 2.734 0 0 1-2.738 2.73h-17.77a2.734 2.734 0 0 1-2.74-2.73V26.132a2.734 2.734 0 0 1 2.74-2.73h17.77a2.734 2.734 0 0 1 2.738 2.73v34.837Zm-.777-34.837c0-1.08-.878-1.955-1.961-1.955h-17.77a1.958 1.958 0 0 0-1.962 1.955v34.837c0 1.08.878 1.954 1.962 1.954h17.77c1.083 0 1.96-.875 1.96-1.954V26.132ZM31.97 59.592a1.914 1.914 0 0 0 1.918-1.91c0-1.056-.859-1.911-1.918-1.911a1.914 1.914 0 0 0-1.917 1.91c0 1.056.859 1.912 1.917 1.912Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.857 63.77a2.805 2.805 0 0 0 2.81-2.801h-.143a2.663 2.663 0 0 1-2.667 2.658v.142Zm-17.77 0h17.77v-.143h-17.77v.142Zm-2.81-2.801c0 1.547 1.258 2.8 2.81 2.8v-.142a2.663 2.663 0 0 1-2.668-2.658h-.143Zm0-34.837v34.837h.142V26.132h-.143Zm2.81-2.8a2.805 2.805 0 0 0-2.81 2.8h.142a2.663 2.663 0 0 1 2.667-2.659v-.142Zm17.77 0h-17.77v.142h17.77v-.143Zm2.81 2.8c0-1.547-1.259-2.8-2.81-2.8v.142a2.663 2.663 0 0 1 2.667 2.658h.142Zm0 34.837V26.132h-.143v34.837h.142Zm-2.81-36.72c1.044 0 1.89.843 1.89 1.883h.142c0-1.12-.91-2.026-2.032-2.026v.142Zm-17.77 0h17.77v-.143h-17.77v.142Zm-1.89 1.883c0-1.04.845-1.884 1.89-1.884v-.142a2.029 2.029 0 0 0-2.033 2.026h.142Zm0 34.837V26.132h-.143v34.837h.142Zm1.89 1.883a1.887 1.887 0 0 1-1.89-1.883h-.143c0 1.119.91 2.025 2.033 2.025v-.142Zm17.77 0h-17.77v.142h17.77v-.142Zm1.89-1.883c0 1.04-.846 1.883-1.89 1.883v.142a2.029 2.029 0 0 0 2.032-2.025h-.142Zm0-34.837v34.837h.142V26.132h-.142Zm-8.93 31.55c0 1.016-.826 1.84-1.846 1.84v.142a1.985 1.985 0 0 0 1.989-1.982h-.142Zm-1.846-1.84c1.02 0 1.847.824 1.847 1.84h.142c0-1.095-.89-1.982-1.989-1.982v.142Zm-1.846 1.84c0-1.016.827-1.84 1.846-1.84V55.7a1.985 1.985 0 0 0-1.988 1.982h.142Zm1.846 1.84a1.843 1.843 0 0 1-1.846-1.84h-.142c0 1.095.89 1.982 1.988 1.982v-.142Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.655 47.048a1.402 1.402 0 0 1-1.409-1.395V30.466c0-.771.63-1.396 1.41-1.396h8.96c.778 0 1.409.625 1.409 1.396v15.187c0 .77-.631 1.395-1.41 1.395h-8.959Zm7.47-.749h1.49a.65.65 0 0 0 .653-.646V30.466a.65.65 0 0 0-.653-.647h-8.959a.649.649 0 0 0-.653.647v15.187c0 .357.291.646.652.646h6.713v-6.252c0-.206.17-.374.378-.374.21 0 .378.167.378.374V46.3Zm-5.934-9.66V32.04c0-.356.297-.645.664-.645h2.391c.367 0 .664.288.664.646v4.597a.655.655 0 0 1-.664.646h-2.391a.656.656 0 0 1-.664-.646Zm.79-.123h2.14v-4.353h-2.14v4.353Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.124 46.3h-.07v.07h.07v-.07Zm-.756 0v.07h.07v-.07h-.07Zm-2.247-9.784v.071h.07v-.071h-.07Zm-2.14 0h-.072v.071h.071v-.071Zm2.14-4.353h.07v-.07h-.07v.07Zm-2.14 0v-.07h-.072v.07h.071Zm-3.806 13.49c0 .81.663 1.467 1.48 1.467v-.143a1.33 1.33 0 0 1-1.338-1.324h-.142Zm0-15.187v15.187h.142V30.466h-.142Zm1.48-1.467c-.817 0-1.48.656-1.48 1.467h.142a1.33 1.33 0 0 1 1.338-1.325V29Zm7.091 0h-7.09v.142h7.09V29Zm1.87 0h-1.87v.142h1.87V29Zm1.48 1.467c0-.811-.663-1.467-1.48-1.467v.142c.74 0 1.338.594 1.338 1.325h.142Zm0 15.187V30.466h-.142v15.187h.142Zm-1.48 1.467c.816 0 1.48-.656 1.48-1.467h-.142c0 .73-.599 1.324-1.339 1.324v.143Zm-1.87 0h1.87v-.143h-1.87v.143Zm-7.09 0h7.09v-.143h-7.09v.143Zm8.96-.892h-1.492v.142h1.491v-.142Zm.581-.575c0 .317-.26.575-.582.575v.142c.4 0 .724-.32.724-.717h-.142Zm0-15.187v15.187h.142V30.466h-.142Zm-.582-.576c.322 0 .582.258.582.576h.142a.72.72 0 0 0-.724-.718v.142Zm-1.869 0h1.87v-.142h-1.87v.142Zm-7.09 0h7.09v-.142h-7.09v.142Zm-.582.576c0-.318.26-.576.581-.576v-.142a.72.72 0 0 0-.723.718h.142Zm0 15.187V30.466h-.142v15.187h.142Zm.581.575a.578.578 0 0 1-.581-.575h-.142a.72.72 0 0 0 .723.717v-.142Zm6.713 0h-6.713v.142h6.713v-.142Zm-.071-6.18v6.251h.142v-6.252h-.142Zm.45-.446a.448.448 0 0 0-.45.445h.142c0-.166.137-.303.307-.303v-.142Zm.449.445a.448.448 0 0 0-.45-.445v.142c.17 0 .307.136.307.303h.143Zm0 6.252v-6.252h-.143V46.3h.143ZM29.12 32.041v4.597h.142v-4.597h-.142Zm.735-.717a.726.726 0 0 0-.735.716h.142c0-.315.264-.574.593-.574v-.142Zm2.391 0h-2.391v.142h2.391v-.142Zm.735.716a.726.726 0 0 0-.735-.716v.142c.33 0 .593.259.593.575h.142Zm0 4.598v-4.597h-.142v4.597h.142Zm-.735.718c.405 0 .735-.32.735-.718h-.142a.584.584 0 0 1-.593.575v.142Zm-2.391 0h2.391v-.143h-2.391v.142Zm-.735-.718c0 .398.33.718.735.718v-.143a.585.585 0 0 1-.593-.575h-.142Zm3-.193h-2.14v.142h2.14v-.142Zm-.07-4.282v4.353h.142v-4.353h-.142Zm-2.07.072h2.14v-.143h-2.14v.142Zm.071 4.28v-4.352h-.142v4.353h.142Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.346 2.55c3.652.22 6.07 3.313 5.4 6.91a.149.149 0 0 1-.152.118.11.11 0 0 1-.104-.133c.644-3.458-1.68-6.433-5.19-6.644a.11.11 0 0 1-.105-.134.149.149 0 0 1 .151-.118Zm-.588 2.733c2.187.109 3.616 1.939 3.192 4.087a.155.155 0 0 1-.155.121.11.11 0 0 1-.105-.134c.395-2.007-.94-3.716-2.983-3.817a.11.11 0 0 1-.105-.135.156.156 0 0 1 .156-.122Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.745 9.46-.302-.056.302.056Zm-5.399-6.91.019-.308-.019.307Zm5.248 7.028.019-.307-.019.307Zm-.104-.133-.303-.057.303.057ZM49.3 2.8l.018-.308-.019.308Zm-.105-.134.303.057-.303-.057ZM51.95 9.37l-.302-.06.302.06Zm-3.192-4.087-.016.308.016-.308Zm2.931 4.074.303.06-.302-.06ZM48.708 5.54l-.015.307.015-.307Zm6.341 3.977c.704-3.78-1.846-7.044-5.683-7.275l-.037.615c3.467.209 5.75 3.132 5.114 6.547l.606.113Zm-.472.369a.457.457 0 0 0 .472-.37l-.605-.112a.164.164 0 0 1 .059-.1.163.163 0 0 1 .11-.033l-.036.615Zm-.389-.498a.418.418 0 0 0 .389.498l.037-.615c.05.003.103.027.14.075a.196.196 0 0 1 .04.155l-.606-.113Zm-4.906-6.28c3.326.2 5.516 3.005 4.906 6.28l.606.113c.678-3.64-1.78-6.785-5.475-7.008l-.037.616Zm-.389-.497a.418.418 0 0 0 .389.498l.037-.616c.05.003.103.028.14.076a.196.196 0 0 1 .04.155l-.606-.113Zm.473-.37a.457.457 0 0 0-.473.37l.606.113a.163.163 0 0 1-.06.1.163.163 0 0 1-.11.033l.037-.615Zm2.887 7.188c.46-2.332-1.104-4.335-3.48-4.453l-.03.615c2 .1 3.293 1.755 2.906 3.72l.604.118Zm-.473.37a.463.463 0 0 0 .473-.37l-.604-.119a.158.158 0 0 1 .056-.094.157.157 0 0 1 .106-.032l-.03.615Zm-.392-.502a.417.417 0 0 0 .392.502l.03-.615c.05.002.105.026.144.076.038.05.048.108.039.156l-.605-.119Zm-2.695-3.45c1.855.092 3.055 1.628 2.695 3.45l.605.12c.432-2.192-1.039-4.075-3.27-4.185l-.03.615Zm-.392-.502a.417.417 0 0 0 .392.502l.03-.615a.196.196 0 0 1 .143.076c.039.05.049.109.04.157l-.605-.12Zm.473-.37a.463.463 0 0 0-.473.37l.604.12a.157.157 0 0 1-.056.094.157.157 0 0 1-.106.032l.03-.615Z",
    fill: "currentColor"
  }));
};

var SvgDislike104X104 = function SvgDislike104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dislike",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.766 18.07c.955-7.833 6.206-11.143 13.677-11.143h77.512c3.891 0 7.045 3.185 7.045 7.115v38.371c0 3.93-3.154 7.114-7.045 7.114H73.576a1.02 1.02 0 0 1-.076-.003l-1.405.478c-.23.064-.626.19-1.097.357-.692.246-1.45.544-2.25.896a35.316 35.316 0 0 0-6.414 3.64c-6.511 4.67-9.925 10.86-9.925 17.945v16.724c0 .485-.34.901-.811.992-3.85.747-7.672.454-10.557-1.69-2.995-2.219-4.476-6.246-4.476-11.877V68.115a.93.93 0 0 0-.918-.927H10.968a.994.994 0 0 1-.205.021c-2.305 0-4.49-.71-6.338-2.064C1.154 62.763-.523 58.526.145 54.34L5.76 18.17l.006-.1zm68.81 39.437h22.379c2.787 0 5.045-2.28 5.045-5.094V14.042c0-2.814-2.258-5.095-5.045-5.095H69.951a11.055 11.055 0 0 1 4.625 9.014v39.546zM63.698 8.947c4.905.026 8.878 4.054 8.878 9.014v39.746l-1.068.365c-.74.205-2.062.674-3.558 1.33a37.288 37.288 0 0 0-6.775 3.847c-7.02 5.035-10.766 11.827-10.766 19.59v15.873c-3.07.46-6.042.118-8.184-1.473-2.402-1.78-3.66-5.201-3.66-10.25V68.115c0-1.622-1.311-2.947-2.918-2.947H10.763a.992.992 0 0 0-.194.02 8.634 8.634 0 0 1-4.971-1.679c-2.652-1.931-4.028-5.406-3.478-8.852l5.626-36.243.012-.157c.83-6.61 5.136-9.31 11.685-9.31H63.698z",
    clipRule: "evenodd"
  }));
};

var SvgDislike16X16 = function SvgDislike16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dislike",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.936 10.516c-.412 0-.806-.124-1.138-.358a1.897 1.897 0 0 1-.772-1.862L.847 3.24l.004-.068c.166-1.31 1.104-1.88 2.362-1.88h6.501c.136 0 .27.014.397.04a.51.51 0 0 1 .197-.04h4.304c.767 0 1.388.606 1.388 1.352v5.434c0 .745-.622 1.35-1.388 1.35h-3.394l-.168.055c-.326.088-.84.305-1.325.641-.868.6-1.312 1.375-1.312 2.263v2.368a.49.49 0 0 1-.405.477c-.653.122-1.305.074-1.828-.3-.545-.39-.802-1.062-.802-1.958v-2.461H2a.533.533 0 0 1-.064.004zm9.737-2.062h2.939c.214 0 .388-.169.388-.377V2.643c0-.21-.174-.38-.388-.38h-3.19c.16.277.251.595.251.934v5.257zm-1-5.257a.948.948 0 0 0-.959-.934h-6.5c-.808 0-1.276.285-1.367.967l-.006.084-.827 5.135a.94.94 0 0 0 .37.92.941.941 0 0 0 .5.173.521.521 0 0 1 .052-.003h3.66c.43 0 .782.341.782.76v2.674c0 .616.146.997.394 1.175.162.115.389.167.641.168v-1.93c0-1.215.61-2.28 1.732-3.055a5.688 5.688 0 0 1 1.528-.755V3.197z",
    clipRule: "evenodd"
  }));
};

var SvgDislike24X24 = function SvgDislike24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dislike",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M14.69 3.058A.497.497 0 0 1 14.923 3h5.451C21.272 3 22 3.73 22 4.629v7.09c0 .9-.728 1.63-1.626 1.63h-4.319l-.226.075c-.436.123-1.093.41-1.723.859-1.132.805-1.716 1.855-1.716 3.058v3.09a.5.5 0 0 1-.404.492c-.79.155-1.587.095-2.213-.366-.651-.479-.962-1.317-.962-2.448v-3.345H4.383a.504.504 0 0 1-.064.004c-.495 0-.967-.152-1.364-.441-.707-.51-1.067-1.412-.924-2.3l1.042-6.62.004-.072C3.277 3.704 4.402 3 5.937 3h8.233c.179 0 .352.02.52.058zm1.403.944c.269.382.426.848.426 1.351v6.994h3.855c.346 0 .626-.281.626-.628V4.63a.626.626 0 0 0-.626-.627h-4.28zm-.574 1.351a1.35 1.35 0 0 0-1.349-1.351H5.936c-1.083 0-1.738.41-1.863 1.394l-.006.089-1.048 6.699c-.084.521.124 1.044.522 1.331.213.155.459.24.723.25a.505.505 0 0 1 .055-.003h4.635a.86.86 0 0 1 .857.86v3.487c0 .842.2 1.38.554 1.64.26.193.629.264 1.025.242v-2.65c0-1.54.75-2.889 2.137-3.875.727-.518 1.477-.847 1.992-.995V5.353z"
  }));
};

var SvgDislike64X64 = function SvgDislike64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -dislike",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.557 9.876C4.147 5.042 7.385 3 11.993 3h47.653C62.051 3 64 4.938 64 7.328v23.344C64 33.063 62.05 35 59.646 35H45.96a.62.62 0 0 1-.38.37l-1.11.378c-.142.04-.386.118-.677.22-.427.152-.894.336-1.388.553a21.78 21.78 0 0 0-3.956 2.246c-4.016 2.882-6.122 6.702-6.122 11.072v10.32c0 .299-.21.556-.5.612-2.375.46-4.732.28-6.512-1.042-1.848-1.37-2.76-3.855-2.76-7.33V40.755a.573.573 0 0 0-.567-.572H6.766a.612.612 0 0 1-.127.013 6.555 6.555 0 0 1-3.91-1.273C.713 37.452-.322 34.838.09 32.255L3.553 9.937l.004-.061zm41.023 24.52-.473.161c-.456.127-1.271.416-2.194.822a22.999 22.999 0 0 0-4.18 2.373c-4.33 3.107-6.64 7.297-6.64 12.087v9.794c-1.894.284-3.727.073-5.048-.909-1.481-1.098-2.257-3.209-2.257-6.324V40.754c0-1-.81-1.818-1.8-1.818H6.64a.61.61 0 0 0-.12.012 5.324 5.324 0 0 1-3.066-1.036C1.817 36.72.969 34.576 1.308 32.45l3.47-22.362.008-.097c.512-4.078 3.167-5.745 7.207-5.745h27.268c3.039 0 5.505 2.492 5.505 5.562v24.138a.61.61 0 0 0-.186.44v.01zM46 33.77h13.646a3.108 3.108 0 0 0 3.118-3.099V7.328c0-1.712-1.396-3.1-3.118-3.1H43.123A6.822 6.822 0 0 1 46 9.809V33.77z",
    clipRule: "evenodd"
  }));
};

var SvgDocument104X104 = function SvgDocument104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.032 28.317c-.021.13-.032.262-.032.396v68.242c0 3.891 3.18 7.045 7.102 7.045h59.796C85.82 104 89 100.846 89 96.955V7.045C89 3.154 85.82 0 81.898 0H45.153c-.127 0-.252.01-.376.028a1.01 1.01 0 0 0-1.082.43c-.102.072-.2.152-.292.239l-27.62 26.201a2.52 2.52 0 0 0-.268.297.998.998 0 0 0-.483 1.121zm1.984.75v67.888c0 2.787 2.277 5.045 5.086 5.045h59.796c2.809 0 5.086-2.259 5.086-5.045V7.045C86.984 4.259 84.707 2 81.898 2H45.55l-.005 24.558a2.522 2.522 0 0 1-2.531 2.51H17.016zM43.534 3.34 18.52 27.067h24.493c.284 0 .515-.229.515-.51l.005-23.217z",
    clipRule: "evenodd"
  }));
};

var SvgDocument16X16 = function SvgDocument16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.503.2-4.03 3.855a.767.767 0 0 0-.034.034.5.5 0 0 0-.187.437.722.722 0 0 0-.002.05v10.036c0 .766.622 1.388 1.39 1.388h8.722c.767 0 1.39-.622 1.39-1.388V1.389A1.39 1.39 0 0 0 12.361 0h-5.36c-.02 0-.037 0-.056.002a.499.499 0 0 0-.405.164.755.755 0 0 0-.033.03L6.503.2zm-.09 1.47L3.996 3.981h2.416v-2.31zM3.25 4.981v9.631c0 .214.174.388.39.388h8.722a.389.389 0 0 0 .39-.388V1.389a.39.39 0 0 0-.39-.389h-4.95v3.258c0 .4-.324.723-.723.723H3.25z",
    clipRule: "evenodd"
  }));
};

var SvgDocument24X24 = function SvgDocument24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.192 7.145a.503.503 0 0 0-.189.453.8.8 0 0 0-.003.064v12.712C5 21.272 5.713 22 6.592 22h10.816c.88 0 1.592-.728 1.592-1.626V3.626C19 2.728 18.288 2 17.408 2h-6.647c-.02 0-.04 0-.06.003a.486.486 0 0 0-.422.172.77.77 0 0 0-.046.042l-4.996 4.88a.759.759 0 0 0-.045.048Zm4.97-3.475L6.71 7.042h3.45l.002-3.372ZM11.14 3l-.001 4.261a.773.773 0 0 1-.766.781H5.98v12.332a.62.62 0 0 0 .613.626h10.816a.62.62 0 0 0 .613-.626V3.626A.62.62 0 0 0 17.408 3h-6.267Z",
    fill: "currentColor"
  }));
};

var SvgDocumentAdd104X104 = function SvgDocumentAdd104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-add",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M72.408 41.124a.996.996 0 0 1-.47-.117 30.347 30.347 0 0 0-.438-.003c-16.843 0-30.497 13.653-30.497 30.495 0 16.844 13.654 30.498 30.497 30.498s30.497-13.655 30.497-30.497c0-16.398-12.943-29.773-29.169-30.468a.997.997 0 0 1-.42.092zm1-2.069V7.045A7.044 7.044 0 0 0 66.364 0H29.912c-.125 0-.25.01-.373.028a1.003 1.003 0 0 0-1.074.43c-.1.072-.197.15-.288.237L.777 26.898a2.495 2.495 0 0 0-.266.297 1 1 0 0 0-.48 1.122c-.02.13-.03.263-.03.396v68.242A7.044 7.044 0 0 0 7.043 104h63.853c.03 0 .06-.001.09-.004.17.003.342.004.513.004 17.95 0 32.5-14.551 32.5-32.5 0-17.309-13.53-31.457-30.592-32.445zM2 29.067v67.888A5.044 5.044 0 0 0 7.044 102H60.25C47.845 97.423 39 85.494 39 71.5 39 53.58 53.501 39.05 71.408 39V7.045A5.044 5.044 0 0 0 66.364 2H30.306L30.3 26.558a2.512 2.512 0 0 1-2.511 2.51H2zM28.305 3.34 3.493 27.067H27.79c.281 0 .51-.229.511-.51l.004-23.217zM71 71H59.985a.992.992 0 0 0-.985.998c0 .552.441.999.985.999H71v11.018c0 .544.448.985 1 .985s1-.441 1-.985V72.997h11.015a.992.992 0 0 0 .985-.999.992.992 0 0 0-.985-.998H73V59.985c0-.544-.448-.985-1-.985s-1 .441-1 .985V71z",
    clipRule: "evenodd"
  }));
};

var SvgDocumentAdd16X16 = function SvgDocumentAdd16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.162 4.258V1h4.95a.39.39 0 0 1 .389.389v4.377A5.124 5.124 0 0 0 7.834 15H1.39A.389.389 0 0 1 1 14.611v-9.63h3.439c.4 0 .723-.324.723-.723zM10.8 16H1.39A1.389 1.389 0 0 1 0 14.611V4.575c0-.017 0-.034.002-.051a.506.506 0 0 1 .186-.434.722.722 0 0 1 .035-.036L4.258.196l.033-.03A.499.499 0 0 1 4.7.003.72.72 0 0 1 4.752 0h5.36a1.39 1.39 0 0 1 1.389 1.389v4.4a5.125 5.125 0 0 1-.7 10.21zm.173-9.247.028.001h.002a4.124 4.124 0 1 1-.03 0zM1.747 3.981l2.416-2.31v2.31H1.746zm9.629 8.918v-1.523h1.522a.5.5 0 0 0 0-1h-1.522V8.854a.5.5 0 0 0-1 0v1.522H8.853a.5.5 0 0 0 0 1h1.523V12.9a.5.5 0 0 0 1 0z",
    clipRule: "evenodd"
  }));
};

var SvgDocumentAdd24X24 = function SvgDocumentAdd24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-add",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.271 7.042H3.747l3.525-3.371v3.371ZM2 7.662c0-.023.001-.045.003-.068a.504.504 0 0 1 .191-.448.763.763 0 0 1 .047-.048l5.107-4.884a.795.795 0 0 1 .043-.037.499.499 0 0 1 .432-.174A.783.783 0 0 1 7.886 2h6.79c.898 0 1.626.728 1.626 1.626V9.32A6.357 6.357 0 0 1 15.52 22H3.626A1.626 1.626 0 0 1 2 20.375V7.662ZM12.22 21a6.358 6.358 0 0 1 3.082-11.705V3.626A.626.626 0 0 0 14.676 3H8.272v4.261a.78.78 0 0 1-.782.781H3v12.332c0 .346.28.626.626.626h8.594Zm3.55-10.713a5.357 5.357 0 1 0 .038.001h-.038Zm.373 7.918v-2.062h2.062a.5.5 0 0 0 0-1h-2.062V13.08a.5.5 0 0 0-1 0v2.062H13.08a.5.5 0 0 0 0 1h2.062v2.062a.5.5 0 0 0 1 0Z",
    fill: "currentColor"
  }));
};

var SvgDocumentCash104X104 = function SvgDocumentCash104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-cash",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M73.408 39.055V7.045A7.044 7.044 0 0 0 66.364 0H29.912c-.125 0-.25.01-.373.028a1.003 1.003 0 0 0-1.074.43c-.1.072-.197.15-.288.237L.777 26.898a2.495 2.495 0 0 0-.266.297 1 1 0 0 0-.48 1.122c-.02.13-.03.263-.03.396v68.242A7.044 7.044 0 0 0 7.043 104h63.853c.03 0 .06-.001.09-.004.17.003.342.004.513.004 17.95 0 32.5-14.551 32.5-32.5 0-17.309-13.53-31.457-30.592-32.445zm-1.47 1.952a.996.996 0 0 0 .89.025c16.226.695 29.169 14.07 29.169 30.468 0 16.843-13.654 30.497-30.497 30.497S41.004 88.343 41.004 71.499c0-16.842 13.653-30.495 30.496-30.495.146 0 .292 0 .438.003zM71.408 39V7.045A5.044 5.044 0 0 0 66.364 2H30.306L30.3 26.558a2.512 2.512 0 0 1-2.511 2.51H2v67.887A5.044 5.044 0 0 0 7.044 102H60.25C47.845 97.423 39 85.494 39 71.5 39 53.58 53.501 39.05 71.408 39zM3.493 27.067 28.306 3.34 28.3 26.556c0 .282-.23.511-.511.511H3.493zM71 56.01v-4.002c0-.557.448-1.008 1-1.008s1 .451 1 1.008v4.107c3.967.612 7.18 3.607 7.87 7.541.098.552-.286 1.076-.857 1.17-.571.094-1.113-.278-1.21-.83-.606-3.445-3.69-5.965-7.303-5.967-4.266 0-7.402 2.683-7.402 6.477 0 3.347 2.764 5.427 7.636 6.504C77.449 72.275 81 74.946 81 79.492c0 4.501-3.378 7.821-8 8.413v4.087c0 .557-.448 1.008-1 1.008s-1-.451-1-1.008v-4.005c-5.014-.251-9-4.263-9-9.175 0-.56.47-1.015 1.049-1.015.58 0 1.049.454 1.049 1.015 0 3.954 3.314 7.16 7.402 7.16 4.268 0 7.402-2.684 7.402-6.48 0-3.348-2.76-5.425-7.636-6.504C65.554 71.725 62 69.05 62 64.506c0-4.818 3.874-8.283 9-8.496z",
    clipRule: "evenodd"
  }));
};

var SvgDocumentCash16X16 = function SvgDocumentCash16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-cash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 4.575c0-.017 0-.034.002-.051a.506.506 0 0 1 .186-.434.722.722 0 0 1 .035-.036L4.258.196l.033-.03A.499.499 0 0 1 4.7.003.72.72 0 0 1 4.752 0h5.36a1.39 1.39 0 0 1 1.389 1.389v4.4a5.125 5.125 0 0 1-.7 10.21h-.012l-.01.001h-9.39A1.389 1.389 0 0 1 0 14.611V4.575zM7.834 15a5.124 5.124 0 0 1 2.667-9.234V1.389A.39.39 0 0 0 10.112 1h-4.95v3.258c0 .399-.324.723-.723.723H1v9.63c0 .215.174.389.389.389h6.445zm3.139-8.247h-.097a4.124 4.124 0 1 0 .127.001h-.03zM1.747 3.981l2.416-2.31v2.31H1.746zm8.629 4.288v-.236a.5.5 0 0 1 1 0v.247a1.688 1.688 0 0 1 1.162 1.328.5.5 0 1 1-.986.167.688.688 0 0 0-.676-.572c-.413 0-.685.242-.685.587 0 .277.254.475.796.599.943.215 1.574.706 1.574 1.573 0 .755-.495 1.332-1.185 1.52v.238a.5.5 0 0 1-1 0v-.247a1.686 1.686 0 0 1-1.185-1.61.5.5 0 0 1 1 0 .686.686 0 0 0 .707.685c.4-.008.663-.247.663-.586 0-.277-.255-.475-.797-.598-.943-.217-1.573-.707-1.573-1.574 0-.754.494-1.332 1.185-1.52z",
    clipRule: "evenodd"
  }));
};

var SvgDocumentCash24X24 = function SvgDocumentCash24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-cash",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.662c0-.023.001-.045.003-.068a.504.504 0 0 1 .191-.448.763.763 0 0 1 .047-.048l5.107-4.884a.795.795 0 0 1 .043-.037.499.499 0 0 1 .432-.174A.783.783 0 0 1 7.886 2h6.79c.898 0 1.626.728 1.626 1.626V9.32A6.357 6.357 0 0 1 15.52 22H3.626A1.626 1.626 0 0 1 2 20.375V7.662ZM12.22 21a6.358 6.358 0 0 1 3.082-11.705V3.626A.626.626 0 0 0 14.676 3H8.272v4.261a.78.78 0 0 1-.782.781H3v12.332c0 .346.28.626.626.626h8.594Zm3.55-10.713a5.357 5.357 0 1 0 .038.001h-.038ZM3.747 7.042l3.525-3.371v3.371H3.746Zm11.396 5.404v-.405a.5.5 0 0 1 1 0v.414c.75.193 1.338.81 1.473 1.603a.5.5 0 0 1-.986.168 1.002 1.002 0 0 0-.987-.834c-.592 0-1 .361-1 .875 0 .429.372.719 1.112.888 1.14.262 1.89.844 1.89 1.864 0 .926-.63 1.627-1.502 1.821v.404a.5.5 0 0 1-1 0v-.412a2.002 2.002 0 0 1-1.5-1.938.5.5 0 0 1 1 0 1.001 1.001 0 0 0 1.02 1c.582-.007.981-.367.981-.875 0-.43-.372-.72-1.113-.89-1.14-.26-1.889-.843-1.889-1.862 0-.926.63-1.627 1.501-1.821Z",
    fill: "currentColor"
  }));
};

var SvgDocumentChecked104X104 = function SvgDocumentChecked104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-checked",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M73.408 7.045v32.01C90.47 40.043 104 54.191 104 71.5 104 89.45 89.45 104 71.5 104c-.171 0-.342-.001-.513-.004a.888.888 0 0 1-.09.004H7.044A7.044 7.044 0 0 1 0 96.955V28.713c0-.133.01-.266.032-.396a1.002 1.002 0 0 1 .479-1.122c.08-.105.168-.204.265-.297L28.177.695c.09-.086.187-.165.288-.237a1 1 0 0 1 1.074-.43c.123-.019.248-.028.373-.028h36.452a7.044 7.044 0 0 1 7.044 7.045zm-1 34.079a.996.996 0 0 1-.47-.117 30.347 30.347 0 0 0-.438-.003c-16.843 0-30.497 13.653-30.497 30.495 0 16.844 13.654 30.498 30.497 30.498s30.497-13.655 30.497-30.497c0-16.398-12.943-29.773-29.169-30.468a.997.997 0 0 1-.42.092zm-1-34.079V39C53.501 39.05 39 53.581 39 71.5c0 13.994 8.845 25.923 21.25 30.5H7.044A5.044 5.044 0 0 1 2 96.955V29.067h25.79a2.512 2.512 0 0 0 2.511-2.51L30.306 2h36.058a5.044 5.044 0 0 1 5.044 5.045zM28.305 3.34 3.493 27.067H27.79c.281 0 .51-.229.511-.51l.004-23.217zM56.303 70.77a1.039 1.039 0 0 1 1.464 0l9.737 9.692 17.682-20.111a1.038 1.038 0 0 1 1.46-.097c.43.374.474 1.025.098 1.453l-18.41 20.94a1.038 1.038 0 0 1-1.511.05l-10.52-10.47a1.027 1.027 0 0 1 0-1.457z",
    clipRule: "evenodd"
  }));
};

var SvgDocumentChecked16X16 = function SvgDocumentChecked16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.002 4.524A.717.717 0 0 0 0 4.575v10.036C0 15.378.622 16 1.389 16h9.487a5.124 5.124 0 0 0 .625-10.21V1.389A1.39 1.39 0 0 0 10.112 0h-5.36A.72.72 0 0 0 4.7.002a.507.507 0 0 0-.41.165.748.748 0 0 0-.032.029L.223 4.054a.722.722 0 0 0-.035.036.5.5 0 0 0-.186.434zm5.75 6.352c0 1.691.819 3.19 2.082 4.124H1.39A.389.389 0 0 1 1 14.611v-9.63h3.439c.4 0 .723-.324.723-.723V1h4.95a.39.39 0 0 1 .389.389v4.377a5.124 5.124 0 0 0-4.749 5.11zm5.124-4.124a4.191 4.191 0 0 1 .125.002h.002a4.124 4.124 0 1 1-.127-.002zM4.163 1.67 1.747 3.98h2.415V1.67zm4.305 8.852a.5.5 0 0 1 .707 0l1.116 1.117 2.264-2.587a.5.5 0 1 1 .752.658l-2.615 2.99a.5.5 0 0 1-.73.024L8.468 11.23a.5.5 0 0 1 0-.708z",
    clipRule: "evenodd"
  }));
};

var SvgDocumentChecked24X24 = function SvgDocumentChecked24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-checked",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.003 7.594A.784.784 0 0 0 2 7.662v12.712C2 21.272 2.728 22 3.626 22H15.52l.034-.001h.09a6.357 6.357 0 0 0 .658-12.68V3.626c0-.898-.728-1.626-1.626-1.626h-6.79c-.021 0-.042 0-.063.003a.503.503 0 0 0-.432.174.795.795 0 0 0-.043.037L2.24 7.098a.763.763 0 0 0-.047.048.5.5 0 0 0-.191.448Zm7.283 8.049c0 2.25 1.17 4.227 2.934 5.357H3.626A.626.626 0 0 1 3 20.374V8.042h4.49a.78.78 0 0 0 .781-.781l.001-4.26h6.404c.346 0 .626.28.626.625v5.669a6.358 6.358 0 0 0-6.016 6.348Zm6.357-5.357a5.306 5.306 0 0 1 .159.002h.005a5.358 5.358 0 1 1-.164-.002ZM7.272 3.67 3.747 7.042H7.27l.001-3.371Zm5.414 11.619a.5.5 0 0 1 .707 0l1.516 1.515 2.961-3.384a.5.5 0 0 1 .753.658l-3.313 3.786a.5.5 0 0 1-.73.025l-1.894-1.893a.5.5 0 0 1 0-.707Z",
    fill: "currentColor"
  }));
};

var SvgDocumentError104X104 = function SvgDocumentError104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-error",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.408 41.124a.996.996 0 0 1-.47-.117 30.347 30.347 0 0 0-.438-.003c-16.843 0-30.496 13.653-30.496 30.495 0 16.844 13.653 30.498 30.496 30.498 16.843 0 30.497-13.654 30.497-30.498 0-16.397-12.942-29.772-29.169-30.467a.997.997 0 0 1-.42.092Zm1-2.069V7.045A7.044 7.044 0 0 0 66.364 0H29.912c-.125 0-.25.01-.372.028a1.003 1.003 0 0 0-1.075.43c-.1.072-.197.15-.288.237L.777 26.898a2.495 2.495 0 0 0-.266.297 1 1 0 0 0-.48 1.122c-.02.13-.03.263-.03.396v68.242A7.044 7.044 0 0 0 7.043 104h63.853c.03 0 .06-.001.09-.004.17.003.342.004.513.004 17.95 0 32.5-14.551 32.5-32.5 0-17.309-13.53-31.457-30.592-32.445ZM2 29.067v67.888A5.044 5.044 0 0 0 7.044 102H60.25C47.845 97.423 39 85.494 39 71.5 39 53.58 53.501 39.05 71.408 39V7.045A5.044 5.044 0 0 0 66.364 2H30.306L30.3 26.558a2.512 2.512 0 0 1-2.511 2.51H2ZM28.305 3.34 3.493 27.067H27.79c.282 0 .51-.229.511-.51l.005-23.217ZM72 70.586l-7.789-7.789a.992.992 0 0 0-1.402.01.992.992 0 0 0-.01 1.402l7.789 7.789-7.791 7.79a.993.993 0 0 0 .01 1.404.993.993 0 0 0 1.404.011l7.791-7.791 7.79 7.789a.992.992 0 0 0 1.401-.01.992.992 0 0 0 .01-1.402L73.414 72l7.789-7.789a.993.993 0 0 0-.01-1.403.993.993 0 0 0-1.404-.011L72 70.586Z",
    fill: "currentColor"
  }));
};

var SvgDocumentError16X16 = function SvgDocumentError16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-error",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.162 4.258V1h4.95a.39.39 0 0 1 .389.389v4.377A5.124 5.124 0 0 0 7.834 15H1.39A.389.389 0 0 1 1 14.611v-9.63h3.439c.4 0 .723-.324.723-.723ZM10.8 16H1.39A1.389 1.389 0 0 1 0 14.611V4.575c0-.017 0-.034.002-.051a.506.506 0 0 1 .186-.434.722.722 0 0 1 .035-.036L4.258.196l.033-.03A.499.499 0 0 1 4.7.003.72.72 0 0 1 4.752 0h5.36a1.39 1.39 0 0 1 1.389 1.389v4.4a5.125 5.125 0 0 1-.7 10.21Zm.173-9.247.028.001h.002a4.124 4.124 0 1 1-.03 0ZM1.747 3.981l2.416-2.31v2.31H1.746Zm10.913 7.972-1.076-1.076L12.66 9.8a.5.5 0 1 0-.707-.707l-1.076 1.077-1.078-1.078a.5.5 0 0 0-.707.707l1.078 1.078-1.077 1.076a.5.5 0 1 0 .707.707l1.077-1.076 1.076 1.076a.5.5 0 0 0 .707-.707Z",
    fill: "currentColor"
  }));
};

var SvgDocumentError24X24 = function SvgDocumentError24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -document-error",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.271 7.042H3.747l3.525-3.371v3.371ZM2 7.662c0-.023.001-.045.003-.068a.504.504 0 0 1 .191-.448.763.763 0 0 1 .047-.048l5.107-4.884a.795.795 0 0 1 .043-.037.499.499 0 0 1 .432-.174A.783.783 0 0 1 7.886 2h6.79c.898 0 1.626.728 1.626 1.626V9.32A6.357 6.357 0 0 1 15.52 22H3.626A1.626 1.626 0 0 1 2 20.375V7.662ZM12.22 21a6.358 6.358 0 0 1 3.082-11.705V3.626A.626.626 0 0 0 14.676 3H8.272v4.261a.78.78 0 0 1-.782.781H3v12.332c0 .346.28.626.626.626h8.594Zm3.55-10.713a5.357 5.357 0 1 0 .038.001h-.038Zm2.037 6.814-1.457-1.458 1.457-1.457a.5.5 0 0 0-.707-.707l-1.457 1.457-1.459-1.458a.5.5 0 1 0-.707.707l1.458 1.458-1.458 1.459a.5.5 0 0 0 .707.707l1.459-1.459 1.457 1.458a.5.5 0 1 0 .707-.707Z",
    fill: "currentColor"
  }));
};

var SvgDownload104X104 = function SvgDownload104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -download",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M73.826 68.372a1.01 1.01 0 0 0 0-1.425 1.006 1.006 0 0 0-1.423 0L53.005 86.374V1.008a1.007 1.007 0 1 0-2.012 0v85.366L31.595 66.947a1.005 1.005 0 0 0-1.423 0 1.01 1.01 0 0 0 0 1.425l21.115 21.149c.393.393 1.03.393 1.424 0l21.115-21.149zM104 71.984a1.001 1.001 0 1 0-2 0v30.013H2V71.984a1 1 0 1 0-2 0v31.319c0 .385.312.697.696.697h102.608a.697.697 0 0 0 .696-.697V71.984z",
    clipRule: "evenodd"
  }));
};

var SvgDownload16X16 = function SvgDownload16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.906 7.47 2.474 2.708V.5c0-.276.232-.5.518-.5s.518.224.518.5v9.736l2.688-2.766a.531.531 0 0 1 .732-.023c.209.189.22.505.024.707l-3.584 3.688a.53.53 0 0 1-.767-.011l-3.38-3.7a.488.488 0 0 1 .046-.705.531.531 0 0 1 .731.044zM16 8.5a.5.5 0 0 0-1 0v6.41c0 .05-.04.09-.09.09H1.09a.09.09 0 0 1-.09-.09V8.5a.5.5 0 0 0-1 0v7.343c0 .087.07.157.157.157h15.686c.087 0 .157-.07.157-.157V8.5z",
    clipRule: "evenodd"
  }));
};

var SvgDownload24X24 = function SvgDownload24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m7.375 11.003 4.125 4.675V2.5a.5.5 0 0 1 1 0v13.236l4.135-4.411a.5.5 0 0 1 .73.684l-5 5.334a.5.5 0 0 1-.74-.011l-5-5.667a.5.5 0 0 1 .75-.662ZM22 12.5a.5.5 0 0 0-1 0v8.384a.115.115 0 0 1-.116.116H3.116A.115.115 0 0 1 3 20.884V12.5a.5.5 0 0 0-1 0v9.304c0 .108.088.196.196.196h19.608a.196.196 0 0 0 .196-.196V12.5Z",
    clipRule: "evenodd"
  }));
};

var SvgEcology104X104 = function SvgEcology104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -ecology",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M51.988 101.931C81.704 90.623 101.32 64.388 102 34.994V7.044A5.05 5.05 0 0 0 96.955 2H7.045A5.05 5.05 0 0 0 2 7.044v27.973c.674 29.366 20.28 55.601 49.988 66.914zM7.045 0h89.91C100.84 0 104 3.16 104 7.044v27.973c-.702 30.353-20.98 57.396-51.66 68.919a1.014 1.014 0 0 1-.703 0C20.964 92.408.695 65.365 0 35.04V7.044C0 3.16 3.16 0 7.045 0zm51.992 63.39-.026.023c-3.595 3.4-5.297 7.384-6.011 9.552v4.853c1.01-.064 2.485-.255 4.338-.762h-.001c4.075-1.118 7.882-3.207 10.72-5.887 3.429-3.234 5.099-7.137 5.895-9.841.555-1.883.749-3.407.812-4.403-3.315.148-10.415 1.45-15.727 6.465zm-28.99-2.063c.798 2.705 2.468 6.608 5.896 9.844 2.839 2.678 6.645 4.767 10.72 5.884h-.001c1.853.508 3.328.699 4.338.764v-4.854c-.714-2.168-2.416-6.151-6.01-9.551a.497.497 0 0 1-.047-.044c-5.293-4.996-12.391-6.297-15.706-6.444.062.996.256 2.52.81 4.402zm0-20.343c.798 2.704 2.468 6.607 5.896 9.843 2.839 2.679 6.645 4.769 10.72 5.886h-.001c1.853.506 3.328.697 4.338.762v-4.854c-.714-2.168-2.416-6.15-6.01-9.55a.497.497 0 0 1-.047-.045c-5.293-4.996-12.391-6.297-15.706-6.444.062.996.256 2.52.81 4.401zM52 12.42c-2.121 2.977-4.941 8.27-4.941 13.364 0 6.077 2.124 10.66 4.94 10.66 2.82 0 4.945-4.583 4.945-10.66 0-5.094-2.822-10.386-4.944-13.364zm7.019 30.643-.007.006c-3.595 3.4-5.297 7.384-6.011 9.552v4.854c1.01-.065 2.485-.256 4.338-.763h-.001c4.075-1.117 7.882-3.207 10.72-5.886 3.429-3.235 5.099-7.138 5.895-9.843.555-1.882.749-3.405.812-4.401-3.315.147-10.415 1.45-15.727 6.464l-.02.017zm-1.152 15.577h-.001c-2.08.57-3.74.773-4.865.836v8.535c1.068-1.944 2.564-4.098 4.662-6.077l.037-.03c6.437-6.039 15.252-7.09 18.125-6.987a1 1 0 0 1 .964.98c.02 1.01-.073 3.13-.918 5.994-.866 2.941-2.687 7.19-6.44 10.732-3.072 2.9-7.18 5.16-11.564 6.36h-.001c-2.08.57-3.74.773-4.865.837v8.194a1 1 0 1 1-2 0v-8.194c-1.126-.064-2.786-.267-4.865-.836h-.001c-4.385-1.201-8.491-3.46-11.564-6.36-3.752-3.542-5.574-7.791-6.44-10.732-.845-2.865-.937-4.985-.918-5.994a1 1 0 0 1 .964-.98c2.87-.108 11.714.95 18.136 6.994l.017.015.009.008c2.099 1.979 3.595 4.133 4.662 6.076v-8.535c-1.126-.063-2.786-.266-4.865-.835h-.001c-4.385-1.202-8.491-3.46-11.564-6.36-3.752-3.542-5.574-7.791-6.44-10.732-.845-2.865-.937-4.986-.918-5.994a1 1 0 0 1 .964-.98c2.87-.102 11.714.95 18.135 6.994a.239.239 0 0 1 .02.018l.006.006c2.099 1.979 3.596 4.133 4.663 6.074v-9.344c-3.544-.782-5.942-5.71-5.942-12.538 0-7.768 5.53-14.867 6.162-15.65.38-.472 1.178-.472 1.559 0 .63.784 6.164 7.883 6.164 15.65 0 6.827-2.4 11.755-5.943 12.538v9.344c1.068-1.941 2.565-4.095 4.663-6.074a.331.331 0 0 1 .036-.032c6.438-6.04 15.252-7.088 18.125-6.986a1 1 0 0 1 .964.98c.02 1.008-.073 3.129-.918 5.994-.866 2.94-2.687 7.19-6.44 10.732-3.072 2.9-7.18 5.158-11.564 6.36z",
    clipRule: "evenodd"
  }));
};

var SvgEcology16X16 = function SvgEcology16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -ecology",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.998 14.965c4.165-1.638 6.906-5.337 7.002-9.474V1.389A.39.39 0 0 0 14.611 1H1.389A.39.39 0 0 0 1 1.389v4.114c.095 4.124 2.834 7.823 6.998 9.462zM1.389 0h13.222A1.39 1.39 0 0 1 16 1.389v4.114c-.106 4.616-3.179 8.72-7.826 10.466a.506.506 0 0 1-.352 0C3.176 14.222.105 10.118 0 5.514V1.389A1.39 1.39 0 0 1 1.389 0zm8.73 10.563a2.904 2.904 0 0 0 .809-1.432c-.478.091-1.135.314-1.651.801a3.097 3.097 0 0 0-.777 1.21v.25a3.423 3.423 0 0 0 1.619-.828zM5.11 9.273c.104.354.323.867.77 1.29a3.433 3.433 0 0 0 1.619.828v-.249a3.092 3.092 0 0 0-.776-1.21c-.517-.487-1.173-.71-1.651-.8.01.044.023.091.038.14zM7.5 8.15a3.097 3.097 0 0 0-.776-1.21c-.517-.487-1.173-.71-1.651-.8a2.9 2.9 0 0 0 .808 1.432 3.436 3.436 0 0 0 1.619.827V8.15zm.874-4.005c0-.444-.175-.913-.374-1.29-.198.376-.374.845-.374 1.29 0 .836.287 1.214.374 1.214.087 0 .374-.378.374-1.214zm2.554 1.994c-.478.091-1.135.314-1.651.801A3.101 3.101 0 0 0 8.5 8.15v.25a3.426 3.426 0 0 0 1.619-.828 2.894 2.894 0 0 0 .809-1.433zm.589-1.054c.265.01.476.224.48.488.005.168-.01.52-.148.99a4.003 4.003 0 0 1-.872 1.544c.213-.028.399-.037.54-.03a.497.497 0 0 1 .48.488c.005.168-.01.52-.148.99a3.909 3.909 0 0 1-1.044 1.735 4.435 4.435 0 0 1-1.848 1.02h-.001a3.853 3.853 0 0 1-.456.092v.894a.499.499 0 1 1-1 0v-.894a3.936 3.936 0 0 1-.456-.093h-.001a4.437 4.437 0 0 1-1.847-1.019 3.887 3.887 0 0 1-1.044-1.736 3.287 3.287 0 0 1-.15-.989.499.499 0 0 1 .482-.488c.143-.004.332.006.545.035a3.986 3.986 0 0 1-.877-1.549 3.296 3.296 0 0 1-.15-.99.5.5 0 0 1 .482-.488c.6-.025 1.93.188 2.926 1.127.02.02.035.039.052.058.012.014.024.029.038.043v-.09c-.531-.297-.874-1.066-.874-2.078 0-.96.53-1.959.985-2.523a.499.499 0 0 1 .779.001c.454.565.984 1.565.984 2.522 0 1.012-.342 1.781-.874 2.077v.091c.015-.015.028-.03.041-.046.016-.018.031-.036.05-.054.996-.94 2.342-1.155 2.926-1.128z",
    clipRule: "evenodd"
  }));
};

var SvgEcology24X24 = function SvgEcology24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -ecology",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M11.5 13.977v-.299a4.731 4.731 0 0 1-.343-.058 3.956 3.956 0 0 1 .003.003c.121.114.235.233.34.354zm1-.299v.3c.105-.122.218-.24.34-.355a4.334 4.334 0 0 1 .003-.003 4.731 4.731 0 0 1-.343.058zm0 2.279v.5a4.25 4.25 0 0 0 .41-.092c.711-.195 1.376-.56 1.866-1.022.5-.472.825-1.064 1.012-1.695.04-.135.071-.266.094-.388-.774.106-1.708.479-2.356 1.09-.5.472-.83 1.037-1.026 1.607zm-1 1.51a5.062 5.062 0 0 1-.675-.138c-.865-.237-1.675-.682-2.287-1.259-.642-.606-1.052-1.35-1.286-2.139a4.11 4.11 0 0 1-.183-1.213.5.5 0 0 1 .482-.488c.316-.011.67.02 1.036.096a4.605 4.605 0 0 1-.05-.046c-.64-.605-1.05-1.349-1.285-2.138a4.11 4.11 0 0 1-.183-1.213.5.5 0 0 1 .482-.488c1.082-.04 2.592.432 3.61 1.392.12.115.234.233.339.355v-.506c-.704-.322-1.107-1.333-1.107-2.565 0-1.08.544-2.275 1.217-3.112a.5.5 0 0 1 .78 0c.673.837 1.217 2.032 1.217 3.112 0 1.232-.403 2.243-1.107 2.565v.506c.105-.122.219-.24.34-.355 1.017-.96 2.527-1.431 3.61-1.392a.5.5 0 0 1 .48.488c.008.335-.049.76-.183 1.214-.233.788-.643 1.532-1.285 2.137l-.05.046c.367-.075.72-.107 1.037-.096a.5.5 0 0 1 .482.488c.007.335-.05.76-.184 1.214-.233.788-.643 1.532-1.285 2.139-.612.576-1.422 1.02-2.287 1.258a5.062 5.062 0 0 1-.675.139v1.24a.5.5 0 1 1-1 0v-1.24zm0-1.01v-.5a3.965 3.965 0 0 0-1.026-1.607c-.648-.611-1.582-.984-2.356-1.09.023.122.054.253.093.388.188.631.514 1.223 1.013 1.695.49.462 1.155.827 1.865 1.021.145.04.282.07.411.093zm1-3.79c.13-.022.267-.052.41-.091.711-.195 1.376-.56 1.866-1.023.5-.471.825-1.063 1.012-1.694.04-.135.071-.266.094-.388-.774.106-1.708.478-2.356 1.09-.5.47-.83 1.036-1.026 1.606v.5zm-1 0v-.5a3.976 3.976 0 0 0-1.026-1.607c-.648-.61-1.582-.983-2.356-1.09.023.123.054.253.093.388.188.632.514 1.224 1.013 1.695.49.463 1.155.828 1.865 1.022.144.04.282.07.411.092zM20.374 2C21.272 2 22 2.728 22 3.626v5.222c-.134 5.782-3.998 10.931-9.826 13.12a.5.5 0 0 1-.352 0C5.995 19.778 2.132 14.628 2 8.836v-5.21C2 2.728 2.728 2 3.626 2h16.748zM21 8.836v-5.21A.626.626 0 0 0 20.374 3H3.626A.626.626 0 0 0 3 3.626v5.199c.122 5.304 3.642 10.054 8.998 12.14 5.357-2.086 8.88-6.835 9.002-12.129zm-9-3.637c-.354.601-.607 1.31-.607 1.918 0 1.019.333 1.672.607 1.672s.607-.653.607-1.672c0-.608-.253-1.317-.607-1.918z"
  }));
};

var SvgEdit104X104 = function SvgEdit104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -edit",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M98.152 5.948c3.298 3.351 5.345 7.35 5.765 11.26.459 4.278-.978 8.248-4.155 11.48L98.178 30.3c-.007.008-.009.019-.017.027L88.015 40.64l-.005.004-.002.003-.002.002-57.27 56.859a.487.487 0 0 1-.023.021l-.002.001a.984.984 0 0 1-.472.246l-27.18 6.161a2.482 2.482 0 0 1-2.345-.708 2.57 2.57 0 0 1-.639-2.399l6.708-27.494c.041-.18.131-.35.268-.49l.001-.002h.001l.002-.003h.001l.001-.002h.001l.001-.002 57.271-56.86 9.842-10.012c.005-.004.006-.01.01-.015l1.611-1.638C78.965 1.078 82.868-.385 87.077.087c3.843.428 7.776 2.51 11.075 5.861zM86.86 2.108c3.393.378 6.9 2.252 9.88 5.28 2.975 3.024 4.819 6.59 5.189 10.041.392 3.644-.846 7.04-3.58 9.821l-.899.914L76.31 6.665l.9-.915c2.728-2.782 6.067-4.043 9.65-3.641zm.458 36.366L66.433 16.713l8.463-8.607L96.04 29.608l-8.723 8.866zM30.054 95.342 9.171 73.581l55.84-55.439 20.883 21.76-55.84 55.438zm-27.908 6.466c.06.062.223.206.478.144l25.444-5.768L8.296 75.582l-6.28 25.738a.52.52 0 0 0 .13.488z",
    clipRule: "evenodd"
  }));
};

var SvgEdit16X16 = function SvgEdit16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.036.979c.542.55.88 1.213.95 1.869.08.74-.167 1.425-.713 1.98l-.23.234c-.003.002-.003.004-.005.006l-1.492 1.515-.002.002v.001l-.002.001-8.422 8.357a.503.503 0 0 1-.248.134l-3.993.906a.711.711 0 0 1-.675-.206.739.739 0 0 1-.183-.689l.986-4.035a.505.505 0 0 1 .137-.248l.002-.002 8.42-8.355L11.01.982l.001-.002.001-.001.237-.241C11.722.255 12.306 0 12.934 0h.002c.733 0 1.48.348 2.1.979zm-2.1.037c.466 0 .96.241 1.393.681.382.388.616.835.662 1.262.041.376-.072.716-.318 1.02l-2.58-2.621c.256-.212.535-.342.842-.342zm.261 4.486L10.62 2.816l.748-.76 2.61 2.653-.78.793zm-8.418 8.36-2.578-2.684 7.706-7.646 2.578 2.683-7.706 7.648zm-3.016-1.686L1.1 14.891l2.686-.608-2.023-2.107z",
    clipRule: "evenodd"
  }));
};

var SvgEdit24X24 = function SvgEdit24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.573 2.02c.788.088 1.587.507 2.252 1.182 1.446 1.47 1.57 3.394.3 4.685l-.294.3c-.001 0-.002 0-.002.002l-.002.002-1.89 1.921-.001.001v.001l-.002.001v.001L8.262 20.7h-.001a.503.503 0 0 1-.248.135l-5.062 1.147a.768.768 0 0 1-.728-.22.798.798 0 0 1-.2-.748l1.25-5.114a.507.507 0 0 1 .134-.245l.002-.002h.001L14.081 5.067l1.833-1.864.3-.306c.661-.672 1.48-.983 2.359-.878Zm1.894 5.087-3.484-3.54c.43-.411.923-.592 1.482-.537.562.063 1.148.379 1.652.891.793.804 1.34 2.111.35 3.186Zm-1.88 1.924-3.452-3.596L16.27 4.28l3.496 3.551-1.179 1.199Zm-14.12 6.993L7.92 19.62l9.956-9.875-3.453-3.594-9.956 9.874ZM3.08 20.911l.95-3.888 2.897 3.017-3.847.871Z",
    clipRule: "evenodd"
  }));
};

var SvgExclamation16X16 = function SvgExclamation16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    role: "img",
    className: "icon -exclamation",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.212 2.91A.5.5 0 0 0 7.22 3v8l.008.09A.5.5 0 0 0 8.22 11V3l-.008-.09ZM7.75 13.923a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    fill: "currentColor"
  })));
};

var SvgExclamation24X24 = function SvgExclamation24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -exclamation",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(11 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.05,
    cy: 18.75,
    r: 0.5,
    fill: "currentColor",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M1 .5v15"
  })));
};

var SvgExit16X16 = function SvgExit16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -exit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.5 0a.5.5 0 1 0 0 1h6.41c.05 0 .09.04.09.09v13.82c0 .05-.04.09-.09.09H8.5a.5.5 0 0 0 0 1h7.343c.087 0 .157-.07.157-.157V.157A.157.157 0 0 0 15.843 0H8.5zM7.47 11.094l2.708-2.474H.5c-.276 0-.5-.232-.5-.518s.224-.518.5-.518h9.736L7.47 4.896a.531.531 0 0 1-.023-.732.488.488 0 0 1 .707-.024l3.688 3.584a.53.53 0 0 1-.011.767l-3.7 3.38a.488.488 0 0 1-.705-.046.531.531 0 0 1 .044-.731z",
    clipRule: "evenodd"
  }));
};

var SvgExit24X24 = function SvgExit24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -exit"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-7.5a.5.5 0 1 1 0-1h7.2a1.3 1.3 0 0 0 1.3-1.3V4.3A1.3 1.3 0 0 0 19.7 3h-7.2a.5.5 0 1 1 0-1H20zm-8.698 4.658a.5.5 0 0 1 .707-.023l5.334 5a.5.5 0 0 1-.011.74l-5.667 5a.5.5 0 0 1-.662-.75L15.68 12.5H2.5a.5.5 0 1 1 0-1h13.236l-4.411-4.135a.5.5 0 0 1-.023-.707z"
  }));
};

var SvgExpand104X104 = function SvgExpand104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 100,
    height: 104,
    viewBox: "0 0 100 104",
    fill: "currentColor",
    className: "icon -expand",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.515 103.958a.518.518 0 0 1-.518-.52l.231-96.934a.52.52 0 1 1 1.038.003l-.23 96.933a.519.519 0 0 1-.521.518Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.267 47.216a.52.52 0 0 1 .52.52v55.745a.52.52 0 0 1-1.039 0V47.735a.52.52 0 0 1 .52-.519Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 103.5a.5.5 0 0 1 .5-.5h89.678a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22 6.508a.52.52 0 0 1 .52-.519h55.325a.519.519 0 1 1 0 1.038H4.739a.519.519 0 0 1-.519-.519Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.492 0c.276 0 .502.224.504.5.002.276-.22.5-.496.5H72.508a.505.505 0 0 1-.504-.5.495.495 0 0 1 .496-.5h25.992Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.038 26.86a.52.52 0 1 1-1.038 0V.52a.519.519 0 1 1 1.038 0v26.34Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.796 30.802a.526.526 0 0 1-.738.015.512.512 0 0 1-.015-.73L97.555.674c.2-.206.53-.213.738-.016a.512.512 0 0 1 .015.73L69.796 30.802Z",
    fill: "currentColor"
  }));
};

var SvgExpand16X16 = function SvgExpand16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "currentColor",
    className: "icon -expand",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.366-.174h-3.914l.008 1h2.978L7.556 6.2l.674.738 5.64-5.15v2.779h1V0h-.503l-.002-.174Zm-5.54 1.305H.5V15.5h13.391v-8h-1v7H1.5V2.13h7.326v-1Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.667,
    height: 16,
    fill: "currentColor"
  }))));
};

var SvgExpand24X24 = function SvgExpand24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: "icon -expand",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.759 1-9.526 8.702.674.739L22 2.135V7h1V0h-6.504l.008 1h5.255ZM14 2H1.5v21.5h20v-12h-1v11h-18V3H14V2Z"
  }));
};

var SvgExpand64X64 = function SvgExpand64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 64,
    height: 66,
    viewBox: "0 0 64 66",
    fill: "currentColor",
    className: "icon -expand",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.535 30.922c.295 0 .534.239.534.534v33.773a.536.536 0 0 1-1.069.002V31.458c0-.295.24-.535.535-.535Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.178 65.5a.5.5 0 0 1 .5-.5h54a.5.5 0 1 1 0 1h-54a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.188 5.176c0-.295.24-.534.535-.534h33.106a.534.534 0 1 1 0 1.069H3.723a.534.534 0 0 1-.535-.535Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.486.774a.54.54 0 0 1 .539.534.53.53 0 0 1-.53.535H44.313a.54.54 0 0 1-.539-.535.53.53 0 0 1 .53-.534h15.182Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.067 16.962a.535.535 0 1 1-1.069 0V1.308a.535.535 0 1 1 1.07 0v15.654Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.963 19.088a.535.535 0 0 1-.746-.766L58.703 1.313a.535.535 0 1 1 .745.766L41.963 19.088Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.712 65.558a.53.53 0 0 1-.535-.53V5.465a.54.54 0 0 1 .535-.539.53.53 0 0 1 .534.53v59.563a.54.54 0 0 1-.534.54Z",
    fill: "currentColor"
  }));
};

var SvgFashion104X104 = function SvgFashion104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -fashion",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.82.34a1 1 0 0 1 1.212-.227l31.43 16.38c.441.23.646.749.482 1.218l-8.896 25.314a1 1 0 0 1-.943.668H80.872V103a1 1 0 0 1-1 1H22.35a1 1 0 0 1-1-1V43.693H8.709a1 1 0 0 1-.956-.708L.043 17.67a1 1 0 0 1 .508-1.185L33.168.106a1 1 0 0 1 1.197.231c5.821 6.578 11.95 9.906 18.02 9.993 6.06.088 12.326-3.052 18.434-9.99ZM2.201 17.894 9.45 41.693H22.35a1 1 0 0 1 1 1V102h55.523V42.693a1 1 0 0 1 1-1h13.524l8.373-23.827-29.972-15.62c-6.194 6.815-12.79 10.18-19.44 10.084-6.636-.095-13.074-3.633-18.974-10.094L2.203 17.895Z",
    fill: "currentColor0"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  }))));
};

var SvgFashion16X16 = function SvgFashion16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -fashion",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.503.17a.5.5 0 0 1 .606-.113l4.622 2.408a.5.5 0 0 1 .24.61l-1.307 3.722a.5.5 0 0 1-.472.334h-1.593V15.5a.5.5 0 0 1-.5.5h-8.46a.5.5 0 0 1-.5-.5V7.131H1.635a.5.5 0 0 1-.479-.354L.022 3.054a.5.5 0 0 1 .254-.592L5.072.053a.5.5 0 0 1 .599.116c.817.923 1.632 1.34 2.39 1.35.755.011 1.585-.376 2.442-1.35ZM1.1 3.166l.903 2.965H3.64a.5.5 0 0 1 .5.5V15h7.459V6.631a.5.5 0 0 1 .5-.5h1.739l1.047-2.98-3.9-2.031c-.905.921-1.899 1.414-2.938 1.4-1.031-.016-1.999-.53-2.86-1.405L1.1 3.166Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
};

var SvgFashion24X24 = function SvgFashion24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -fashion",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.27 2.17a.5.5 0 0 1 .607-.113l5.854 3.05a.5.5 0 0 1 .24.61l-1.656 4.715a.5.5 0 0 1-.472.334h-2.151V21.5a.5.5 0 0 1-.5.5H6.477a.5.5 0 0 1-.5-.5V10.766h-2.04a.5.5 0 0 1-.48-.354L2.023 5.697a.5.5 0 0 1 .254-.593l6.075-3.05a.5.5 0 0 1 .6.115c1.05 1.186 2.114 1.74 3.125 1.755 1.007.015 2.093-.504 3.194-1.754ZM3.101 5.809l1.206 3.957h2.17a.5.5 0 0 1 .5.5V21h9.715V10.266a.5.5 0 0 1 .5-.5h2.297l1.396-3.972-5.13-2.673c-1.148 1.196-2.398 1.822-3.693 1.803-1.287-.018-2.505-.673-3.598-1.808L3.1 5.809Z",
    fill: "currentColor"
  }));
};

var SvgFashion64X64 = function SvgFashion64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -fashion",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.712.17a.5.5 0 0 1 .606-.113l19.413 10.116a.5.5 0 0 1 .24.61l-5.493 15.635a.5.5 0 0 1-.472.334h-8.29V63.5a.5.5 0 0 1-.5.5h-35.53a.5.5 0 0 1-.5-.5V26.752H5.262a.5.5 0 0 1-.479-.354L.022 10.762a.5.5 0 0 1 .254-.592L20.42.053a.5.5 0 0 1 .599.116c3.608 4.077 7.423 6.157 11.216 6.212 3.789.054 7.69-1.91 11.476-6.211ZM1.102 10.874l4.53 14.878h8.054a.5.5 0 0 1 .5.5V63h34.53V26.252a.5.5 0 0 1 .5-.5h8.436l5.233-14.892L44.2 1.123c-3.829 4.239-7.894 6.316-11.98 6.257-4.076-.058-8.046-2.244-11.693-6.262L1.101 10.874Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  }))));
};

var SvgFastFood104X104 = function SvgFastFood104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -fast-food",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 82.206h69.314V100a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V82.206Z",
    stroke: "#3FA110",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.566 73.064s40.537-8.954 33.78 0c-6.755 8.956 30.403 0 30.403 0",
    stroke: "#3FA110",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 64.551H.664C.614 51.137 5.04 36 37 36c28.995 0 34 15.042 34 28.551Z",
    stroke: "#3FA110",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.281 46.607c0-1.799 1.393-4.07 2.377-4.07.985 0 2.378 2.271 2.378 4.07 0 1.798-1.393 2.442-2.378 2.442-.984 0-2.377-.644-2.377-2.442Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.445 42.322a.937.937 0 0 0-1.766 0c-.605 1.598-1.24 3.47-.9 3.47h3.566c.34 0-.295-1.872-.9-3.47Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.051 51.084c0 1.798-1.392 4.07-2.377 4.07-.985 0-2.377-2.272-2.377-4.07 0-1.799 1.392-2.442 2.377-2.442.985 0 2.377.643 2.377 2.442Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.016 51.084c0 1.798-1.392 4.07-2.377 4.07-.985 0-2.377-2.272-2.377-4.07 0-1.799 1.392-2.442 2.377-2.442.985 0 2.377.643 2.377 2.442Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.85 55.369a.937.937 0 0 0 1.767 0c.604-1.599 1.24-3.471.9-3.471H14.95c-.34 0 .295 1.872.9 3.47Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.886 55.369a.937.937 0 0 0 1.766 0c.605-1.599 1.24-3.471.9-3.471h-3.566c-.34 0 .295 1.872.9 3.47Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.752 103h11.593a2 2 0 0 0 1.951-1.56l15.442-68.536a2 2 0 0 0-1.951-2.44H57.23",
    stroke: "#3FA110",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.742 29.855V1.647",
    stroke: "#3FA110",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.515 42.07H70.801",
    stroke: "#3FA110",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  }))));
};

var SvgFastFood16X16 = function SvgFastFood16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -fast-food",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.836 12.942h9.889a3.008 3.008 0 0 1-2.966 2.507H3.801a3.008 3.008 0 0 1-2.965-2.507Z",
    stroke: "#3FA110",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.84 11.085s6.236-1.378 5.197 0c-1.04 1.378 4.677 0 4.677 0",
    stroke: "#3FA110",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22 7.645c0 .277-.215.627-.366.627-.152 0-.366-.35-.366-.627 0-.276.214-.375.366-.375.151 0 .366.099.366.375Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.414 6.956c0-.276.214-.626.366-.626.151 0 .365.35.365.626 0 .277-.214.376-.365.376-.152 0-.366-.099-.366-.376Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.071 7.645c0 .277-.214.627-.365.627-.152 0-.366-.35-.366-.627 0-.276.214-.375.366-.375.151 0 .365.099.365.375Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.944 15.47h.921a2 2 0 0 0 1.95-1.554l1.596-6.959a2 2 0 0 0-1.95-2.447H9.68",
    stroke: "#3FA110",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.406 4.291V.577",
    stroke: "#3FA110",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.167 6.264h-3.311",
    stroke: "#3FA110",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9.281H.559c-.008-1.991.65-4.238 5.394-4.238C10.257 5.043 11 7.276 11 9.281Z",
    stroke: "#3FA110",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
};

var SvgFastFood24X24 = function SvgFastFood24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -fast-food",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.602 18.74h16.457V20a4 4 0 0 1-4 4H4.602a4 4 0 0 1-4-4v-1.26Zm1 1V20a3 3 0 0 0 3 3h8.457a3 3 0 0 0 3-3v-.26H1.602Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.534 17.349a.5.5 0 1 1-.216-.977l.108.489-.108-.489.007-.001.021-.005.08-.017.297-.063c.255-.053.617-.126 1.047-.207.858-.163 1.99-.359 3.078-.49 1.071-.129 2.155-.202 2.886-.095.187.028.37.07.534.136.16.064.337.166.465.336.142.188.19.413.15.64-.036.207-.14.393-.262.556-.013.016-.023.03-.032.044.04.012.09.023.153.033.502.084 1.36.03 2.337-.099a39.983 39.983 0 0 0 2.741-.478 52.31 52.31 0 0 0 1.207-.265l.07-.017.018-.004.005-.001.117.486.117.486-.006.002-.02.004-.072.017-.274.063c-.233.053-.565.127-.959.208a40.98 40.98 0 0 1-2.813.49c-.972.13-1.965.205-2.632.095a1.948 1.948 0 0 1-.499-.144.968.968 0 0 1-.432-.37c-.254-.42-.046-.858.175-1.152l.017-.023a1.654 1.654 0 0 0-.25-.053c-.585-.087-1.548-.031-2.62.098a47.16 47.16 0 0 0-3.013.48 60.426 60.426 0 0 0-1.32.265l-.077.016-.02.005h-.005Zm14.703-.488.117.486a.5.5 0 1 0-.234-.972l.117.486Zm-6.763.3h.001Zm.06.142-.004.011.003-.011Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.992 11.789c0 .415-.322.94-.549.94-.227 0-.548-.525-.548-.94 0-.415.32-.564.548-.564.227 0 .549.149.549.564Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.281 10.755c0-.415.322-.94.549-.94.227 0 .548.525.548.94 0 .415-.321.564-.548.564-.227 0-.549-.149-.549-.564Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.769 11.789c0 .415-.321.94-.549.94-.227 0-.548-.525-.548-.94 0-.415.321-.564.548-.564.228 0 .549.149.549.564Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.871 6.904a.5.5 0 0 1 .5-.5h8.09a2.5 2.5 0 0 1 2.43 3.086l-3.036 12.596A2.5 2.5 0 0 1 18.425 24H16.5a.5.5 0 0 1 0-1h1.924a1.5 1.5 0 0 0 1.459-1.148l3.036-12.596a1.5 1.5 0 0 0-1.459-1.852h-8.089a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.172.157a.5.5 0 0 1 .5.5v5.918a.5.5 0 0 1-1 0V.657a.5.5 0 0 1 .5-.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3 9.534a.5.5 0 0 1 .5-.5h6.435a.5.5 0 1 1 0 1h-6.434a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.032 8.915C3.416 7.69 5.562 7.07 8.609 7.07c3.034 0 5.18.617 6.566 1.842C16.577 10.149 17.11 11.92 17.11 14v.5h-17V14c0-2.074.525-3.845 1.923-5.085ZM1.121 13.5h14.977c-.08-1.67-.575-2.947-1.584-3.838C13.39 8.67 11.536 8.07 8.608 8.07c-2.941 0-4.795.602-5.914 1.594-1.006.892-1.495 2.168-1.574 3.836Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))));
};

var SvgFastFood64X64 = function SvgFastFood64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -fast-food",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.441 50.806h42.22v2.528c0 5.43-4.403 9.833-9.834 9.833H12.275c-5.431 0-9.834-4.403-9.834-9.833v-2.528Zm1 1v1.528a8.833 8.833 0 0 0 8.834 8.833h22.552a8.833 8.833 0 0 0 8.833-8.833v-1.528H3.441Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.913 45.45-.108-.488-.108-.488.019-.004.054-.012.209-.045a162.102 162.102 0 0 1 3.566-.717c2.278-.431 5.279-.95 8.153-1.297 2.857-.344 5.646-.525 7.473-.256.462.068.881.167 1.234.31.35.14.67.338.887.626.23.305.313.67.245 1.06-.064.371-.26.747-.545 1.124-.493.654-.42.926-.36 1.023.044.074.144.172.354.27.209.096.494.178.858.238 1.477.245 3.878.084 6.479-.26 2.581-.343 5.296-.857 7.37-1.286a139.394 139.394 0 0 0 3.24-.712l.188-.044.048-.012.015-.004.086.354-.086-.354a.5.5 0 0 1 .235.972l-.097-.402.097.402-.017.005-.05.011-.192.046a140.032 140.032 0 0 1-3.265.717c-2.084.431-4.826.95-7.441 1.297-2.596.345-5.133.528-6.774.257a4.382 4.382 0 0 1-1.115-.319c-.318-.147-.607-.356-.79-.66-.396-.656-.128-1.416.419-2.14.234-.312.331-.54.358-.694.023-.134-.004-.215-.058-.287-.067-.088-.205-.197-.463-.301a4.5 4.5 0 0 0-1.005-.248c-1.68-.247-4.349-.084-7.208.26-2.843.343-5.819.857-8.087 1.287a161.986 161.986 0 0 0-3.748.756l-.053.012-.017.003Zm-.596-.38a.5.5 0 0 1 .38-.596l.108.488.108.488a.5.5 0 0 1-.596-.38Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.312 31.436c0 1.108-.856 2.506-1.462 2.506s-1.463-1.398-1.463-2.506c0-1.106.857-1.502 1.463-1.502.606 0 1.462.396 1.462 1.502Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.086 28.68c0-1.106.857-2.504 1.463-2.504.606 0 1.463 1.398 1.463 2.505 0 1.106-.857 1.503-1.463 1.503-.606 0-1.463-.397-1.463-1.503Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.719 31.436c0 1.108-.857 2.506-1.463 2.506-.606 0-1.463-1.398-1.463-2.506 0-1.106.857-1.502 1.463-1.502.606 0 1.463.396 1.463 1.502Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.233 63.241h6.871c.554 0 1.035-.402 1.156-.968l9.152-42.518c.167-.776-.397-1.514-1.156-1.514H36.44",
    stroke: "#3FA110",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.457 1.251a.5.5 0 0 1 .5.5v15.783a.5.5 0 1 1-1 0V1.751a.5.5 0 0 1 .5-.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3 25.424a.5.5 0 0 1 .5-.5h17.16a.5.5 0 1 1 0 1H44.8a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.975 24.398c3.47-3.074 8.95-4.71 16.987-4.71 8 0 13.48 1.63 16.958 4.702 3.493 3.084 4.876 7.534 4.876 12.943v.5H1.129v-.5c0-5.397 1.362-9.847 4.846-12.935ZM2.133 36.833h41.658c-.083-5.008-1.435-8.959-4.533-11.693-3.214-2.838-8.402-4.453-16.296-4.453-7.932 0-13.119 1.62-16.323 4.46-3.089 2.736-4.424 6.686-4.506 11.686Z",
    fill: "currentColor"
  }));
};

var SvgFeedbackError104X104 = function SvgFeedbackError104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-error",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M104 52c0-28.72-23.28-52-52-52S0 23.28 0 52c0 8.834 2.207 17.351 6.357 24.934a52.228 52.228 0 0 0 12.6 15.22C28.197 99.767 39.774 104 52 104c28.72 0 52-23.28 52-52zM2 52C2 24.385 24.385 2 52 2s50 22.385 50 50-22.385 50-50 50c-11.758 0-22.886-4.07-31.771-11.39A50.229 50.229 0 0 1 8.11 75.974C4.121 68.684 2 60.496 2 52zm48.574 0L31.295 71.28a1.008 1.008 0 0 0 1.426 1.425L52 53.425l19.28 19.28a1.008 1.008 0 0 0 1.425-1.426L53.425 52l19.28-19.28a1.008 1.008 0 0 0-1.426-1.425L52 50.575l-19.28-19.28a1.008 1.008 0 0 0-1.425 1.426L50.575 52z",
    clipRule: "evenodd"
  }));
};

var SvgFeedbackError16X16 = function SvgFeedbackError16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-error",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8c0-4.42-3.58-8-8-8a7.999 7.999 0 0 0-5.084 14.177A7.966 7.966 0 0 0 8 16c4.42 0 8-3.58 8-8ZM1 8c0-3.867 3.133-7 7-7s7 3.133 7 7-3.133 7-7 7a6.966 6.966 0 0 1-4.448-1.595 7.025 7.025 0 0 1-1.697-2.05A6.96 6.96 0 0 1 1 8Zm6.293 0-2.564 2.563a.5.5 0 0 0 .708.708L8 8.707l2.563 2.564a.5.5 0 0 0 .708-.708L8.707 8l2.564-2.563a.5.5 0 0 0-.708-.708L8 7.293 5.437 4.729a.5.5 0 1 0-.708.708L7.293 8Z",
    fill: "currentColor"
  }));
};

var SvgFeedbackError24X24 = function SvgFeedbackError24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-error",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.96 9.96 0 0 0 1.222 4.795 10.069 10.069 0 0 0 2.423 2.927A9.965 9.965 0 0 0 12 22c5.523 0 10-4.477 10-10ZM3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 8.965 8.965 0 0 1-5.72-2.05 9.07 9.07 0 0 1-2.18-2.635A8.96 8.96 0 0 1 3 12Zm8.326 0L8.14 15.186a.477.477 0 1 0 .674.674L12 12.674l3.186 3.186a.477.477 0 1 0 .674-.674L12.674 12l3.186-3.186a.477.477 0 1 0-.674-.674L12 11.326 8.814 8.14a.477.477 0 1 0-.674.674L11.326 12Z",
    fill: "currentColor"
  }));
};

var SvgFeedbackInfo104X104 = function SvgFeedbackInfo104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-info",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104,
    "aria-label": "\\xCDcone de Feedback de Informa\\xE7\\xE3o"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M104 52c0-28.72-23.28-52-52-52S0 23.28 0 52c0 8.834 2.207 17.351 6.357 24.934a52.228 52.228 0 0 0 12.6 15.22C28.197 99.767 39.774 104 52 104c28.72 0 52-23.28 52-52zM2 52C2 24.385 24.385 2 52 2s50 22.385 50 50-22.385 50-50 50c-11.758 0-22.886-4.07-31.771-11.39A50.229 50.229 0 0 1 8.11 75.974C4.121 68.684 2 60.496 2 52zm49-7.922V78.34a1 1 0 1 0 2 0V44.08a1 1 0 1 0-2 0zm1-16.459a2.292 2.292 0 1 1 0 4.584 2.292 2.292 0 0 1 0-4.584z",
    clipRule: "evenodd"
  }));
};

var SvgFeedbackInfo16X16 = function SvgFeedbackInfo16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-info",
    "aria-label": "\\xCDcone de Feedback de Informa\\xE7\\xE3o",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 8c0-4.42-3.58-8-8-8a7.999 7.999 0 0 0-5.084 14.177A7.966 7.966 0 0 0 8 16c4.42 0 8-3.58 8-8zM1 8c0-3.867 3.133-7 7-7s7 3.133 7 7-3.133 7-7 7a6.966 6.966 0 0 1-4.448-1.595 7.025 7.025 0 0 1-1.697-2.05A6.96 6.96 0 0 1 1 8zm6.5-1.165v5.038a.5.5 0 0 0 1 0V6.835a.5.5 0 0 0-1 0zM8 4.127a.625.625 0 1 1 0 1.25.625.625 0 0 1 0-1.25z",
    clipRule: "evenodd"
  }));
};

var SvgFeedbackInfo24X24 = function SvgFeedbackInfo24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-info",
    "aria-label": "\\xCDcone de Feedback de Informa\\xE7\\xE3o",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.96 9.96 0 0 0 1.222 4.795 10.069 10.069 0 0 0 2.423 2.927A9.965 9.965 0 0 0 12 22c5.523 0 10-4.477 10-10ZM3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 8.965 8.965 0 0 1-5.72-2.05 9.07 9.07 0 0 1-2.18-2.635A8.96 8.96 0 0 1 3 12Zm8.5-1.526v6.052c0 .262.224.474.5.474s.5-.212.5-.474v-6.052A.488.488 0 0 0 12 10c-.276 0-.5.212-.5.474Zm.5-3.253a.665.665 0 1 1 0 1.33.665.665 0 0 1 0-1.33Z",
    fill: "currentColor"
  }));
};

var SvgFeedbackQuestion104X104 = function SvgFeedbackQuestion104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-question",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52 102c27.614 0 50-22.386 50-50S79.614 2 52 2 2 24.386 2 52s22.386 50 50 50zm0 2c28.719 0 52-23.281 52-52S80.719 0 52 0 0 23.281 0 52s23.281 52 52 52zm-2-29a2 2 0 1 0 4 0 2 2 0 0 0-4 0zm2-48.005c-6.068 0-10.987 4.876-10.987 10.891 0 .551-.45.998-1.006.998S39 38.437 39 37.886C39 30.77 44.82 25 52 25s13 5.769 13 12.886c0 5.191-3.126 9.814-7.85 11.836-2.52 1.078-4.143 3.47-4.143 6.13v7.15c0 .551-.45.998-1.006.998s-1.007-.447-1.007-.998v-7.15c0-3.465 2.109-6.571 5.357-7.962 3.994-1.709 6.636-5.616 6.636-10.004 0-6.015-4.918-10.89-10.987-10.89z",
    clipRule: "evenodd"
  }));
};

var SvgFeedbackQuestion16X16 = function SvgFeedbackQuestion16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-question",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm-.5-4.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zM8 5.007c-.691 0-1.251.565-1.251 1.261a.502.502 0 0 1-.5.504.502.502 0 0 1-.499-.504A2.259 2.259 0 0 1 8 4a2.26 2.26 0 0 1 2.25 2.268c0 .915-.541 1.728-1.358 2.082a.641.641 0 0 0-.393.585v1.061c0 .278-.224.504-.5.504s-.499-.226-.499-.504V8.935c0-.657.393-1.245.995-1.51a1.26 1.26 0 0 0 .756-1.157c0-.696-.56-1.26-1.251-1.26z",
    clipRule: "evenodd"
  }));
};

var SvgFeedbackQuestion24X24 = function SvgFeedbackQuestion24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-question",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0 1c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-.5-6a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm.5-7.66c-.786 0-1.423.648-1.423 1.447 0 .232-.185.42-.413.42a.417.417 0 0 1-.414-.42C9.75 8.524 10.758 7.5 12 7.5c1.243 0 2.25 1.024 2.25 2.287 0 .92-.541 1.74-1.358 2.098a.788.788 0 0 0-.478.72v1.122c0 .232-.185.42-.414.42a.417.417 0 0 1-.413-.42v-1.121c0-.65.385-1.232.977-1.492.517-.227.859-.746.859-1.328 0-.798-.637-1.445-1.423-1.445Z",
    fill: "currentColor"
  }));
};

var SvgFeedbackSuccess104X104 = function SvgFeedbackSuccess104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-success",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52 0c28.72 0 52 23.28 52 52s-23.28 52-52 52S0 80.72 0 52 23.28 0 52 0zm0 2C24.385 2 2 24.385 2 52s22.385 50 50 50 50-22.385 50-50S79.615 2 52 2zM33.08 51.293a1 1 0 0 1 1.414 0l13.815 13.816L73.105 36.77a1 1 0 0 1 1.505 1.317L49.11 67.23a1 1 0 0 1-1.46.049L33.08 52.707a1 1 0 0 1 0-1.414z",
    clipRule: "evenodd"
  }));
};

var SvgFeedbackSuccess16X16 = function SvgFeedbackSuccess16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-success",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm0 1C4.133 1 1 4.133 1 8s3.133 7 7 7 7-3.133 7-7-3.133-7-7-7zM4.967 7.647a.5.5 0 0 1 .707 0L7.44 9.41l3.399-3.883a.5.5 0 0 1 .752.659l-3.75 4.285a.5.5 0 0 1-.73.024L4.967 8.354a.5.5 0 0 1 0-.707z",
    clipRule: "evenodd"
  }));
};

var SvgFeedbackSuccess24X24 = function SvgFeedbackSuccess24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-success",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Zm-3.862 8.67a.477.477 0 0 1 .669 0l2.208 2.18 4.157-4.69a.477.477 0 0 1 .667-.044c.196.17.216.464.044.658l-4.49 5.067a.477.477 0 0 1-.69.022L8.139 12.33a.463.463 0 0 1 0-.66Z",
    fill: "currentColor"
  }));
};

var SvgFeedbackSuccess64X64 = function SvgFeedbackSuccess64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -feedback-success",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0Zm0 1.23C15.006 1.23 1.23 15.007 1.23 32S15.007 62.77 32 62.77 62.77 48.993 62.77 32 48.993 1.23 32 1.23ZM20.357 31.566c.24-.24.63-.24.87 0l8.501 8.502 15.26-17.44a.615.615 0 1 1 .926.811L30.22 41.372a.615.615 0 0 1-.898.03l-8.966-8.967a.615.615 0 0 1 0-.87Z"
  }));
};

var SvgFilter104X104 = function SvgFilter104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -filter",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M67.083 89.447V52.192l36.161-35.834c1.623-1.608.474-4.358-1.822-4.358H2.582C.286 12-.863 14.75.76 16.358l36.16 35.835v37.254c0 1.41 1.155 2.553 2.578 2.553h25.008c1.423 0 2.577-1.143 2.577-2.553zm-27.585.571a.574.574 0 0 1-.577-.57V51.781a.986.986 0 0 0-.293-.7L2.174 14.956a.57.57 0 0 1 .408-.975h98.84a.57.57 0 0 1 .408.975L65.376 51.08a.987.987 0 0 0-.293.701v37.665c0 .315-.258.571-.577.571H39.498z",
    clipRule: "evenodd"
  }));
};

var SvgFilter16X16 = function SvgFilter16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -filter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.572 13.568V8.175l5.215-5.223c.46-.462.134-1.252-.518-1.252H.734a.733.733 0 0 0-.516 1.253L5.43 8.175v5.393c0 .404.328.732.73.732H9.84a.732.732 0 0 0 .732-.732zm-1-5.6v5.33H6.43v-5.33a.501.501 0 0 0-.147-.354L1.381 2.702h13.24L9.719 7.614a.501.501 0 0 0-.146.354z",
    clipRule: "evenodd"
  }));
};

var SvgFilter24X24 = function SvgFilter24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -filter"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M15.676 12.158v8.384a.857.857 0 0 1-.856.858H9.181a.856.856 0 0 1-.855-.858v-8.384L.251 4.063C-.286 3.523.095 2.6.857 2.6h22.287c.763 0 1.145.924.606 1.464l-8.074 8.094zm-1 8.24V11.95c0-.133.053-.26.147-.354l7.973-7.993H1.206l7.974 7.993a.502.502 0 0 1 .146.354v8.447h5.35z"
  }));
};

var SvgFinancialFeedbackError104X104 = function SvgFinancialFeedbackError104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -financial-feedback-error",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.991 65.075v-7.557h32.855a.99.99 0 0 0 .995-.983.99.99 0 0 0-.995-.983H1.99V21.925c0-2.74 2.248-4.959 5.023-4.959h75.973c2.774 0 5.022 2.22 5.022 4.96v12.147c-10.866-5.455-24.446-3.648-33.515 5.421-8.258 8.258-10.494 20.256-6.71 30.54H7.014c-2.775 0-5.023-2.22-5.023-4.96zM48.591 72H7.014C3.14 72 0 68.9 0 65.075v-43.15C0 18.1 3.14 15 7.014 15h75.973C86.861 15 90 18.1 90 21.925V35.02c0 .05-.004.1-.011.147a29.066 29.066 0 0 1 5.517 4.328c11.326 11.325 11.326 29.687 0 41.012-11.325 11.325-29.687 11.325-41.012 0A28.94 28.94 0 0 1 48.59 72zm7.322 7.087c10.542 10.54 27.633 10.54 38.173 0 10.542-10.542 10.542-27.632 0-38.173-10.54-10.542-27.631-10.542-38.173 0-10.54 10.54-10.54 27.631 0 38.173zM75 58.53l-8.226-8.227a1.039 1.039 0 1 0-1.47 1.47L73.531 60l-8.227 8.227a1.039 1.039 0 1 0 1.47 1.469L75 61.469l8.227 8.227a1.039 1.039 0 1 0 1.469-1.47L76.469 60l8.227-8.227a1.039 1.039 0 1 0-1.47-1.469L75 58.531z",
    clipRule: "evenodd"
  }));
};

var SvgFinancialFeedbackError16X16 = function SvgFinancialFeedbackError16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -financial-feedback-error",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 10.125V9.35h4.5a.5.5 0 1 0 0-.997H1V3.685c0-.214.174-.388.389-.388h11.222c.215 0 .389.174.389.388v1.12a4.613 4.613 0 0 0-4.856 1.058 4.582 4.582 0 0 0-1.128 4.65H1.389A.39.39 0 0 1 1 10.125zm6.475 1.386H1.39A1.388 1.388 0 0 1 0 10.125v-6.44C0 2.92.622 2.3 1.389 2.3h11.222c.767 0 1.389.62 1.389 1.385v1.637a4.582 4.582 0 0 1 .652 7.033 4.61 4.61 0 0 1-7.177-.844zm6.47.139a3.586 3.586 0 0 0 0-5.081 3.61 3.61 0 0 0-5.094 0 3.587 3.587 0 0 0 0 5.08 3.608 3.608 0 0 0 5.094 0zm-2.547-3.246-.914-.913a.5.5 0 0 0-.708 0 .498.498 0 0 0 0 .706l.915.912-.915.913a.498.498 0 0 0 0 .705.501.501 0 0 0 .707 0l.915-.912.915.912a.501.501 0 0 0 .708 0 .498.498 0 0 0 0-.705l-.915-.913.914-.912a.498.498 0 0 0 0-.706.501.501 0 0 0-.707 0l-.915.913z",
    clipRule: "evenodd"
  }));
};

var SvgFinancialFeedbackError24X24 = function SvgFinancialFeedbackError24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -financial-feedback-error",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 15.269v-1.46h7.167a.5.5 0 0 0 0-1H1V5.363c0-.477.387-.863.863-.863H19.07c.477 0 .863.386.863.863v2.117a6.788 6.788 0 0 0-7.523 1.422 6.797 6.797 0 0 0-1.543 7.23H1.863A.864.864 0 0 1 1 15.268Zm10.346 1.864H1.863A1.865 1.865 0 0 1 0 15.269V5.364C0 4.334.835 3.5 1.863 3.5H19.07c1.03 0 1.863.834 1.863 1.864v2.66a6.795 6.795 0 0 1 1.078 10.486 6.786 6.786 0 0 1-10.665-1.377Zm8.662-8.5a.5.5 0 0 0 .389.236 5.794 5.794 0 0 1 .907 8.934 5.786 5.786 0 0 1-8.187 0 5.794 5.794 0 0 1 0-8.193 5.789 5.789 0 0 1 6.891-.977ZM17.211 13l-1.592-1.593a.5.5 0 1 0-.707.708l1.591 1.592-1.591 1.593a.5.5 0 0 0 .707.707l1.591-1.592 1.592 1.592a.5.5 0 1 0 .707-.707l-1.591-1.593 1.59-1.592a.5.5 0 0 0-.706-.708L17.21 13Z",
    fill: "currentColor"
  }));
};

var SvgFinancialFeedbackError64X64 = function SvgFinancialFeedbackError64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -financial-feedback-error",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52.173 10c2.388 0 4.324 1.885 4.324 4.211v7.165C61.041 24.643 64 29.976 64 36c0 9.941-8.059 18-18 18-6.801 0-12.721-3.772-15.783-9.338H4.326C1.936 44.662 0 42.777 0 40.451v-26.24C0 11.885 1.936 10 4.325 10h47.848zM29.617 43.467A17.934 17.934 0 0 1 28 36c0-9.941 8.059-18 18-18 3.39 0 6.562.937 9.27 2.567v-6.356c0-1.666-1.387-3.016-3.097-3.016H4.325c-1.71 0-3.097 1.35-3.097 3.016V34.66h20.26c.338 0 .613.267.613.598 0 .33-.275.597-.614.597H1.227v4.596c0 1.666 1.387 3.016 3.098 3.016h25.292zM62.8 36c0 9.278-7.522 16.8-16.8 16.8S29.2 45.278 29.2 36 36.722 19.2 46 19.2 62.8 26.722 62.8 36zm-10.946-5.854a.5.5 0 0 1 0 .708L46.707 36l5.147 5.146a.5.5 0 0 1-.708.708L46 36.707l-5.146 5.147a.5.5 0 0 1-.708-.708L45.293 36l-5.147-5.146a.5.5 0 0 1 .708-.708L46 35.293l5.146-5.147a.5.5 0 0 1 .708 0z",
    clipRule: "evenodd"
  }));
};

var SvgFinancialFeedbackSuccess104X104 = function SvgFinancialFeedbackSuccess104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -financial-feedback-success",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.991 57.518v7.557c0 2.74 2.248 4.959 5.023 4.959h40.77C44 59.75 46.236 47.752 54.494 39.494c9.068-9.069 22.649-10.876 33.515-5.421V21.925c0-2.74-2.248-4.959-5.022-4.959H7.014c-2.775 0-5.023 2.22-5.023 4.96v33.626h32.855c.55 0 .995.44.995.983a.99.99 0 0 1-.995.983H1.99zM7.014 72H48.59a28.94 28.94 0 0 0 5.903 8.506c11.325 11.325 29.687 11.325 41.012 0 11.326-11.325 11.326-29.687 0-41.012a29.066 29.066 0 0 0-5.517-4.328.975.975 0 0 0 .011-.147V21.925C90 18.1 86.86 15 82.987 15H7.014C3.14 15 0 18.1 0 21.925v43.15C0 68.9 3.14 72 7.014 72zm87.072-31.086c10.542 10.54 10.542 27.631 0 38.173-10.54 10.54-27.631 10.54-38.173 0-10.54-10.542-10.54-27.632 0-38.173 10.542-10.542 27.633-10.542 38.173 0zm-7.765 12.458a1 1 0 0 0-.157-1.32l-.092-.073a1 1 0 0 0-1.32.158L72.34 66.136l-6.739-6.648-.087-.077a1 1 0 0 0-1.317 1.5l7.489 7.39.085.075a1 1 0 0 0 1.366-.124l13.11-14.789.073-.091z",
    clipRule: "evenodd"
  }));
};

var SvgFinancialFeedbackSuccess16X16 = function SvgFinancialFeedbackSuccess16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -financial-feedback-success",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 9.35v.775a.39.39 0 0 0 .389.388h5.627a4.582 4.582 0 0 1 1.128-4.65A4.613 4.613 0 0 1 13 4.805v-1.12a.388.388 0 0 0-.389-.388H1.389A.388.388 0 0 0 1 3.685v4.667h4.5a.5.5 0 1 1 0 .997H1zm.389 2.16h6.086a4.61 4.61 0 0 0 7.177.844A4.582 4.582 0 0 0 14 5.323V3.685c0-.765-.622-1.385-1.389-1.385H1.389C.622 2.3 0 2.92 0 3.685v6.44c0 .765.622 1.386 1.389 1.386zM13.945 6.57a3.586 3.586 0 0 1 0 5.08 3.608 3.608 0 0 1-5.094 0 3.587 3.587 0 0 1 0-5.08 3.61 3.61 0 0 1 5.094 0zm-.791 1.277a.5.5 0 0 0-.708 0l-1.658 1.658-.646-.606-.071-.056a.5.5 0 0 0-.613.785l1 .938.079.06a.5.5 0 0 0 .617-.072l2-2 .057-.069a.5.5 0 0 0-.057-.638z",
    clipRule: "evenodd"
  }));
};

var SvgFinancialFeedbackSuccess24X24 = function SvgFinancialFeedbackSuccess24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -financial-feedback-success",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 13.809v1.46c0 .476.387.863.863.863h9.004a6.796 6.796 0 0 1 1.543-7.23 6.789 6.789 0 0 1 7.524-1.42V5.363a.863.863 0 0 0-.863-.863H1.863A.864.864 0 0 0 1 5.364v7.444h7.167a.5.5 0 0 1 0 1H1Zm.863 3.324h9.484a6.786 6.786 0 0 0 10.665 1.378 6.795 6.795 0 0 0-1.078-10.487v-2.66c0-1.03-.834-1.864-1.863-1.864H1.863A1.864 1.864 0 0 0 0 5.364V15.27c0 1.028.835 1.864 1.863 1.864Zm18.535-8.264a.5.5 0 0 1-.389-.236 5.789 5.789 0 0 0-6.891.977 5.794 5.794 0 0 0 0 8.193 5.787 5.787 0 0 0 8.187 0 5.794 5.794 0 0 0-.907-8.934Zm-.444 2.877a.5.5 0 0 0-.707 0l-2.859 2.858-1.246-1.169-.07-.055a.5.5 0 0 0-.614.785l1.6 1.5.079.06a.5.5 0 0 0 .617-.071l3.2-3.2.058-.07a.5.5 0 0 0-.058-.638Z",
    fill: "currentColor"
  }));
};

var SvgFinancialFeedbackSuccess64X64 = function SvgFinancialFeedbackSuccess64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    rrole: "img",
    className: "icon -financial-feedback-success",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52.173 10c2.388 0 4.324 1.885 4.324 4.211v7.165C61.041 24.643 64 29.976 64 36c0 9.941-8.059 18-18 18-6.801 0-12.721-3.772-15.783-9.338H4.326C1.936 44.662 0 42.777 0 40.451v-26.24C0 11.885 1.936 10 4.325 10h47.848zM29.617 43.467A17.934 17.934 0 0 1 28 36c0-9.941 8.059-18 18-18 3.39 0 6.562.937 9.27 2.567v-6.356c0-1.666-1.387-3.016-3.097-3.016H4.325c-1.71 0-3.097 1.35-3.097 3.016V34.66h20.26c.338 0 .613.267.613.598 0 .33-.275.597-.614.597H1.227v4.596c0 1.666 1.387 3.016 3.098 3.016h25.292zM62.8 36c0 9.278-7.522 16.8-16.8 16.8S29.2 45.278 29.2 36 36.722 19.2 46 19.2 62.8 26.722 62.8 36zm-8.928-4.665a.5.5 0 1 0-.744-.67l-8.647 9.609-4.627-4.628a.5.5 0 0 0-.708.708l4.851 4.85a.7.7 0 0 0 1.016-.026l8.859-9.843z",
    clipRule: "evenodd"
  }));
};

var SvgFinancialFeedbackWaiting104X104 = function SvgFinancialFeedbackWaiting104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -financial-feedback-waiting",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M90 21.925C90 18.1 86.86 15 82.987 15H7.014C3.14 15 0 18.1 0 21.925v43.15C0 68.9 3.14 72 7.014 72H48.59C53.156 82.028 63.264 89 75 89c16.016 0 29-12.984 29-29 0-10.526-5.608-19.743-14-24.824v-13.25zM46 60c0 3.528.63 6.908 1.783 10.035l-40.77-.001c-2.774 0-5.022-2.22-5.022-4.96v-7.556h32.855a.99.99 0 0 0 .995-.983.99.99 0 0 0-.995-.983H1.99V21.925c0-2.74 2.248-4.959 5.023-4.959h75.973c2.774 0 5.022 2.22 5.022 4.96v12.148A28.878 28.878 0 0 0 75 31c-16.016 0-29 12.984-29 29zm29 27c14.912 0 27-12.088 27-27S89.912 33 75 33 48 45.088 48 60s12.088 27 27 27zm-.095-44c.768 0 .999.627.999 1.4v14.613l8.66 5.203c.659.398 1.057.943.661 1.606-.395.663-1.074.576-1.733.178l-8.816-5.321A1.402 1.402 0 0 1 74 59.478V44.4c0-.773.136-1.4.905-1.4z",
    clipRule: "evenodd"
  }));
};

var SvgFinancialFeedbackWaiting16X16 = function SvgFinancialFeedbackWaiting16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -financial-feedback-waiting",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 9.35v.775a.39.39 0 0 0 .389.388h5.627a4.582 4.582 0 0 1 1.128-4.65A4.613 4.613 0 0 1 13 4.805v-1.12a.388.388 0 0 0-.389-.388H1.389A.388.388 0 0 0 1 3.685v4.667h4.5a.5.5 0 1 1 0 .997H1zm.389 2.16h6.086a4.61 4.61 0 0 0 7.177.844A4.582 4.582 0 0 0 14 5.323V3.685c0-.765-.622-1.385-1.389-1.385H1.389C.622 2.3 0 2.92 0 3.685v6.44c0 .765.622 1.386 1.389 1.386zM13.945 6.57a3.586 3.586 0 0 1 0 5.08 3.608 3.608 0 0 1-5.094 0 3.587 3.587 0 0 1 0-5.08 3.61 3.61 0 0 1 5.094 0zm-2.71-.07c.268 0 .485.215.485.48v2.1l1.381.979c.23.136.304.43.166.657a.488.488 0 0 1-.665.164l-1.617-1.118a.478.478 0 0 1-.235-.411V6.979c0-.265.217-.48.485-.48z",
    clipRule: "evenodd"
  }));
};

var SvgFinancialFeedbackWaiting24X24 = function SvgFinancialFeedbackWaiting24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -financial-feedback-waiting",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.071 3.5c1.03 0 1.863.834 1.863 1.864v2.66a6.795 6.795 0 0 1 1.077 10.486 6.786 6.786 0 0 1-10.664-1.377H1.863A1.865 1.865 0 0 1 0 15.269V5.364C0 4.334.835 3.5 1.863 3.5h17.208Zm-5.953 6.11a5.795 5.795 0 0 0 0 8.194 5.786 5.786 0 0 0 8.186 0 5.795 5.795 0 0 0 0-8.194 5.786 5.786 0 0 0-8.186 0Zm4.157.301a.5.5 0 0 1 .5.5v3.65l1.928 1.165a.5.5 0 0 1-.514.858l-2.171-1.31a.5.5 0 0 1-.243-.429v-3.934a.5.5 0 0 1 .5-.5Zm1.796-5.41H1.863A.864.864 0 0 0 1 5.364v7.444h7.167a.5.5 0 0 1 0 1H1v1.46c0 .477.387.864.863.864h9.005a6.796 6.796 0 0 1 1.543-7.23 6.789 6.789 0 0 1 7.523-1.42V5.364a.863.863 0 0 0-.863-.863Z",
    fill: "currentColor"
  }));
};

var SvgFinancialFeedbackWaiting64X64 = function SvgFinancialFeedbackWaiting64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -financial-feedback-waiting",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M56.497 14.211c0-2.326-1.936-4.211-4.324-4.211H4.325C1.936 10 0 11.885 0 14.211v26.24c0 2.326 1.936 4.211 4.325 4.211h25.892C33.28 50.228 39.2 54 46 54c9.941 0 18-8.059 18-18 0-6.024-2.959-11.357-7.503-14.624v-7.165zM28 36c0 2.664.579 5.193 1.617 7.467H4.325c-1.71 0-3.097-1.35-3.097-3.016v-4.596h20.26c.338 0 .613-.267.613-.597a.606.606 0 0 0-.614-.598H1.227V14.21c0-1.666 1.387-3.016 3.098-3.016h47.848c1.71 0 3.096 1.35 3.096 3.016v6.356A17.916 17.916 0 0 0 46 18c-9.941 0-18 8.059-18 18zm18 16.8c9.278 0 16.8-7.522 16.8-16.8S55.278 19.2 46 19.2 29.2 26.722 29.2 36 36.722 52.8 46 52.8zM45.556 26c.473 0 .615.377.615.841v8.777l5.325 3.125c.406.239.65.566.407.964-.243.398-.66.346-1.066.107l-5.421-3.196a.838.838 0 0 1-.416-.721V26.84c0-.464.084-.841.556-.841z",
    clipRule: "evenodd"
  }));
};

var SvgFirstAidKit104X104 = function SvgFirstAidKit104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -first-aid-kit",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M96.955 0A7.044 7.044 0 0 1 104 7.044V35.04c-.702 30.332-20.998 57.38-51.66 68.896a1.002 1.002 0 0 1-.704 0C20.981 92.415.695 65.366 0 35.017V7.044A7.044 7.044 0 0 1 7.045 0h89.91zM102 35.017V7.044A5.044 5.044 0 0 0 96.955 2H7.045A5.044 5.044 0 0 0 2 7.044v27.95c.672 29.373 20.276 55.622 49.988 66.937 29.72-11.31 49.333-37.56 50.012-66.914zm-45.627 7.55h6.64a.71.71 0 0 1 .71.71v5.906a.71.71 0 0 1-.71.71h-6.64a.71.71 0 0 0-.71.71v6.64a.71.71 0 0 1-.71.71h-5.906a.71.71 0 0 1-.71-.71v-6.64a.71.71 0 0 0-.71-.71h-6.64a.71.71 0 0 1-.71-.71v-5.907a.71.71 0 0 1 .71-.71h6.64a.71.71 0 0 0 .71-.71v-6.64a.71.71 0 0 1 .71-.709h5.906a.71.71 0 0 1 .71.71v6.64c0 .391.319.71.71.71zm-14.38-17.299v-3.403A7.805 7.805 0 0 1 49.8 14.06h4.402a7.806 7.806 0 0 1 7.806 7.805v3.403H41.993zm-1 2h35.312a5.335 5.335 0 0 1 5.335 5.336V61.91a5.335 5.335 0 0 1-5.335 5.335h-48.61a5.335 5.335 0 0 1-5.336-5.335V32.604a5.335 5.335 0 0 1 5.335-5.336h13.3zm-1-2v-3.403c0-5.415 4.39-9.805 9.806-9.805h4.402c5.415 0 9.806 4.39 9.806 9.805v3.403h12.298a7.336 7.336 0 0 1 7.335 7.336V61.91a7.335 7.335 0 0 1-7.335 7.335h-48.61a7.335 7.335 0 0 1-7.336-7.335V32.604a7.336 7.336 0 0 1 7.335-7.336h12.3z",
    clipRule: "evenodd"
  }));
};

var SvgFirstAidKit16X16 = function SvgFirstAidKit16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -first-aid-kit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 5.491c-.096 4.137-2.837 7.836-7.002 9.474C3.834 13.326 1.095 9.627 1 5.503V1.389A.39.39 0 0 1 1.389 1h13.222a.39.39 0 0 1 .389.389v4.102zM14.611 0H1.389A1.39 1.39 0 0 0 0 1.389v4.125c.105 4.604 3.176 8.708 7.822 10.455a.506.506 0 0 0 .352 0c4.647-1.746 7.72-5.85 7.826-10.466V1.389A1.39 1.39 0 0 0 14.611 0zM9.619 6.613h-.976a.105.105 0 0 1-.104-.104v-.977a.104.104 0 0 0-.105-.104h-.869a.104.104 0 0 0-.104.104v.977a.105.105 0 0 1-.105.104h-.975a.104.104 0 0 0-.105.104v.87c0 .057.047.103.105.103h.975c.058 0 .105.047.105.105v.976c0 .058.047.105.104.105h.87a.105.105 0 0 0 .104-.105v-.976c0-.058.047-.105.104-.105h.976a.103.103 0 0 0 .104-.104v-.869a.103.103 0 0 0-.104-.104zm1.955 3.276a.432.432 0 0 0 .432-.432v-4.31a.432.432 0 0 0-.432-.43H4.426a.433.433 0 0 0-.432.43v4.31c0 .238.194.432.432.432h7.148zM7.676 2.773a.796.796 0 0 0-.795.795v.148h2.238v-.148a.796.796 0 0 0-.795-.795h-.648zm2.443.943h1.455c.789 0 1.432.642 1.432 1.431v4.31c0 .79-.643 1.432-1.432 1.432H4.426a1.434 1.434 0 0 1-1.432-1.432v-4.31c0-.789.643-1.43 1.432-1.43H5.88v-.149c0-.989.806-1.795 1.795-1.795h.648c.99 0 1.795.806 1.795 1.795v.148z",
    clipRule: "evenodd"
  }));
};

var SvgFirstAidKit24X24 = function SvgFirstAidKit24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -first-aid-kit",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.374 2C21.272 2 22 2.728 22 3.626v5.222c-.134 5.782-3.998 10.931-9.826 13.12a.5.5 0 0 1-.352 0C5.995 19.778 2.132 14.628 2 8.836v-5.21C2 2.728 2.728 2 3.626 2h16.748ZM21 8.836v-5.21A.626.626 0 0 0 20.374 3H3.626A.626.626 0 0 0 3 3.626v5.199c.122 5.304 3.642 10.053 8.998 12.14 5.357-2.086 8.88-6.835 9.002-12.129Zm-8.185 1.407h1.237c.072 0 .132.059.132.132v1.1c0 .074-.06.133-.132.133h-1.237a.131.131 0 0 0-.132.132v1.237c0 .073-.06.132-.133.132h-1.1a.132.132 0 0 1-.132-.132V11.74a.132.132 0 0 0-.132-.132H9.948a.132.132 0 0 1-.131-.133v-1.1c0-.073.059-.132.13-.132h1.239a.132.132 0 0 0 .132-.132V8.874c0-.073.059-.132.132-.132h1.1c.073 0 .133.059.133.132v1.237c0 .073.058.132.132.132Zm-2.366-3.536v-.32c0-.63.51-1.14 1.141-1.14h.82c.63 0 1.141.51 1.141 1.14v.32H10.45Zm-.5 1h6.579a.68.68 0 0 1 .68.68v5.459a.68.68 0 0 1-.68.68H7.473a.68.68 0 0 1-.681-.68V8.387a.68.68 0 0 1 .68-.68H9.95Zm-.5-1v-.32a2.14 2.14 0 0 1 2.141-2.14h.82a2.14 2.14 0 0 1 2.141 2.14v.32h1.977c.928 0 1.68.752 1.68 1.68v5.459a1.68 1.68 0 0 1-1.68 1.68H7.473a1.68 1.68 0 0 1-1.681-1.68V8.387c0-.928.753-1.68 1.68-1.68H9.45Z",
    fill: "currentColor"
  }));
};

var SvgFlash104X104 = function SvgFlash104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -flash",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.729 47.95 64.946.37c.688-.836 2.028-.135 1.734.907L55.127 42.191a.822.822 0 0 0 .08.67c.108.201.28.344.482.4L77.78 49.69a1 1 0 0 1 .487 1.603l-43.9 52.344c-.715.854-2.081.073-1.707-.978l16.223-45.586a.842.842 0 0 0-.05-.671.77.77 0 0 0-.499-.422l-22.113-6.433a1 1 0 0 1-.492-1.596zM63.462 5.313 28.238 48.05l20.655 6.01c.704.206 1.28.655 1.635 1.272l.092.172c.362.7.411 1.544.14 2.26L36.408 98.09l39.34-46.909-20.609-5.997a2.763 2.763 0 0 1-1.586-1.19l-.09-.157a2.79 2.79 0 0 1-.26-2.194l10.259-36.33z",
    clipRule: "evenodd"
  }));
};

var SvgFlash16X16 = function SvgFlash16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -flash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m3.822 7.273.054-.072L9.644.67c.355-.402 1.008-.037.853.476L8.87 6.514l3.01.818a.5.5 0 0 1 .296.744l-.055.072-6.456 7.183c-.37.412-1.036.005-.839-.512l2.286-5.994-2.994-.811a.5.5 0 0 1-.297-.741zM8.876 3.05 5.158 7.259l2.475.672a.76.76 0 0 1 .422.289l.055.09c.1.189.115.415.038.612l-1.427 3.74 4.116-4.578-2.46-.668a.767.767 0 0 1-.394-.248l-.062-.09a.735.735 0 0 1-.08-.607L8.876 3.05z",
    clipRule: "evenodd"
  }));
};

var SvgFlash24X24 = function SvgFlash24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -flash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.82 11.01.052-.073L14.714.677c.352-.408 1.011-.05.859.467l-2.577 8.722 4.888 1.36a.5.5 0 0 1 .295.74l-.053.072-9.898 11.288c-.366.418-1.038.017-.844-.503l3.615-9.72-4.883-1.358a.5.5 0 0 1-.297-.736Zm8.136-7.922-6.814 7.905 4.225 1.175a.89.89 0 0 1 .5.345l.06.103c.124.227.141.5.05.728l-2.709 7.28 7.582-8.648-4.213-1.17a.901.901 0 0 1-.478-.32l-.06-.093a.876.876 0 0 1-.09-.71l1.947-6.595Z",
    clipRule: "evenodd"
  }));
};

var SvgFlashOff104X104 = function SvgFlashOff104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -flash-off",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M64.944.37c.664-.806 1.934-.183 1.76.797l-.025.11-11.554 40.914a.824.824 0 0 0 .08.67c.09.167.225.294.385.364l.099.035 22.09 6.43a1 1 0 0 1 .558 1.508l-.07.094-8.042 9.587-1.532-1.285 7.055-8.413-20.607-5.997a2.76 2.76 0 0 1-1.59-1.19l-.09-.158a2.776 2.776 0 0 1-.31-1.987l.05-.205 10.26-36.33-21.685 26.309-1.544-1.272L64.944.37zM34.41 37.417l1.543 1.272-7.715 9.36 20.656 6.009a2.758 2.758 0 0 1 1.635 1.272l.092.172c.327.636.398 1.39.205 2.06l-.065.199-14.356 40.33 26.448-31.534 1.533 1.285-30.02 35.793c-.69.825-1.988.125-1.74-.87l.032-.107 16.224-45.584a.852.852 0 0 0-.048-.674.768.768 0 0 0-.39-.383l-.109-.039-22.114-6.433a1 1 0 0 1-.565-1.496l.073-.1 8.68-10.532zM14.626 11.211a1.008 1.008 0 0 0-1.33 1.51L89.28 88.704l.094.084a1.008 1.008 0 0 0 1.33-1.51L14.722 11.296l-.095-.084z",
    clipRule: "evenodd"
  }));
};

var SvgFlashOff16X16 = function SvgFlashOff16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -flash-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.515 1.019c.057-.443-.559-.716-.884-.346l-3.377 3.84.772.597 1.862-2.12-1.051 3.492-.024.115-.002.015-4.603-5.02a.5.5 0 1 0-.737.676L7.72 7.99a.82.82 0 0 0-.08-.026l-2.522-.687.492-.558.135-.155-.772-.596-.136.155-.973 1.107-.05.068c-.155.256-.02.594.297.68l3.016.823-2.304 6.07-.023.08c-.089.45.54.755.877.377l4.005-4.475-.766-.603-2.218 2.478L8.15 8.905l.03-.094a.67.67 0 0 0-.007-.325l4.623 5.04a.5.5 0 1 0 .737-.675L8.564 7.433l2.31.63-.508.567.766.602 1-1.118.051-.067c.159-.256.024-.597-.294-.684l-3.03-.827 1.639-5.438.017-.08z",
    clipRule: "evenodd"
  }));
};

var SvgFlashOff24X24 = function SvgFlashOff24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -flash-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.707.677c.325-.378.94-.1.884.353l-.017.082-2.585 8.77 4.9 1.366a.473.473 0 0 1 .294.698l-.05.07-1.812 2.07-.767-.615 1.32-1.51-4.244-1.181a.902.902 0 0 1-.476-.317l-.058-.09a.824.824 0 0 1-.115-.566l.026-.117 1.957-6.644-4.058 4.718-.771-.61L14.707.678ZM7.822 8.681l.772.61-1.476 1.714 4.254 1.185a.888.888 0 0 1 .509.357l.05.087a.843.843 0 0 1 .083.585l-.035.113-2.725 7.337 4.983-5.694.766.616-6.768 7.735c-.338.386-.966.074-.877-.386l.023-.083 3.627-9.771-4.898-1.364a.473.473 0 0 1-.296-.696l.05-.069 1.958-2.276ZM4.057 3.32a.494.494 0 0 0-.678.717L19.942 19.68a.493.493 0 1 0 .677-.718L4.057 3.32Z",
    clipRule: "evenodd"
  }));
};

var SvgFlow104X104 = function SvgFlow104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -flow",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M53.001 30.315h24.353a1.8 1.8 0 0 0 1.8-1.8V1.799A1.8 1.8 0 0 0 77.355 0H26.647a1.8 1.8 0 0 0-1.801 1.799v26.716a1.8 1.8 0 0 0 1.8 1.8h24.355v22.808H28.1a7.045 7.045 0 0 0-7.045 7.045v14.59H1.8a1.8 1.8 0 0 0-1.8 1.8V102.2a1.8 1.8 0 0 0 1.8 1.8h40.509a1.8 1.8 0 0 0 1.8-1.8V76.559a1.8 1.8 0 0 0-1.8-1.8H23.054v-14.59a5.045 5.045 0 0 1 5.045-5.046h23.867a1.011 1.011 0 0 0 .07 0h23.866a5.045 5.045 0 0 1 5.045 5.045v14.59H61.692a1.8 1.8 0 0 0-1.8 1.8V102.2a1.8 1.8 0 0 0 1.8 1.8H102.2a1.8 1.8 0 0 0 1.8-1.8V76.559a1.8 1.8 0 0 0-1.8-1.8H82.947v-14.59a7.045 7.045 0 0 0-7.045-7.046h-22.9V30.315zm-1-2h25.154V2h-50.31v26.315h25.156zM2 76.759h40.109V102H2V76.759zm100.001 0h-40.11V102h40.11V76.759z",
    clipRule: "evenodd"
  }));
};

var SvgFlow16X16 = function SvgFlow16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -flow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.5 5.164h2.546a1.3 1.3 0 0 0 1.3-1.3V1.3a1.3 1.3 0 0 0-1.3-1.3H4.954a1.3 1.3 0 0 0-1.3 1.3v2.564a1.3 1.3 0 0 0 1.3 1.3H7.5v2.648H4.486c-.768 0-1.389.622-1.389 1.389v1.793H1.3c-.717 0-1.3.583-1.3 1.3V14.7A1.3 1.3 0 0 0 1.3 16h4.593a1.3 1.3 0 0 0 1.3-1.3v-2.406c0-.717-.583-1.3-1.3-1.3H4.097V9.2c0-.215.174-.389.39-.389h7.028c.215 0 .39.174.39.389v1.793h-1.797c-.718 0-1.3.583-1.3 1.3V14.7a1.3 1.3 0 0 0 1.3 1.3H14.7a1.3 1.3 0 0 0 1.3-1.3v-2.406c0-.717-.583-1.3-1.3-1.3h-1.797V9.2c0-.767-.622-1.389-1.389-1.389H8.5V5.164zm-.5-1h3.046a.3.3 0 0 0 .3-.3V1.3a.3.3 0 0 0-.3-.3H4.954a.3.3 0 0 0-.3.3v2.564a.3.3 0 0 0 .3.3H8zm-2.107 7.83H1.3c-.165 0-.3.135-.3.3V14.7a.3.3 0 0 0 .3.3h4.593a.3.3 0 0 0 .3-.3v-2.406c0-.165-.135-.3-.3-.3zm4.215 0H14.7c.164 0 .3.135.3.3V14.7a.3.3 0 0 1-.3.3h-4.593a.3.3 0 0 1-.3-.3v-2.406c0-.165.135-.3.3-.3z",
    clipRule: "evenodd"
  }));
};

var SvgFlow24X24 = function SvgFlow24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -flow",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 8.274h3.572a1.3 1.3 0 0 0 1.3-1.3V3.299A1.3 1.3 0 0 0 16.072 2H7.927a1.3 1.3 0 0 0-1.299 1.299v3.675a1.3 1.3 0 0 0 1.3 1.3H11.5v3.621H7.548c-.898 0-1.626.728-1.626 1.626v2.405H3.3a1.3 1.3 0 0 0-1.3 1.3V20.7A1.3 1.3 0 0 0 3.3 22h6.244a1.3 1.3 0 0 0 1.3-1.3v-3.474a1.3 1.3 0 0 0-1.3-1.3H6.922V13.52c0-.346.28-.626.626-.626h8.904c.346 0 .626.28.626.626v2.405h-2.622a1.3 1.3 0 0 0-1.3 1.3V20.7a1.3 1.3 0 0 0 1.3 1.3H20.7a1.3 1.3 0 0 0 1.3-1.3v-3.474a1.3 1.3 0 0 0-1.3-1.3h-2.622V13.52c0-.898-.728-1.626-1.626-1.626H12.5V8.274Zm-.5-1h4.072a.3.3 0 0 0 .3-.3V3.299a.3.3 0 0 0-.3-.299H7.927a.3.3 0 0 0-.299.299v3.675a.3.3 0 0 0 .3.3H12ZM9.844 20.7a.3.3 0 0 1-.3.3H3.3a.3.3 0 0 1-.3-.3v-3.474a.3.3 0 0 1 .3-.3h6.244a.3.3 0 0 1 .3.3V20.7ZM20.7 21a.3.3 0 0 0 .3-.3v-3.474a.3.3 0 0 0-.3-.3h-6.244a.3.3 0 0 0-.3.3V20.7a.3.3 0 0 0 .3.3H20.7Z",
    fill: "currentColor"
  }));
};

var SvgFolder104X104 = function SvgFolder104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -folder",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.578 19h33.67a2 2 0 0 1 1.854 1.251L46.019 25H6.578v-4a2 2 0 0 1 2-2Zm-4 6v-4a4 4 0 0 1 4-4h33.67a4 4 0 0 1 3.709 2.503L48.175 25H100a4 4 0 0 1 3.945 4.658l-9.01 54A4 4 0 0 1 90.99 87H13.01a4 4 0 0 1-3.945-3.342l-9.01-54A4 4 0 0 1 4.002 25h.577Zm44.405 2H4.001a2 2 0 0 0-1.973 2.33l9.01 54A2 2 0 0 0 13.01 85H90.99a2 2 0 0 0 1.973-1.67l9.009-54A2 2 0 0 0 100 27H48.983Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  }))));
};

var SvgFolder16X16 = function SvgFolder16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -folder",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.5h6.418l.273 1H2v-1Zm-1 1v-1a1 1 0 0 1 1-1h6.418a1 1 0 0 1 .965.737L9.727 4.5h5.248c.638 0 1.12.562 1.009 1.175l-1.275 7a1.018 1.018 0 0 1-1.01.825H2.3c-.496 0-.922-.348-1.009-.825l-1.275-7C-.094 5.07.375 4.515 1 4.5Zm.025 1 1.275 7h11.4l1.275-7H1.025Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
};

var SvgFolder24X24 = function SvgFolder24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -folder",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.5h11.92l.683 2H3v-2Zm-1 2v-2a1 1 0 0 1 1-1h11.92a1 1 0 0 1 .947.677L16.66 6.5h6.325c.63 0 1.107.558 1.001 1.169l-2.09 12c-.083.48-.506.831-1 .831H3.105c-.494 0-.917-.351-1-.831l-2.09-12A1.005 1.005 0 0 1 1.016 6.5H2Zm15 1H1.016l2.09 12h17.788l2.09-12H17Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))));
};

var SvgFolder64X64 = function SvgFolder64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -folder",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12h23.058a1 1 0 0 1 .915.598L31.468 16H5v-3a1 1 0 0 1 1-1Zm-2 4v-3a2 2 0 0 1 2-2h23.058a2 2 0 0 1 1.83 1.195L32.562 16h29.415c1.253 0 2.205 1.115 1.995 2.336l-5.686 33A2.017 2.017 0 0 1 56.291 53H7.709a2.017 2.017 0 0 1-1.994-1.664l-5.686-33C-.18 17.115.771 16 2.024 16H4Zm29 1H2.024c-.627 0-1.103.557-.997 1.168l5.685 33c.083.48.504.832.997.832h48.582c.493 0 .914-.352.997-.832l5.686-33A1.004 1.004 0 0 0 61.976 17H33Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  }))));
};

var SvgFootprint104X104 = function SvgFootprint104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -footprint"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.375 22.063c0 8.619-5.93 15.062-12.625 15.062s-12.625-6.443-12.625-15.063C23.125 13.444 29.055 7 35.75 7c6.694 0 12.625 6.443 12.625 15.063Zm2 0c0 9.423-6.548 17.062-14.625 17.062s-14.625-7.64-14.625-17.063C21.125 12.64 27.673 5 35.75 5s14.625 7.64 14.625 17.063ZM13.812 59.874c6.321 0 11.813-5.801 11.813-13.438C25.625 38.801 20.133 33 13.812 33 7.492 33 2 38.801 2 46.438c0 7.636 5.492 13.437 11.813 13.437Zm0 2c7.629 0 13.813-6.912 13.813-15.438C27.625 37.913 21.441 31 13.812 31 6.184 31 0 37.912 0 46.438c0 8.525 6.184 15.437 13.813 15.437Zm76.376-2c6.32 0 11.812-5.801 11.812-13.438C102 38.801 96.508 33 90.187 33c-6.32 0-11.812 5.801-11.812 13.438 0 7.636 5.492 13.437 11.813 13.437Zm0 2c7.628 0 13.812-6.912 13.812-15.438C104 37.913 97.816 31 90.187 31c-7.628 0-13.812 6.912-13.812 15.438 0 8.525 6.184 15.437 13.813 15.437Zm-23.563-24.75c6.695 0 12.625-6.443 12.625-15.063C79.25 13.444 73.32 7 66.625 7 59.931 7 54 13.443 54 22.063c0 8.619 5.93 15.062 12.625 15.062Zm0 2c8.077 0 14.625-7.64 14.625-17.063C81.25 12.64 74.702 5 66.625 5S52 12.64 52 22.063c0 9.423 6.548 17.062 14.625 17.062Zm17.5 34.938c0 6.191-3.314 11.943-8.963 16.214-5.65 4.272-13.545 6.973-22.35 6.973-8.804 0-16.699-2.7-22.349-6.973-5.649-4.27-8.963-10.023-8.963-16.215 0-6.191 3.314-11.943 8.963-16.214 5.65-4.272 13.545-6.973 22.35-6.973 8.804 0 16.699 2.7 22.349 6.973 5.649 4.27 8.963 10.023 8.963 16.215Zm2 0c0 13.91-14.915 25.187-33.313 25.187-18.398 0-33.312-11.277-33.312-25.188 0-13.91 14.914-25.187 33.313-25.187 18.397 0 33.312 11.277 33.312 25.188Z"
  }));
};

var SvgFootprint16X16 = function SvgFootprint16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -footprint"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3.625c0 1.048-.699 1.625-1.25 1.625s-1.25-.577-1.25-1.625S4.949 2 5.5 2s1.25.577 1.25 1.625Zm1 0c0 1.45-1.007 2.625-2.25 2.625S3.25 5.075 3.25 3.625 4.257 1 5.5 1s2.25 1.175 2.25 2.625ZM2.125 8.75c.52 0 1.125-.508 1.125-1.375S2.645 6 2.125 6 1 6.508 1 7.375 1.605 8.75 2.125 8.75Zm0 1c1.174 0 2.125-1.063 2.125-2.375S3.299 5 2.125 5 0 6.063 0 7.375.951 9.75 2.125 9.75Zm11.75-1c.52 0 1.125-.508 1.125-1.375S14.395 6 13.875 6s-1.125.508-1.125 1.375.605 1.375 1.125 1.375Zm0 1C15.049 9.75 16 8.687 16 7.375S15.049 5 13.875 5 11.75 6.063 11.75 7.375s.951 2.375 2.125 2.375Zm-3.625-4.5c.551 0 1.25-.577 1.25-1.625S10.801 2 10.25 2 9 2.577 9 3.625s.699 1.625 1.25 1.625Zm0 1c1.243 0 2.25-1.175 2.25-2.625S11.493 1 10.25 1 8 2.175 8 3.625 9.007 6.25 10.25 6.25Zm2 5.375c0 .688-.367 1.385-1.104 1.942-.738.559-1.803.933-3.021.933s-2.283-.374-3.02-.933C4.366 13.01 4 12.313 4 11.625s.367-1.385 1.104-1.942c.738-.559 1.803-.933 3.021-.933s2.283.374 3.02.933c.739.557 1.105 1.254 1.105 1.942Zm1 0c0 2.14-2.294 3.875-5.125 3.875C5.295 15.5 3 13.765 3 11.625 3 9.485 5.295 7.75 8.125 7.75s5.125 1.735 5.125 3.875Z"
  }));
};

var SvgFootprint24X24 = function SvgFootprint24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -footprint"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.688 6.281c0 1.41-.951 2.282-1.813 2.282S7.062 7.69 7.062 6.28C7.063 4.871 8.014 4 8.876 4s1.813.871 1.813 2.281Zm1 0c0 1.812-1.26 3.282-2.813 3.282-1.553 0-2.813-1.47-2.813-3.282S7.322 3 8.876 3c1.553 0 2.813 1.47 2.813 3.281Zm-7.032 6.657c.813 0 1.657-.774 1.657-1.97C6.313 9.775 5.468 9 4.655 9 3.843 9 3 9.774 3 10.969s.843 1.969 1.656 1.969Zm0 1c1.467 0 2.657-1.33 2.657-2.97C7.313 9.33 6.123 8 4.655 8S2 9.33 2 10.969c0 1.64 1.19 2.969 2.656 2.969Zm14.688-1c.813 0 1.656-.774 1.656-1.97C21 9.775 20.157 9 19.344 9s-1.657.774-1.657 1.969.844 1.969 1.657 1.969Zm0 1c1.467 0 2.656-1.33 2.656-2.97C22 9.33 20.81 8 19.344 8c-1.467 0-2.657 1.33-2.657 2.969 0 1.64 1.19 2.969 2.657 2.969Zm-4.532-5.376c.862 0 1.813-.87 1.813-2.28 0-1.41-.95-2.282-1.813-2.282C13.951 4 13 4.871 13 6.281c0 1.41.95 2.282 1.813 2.282Zm0 1c1.554 0 2.813-1.469 2.813-3.28 0-1.813-1.26-3.282-2.813-3.282C13.26 3 12 4.47 12 6.281c0 1.812 1.26 3.282 2.813 3.282Zm2.75 6.72c0 .955-.51 1.894-1.479 2.627-.97.733-2.355 1.216-3.927 1.216-1.571 0-2.956-.483-3.927-1.216-.969-.733-1.479-1.672-1.479-2.628 0-.955.51-1.894 1.48-2.627.97-.734 2.355-1.216 3.926-1.216 1.572 0 2.957.482 3.927 1.216.97.733 1.48 1.671 1.48 2.627Zm1 0c0 2.674-2.868 4.843-6.406 4.843S5.75 18.956 5.75 16.281c0-2.675 2.868-4.843 6.406-4.843s6.406 2.168 6.406 4.843Z"
  }));
};

var SvgFootprint64X64 = function SvgFootprint64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -footprint"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 13.5c0 5.397-3.72 9.5-8 9.5-4.28 0-8-4.103-8-9.5S17.72 4 22 4c4.28 0 8 4.103 8 9.5Zm1 0c0 5.799-4.03 10.5-9 10.5s-9-4.701-9-10.5S17.03 3 22 3s9 4.701 9 10.5ZM8.5 37c4.04 0 7.5-3.698 7.5-8.5S12.54 20 8.5 20 1 23.698 1 28.5 4.46 37 8.5 37Zm0 1c4.694 0 8.5-4.253 8.5-9.5S13.194 19 8.5 19 0 23.253 0 28.5 3.806 38 8.5 38Zm47-1c4.04 0 7.5-3.698 7.5-8.5S59.54 20 55.5 20 48 23.698 48 28.5s3.46 8.5 7.5 8.5Zm0 1c4.694 0 8.5-4.253 8.5-9.5S60.194 19 55.5 19 47 23.253 47 28.5s3.806 9.5 8.5 9.5ZM41 23c4.28 0 8-4.103 8-9.5S45.28 4 41 4c-4.28 0-8 4.103-8 9.5s3.72 9.5 8 9.5Zm0 1c4.97 0 9-4.701 9-10.5S45.97 3 41 3s-9 4.701-9 10.5S36.03 24 41 24Zm11 21.5c0 3.898-2.087 7.501-5.607 10.163C42.872 58.324 37.963 60 32.5 60c-5.464 0-10.372-1.676-13.893-4.337C15.087 53 13 49.398 13 45.5c0-3.898 2.087-7.501 5.607-10.163C22.128 32.676 27.037 31 32.5 31c5.464 0 10.372 1.676 13.893 4.337C49.913 38 52 41.602 52 45.5Zm1 0C53 54.06 43.822 61 32.5 61S12 54.06 12 45.5C12 36.94 21.178 30 32.5 30S53 36.94 53 45.5Z"
  }));
};

var SvgGallery104X104 = function SvgGallery104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -gallery",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.8 18h83.602a3.8 3.8 0 0 1 3.8 3.801v3.2h7.79c2.693 0 4.89 2.092 5.004 4.714l.004.214v51.143c0 2.65-2.126 4.812-4.791 4.924l-.217.004H11.009c-2.693 0-4.89-2.092-5.004-4.714L6 81.072v-6.07H3.8A3.801 3.801 0 0 1 0 71.201v-49.4A3.801 3.801 0 0 1 3.8 18zm4.22 57.002v6.07c0 1.566 1.245 2.847 2.813 2.936l.176.005h87.983c1.591 0 2.892-1.224 2.983-2.768l.005-.173V29.93c0-1.566-1.244-2.847-2.813-2.936l-.175-.005h-7.79V71.2a3.8 3.8 0 0 1-3.8 3.801H8.02zm81.182-53.201c0-.993-.807-1.801-1.8-1.801H3.8c-.992 0-1.8.808-1.8 1.801v49.4c0 .993.808 1.801 1.8 1.801h83.602c.993 0 1.8-.808 1.8-1.801v-49.4zM10.879 35.817a6.938 6.938 0 0 1 6.94-6.938 6.939 6.939 0 1 1-6.94 6.938zm11.878 0a4.938 4.938 0 0 0-4.938-4.938 4.938 4.938 0 1 0 4.938 4.938zm62.189-3.563a1 1 0 0 0-1.414-.005l-32.03 31.824-16.364-17.672-.093-.088a1 1 0 0 0-1.345.058L11.174 68.763l-.084.094a1 1 0 0 0 .08 1.32l.093.084a1 1 0 0 0 1.32-.08L34.375 48.52 50.74 66.193l.093.089a1 1 0 0 0 1.345-.059l32.764-32.555.084-.094a1 1 0 0 0-.079-1.32z",
    clipRule: "evenodd"
  }));
};

var SvgGallery16X16 = function SvgGallery16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -gallery",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.08c0-.321.259-.58.579-.58h12.754c.32 0 .58.259.58.58V4.5h1.147c.466 0 .849.371.898.848l.005.103.037 7.096c0 .492-.352.896-.805.947l-.098.006H3.939c-.466 0-.848-.37-.897-.838l-.006-.101-.032-1.366H.579A.579.579 0 0 1 0 10.616V3.08Zm3.84 8.115.033 1.352c0 .03.016.054.04.064l.026.006h11.158a.066.066 0 0 0 .061-.041l.006-.027-.037-7.095a.07.07 0 0 0-.041-.066l-.026-.005h-1.147v5.233a.58.58 0 0 1-.58.579H3.84Zm9.073-1H1V3.5h11.913v6.695ZM1.5 5.369a1.368 1.368 0 1 1 2.738 0 1.37 1.37 0 1 1-2.738 0Zm1.738 0a.369.369 0 1 0-.738 0 .369.369 0 0 0 .738 0Zm8.9-1.223a.5.5 0 0 0-.707 0L7.637 7.94l-1.64-1.77-.068-.063a.5.5 0 0 0-.65.047L2.646 8.77l-.058.07a.5.5 0 0 0 .056.637l.07.058a.5.5 0 0 0 .637-.055l2.264-2.251L7.256 9l.07.062a.5.5 0 0 0 .651-.049l4.161-4.16.058-.07a.5.5 0 0 0-.058-.638Z"
  }));
};

var SvgGallery24X24 = function SvgGallery24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -gallery",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.916 4h20.168c.506 0 .916.417.916.933V6h.576c.74 0 1.348.536 1.418 1.22l.006.13v11.3c0 .702-.565 1.278-1.287 1.344l-.137.006H2.425c-.74 0-1.35-.535-1.418-1.22L1 18.65V18H.916A.924.924 0 0 1 0 17.067V4.933C0 4.417.41 4 .916 4Zm1.1 14v.65c0 .186.14.342.326.378l.083.008h20.151a.403.403 0 0 0 .4-.309l.008-.078V7.351a.393.393 0 0 0-.326-.379l-.082-.008H22v10.103c0 .516-.41.933-.916.933H2.016Zm18.967-1.035H1.016V5.035h19.967v11.93ZM2 8A2 2 0 1 1 6 8a2 2 0 0 1-4 0Zm2.92 0A.92.92 0 1 0 3.08 8a.92.92 0 0 0 1.84 0Zm14.935-1.855a.494.494 0 0 0-.703 0l-7.69 7.734-3.508-3.809-.069-.062a.495.495 0 0 0-.646.047l-5.093 5.09-.057.07a.502.502 0 0 0 .055.637l.069.058c.193.135.46.117.633-.056l4.728-4.726 3.51 3.811.068.062c.194.145.47.13.647-.048l8.056-8.102.057-.069a.502.502 0 0 0-.057-.637Z"
  }));
};

var SvgGallery40X40 = function SvgGallery40X40(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -gallery",
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.462 1h32.154c.807 0 1.462.655 1.462 1.462v1.23h2.996c1.036 0 1.88.805 1.925 1.814l.001.082v19.67c0 1.02-.818 1.851-1.843 1.894l-.083.002H5.234c-1.035 0-1.88-.805-1.924-1.813l-.002-.082v-2.335h-.846A1.462 1.462 0 0 1 1 21.462v-19C1 1.655 1.655 1 2.462 1Zm1.623 21.924v2.335a1.14 1.14 0 0 0 1.082 1.129l.067.002h33.84c.612 0 1.112-.471 1.147-1.065l.002-.066V5.588a1.14 1.14 0 0 0-1.082-1.13l-.067-.001h-2.996v17.005c0 .807-.655 1.462-1.462 1.462H4.085ZM35.309 2.462a.693.693 0 0 0-.693-.693H2.462a.693.693 0 0 0-.693.693v19c0 .382.311.693.693.693h32.154c.382 0 .693-.311.693-.693v-19ZM5.184 7.852a2.669 2.669 0 1 1 5.337.001 2.669 2.669 0 0 1-5.337 0Zm4.569 0a1.9 1.9 0 1 0-3.798 0 1.9 1.9 0 0 0 3.798 0Zm23.919-1.37a.385.385 0 0 0-.544-.002l-12.32 12.24-6.293-6.796-.036-.035a.385.385 0 0 0-.518.023l-8.663 8.612-.033.037a.385.385 0 0 0 .03.507l.037.032c.15.118.369.108.508-.03l8.38-8.332 6.295 6.798.036.034c.15.125.375.119.517-.023L33.67 7.027l.032-.037a.385.385 0 0 0-.03-.508Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.078 3.692h-.25v.25h.25v-.25Zm4.92 1.814.25-.006v-.005l-.25.01Zm.002.082h.25v-.005l-.25.005Zm-1.843 21.564.006.25h.005l-.01-.25Zm-.083.002v.25h.005l-.005-.25ZM3.31 25.341l-.25.005v.006l.25-.011Zm-.002-.082h-.25v.005l.25-.005Zm0-2.335h.25v-.25h-.25v.25Zm.777 0v-.25h-.25v.25h.25Zm1.082 3.464-.014.25h.007l.007-.25Zm.067.002-.007.25h.007v-.25Zm34.987-1.065.25.015v-.008l-.25-.007Zm.002-.066.25.007v-.007h-.25Zm-1.082-20.8.015-.25h-.008l-.007.25Zm-.067-.002.007-.25h-.007v.25Zm-2.996 0v-.25h-.25v.25h.25Zm-2.95 2.023.176.178-.176-.178Zm.544.002.177-.176-.177.176ZM20.809 18.721l-.184.17.176.19.184-.183-.177-.177Zm-6.294-6.797.183-.17-.005-.006-.006-.006-.172.182Zm-.036-.035.172-.18-.006-.006-.006-.005-.16.191Zm-.518.023.177.177-.177-.177Zm-8.663 8.612-.177-.177-.005.006-.005.005.187.166Zm-.033.037-.186-.166-.006.005-.005.007.197.154Zm.03.507-.176.177.005.005.006.005.166-.187Zm.037.032-.166.187.006.006.006.004.154-.197Zm.508-.03.176.177-.176-.177Zm8.38-8.332.184-.17-.176-.19-.183.183.176.177Zm6.295 6.798-.184.17.006.006.006.005.172-.181Zm.036.034-.172.181.005.006.006.005.16-.192Zm.517-.023-.176-.177.176.177ZM33.67 7.027l.176.176.006-.005.005-.006-.187-.166Zm.032-.037.187.166.005-.006.005-.006-.197-.154Zm.914-6.24H2.462v.5h32.154v-.5Zm1.712 1.712c0-.945-.766-1.712-1.712-1.712v.5c.67 0 1.212.543 1.212 1.212h.5Zm0 1.23v-1.23h-.5v1.23h.5Zm2.746-.25h-2.996v.5h2.996v-.5Zm2.174 2.053c-.05-1.145-1.008-2.053-2.174-2.053v.5c.905 0 1.637.703 1.675 1.575l.5-.022Zm.002.088-.002-.083-.5.011.002.082.5-.01Zm0 19.675V5.588h-.5v19.67h.5Zm-2.082 2.144c1.155-.049 2.082-.986 2.082-2.143h-.5c0 .88-.708 1.606-1.603 1.643l.02.5Zm-.089.002.084-.002-.01-.5-.084.002.01.5Zm-33.845 0h33.84v-.5H5.234v.5ZM3.06 25.352c.05 1.145 1.008 2.052 2.174 2.052v-.5c-.905 0-1.637-.702-1.675-1.574l-.499.022Zm-.002-.088.002.082.5-.01-.002-.083-.5.01Zm0-2.34v2.335h.5v-2.335h-.5Zm-.596.25h.846v-.5h-.846v.5ZM.75 21.462c0 .945.766 1.712 1.712 1.712v-.5a1.212 1.212 0 0 1-1.212-1.212h-.5Zm0-19v19h.5v-19h-.5ZM2.462.75C1.516.75.75 1.517.75 2.462h.5c0-.67.543-1.212 1.212-1.212v-.5Zm1.873 24.509v-2.335h-.5v2.335h.5Zm.846.88a.89.89 0 0 1-.846-.88h-.5c0 .739.586 1.337 1.318 1.378l.028-.499Zm.06 0-.067-.001-.014.5.067.002.015-.5Zm33.833 0H5.234v.5h33.84v-.5Zm.898-.829a.892.892 0 0 1-.898.83v.5c.742 0 1.354-.572 1.397-1.3l-.5-.03Zm.001-.059-.002.067.5.014.002-.066-.5-.015Zm0-19.663v19.67h.5V5.588h-.5Zm-.846-.88a.89.89 0 0 1 .846.88h.5a1.39 1.39 0 0 0-1.317-1.379l-.029.5Zm-.06-.001.067.002.014-.5-.067-.002-.014.5Zm-2.99 0h2.997v-.5h-2.996v.5Zm.25 16.755V4.457h-.5v17.005h.5Zm-1.71 1.712c.945 0 1.71-.767 1.71-1.712h-.5c0 .67-.542 1.212-1.21 1.212v.5Zm-30.532 0h30.531v-.5H4.085v.5ZM34.616 2.019c.244 0 .443.199.443.443h.5a.943.943 0 0 0-.943-.943v.5Zm-32.154 0h32.154v-.5H2.462v.5Zm-.443.443c0-.244.2-.443.443-.443v-.5a.943.943 0 0 0-.943.943h.5Zm0 19v-19h-.5v19h.5Zm.443.443a.443.443 0 0 1-.443-.443h-.5c0 .52.423.943.943.943v-.5Zm32.154 0H2.462v.5h32.154v-.5Zm.443-.443a.443.443 0 0 1-.443.443v.5c.52 0 .943-.423.943-.943h-.5Zm0-19v19h.5v-19h-.5ZM7.853 4.934a2.919 2.919 0 0 0-2.919 2.919h.5a2.419 2.419 0 0 1 2.42-2.419v-.5Zm2.919 2.919a2.918 2.918 0 0 0-2.919-2.919v.5a2.418 2.418 0 0 1 2.419 2.419h.5Zm-2.919 2.919a2.919 2.919 0 0 0 2.919-2.92h-.5a2.419 2.419 0 0 1-2.419 2.42v.5Zm-2.919-2.92a2.919 2.919 0 0 0 2.92 2.92v-.5a2.419 2.419 0 0 1-2.42-2.42h-.5Zm2.92-1.648c.91 0 1.649.738 1.649 1.649h.5a2.15 2.15 0 0 0-2.15-2.15v.5Zm-1.65 1.649c0-.911.738-1.65 1.65-1.65v-.5a2.15 2.15 0 0 0-2.15 2.15h.5Zm1.65 1.65a1.65 1.65 0 0 1-1.65-1.65h-.5a2.15 2.15 0 0 0 2.15 2.15v-.5Zm1.649-1.65a1.65 1.65 0 0 1-1.65 1.65v.5a2.15 2.15 0 0 0 2.15-2.15h-.5Zm23.8-1.195a.135.135 0 0 1 .191 0l.355-.352a.635.635 0 0 0-.898-.003l.353.355Zm-12.318 12.24 12.319-12.24-.353-.355-12.319 12.24.353.355Zm-6.654-6.805 6.294 6.797.367-.34-6.294-6.796-.367.34Zm-.024-.022.035.034.345-.363-.036-.034-.345.363Zm-.17.018a.135.135 0 0 1 .181-.008l.321-.383a.635.635 0 0 0-.854.037l.353.354Zm-8.663 8.613 8.664-8.613-.353-.354-8.664 8.612.353.355Zm-.022.025.032-.037-.373-.332-.032.037.373.332Zm.021.165a.135.135 0 0 1-.01-.177l-.394-.308a.635.635 0 0 0 .05.838l.354-.353Zm.025.021-.036-.032-.332.374.036.032.332-.373Zm.166-.02a.135.135 0 0 1-.178.01l-.308.394a.635.635 0 0 0 .838-.05l-.352-.354Zm8.38-8.332-8.38 8.332.352.354 8.381-8.332-.352-.354Zm6.654 6.805-6.294-6.798-.367.34 6.294 6.798.367-.34Zm.025.023-.036-.034-.344.362.035.034.345-.362Zm.169-.019a.135.135 0 0 1-.18.008l-.322.384a.635.635 0 0 0 .854-.037l-.352-.355ZM33.493 6.849 20.892 19.37l.352.355L33.846 7.203l-.352-.354Zm.022-.025-.032.036.374.332.032-.036-.374-.332Zm-.02-.166a.135.135 0 0 1 .01.178l.394.308a.635.635 0 0 0-.05-.838l-.355.352Z",
    fill: "currentColor"
  }));
};

var SvgGallery56X56 = function SvgGallery56X56(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -gallery",
    width: 58,
    height: 38,
    viewBox: "0 0 58 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.046 1h45.017c1.13 0 2.046.916 2.046 2.047v1.722h4.194c1.45 0 2.634 1.127 2.695 2.539l.002.115v27.539c0 1.427-1.145 2.59-2.58 2.651l-.117.003H6.928c-1.45 0-2.633-1.127-2.694-2.539l-.003-.115v-3.269H3.046A2.047 2.047 0 0 1 1 29.647v-26.6C1 1.917 1.916 1 3.046 1ZM5.32 31.693v3.269c0 .843.67 1.533 1.515 1.58l.094.003h47.375c.857 0 1.558-.659 1.607-1.49l.003-.093V7.423c0-.843-.67-1.533-1.515-1.58l-.095-.004H50.11v23.808c0 1.13-.916 2.046-2.046 2.046H5.319ZM49.032 3.047a.97.97 0 0 0-.97-.97H3.047a.97.97 0 0 0-.969.97v26.6c0 .534.435.97.97.97h45.016a.97.97 0 0 0 .969-.97v-26.6ZM6.858 10.594a3.736 3.736 0 1 1 7.472 0 3.736 3.736 0 0 1-7.472 0Zm6.396 0a2.659 2.659 0 1 0-5.318 0 2.659 2.659 0 0 0 5.318 0ZM46.74 8.675a.538.538 0 0 0-.761-.002L28.732 25.809l-8.811-9.516-.05-.048a.539.539 0 0 0-.725.032L7.016 28.334l-.044.05a.539.539 0 0 0 .042.712l.05.045c.212.165.517.15.712-.043l11.733-11.665 8.812 9.517.05.048c.21.176.525.167.725-.032l17.642-17.53.045-.05a.539.539 0 0 0-.043-.711Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M50.109 4.77h-.15v.15h.15v-.15Zm6.889 2.538.15-.003v-.003l-.15.006Zm.002.115h.15V7.42l-.15.003Zm-2.58 30.19.003.15h.004l-.007-.15Zm-.117.003v.15h.004l-.004-.15Zm-50.07-2.539-.15.003v.004l.15-.007Zm-.002-.115h-.15v.003l.15-.003Zm0-3.269h.15v-.15h-.15v.15Zm1.088 0v-.15h-.15v.15h.15Zm1.515 4.85-.009.15h.004l.005-.15Zm.094.002-.004.15h.004v-.15Zm48.982-1.49.15.009v-.005l-.15-.004Zm.003-.093.15.004v-.004h-.15Zm-1.515-29.12.008-.15h-.004l-.004.15Zm-.095-.003.005-.15h-.005v.15Zm-4.194 0v-.15h-.15v.15h.15Zm-4.13 2.834.105.106-.105-.106Zm.761.002.106-.106-.106.106ZM28.732 25.809l-.11.102.105.114.11-.11-.105-.106Zm-8.811-9.516.11-.102-.007-.007-.103.109Zm-.05-.048.103-.109-.007-.006-.097.115Zm-.725.032-.106-.106.106.106ZM7.016 28.334l-.105-.106-.007.007.112.1Zm-.044.05-.113-.099-.006.007.119.093Zm.042.712-.106.106.007.006.1-.112Zm.05.045-.099.112.007.006.093-.118Zm.712-.043.105.106-.105-.106Zm11.733-11.665.11-.101-.105-.114-.11.11.105.105Zm8.812 9.517-.11.102.007.007.103-.109Zm.05.048-.104.109.008.006.096-.115Zm.725-.032.105.107-.105-.107Zm17.642-17.53.106.107.006-.007-.112-.1Zm.045-.05.112.1.006-.008-.118-.092ZM48.063.85H3.046v.3h45.017v-.3Zm2.196 2.197A2.196 2.196 0 0 0 48.063.85v.3c1.047 0 1.896.85 1.896 1.897h.3Zm0 1.722V3.047h-.3v1.722h.3Zm4.044-.15H50.11v.3h4.194v-.3Zm2.845 2.683c-.065-1.495-1.316-2.683-2.845-2.683v.3c1.372 0 2.487 1.065 2.545 2.396l.3-.013Zm.002.118-.002-.115-.3.006.002.115.3-.006Zm0 27.542V7.423h-.3v27.539h.3Zm-2.723 2.801c1.513-.063 2.723-1.291 2.723-2.801h-.3c0 1.344-1.079 2.444-2.436 2.501l.013.3Zm-.12.003.116-.003-.006-.3-.117.003.007.3Zm-47.379 0h47.375v-.3H6.928v.3Zm-2.844-2.682c.065 1.494 1.315 2.682 2.844 2.682v-.3c-1.372 0-2.487-1.066-2.545-2.395l-.3.013Zm-.003-.119.003.115.3-.006-.003-.115-.3.006Zm0-3.272v3.269h.3v-3.269h-.3Zm-1.035.15h1.185v-.3H3.046v.3ZM.85 29.647c0 1.213.984 2.196 2.196 2.196v-.3a1.897 1.897 0 0 1-1.896-1.896h-.3Zm0-26.6v26.6h.3v-26.6h-.3ZM3.046.85A2.197 2.197 0 0 0 .85 3.047h.3c0-1.048.85-1.897 1.896-1.897v-.3ZM5.47 34.962v-3.269h-.3v3.269h.3Zm1.373 1.431a1.445 1.445 0 0 1-1.373-1.431h-.3c0 .925.735 1.678 1.656 1.73l.017-.299Zm.09.003-.094-.003-.009.3.095.003.008-.3Zm47.371 0H6.928v.3h47.375v-.3Zm1.457-1.35a1.449 1.449 0 0 1-1.457 1.35v.3c.935 0 1.703-.72 1.757-1.632l-.3-.018Zm.003-.088-.003.093.3.008.003-.093-.3-.008Zm0-27.535v27.539h.3V7.423h-.3Zm-1.374-1.431c.768.044 1.374.67 1.374 1.431h.3c0-.925-.735-1.678-1.657-1.73l-.017.299Zm-.09-.003.095.003.008-.3-.094-.002-.009.3Zm-4.19 0h4.194v-.3H50.11v.3Zm.15 23.658V5.839h-.3v23.808h.3Zm-2.196 2.196a2.196 2.196 0 0 0 2.196-2.196h-.3a1.896 1.896 0 0 1-1.896 1.896v.3Zm-42.744 0h42.744v-.3H5.319v.3ZM48.063 2.227a.82.82 0 0 1 .819.82h.3a1.12 1.12 0 0 0-1.12-1.12v.3Zm-45.017 0h45.017v-.3H3.046v.3Zm-.819.82a.82.82 0 0 1 .82-.82v-.3a1.12 1.12 0 0 0-1.12 1.12h.3Zm0 26.6v-26.6h-.3v26.6h.3Zm.82.82a.82.82 0 0 1-.82-.82h-.3c0 .617.502 1.12 1.12 1.12v-.3Zm45.016 0H3.046v.3h45.017v-.3Zm.819-.82a.82.82 0 0 1-.82.82v.3a1.12 1.12 0 0 0 1.12-1.12h-.3Zm0-26.6v26.6h.3v-26.6h-.3ZM10.595 6.708a3.886 3.886 0 0 0-3.887 3.886h.3a3.586 3.586 0 0 1 3.587-3.586v-.3Zm3.885 3.886a3.886 3.886 0 0 0-3.885-3.886v.3a3.586 3.586 0 0 1 3.585 3.586h.3Zm-3.885 3.886a3.886 3.886 0 0 0 3.885-3.886h-.3a3.586 3.586 0 0 1-3.585 3.586v.3Zm-3.887-3.886a3.887 3.887 0 0 0 3.887 3.886v-.3a3.587 3.587 0 0 1-3.587-3.586h-.3Zm3.887-2.509a2.509 2.509 0 0 1 2.509 2.509h.3a2.809 2.809 0 0 0-2.81-2.809v.3Zm-2.51 2.509a2.51 2.51 0 0 1 2.51-2.509v-.3a2.81 2.81 0 0 0-2.81 2.809h.3Zm2.51 2.51a2.51 2.51 0 0 1-2.51-2.51h-.3a2.81 2.81 0 0 0 2.81 2.81v-.3Zm2.509-2.51a2.51 2.51 0 0 1-2.51 2.51v.3a2.81 2.81 0 0 0 2.81-2.81h-.3Zm32.98-1.815a.389.389 0 0 1 .55.002l.212-.212a.688.688 0 0 0-.973-.003l.211.213ZM28.838 25.915 46.084 8.78l-.211-.213-17.247 17.136.212.213Zm-9.027-9.52 8.81 9.516.221-.204-8.811-9.516-.22.204Zm-.044-.041.05.048.207-.218-.05-.047-.207.217Zm-.515.03a.389.389 0 0 1 .522-.024l.193-.23a.689.689 0 0 0-.927.04l.212.213ZM7.122 28.44l12.13-12.058-.212-.212L6.91 28.228l.212.213Zm-.038.043.045-.05-.225-.2-.045.051.225.2Zm.037.506a.389.389 0 0 1-.031-.513l-.237-.185c-.21.27-.193.66.055.91l.213-.212Zm.043.039-.05-.046-.2.225.051.045.2-.224Zm.506-.037c-.14.14-.36.15-.513.03l-.185.237c.27.21.66.193.91-.055l-.212-.212Zm11.733-11.665L7.67 28.992l.211.212L19.615 17.54l-.212-.213Zm9.028 9.521-8.812-9.516-.22.203 8.812 9.517.22-.204Zm.043.041-.05-.047-.206.217.05.048.206-.218Zm.516-.03a.389.389 0 0 1-.523.024l-.192.23a.689.689 0 0 0 .926-.04l-.211-.213ZM46.632 9.33 28.99 26.86l.211.213 17.642-17.53-.211-.213Zm.038-.044-.044.05.224.2.045-.05-.225-.2Zm-.036-.505c.14.14.15.36.03.512l.237.185a.688.688 0 0 0-.055-.909l-.212.212Z"
  }));
};

var SvgGallery72X72 = function SvgGallery72X72(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -gallery",
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63 0H60.51a2.631 2.631 0 0 1 2.63 2.631v2.215h5.393c1.865 0 3.386 1.449 3.465 3.264l.003.148v35.407c0 1.835-1.472 3.331-3.317 3.409l-.15.003H7.62c-1.864 0-3.385-1.448-3.464-3.264l-.003-.148v-4.202H2.63A2.631 2.631 0 0 1 0 36.83v-34.2A2.632 2.632 0 0 1 2.63 0Zm2.922 39.463v4.202c0 1.084.862 1.97 1.948 2.033l.121.003h60.911c1.102 0 2.003-.848 2.066-1.916l.003-.12V8.258c0-1.084-.861-1.97-1.947-2.032l-.122-.004H63.14v30.61a2.631 2.631 0 0 1-2.631 2.63H5.552ZM61.755 2.63c0-.687-.559-1.246-1.246-1.246H2.63c-.687 0-1.246.559-1.246 1.246v34.2c0 .688.559 1.247 1.246 1.247h57.878c.687 0 1.246-.56 1.246-1.247v-34.2ZM7.532 12.335a4.803 4.803 0 1 1 9.606 0 4.803 4.803 0 0 1-9.606 0Zm8.223 0a3.419 3.419 0 1 0-6.837 0 3.419 3.419 0 0 0 6.837 0Zm43.054-2.467a.692.692 0 0 0-.98-.003L35.657 31.897l-11.33-12.235-.064-.061a.693.693 0 0 0-.931.04L7.736 35.145l-.058.065a.692.692 0 0 0 .055.914l.065.058a.692.692 0 0 0 .914-.055l15.086-14.997 11.329 12.235.065.062c.27.226.674.214.931-.04l22.683-22.54.058-.064a.692.692 0 0 0-.055-.914Z"
  }));
};

var SvgGift104X104 = function SvgGift104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -gift",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M61.457 37.4h35.499c3.884 0 7.044 3.16 7.044 7.045v52.51A7.052 7.052 0 0 1 96.956 104H7.044A7.052 7.052 0 0 1 0 96.956V44.444C0 40.56 3.16 37.4 7.044 37.4h35.499c-7.893-1.925-18.679-5.178-23.548-9.467a15.958 15.958 0 0 1-5.403-11.985A15.85 15.85 0 0 1 18.277 4.67 15.857 15.857 0 0 1 29.548.008h.017a14.806 14.806 0 0 1 12.369 5.979c3.406 3.86 8.051 13.96 10.066 23.66 2.015-9.7 6.66-19.8 10.066-23.66A14.832 14.832 0 0 1 74.469.009h.019c4.221 0 8.222 1.655 11.235 4.66a15.85 15.85 0 0 1 4.685 11.279 15.96 15.96 0 0 1-5.402 11.985c-4.869 4.289-15.655 7.543-23.549 9.467zM29.584 2.008c-7.725 0-13.984 6.25-13.992 13.942a13.962 13.962 0 0 0 4.725 10.483c6.579 5.795 25.68 9.794 30.659 10.758-.426-11.004-6.455-25.284-10.567-29.91a1.265 1.265 0 0 1-.057-.07 12.802 12.802 0 0 0-10.754-5.203h-.014zM51 102H7.044A5.05 5.05 0 0 1 2 96.956V44.444A5.05 5.05 0 0 1 7.044 39.4H51V102zm51-5.045A5.05 5.05 0 0 1 96.956 102H53V39.4h43.956A5.05 5.05 0 0 1 102 44.445v52.51zM63.591 7.282c.02-.023.039-.047.057-.071a12.846 12.846 0 0 1 10.789-5.203h.015c7.689 0 13.948 6.252 13.956 13.942a13.959 13.959 0 0 1-4.725 10.482c-6.577 5.795-25.679 9.795-30.659 10.759.426-11.003 6.455-25.284 10.567-29.91z",
    clipRule: "evenodd"
  }));
};

var SvgGift16X16 = function SvgGift16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -gift",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.711 5.501h2.9A1.39 1.39 0 0 1 16 6.89v7.723a1.39 1.39 0 0 1-1.389 1.39H1.389A1.39 1.39 0 0 1 0 14.611V6.89a1.39 1.39 0 0 1 1.389-1.388H4.29c-.549-.224-1.044-.482-1.377-.775A2.699 2.699 0 0 1 4.699.002.517.517 0 0 1 4.765 0h.017a2.53 2.53 0 0 1 2.012 1.012c.413.474.869 1.376 1.206 2.372.337-.996.793-1.898 1.206-2.372a2.517 2.517 0 0 1 2.11-1.01h.003c.703 0 1.38.28 1.889.788a2.699 2.699 0 0 1-.121 3.936c-.333.293-.827.551-1.376.775zM3.498 1.498a1.699 1.699 0 0 0 .076 2.478c.714.628 2.683 1.152 3.884 1.408-.181-1.446-.923-3.159-1.426-3.725-.011-.01-.02-.023-.029-.035a1.536 1.536 0 0 0-1.286-.623c-.471 0-.898.177-1.219.497zM7.5 15.001H1.389A.39.39 0 0 1 1 14.612V6.89c0-.214.174-.388.389-.388H7.5v8.5zm7.5-.389a.39.39 0 0 1-.389.39H8.5v-8.5h6.111c.215 0 .389.173.389.387v7.723zM9.968 1.66c.011-.01.02-.023.029-.035a1.54 1.54 0 0 1 1.25-.623l.02.001a1.69 1.69 0 0 1 1.236.496 1.698 1.698 0 0 1-.076 2.478c-.714.628-2.684 1.151-3.885 1.408.181-1.446.923-3.159 1.426-3.725z",
    clipRule: "evenodd"
  }));
};

var SvgGift24X24 = function SvgGift24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -gift",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.955 8.968h4.419c.897 0 1.626.73 1.626 1.627v9.78c0 .896-.729 1.627-1.626 1.627H3.626c-.897 0-1.626-.73-1.626-1.627v-9.78c0-.898.729-1.627 1.626-1.627h4.419c-.955-.332-1.859-.739-2.4-1.215a3.283 3.283 0 0 1-1.113-2.468 3.29 3.29 0 0 1 3.286-3.283c.029.002.05.001.07 0a3.071 3.071 0 0 1 2.481 1.23c.568.65 1.203 1.955 1.631 3.351.428-1.396 1.063-2.7 1.631-3.35a3.033 3.033 0 0 1 2.565-1.23h.004c1.792 0 3.266 1.472 3.268 3.282a3.283 3.283 0 0 1-1.113 2.468c-.541.476-1.445.883-2.4 1.215ZM14.394 3.88a2.084 2.084 0 0 1 1.743-.878c.017.001.033.002.045 0a2.289 2.289 0 0 1 2.286 2.284 2.283 2.283 0 0 1-.774 1.717c-.96.845-3.651 1.54-5.161 1.852.192-1.896 1.19-4.22 1.861-4.975Zm-6.558-.878a2.293 2.293 0 0 0-2.304 2.284 2.283 2.283 0 0 0 .774 1.717c.96.845 3.651 1.54 5.161 1.852-.192-1.896-1.19-4.22-1.861-4.975a2.097 2.097 0 0 0-1.769-.878h-.001Zm3.664 18H3.626A.627.627 0 0 1 3 20.375V10.595c0-.346.281-.627.626-.627H11.5v11.034Zm9.5-.627a.627.627 0 0 1-.626.627H12.5V9.967h7.874c.345 0 .626.281.626.627v9.78Z",
    fill: "currentColor"
  }));
};

var SvgGoal104X104 = function SvgGoal104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -goal",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m74.414 3.49-9.716 15.127A1 1 0 0 0 65 19.998l15.128 9.716-37.17 8.097-5.712-26.224 37.17-8.096zm8.497 27.664-39.529 8.611 7.209 33.094c.8-.031 1.603-.047 2.409-.047 21.11 0 40.37 10.774 51.601 28.235 1.09 1.696-.181 3.953-2.191 3.953H3.59c-2.01 0-3.282-2.257-2.191-3.953 10.441-16.231 27.817-26.684 47.17-28.076l-7.354-33.757-6.132-28.154-.006-.024a1 1 0 0 1 .765-1.19l40.506-8.823c.87-.19 1.535.768 1.054 1.517l-10.48 16.316 16.317 10.48c.75.481.543 1.628-.328 1.818zM102.41 103c.443 0 .735-.519.509-.871-10.868-16.895-29.497-27.317-49.92-27.317-20.422 0-39.05 10.421-49.918 27.317-.227.352.066.871.509.871h98.82z",
    clipRule: "evenodd"
  }));
};

var SvgGoal16X16 = function SvgGoal16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -goal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.424 2.753a.5.5 0 0 0 .15.691l1.508.968-4.289.935-.69-3.167 4.29-.934-.969 1.507zM7.93 10.562l-.923-4.238 5.468-1.192a.5.5 0 0 0 .164-.909l-2.102-1.35 1.35-2.102a.5.5 0 0 0-.527-.759L5.423 1.305a.5.5 0 0 0-.403.6l1.9 8.719a9.363 9.363 0 0 0-6.804 4.252A.733.733 0 0 0 .734 16h14.533c.573 0 .931-.638.619-1.124a9.358 9.358 0 0 0-7.957-4.314zM14.76 15a8.352 8.352 0 0 0-6.758-3.439 8.352 8.352 0 0 0-6.759 3.44H14.76z",
    clipRule: "evenodd"
  }));
};

var SvgGoal24X24 = function SvgGoal24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -goal",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.317 3.246-1.401 2.182a.5.5 0 0 0 .15.69l2.18 1.4-5.876 1.28-.93-4.271 5.877-1.28ZM11.804 15.38l-1.22-5.604 7.055-1.538a.5.5 0 0 0 .164-.909l-2.775-1.782 1.782-2.776a.5.5 0 0 0-.527-.759L8.75 3.654l-.012.002a.5.5 0 0 0-.382.595l2.438 11.189a11.727 11.727 0 0 0-8.669 5.342c-.338.526.051 1.22.672 1.22h18.408c.62 0 1.01-.694.671-1.22a11.72 11.72 0 0 0-10.072-5.402ZM20.82 21A10.717 10.717 0 0 0 12 16.378a10.717 10.717 0 0 0-8.819 4.623h17.64Z",
    fill: "currentColor"
  }));
};

var SvgGraduation104X104 = function SvgGraduation104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -graduation",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.643 42.865.688 41.91c-.949-.307-.905-1.644.062-1.89l51-12.988c.164-.041.336-.041.5 0l51 12.988c.967.246 1.011 1.583.062 1.89L78.5 49.94v16.745c0 .412-.26.78-.652.923l-25.5 9.33a1.015 1.015 0 0 1-.696 0l-25.5-9.33a.986.986 0 0 1-.652-.923V49.94L5.643 43.513v32.359a.993.993 0 0 1-1 .985c-.553 0-1-.44-1-.985V42.865zM27.5 50.587V66L52 74.964 76.5 66V50.587l-24.188 7.83a1.015 1.015 0 0 1-.624 0L27.5 50.586zm71.948-9.501L52 29.003 4.552 41.086 52 56.444l47.448-15.358z",
    clipRule: "evenodd"
  }));
};

var SvgGraduation16X16 = function SvgGraduation16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -graduation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.156 9.266a.51.51 0 0 1-.312 0L4.75 8.27v1.536L8 10.988l3.25-1.182V8.27l-3.094.996zM12.25 7.95l3.406-1.097a.487.487 0 0 0-.03-.939l-7.5-1.897a.51.51 0 0 0-.251 0l-7.5 1.897a.487.487 0 0 0-.031.94l.191.061v4.575c0 .27.224.49.5.49s.5-.22.5-.49V7.236l2.215.713v2.197c0 .205.13.388.326.46l3.75 1.363a.51.51 0 0 0 .348 0l3.75-1.364a.49.49 0 0 0 .326-.459V7.95zm-7.852-.822-2.123-.683L8 4.995l5.724 1.449-5.724 1.842-3.584-1.154a.492.492 0 0 0-.017-.005z",
    clipRule: "evenodd"
  }));
};

var SvgGraduation24X24 = function SvgGraduation24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -graduation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.821 10.107.344 9.95c-.474-.156-.452-.835.03-.96l11.5-2.974a.5.5 0 0 1 .251 0l11.5 2.974c.483.125.505.804.031.96l-5.406 1.777v3.636a.5.5 0 0 1-.326.469l-5.75 2.137a.5.5 0 0 1-.348 0l-5.75-2.137a.5.5 0 0 1-.326-.47v-3.635l-3.929-1.291v7.03a.5.5 0 1 1-1 0v-7.36Zm5.607.79a.516.516 0 0 0-.043-.014L2.276 9.532 12 7.017l9.724 2.515-4.113 1.352a.489.489 0 0 0-.034.011L12 12.73l-5.572-1.832Zm.322 1.16v2.958L12 16.966l5.25-1.951v-2.96l-5.094 1.676a.499.499 0 0 1-.312 0L6.75 12.056Z",
    fill: "currentColor"
  }));
};

var SvgHanger104X104 = function SvgHanger104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -hanger"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.01 9.77c-3.231 2.896-5.173 6.724-5 10.587a1 1 0 0 1-1.997.09c-.208-4.605 2.104-8.977 5.663-12.166C42.241 5.088 47.14 3 52.288 3c5.128 0 9.797 2.317 13.172 5.607C68.824 11.887 71 16.23 71 20.402c0 4.041-1.353 8.677-4.417 12.32-2.935 3.49-7.396 6.015-13.583 6.259V45h2.9c7.675 1.738 10.01 8.589 11.617 13.345 1.913 5.671 2.969 8.798 10.483 8.798 20.566 0 26 18.458 26 28.214V101H0v-5.643c0-9.756 5.434-28.214 26-28.214 7.509 0 8.564-3.127 10.478-8.798C38.085 53.59 40.42 46.738 48.1 45H51v-7a1 1 0 0 1 1-1h.011c6.129 0 10.343-2.356 13.041-5.565C67.775 28.198 69 24.035 69 20.402c0-3.504-1.856-7.36-4.936-10.363C60.994 7.047 56.807 5 52.288 5c-4.619 0-9.05 1.88-12.277 4.77ZM102 99v-3.643c0-4.582-1.291-11.22-4.947-16.649-3.585-5.324-9.484-9.565-19.053-9.565-4.013 0-6.799-.835-8.779-2.881-1.76-1.82-2.631-4.403-3.507-7.002l-.092-.274c-1.638-4.85-3.667-10.45-9.954-11.986h-7.336c-6.292 1.535-8.321 7.136-9.959 11.985l-.093.275c-.875 2.599-1.745 5.182-3.505 7.001-1.98 2.046-4.764 2.882-8.775 2.882-9.569 0-15.467 4.241-19.053 9.565C3.29 84.137 2 90.775 2 95.358V99h100Z"
  }));
};

var SvgHanger16X16 = function SvgHanger16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -hanger"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.586 2.102c-.39.37-.604.84-.585 1.289a.5.5 0 1 1-.999.042c-.034-.796.343-1.532.896-2.057C6.452.851 7.22.5 8.04.5c.832 0 1.57.397 2.092.935.517.534.868 1.256.868 1.977 0 .66-.207 1.42-.69 2.028-.412.52-1.015.91-1.81 1.025V7.5h.563c1.106.248 1.443 1.227 1.675 1.906.276.81.428 1.257 1.512 1.257 2.834 0 3.676 2.407 3.745 3.837.003.067.005.132.005.194v.806H0v-.806c0-.062.002-.127.005-.194.07-1.43.911-3.837 3.745-3.837 1.083 0 1.235-.446 1.511-1.257.232-.68.569-1.658 1.676-1.906H7.5V6a.5.5 0 0 1 .5-.5h.002c.736 0 1.217-.294 1.526-.682.32-.404.472-.937.472-1.406 0-.408-.209-.891-.587-1.281C9.04 1.745 8.548 1.5 8.04 1.5a2.15 2.15 0 0 0-1.454.602ZM8 8.5h-.934c-.432.138-.619.527-.858 1.229l-.025.072c-.113.338-.287.855-.66 1.236-.476.489-1.106.626-1.773.626-1.13 0-1.767.477-2.16 1.055-.38.56-.55 1.25-.584 1.782h13.988c-.034-.531-.204-1.223-.584-1.782-.393-.578-1.03-1.055-2.16-1.055-.668 0-1.297-.137-1.774-.626-.373-.38-.546-.898-.66-1.236L9.79 9.73c-.239-.702-.426-1.091-.858-1.229H8Z"
  }));
};

var SvgHanger24X24 = function SvgHanger24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -hanger"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.235 4.5c-.485.46-.758 1.05-.733 1.623a.5.5 0 1 1-1 .043c-.039-.922.397-1.778 1.044-2.392.649-.615 1.546-1.024 2.502-1.024.966 0 1.827.461 2.438 1.091.607.627 1.014 1.47 1.014 2.303 0 .773-.243 1.663-.806 2.372-.494.623-1.223 1.086-2.194 1.204v.53h.25c1.476.341 1.925 1.687 2.234 2.621.368 1.114.571 1.729 2.016 1.729 3.955 0 5 3.625 5 5.542v1.108H2v-1.108C2 18.225 3.045 14.6 7 14.6c1.444 0 1.647-.615 2.015-1.729.309-.934.758-2.28 2.235-2.621h.25v-1a.5.5 0 0 1 .5-.5h.002c.915 0 1.52-.367 1.91-.856.4-.505.588-1.167.588-1.75 0-.52-.265-1.125-.732-1.607-.463-.478-1.078-.787-1.72-.787-.672 0-1.33.291-1.813.75Zm3.8 8.685c-.323-.976-.626-1.703-1.412-1.935h-1.246c-.788.232-1.09.96-1.413 1.935l-.03.09c-.155.476-.361 1.106-.797 1.566-.545.575-1.282.759-2.137.759-1.61 0-2.56.71-3.148 1.602-.623.944-.852 2.125-.852 2.94v.108h18v-.108c0-.815-.23-1.995-.852-2.94C19.56 16.31 18.611 15.6 17 15.6c-.856 0-1.592-.182-2.138-.758-.435-.46-.642-1.09-.798-1.566l-.03-.09Z"
  }));
};

var SvgHanger64X64 = function SvgHanger64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -hanger"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.313 7.819c-1.805 1.712-2.905 3.991-2.807 6.308a.5.5 0 0 1-.999.042c-.114-2.664 1.15-5.209 3.117-7.076C26.595 5.226 29.306 4 32.16 4c2.842 0 5.425 1.36 7.289 3.283 1.86 1.92 3.051 4.451 3.051 6.865 0 2.352-.744 5.055-2.432 7.18-1.625 2.046-4.108 3.534-7.568 3.663V28h1.9c4.723.993 6.16 4.908 7.149 7.626 1.177 3.24 1.827 5.027 6.451 5.027 12.656 0 16 10.547 16 16.123V60H0v-3.224C0 51.2 3.344 40.653 16 40.653c4.62 0 5.27-1.786 6.448-5.027.989-2.718 2.426-6.633 7.152-7.626h1.9v-3.5a.5.5 0 0 1 .5-.5h.006c3.41 0 5.765-1.388 7.279-3.294 1.527-1.922 2.215-4.396 2.215-6.558 0-2.1-1.05-4.393-2.77-6.169C37.015 6.207 34.679 5 32.16 5c-2.572 0-5.043 1.108-6.847 2.819Zm15.296 28.149c-.997-2.74-2.267-6.068-6.316-6.968h-4.586c-4.052.9-5.323 4.228-6.32 6.968l-.05.139c-.545 1.501-1.072 2.954-2.13 3.97-1.157 1.11-2.785 1.576-5.207 1.576-6.003 0-9.704 2.48-11.937 5.558C1.795 50.338 1 54.15 1 56.776V59h62v-2.224c0-2.626-.795-6.438-3.063-9.565-2.233-3.078-5.934-5.558-11.937-5.558-2.423 0-4.052-.466-5.21-1.577-1.058-1.015-1.586-2.468-2.13-3.97l-.051-.139Z"
  }));
};

var SvgHealthcare104X104 = function SvgHealthcare104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -healthcare",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.956 0A7.044 7.044 0 0 1 104 7.044V35.04c-.702 30.332-20.998 57.38-51.66 68.896a1.002 1.002 0 0 1-.703 0C20.982 92.415.696 65.368 0 35.017V7.044A7.044 7.044 0 0 1 7.045 0h89.911ZM102 35.017V7.044A5.044 5.044 0 0 0 96.956 2H7.045A5.044 5.044 0 0 0 2 7.044v27.95c.673 29.374 20.276 55.622 49.99 66.937C81.707 90.621 101.32 64.372 102 35.017Zm-62.187-6.66C32.4 28.474 26.5 34.559 26.616 41.95c0 10.896 8.463 21.972 24.808 33.509a1 1 0 0 0 1.154 0c16.344-11.537 24.807-22.613 24.807-33.524.114-7.377-5.784-13.462-13.176-13.579h-.021a14.15 14.15 0 0 0-12.187 7.079 14.152 14.152 0 0 0-12.188-7.08ZM75.385 41.92c0 9.99-7.9 20.448-23.384 31.497-15.486-11.048-23.385-21.508-23.385-31.481-.098-6.303 4.92-11.48 11.208-11.58a12.143 12.143 0 0 1 11.245 7.75c.33.85 1.533.85 1.864 0a12.149 12.149 0 0 1 11.254-7.75c6.284.106 11.295 5.28 11.198 11.564Z",
    fill: "currentColor"
  }));
};

var SvgHealthcare16X16 = function SvgHealthcare16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -healthcare",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.998 14.965c4.165-1.637 6.906-5.337 7.002-9.474V1.389A.39.39 0 0 0 14.611 1H1.389A.39.39 0 0 0 1 1.389v4.114c.095 4.125 2.835 7.824 6.998 9.462zM1.389 0h13.222A1.39 1.39 0 0 1 16 1.389v4.114c-.107 4.617-3.179 8.72-7.826 10.466a.506.506 0 0 1-.352 0C3.176 14.222.106 10.118 0 5.514V1.389A1.39 1.39 0 0 1 1.389 0zm3.525 6.512c0 1.29 1.038 2.7 3.086 4.202 2.048-1.503 3.086-2.913 3.086-4.194A1.326 1.326 0 0 0 9.79 5.17c-.59.005-1.11.363-1.324.915-.149.384-.783.384-.932 0a1.426 1.426 0 0 0-1.329-.915 1.322 1.322 0 0 0-1.291 1.342zM9.797 4.17h.004a2.325 2.325 0 0 1 2.285 2.358c0 1.7-1.242 3.406-3.797 5.21a.503.503 0 0 1-.578 0C5.156 9.934 3.914 8.228 3.914 6.52a2.323 2.323 0 0 1 2.285-2.35c.708.003 1.352.3 1.801.795a2.417 2.417 0 0 1 1.797-.795z",
    clipRule: "evenodd"
  }));
};

var SvgHealthcare24X24 = function SvgHealthcare24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -healthcare",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.374 2C21.272 2 22 2.728 22 3.626v5.222c-.134 5.782-3.998 10.931-9.826 13.12a.5.5 0 0 1-.352 0C5.995 19.778 2.132 14.628 2 8.836v-5.21C2 2.728 2.728 2 3.626 2h16.748ZM21 8.836v-5.21A.626.626 0 0 0 20.374 3H3.626A.626.626 0 0 0 3 3.626v5.199c.122 5.304 3.642 10.053 8.998 12.14 5.357-2.086 8.88-6.835 9.002-12.129ZM9.731 7.282a2.81 2.81 0 0 0-2.773 2.851c0 2.153 1.634 4.291 4.754 6.494a.5.5 0 0 0 .576 0c3.12-2.203 4.754-4.341 4.754-6.502a2.806 2.806 0 0 0-2.763-2.843h-.01A2.95 2.95 0 0 0 12 8.364a2.95 2.95 0 0 0-2.269-1.082Zm6.311 2.835c0 1.702-1.353 3.53-4.042 5.486-2.689-1.955-4.042-3.784-4.042-5.478a1.81 1.81 0 0 1 1.779-1.843c.79.004 1.507.498 1.797 1.243a.5.5 0 0 0 .932 0 1.95 1.95 0 0 1 1.802-1.243c.996.019 1.79.84 1.774 1.835Z",
    fill: "currentColor"
  }));
};

var SvgHeart104X104 = function SvgHeart104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -heart",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.003 31.122C-.227 16.374 11.63 4.233 26.507 4 37.43 4.053 47.287 10.288 52 19.923 56.714 10.288 66.57 4.053 77.493 4h.021c14.857.233 26.713 12.374 26.483 27.107 0 22.21-17.5 44.943-51.42 68.711a1.004 1.004 0 0 1-1.154 0C17.503 76.05.003 53.317.003 31.122ZM52 97.792c33.062-23.285 49.997-45.407 49.997-66.7.213-13.649-10.756-24.885-24.504-25.107-10.88.057-20.62 6.71-24.56 16.778-.331.844-1.535.844-1.865 0-3.942-10.071-13.687-16.725-24.55-16.778C12.765 6.201 1.791 17.44 2.003 31.107c0 21.278 16.936 43.4 49.997 66.684Z",
    fill: "currentColor"
  }));
};

var SvgHeart16X16 = function SvgHeart16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -heart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 4.69C-.035 2.14 1.864.04 4.254 0 5.778.008 7.173.832 8 2.15 8.83.832 10.223.008 11.748 0h.01c2.38.04 4.279 2.14 4.242 4.683 0 3.68-2.638 7.38-7.711 11.219a.473.473 0 0 1-.577 0C2.64 12.064 0 8.363.001 4.69zm8 10.116c4.643-3.575 7-6.945 7-10.131.028-1.958-1.427-3.57-3.252-3.603-1.454.01-2.755.97-3.282 2.422a.489.489 0 0 1-.932 0C7.007 2.04 5.704 1.08 4.258 1.072 2.431 1.102.973 2.715 1 4.682c0 3.18 2.357 6.549 7 10.124z",
    clipRule: "evenodd"
  }));
};

var SvgHeart24X24 = function SvgHeart24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -heart",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.012C1.955 5.015 4.302 2.547 7.253 2.5A5.6 5.6 0 0 1 12 5.204 5.6 5.6 0 0 1 16.747 2.5h.01c2.94.047 5.288 2.515 5.242 5.504 0 4.378-3.318 8.804-9.711 13.403a.492.492 0 0 1-.577 0c-6.393-4.6-9.71-9.025-9.71-13.395Zm10 12.353c5.963-4.35 8.999-8.46 8.999-12.37.037-2.431-1.866-4.435-4.252-4.476-1.897.011-3.594 1.203-4.281 3.005a.497.497 0 0 1-.932 0c-.688-1.804-2.388-2.996-4.277-3.005-2.388.038-4.294 2.043-4.256 4.485 0 3.9 3.035 8.011 8.998 12.361Z",
    fill: "currentColor"
  }));
};

var SvgHeartFilled104X104 = function SvgHeartFilled104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -heart-filled",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26.507 4C11.629 4.233-.226 16.374.003 31.122c0 22.195 17.5 44.928 51.42 68.696.346.243.808.243 1.154 0 33.92-23.768 51.42-46.501 51.42-68.71C104.227 16.373 92.371 4.232 77.514 4h-.02C66.57 4.053 56.713 10.288 52 19.923 47.286 10.288 37.43 4.053 26.507 4Z",
    fill: "currentColor"
  }));
};

var SvgHeartFilled16X16 = function SvgHeartFilled16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -heart-filled",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.253 0C1.863.04-.036 2.14 0 4.69c0 3.673 2.638 7.373 7.711 11.212.173.13.404.13.577 0C13.362 12.064 16 8.363 16 4.682 16.037 2.14 14.138.04 11.758 0h-.01C10.223.008 8.828.832 8 2.15 7.172.832 5.778.008 4.253 0Z",
    fill: "currentColor"
  }));
};

var SvgHeartFilled24X24 = function SvgHeartFilled24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -heart-filled",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.252 2.5c-2.95.047-5.298 2.515-5.251 5.512 0 4.37 3.317 8.796 9.71 13.395a.492.492 0 0 0 .577 0c6.393-4.6 9.71-9.025 9.71-13.403.047-2.989-2.3-5.457-5.24-5.504h-.01A5.6 5.6 0 0 0 12 5.204 5.6 5.6 0 0 0 7.252 2.5Z",
    fill: "currentColor"
  }));
};

var SvgHome104X104 = function SvgHome104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -home",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m52 2.377 36.995 34.079v65.537H67.137V67.084c0-.554-.449-1.003-1.002-1.003h-27.27c-.554 0-1.002.45-1.002 1.003v34.909H16.005v-65.84a1 1 0 0 0-.132-.497L52 2.376zm.674-2.113 37.93 34.94c.05.039.096.081.138.128l12.932 11.912c.408.376.437 1.015.065 1.427a.993.993 0 0 1-1.413.065L91 38.303v64.694c0 .554-.449 1.003-1.003 1.003H66.135c-.21 0-.406-.065-.567-.175a.987.987 0 0 1-.561.175H15.003A1.003 1.003 0 0 1 14 102.997V37.382L1.674 48.736a.993.993 0 0 1-1.413-.065 1.017 1.017 0 0 1 .065-1.427l51-46.98a.993.993 0 0 1 1.348 0zM39.868 102h25.139c.042 0 .084.002.125.007v-33.92H39.868V102z",
    clipRule: "evenodd"
  }));
};

var SvgHome16X16 = function SvgHome16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.163 7.711a.5.5 0 0 0 .674-.738L8.337.13a.5.5 0 0 0-.674 0l-7.5 6.842a.5.5 0 0 0 .674.738L2 6.651v8.848a.5.5 0 0 0 .5.5h3.48A.45.45 0 0 0 6 16h4a.45.45 0 0 0 .02 0h3.48a.5.5 0 0 0 .5-.5V6.65l1.163 1.061zM9.5 15v-4.264h-3V15h3zM3 15V5.737l5-4.561 5 4.561V15h-2.5v-4.763a.5.5 0 0 0-.5-.5H6a.5.5 0 0 0-.5.5V15H3z",
    clipRule: "evenodd"
  }));
};

var SvgHome24X24 = function SvgHome24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -home"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M9.485 22H5.033a.5.5 0 0 1-.5-.5V9.988l-1.696 1.548a.5.5 0 0 1-.674-.739l9.5-8.667a.5.5 0 0 1 .674 0l9.5 8.667a.5.5 0 0 1-.674.739l-1.696-1.547V21.5a.5.5 0 0 1-.5.5H9.485zm.482-1h4.066v-5.667H9.967V21zm8.5-11.924L12 3.176l-6.467 5.9a.51.51 0 0 1 0 .015v11.91h3.434v-6.168a.5.5 0 0 1 .5-.5h5.066a.5.5 0 0 1 .5.5V21h3.434V9.076z"
  }));
};

var SvgHouse104X104 = function SvgHouse104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -house",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M96.956 0A7.044 7.044 0 0 1 104 7.044V35.04c-.702 30.332-20.997 57.38-51.66 68.896a1.002 1.002 0 0 1-.703 0C20.982 92.415.696 65.368 0 35.017V7.044A7.044 7.044 0 0 1 7.045 0h89.911zM102 35.017V7.044A5.044 5.044 0 0 0 96.956 2H7.045A5.044 5.044 0 0 0 2 7.044v27.95c.673 29.374 20.276 55.622 49.99 66.937C81.707 90.621 101.32 64.372 102 35.017zm-22.44 7.458a1 1 0 0 1-1.413.065l-5.479-4.998v33.432a1 1 0 0 1-1 1H32.332a1 1 0 0 1-1-1V37.542l-5.478 4.998a1 1 0 0 1-1.348-1.477l26.82-24.468a1 1 0 0 1 1.348 0l26.821 24.468a1 1 0 0 1 .065 1.412zm-33.712 27.5h12.304V53.151H45.848v16.822zM52 18.686l18.678 17.039c-.006.045-.01.09-.01.137v34.111H60.152V52.152a1 1 0 0 0-1-1H44.848a1 1 0 0 0-1 1v17.822H33.332V35.942c0-.07-.007-.139-.02-.205L52 18.687z",
    clipRule: "evenodd"
  }));
};

var SvgHouse16X16 = function SvgHouse16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -house",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.998 14.965c4.165-1.637 6.906-5.337 7.002-9.474V1.389A.39.39 0 0 0 14.611 1H1.389A.39.39 0 0 0 1 1.389v4.114c.095 4.125 2.835 7.824 6.998 9.462zM1.389 0h13.222A1.39 1.39 0 0 1 16 1.389v4.114c-.107 4.617-3.179 8.72-7.826 10.466a.506.506 0 0 1-.352 0C3.176 14.222.106 10.118 0 5.514V1.389A1.39 1.39 0 0 1 1.389 0zm8.163 10.29h.84V5.761L8 3.58 5.608 5.761v4.53h.84V8.021a.5.5 0 0 1 .5-.5h2.104a.5.5 0 0 1 .5.5v2.268zm-1 0H7.448V8.522h1.104v1.768zm-.888-7.758a.5.5 0 0 1 .673 0l3.945 3.598a.5.5 0 0 1-.674.74l-.215-.196v4.116a.5.5 0 0 1-.5.5H5.108a.5.5 0 0 1-.5-.5V6.674l-.215.196a.5.5 0 1 1-.674-.74l3.945-3.598z",
    clipRule: "evenodd"
  }));
};

var SvgHouse24X24 = function SvgHouse24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -house",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M13.352 16.034H8.336a.5.5 0 0 1-.5-.5v-5.517l-.495.452a.5.5 0 0 1-.674-.738l4.996-4.558a.5.5 0 0 1 .674 0l4.996 4.558a.5.5 0 0 1-.674.738l-.496-.452v5.517a.5.5 0 0 1-.5.5h-2.31zm-.52-1V12.53h-1.664v2.505h1.664zM8.836 9.105v5.929h1.332v-3.005a.5.5 0 0 1 .5-.5h2.664a.5.5 0 0 1 .5.5v3.005h1.331V9.105L12 6.22 8.836 9.105zM20.374 2C21.272 2 22 2.728 22 3.626v5.222c-.134 5.782-3.998 10.931-9.826 13.12a.5.5 0 0 1-.352 0C5.995 19.778 2.132 14.628 2 8.836v-5.21C2 2.728 2.728 2 3.626 2h16.748zM21 8.836v-5.21A.626.626 0 0 0 20.374 3H3.626A.626.626 0 0 0 3 3.626v5.199c.122 5.304 3.642 10.054 8.998 12.14 5.357-2.086 8.88-6.835 9.002-12.129z"
  }));
};

var SvgKey104X104 = function SvgKey104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -key",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30.978 58.386a1 1 0 0 0-.298.712v5.467h-9.227a1 1 0 0 0-1 1v9.21h-9.226a1 1 0 0 0-1 1v9.209H4.409a1 1 0 0 0-.706.292l-3.41 3.403a1 1 0 0 0-.293.708V103a1 1 0 0 0 1 1h13.635c.266 0 .521-.107.71-.295l43.472-43.737c15.526 7.31 34.134.929 41.844-14.483A31.591 31.591 0 0 0 94.949 9.22l-.01-.009C82.54-3.11 62.48-3.064 50.139 9.317a31.59 31.59 0 0 0-6.042 36.136L30.978 58.385zM98.873 44.59c-7.325 14.641-25.15 20.583-39.816 13.272a1 1 0 0 0-1.155.19L14.219 102H2v-12.2l2.823-2.817h6.404a1 1 0 0 0 1-1v-9.21h9.226a1 1 0 0 0 1-1v-9.21h9.227a1 1 0 0 0 1-1v-6.048l13.338-13.15a1 1 0 0 0 .187-1.17 29.59 29.59 0 0 1 5.35-34.467C63.115-.87 81.906-.915 93.524 10.626a29.59 29.59 0 0 1 5.348 33.965zM80.794 29.815c3.63 0 6.572-2.937 6.572-6.561s-2.942-6.561-6.572-6.561-6.572 2.937-6.572 6.56 2.942 6.562 6.572 6.562z",
    clipRule: "evenodd"
  }));
};

var SvgKey16X16 = function SvgKey16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -key",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.195 8.544a4.021 4.021 0 0 0 5.382-1.794 3.998 3.998 0 0 0-.721-4.588 4.021 4.021 0 0 0-5.672.015 3.988 3.988 0 0 0-.723 4.658.498.498 0 0 1-.093.585L5.512 9.25v.742a.5.5 0 0 1-.5.5H4.008v1.002a.5.5 0 0 1-.5.5H2.504v1a.5.5 0 0 1-.5.5h-.796L1 13.704v1.295h1.297l6.321-6.36a.5.5 0 0 1 .577-.094zm5.368-7.09.005.005a5 5 0 0 1 .904 5.738 5.025 5.025 0 0 1-6.39 2.393L2.86 15.85a.502.502 0 0 1-.355.148H.5a.5.5 0 0 1-.5-.5v-2.002c0-.133.053-.261.147-.354l.501-.501a.503.503 0 0 1 .353-.146h.503v-1.001c0-.277.223-.5.5-.5h1.004V9.992a.5.5 0 0 1 .5-.5h1.004v-.45c0-.134.053-.263.148-.356l1.754-1.73a4.985 4.985 0 0 1 1.062-5.485 5.024 5.024 0 0 1 7.087-.016zM11.268 3.77a.966.966 0 1 1 1.934.002.966.966 0 0 1-1.934-.002z",
    clipRule: "evenodd"
  }));
};

var SvgKey24X24 = function SvgKey24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -key",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.864 12.966a.5.5 0 0 0-.149.356v.704H6.31a.5.5 0 0 0-.5.5v1.402H4.405a.5.5 0 0 0-.5.5v1.401h-.77a.5.5 0 0 0-.354.146l-.635.635a.5.5 0 0 0-.146.354v2.535a.5.5 0 0 0 .5.5h2.54a.5.5 0 0 0 .355-.148l7.944-7.992a6.22 6.22 0 0 0 8.006-2.932 6.198 6.198 0 0 0-1.121-7.116 6.223 6.223 0 0 0-8.793.016 6.197 6.197 0 0 0-1.28 6.884l-2.287 2.255Zm12.587-2.487a5.22 5.22 0 0 1-6.997 2.332.5.5 0 0 0-.578.095l-8.044 8.093H3v-1.828l.342-.342h1.063a.5.5 0 0 0 .5-.5v-1.401H6.31a.5.5 0 0 0 .5-.5v-1.402h1.405a.5.5 0 0 0 .5-.5v-.995l2.391-2.358a.5.5 0 0 0 .093-.585 5.197 5.197 0 0 1 .94-6.055 5.222 5.222 0 0 1 7.373-.02 5.198 5.198 0 0 1 .939 5.966Zm-3.087-2.613a1.223 1.223 0 1 0 .002-2.445 1.223 1.223 0 0 0-.002 2.445Z",
    fill: "currentColor"
  }));
};

var SvgLamp104X104 = function SvgLamp104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -lamp",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M51.858 0c-18.282 0-33.172 13.126-35.55 29.484-1.37 10.077 1.876 20.03 8.896 27.62 5.726 6.022 8.91 14.097 8.91 22.487l-.025 13.524C34.09 99.14 39.137 104 45.37 104h13.23c6.233 0 11.28-4.86 11.28-10.883l.018-9.496.007-4.028c0-8.705 2.943-16.493 8.353-21.94C84.575 51.304 88 43.023 88 34.317 87.974 15.364 71.676 0 51.858 0zm16.01 82.621.006-3.03c0-9.205 3.133-17.499 8.932-23.338 5.946-5.974 9.163-13.752 9.163-21.934C85.945 16.49 70.575 2 51.858 2 34.6 2 20.555 14.382 18.32 29.759c-1.289 9.477 1.766 18.84 8.376 25.988 6.072 6.386 9.449 14.95 9.449 23.846l-.006 3.028h31.729zm-31.732 2h31.728l-.016 8.494c0 4.91-4.127 8.885-9.248 8.885H45.369c-5.12 0-9.249-3.975-9.249-8.883l.016-8.496z",
    clipRule: "evenodd"
  }));
};

var SvgLamp16X16 = function SvgLamp16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -lamp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.98 0C5.188 0 2.913 2.061 2.547 4.639a5.402 5.402 0 0 0 1.361 4.349 4.527 4.527 0 0 1 1.183 3.07l-.003 1.988c0 1.084.88 1.954 1.964 1.954h1.893c1.082 0 1.962-.87 1.962-1.953l.004-1.988c0-1.193.388-2.249 1.095-2.98A5.264 5.264 0 0 0 13.5 5.4C13.496 2.414 11.004 0 7.98 0zm0 1c2.488 0 4.528 1.977 4.532 4.4 0 1.11-.425 2.166-1.212 2.98-.896.926-1.377 2.235-1.377 3.678v.092H6.079v-.091a5.53 5.53 0 0 0-1.445-3.75 4.39 4.39 0 0 1-1.108-3.533C3.822 2.69 5.686 1 7.98 1zM6.078 13.15l-.002.897c0 .525.433.953.976.953h1.893a.963.963 0 0 0 .974-.954l.002-.896H6.078z",
    clipRule: "evenodd"
  }));
};

var SvgLamp24X24 = function SvgLamp24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -lamp",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.973 2C8.42 2 5.525 4.562 5.06 7.762c-.268 1.971.366 3.918 1.731 5.4a5.783 5.783 0 0 1 1.571 3.978v.734a.49.49 0 0 0 0 .03l-.004 1.754c0 1.298 1.08 2.342 2.412 2.342h2.455c1.33 0 2.412-1.044 2.412-2.341l.004-2.518c0-1.544.517-2.916 1.46-3.868A6.45 6.45 0 0 0 19 8.707C18.996 4.999 15.826 2 11.973 2Zm-2.6 16.39-.003 1.269c0 .74.623 1.341 1.4 1.341h2.455c.777 0 1.4-.602 1.4-1.342l.002-1.268H9.373Zm5.256-1v-.25c0-1.794.612-3.419 1.75-4.567a5.456 5.456 0 0 0 1.609-3.865C17.984 5.562 15.277 3 11.973 3c-3.042 0-5.517 2.19-5.91 4.9-.227 1.67.31 3.323 1.472 4.583a6.772 6.772 0 0 1 1.84 4.658v.249h5.254Z",
    fill: "currentColor"
  }));
};

var SvgLeaf104X104 = function SvgLeaf104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -leaf",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M84.133 76.325c9.28-16.437 15.73-41.649 19.784-68.149.724-4.729-3.355-8.815-8.078-8.093-26.474 4.048-51.694 10.464-68.241 19.69a43.196 43.196 0 0 0-8.749 5.796c-.329.325-.573.536-1.145 1.004l-.004.003c-.624.512-.903.752-1.238 1.087-16.571 16.268-17.04 42.79-1.203 59.64L.293 102.292a1.002 1.002 0 0 0 0 1.416 1 1 0 0 0 1.414 0l14.958-14.979c16.569 15.985 43.006 15.694 59.213-.85l.362-.37c1.102-1.103 1.6-1.651 2.122-2.427a43.498 43.498 0 0 0 5.77-8.756zM18.08 87.312c15.78 15.198 40.942 14.913 56.37-.836l.368-.377c1.041-1.041 1.476-1.523 1.913-2.179l.07-.094a41.674 41.674 0 0 0 5.566-8.44c9.149-16.208 15.554-41.243 19.574-67.513.518-3.393-2.411-6.328-5.8-5.81C69.893 6.076 44.847 12.448 28.53 21.544a41.342 41.342 0 0 0-8.325 5.496c-.334.334-.612.573-1.234 1.083l-.004.003c-.573.47-.819.68-1.098.96-15.785 15.497-16.246 40.74-1.195 56.801l54.18-54.254a1 1 0 0 1 1.414 0c.39.391.39 1.025 0 1.416L18.08 87.312z",
    clipRule: "evenodd"
  }));
};

var SvgLeaf16X16 = function SvgLeaf16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -leaf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.041 11.735c1.384-2.45 2.34-6.191 2.942-10.126A1.396 1.396 0 0 0 14.395.016c-3.932.6-7.674 1.552-10.155 2.936a6.709 6.709 0 0 0-1.343.891c-.06.059-.091.085-.168.148-.099.081-.145.12-.204.179a6.627 6.627 0 0 0-.412 9.007l-1.967 1.97a.5.5 0 0 0 .706.707l1.963-1.966a6.53 6.53 0 0 0 8.948-.366l.047-.046.02-.02c.16-.161.242-.253.328-.377.347-.411.643-.862.883-1.344zm-9.517 1.444a5.536 5.536 0 0 0 7.533-.364l.049-.048.014-.014a1.75 1.75 0 0 0 .225-.256l.034-.045a5.89 5.89 0 0 0 .781-1.187c1.318-2.335 2.252-5.987 2.836-9.808a.397.397 0 0 0-.45-.453c-3.82.584-7.474 1.514-9.84 2.833a5.804 5.804 0 0 0-1.13.739c-.063.063-.11.104-.215.19a1.8 1.8 0 0 0-.135.116 5.627 5.627 0 0 0-.404 7.586l7.702-7.712a.499.499 0 1 1 .706.707l-7.706 7.716z",
    clipRule: "evenodd"
  }));
};

var SvgLeaf24X24 = function SvgLeaf24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -leaf",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M4.723 18.565c-2.857-3.269-2.699-8.243.435-11.32.072-.072.13-.121.254-.223.099-.081.14-.116.209-.183A8.33 8.33 0 0 1 7.3 5.722C10.427 3.98 15.158 2.777 20.12 2.02a1.636 1.636 0 0 1 1.862 1.864c-.76 4.973-1.97 9.696-3.715 12.786-.3.603-.67 1.168-1.105 1.682-.108.158-.21.27-.423.484l-.066.067a8.142 8.142 0 0 1-11.246.374l-2.573 2.576a.5.5 0 0 1-.707-.706l2.577-2.582zm1.411.003a7.143 7.143 0 0 0 9.825-.366l.07-.07c.18-.181.25-.26.316-.358l.036-.048c.39-.458.722-.962 1.002-1.524 1.68-2.976 2.866-7.61 3.61-12.469a.636.636 0 0 0-.723-.725c-4.848.74-9.491 1.921-12.502 3.598a7.407 7.407 0 0 0-1.469.966c-.072.073-.129.122-.254.224a2.31 2.31 0 0 0-.183.16 7.262 7.262 0 0 0-.43 9.9l9.858-9.871a.5.5 0 1 1 .707.706l-9.863 9.877z"
  }));
};

var SvgLike104X104 = function SvgLike104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -like",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M98.234 89.784c-.955 7.834-6.206 11.143-13.677 11.143H7.045C3.154 100.927 0 97.742 0 93.813V55.44c0-3.929 3.154-7.113 7.045-7.113h23.379c.026 0 .051 0 .076.003l1.405-.479c.23-.063.625-.19 1.097-.357a33.291 33.291 0 0 0 2.25-.895 35.32 35.32 0 0 0 6.414-3.64c6.511-4.67 9.925-10.861 9.925-17.945V8.29c0-.484.34-.9.811-.992 3.85-.747 7.672-.454 10.557 1.69 2.995 2.22 4.476 6.246 4.476 11.878v18.873a.93.93 0 0 0 .918.927h24.679a.994.994 0 0 1 .205-.02c2.305 0 4.49.709 6.338 2.063 3.271 2.382 4.948 6.62 4.281 10.805L98.24 89.685l-.006.099zm-68.81-39.437H7.045C4.258 50.347 2 52.627 2 55.441v38.372c0 2.814 2.258 5.094 5.045 5.094h27.004a11.055 11.055 0 0 1-4.625-9.013V50.347zm10.88 48.56c-4.906-.023-8.88-4.053-8.88-9.013V50.147l1.068-.365c.74-.204 2.062-.673 3.558-1.33a37.297 37.297 0 0 0 6.775-3.847c7.02-5.035 10.766-11.827 10.766-19.59V9.142c3.07-.46 6.043-.118 8.184 1.473 2.402 1.78 3.66 5.202 3.66 10.25V39.74c0 1.622 1.311 2.947 2.918 2.947h24.884a.992.992 0 0 0 .195-.02 8.634 8.634 0 0 1 4.97 1.68c2.652 1.93 4.028 5.406 3.478 8.851L96.254 89.44l-.012.158c-.83 6.609-5.136 9.31-11.685 9.31H40.305z",
    clipRule: "evenodd"
  }));
};

var SvgLike16X16 = function SvgLike16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -like",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.064 6.066c.412 0 .806.124 1.138.358.59.413.89 1.144.772 1.862l-.821 5.057-.004.068c-.166 1.31-1.104 1.88-2.362 1.88H6.286c-.136 0-.27-.014-.397-.04a.51.51 0 0 1-.197.04H1.388C.621 15.29 0 14.685 0 13.939V8.505c0-.745.622-1.35 1.388-1.35h3.394L4.95 7.1c.326-.088.84-.305 1.325-.641.868-.6 1.312-1.375 1.312-2.263V1.828a.49.49 0 0 1 .405-.477c.653-.122 1.305-.074 1.828.3.545.39.802 1.062.802 1.958V6.07H14a.518.518 0 0 1 .064-.004zM4.327 8.128H1.388A.383.383 0 0 0 1 8.505v5.434c0 .21.174.38.388.38h3.19a1.856 1.856 0 0 1-.251-.934V8.128zm1 5.257c0 .515.43.934.959.934h6.5c.808 0 1.277-.285 1.367-.967l.006-.084.827-5.135a.94.94 0 0 0-.37-.92.941.941 0 0 0-.5-.173.52.52 0 0 1-.052.003h-3.66a.773.773 0 0 1-.782-.76V3.608c0-.616-.146-.997-.394-1.175-.162-.115-.389-.167-.641-.167v1.93c0 1.214-.61 2.278-1.732 3.054a5.688 5.688 0 0 1-1.528.755v5.379z",
    clipRule: "evenodd"
  }));
};

var SvgLike24X24 = function SvgLike24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -like",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M9.31 20.942a.497.497 0 0 1-.233.058h-5.45C2.727 21 2 20.27 2 19.371v-7.09c0-.9.728-1.63 1.626-1.63h4.32l.225-.075c.436-.123 1.093-.41 1.723-.859 1.132-.805 1.716-1.855 1.716-3.058v-3.09a.5.5 0 0 1 .404-.492c.79-.155 1.587-.095 2.213.366.651.479.962 1.317.962 2.448v3.345h4.428a.504.504 0 0 1 .064-.004c.495 0 .967.152 1.364.441.708.51 1.067 1.412.924 2.3l-1.042 6.62-.004.072c-.2 1.631-1.325 2.335-2.859 2.335H9.83c-.179 0-.352-.02-.52-.058zm-1.403-.944a2.345 2.345 0 0 1-.426-1.351v-6.994H3.626a.626.626 0 0 0-.626.628v7.09c0 .347.28.627.626.627h4.28zm.574-1.351a1.35 1.35 0 0 0 1.349 1.351h8.234c1.083 0 1.738-.41 1.863-1.394l.006-.089 1.048-6.699c.084-.521-.124-1.044-.522-1.331a1.302 1.302 0 0 0-.723-.25.505.505 0 0 1-.055.003h-4.635a.86.86 0 0 1-.857-.86V5.891c0-.842-.2-1.38-.554-1.64-.26-.193-.629-.264-1.025-.242v2.65c0 1.54-.75 2.889-2.137 3.875-.727.518-1.477.847-1.992.995v7.118z"
  }));
};

var SvgLike64X64 = function SvgLike64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -like",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M60.443 54.124C59.853 58.958 56.615 61 52.007 61H4.354C1.949 61 0 59.062 0 56.672V33.328C0 30.938 1.95 29 4.354 29H18.04a.62.62 0 0 1 .38-.37l1.11-.378c.142-.04.386-.118.677-.22.427-.152.894-.336 1.388-.553a21.78 21.78 0 0 0 3.956-2.246c4.016-2.882 6.122-6.702 6.122-11.072V3.84c0-.299.21-.556.5-.612 2.375-.46 4.732-.28 6.512 1.042 1.848 1.37 2.76 3.855 2.76 7.33v11.645c0 .312.257.572.567.572h15.222a.611.611 0 0 1 .127-.013c1.421 0 2.77.438 3.91 1.273 2.017 1.47 3.051 4.084 2.64 6.667l-3.464 22.318-.004.061zM19.42 29.604l.473-.161c.456-.127 1.271-.416 2.194-.822a22.999 22.999 0 0 0 4.18-2.373c4.33-3.107 6.64-7.298 6.64-12.088V4.367c1.894-.285 3.727-.073 5.048.909 1.481 1.098 2.257 3.209 2.257 6.324v11.646c0 1 .81 1.818 1.8 1.818H57.36a.61.61 0 0 0 .12-.012 5.325 5.325 0 0 1 3.066 1.036c1.636 1.192 2.484 3.336 2.145 5.462l-3.47 22.362-.008.097c-.512 4.078-3.168 5.745-7.207 5.745H24.739c-3.039 0-5.505-2.492-5.505-5.562V30.054a.61.61 0 0 0 .186-.44v-.01zM18 30.23H4.354a3.108 3.108 0 0 0-3.118 3.099v23.344c0 1.712 1.396 3.1 3.118 3.1h16.523A6.822 6.822 0 0 1 18 54.191V30.23z",
    clipRule: "evenodd"
  }));
};

var SvgListBullet104X104 = function SvgListBullet104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -list-bullet",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.2 3c6.185 0 11.2 5.055 11.2 11.291 0 6.237-5.014 11.293-11.2 11.293C5.014 25.584 0 20.529 0 14.29 0 8.055 5.014 3 11.2 3zm0 2.016C6.118 5.016 2 9.17 2 14.291c0 5.124 4.118 9.276 9.2 9.276 5.081 0 9.2-4.152 9.2-9.276 0-5.122-4.12-9.275-9.2-9.275zm30.6 8.267H103c.552 0 1 .452 1 1.009 0 .556-.448 1.008-1 1.008H41.8c-.552 0-1-.452-1-1.008 0-.557.448-1.009 1-1.009zm0 37.709H103c.552 0 1 .451 1 1.008s-.448 1.008-1 1.008H41.8c-.552 0-1-.451-1-1.008s.448-1.008 1-1.008zM103 88.701H41.8c-.552 0-1 .451-1 1.008s.448 1.008 1 1.008H103c.552 0 1-.451 1-1.008s-.448-1.008-1-1.008zm-80.6 1.008c0-6.237-5.014-11.293-11.2-11.293C5.014 78.416 0 83.471 0 89.71 0 95.945 5.014 101 11.2 101c6.185 0 11.2-5.055 11.2-11.291zm-20.4 0c0-5.124 4.118-9.276 9.2-9.276 5.081 0 9.2 4.152 9.2 9.276 0 5.122-4.12 9.274-9.2 9.274-5.082 0-9.2-4.152-9.2-9.274zm9.2-49.001c6.186 0 11.2 5.055 11.2 11.292s-5.014 11.292-11.2 11.292C5.014 63.292 0 58.237 0 52s5.014-11.292 11.2-11.292zm0 2.016C6.118 42.724 2 46.876 2 52s4.118 9.276 9.2 9.276c5.081 0 9.2-4.153 9.2-9.276s-4.119-9.276-9.2-9.276z",
    clipRule: "evenodd"
  }));
};

var SvgListBullet16X16 = function SvgListBullet16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -list-bullet",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 0a2 2 0 1 1-.001 4.001A2 2 0 0 1 2 0zm0 1a1 1 0 1 0 .001 2.001A1 1 0 0 0 2 1zm4.5.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm0 6h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm9 6h-9a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zM4 14a2 2 0 1 0-4.001.001A2 2 0 0 0 4 14zm-3 0a1 1 0 1 1 2.001.001A1 1 0 0 1 1 14zm1-8a2 2 0 1 1-.001 4.001A2 2 0 0 1 2 6zm0 1a1 1 0 1 0 .001 2.001A1 1 0 0 0 2 7z",
    clipRule: "evenodd"
  }));
};

var SvgListBullet24X24 = function SvgListBullet24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -list-bullet",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 2.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1.042a1.458 1.458 0 1 0 0 2.916 1.458 1.458 0 0 0 0-2.916Zm5.024.958h11.952c.29 0 .524.224.524.5s-.235.5-.524.5H9.524A.513.513 0 0 1 9 5c0-.276.235-.5.524-.5Zm0 7h11.952c.29 0 .524.224.524.5s-.235.5-.524.5H9.524A.513.513 0 0 1 9 12c0-.276.235-.5.524-.5Zm11.952 7H9.524A.513.513 0 0 0 9 19c0 .276.235.5.524.5h11.952c.29 0 .524-.224.524-.5s-.235-.5-.524-.5ZM7 19a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm-3.958 0a1.458 1.458 0 1 1 2.917 0 1.458 1.458 0 0 1-2.917 0ZM4.5 9.5a2.5 2.5 0 1 1-.001 5 2.5 2.5 0 0 1 0-5Zm0 1.042a1.458 1.458 0 1 0-.001 2.916 1.458 1.458 0 0 0 0-2.916Z",
    clipRule: "evenodd"
  }));
};

var SvgLocation104X104 = function SvgLocation104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -location",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M96.955 102c2.782 0 5.045-2.268 5.045-5.056v-52.61c0-2.789-2.263-5.056-5.045-5.056h-13.33c-2.437 11.4-10.912 20.903-22.342 24.334l-6.975 16.074a2.478 2.478 0 0 1-2.303 1.512h-.003a2.479 2.479 0 0 1-2.303-1.518l-6.985-16.212c-8.131-2.437-14.867-7.86-19.003-15.311a32.322 32.322 0 0 1-3.339-8.88H7.045C4.263 39.278 2 41.546 2 44.334v52.611C2 99.732 4.263 102 7.045 102h89.91zM45.759 2.61C34.927 4.766 25.953 13.007 22.898 23.607c-2.32 8.049-1.411 16.423 2.561 23.58 3.954 7.124 10.438 12.271 18.261 14.492.289.082.526.29.644.566l7.171 16.644c.121.28.368.31.469.31h.001c.101 0 .348-.03.469-.308l7.162-16.506a.999.999 0 0 1 .643-.564c13.024-3.697 22.104-15.752 22.082-29.314v-.005A30.347 30.347 0 0 0 71.262 8.893C65.791 4.39 58.977 2 51.928 2c-2.046 0-4.112.2-6.169.61zm38.237 34.668h12.959c3.885 0 7.045 3.165 7.045 7.055v52.611c0 3.891-3.16 7.056-7.045 7.056H7.045C3.16 104 0 100.835 0 96.944v-52.61c0-3.891 3.16-7.056 7.045-7.056h12.963c-.703-4.666-.394-9.498.969-14.225C24.236 11.741 33.812 2.947 45.368.649c9.741-1.936 19.642.507 27.165 6.7a32.343 32.343 0 0 1 11.828 25.154 32.007 32.007 0 0 1-.365 4.775zM63.297 24.072C60.606 20.462 56.489 18.39 52 18.39c-7.767 0-14.086 6.332-14.086 14.115 0 4.274 1.902 8.272 5.22 10.968 3.307 2.687 7.647 3.717 11.912 2.825 5.123-1.07 9.387-5.19 10.611-10.25 1.036-4.287.197-8.54-2.36-11.976zM52.029 48.614a16.053 16.053 0 0 1-10.156-3.589 16.068 16.068 0 0 1-5.959-12.52c0-8.886 7.216-16.115 16.086-16.115 5.127 0 9.829 2.364 12.9 6.487 2.878 3.864 3.863 8.836 2.701 13.64-1.402 5.796-6.283 10.513-12.145 11.74-1.143.239-2.291.357-3.427.357z",
    clipRule: "evenodd"
  }));
};

var SvgLocation16X16 = function SvgLocation16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -location",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.611 15a.391.391 0 0 0 .389-.391V6.873a.39.39 0 0 0-.389-.39h-1.693c-.445 1.62-1.662 2.964-3.293 3.513l-.962 2.216a.72.72 0 0 1-.662.435H8a.721.721 0 0 1-.662-.437l-.964-2.235a5.081 5.081 0 0 1-2.843-2.37 5.086 5.086 0 0 1-.443-1.122H1.389a.39.39 0 0 0-.389.39v7.736c0 .215.175.39.389.39h13.222zM7.151 1.084A4.074 4.074 0 0 0 4.06 3.923a4.161 4.161 0 0 0 .345 3.198 4.086 4.086 0 0 0 2.474 1.963.5.5 0 0 1 .322.283l.801 1.857.797-1.837a.503.503 0 0 1 .322-.282 4.134 4.134 0 0 0 2.991-3.971v-.002a4.114 4.114 0 0 0-4.123-4.13c-.278 0-.558.026-.838.082zm5.934 4.399h1.526c.766 0 1.389.624 1.389 1.39v7.736c0 .767-.623 1.39-1.389 1.39H1.389A1.392 1.392 0 0 1 0 14.61V6.873c0-.766.623-1.39 1.389-1.39h1.527a5.253 5.253 0 0 1 .183-1.837A5.08 5.08 0 0 1 6.956.104a5.13 5.13 0 0 1 4.287 1.058 5.106 5.106 0 0 1 1.869 3.973c0 .074-.008.147-.015.22a3.81 3.81 0 0 0-.012.128zM9.378 4.104A1.702 1.702 0 0 0 8 3.411a1.724 1.724 0 1 0 .376 3.406 1.71 1.71 0 0 0 1.289-1.246 1.732 1.732 0 0 0-.287-1.467zm-.797 3.691c-.192.041-.386.06-.577.06-.623 0-1.228-.21-1.716-.607A2.724 2.724 0 0 1 8 2.411c.854 0 1.669.41 2.181 1.096.485.653.652 1.491.457 2.3a2.73 2.73 0 0 1-2.057 1.988z",
    clipRule: "evenodd"
  }));
};

var SvgLocation24X24 = function SvgLocation24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -location",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.374 21A.628.628 0 0 0 21 20.37v-9.799a.628.628 0 0 0-.626-.628h-2.25c-.534 2.074-2.08 3.796-4.164 4.475l-1.242 2.863a.782.782 0 0 1-1.435-.002l-1.244-2.888a6.297 6.297 0 0 1-4.171-4.448H3.626a.628.628 0 0 0-.626.628v9.8c0 .345.281.627.626.627h16.748ZM10.898 3.107A5.295 5.295 0 0 0 6.881 6.8c-.409 1.418-.249 2.892.449 4.152a5.311 5.311 0 0 0 3.213 2.55.5.5 0 0 1 .322.283l1.136 2.636 1.133-2.61a.5.5 0 0 1 .322-.283 5.37 5.37 0 0 0 3.886-5.157v-.002a5.342 5.342 0 0 0-5.357-5.367c-.36 0-.724.036-1.087.107Zm7.398 5.836h2.078c.897 0 1.626.731 1.626 1.628v9.8c0 .896-.729 1.627-1.626 1.627H3.626A1.629 1.629 0 0 1 2 20.371v-9.799c0-.897.729-1.628 1.626-1.628h2.063a6.547 6.547 0 0 1 .231-2.423 6.305 6.305 0 0 1 4.783-4.393 6.368 6.368 0 0 1 5.321 1.313 6.34 6.34 0 0 1 2.318 4.927c0 .138-.014.273-.029.408a9.353 9.353 0 0 0-.017.168Zm-4.443-1.958A2.294 2.294 0 0 0 12 6.054a2.316 2.316 0 1 0 .503 4.578 2.296 2.296 0 0 0 1.735-1.677 2.325 2.325 0 0 0-.385-1.97Zm-1.145 4.624c-.234.049-.47.073-.703.073a3.306 3.306 0 0 1-3.316-3.314A3.317 3.317 0 0 1 12 5.054c1.055 0 2.022.486 2.655 1.334.592.795.794 1.816.556 2.802a3.315 3.315 0 0 1-2.503 2.42Z",
    fill: "currentColor"
  }));
};

var SvgMailClosed104X104 = function SvgMailClosed104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -mail-closed",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 24.045v55.91A7.044 7.044 0 0 0 7.045 87h89.91A7.045 7.045 0 0 0 104 79.955v-55.91A7.045 7.045 0 0 0 96.955 17H7.045A7.044 7.044 0 0 0 0 24.045zm4.398-4.296A5.022 5.022 0 0 1 7.045 19h89.91c.97 0 1.876.274 2.644.748l-44.197 40.37a5.041 5.041 0 0 1-6.803 0L4.398 19.75zm-1.465 1.372A5.022 5.022 0 0 0 2 24.045v55.91A5.044 5.044 0 0 0 7.045 85h89.91A5.044 5.044 0 0 0 102 79.955v-55.91a5.021 5.021 0 0 0-.935-2.927L56.751 61.595a7.042 7.042 0 0 1-9.501 0L2.933 21.12z",
    clipRule: "evenodd"
  }));
};

var SvgMailClosed16X16 = function SvgMailClosed16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -mail-closed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 3.889v8.223c0 .766.622 1.388 1.389 1.388h13.222c.767 0 1.389-.622 1.389-1.388V3.889A1.39 1.39 0 0 0 14.611 2.5H1.389A1.39 1.39 0 0 0 0 3.889zm1 .246v7.977c0 .214.174.388.389.388h13.222a.389.389 0 0 0 .389-.388V4.134l-6.064 5.54c-.531.482-1.341.482-1.873-.002L1 4.135zM14.211 3.5H1.788l5.949 5.433c.149.136.377.136.525.001L14.211 3.5z",
    clipRule: "evenodd"
  }));
};

var SvgMailClosed24X24 = function SvgMailClosed24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -mail-closed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m1.792 4.982 9.626 8.612a.875.875 0 0 0 1.164 0l9.625-8.612a.894.894 0 0 0-.07-.002H1.863a.894.894 0 0 0-.071.002zm21.183.64-9.718 8.695a1.89 1.89 0 0 1-2.513 0l-9.72-8.694A.832.832 0 0 0 1 5.825v12.35c0 .467.386.845.863.845h20.274a.855.855 0 0 0 .863-.846V5.824a.832.832 0 0 0-.025-.202zM0 5.825C0 4.817.834 4 1.863 4h20.274C23.167 4 24 4.817 24 5.825v12.35C24 19.181 23.166 20 22.137 20H1.863C.833 20 0 19.182 0 18.174V5.824z"
  }));
};

var SvgMailOpen104X104 = function SvgMailOpen104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -mail-open",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M46.53 1.853.392 37.159a.998.998 0 0 0-.392.794v57.044a9 9 0 0 0 9 9h86a9 9 0 0 0 9.001-9V37.953a.999.999 0 0 0-.418-.813L57.469 1.853a9 9 0 0 0-10.939 0zm54.902 36.16L56.254 3.44a7 7 0 0 0-8.508 0L2.568 38.012l44.77 39.97a7 7 0 0 0 9.324 0l44.77-39.97zM2 94.997v-54.81l44.007 39.287a9 9 0 0 0 11.987 0l44.007-39.288v54.811a7 7 0 0 1-7 7H9a7 7 0 0 1-7-7z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h104v104H0z"
  }))));
};

var SvgMailOpen16X16 = function SvgMailOpen16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -mail-open",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m1.285 5.994 6.383 5.68a.5.5 0 0 0 .664 0l6.383-5.68-6.412-4.892a.5.5 0 0 0-.606 0L1.285 5.994zm14.514-.43a.5.5 0 0 1 .201.4V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5V5.964a.5.5 0 0 1 .201-.4L7.091.306a1.5 1.5 0 0 1 1.819 0l6.89 5.256zM1 14.5V7.078l6.003 5.343a1.5 1.5 0 0 0 1.994 0L15 7.078V14.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
};

var SvgMailOpen24X24 = function SvgMailOpen24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -mail-open",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m1.253 8.899 10.07 8.528c.392.332.96.332 1.352 0l10.071-8.53L12.634 1.19a1.043 1.043 0 0 0-1.267 0L1.253 8.9Zm22.556-.411a.49.49 0 0 1 .191.39V21.95C24 23.083 23.097 24 21.984 24H2.016C.903 24 0 23.083 0 21.951V8.878a.49.49 0 0 1 .213-.406L10.791.41a1.99 1.99 0 0 1 2.42 0l10.598 8.078ZM.96 21.951V9.921l9.749 8.255a1.991 1.991 0 0 0 2.58 0L23.04 9.92V21.95c0 .593-.473 1.073-1.056 1.073H2.016c-.583 0-1.056-.48-1.056-1.073Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))));
};

var SvgMailOpen64X64 = function SvgMailOpen64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -mail-open",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.274 23.53 29.73 48.82a3.406 3.406 0 0 0 4.538 0l28.458-25.29L34.07 1.7a3.404 3.404 0 0 0-4.136 0L1.273 23.53zm62.53-.43c.119.092.196.237.196.4v36c0 2.485-1.984 4.5-4.43 4.5H4.43C1.985 64 0 61.986 0 59.5v-36c0-.17.084-.32.212-.41L29.342.9a4.376 4.376 0 0 1 5.317 0l29.145 22.2zM.983 59.5V24.602l28.097 24.97a4.38 4.38 0 0 0 5.836 0l28.098-24.97V59.5c0 1.933-1.543 3.5-3.446 3.5H4.431C2.528 63 .985 61.433.985 59.5z",
    clipRule: "evenodd"
  }));
};

var SvgMedal104X104 = function SvgMedal104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -medal",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.936 99.91-4.827-11.466 3.674-5.856a.906.906 0 0 0-.32-1.267 1.01 1.01 0 0 0-1.365.311L21.417 87.5 8.803 89.154l16.289-27.676 1.006.973a37.05 37.05 0 0 0 16.823 9.32l1.436.357L27.936 99.91zM52 71.013c-19.196 0-34.855-15.26-34.855-34.074 0-18.813 15.66-34.073 34.855-34.073 19.197 0 34.856 15.26 34.856 34.073S71.196 71.013 52 71.013zm30.581 16.486-3.68-5.867a1.01 1.01 0 0 0-1.365-.312.906.906 0 0 0-.32 1.268l3.673 5.856-4.827 11.466-16.42-27.782 1.435-.357a37.05 37.05 0 0 0 16.823-9.32l1.006-.973 16.29 27.676-12.615-1.655zm-5.454 14.914 5.484-13.026 14.275 1.872a1 1 0 0 0 .955-.413.897.897 0 0 0 .034-.967L80.263 59.955l.488-.594c5.047-6.155 8.067-13.95 8.067-22.422C88.818 17.147 72.325 1 52 1S15.182 17.147 15.182 36.94c0 8.47 3.02 16.266 8.067 22.42l.488.595L6.125 89.88a.894.894 0 0 0 .035.966c.203.295.572.464.955.414l14.275-1.872 5.483 13.026a.977.977 0 0 0 .912.587c.36 0 .684-.188.855-.476l17.372-29.393a.845.845 0 0 1 .015-.027l.368-.636.728.095a37.895 37.895 0 0 0 9.754 0l.713-.093.372.615.027.047 17.372 29.392a.991.991 0 0 0 .922.474.978.978 0 0 0 .844-.585zm-31.1-29.31-.002.006.002-.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.246 16.195c3.821-2.074 8.177-3.172 12.594-3.172 14.2 0 25.686 11.13 25.686 24.726 0 3.72-.836 7.293-2.487 10.627a.967.967 0 0 1-.873.518c-.143 0-.288-.03-.426-.094-.485-.223-.648-.747-.444-1.159a22.112 22.112 0 0 0 2.313-9.892c0-12.697-10.7-22.957-23.769-22.957-4.072 0-8.092 1.011-11.625 2.928-.485.264-1.08.083-1.328-.343-.234-.402-.104-.931.359-1.182zm25.87 42.421c.238.416.096.958-.374 1.21-3.789 2.024-8.096 3.095-12.453 3.095-14.264 0-25.812-11.243-25.812-24.99 0-3.606.775-7.082 2.305-10.338.21-.448.788-.68 1.299-.455.204.09.354.234.447.401.132.24.145.529.027.781a22.44 22.44 0 0 0-2.142 9.61c0 12.815 10.742 23.181 23.876 23.181 4.018 0 7.992-.986 11.493-2.857.294-.157.627-.152.9-.029a.946.946 0 0 1 .435.391zm-6.863-18.624c-.029-.17-.013-.341.04-.497a.99.99 0 0 1 .236-.382l4.22-4.207 1.553-1.549-2.17-.321-5.833-.865a.933.933 0 0 1-.702-.527l-2.61-5.402-.993-2.056-.992 2.056-2.607 5.403a.937.937 0 0 1-.702.528l-5.832.868-2.17.323 1.554 1.548 4.222 4.204c.223.223.331.552.276.879l-.995 5.938-.371 2.218 1.98-1.065 5.217-2.805a.894.894 0 0 1 .85 0l5.218 2.802 1.982 1.064-.373-2.217-.998-5.938zm3.157 10.721c.289-.214.444-.589.38-.968l-1.515-9.015-.094-.561.403-.402 6.406-6.386c.258-.259.358-.655.242-1.02a.947.947 0 0 0-.755-.66L57.62 30.39l-.577-.086-.253-.525-3.963-8.202a.93.93 0 0 0-.833-.536.93.93 0 0 0-.832.537l-3.958 8.204-.253.525-.577.086-8.855 1.318a.946.946 0 0 0-.755.66c-.115.364-.016.76.243 1.018l6.41 6.383.403.402-.094.561-1.51 9.016a1 1 0 0 0 .38.968.902.902 0 0 0 .964.072l7.92-4.258.521-.281.522.28 7.922 4.255c.308.165.68.139.964-.073z"
  })));
};

var SvgMedal16X16 = function SvgMedal16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -medal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.065 2.457a3.9 3.9 0 0 1 5.81 3.395c0 .586-.128 1.15-.38 1.675a.3.3 0 0 1-.54-.258 3.26 3.26 0 0 0 .32-1.417 3.3 3.3 0 0 0-4.916-2.873.3.3 0 0 1-.294-.522zm3.572 6.339a.3.3 0 0 1 .41.119c.08.146.027.33-.12.41a3.911 3.911 0 0 1-1.888.487c-2.16 0-3.918-1.764-3.918-3.933 0-.568.118-1.116.35-1.628a.301.301 0 1 1 .55.25 3.311 3.311 0 0 0-.297 1.378 3.325 3.325 0 0 0 3.315 3.328c.56 0 1.112-.142 1.598-.411z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.065 2.457.073.131-.073-.13zm5.43 5.07.136.065-.135-.065zm-.4.141-.064.136.065-.136zm-.14-.399-.136-.064.135.064zM6.358 2.98l-.074-.13.074.13zm-.409-.114.131-.073-.13.073zm4.096 6.05-.131.072.131-.072zm-.41-.12.074.132-.073-.131zm.292.53.072.132-.072-.131zM4.472 4.252l-.137-.062.137.062zm.4-.15.062-.137-.063.137zm.149.4-.137-.062.137.062zM7.975 1.81c-.695 0-1.381.179-1.984.518l.147.261a3.757 3.757 0 0 1 1.837-.479v-.3zm4.05 4.043a4.05 4.05 0 0 0-4.05-4.043v.3a3.75 3.75 0 0 1 3.75 3.743h.3zm-.394 1.74a4.002 4.002 0 0 0 .393-1.74h-.3c0 .564-.122 1.106-.364 1.61l.271.13zm-.406.256a.45.45 0 0 0 .406-.256l-.27-.13a.15.15 0 0 1-.136.086v.3zm-.194-.044a.45.45 0 0 0 .194.044v-.3a.149.149 0 0 1-.065-.015l-.129.27zm-.212-.6a.45.45 0 0 0 .212.6l.13-.27a.15.15 0 0 1-.071-.2l-.27-.13zm.305-1.352c0 .474-.102.929-.305 1.353l.27.129c.223-.465.336-.964.336-1.482h-.3zm-3.15-3.144a3.15 3.15 0 0 1 3.15 3.144h.3a3.45 3.45 0 0 0-3.45-3.444v.3zm-1.542.402a3.155 3.155 0 0 1 1.543-.402v-.3c-.592 0-1.176.152-1.69.44l.147.262zM5.82 2.94a.45.45 0 0 0 .612.171l-.147-.261a.15.15 0 0 1-.204-.057l-.261.147zm.171-.612a.45.45 0 0 0-.171.612l.261-.147a.15.15 0 0 1 .057-.204l-.147-.261zm4.187 6.516a.45.45 0 0 0-.614-.178l.146.262a.15.15 0 0 1 .205.06l.263-.144zM10 9.457a.453.453 0 0 0 .178-.614l-.263.144a.153.153 0 0 1-.06.208l.145.262zm-1.96.505c.685 0 1.363-.175 1.96-.505l-.145-.262a3.761 3.761 0 0 1-1.816.467v.3zM3.97 5.879c0 2.251 1.824 4.083 4.068 4.083v-.3c-2.077 0-3.768-1.697-3.768-3.783h-.3zm.364-1.69a4.063 4.063 0 0 0-.364 1.69h.3c0-.546.114-1.073.338-1.566l-.274-.124zm.599-.225a.451.451 0 0 0-.599.225l.274.124a.151.151 0 0 1 .2-.076l.125-.273zm.223.6a.453.453 0 0 0-.223-.6l-.125.273c.076.035.11.125.075.202l.273.124zm-.283 1.315c0-.46.095-.902.283-1.316l-.273-.124c-.206.454-.31.938-.31 1.44h.3zm3.165 3.178a3.175 3.175 0 0 1-3.165-3.178h-.3a3.475 3.475 0 0 0 3.465 3.478v-.3zm1.525-.392a3.159 3.159 0 0 1-1.525.392v.3c.585 0 1.162-.149 1.67-.43l-.145-.262z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 0C4.88 0 2.337 2.568 2.337 5.73c0 1.316.44 2.53 1.18 3.498L1.06 13.55a.46.46 0 0 0 .016.482.443.443 0 0 0 .43.196l1.848-.251.708 1.743a.447.447 0 0 0 .413.28.445.445 0 0 0 .386-.226l2.484-4.352a5.62 5.62 0 0 0 1.31 0l2.485 4.352a.445.445 0 0 0 .415.225.447.447 0 0 0 .383-.28l.708-1.742 1.849.25a.443.443 0 0 0 .429-.195.461.461 0 0 0 .016-.482l-2.457-4.322a5.745 5.745 0 0 0 1.18-3.498C13.663 2.568 11.12 0 8 0zm.001 10.7c-2.71 0-4.914-2.23-4.914-4.97S5.292.76 8.001.76c2.71 0 4.914 2.23 4.914 4.97 0 2.74-2.204 4.97-4.914 4.97zm-3.479 4.152-.546-1.344.49-.81a.309.309 0 0 0-.1-.422.301.301 0 0 0-.417.102l-.496.818-1.435.195 2.1-3.697a5.505 5.505 0 0 0 2.523 1.447l-2.119 3.71zm7.53-2.474.496.818 1.436.195-2.101-3.697a5.504 5.504 0 0 1-2.522 1.447l2.118 3.71.547-1.343-.49-.81a.309.309 0 0 1 .1-.422.301.301 0 0 1 .417.102z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.13 4.776c.111.017.204.1.239.214a.327.327 0 0 1-.075.321l-.932.963.22 1.359a.322.322 0 0 1-.118.306.283.283 0 0 1-.312.024L8 7.322l-1.153.642a.283.283 0 0 1-.312-.024.322.322 0 0 1-.118-.307l.22-1.358-.933-.963a.327.327 0 0 1-.075-.321.301.301 0 0 1 .239-.214l1.289-.198.576-1.237a.295.295 0 0 1 .266-.175c.113 0 .216.068.266.175l.576 1.236 1.29.198zM8.75 6.218a.325.325 0 0 1 .085-.278l.614-.634-.849-.13a.298.298 0 0 1-.223-.172l-.38-.814-.38.814a.298.298 0 0 1-.222.172l-.85.13.615.634c.07.072.102.176.085.278l-.144.895.759-.423a.282.282 0 0 1 .276 0l.76.423-.146-.895z",
    clipRule: "evenodd"
  })));
};

var SvgMedal24X24 = function SvgMedal24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -medal",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.947 19.163-3.29-5.616a6.992 6.992 0 0 0 1.588-4.438C19.245 5.19 15.995 2 12 2S4.754 5.19 4.754 9.11c0 1.677.596 3.22 1.59 4.437l-3.291 5.616a.384.384 0 0 0 .015.412c.084.124.233.19.383.17l2.568-.339.986 2.352a.398.398 0 0 0 .368.242.4.4 0 0 0 .345-.195l3.322-5.646.001-.003a7.418 7.418 0 0 0 1.918 0l.001.003 3.322 5.646a.4.4 0 0 0 .345.195h.027a.397.397 0 0 0 .341-.242l.986-2.352 2.568.339a.4.4 0 0 0 .384-.17.385.385 0 0 0 .014-.412ZM7.433 20.726l-.717-1.712.644-1.03a.386.386 0 0 0-.132-.538.403.403 0 0 0-.547.129l-.65 1.042-1.885.248 2.758-4.707A7.28 7.28 0 0 0 10.214 16l-2.78 4.726ZM5.551 9.109c0 3.49 2.893 6.329 6.449 6.329s6.45-2.84 6.45-6.329S15.555 2.781 12 2.781 5.55 5.621 5.55 9.11Zm12.419 9.508-.65-1.042a.402.402 0 0 0-.548-.129.386.386 0 0 0-.132.537l.644 1.031-.717 1.712L13.787 16a7.28 7.28 0 0 0 3.31-1.842l2.757 4.707-1.884-.248ZM15.11 8.167a.392.392 0 0 0-.314-.272l-1.692-.252-.757-1.574A.388.388 0 0 0 12 5.846a.388.388 0 0 0-.348.223l-.757 1.574-1.692.253a.392.392 0 0 0-.313.272.407.407 0 0 0 .098.41l1.225 1.225-.289 1.73a.404.404 0 0 0 .155.39.382.382 0 0 0 .41.031L12 11.137l1.513.816a.38.38 0 0 0 .41-.03c.12-.09.18-.241.155-.39l-.29-1.731 1.224-1.226a.407.407 0 0 0 .098-.41ZM13.1 9.377a.406.406 0 0 0-.112.353l.19 1.14-.997-.538a.38.38 0 0 0-.361 0l-.997.538.19-1.14a.406.406 0 0 0-.112-.353l-.807-.807 1.115-.166a.39.39 0 0 0 .293-.219L12 7.148l.498 1.037a.39.39 0 0 0 .293.218l1.115.166-.806.808Zm-1.131-5.07c-.88 0-1.746.22-2.507.635a.375.375 0 0 0-.15.52.4.4 0 0 0 .536.145 4.443 4.443 0 0 1 2.12-.537c2.389 0 4.331 1.882 4.331 4.195 0 .632-.14 1.24-.42 1.805a.376.376 0 0 0 .186.508.402.402 0 0 0 .525-.18c.33-.669.497-1.387.497-2.133 0-2.734-2.296-4.957-5.118-4.957Zm2.184 8.707a.401.401 0 0 1 .537.151.38.38 0 0 1-.156.524 5.258 5.258 0 0 1-2.478.619c-2.836 0-5.143-2.247-5.143-5.008 0-.723.155-1.421.46-2.074a.4.4 0 0 1 .525-.191.381.381 0 0 1 .196.51 4.11 4.11 0 0 0-.39 1.755c0 2.336 1.952 4.237 4.352 4.237.733 0 1.458-.18 2.097-.523Z",
    fill: "currentColor"
  }));
};

var SvgMenu104X104 = function SvgMenu104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -menu",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 16h102a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2zm0 37h102a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2zm102 37H1a1 1 0 1 1 0-2h102a1 1 0 0 1 0 2z",
    clipRule: "evenodd"
  }));
};

var SvgMenu16X16 = function SvgMenu16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -menu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.5 3.014h15c.276 0 .5-.227.5-.507S15.776 2 15.5 2H.5c-.276 0-.5.227-.5.507s.224.507.5.507zm0 5.493h15c.276 0 .5-.227.5-.507s-.224-.507-.5-.507H.5c-.276 0-.5.227-.5.507s.224.507.5.507zM15.5 14H.5c-.276 0-.5-.227-.5-.507s.224-.507.5-.507h15c.276 0 .5.227.5.507s-.224.507-.5.507z",
    clipRule: "evenodd"
  }));
};

var SvgMenu24X24 = function SvgMenu24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -menu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.5 4h23a.5.5 0 0 0 0-1H.5a.5.5 0 0 0 0 1Zm0 9h23a.5.5 0 0 0 0-1H.5a.5.5 0 0 0 0 1Zm23 8H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1Z",
    clipRule: "evenodd"
  }));
};

var SvgMicrophone104X104 = function SvgMicrophone104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -microphone",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M70.228 52c0 9.941-8.16 18-18.228 18-10.067 0-18.228-8.059-18.228-18V18c0-9.941 8.16-18 18.228-18 10.067 0 18.228 8.059 18.228 18v34zm-2.025 0V18c0-8.837-7.254-16-16.203-16S35.797 9.163 35.797 18v34c0 8.837 7.254 16 16.203 16s16.203-7.163 16.203-16zM84 35v17c0 17.118-13.783 31.056-30.987 31.584V102h16.202c.56 0 1.013.448 1.013 1s-.453 1-1.013 1h-34.43c-.56 0-1.013-.448-1.013-1s.453-1 1.013-1h16.202V83.585C33.783 83.056 20 69.118 20 52V35c0-.552.453-1 1.013-1 .559 0 1.012.448 1.012 1v17c0 16.348 13.42 29.6 29.975 29.6S81.975 68.348 81.975 52V35c0-.552.453-1 1.012-1 .56 0 1.013.448 1.013 1z",
    clipRule: "evenodd"
  }));
};

var SvgMicrophone16X16 = function SvgMicrophone16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -microphone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 8a3 3 0 1 1-6 0V3a3 3 0 1 1 6 0v5zm-3 2a2 2 0 0 0 2-2V3a2 2 0 1 0-4 0v5a2 2 0 0 0 2 2zm2.5 5h-2v-2.025A5.001 5.001 0 0 0 13 8V5.5a.5.5 0 0 0-1 0V8a4 4 0 0 1-8 0V5.5a.5.5 0 0 0-1 0V8a5.001 5.001 0 0 0 4.5 4.975V15h-2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  }));
};

var SvgMicrophone24X24 = function SvgMicrophone24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -microphone"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M16.333 12a4.333 4.333 0 1 1-8.666 0V4.333a4.333 4.333 0 1 1 8.666 0V12zm-1 0V4.333a3.333 3.333 0 1 0-6.666 0V12a3.333 3.333 0 1 0 6.666 0zM12.5 23h3.333a.5.5 0 1 1 0 1H8.167a.5.5 0 1 1 0-1H11.5v-3.617A7.4 7.4 0 0 1 4.6 12V8.167a.5.5 0 0 1 1 0V12a6.4 6.4 0 1 0 12.8 0V8.167a.5.5 0 1 1 1 0V12a7.4 7.4 0 0 1-6.9 7.383V23z"
  }));
};

var SvgMoney104X104 = function SvgMoney104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -money",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M96.956 102c2.781 0 5.044-2.27 5.044-5.061V44.287c0-2.79-2.263-5.06-5.044-5.06h-8.081C84.08 56.409 70.722 70.835 52.344 77.756a.993.993 0 0 1-.705-.001c-18.378-6.924-31.732-21.356-36.52-38.528H7.044c-2.781 0-5.044 2.27-5.044 5.06v52.652C2 99.73 4.263 102 7.044 102h89.912zM15.702 2a.513.513 0 0 0-.511.515v23.771c.09 3.929.643 7.781 1.609 11.507a.974.974 0 0 1 .108.43c4.473 16.655 17.324 30.715 35.083 37.527 21.88-8.387 36.317-27.773 36.819-49.487l-.001-23.748A.513.513 0 0 0 88.298 2H15.702zm73.69 35.227h7.564c3.884 0 7.044 3.167 7.044 7.06v52.652c0 3.893-3.16 7.061-7.044 7.061H7.044C3.16 104 0 100.832 0 96.939V44.287c0-3.893 3.16-7.06 7.044-7.06h7.56a52.42 52.42 0 0 1-1.413-10.918V2.515A2.515 2.515 0 0 1 15.702 0h72.596a2.515 2.515 0 0 1 2.511 2.515v23.771a52.624 52.624 0 0 1-1.417 10.941zM52.005 50.114h.003c4.75-.002 8.199-3.14 8.199-7.462 0-3.685-2.836-6.205-8.43-7.49-8.252-1.892-9.984-6.176-9.984-9.437 0-5.17 3.817-8.998 9.209-9.42v-4.271a1 1 0 0 1 2 0v4.282a10.198 10.198 0 0 1 9.066 8.474 1 1 0 0 1-1.972.334A8.206 8.206 0 0 0 52 18.263c-4.755 0-8.207 3.139-8.207 7.462 0 3.686 2.837 6.205 8.43 7.489 8.252 1.893 9.984 6.177 9.984 9.438 0 5.168-3.814 8.998-9.205 9.42v4.27a1 1 0 0 1-2 0v-4.277c-5.161-.505-9.21-4.877-9.21-10.181a1 1 0 0 1 2 0c0 4.538 3.68 8.229 8.204 8.23h.003a.01.01 0 0 1 .003 0h.003z",
    clipRule: "evenodd"
  }));
};

var SvgMoney16X16 = function SvgMoney16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -money",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.611 15a.39.39 0 0 0 .389-.391V6.866a.39.39 0 0 0-.389-.391h-.942c-.795 2.519-2.779 4.621-5.494 5.643a.511.511 0 0 1-.353 0C5.106 11.094 3.123 8.991 2.33 6.475h-.941A.39.39 0 0 0 1 6.866v7.743a.39.39 0 0 0 .389.391h13.222zM13.06 1H2.94v3.219c.068 2.995 2.047 5.687 5.059 6.894 3.012-1.206 4.992-3.898 5.061-6.906V1zm.871 4.475h.68c.766 0 1.389.624 1.389 1.391v7.743c0 .767-.623 1.391-1.389 1.391H1.389A1.392 1.392 0 0 1 0 14.609V6.866c0-.767.623-1.391 1.389-1.391h.679A8.17 8.17 0 0 1 1.94 4.23V.723c0-.399.324-.723.722-.723h10.676c.398 0 .722.324.722.723v3.496c-.01.425-.055.845-.129 1.256zM8.001 7.37h.001c.411 0 .852-.233.852-.745 0-.132 0-.535-.966-.757-1.515-.348-1.742-1.234-1.742-1.732 0-.829.558-1.48 1.355-1.678v-.336a.5.5 0 1 1 1 0v.345A1.85 1.85 0 0 1 9.829 3.94a.501.501 0 0 1-.987.167A.855.855 0 0 0 8 3.391c-.411 0-.854.233-.854.745 0 .132 0 .536.966.757 1.515.348 1.742 1.235 1.742 1.732 0 .83-.557 1.481-1.353 1.678v.336a.5.5 0 0 1-1 0v-.346a1.855 1.855 0 0 1-1.355-1.78.5.5 0 0 1 1 0c0 .472.383.856.853.857h.002z",
    clipRule: "evenodd"
  }));
};

var SvgMoney24X24 = function SvgMoney24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -money",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.374 21a.628.628 0 0 0 .626-.629v-9.808a.629.629 0 0 0-.626-.629h-1.277c-.974 3.196-3.488 5.864-6.922 7.157a.489.489 0 0 1-.353 0c-3.436-1.295-5.949-3.965-6.921-7.157H3.626a.629.629 0 0 0-.626.629v9.808c0 .347.281.629.626.629h16.748ZM18.543 3H5.457v4.21c.088 3.868 2.649 7.337 6.542 8.877 3.893-1.539 6.455-5.009 6.544-8.889V3Zm.808 5.934h1.023A1.63 1.63 0 0 1 22 10.563v9.808A1.63 1.63 0 0 1 20.374 22H3.626A1.63 1.63 0 0 1 2 20.371v-9.808a1.63 1.63 0 0 1 1.626-1.629h1.021c-.11-.56-.177-1.131-.19-1.713V2.782c0-.431.351-.782.782-.782h13.522c.431 0 .782.351.782.782V7.21a10.166 10.166 0 0 1-.192 1.724Zm-7.35 2.401h.001c.584 0 1.213-.338 1.213-1.077 0-.194 0-.784-1.327-1.089-1.829-.42-2.103-1.473-2.103-2.064 0-1.02.71-1.822 1.716-2.024v-.526a.5.5 0 1 1 1 0v.538a2.209 2.209 0 0 1 1.684 1.785.5.5 0 0 1-.986.168A1.215 1.215 0 0 0 12 6.03c-.585 0-1.215.337-1.215 1.076 0 .194 0 .785 1.327 1.09 1.829.42 2.103 1.473 2.103 2.063 0 1.021-.71 1.822-1.714 2.024v.527a.5.5 0 0 1-1 0v-.536a2.219 2.219 0 0 1-1.716-2.158.5.5 0 0 1 1 0 1.22 1.22 0 0 0 1.214 1.22h.002Z",
    fill: "currentColor"
  }));
};

var SvgMotorcycle104X104 = function SvgMotorcycle104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -motorcycle",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M76.8 52.696H86c17.261 0 17.995 17.694 18 17.872a.999.999 0 0 1-1 1.024h-4.388c1.222 7.343-3.393 14.547-10.776 16.428a14.631 14.631 0 0 1-3.619.455c-6.508 0-12.458-4.368-14.145-10.92a14.5 14.5 0 0 1-.255-5.962h-6.745c-1.978.648-4.206 1.058-6.702 1.154.019.41.031.819.031 1.233a.997.997 0 0 1-1 .994H35.95C35.432 82.516 29.113 88.5 21.401 88.5c-7.713 0-14.032-5.984-14.55-13.526H1c-.552 0-1-.445-1-.994C0 63.248 6.929 54.1 16.569 50.717 6.836 49.176 1.27 44.567.013 36.944A.998.998 0 0 1 1 35.788h37.231c10.349 0 12.474 3.914 12.907 5.596.658 2.556-.851 5.338-3.757 6.923a37.637 37.637 0 0 1-7.733 2.347c8.752 2.996 15.301 10.73 16.535 20.11 13.9-.49 18.617-11.601 18.617-16.735V23.257c0-4.262-4.619-5.768-5.8-5.768h-6.799c-.553 0-1-.446-1-.994 0-.55.447-.995 1-.995H69c2.22 0 7.8 2.307 7.8 7.758v29.438zm-52.17-3.381c-12.998 0-20.528-3.88-22.407-11.537H38.23c6.207 0 10.309 1.533 10.97 4.1.42 1.635-.722 3.562-2.694 4.643a35.417 35.417 0 0 1-14.857 2.795h-.011l-.04-.001h-6.97zM2.02 72.985C2.546 60.941 12.564 51.304 24.8 51.304h6.623c.12.003.24.005.361.006l.242.004c11.566.213 21.052 9.03 22.243 20.275-.004.02-.01.04-.015.059-.012.043-.023.086-.023.134a.97.97 0 0 0 .093.41l.006.064c.019.242.038.484.049.729H2.02zm74.757-18.3c-.258 4.136-2.898 10.938-9.382 14.919h34.522c-.402-3.552-2.722-14.919-15.918-14.919h-9.222zm-4.77 22.377c1.724 6.693 8.603 10.743 15.332 9.031 6.48-1.65 10.482-8.053 9.234-14.5H71.867a12.48 12.48 0 0 0 .142 5.469zM8.853 74.974c.513 6.446 5.94 11.537 12.55 11.537 6.609 0 12.036-5.091 12.549-11.537H8.85z",
    clipRule: "evenodd"
  }));
};

var SvgMotorcycle16X16 = function SvgMotorcycle16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -motorcycle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 3.043h-1c-.276 0-.5-.233-.5-.521S9.225 2 9.5 2h1c.69 0 1.5.638 1.5 1.565V7.74h1c1.258 0 2.12.606 2.605 1.587.281.57.384 1.131.396 1.528a.512.512 0 0 1-.5.537h-.263c0 1.163-.751 2.222-1.88 2.524-1.338.357-2.7-.485-3.042-1.881a2.722 2.722 0 0 1-.078-.643h-.561c-.22.071-.453.123-.699.153a.503.503 0 0 1-.478.369H5.95C5.718 13.103 4.71 14 3.5 14c-1.209 0-2.218-.897-2.45-2.087H.5a.511.511 0 0 1-.5-.522 4.22 4.22 0 0 1 1.785-3.476C.805 7.534.178 6.826.007 5.737c-.05-.318.185-.607.493-.607h5.475c1.144 0 1.913.329 2.183.967.264.625-.06 1.31-.711 1.678-.09.04-.18.078-.271.113a4.183 4.183 0 0 1 1.733 2.613 2.8 2.8 0 0 0 .424-.093L11 8.088V3.564c0-.276-.312-.522-.5-.522zM3.99 8.261h.985l.172.004c1.42.071 2.58 1.173 2.811 2.604H1.041c.238-1.477 1.467-2.603 2.949-2.608zm1.175-1.04a4.6 4.6 0 0 0 1.846-.383c.193-.11.26-.254.233-.32-.073-.172-.477-.344-1.268-.344H1.2c.407.708 1.339 1.043 2.775 1.043H5c.055 0 .11.002.165.004zm6.798 1.562a3.238 3.238 0 0 1-.722 1.565h3.672a2.778 2.778 0 0 0-.198-.544c-.32-.649-.85-1.021-1.715-1.021h-1.037zm-.679 2.992a1.631 1.631 0 0 1-.046-.384h3c-.001.697-.451 1.332-1.128 1.513-.803.214-1.62-.29-1.826-1.129zm-9.199.138h2.83c-.206.608-.762 1.044-1.415 1.044s-1.208-.436-1.415-1.044z",
    clipRule: "evenodd"
  }));
};

var SvgMotorcycle24X24 = function SvgMotorcycle24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -motorcycle",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M10.091 11.77a5.843 5.843 0 0 1 3.087 4.174 4.79 4.79 0 0 0 1.024-.196l2.664-3.532V5.521c0-.569-.611-1.027-1.033-1.027H14.3a.498.498 0 1 1 0-.994h1.533c.923 0 2.033.832 2.033 2.021v6.363h1.801c1.823 0 3.057.826 3.755 2.175.24.463.399.954.493 1.444.057.296.08.53.085.674a.498.498 0 0 1-.5.512h-.678a3.548 3.548 0 0 1-2.674 3.694 3.568 3.568 0 0 1-4.34-2.556 3.543 3.543 0 0 1-.1-1.138h-1.18a5.79 5.79 0 0 1-1.262.245 5.93 5.93 0 0 1 0 .02.499.499 0 0 1-.5.498H8.633A3.561 3.561 0 0 1 5.099 20.5a3.56 3.56 0 0 1-3.53-3.048H.5a.499.499 0 0 1-.5-.497 5.828 5.828 0 0 1 3.114-5.152C1.377 11.33.28 10.313.006 8.65A.498.498 0 0 1 .5 8.073h8.396c1.66 0 2.742.44 3.103 1.254.34.77-.088 1.633-.951 2.1a8.673 8.673 0 0 1-.956.343zm-2.443-.643a7.631 7.631 0 0 0 2.961-.592c.407-.221.58-.568.473-.807-.163-.37-.88-.661-2.188-.661H1.148c.538 1.404 2.137 2.055 4.681 2.055h.003a6.02 6.02 0 0 1 .035 0H7.4c.083 0 .166.002.248.005zm-1.813.99c-2.505.015-4.56 1.912-4.81 4.34H12.23c0-.022.001-.044.004-.066-.272-2.333-2.212-4.16-4.604-4.27-.089 0-.178-.002-.268-.005H5.835zm16.405 3.578h.694a4.365 4.365 0 0 0-.4-1.18c-.535-1.033-1.437-1.636-2.867-1.636h-1.824c-.114 1.036-.644 2.056-1.52 2.816h5.908a.5.5 0 0 1 .01 0zm-.422.994h-5.107c-.03.298-.008.6.067.892A2.567 2.567 0 0 0 19.9 19.42a2.552 2.552 0 0 0 1.918-2.73zm-19.236.763A2.564 2.564 0 0 0 5.1 19.506a2.564 2.564 0 0 0 2.52-2.054H2.582z"
  }));
};

var SvgNotebook104X104 = function SvgNotebook104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -notebook",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.586 12h76.83c4.064 0 7.358 3.298 7.358 7.366v52.077l6.075 17.095c.6 1.688-.65 3.462-2.439 3.462H2.591c-1.79 0-3.039-1.774-2.44-3.462l6.077-17.095V19.366c0-4.068 3.294-7.366 7.358-7.366zM7.933 72.618l-5.897 16.59a.59.59 0 0 0 .555.79h98.819a.59.59 0 0 0 .555-.789l-5.897-16.591H7.933zm87.84-53.252a5.361 5.361 0 0 0-5.357-5.364h-76.83a5.361 5.361 0 0 0-5.358 5.364v51.25h87.546v-51.25z",
    clipRule: "evenodd"
  }));
};

var SvgNotebook16X16 = function SvgNotebook16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -notebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m15.084 10.805.873 2.463a.735.735 0 0 1-.691.982H.734a.732.732 0 0 1-.6-.312.74.74 0 0 1-.092-.67l.873-2.463V3.19c0-.794.644-1.44 1.435-1.44h11.299c.792 0 1.435.646 1.435 1.44v7.615zM1.914 3.19c0-.24.197-.437.436-.437h11.299c.24 0 .435.196.435.437v7.2H1.914v-7.2zm-.803 10.056.657-1.853H14.23l.657 1.853H1.11z",
    clipRule: "evenodd"
  }));
};

var SvgNotebook24X24 = function SvgNotebook24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -notebook",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.338 2.7h17.324c1.068 0 1.934.868 1.934 1.937V16.34l1.355 3.813a.86.86 0 0 1-.81 1.148H.86a.86.86 0 0 1-.809-1.148l1.354-3.812V4.637c0-1.07.866-1.937 1.934-1.937Zm-1.08 14.227L1.06 20.3H22.94l-1.197-3.372H2.257Zm19.338-12.29a.935.935 0 0 0-.934-.935H3.338a.935.935 0 0 0-.934.935v11.288h19.192V4.637Z",
    fill: "currentColor"
  }));
};

var SvgNotification104X104 = function SvgNotification104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -notification",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M77.894 55.701c.04 10.83 4.237 21.024 11.816 28.697.276.279.364.694.226 1.061.109.454.076.942-.116 1.389-.318.813-1.129 1.399-2.044 1.363H66.314v1.352c0 7.96-6.421 14.437-14.313 14.437s-14.313-6.477-14.313-14.437v-1.352h-21.5a2.192 2.192 0 0 1-2.02-1.396 2.142 2.142 0 0 1-.103-1.36 1.01 1.01 0 0 1 .227-1.057c7.579-7.673 11.776-17.867 11.816-28.701l-.006-16.74c-.012-11.722 7.82-22.028 19.047-25.063l.244-.067c.329-.086.654-.156.98-.224l.14-.031c.78-.165 1.55-.22 2.296-.273.263-.019.526-.038.788-.062.104-.009.207-.028.31-.046l.041-.008c.22-.041.44-.079.664-.09l.397-.027V1c0-.553.443-1 .992-1s.991.447.991 1v12.069l.409.025a4.836 4.836 0 0 1 .701.098c.1.018.2.036.302.045.264.024.525.043.788.062.747.053 1.517.108 2.295.273l.141.031c.326.068.652.138.974.222l.252.069C70.08 16.929 77.91 27.235 77.899 38.958l-.006 16.743zm9.895 30.51c.09.039.17-.05.199-.128.044-.103.027-.186-.029-.24a1.005 1.005 0 0 1-.307-.71c-7.537-7.967-11.7-18.38-11.741-29.428l.006-16.748c.012-10.818-7.217-20.33-17.577-23.132l-.245-.066c-.28-.074-.572-.135-.862-.197l-.012-.002-.143-.031c-.641-.136-1.311-.184-2.018-.235h-.007c-.276-.02-.55-.04-.826-.065a5.367 5.367 0 0 1-.596-.092 2.432 2.432 0 0 0-.333-.046l-.248-.014-.093-.005c-.164-.01-.328-.019-.49-.031-.058 0-.164-.014-.27-.03a1.997 1.997 0 0 0-.177 0c-.04.007-.107 0-.151-.005l-.03-.003c-.14.024-.245.038-.352.04-.12.01-.273.02-.432.028l-.102.006-.238.013c-.122.006-.235.027-.347.048l-.061.01a5.299 5.299 0 0 1-.533.08c-.273.026-.549.046-.824.066h-.008c-.707.051-1.377.1-2.02.235l-.14.03-.023.006c-.286.06-.574.12-.857.196l-.238.064c-10.362 2.802-17.59 12.314-17.579 23.13l.006 16.746c-.04 11.052-4.203 21.465-11.74 29.433-.005.263-.11.52-.307.71a.184.184 0 0 0-.043.207c.044.108.118.16.2.16H38.68c.547 0 .991.447.991 1v2.352c0 6.858 5.532 12.437 12.33 12.437 6.8 0 12.33-5.58 12.33-12.437V87.21c0-.553.444-1 .992-1H87.79z",
    clipRule: "evenodd"
  }));
};

var SvgNotification16X16 = function SvgNotification16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -notification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.201 8.544a5.625 5.625 0 0 0 1.653 3.972c.111.11.16.264.142.415a.674.674 0 0 1-.052.335c-.1.249-.312.403-.633.412h-2.847A2.473 2.473 0 0 1 8 16a2.474 2.474 0 0 1-2.464-2.322H2.674a.669.669 0 0 1-.622-.426.644.644 0 0 1-.031-.418c0-.118.04-.231.126-.318A5.627 5.627 0 0 0 3.8 8.542l-.001-2.46a4.172 4.172 0 0 1 3.32-4.079c.12-.025.25-.037.38-.046V.5a.5.5 0 0 1 1.002 0v1.457a2.822 2.822 0 0 1 .569.087c1.863.499 3.134 2.155 3.132 4.039v2.461zM9.48 13.178a.5.5 0 0 1 .5-.5h2.678A6.606 6.606 0 0 1 11.2 8.546V6.082a3.169 3.169 0 0 0-2.35-3.06l-.163-.038c-.077-.017-.15-.022-.22-.028-.015 0-.03-.002-.043-.003l-.122-.008a2.208 2.208 0 0 1-.114-.017l-.145-.011a1.193 1.193 0 0 1-.122.001l-.344.035-.045.004c-.07.005-.14.01-.21.025l-.14.031C5.765 3.392 4.799 4.651 4.8 6.081v2.463a6.614 6.614 0 0 1-1.457 4.134h2.678a.5.5 0 0 1 .5.5v.347a1.478 1.478 0 0 0 2.957 0v-.347z",
    clipRule: "evenodd"
  }));
};

var SvgNotification24X24 = function SvgNotification24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -notification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.853 19.112a.498.498 0 0 1 .139.443.766.766 0 0 1-.058.412c-.109.282-.425.464-.727.472h-4.644v.03c0 1.947-1.598 3.531-3.562 3.531-1.965 0-3.564-1.584-3.564-3.531v-.03H3.773a.776.776 0 0 1-.715-.49.73.73 0 0 1-.026-.501.42.42 0 0 1 .116-.336 8.856 8.856 0 0 0 2.633-6.279L5.78 9.058c-.003-2.766 1.88-5.2 4.577-5.917a4.152 4.152 0 0 1 .901-.142l.169-.013.07-.012V.5c0-.277.225-.5.505-.5.278 0 .505.223.505.5v2.474l.013.002.007.001.218.022a4.093 4.093 0 0 1 .845.128c2.754.731 4.637 3.165 4.634 5.932l-.002 3.776a8.854 8.854 0 0 0 2.632 6.277Zm-6.299.827c0-.276.226-.5.505-.5h4.718a9.829 9.829 0 0 1-2.566-6.603l.002-3.778c.003-2.315-1.572-4.35-3.83-4.95a4.397 4.397 0 0 0-.23-.055l-.033-.007a2.956 2.956 0 0 0-.41-.048l-.036-.002-.186-.014a3.555 3.555 0 0 1-.148-.022l-.15-.014a1.713 1.713 0 0 1-.195-.016h-.004c-.033.005-.065.01-.097.011l-.182.011-.197.03-.187.014-.035.002c-.135.01-.268.018-.4.046l-.033.007c-.067.014-.127.026-.186.042-2.314.615-3.889 2.65-3.886 4.964l.002 3.778a9.835 9.835 0 0 1-2.565 6.604h4.717c.28 0 .505.224.505.5v.53C9.447 21.865 10.592 23 12 23s2.553-1.135 2.553-2.531v-.53Z",
    clipRule: "evenodd"
  }));
};

var SvgOpenFinance104X104 = function SvgOpenFinance104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -open-finance-false",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M53.862 104c-11.48 0-21.53-3.872-29.879-11.5l-.655-.602 15.386-15.386.6.557c3.966 3.648 8.924 5.498 14.744 5.498 6.369 0 11.74-2.237 15.957-6.648 4.233-4.426 6.38-10.213 6.38-17.203S74.29 45.98 70.135 41.63c-3.625-3.788-8.191-5.946-13.577-6.428l-.776-.07v-21.67l.905.053c7.018.428 13.75 2.45 20.007 6.004 7.12 4.049 12.752 9.62 16.75 16.554 4.05 7.038 6.072 14.742 6.016 22.905a46.02 46.02 0 0 1-5.935 22.247c-4.034 7.142-9.628 12.797-16.632 16.8C69.96 101.99 62.21 104 53.862 104ZM25.797 91.836c7.886 6.943 17.326 10.459 28.065 10.459 8.046 0 15.512-1.934 22.186-5.75 6.732-3.85 12.113-9.289 15.993-16.161a44.34 44.34 0 0 0 5.714-21.422c.056-7.852-1.893-15.271-5.79-22.04-3.84-6.671-9.26-12.027-16.113-15.92-5.762-3.276-11.934-5.196-18.368-5.72v18.303c5.47.65 10.14 2.956 13.88 6.864 4.465 4.675 6.733 10.823 6.733 18.264 0 7.444-2.307 13.628-6.853 18.381-4.552 4.762-10.333 7.175-17.189 7.175-5.966 0-11.105-1.817-15.288-5.406l-12.97 12.973Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.398 41.586 16.322 19.51l.456-.594C25.35 7.774 37.685 1.081 51.508.067L52.424 0v35.139l-.77.075c-4.896.474-9.154 2.422-12.656 5.79l-.6.582ZM18.587 19.364l19.845 19.84c3.474-3.119 7.6-5.003 12.287-5.602V1.839C37.999 3.018 26.643 9.21 18.587 19.364Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.97 57.526H4.487l-.104-.736c-1.573-11.402 1.783-24.543 8.765-34.294l.585-.814 22.5 22.496-.387.583c-2.259 3.387-3.547 7.41-3.827 11.967l-.047.798ZM5.979 55.821h24.4c.375-4.277 1.607-8.11 3.673-11.419L13.956 24.311C7.758 33.42 4.738 45.329 5.978 55.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.058 89.412-.596-.49C14.357 83.917 6.61 75.166 4.388 61.88l-.166-.99h27.79l.07.775c.401 4.515 1.748 8.46 4.007 11.724l.406.585-15.437 15.44ZM6.246 62.59c2.27 11.792 9.082 19.762 14.703 24.521l13.345-13.345c-2.066-3.194-3.35-6.948-3.83-11.176H6.247Z"
  }));
};

var SvgOpenFinance24X24 = function SvgOpenFinance24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -open-finance-false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.492 24c-2.65 0-4.97-.893-6.896-2.654l-.15-.139 3.55-3.55.138.128c.915.842 2.06 1.27 3.403 1.27 1.47 0 2.71-.517 3.682-1.535.977-1.022 1.472-2.357 1.472-3.97s-.485-2.939-1.444-3.943c-.837-.874-1.89-1.372-3.133-1.483l-.18-.016V3.107l.21.012c1.619.099 3.173.565 4.617 1.386a10.228 10.228 0 0 1 3.865 3.82 10.316 10.316 0 0 1 1.388 5.286 10.62 10.62 0 0 1-1.37 5.134 10.14 10.14 0 0 1-3.838 3.876c-1.6.915-3.388 1.379-5.315 1.379Zm-6.477-2.807c1.82 1.602 3.998 2.414 6.477 2.414 1.856 0 3.58-.447 5.12-1.327a9.752 9.752 0 0 0 3.69-3.73 10.232 10.232 0 0 0 1.319-4.943 9.924 9.924 0 0 0-1.336-5.086c-.887-1.54-2.137-2.776-3.719-3.674a10.19 10.19 0 0 0-4.238-1.32V7.75c1.262.15 2.34.682 3.203 1.584 1.03 1.079 1.553 2.497 1.553 4.214 0 1.718-.532 3.145-1.581 4.242-1.05 1.099-2.385 1.656-3.967 1.656-1.377 0-2.563-.42-3.528-1.248l-2.993 2.994Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.923 9.597 3.828 4.502l.105-.137C5.912 1.794 8.758.25 11.948.015L12.159 0v8.109l-.177.017A4.777 4.777 0 0 0 9.06 9.462l-.138.135ZM4.35 4.469l4.58 4.578a5.139 5.139 0 0 1 2.835-1.293V.424C8.83.696 6.21 2.125 4.35 4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.44 13.275H1.095l-.023-.17c-.364-2.631.411-5.664 2.022-7.914l.135-.188 5.192 5.192-.089.134c-.521.782-.818 1.71-.883 2.762l-.01.184Zm-6-.393h5.632c.086-.988.37-1.872.847-2.636L3.282 5.61c-1.43 2.102-2.127 4.85-1.841 7.272Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.92 20.633-.137-.113c-1.41-1.155-3.197-3.174-3.71-6.24l-.038-.229h6.413l.016.179c.093 1.042.404 1.952.925 2.706l.094.134-3.563 3.563Zm-3.418-6.19c.524 2.722 2.096 4.561 3.393 5.66l3.08-3.08c-.477-.737-.774-1.604-.884-2.58H1.502Z"
  }));
};

var SvgOpenFinanceFilled104X104 = function SvgOpenFinanceFilled104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -open-finance-filled",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M93.452 36.195c-4.01-6.954-9.586-12.46-16.732-16.516-6.291-3.57-12.96-5.569-20.002-5.996v20.33c5.729.51 10.52 2.778 14.375 6.806 4.408 4.61 6.617 10.602 6.617 17.978 0 7.378-2.245 13.407-6.735 18.096-4.491 4.69-10.118 7.032-16.879 7.032-6.184 0-11.384-1.945-15.601-5.824L24.059 92.523C32.432 100.175 42.378 104 53.899 104c8.387 0 16.06-1.987 23.02-5.965 7.029-4.016 12.569-9.604 16.612-16.766a45.915 45.915 0 0 0 5.928-22.211c.059-8.188-1.944-15.81-6.007-22.863Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.16 40.158c3.725-3.58 8.193-5.624 13.4-6.127V0C38.279.973 25.666 7.353 16.82 18.84l21.34 21.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.791 56.722c.299-4.812 1.643-9.014 4.04-12.6L13.146 22.455c-7.51 10.476-10.213 23.83-8.773 34.263h26.42v.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.859 61.874H4.375c2.023 12.045 8.787 21.022 16.062 26.981L35.09 74.217c-2.405-3.472-3.812-7.587-4.231-12.343Z"
  }));
};

var SvgOpenFinanceFilled24X24 = function SvgOpenFinanceFilled24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -open-finance-filled",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.628 8.353c-.926-1.605-2.212-2.876-3.862-3.812a10.537 10.537 0 0 0-4.616-1.383v4.691c1.322.118 2.428.641 3.318 1.57 1.017 1.065 1.527 2.447 1.527 4.15 0 1.702-.518 3.094-1.555 4.176-1.036 1.082-2.335 1.622-3.895 1.622-1.427 0-2.627-.448-3.6-1.344l-3.332 3.329C7.546 23.117 9.841 24 12.5 24c1.935 0 3.706-.458 5.312-1.376a10.074 10.074 0 0 0 3.834-3.87 10.597 10.597 0 0 0 1.368-5.125 10.24 10.24 0 0 0-1.386-5.276Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.868 9.267a5.038 5.038 0 0 1 3.093-1.414V0C8.896.224 5.985 1.697 3.943 4.348l4.925 4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.167 13.09c.069-1.11.38-2.08.933-2.908l-5.005-5c-1.733 2.417-2.357 5.5-2.025 7.907h6.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.182 14.279H1.07c.467 2.78 2.028 4.851 3.707 6.226l3.382-3.378c-.555-.801-.88-1.75-.977-2.848Z"
  }));
};

var SvgOperationCardIn104X104 = function SvgOperationCardIn104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -operation-card-in",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M67.846 51.99c2.83 0 5.123-2.271 5.123-5.072V2H42.603v14.781a1.01 1.01 0 0 1-1.016 1.006 1.01 1.01 0 0 1-1.015-1.006V2.001h-9.54v44.917c0 2.801 2.293 5.071 5.123 5.071h31.691zM30.001 0h-14a1 1 0 1 0 0 2h13v44.918C29 50.83 32.202 54 36.154 54h31.691C71.797 54 75 50.83 75 46.918V2h12.998a1 1 0 1 0 0-2H74a1.05 1.05 0 0 0-.029 0H41.602a1.047 1.047 0 0 0-.015 0H30.03a1.047 1.047 0 0 0-.014 0h-.015zm4.723 84.268L50.978 69.31v33.693c0 .551.458.997 1.022.997s1.023-.446 1.023-.997V69.199l16.28 13.925a1.04 1.04 0 0 0 1.444-.093.98.98 0 0 0-.095-1.407L52.674 66.248a1.042 1.042 0 0 0-1.375.024L33.32 82.817a.98.98 0 0 0-.042 1.41c.388.401 1.035.42 1.446.041zM63 42.467V25.534c0-1.4-1.122-2.534-2.505-2.534h-7.99C51.123 23 50 24.134 50 25.534v16.933c0 1.4 1.122 2.533 2.506 2.533h7.989C61.878 45 63 43.866 63 42.467zm-2.505-17.449c.281 0 .51.23.51.516v16.933a.513.513 0 0 1-.51.515h-7.99a.512.512 0 0 1-.509-.515V25.534c0-.286.228-.516.51-.516h7.989z",
    clipRule: "evenodd"
  }));
};

var SvgOperationCardIn16X16 = function SvgOperationCardIn16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -operation-card-in",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.18 1H2.52C2.232 1 2 .776 2 .5s.232-.5.519-.5H13.48c.287 0 .519.224.519.5s-.232.5-.519.5h-1.66v6.215c0 .768-.645 1.39-1.44 1.39H5.62c-.795 0-1.44-.622-1.44-1.39V1zm1.037 0v6.215c0 .216.181.39.405.39h4.758a.396.396 0 0 0 .404-.39V1H6.955v1.807a.51.51 0 0 1-.518.5.51.51 0 0 1-.519-.5V1h-.7zm-.275 11.974c.196.2.524.21.733.02l1.807-1.643V15.5c0 .276.233.5.52.5a.51.51 0 0 0 .518-.5v-4.205l1.821 1.54a.532.532 0 0 0 .732-.046.488.488 0 0 0-.048-.706L8.343 9.816a.533.533 0 0 0-.698.012l-2.682 2.44a.487.487 0 0 0-.021.706zm5.085-6.432V4.074a.737.737 0 0 0-.749-.723h-1.22a.737.737 0 0 0-.75.723v2.468c0 .4.336.722.75.722h1.22a.736.736 0 0 0 .75-.722zm-1.683-.278V4.351h.645v1.913h-.645z",
    clipRule: "evenodd"
  }));
};

var SvgOperationCardIn24X24 = function SvgOperationCardIn24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -operation-card-in",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.685 1H3.994A.497.497 0 0 1 3.5.5c0-.276.221-.5.494-.5h16.012c.273 0 .494.224.494.5s-.221.5-.494.5h-2.69v9.798c0 1.03-.823 1.863-1.84 1.863H8.526a1.852 1.852 0 0 1-1.84-1.863V1Zm.988 0v9.798c0 .477.382.863.853.863H15.476a.858.858 0 0 0 .853-.863V1h-6.12v3.038c0 .276-.22.5-.494.5a.497.497 0 0 1-.494-.5V1H7.673Zm.749 18.464 3.084-2.944v6.98c0 .276.221.5.494.5a.497.497 0 0 0 .494-.5v-7.036l3.098 2.749a.49.49 0 0 0 .697-.047.504.504 0 0 0-.046-.705l-3.917-3.476a.49.49 0 0 0-.665.012l-3.917 3.74a.504.504 0 0 0-.02.707c.186.2.5.21.698.02Zm6.275-9.7V5.98a.836.836 0 0 0-.831-.84h-1.784a.836.836 0 0 0-.83.84v3.784c0 .465.371.841.83.841h1.784c.46 0 .83-.376.83-.84Zm-2.455-.159V6.14h1.468v3.466H12.24Z",
    fill: "currentColor"
  }));
};

var SvgOperationCardOut104X104 = function SvgOperationCardOut104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -operation-card-out",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M67.846 51.99c2.83 0 5.123-2.271 5.123-5.072V2H42.603v14.781a1.01 1.01 0 0 1-1.016 1.006 1.01 1.01 0 0 1-1.015-1.006V2.001h-9.54v44.917c0 2.801 2.293 5.071 5.123 5.071h31.691zM30.001 0h-14a1 1 0 1 0 0 2h13v44.918C29 50.83 32.202 54 36.154 54h31.691C71.797 54 75 50.83 75 46.918V2h12.998a1 1 0 1 0 0-2H74a1.05 1.05 0 0 0-.029 0H41.602a1.047 1.047 0 0 0-.015 0H30.03a1.047 1.047 0 0 0-.014 0h-.015zm4.723 85.732 16.254 14.958V66.998c0-.551.458-.998 1.022-.998s1.023.447 1.023.998v33.804l16.28-13.926a1.04 1.04 0 0 1 1.444.093.98.98 0 0 1-.095 1.408l-17.978 15.376a1.042 1.042 0 0 1-1.375-.025L33.32 87.183a.98.98 0 0 1-.042-1.41 1.04 1.04 0 0 1 1.446-.041zM63 42.467V25.534c0-1.4-1.122-2.534-2.505-2.534h-7.99C51.123 23 50 24.134 50 25.534v16.933c0 1.4 1.122 2.533 2.506 2.533h7.989C61.878 45 63 43.866 63 42.467zm-2.505-17.449c.281 0 .51.23.51.516v16.933a.513.513 0 0 1-.51.515h-7.99a.512.512 0 0 1-.509-.515V25.534c0-.286.228-.516.51-.516h7.989z",
    clipRule: "evenodd"
  }));
};

var SvgOperationCardOut16X16 = function SvgOperationCardOut16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -operation-card-out",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.18 1H2.52C2.232 1 2 .776 2 .5s.232-.5.519-.5H13.48c.287 0 .519.224.519.5s-.232.5-.519.5h-1.66v6.215c0 .768-.645 1.39-1.44 1.39H5.62c-.795 0-1.44-.622-1.44-1.39V1zm1.037 0v6.215c0 .216.181.39.405.39h4.758a.396.396 0 0 0 .404-.39V1H6.955v1.807a.51.51 0 0 1-.518.5.51.51 0 0 1-.519-.5V1h-.7zm5.843 11.717a.532.532 0 0 0-.733-.02L8.52 14.34v-4.15a.51.51 0 0 0-.519-.5.51.51 0 0 0-.519.5v4.206l-1.821-1.54a.532.532 0 0 0-.732.047.488.488 0 0 0 .048.706l2.682 2.266c.201.17.503.164.698-.013l2.682-2.439a.487.487 0 0 0 .021-.707zm-1.033-6.175V4.074a.737.737 0 0 0-.749-.723h-1.22a.737.737 0 0 0-.75.723v2.468c0 .4.336.722.75.722h1.22a.736.736 0 0 0 .75-.722zm-1.683-.278V4.351h.645v1.913h-.645z",
    clipRule: "evenodd"
  }));
};

var SvgOperationCardOut24X24 = function SvgOperationCardOut24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -operation-card-out",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.685 1H3.994A.497.497 0 0 1 3.5.5c0-.276.221-.5.494-.5h16.012c.273 0 .494.224.494.5s-.221.5-.494.5h-2.69v9.798c0 1.03-.823 1.863-1.84 1.863H8.526a1.852 1.852 0 0 1-1.84-1.863V1Zm.988 0v9.798c0 .477.382.863.853.863H15.476a.858.858 0 0 0 .853-.863V1h-6.12v3.038c0 .276-.22.5-.494.5a.497.497 0 0 1-.494-.5V1H7.673Zm8.604 18.417a.49.49 0 0 0-.699-.02l-3.084 2.944v-6.98c0-.276-.221-.5-.494-.5a.497.497 0 0 0-.494.5v7.036l-3.098-2.748a.49.49 0 0 0-.697.046.504.504 0 0 0 .046.706l3.917 3.475a.49.49 0 0 0 .665-.012l3.917-3.74a.504.504 0 0 0 .02-.707Zm-1.58-9.653V5.98a.836.836 0 0 0-.831-.84h-1.784a.836.836 0 0 0-.83.84v3.784c0 .465.371.841.83.841h1.784c.46 0 .83-.376.83-.84Zm-2.455-.159V6.14h1.468v3.466H12.24Z",
    fill: "currentColor"
  }));
};

var SvgOrderDown16X16 = function SvgOrderDown16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -order-down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.427.28 3.14 5.892a.679.679 0 0 0-.049.753c.13.223.37.354.623.354h8.572c.253 0 .493-.13.622-.352a.681.681 0 0 0-.047-.753L8.574.28A.72.72 0 0 0 8 0a.722.722 0 0 0-.573.28zM4.317 6h7.366L8 1.177 4.317 6zm7.969 3c.254 0 .493.13.623.354a.679.679 0 0 1-.05.753L8.574 15.72A.721.721 0 0 1 8 16a.72.72 0 0 1-.574-.28L3.14 10.105a.682.682 0 0 1-.047-.753A.718.718 0 0 1 3.714 9h8.572z",
    clipRule: "evenodd"
  }));
};

var SvgOrderDown24X24 = function SvgOrderDown24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -order-down",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.116 9.601a.913.913 0 0 0 .772.399h14.223c.313 0 .61-.146.772-.397A.73.73 0 0 0 20 9.21a.736.736 0 0 0-.177-.474L12.711.315A.93.93 0 0 0 12 0a.93.93 0 0 0-.71.314l-7.112 8.42a.722.722 0 0 0-.062.867ZM5.316 9 12 1.084 18.685 9H5.315Zm14.568 5.399A.913.913 0 0 0 19.11 14H4.89a.913.913 0 0 0-.772.397.729.729 0 0 0-.117.393c0 .172.063.338.177.474l7.112 8.421A.93.93 0 0 0 12 24a.93.93 0 0 0 .71-.314l7.112-8.42a.722.722 0 0 0 .062-.867Z",
    fill: "currentColor"
  }));
};

var SvgOrderNoPosition16X16 = function SvgOrderNoPosition16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -order-no-position",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.427.28 3.14 5.892a.679.679 0 0 0-.049.753c.13.223.37.354.623.354h8.572c.253 0 .493-.13.622-.352a.681.681 0 0 0-.047-.753L8.574.28A.72.72 0 0 0 8 0a.722.722 0 0 0-.573.28zM4.317 6h7.366L8 1.177 4.317 6zm7.969 3c.254 0 .493.13.623.354a.679.679 0 0 1-.05.753L8.574 15.72A.721.721 0 0 1 8 16a.72.72 0 0 1-.574-.28L3.14 10.105a.682.682 0 0 1-.047-.753A.718.718 0 0 1 3.714 9h8.572zm-.603 1L8 14.824 4.317 10h7.366z",
    clipRule: "evenodd"
  }));
};

var SvgOrderNoPosition24X24 = function SvgOrderNoPosition24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -order-no-position",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.116 9.601a.913.913 0 0 0 .772.399h14.223c.313 0 .61-.146.772-.397A.73.73 0 0 0 20 9.21a.736.736 0 0 0-.177-.474L12.711.315A.93.93 0 0 0 12 0a.93.93 0 0 0-.71.314l-7.112 8.42a.722.722 0 0 0-.062.867ZM5.316 9 12 1.084 18.685 9H5.315Zm14.568 5.399A.913.913 0 0 0 19.11 14H4.89a.913.913 0 0 0-.772.397.729.729 0 0 0-.117.393c0 .172.063.338.177.474l7.112 8.421A.93.93 0 0 0 12 24a.93.93 0 0 0 .71-.314l7.112-8.42a.722.722 0 0 0 .062-.867ZM18.686 15 12 22.916 5.315 15h13.37Z",
    fill: "currentColor"
  }));
};

var SvgOrderUp16X16 = function SvgOrderUp16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -order-up",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.427.28 3.14 5.892a.679.679 0 0 0-.049.753c.13.223.37.354.623.354h8.572c.253 0 .493-.13.622-.352a.681.681 0 0 0-.047-.753L8.574.28A.72.72 0 0 0 8 0a.722.722 0 0 0-.573.28zM12.286 9c.254 0 .493.13.623.354a.679.679 0 0 1-.05.753L8.574 15.72A.721.721 0 0 1 8 16a.72.72 0 0 1-.574-.28L3.14 10.105a.682.682 0 0 1-.047-.753A.718.718 0 0 1 3.714 9h8.572zm-.603 1L8 14.824 4.317 10h7.366z",
    clipRule: "evenodd"
  }));
};

var SvgOrderUp24X24 = function SvgOrderUp24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -order-up",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.116 9.601a.913.913 0 0 0 .772.399h14.223c.313 0 .61-.146.772-.397A.73.73 0 0 0 20 9.21a.736.736 0 0 0-.177-.474L12.711.315A.93.93 0 0 0 12 0a.93.93 0 0 0-.71.314l-7.112 8.42a.722.722 0 0 0-.062.867Zm15.768 4.797A.913.913 0 0 0 19.11 14H4.89a.913.913 0 0 0-.772.397.729.729 0 0 0-.117.393c0 .172.063.338.177.474l7.112 8.421A.93.93 0 0 0 12 24a.93.93 0 0 0 .71-.314l7.112-8.42a.722.722 0 0 0 .062-.867ZM18.686 15 12 22.916 5.315 15h13.37Z",
    fill: "currentColor"
  }));
};

var SvgPadlockClosed104X104 = function SvgPadlockClosed104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -padlock-closed",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32 36H19.589c-3.915 0-7.089 3.122-7.089 6.973v54.054c0 3.851 3.174 6.973 7.089 6.973H84.41c3.916 0 7.09-3.122 7.09-6.973V42.973c0-3.851-3.174-6.973-7.09-6.973H72V19.959C72 8.936 63.045 0 52 0S32 8.936 32 19.959V36zm1.988 0h36.024V19.959c0-9.927-8.065-17.976-18.012-17.976S33.988 10.032 33.988 19.96V36zm-14.4 1.98c-2.803 0-5.075 2.235-5.075 4.993v54.054c0 2.758 2.272 4.993 5.076 4.993H84.41c2.804 0 5.077-2.235 5.077-4.993V42.973c0-2.758-2.273-4.993-5.077-4.993H19.59z",
    clipRule: "evenodd"
  }));
};

var SvgPadlockClosed16X16 = function SvgPadlockClosed16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -padlock-closed",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.56 3.367C4.56 1.5 6.108 0 8 0s3.44 1.5 3.44 3.367v2.421c0 .321-.132.212-.44.212s-.705.11-.705-.212V3.367c0-1.226-1.02-2.233-2.295-2.233S5.705 2.141 5.705 3.367v1.805h6.879c.785 0 1.416.648 1.416 1.443v7.941c0 .795-.631 1.444-1.416 1.444H3.416C2.632 16 2 15.35 2 14.556v-7.94c0-.795.632-1.444 1.416-1.444H4.56V3.367zM3.416 6.3a.31.31 0 0 0-.305.314v7.941c0 .176.14.314.305.314h9.168a.31.31 0 0 0 .305-.314v-7.94a.31.31 0 0 0-.305-.315H5.178a.581.581 0 0 1-.091 0H3.416z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.44 5.788v-.616h-1.145v.616c0 .321.397.212.705.212.308 0 .44.11.44-.212z"
  })));
};

var SvgPadlockClosed24X24 = function SvgPadlockClosed24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -padlock-closed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.463 8.997a.543.543 0 0 0 .113 0h8.848a.543.543 0 0 0 .113 0h2.626c.47 0 .85.385.85.861v12.283c0 .475-.38.86-.85.86H4.838a.857.857 0 0 1-.852-.86V9.858c0-.475.382-.86.852-.86h2.625ZM17 8h2.163C20.178 8 21 8.83 21 9.858v12.283A1.848 1.848 0 0 1 19.163 24H4.837A1.849 1.849 0 0 1 3 22.14V9.858C3 8.832 3.823 8 4.837 8H7V4.833C7 2.163 9.238 0 12 0c2.761 0 5 2.163 5 4.833V8Zm-1.039 0V4.833c0-2.115-1.773-3.829-3.962-3.829-2.187 0-3.96 1.714-3.96 3.829V8h7.922Z",
    clipRule: "evenodd"
  }));
};

var SvgPadlockOpen104X104 = function SvgPadlockOpen104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -padlock-open",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32 36V20C32 8.954 40.954 0 52 0s20 8.954 20 20a1 1 0 1 1-2 0c0-9.941-8.059-18-18-18-9.83 0-17.82 7.88-17.997 17.67L34 20v16h50.41c3.916 0 7.09 3.122 7.09 6.973v54.054c0 3.851-3.174 6.973-7.09 6.973H19.59c-3.915 0-7.089-3.122-7.089-6.973V42.973c0-3.851 3.174-6.973 7.089-6.973H32zm-12.411 1.98c-2.804 0-5.076 2.235-5.076 4.993v54.054c0 2.758 2.272 4.993 5.076 4.993H84.41c2.804 0 5.077-2.235 5.077-4.993V42.973c0-2.758-2.273-4.993-5.077-4.993H19.59z",
    clipRule: "evenodd"
  }));
};

var SvgPadlockOpen16X16 = function SvgPadlockOpen16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -padlock-open",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.56 3.367C4.56 1.5 6.108 0 8 0s3.44 1.5 3.44 3.367v.421a.57.57 0 0 1-.573.567.57.57 0 0 1-.572-.567v-.421c0-1.226-1.02-2.233-2.295-2.233S5.705 2.141 5.705 3.367v1.805h6.879c.785 0 1.416.648 1.416 1.443v7.941c0 .795-.631 1.444-1.416 1.444H3.416C2.632 16 2 15.35 2 14.556v-7.94c0-.795.632-1.444 1.416-1.444H4.56V3.367zM3.416 6.3a.31.31 0 0 0-.305.314v7.941c0 .176.14.314.305.314h9.168a.31.31 0 0 0 .305-.314v-7.94a.31.31 0 0 0-.305-.315H5.178a.581.581 0 0 1-.091 0H3.416z",
    clipRule: "evenodd"
  }));
};

var SvgPadlockOpen24X24 = function SvgPadlockOpen24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -padlock-open",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.463 8.998a.543.543 0 0 0 .113 0h11.587c.47 0 .85.385.85.86v12.284c0 .475-.38.86-.85.86H4.838a.857.857 0 0 1-.852-.86V9.857c0-.475.382-.86.852-.86h2.625Zm.576-4.165V8h11.124C20.178 8 21 8.832 21 9.858v12.284A1.848 1.848 0 0 1 19.163 24H4.837A1.849 1.849 0 0 1 3 22.142V9.857C3 8.832 3.823 8 4.837 8H7V4.833C7 2.164 9.238 0 12 0c2.761 0 5 2.164 5 4.833v.652a.511.511 0 0 1-.52.502.511.511 0 0 1-.519-.502v-.652c0-2.114-1.773-3.828-3.962-3.828-2.187 0-3.96 1.714-3.96 3.828Z",
    fill: "currentColor"
  }));
};

var SvgPassword104X104 = function SvgPassword104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -password",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M45.5 2c-9.722 0-17.512 7.509-17.512 16.662V43h35.024V18.662C63.012 9.51 55.222 2 45.5 2zM26 18.662V43H12.023C8.696 43 6 45.676 6 48.977v49.046C6 101.324 8.696 104 12.023 104h66.954c3.327 0 6.023-2.676 6.023-5.977V89h7.012C95.32 89 98 86.3 98 82.97V65.03C98 61.7 95.32 59 92.012 59H85V48.977C85 45.676 82.304 43 78.977 43H65V18.662C65 8.306 56.22 0 45.5 0S26 8.306 26 18.662zM82.993 59V48.977c0-2.2-1.798-3.985-4.016-3.985H12.023c-2.218 0-4.015 1.784-4.015 3.985v49.046c0 2.201 1.797 3.985 4.015 3.985h66.954c2.218 0 4.015-1.784 4.015-3.985V89H40.989C37.68 89 35 86.3 35 82.97V65.03C35 61.7 37.68 59 40.988 59h42.005zm-42.005 2.01c-2.205 0-3.992 1.8-3.992 4.02v17.94c0 2.22 1.787 4.02 3.992 4.02h51.024c2.205 0 3.992-1.8 3.992-4.02V65.03c0-2.22-1.787-4.02-3.992-4.02H40.988zM66.48 68.5c.555 0 1.005.448 1.005 1v3.549l3.577-1.376c.518-.199 1.1.057 1.3.573a.998.998 0 0 1-.575 1.293l-3.645 1.401 2.4 2.925a.996.996 0 0 1-.142 1.407c-.43.349-1.063.285-1.414-.142L66.5 76.1l-2.396 3.017a1.009 1.009 0 0 1-1.412.164.997.997 0 0 1-.166-1.404l2.334-2.938-3.657-1.422a.998.998 0 0 1-.57-1.295 1.007 1.007 0 0 1 1.302-.568l3.54 1.377V69.5c0-.552.45-1 1.005-1zm17.568 0c.555 0 1.005.448 1.005 1v3.55l3.58-1.376c.517-.199 1.1.057 1.3.573a.999.999 0 0 1-.576 1.293l-3.645 1.401 2.4 2.92a.996.996 0 0 1-.141 1.407c-.43.35-1.063.287-1.414-.14l-2.49-3.028-2.4 3.02a1.009 1.009 0 0 1-1.411.163.996.996 0 0 1-.165-1.404l2.336-2.939-3.655-1.421a.998.998 0 0 1-.57-1.295 1.007 1.007 0 0 1 1.302-.568l3.54 1.376V69.5c0-.552.45-1 1.004-1zm-35.132.001c.555 0 1.005.448 1.005 1v3.55l3.578-1.376c.518-.199 1.1.058 1.3.573a.998.998 0 0 1-.575 1.293l-3.645 1.401 2.401 2.92a.996.996 0 0 1-.142 1.408c-.43.35-1.062.286-1.414-.141l-2.49-3.03-2.402 3.022a1.009 1.009 0 0 1-1.412.164.997.997 0 0 1-.164-1.405l2.336-2.94-3.652-1.42a.998.998 0 0 1-.57-1.295 1.007 1.007 0 0 1 1.301-.568l3.54 1.377V69.5c0-.552.45-1 1.005-1z",
    clipRule: "evenodd"
  }));
};

var SvgPassword16X16 = function SvgPassword16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -password",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.998.999c-1.162 0-2.096.928-2.096 2.062v3.222h4.193V3.06c0-1.134-.934-2.062-2.097-2.062zm-3.1 2.062v3.222h-.984c-.78 0-1.414.67-1.414 1.498v6.72C1.5 15.33 2.133 16 2.914 16h8.172c.78 0 1.414-.67 1.414-1.499V13.5h.5a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 13 8.5h-.5v-.719c0-.827-.633-1.498-1.414-1.498h-.988V3.06C10.098 1.366 8.706 0 6.998 0c-1.707 0-3.1 1.366-3.1 3.06zm7.66 5.439v-.719c0-.276-.212-.5-.472-.5H2.914c-.26 0-.471.224-.471.5v6.72c0 .276.211.5.471.5h8.172c.26 0 .471-.224.471-.5V13.5H6.5A1.5 1.5 0 0 1 5 12v-2a1.5 1.5 0 0 1 1.5-1.5h5.057zM6.5 9.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H6.5zm.876.63c.11 0 .2.09.2.2v.444l.405-.168a.2.2 0 1 1 .153.37l-.44.182.294.386a.2.2 0 0 1-.318.243l-.29-.381-.28.378a.2.2 0 1 1-.321-.237l.286-.389-.442-.185a.2.2 0 0 1 .154-.37l.4.168v-.441c0-.11.089-.2.2-.2zm4.843 0c.11 0 .2.09.2.2v.444l.404-.168a.2.2 0 1 1 .153.37l-.44.182.295.386a.2.2 0 0 1-.318.243l-.292-.382-.279.379a.2.2 0 1 1-.322-.237l.287-.389-.442-.185a.2.2 0 0 1 .155-.37l.399.168v-.441c0-.11.09-.2.2-.2zm-2.422 0c.11 0 .2.09.2.2v.444l.405-.168a.2.2 0 1 1 .153.37l-.44.182.294.386a.2.2 0 0 1-.318.243l-.29-.381-.28.378a.2.2 0 1 1-.321-.238l.286-.388-.442-.185a.2.2 0 1 1 .154-.37l.4.168v-.441c0-.11.089-.2.2-.2z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
};

var SvgPassword24X24 = function SvgPassword24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -password",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.502 1.002c-2.232 0-3.95 1.578-3.95 3.42v5.233h7.9V4.422c0-1.842-1.718-3.42-3.95-3.42zm-4.977 3.42v5.233H2.508c-.833 0-1.508.671-1.508 1.5v11.343c0 .829.675 1.5 1.508 1.5h15.984c.833 0 1.508-.671 1.508-1.5V20.55h1.526c.814 0 1.474-.672 1.474-1.5v-4.274c0-.829-.66-1.5-1.474-1.5H20v-2.12c0-.829-.675-1.5-1.508-1.5h-3.013V4.422c0-2.488-2.28-4.42-4.977-4.42-2.698 0-4.977 1.932-4.977 4.42zm13.47 8.853v-2.12c0-.276-.226-.5-.503-.5H2.508a.501.501 0 0 0-.503.5v11.343c0 .276.226.5.503.5h15.984a.501.501 0 0 0 .503-.5V20.55h-9.52C8.66 20.55 8 19.877 8 19.05v-4.274c0-.829.66-1.5 1.474-1.5h9.52zm-9.52 1a.496.496 0 0 0-.492.5v4.274c0 .276.22.5.491.5h12.052a.496.496 0 0 0 .491-.5v-4.274c0-.277-.22-.5-.491-.5H9.474zm6.018 1.311a.3.3 0 0 1 .3.3v.703l.737-.278a.3.3 0 0 1 .212.561l-.747.282.487.583a.3.3 0 1 1-.46.384l-.524-.626-.503.623a.3.3 0 1 1-.467-.377l.474-.587-.75-.287a.3.3 0 0 1 .214-.56l.727.278v-.699a.3.3 0 0 1 .3-.3zm4.064 0a.3.3 0 0 1 .3.3v.704l.737-.279a.3.3 0 0 1 .212.561l-.746.282.487.582a.3.3 0 1 1-.46.385l-.524-.626-.504.623a.3.3 0 1 1-.467-.377l.474-.587-.75-.287a.3.3 0 1 1 .215-.56l.726.278v-.699a.3.3 0 0 1 .3-.3zm-8.123 0a.3.3 0 0 1 .3.3v.703l.735-.278a.3.3 0 1 1 .212.562l-.745.281.487.582a.3.3 0 1 1-.46.385l-.525-.627-.504.624a.3.3 0 1 1-.467-.377l.474-.587-.748-.286a.3.3 0 0 1 .214-.56l.727.277v-.699a.3.3 0 0 1 .3-.3z",
    clipRule: "evenodd"
  }));
};

var SvgPatrimony104X104 = function SvgPatrimony104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -patrimony",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 35.017c.674 29.367 20.28 55.602 49.988 66.914C81.704 90.623 101.32 64.388 102 34.994V7.045A5.05 5.05 0 0 0 96.955 2H7.044A5.05 5.05 0 0 0 2 7.045v27.972zM7.044 0h89.911A7.052 7.052 0 0 1 104 7.045v27.972c-.702 30.353-20.98 57.396-51.66 68.919a.996.996 0 0 1-.704 0C20.964 92.409.696 65.366 0 35.04V7.045C0 3.16 3.16 0 7.044 0zm53.285 73.849h10.826V15.725l-38.311.078v58.046H43.67V55.56a1 1 0 0 1 1-1h14.658a1 1 0 0 1 1 1v18.288zm-2 0H45.67V56.56h12.658v17.288zm13.824-60.125h.002a.998.998 0 0 1 1 1v60.125a1 1 0 0 1-1 1H31.843a1 1 0 0 1-1-1V14.805a1 1 0 0 1 1-1l40.31-.081zM45.181 27.479h14.902a1 1 0 0 0 0-2H45.18a1 1 0 0 0 0 2zm14.392 14.27H44.67a1 1 0 0 1 0-2h14.902a1 1 0 0 1 0 2z",
    clipRule: "evenodd"
  }));
};

var SvgPatrimony16X16 = function SvgPatrimony16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -patrimony",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.998 14.965c4.165-1.637 6.906-5.337 7.002-9.474V1.389A.39.39 0 0 0 14.611 1H1.389A.39.39 0 0 0 1 1.389v4.114c.095 4.125 2.835 7.824 6.998 9.462ZM1.389 0h13.222A1.39 1.39 0 0 1 16 1.389v4.114c-.107 4.617-3.179 8.72-7.826 10.466a.506.506 0 0 1-.352 0C3.176 14.222.106 10.118 0 5.514V1.389A1.39 1.39 0 0 1 1.389 0Zm8.189 10.86h.886V3.02l-4.928.009v7.832h.886V8.525a.5.5 0 0 1 .5-.5h2.156a.5.5 0 0 1 .5.5v2.336Zm-1 0H7.423V9.026h1.155v1.836Zm2.385-8.841a.499.499 0 0 1 .5.5v8.842a.5.5 0 0 1-.5.5H5.037a.5.5 0 0 1-.5-.5V2.53a.5.5 0 0 1 .499-.5l5.928-.011ZM6.997 4.747h2.191a.5.5 0 1 0 0-1h-2.19a.5.5 0 0 0 0 1Zm2.116 2.099h-2.19a.5.5 0 0 1 0-1h2.19a.5.5 0 1 1 0 1Z",
    fill: "currentColor"
  }));
};

var SvgPatrimony24X24 = function SvgPatrimony24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -patrimony",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.998 20.965c5.353-2.084 8.879-6.83 9.002-12.14V3.626A.627.627 0 0 0 20.374 3H3.626A.627.627 0 0 0 3 3.626v5.211c.122 5.298 3.647 10.044 8.998 12.128ZM3.626 2h16.748C21.271 2 22 2.73 22 3.626v5.211c-.134 5.789-3.991 10.94-9.826 13.132a.506.506 0 0 1-.352 0C5.988 19.776 2.133 14.626 2 8.848V3.626C2 2.73 2.729 2 3.626 2Zm10.24 13.757h1.388v-10.2l-6.509.014v10.186h1.39v-3.093a.5.5 0 0 1 .5-.5h2.73a.5.5 0 0 1 .5.5v3.093Zm-1 0h-1.73v-2.593h1.73v2.593ZM8.243 4.572l7.51-.015c.121-.017.26.053.353.146a.5.5 0 0 1 .147.354v11.2a.5.5 0 0 1-.5.5H8.245a.5.5 0 0 1-.5-.5V5.072a.5.5 0 0 1 .5-.5Zm2.486 3.174h2.776a.5.5 0 0 0 0-1H10.73a.5.5 0 0 0 0 1Zm2.68 2.659h-2.775a.5.5 0 0 1 0-1h2.776a.5.5 0 0 1 0 1Z",
    fill: "currentColor"
  }));
};

var SvgPay104X104 = function SvgPay104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pay",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m42.696 47.801.008.001c4.81-.004 8.3-3.162 8.3-7.514 0-3.71-2.87-6.247-8.532-7.54-8.337-1.9-10.087-6.206-10.087-9.483 0-5.197 3.86-9.045 9.311-9.465V9.497c0-.55.447-.997 1-.997.553 0 1 .447 1 .997v4.312a10.28 10.28 0 0 1 9.167 8.517 1 1 0 0 1-1.972.334 8.291 8.291 0 0 0-8.198-6.907c-4.813 0-8.308 3.16-8.308 7.512 0 3.712 2.871 6.248 8.532 7.54 8.337 1.902 10.087 6.207 10.087 9.483 0 5.197-3.859 9.045-9.308 9.467v4.302c0 .55-.447.997-1 .997-.553 0-1-.447-1-.997v-4.31c-5.218-.503-9.31-4.898-9.31-10.23a.999.999 0 0 1 2 0c0 4.567 3.723 8.282 8.302 8.285h.008zm54.259 42.314c2.782 0 5.045-2.256 5.045-5.03V59.844c0-2.775-2.263-5.03-5.045-5.03h-4.91c-2.782 0-5.045 2.255-5.045 5.03v25.24c0 2.775 2.263 5.03 5.045 5.03h4.91zM85 83.795V59.843c0-.56.073-1.103.198-1.627-11.282.143-15.158 2.707-18.887 5.198-3.653 2.44-7.43 4.961-17.541 4.961h-6.8c-3.199 0-5.8 2.594-5.8 5.783 0 3.19 2.601 5.785 5.8 5.785h17a.998.998 0 1 1 0 1.995h-17c-4.052 0-7.389-3.098-7.763-7.043-2.866-.91-5.826-1.9-8.702-2.866l-.038-.013C15.7 68.734 4.646 65.02 2.298 66.697c-.154.111-.298.271-.298.682C2 71.99 13.595 79.54 21.828 83.43a764.517 764.517 0 0 1 6.541 3.106c9.387 4.494 14.558 6.97 20.231 6.97 7.712 0 19.932-4.24 28.024-7.047l.011-.004c4.18-1.45 6.813-2.35 8.365-2.66zm7.045-30.976h4.91c3.885 0 7.045 3.151 7.045 7.025v25.24c0 3.874-3.16 7.025-7.045 7.025h-4.91c-3.634 0-6.634-2.757-7.006-6.284-1.613.386-4.61 1.426-7.746 2.514h-.001C68.582 91.362 56.653 95.5 48.6 95.5c-6.128 0-11.445-2.545-21.096-7.166a811.782 811.782 0 0 0-6.528-3.1C20.763 85.134 0 75.235 0 67.38c0-.976.392-1.771 1.132-2.3 3.026-2.17 11.476.512 25.012 5.061 2.696.906 5.458 1.827 8.149 2.687.637-3.655 3.832-6.445 7.677-6.445h6.8c9.503 0 12.867-2.246 16.428-4.625 4.07-2.716 8.282-5.523 20.828-5.546a7.045 7.045 0 0 1 6.019-3.392z",
    clipRule: "evenodd"
  }));
};

var SvgPay16X16 = function SvgPay16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pay",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.632 7.08c.42 0 .869-.236.869-.752 0-.135 0-.543-.98-.766-1.53-.35-1.758-1.239-1.758-1.739 0-.832.564-1.488 1.369-1.684v-.34a.5.5 0 0 1 1 0v.35a1.856 1.856 0 0 1 1.344 1.477.5.5 0 0 1-.987.167.869.869 0 0 0-.857-.723c-.42 0-.87.237-.87.753 0 .135 0 .543.98.766 1.53.35 1.759 1.24 1.759 1.739 0 .833-.564 1.488-1.37 1.684v.34a.5.5 0 0 1-1 0v-.35a1.861 1.861 0 0 1-1.368-1.788.499.499 0 0 1 1 0 .87.87 0 0 0 .868.867zm7.979 6.224a.39.39 0 0 0 .389-.388V9.204a.389.389 0 0 0-.389-.388h-.722a.389.389 0 0 0-.389.388v3.712a.39.39 0 0 0 .389.388h.722zm-7.111.499c1.075 0 2.84-.613 4.007-1.018.439-.152.756-.26.993-.33V9.327c-1.254.066-1.717.372-2.198.694H10.3c-.58.387-1.182.789-2.775.789h-1a.5.5 0 0 0-.5.498.5.5 0 0 0 .5.499h2.5a.498.498 0 1 1 0 .997h-2.5a1.498 1.498 0 0 1-1.445-1.117c-.362-.117-.727-.237-1.093-.36-.95-.319-2.322-.78-2.91-.824.288.44 1.357 1.246 2.637 1.85l.964.458.01.005c1.327.635 2.06.986 2.812.986zm6.389-5.985h.722c.766 0 1.389.622 1.389 1.386v3.712c0 .764-.623 1.385-1.389 1.385h-.722a1.39 1.39 0 0 1-1.276-.838 107.481 107.481 0 0 0-.777.264h-.003c-1.305.454-3.09 1.073-4.333 1.073-.981 0-1.837-.41-3.255-1.09l-.957-.454C2.737 12.996 0 11.637 0 10.312c0-.258.111-.48.313-.624.587-.422 1.773-.05 3.994.695.184.062.369.122.553.182l.316.104a1.496 1.496 0 0 1 1.349-.856h1c1.29 0 1.721-.287 2.22-.62.592-.396 1.272-.838 3.081-.87a1.38 1.38 0 0 1 1.063-.505z",
    clipRule: "evenodd"
  }));
};

var SvgPay24X24 = function SvgPay24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pay",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.902 10.778h.002c.94-.001 1.597-.587 1.597-1.423 0-.258 0-1.045-1.71-1.436-2.057-.47-2.489-1.57-2.489-2.41 0-1.22.874-2.172 2.1-2.377v-.733a.5.5 0 0 1 1 0v.74a2.592 2.592 0 0 1 2.064 2.112.5.5 0 0 1-.41.576.504.504 0 0 1-.577-.408 1.597 1.597 0 0 0-1.578-1.332c-.94 0-1.599.585-1.599 1.422 0 .259 0 1.045 1.71 1.437 2.057.47 2.49 1.57 2.49 2.41 0 1.22-.874 2.171-2.1 2.377v.731a.5.5 0 1 1-1 0v-.737a2.601 2.601 0 0 1-2.1-2.547.5.5 0 0 1 1 0A1.6 1.6 0 0 0 9.9 10.778h.002Zm12.235 9.558a.864.864 0 0 0 .863-.862V13.77a.864.864 0 0 0-.863-.86h-1.108a.863.863 0 0 0-.862.86v5.703c0 .475.387.862.862.862h1.108Zm-4.672-.813c.792-.274 1.329-.459 1.702-.557v-5.195c0-.014.002-.029.004-.043a.393.393 0 0 0 .004-.037c-2.205.071-2.989.577-3.795 1.115l-.001.001c-.858.573-1.745 1.166-4.108 1.166H9.738c-.569 0-1.033.464-1.033 1.033 0 .57.464 1.032 1.033 1.032h3.833a.5.5 0 1 1 0 .999H9.738a2.033 2.033 0 0 1-1.995-1.657c-.596-.192-1.202-.392-1.804-.595-1.797-.605-4.515-1.52-4.989-1.24.05.716 2.323 2.341 4.363 3.307.541.253 1.03.488 1.479.703 2.079.997 3.225 1.546 4.441 1.546 1.694 0 4.425-.95 6.232-1.578Zm3.564-7.612h1.108c1.027 0 1.863.834 1.863 1.86v5.703a1.865 1.865 0 0 1-1.863 1.86h-1.108c-.85 0-1.569-.572-1.791-1.35-.368.11-.895.293-1.388.464l-.056.02c-1.982.689-4.698 1.632-6.561 1.632-1.444 0-2.735-.619-4.874-1.644l-.076-.037c-.425-.204-.887-.425-1.395-.664C4.686 19.66 0 17.42 0 15.474c0-.308.131-.572.369-.743.792-.568 2.659.018 5.89 1.107.522.176 1.044.347 1.563.516a2.03 2.03 0 0 1 1.916-1.38h1.533c2.06 0 2.75-.462 3.55-.997h.002c.892-.596 1.91-1.266 4.703-1.295a1.856 1.856 0 0 1 1.503-.77Z",
    fill: "currentColor"
  }));
};

var SvgPayment104X104 = function SvgPayment104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -payment",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.459 63.73A34.655 34.655 0 0 0 31 69.498v10.901c0 3.922 3.137 7.101 7.007 7.101h58.986c3.87 0 7.007-3.179 7.007-7.1V44.6c0-3.921-3.137-7.1-7.007-7.1H72.92a.999.999 0 0 0-.206-.307l-14.71-14.957C53.79 17.999 48.422 16.5 38.192 16.5c-8.184 0-19.24.051-31.245.129C3.096 16.653 0 19.797 0 23.672v29.773c0 2.89 1.713 5.513 4.343 6.512 1.771.672 4.095 1.884 7.116 3.773Zm1.073-1.683A32.698 32.698 0 0 0 31 67.498V56.759c-4.075-.746-8.292-2.685-12.37-6.234a35.453 35.453 0 0 1-4.41-4.636 1.003 1.003 0 0 1 .153-1.405.992.992 0 0 1 1.399.154 33.457 33.457 0 0 0 4.162 4.377c6.352 5.528 12.998 6.826 18.75 5.774a10.29 10.29 0 0 0 1.209-.28.992.992 0 0 1 1.01.243L55.445 69.36c2.903 2.857 7.547 2.857 10.435.014 2.844-2.915 2.844-7.58.005-10.49l-26.39-26.679a1.003 1.003 0 0 1 .005-1.413.992.992 0 0 1 1.407.004l6.633 6.705h22.678L56.593 23.646c-3.762-3.782-8.649-5.146-18.402-5.146-8.179 0-19.231.05-31.232.129-2.755.017-4.97 2.266-4.97 5.043v29.773c0 2.077 1.22 3.944 3.056 4.642 1.907.723 4.342 1.992 7.487 3.96Zm37-22.53 14.958 15.12h37.521V44.601c0-2.809-2.246-5.085-5.017-5.085H49.532Zm16.953 17.136.816.825c3.602 3.692 3.602 9.602-.015 13.308a9.426 9.426 0 0 1-13.242-.007l-14.14-14.204c-.24.058-.53.12-.864.181-1.94.355-3.97.466-6.05.276v23.367c0 2.808 2.246 5.085 5.017 5.085h58.986c2.772 0 5.018-2.276 5.018-5.085V56.653H66.485Z",
    fill: "currentColor"
  }));
};

var SvgPayment16X16 = function SvgPayment16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -payment",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 9.098v3.013c0 .215.174.389.389.389h8.722a.389.389 0 0 0 .389-.389V9h-4.198c.32.65.213 1.457-.327 2.007-.68.667-1.77.667-2.454-.003L6.065 9.047a3.69 3.69 0 0 1-.565.05Zm-1-.127v1.015a4.497 4.497 0 0 1-2.1-.728c-.49-.306-.87-.503-1.176-.619A.37.37 0 0 1 1 8.287V3.908c0-.215.172-.388.384-.389C3.406 3.507 4.816 3.5 6 3.5c1.358 0 1.995.177 2.471.654L9.803 5.5H7.452l-.872-.877a.5.5 0 1 0-.71.704l3.9 3.925a.748.748 0 0 1-.002 1.048.749.749 0 0 1-1.043-.007L6.579 8.146a.5.5 0 0 0-.509-.122 2.654 2.654 0 0 1-.893.058.499.499 0 0 0-.21-.03c-.491-.094-1.003-.33-1.506-.767a4.581 4.581 0 0 1-.571-.598.5.5 0 1 0-.78.626c.22.275.453.517.696.728.555.48 1.13.777 1.694.93ZM8.445 6.5 9.935 8H15V6.889a.389.389 0 0 0-.389-.389H8.445Zm-6.584 3.6a5.478 5.478 0 0 0 2.639.889v1.122c0 .767.622 1.389 1.389 1.389h8.722c.767 0 1.389-.622 1.389-1.389V6.889c0-.767-.622-1.389-1.389-1.389h-3.402L9.18 3.448C8.476 2.744 7.597 2.5 6 2.5c-1.187 0-2.598.007-4.622.019A1.387 1.387 0 0 0 0 3.908v4.379c0 .569.34 1.088.87 1.288.239.09.563.258.99.524Z",
    fill: "currentColor"
  }));
};

var SvgPayment24X24 = function SvgPayment24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -payment",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.727 14.932a8.265 8.265 0 0 0 4.173 1.31v1.933C6.9 19.183 7.733 20 8.762 20h13.374c1.03 0 1.863-.817 1.863-1.825v-7.844c0-1.008-.833-1.825-1.863-1.825h-5.328L13.62 5.347C12.6 4.35 11.318 4 8.933 4c-1.84 0-4.22.01-7.086.028C.823 4.035 0 4.85 0 5.853v6.578c0 .748.456 1.43 1.162 1.69.384.143.895.402 1.565.81Zm.54-.825A7.269 7.269 0 0 0 6.9 15.261v-2.007c-.893-.202-1.808-.642-2.693-1.393a8.2 8.2 0 0 1-1.03-1.056.483.483 0 0 1 .076-.689.507.507 0 0 1 .703.075c.29.355.593.664.907.93.823.7 1.666 1.077 2.474 1.22a.515.515 0 0 1 .268.039c.443.05.873.031 1.28-.042a2.14 2.14 0 0 0 .239-.053.507.507 0 0 1 .508.12l3.293 3.226c.551.529 1.432.529 1.976.007.54-.54.54-1.403.003-1.941l-5.98-5.895a.483.483 0 0 1 .002-.693.507.507 0 0 1 .707.002l1.415 1.395h4.354L12.91 6.038c-.79-.775-1.832-1.058-3.977-1.058-1.837 0-4.216.01-7.08.028A.851.851 0 0 0 1 5.853v6.578c0 .35.208.66.515.774.453.168 1.02.456 1.751.902Zm8.775-4.621 2.815 2.775H23v-1.93a.854.854 0 0 0-.863-.845H12.042Zm3.778 3.755a2.335 2.335 0 0 1-.212 3.09 2.454 2.454 0 0 1-3.386-.004l-3.099-3.035a5.481 5.481 0 0 1-1.223.093v4.79c0 .467.386.845.862.845h13.374a.854.854 0 0 0 .863-.845v-4.934h-7.18Z",
    fill: "currentColor"
  }));
};

var SvgPaymentCheckbook104X104 = function SvgPaymentCheckbook104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -payment-checkbook",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 69.498a34.655 34.655 0 0 1-19.541-5.768c-3.021-1.89-5.345-3.1-7.116-3.773C1.713 58.958 0 56.336 0 53.445V23.672c0-3.875 3.096-7.018 6.946-7.043 12.005-.078 23.06-.129 31.245-.129 10.23 0 15.598 1.499 19.813 5.736l14.709 14.957c.09.091.158.196.206.307h24.075c3.869 0 7.006 3.179 7.006 7.1v35.8c0 3.921-3.137 7.1-7.007 7.1H38.008c-3.87 0-7.007-3.18-7.007-7.1V69.497Zm0-2a32.698 32.698 0 0 1-18.468-5.451c-3.145-1.968-5.58-3.237-7.487-3.96-1.837-.698-3.056-2.565-3.056-4.642V23.672c0-2.777 2.215-5.026 4.97-5.043 12-.078 23.053-.13 31.232-.13 9.753 0 14.64 1.365 18.402 5.147L70.217 37.5H47.54l-6.633-6.705a.992.992 0 0 0-1.407-.005 1.003 1.003 0 0 0-.005 1.414l26.39 26.678c2.839 2.91 2.839 7.576-.005 10.49-2.888 2.844-7.532 2.844-10.435-.013l-14.54-14.607a.992.992 0 0 0-1.011-.244c-.2.065-.611.172-1.21.281-5.751 1.052-12.397-.246-18.749-5.774a33.457 33.457 0 0 1-4.162-4.377.992.992 0 0 0-1.4-.154 1.003 1.003 0 0 0-.153 1.405 35.453 35.453 0 0 0 4.412 4.636c4.077 3.549 8.294 5.488 12.369 6.234v10.739ZM61.387 51.5 49.533 39.516h47.46c2.772 0 5.018 2.276 5.018 5.085v35.798c0 2.808-2.246 5.085-5.017 5.085H38.006c-2.771 0-5.018-2.277-5.018-5.085V57.032c2.081.19 4.111.079 6.051-.276.334-.061.623-.123.864-.18l14.14 14.203a9.426 9.426 0 0 0 13.242.007c3.617-3.706 3.617-9.616.015-13.308L63.365 53.5H70a1 1 0 1 0 0-2h-8.613ZM84 77.5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H85a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  }));
};

var SvgPaymentCheckbook16X16 = function SvgPaymentCheckbook16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -payment-checkbook",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 9.098v3.013c0 .215.174.389.389.389h8.722a.389.389 0 0 0 .389-.389V6.889a.389.389 0 0 0-.389-.389H8.445L9.94 8.004A.504.504 0 0 1 10 8h2.5a.5.5 0 0 1 0 1h-1.698c.32.65.213 1.457-.327 2.007-.68.667-1.77.667-2.454-.003L6.065 9.047a3.69 3.69 0 0 1-.565.05Zm-1-.127v1.015a4.497 4.497 0 0 1-2.1-.728c-.49-.306-.87-.503-1.176-.619A.37.37 0 0 1 1 8.287V3.908c0-.215.172-.388.384-.389C3.406 3.507 4.816 3.5 6 3.5c1.358 0 1.995.177 2.471.654L9.803 5.5H7.452l-.872-.877a.5.5 0 1 0-.71.704l3.9 3.925a.748.748 0 0 1-.002 1.048.749.749 0 0 1-1.043-.007L6.579 8.146a.5.5 0 0 0-.509-.122 2.654 2.654 0 0 1-.893.058.499.499 0 0 0-.21-.03c-.491-.094-1.003-.33-1.506-.767a4.581 4.581 0 0 1-.571-.598.5.5 0 1 0-.78.626c.22.275.453.517.696.728.555.48 1.13.777 1.694.93Zm-2.64 1.128a5.478 5.478 0 0 0 2.64.89v1.122c0 .767.622 1.389 1.389 1.389h8.722c.767 0 1.389-.622 1.389-1.389V6.889c0-.767-.622-1.389-1.389-1.389h-3.402L9.18 3.448C8.476 2.744 7.597 2.5 6 2.5c-1.187 0-2.598.007-4.622.019A1.387 1.387 0 0 0 0 3.908v4.379c0 .569.34 1.088.87 1.288.239.09.563.258.99.524ZM13 10a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z",
    fill: "currentColor"
  }));
};

var SvgPaymentCheckbook24X24 = function SvgPaymentCheckbook24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -payment-checkbook",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.266 14.107A7.269 7.269 0 0 0 6.9 15.261v-2.007c-.893-.202-1.808-.642-2.693-1.393a8.2 8.2 0 0 1-1.03-1.056.483.483 0 0 1 .076-.689.507.507 0 0 1 .703.075c.29.355.593.664.907.93.823.7 1.666 1.077 2.474 1.22a.515.515 0 0 1 .268.039c.443.05.873.031 1.28-.042a2.14 2.14 0 0 0 .239-.053.507.507 0 0 1 .508.12l3.293 3.226c.551.529 1.432.529 1.976.007.54-.54.54-1.403.003-1.941l-5.98-5.895a.483.483 0 0 1 .002-.693.507.507 0 0 1 .707.002l1.415 1.395h4.354L12.91 6.038c-.79-.775-1.832-1.058-3.977-1.058-1.837 0-4.216.01-7.08.028A.851.851 0 0 0 1 5.853v6.578c0 .35.208.66.515.774.453.168 1.02.456 1.751.902Zm8.776-4.621 2.403 2.369a.495.495 0 0 1 .046-.002h2.118a.49.49 0 1 1 0 .981h-1.17l.177.175a2.335 2.335 0 0 1-.008 3.322 2.454 2.454 0 0 1-3.386-.004l-3.099-3.035a5.481 5.481 0 0 1-1.223.093v4.79c0 .467.386.845.862.845h13.374a.854.854 0 0 0 .863-.845V10.331a.854.854 0 0 0-.863-.845H12.042Zm-9.315 5.446a8.265 8.265 0 0 0 4.173 1.31v1.933C6.9 19.183 7.733 20 8.762 20h13.374c1.03 0 1.863-.817 1.863-1.825v-7.844c0-1.008-.833-1.825-1.863-1.825h-5.328L13.62 5.347C12.6 4.35 11.318 4 8.933 4c-1.84 0-4.22.01-7.086.028C.823 4.035 0 4.85 0 5.853v6.578c0 .748.456 1.43 1.162 1.69.384.143.895.402 1.565.81ZM18 16.76c0-.271.22-.491.49-.491h2.52a.49.49 0 0 1 0 .982h-2.52a.49.49 0 0 1-.49-.491Z",
    fill: "currentColor"
  }));
};

var SvgPeople104X104 = function SvgPeople104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -people",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.88 39.13c5.013-.062 9.026-4.171 8.964-9.178-.063-5.005-4.177-9.013-9.19-8.951-5.012.063-9.024 4.171-8.96 9.177.061 5.006 4.174 9.013 9.187 8.952zm-7.187-8.977c-.049-3.903 3.079-7.106 6.987-7.155 3.907-.048 7.115 3.077 7.164 6.98a7.072 7.072 0 0 1-6.988 7.154c-3.908.048-7.115-3.076-7.163-6.979zm63.66.025c.061 5.006 4.175 9.013 9.188 8.952 5.012-.062 9.025-4.171 8.962-9.178-.063-5.005-4.176-9.013-9.188-8.951-5.013.063-9.024 4.171-8.962 9.177zm2-.025c-.049-3.903 3.079-7.106 6.987-7.155 3.907-.048 7.114 3.077 7.163 6.98.05 3.902-3.08 7.106-6.987 7.154-3.908.048-7.115-3.076-7.163-6.978zM63.578 40.198c.078 6.252-4.932 11.383-11.191 11.46-6.26.079-11.396-4.926-11.474-11.178-.077-6.251 4.933-11.382 11.192-11.46 6.259-.078 11.396 4.927 11.473 11.178zm-2 .025c-.064-5.148-4.294-9.27-9.448-9.205-5.154.064-9.28 4.29-9.218 9.437.065 5.149 4.295 9.27 9.45 9.206 5.155-.064 9.28-4.29 9.217-9.438zM52.486 59.49c-12.288.154-22.125 10.227-21.973 22.5a1 1 0 0 1-2 .024c-.093-7.555 3.287-14.346 8.66-18.855a1 1 0 0 1-.83-.972c-.119-9.471-7.902-17.054-17.385-16.936C9.475 45.368 1.884 53.142 2 62.613a1 1 0 0 1-2 .025c-.13-10.575 8.345-19.253 18.931-19.385 10.588-.132 19.277 8.334 19.41 18.908 0 .026-.001.051-.003.076a24.163 24.163 0 0 1 14.12-4.745 24.162 24.162 0 0 1 13.237 3.728c.602-9.922 8.786-17.841 18.896-17.967C95.18 43.121 103.87 51.587 104 62.161a1 1 0 0 1-1.999.025c-.119-9.471-7.902-17.053-17.384-16.935-9.478.117-17.067 7.884-16.956 17.35 5.61 4.368 9.254 11.152 9.349 18.81a1 1 0 0 1-2 .024c-.152-12.272-10.237-22.098-22.525-21.946z",
    clipRule: "evenodd"
  }));
};

var SvgPeople16X16 = function SvgPeople16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -people",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.332 6.306a1.684 1.684 0 0 1-1.25-1.604A1.685 1.685 0 0 1 12.747 3a1.682 1.682 0 0 1 .5 3.294c1.537.22 2.732 1.63 2.752 3.353.004.298-.217.543-.493.547-.276.003-.503-.235-.506-.533-.016-1.296-1-2.333-2.2-2.316-1.2.015-2.16 1.078-2.145 2.373a.574.574 0 0 1-.048.24c.746.63 1.216 1.52 1.23 2.512.004.247-.217.45-.493.454-.277.003-.503-.195-.507-.443-.02-1.446-1.343-2.602-2.955-2.584C6.27 9.915 4.98 11.1 5 12.547c.004.247-.217.45-.493.453-.276.003-.503-.195-.507-.443-.015-1.086.52-2.063 1.375-2.717a.577.577 0 0 1-.03-.18c-.015-1.295-1-2.332-2.2-2.315C1.945 7.36.985 8.423 1 9.718c.004.298-.217.543-.493.547-.276.004-.503-.235-.507-.533-.02-1.724 1.144-3.166 2.677-3.426a1.683 1.683 0 0 1-1.25-1.603A1.684 1.684 0 0 1 3.092 3 1.686 1.686 0 0 1 4.8 4.66c.01.77-.502 1.426-1.208 1.634C5.025 6.5 6.162 7.74 6.324 9.303A4.295 4.295 0 0 1 7.87 9a4.28 4.28 0 0 1 1.8.37c.133-1.56 1.238-2.823 2.663-3.064zm.428-2.31a.685.685 0 1 1 .017 1.37.687.687 0 0 1-.696-.676.687.687 0 0 1 .68-.693zM10 6.976a2 2 0 1 1-4 .05 2 2 0 0 1 4-.05zm-.99.013a1.01 1.01 0 1 0-2.02.025 1.01 1.01 0 0 0 2.02-.025zM2.426 4.69a.688.688 0 0 1 1.375-.016.687.687 0 0 1-1.375.016z",
    clipRule: "evenodd"
  }));
};

var SvgPeople24X24 = function SvgPeople24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -people",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.03a2.5 2.5 0 1 0 5-.06 2.5 2.5 0 0 0-5 .06Zm1.076-.013a1.423 1.423 0 1 1 2.846-.034 1.423 1.423 0 0 1-2.846.034ZM17 7.031a2.5 2.5 0 1 0 5-.061 2.5 2.5 0 0 0-5 .06Zm1.076-.014a1.423 1.423 0 1 1 2.846-.034 1.423 1.423 0 0 1-2.846.034ZM15 9.462a3 3 0 1 1-6.001.074 3 3 0 0 1 6-.074ZM11.976 7.56a1.94 1.94 0 1 0 .047 3.878 1.94 1.94 0 0 0-.047-3.878Zm-.037 6.891c-2.737.032-4.927 2.076-4.894 4.568.004.262-.227.478-.516.481-.288.003-.525-.207-.529-.47-.021-1.65.763-3.139 2.02-4.155-.048-1.908-1.634-3.427-3.564-3.403-1.944.023-3.5 1.607-3.477 3.536a.487.487 0 0 1-.483.492.488.488 0 0 1-.496-.48c-.03-2.466 1.959-4.49 4.444-4.52 2.264-.027 4.157 1.607 4.5 3.761a6.425 6.425 0 0 1 2.982-.76 6.427 6.427 0 0 1 3.13.76 4.49 4.49 0 0 1 4.388-3.76c2.486-.031 4.525 1.943 4.556 4.408a.487.487 0 0 1-.483.492.488.488 0 0 1-.496-.48c-.024-1.93-1.62-3.473-3.565-3.45-1.9.024-3.428 1.535-3.476 3.403 1.22.986 1.998 2.418 2.02 4.02.003.264-.227.48-.516.482-.288.004-.525-.207-.529-.47-.034-2.491-2.28-4.485-5.015-4.454Z",
    fill: "currentColor"
  }));
};

var SvgPercent104X104 = function SvgPercent104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -percent",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52 0c28.72 0 52 23.28 52 52s-23.28 52-52 52S0 80.72 0 52 23.28 0 52 0zm0 2C24.385 2 2 24.385 2 52s22.385 50 50 50 50-22.385 50-50S79.615 2 52 2zM33.3 27.2a9.5 9.5 0 1 1-.001 18.999 9.5 9.5 0 0 1 0-18.999zm0 2a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm37.4 28.6a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm0 2a7.5 7.5 0 1 0 .001 15 7.5 7.5 0 0 0 0-15zm4.393-32.307-47.6 47.6a1 1 0 0 0 1.414 1.414l47.6-47.6a1 1 0 0 0-1.414-1.414z",
    clipRule: "evenodd"
  }));
};

var SvgPercent16X16 = function SvgPercent16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -percent",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zm0 1a7 7 0 0 0-7 7 7 7 0 1 0 7-7zM5.25 4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5zm0 1a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm5.5 3.5a1.75 1.75 0 1 1-.001 3.501A1.75 1.75 0 0 1 10.75 8.5zm0 1a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm.396-5.354-7 7a.5.5 0 0 0 .708.708l7-7a.5.5 0 0 0-.708-.708z",
    clipRule: "evenodd"
  }));
};

var SvgPercent24X24 = function SvgPercent24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -percent",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9ZM8.517 7.067a2.083 2.083 0 1 1 0 4.168 2.083 2.083 0 0 1 0-4.168Zm0 1a1.083 1.083 0 1 0-.001 2.165 1.083 1.083 0 0 0 0-2.165Zm6.966 4.7a2.083 2.083 0 1 1 0 4.166 2.083 2.083 0 0 1 0-4.166Zm0 1a1.083 1.083 0 1 0 0 2.165 1.083 1.083 0 0 0 0-2.165Zm.597-6.554L7.213 16.08a.5.5 0 0 0 .707.707l8.867-8.866a.5.5 0 1 0-.707-.707Z",
    fill: "currentColor"
  }));
};

var SvgPhone104X104 = function SvgPhone104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -phone",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.31 65.075 5.61 76.643l-.022.015c-3.359 2.326-6.03 6.117-5.525 9.477.371 2.475 2.883 6.906 6.277 10.337C11.008 101.191 16.976 104 24.028 104c14.63 0 33.222-10.849 51.086-28.705C93.114 57.302 104 38.77 104 24.058c0-7.183-2.625-13.152-7.097-17.673C93.479 2.923 89.067.546 85.95.1c-3.507-.501-5.905.877-8.044 3.724a26.742 26.742 0 0 0-.849 1.2l-.425.622-11.582 17.706c-2.622 4.137-1.528 9.602 2.42 12.364l.166.136c.35.286 1.15.94 1.425 1.172 3.011 2.538 4.28 4.588 4.044 7.622-.326 4.193-3.805 9.813-11.32 17.325-7.478 7.475-13.053 10.927-17.198 11.24-2.994.225-5.006-1.038-7.53-4.057-.144-.172-.463-.562-.752-.916-.269-.33-.512-.627-.566-.69-2.812-4.01-8.279-5.103-12.43-2.474ZM7.763 95.067c-3.116-3.15-5.419-7.213-5.721-9.229-.361-2.403 1.882-5.591 4.675-7.529l17.677-11.553c3.236-2.05 7.51-1.195 9.758 2.004l.404.495c.338.415.784.962.968 1.182 2.896 3.465 5.428 5.053 9.215 4.768 4.733-.357 10.676-4.037 18.462-11.82 7.822-7.818 11.529-13.806 11.9-18.584.297-3.82-1.295-6.393-4.749-9.304a173.002 173.002 0 0 0-1.668-1.368c-3.137-2.198-3.992-6.471-1.95-9.694l11.56-17.672.435-.637.15-.22c.237-.346.431-.62.628-.88C81.25 2.704 83 1.698 85.668 2.08c2.663.38 6.683 2.546 9.813 5.71C99.594 11.948 102 17.42 102 24.057c0 14.057-10.64 32.17-28.3 49.823-17.524 17.517-35.695 28.12-49.672 28.12-6.482 0-11.954-2.576-16.266-6.934Z",
    fill: "currentColor"
  }));
};

var SvgPhone16X16 = function SvgPhone16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.59 9.627.985 11.33l-.011.008c-.594.41-1.06 1.073-.962 1.736.19 1.268 1.832 2.928 3.874 2.928 2.267 0 5.075-1.64 7.762-4.326C14.356 8.97 16 6.17 16 3.891 16 1.786 14.451.22 13.044.019c-.665-.095-1.13.173-1.516.684-.057.076-.306.437-.201.287L9.622 3.598c-.487.767-.284 1.781.429 2.28l.026.022.205.168c.801.675.752 1.306-1.092 3.15-1.833 1.832-2.447 1.878-3.115 1.08a13.382 13.382 0 0 1-.076-.092c-.048-.06-.1-.122-.1-.121a1.703 1.703 0 0 0-2.31-.458zm-2.587 3.298c-.028-.185.226-.546.536-.763l2.592-1.694c.316-.2.733-.116.973.223l.054.066.15.182c1.084 1.297 2.375 1.2 4.59-1.015 2.224-2.224 2.325-3.528 1.028-4.62a16.86 16.86 0 0 0-.27-.22.7.7 0 0 1-.193-.945l1.693-2.59c-.093.134.13-.189.171-.244.187-.249.33-.331.575-.296C13.842 1.143 15 2.314 15 3.89c0 1.952-1.521 4.541-4.058 7.077-2.518 2.517-5.115 4.033-7.055 4.033-1.51 0-2.763-1.267-2.884-2.076z",
    clipRule: "evenodd"
  }));
};

var SvgPhone24X24 = function SvgPhone24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -phone",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.484 14.174 3.187 16.33l-.01.008c-.715.494-1.279 1.294-1.161 2.07.231 1.545 2.258 3.595 4.774 3.595 2.827 0 6.358-2.06 9.738-5.44C19.933 13.159 22 9.64 22 6.797c0-2.596-1.91-4.528-3.631-4.774-.785-.112-1.333.203-1.794.816a5.325 5.325 0 0 0-.134.188l-.026.038-.09.13-2.158 3.302c-.58.912-.338 2.118.515 2.714l.036.029c.068.055.21.172.258.213 1.08.91 1.011 1.8-1.376 4.185-2.373 2.373-3.241 2.438-4.144 1.358l-.104-.127a7.46 7.46 0 0 0-.124-.15 2.023 2.023 0 0 0-2.744-.544Zm-2.501 5.63c-.537-.544-.933-1.242-.979-1.546-.045-.297.306-.795.736-1.095l3.286-2.148c.46-.292 1.07-.17 1.407.308l.07.086.186.227c1.32 1.579 2.863 1.463 5.618-1.291 2.768-2.767 2.89-4.33 1.314-5.658-.07-.059-.293-.24-.333-.272a1.019 1.019 0 0 1-.28-1.377l2.147-3.285.093-.136.017-.025c.042-.061.076-.108.11-.153.262-.35.487-.479.852-.427C19.481 3.192 21 4.728 21 6.796c0 2.516-1.944 5.825-5.18 9.06-3.21 3.209-6.53 5.146-9.03 5.146-1.118 0-2.06-.444-2.807-1.199Z",
    fill: "currentColor"
  }));
};

var SvgPieChart104X104 = function SvgPieChart104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pie-chart",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M57.8 1v44.2a1 1 0 0 0 1 1H103a1 1 0 0 0 1-1C104 20.237 83.763 0 58.8 0a1 1 0 0 0-1 1zm44.188 43.2H59.8V2.011c23.064.524 41.664 19.125 42.188 42.189zM46.2 57.8V14.6a1 1 0 0 0-1-1C20.237 13.6 0 33.837 0 58.8 0 83.763 20.237 104 45.2 104c24.963 0 45.2-20.237 45.2-45.2a1 1 0 0 0-1-1H46.2zm-2-42.189v43.19a1 1 0 0 0 1 1h43.189C87.857 83.196 68.725 102 45.2 102 21.341 102 2 82.659 2 58.8c0-23.524 18.803-42.657 42.2-43.189z",
    clipRule: "evenodd"
  }));
};

var SvgPieChart16X16 = function SvgPieChart16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pie-chart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.5.5V7a.5.5 0 0 0 .5.5h6.5A.5.5 0 0 0 16 7a7 7 0 0 0-7-7 .5.5 0 0 0-.5.5zm6.48 6H9.5V1.02a6.001 6.001 0 0 1 5.48 5.48zm-7.48 2v-6A.5.5 0 0 0 7 2a7 7 0 1 0 7 7 .5.5 0 0 0-.5-.5h-6zm-1 .5a.5.5 0 0 0 .5.5h5.98A6 6 0 1 1 6.5 3.02V9z",
    clipRule: "evenodd"
  }));
};

var SvgPieChart24X24 = function SvgPieChart24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pie-chart",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.766 2.5v8.233a.5.5 0 0 0 .5.5H21.5a.5.5 0 0 0 .5-.5A8.733 8.733 0 0 0 13.266 2a.5.5 0 0 0-.5.5Zm8.217 7.733h-7.217V3.016a7.734 7.734 0 0 1 7.217 7.217Zm-9.75 2.533V5.033a.5.5 0 0 0-.5-.5 8.734 8.734 0 1 0 8.733 8.733.5.5 0 0 0-.5-.5h-7.733Zm-1 .5a.5.5 0 0 0 .5.5h7.717a7.733 7.733 0 1 1-8.217-8.217v7.717Z",
    fill: "currentColor"
  }));
};

var SvgPin104X104 = function SvgPin104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pin",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M44.444.677C28.729 3.496 15.768 15.867 12.12 31.512 7.062 53.216 19.589 74.58 40.358 80.755l9.319 21.707c.877 2.047 3.762 2.05 4.646.007l9.31-21.53C81.053 75.76 93.026 59.65 93 41.349 93.074 15.674 70.103-3.923 44.444.678zM62.636 79.15a.996.996 0 0 0-.64.563l-9.497 21.96a.542.542 0 0 1-.996-.001L42 79.531a.996.996 0 0 0-.642-.566c-20.023-5.707-32.151-26.179-27.3-46.997C17.525 17.099 29.862 5.324 44.794 2.646c24.434-4.38 46.29 14.266 46.217 38.698.027 17.571-11.565 33.014-28.374 37.805zM52 21.005a19.97 19.97 0 0 1 16.039 8.05A19.915 19.915 0 0 1 72 41.005c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20zm0 1.966c-9.96 0-18.034 8.074-18.034 18.034 0 9.96 8.074 18.034 18.034 18.034 9.96 0 18.035-8.074 18.035-18.034 0-3.939-1.265-7.684-3.571-10.774A18.004 18.004 0 0 0 52 22.97z",
    clipRule: "evenodd"
  }));
};

var SvgPin16X16 = function SvgPin16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.805.105c-2.495.438-4.55 2.363-5.128 4.8-.788 3.32 1.12 6.591 4.316 7.613l1.33 3.042c.256.585 1.096.586 1.353.002l1.329-3.018c2.674-.855 4.499-3.32 4.495-6.11.011-3.995-3.63-7.045-7.695-6.33zm.026 11.803a.505.505 0 0 0-.327-.282c-2.817-.789-4.523-3.616-3.84-6.492.486-2.05 2.223-3.676 4.32-4.045 3.44-.606 6.513 1.968 6.503 5.342.004 2.427-1.627 4.56-3.991 5.22a.505.505 0 0 0-.327.282l-1.168 2.653-1.17-2.677zM8 3c1.12 0 2.151.53 2.806 1.409A3.5 3.5 0 1 1 8 3zm0 1.046a2.454 2.454 0 1 0 0 4.908 2.454 2.454 0 0 0 0-4.908z",
    clipRule: "evenodd"
  }));
};

var SvgPin24X24 = function SvgPin24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pin",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.252.155C6.608.81 3.605 3.681 2.759 7.315 1.6 12.31 4.442 17.227 9.18 18.707l2.047 4.778a.84.84 0 0 0 1.546 0l2.045-4.736c3.97-1.241 6.688-4.948 6.682-9.153.017-5.96-5.305-10.51-11.248-9.44ZM10 18.096a.497.497 0 0 0-.32-.283c-4.368-1.246-7.012-5.718-5.954-10.27.755-3.246 3.446-5.819 6.7-6.403a8.533 8.533 0 0 1 10.081 8.454v.002c.007 3.838-2.521 7.212-6.188 8.26a.497.497 0 0 0-.32.281l-1.998 4.631L10 18.096Zm2-13.364c1.544 0 2.966.735 3.87 1.958.618.833.957 1.844.957 2.905 0 2.686-2.161 4.864-4.827 4.864-2.667 0-4.828-2.178-4.828-4.864 0-2.685 2.162-4.863 4.828-4.863Zm0 1c-2.118 0-3.835 1.73-3.835 3.863 0 2.134 1.717 3.864 3.835 3.864s3.834-1.73 3.834-3.864c0-.844-.268-1.645-.759-2.307A3.815 3.815 0 0 0 12 5.732Z",
    fill: "currentColor"
  }));
};

var SvgPinFilled104X104 = function SvgPinFilled104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pin-filled",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52 21.005a19.97 19.97 0 0 1 16.039 8.05A19.915 19.915 0 0 1 72 41.005c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.12 31.512C15.769 15.866 28.73 3.496 44.445.677c25.66-4.6 48.63 14.997 48.555 40.67.027 18.303-11.946 34.412-29.365 39.593l-9.31 21.53c-.885 2.043-3.77 2.04-4.647-.007l-9.319-21.707C19.59 74.58 7.062 53.216 12.121 31.511zm55.919-2.457A19.97 19.97 0 0 0 52 21.005c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20c0-4.366-1.404-8.522-3.961-11.95z",
    clipRule: "evenodd"
  }));
};

var SvgPinFilled16X16 = function SvgPinFilled16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pin-filled",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.677 4.906C2.256 2.468 4.31.543 6.805.105c4.065-.716 7.707 2.334 7.695 6.328.004 2.792-1.821 5.256-4.495 6.111l-1.33 3.018c-.256.584-1.096.583-1.351-.002l-1.33-3.042C2.797 11.496.888 8.225 1.676 4.906zm9.13-.497a3.5 3.5 0 1 0-5.612 4.182 3.5 3.5 0 0 0 5.611-4.182z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 3c1.12 0 2.151.53 2.806 1.409A3.5 3.5 0 1 1 8 3z"
  }));
};

var SvgPinFilled24X24 = function SvgPinFilled24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pin-filled",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76 7.317C3.604 3.683 6.607.812 10.251.157 16.195-.91 21.517 3.638 21.5 9.597c.006 4.206-2.712 7.913-6.682 9.154l-2.044 4.736a.84.84 0 0 1-1.547 0L9.18 18.71c-4.738-1.48-7.582-6.398-6.42-11.392Zm13.25-.803a5 5 0 1 0-8.02 5.974 5 5 0 0 0 8.02-5.974Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.501c1.6 0 3.073.756 4.01 2.013A5 5 0 1 1 12 4.5Z",
    fill: "currentColor"
  }));
};

var SvgPix104X104 = function SvgPix104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pix",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36.363 27.442 52.02 43.101a.9.9 0 0 0 1.268 0l.003-.002 15.598-15.6a17.171 17.171 0 0 1 9.483-4.844L61.758 6.042c-5.39-5.39-14.127-5.39-19.516 0l-16.42 16.42c3.98.382 7.679 2.12 10.541 4.98zm-15.29-3.059L40.828 4.628c6.17-6.17 16.174-6.17 22.344 0L82.985 24.44h-1.88a15.172 15.172 0 0 0-10.803 4.473l-15.598 15.6a2.9 2.9 0 0 1-4.1.002L34.95 28.856a15.182 15.182 0 0 0-10.803-4.473h-3.074zm47.816 52.118L53.287 60.9c-.31-.312-.951-.314-1.268.002L36.363 76.558a17.172 17.172 0 0 1-10.543 4.978l16.422 16.422c5.39 5.389 14.127 5.389 19.516 0L78.37 81.345a17.169 17.169 0 0 1-9.482-4.845zm11.295 3.031c.306.018.613.027.922.027h1.88L63.171 99.372c-6.17 6.17-16.174 6.17-22.344 0L21.072 79.616h3.074c4.08 0 7.918-1.589 10.803-4.473l15.656-15.655c1.095-1.095 3.004-1.099 4.099 0l15.599 15.598a15.17 15.17 0 0 0 9.88 4.446zm19.188-38.704L87.4 28.855a2.278 2.278 0 0 1-.85.172h-5.443c-2.815 0-5.57 1.14-7.558 3.13l-15.6 15.6a7.464 7.464 0 0 1-5.293 2.19 7.468 7.468 0 0 1-5.294-2.189L31.704 32.101a10.759 10.759 0 0 0-7.558-3.131h-6.694a2.27 2.27 0 0 1-.804-.162l-12.02 12.02c-6.17 6.17-6.17 16.173 0 22.344l12.02 12.02c.251-.095.52-.162.804-.162h6.694c2.814 0 5.569-1.142 7.558-3.131L47.36 56.243c2.83-2.828 7.762-2.829 10.589.001l15.599 15.597a10.756 10.756 0 0 0 7.558 3.132h5.443c.302 0 .587.066.85.171l11.973-11.972c6.171-6.17 6.171-16.174 0-22.344zm-1.414 20.93c5.389-5.39 5.389-14.127 0-19.516l-11.22-11.22a4.208 4.208 0 0 1-.189.005h-5.443c-2.284 0-4.53.93-6.143 2.544l-15.6 15.6a9.465 9.465 0 0 1-6.708 2.776 9.468 9.468 0 0 1-6.707-2.774h-.001L30.29 33.515a8.76 8.76 0 0 0-6.144-2.545h-6.694c-.046 0-.09 0-.136-.002L6.043 42.242c-5.39 5.389-5.39 14.126 0 19.516l11.274 11.274.136-.002h6.694a8.76 8.76 0 0 0 6.143-2.545l15.656-15.656c3.61-3.607 9.81-3.611 13.419.002m0 0 15.599 15.597a8.757 8.757 0 0 0 6.143 2.545h5.443c.064 0 .127.002.19.004l11.22-11.22",
    clipRule: "evenodd"
  }));
};

var SvgPix24X24 = function SvgPix24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pix",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.428 6.842a3.934 3.934 0 0 0-1.264-.85l2.395-2.395a2.038 2.038 0 0 1 2.883 0l2.477 2.477a3.94 3.94 0 0 0-1.106.779L12.126 9.54 9.428 6.842Zm7.26.001c.29-.094.596-.143.91-.143h.36l-3.81-3.81a3.038 3.038 0 0 0-4.296 0l-3.8 3.8h.592a2.92 2.92 0 0 1 2.077.86l3.011 3.01c.217.217.57.218.788 0l3-3a2.926 2.926 0 0 1 1.168-.717Zm-1.875 10.304c.326.326.7.588 1.106.779l-2.477 2.477a2.038 2.038 0 0 1-2.883 0l-2.395-2.395a3.936 3.936 0 0 0 1.264-.85l2.698-2.698 2.687 2.687Zm-7.437.073c-.237.06-.482.09-.732.09h-.591l3.799 3.8a3.039 3.039 0 0 0 4.297 0l3.81-3.81h-.361a2.924 2.924 0 0 1-2.077-.86l-3-3a.57.57 0 0 0-.789 0l-3.01 3.01c-.379.379-.842.64-1.346.77Zm10.221-9.638c-.541 0-1.07.22-1.453.602l-3 3a1.435 1.435 0 0 1-1.61.294 1.434 1.434 0 0 1-.426-.294l-3.011-3.01a2.069 2.069 0 0 0-1.454-.603H5.356a.437.437 0 0 1-.154-.031L2.89 9.852a3.038 3.038 0 0 0 0 4.296L5.2 16.46a.436.436 0 0 1 .155-.031h1.287c.542 0 1.071-.22 1.454-.602l3.01-3.011c.123-.123.267-.218.421-.285a1.5 1.5 0 0 1 1.196 0c.154.067.297.162.42.285l3 3c.382.382.912.602 1.453.602h1.047a.44.44 0 0 1 .164.033l2.302-2.303a3.039 3.039 0 0 0 0-4.296l-2.302-2.303a.438.438 0 0 1-.164.033h-1.047Zm-.746 1.31-3 2.999a2.44 2.44 0 0 1-.116.11c.04.034.079.07.117.109l3 2.999c.194.195.47.309.745.309h.83l1.976-1.977a2.038 2.038 0 0 0 0-2.882l-1.977-1.977h-.829a1.07 1.07 0 0 0-.746.31Zm-6.45 3.216c.037-.037.076-.073.116-.108a2.417 2.417 0 0 1-.116-.109L7.39 8.881a1.07 1.07 0 0 0-.747-.31H5.585L3.597 10.56a2.038 2.038 0 0 0 0 2.882l1.987 1.988h1.06c.275 0 .55-.114.746-.31l3.01-3.01Z",
    fill: "currentColor"
  }));
};

var SvgPixFilled104X104 = function SvgPixFilled104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pix-filled",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24.146 24.383c4.08 0 7.918 1.59 10.803 4.473l15.656 15.659a2.9 2.9 0 0 0 4.099-.002l15.598-15.6a15.184 15.184 0 0 1 10.804-4.473h1.879L63.172 4.628c-6.17-6.17-16.174-6.17-22.344 0L21.072 24.383h3.074zm56.96 55.176c-4.08 0-7.918-1.589-10.803-4.473l-15.6-15.598c-1.094-1.099-3.003-1.095-4.098 0L34.95 75.144a15.185 15.185 0 0 1-10.803 4.472h-3.074l19.756 19.756c6.17 6.17 16.174 6.17 22.344 0L82.985 79.56h-1.88zm5.443-50.532c.301 0 .587-.066.85-.172l11.973 11.973c6.171 6.17 6.171 16.173 0 22.344L87.4 75.144a2.28 2.28 0 0 0-.85-.171h-5.444c-2.815 0-5.57-1.141-7.558-3.132l-15.6-15.597c-2.826-2.83-7.759-2.829-10.588-.001L31.704 71.899a10.759 10.759 0 0 1-7.558 3.13h-6.694c-.285 0-.553.068-.804.163l-12.02-12.02c-6.17-6.17-6.17-16.174 0-22.344l12.02-12.02c.252.095.52.162.804.162h6.694c2.815 0 5.569 1.141 7.558 3.131L47.36 47.758a7.468 7.468 0 0 0 5.294 2.19c1.917 0 3.835-.731 5.294-2.191l15.599-15.6a10.758 10.758 0 0 1 7.558-3.13h5.443z",
    clipRule: "evenodd"
  }));
};

var SvgPixFilled24X24 = function SvgPixFilled24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -pix-filled",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.643 6.69a2.92 2.92 0 0 1 2.078.86l3.01 3.01c.217.217.572.218.789 0l3-3a2.92 2.92 0 0 1 2.077-.86h.362l-3.81-3.81a3.038 3.038 0 0 0-4.297 0l-3.8 3.8h.591ZM17.597 17.3a2.92 2.92 0 0 1-2.077-.86l-3-3a.57.57 0 0 0-.788 0L8.72 16.45a2.92 2.92 0 0 1-2.078.86h-.59l3.799 3.8a3.038 3.038 0 0 0 4.296 0l3.81-3.81h-.36Zm1.047-9.718a.438.438 0 0 0 .164-.033l2.302 2.303a3.038 3.038 0 0 1 0 4.296l-2.302 2.303a.437.437 0 0 0-.164-.033h-1.047c-.541 0-1.07-.22-1.453-.602l-3-3c-.544-.544-1.492-.544-2.036 0l-3.011 3.01a2.069 2.069 0 0 1-1.454.603H5.356a.436.436 0 0 0-.155.031L2.89 14.148a3.038 3.038 0 0 1 0-4.296L5.202 7.54c.048.018.1.031.154.031h1.287c.542 0 1.071.22 1.454.602l3.01 3.011c.282.28.65.421 1.019.421.369 0 .737-.14 1.018-.42l3-3a2.069 2.069 0 0 1 1.453-.603h1.047Z",
    fill: "currentColor"
  }));
};

var SvgPlane104X104 = function SvgPlane104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -plane",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M65.73 20.83 25.877.614c-1.813-.738-3.74-.807-5.521-.229l-.152.063-4.929 2.554c-1.414.89-1.816 2.661-.972 4.004a2.9 2.9 0 0 0 .378.479l22.234 26.867-14.575 6.762L8.636 35.49a10 10 0 0 0-1.073-.447 9.014 9.014 0 0 0-1.493-.407c-1.097-.19-2.027-.082-2.715.51L1.06 37.29a1 1 0 0 0-1.057.998v1.177a2.586 2.586 0 0 0 0 .252v57.225c0 3.896 3.153 7.055 7.044 7.055H96.96c3.891 0 7.044-3.159 7.044-7.055V44.338c0-3.896-3.153-7.056-7.044-7.056H75.243l23.189-10.86c4.755-2.156 6.878-7.771 4.738-12.552l-.009-.02c-2.229-4.702-7.816-6.737-12.54-4.567L65.73 20.83zm4.625 16.532a.947.947 0 0 0-.059.028L24.49 58.84c-1.704.853-2.543.774-3.118.199L2.162 39.964a.515.515 0 0 1-.14-.218c-.047-.158-.007-.389.112-.64.032-.068.064-.124.088-.164l2.467-2.307c.097-.082.474-.126 1.04-.028.357.061.751.172 1.159.318.408.147.738.293.92.385l14.177 5.82a1 1 0 0 0 .8-.018l16.148-7.492a1 1 0 0 0 .35-1.544L16.166 6.148a1.37 1.37 0 0 1-.172-.21.875.875 0 0 1 .276-1.202l4.778-2.472a5.958 5.958 0 0 1 4.001.17l40.21 20.4a1 1 0 0 0 .872.015l25.328-11.75c3.722-1.71 8.126-.108 9.89 3.598 1.683 3.775.006 8.204-3.755 9.91L70.355 37.362zm.617 1.92h25.987a5.05 5.05 0 0 1 5.044 5.056v52.604a5.05 5.05 0 0 1-5.044 5.055H7.047a5.05 5.05 0 0 1-5.044-5.055V42.625l17.957 17.83c1.222 1.224 2.994 1.39 5.402.185l45.61-21.358z",
    clipRule: "evenodd"
  }));
};

var SvgPlane16X16 = function SvgPlane16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -plane",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.003 5.479h1.608c.766 0 1.389.624 1.389 1.39v7.736c0 .767-.623 1.39-1.389 1.39H1.389A1.392 1.392 0 0 1 0 14.606V5.98c0-.221.145-.402.342-.47L.6 5.265c.402-.346.965-.12 1.19-.007l1.839.753 1.589-.737-2.987-3.607A.776.776 0 0 1 2.398.499l.764-.397c.416-.143.784-.13 1.117.005l5.746 2.913 3.505-1.626a1.756 1.756 0 0 1 2.317.85c.392.878 0 1.916-.875 2.313l-1.969.922zm-11.824.61c.054.017.128.044.197.078l2.076.85c.129.055.275.05.4-.008l2.375-1.102a.5.5 0 0 0 .174-.772l-3.239-3.91.384-.204a.52.52 0 0 1 .319-.005L9.79 4.022a.501.501 0 0 0 .436.007l3.723-1.727a.752.752 0 0 1 .987.356.756.756 0 0 1-.382.99l-3.991 1.87h-.002l-6.769 3.17a.626.626 0 0 1-.099.042L1.105 6.16l.074-.07zM15 14.606a.39.39 0 0 1-.389.39H1.389a.39.39 0 0 1-.389-.39v-7.14l2.037 2.023a.849.849 0 0 0 .613.254c.163 0 .355-.042.578-.154l6.64-3.11h3.743a.39.39 0 0 1 .389.39v7.737z",
    clipRule: "evenodd"
  }));
};

var SvgPlane24X24 = function SvgPlane24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -plane"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M15.602 9.945 7.178 13.89c-.563.282-1.039.237-1.368-.092L3 11.008v9.364c0 .347.28.628.626.628h16.748c.346 0 .626-.28.626-.628v-9.799a.627.627 0 0 0-.626-.628h-4.772zm2.136-1h2.636c.898 0 1.626.73 1.626 1.628v9.8C22 21.27 21.272 22 20.374 22H3.626A1.627 1.627 0 0 1 2 20.372V9.735a.777.777 0 0 1 0-.096v-.193a.5.5 0 0 1 .368-.482l.366-.342c.216-.185.476-.215.763-.165.11.02.22.05.331.09.105.038.19.076.213.089l2.426.995 2.222-1.032-3.872-4.678a.847.847 0 0 1-.104-.134c-.251-.397-.132-.923.301-1.192l.994-.508c.403-.13.838-.114 1.266.062l7.289 3.696 4.5-2.087a2.083 2.083 0 0 1 2.75 1.002l.005.01a2.086 2.086 0 0 1-1.037 2.75l-3.043 1.425zm2.625-2.333c.541-.246.784-.884.544-1.429a1.082 1.082 0 0 0-1.425-.517l-4.718 2.189a.5.5 0 0 1-.437-.008L6.86 3.058a.839.839 0 0 0-.467-.051l-.725.375 4.205 5.08a.5.5 0 0 1-.174.772L6.69 10.63a.5.5 0 0 1-.4.009L3.627 9.545a1.38 1.38 0 0 0-.3-.103c-.023-.003-.006-.005.074-.075l-.331.301 3.446 3.422c.005.005.015.006.226-.1l13.62-6.378z"
  }));
};

var SvgPlay104X104 = function SvgPlay104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -play",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52 0c28.72 0 52 23.28 52 52s-23.28 52-52 52S0 80.72 0 52 23.28 0 52 0zm0 2C24.385 2 2 24.385 2 52s22.385 50 50 50 50-22.385 50-50S79.615 2 52 2zM35.889 32.705v38.59c0 1.96 2.143 3.163 3.817 2.144l31.703-19.294c1.607-.978 1.607-3.311 0-4.29L39.706 30.561c-1.674-1.019-3.817.185-3.817 2.144zm2 0a.51.51 0 0 1 .777-.436l31.703 19.294c.327.2.327.675 0 .874L38.665 71.731a.51.51 0 0 1-.777-.436v-38.59z",
    clipRule: "evenodd"
  }));
};

var SvgPlay16X16 = function SvgPlay16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -play",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8zm0 1C4.134 1 1 4.133 1 8s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM5.278 5.162v5.676c0 .564.615.908 1.096.617l4.664-2.839a.722.722 0 0 0-.001-1.234L6.376 4.546a.722.722 0 0 0-1.098.616zm1 .495L10.128 8l-3.85 2.343V5.657z",
    clipRule: "evenodd"
  }));
};

var SvgPlay24X24 = function SvgPlay24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -play",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9ZM8.685 8.406v7.187c0 .61.664.984 1.186.67l5.907-3.596a.78.78 0 0 0-.002-1.335L9.873 7.738a.782.782 0 0 0-1.188.668ZM14.951 12l-5.266 3.206V8.794L14.951 12Z",
    clipRule: "evenodd"
  }));
};

var SvgPlus104X104 = function SvgPlus104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -plus",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52 0a1 1 0 0 0-1 1v50H1a1 1 0 1 0 0 2h50v50a1 1 0 0 0 2 0V53h50a1 1 0 0 0 0-2H53V1a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  }));
};

var SvgPlus16X16 = function SvgPlus16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -plus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.492.744a.5.5 0 0 0-.992.09v7h-7l-.09.008a.5.5 0 0 0 .09.992h7v7l.008.09a.5.5 0 0 0 .992-.09v-7h7l.09-.009a.5.5 0 0 0-.09-.991h-7v-7l-.008-.09z",
    clipRule: "evenodd"
  }));
};

var SvgPlus24X24 = function SvgPlus24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -plus",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m11.725 12.345-9.542-.091a.373.373 0 0 1-.37-.373c0-.203.166-.367.37-.365l9.542.091-.005-9.542c0-.204.165-.368.369-.366a.373.373 0 0 1 .369.373l.004 9.542 9.543.092a.373.373 0 0 1 .369.372.364.364 0 0 1-.369.366l-9.542-.092.004 9.543a.364.364 0 0 1-.368.365.373.373 0 0 1-.37-.372l-.004-9.543z"
  }));
};

var SvgPointsAdjust104X104 = function SvgPointsAdjust104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-adjust",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m56.432 87.458 27.659 16.895c.745.456 1.675-.196 1.501-1.052L78.146 66.57l26.049-25.12a1 1 0 0 0-.585-1.713l-35.308-3.86L53.42 1.107c-.346-.81-1.493-.81-1.84 0l-14.88 34.77-35.308 3.86a1 1 0 0 0-.586 1.714L16.278 56.37c.566-.39 1.15-.756 1.748-1.094L3.732 41.493l33.767-3.69a1 1 0 0 0 .81-.602l14.192-33.16 14.192 33.16a1 1 0 0 0 .81.601l33.767 3.691-24.907 24.018a1 1 0 0 0-.286.919l7.1 35.021-25.75-15.729c-.03.066-.064.131-.1.195l-.895 1.541z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52.152 78.465a22.98 22.98 0 0 0 0-6.5l4.776-4.596a2.33 2.33 0 0 0 .402-2.85l-4.824-8.318a2.352 2.352 0 0 0-2.68-1.08l-6.53 1.864a22.996 22.996 0 0 0-5.456-3.07l-1.67-6.645a2.346 2.346 0 0 0-2.273-1.77h-9.648c-1.078 0-2.017.73-2.278 1.77l-1.734 6.908a23.008 23.008 0 0 0-4.957 2.921l-6.96-1.983a2.353 2.353 0 0 0-2.68 1.08L.815 64.516a2.33 2.33 0 0 0 .4 2.852l5.308 5.108a22.329 22.329 0 0 0 0 5.48L1.216 83.06a2.33 2.33 0 0 0-.402 2.85l4.824 8.319a2.353 2.353 0 0 0 2.68 1.078l6.961-1.977a23.02 23.02 0 0 0 4.959 2.924l1.734 6.907a2.345 2.345 0 0 0 2.277 1.768h9.647a2.346 2.346 0 0 0 2.274-1.77l1.667-6.638a22.99 22.99 0 0 0 5.455-3.071l6.53 1.863a2.352 2.352 0 0 0 2.68-1.078l4.824-8.319a2.33 2.33 0 0 0-.402-2.85l-4.772-4.602zm-1.974-.048a.55.55 0 0 0 .162.48l4.803 4.632c.382.368.463.946.198 1.404l-4.648 8.015c-.265.457-.809.676-1.32.531l-6.56-1.872a.555.555 0 0 0-.494.096 21.04 21.04 0 0 1-5.463 3.074.551.551 0 0 0-.34.381l-1.675 6.672c-.128.512-.59.871-1.12.872h-9.294c-.53 0-.992-.358-1.12-.87l-1.738-6.92a.551.551 0 0 0-.323-.375 21.072 21.072 0 0 1-4.996-2.947.555.555 0 0 0-.497-.1l-6.98 1.983a1.16 1.16 0 0 1-1.32-.53l-4.648-8.017a1.148 1.148 0 0 1 .198-1.403l5.313-5.11a.55.55 0 0 0 .164-.471 20.42 20.42 0 0 1 0-5.538.55.55 0 0 0-.163-.47l-5.314-5.115a1.148 1.148 0 0 1-.197-1.405l4.648-8.02c.265-.457.81-.676 1.32-.53l6.979 1.987a.555.555 0 0 0 .497-.098 21.056 21.056 0 0 1 4.995-2.945.552.552 0 0 0 .323-.375l1.737-6.921a1.155 1.155 0 0 1 1.122-.872h9.296c.528.001.99.36 1.118.872l1.68 6.679c.043.174.17.316.339.38a21.051 21.051 0 0 1 5.463 3.074c.14.109.323.144.494.096l6.561-1.872a1.158 1.158 0 0 1 1.32.531l4.647 8.016a1.147 1.147 0 0 1-.198 1.403l-4.807 4.626a.549.549 0 0 0-.162.48c.336 2.151.336 4.34 0 6.492zM29.072 62.015c7.322 0 13.258 5.91 13.258 13.2 0 7.29-5.936 13.2-13.258 13.2-7.322 0-13.257-5.91-13.257-13.2 0-7.29 5.935-13.2 13.257-13.2zM29.21 64c-6.213 0-11.25 5.015-11.25 11.201 0 6.187 5.037 11.202 11.25 11.202s11.25-5.015 11.25-11.202C40.46 69.016 35.423 64 29.21 64z",
    clipRule: "evenodd"
  }));
};

var SvgPointsAdjust16X16 = function SvgPointsAdjust16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-adjust",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.956 11c0-1.036-.875-1.875-1.955-1.875S3.047 9.965 3.047 11c0 1.036.875 1.875 1.954 1.875s1.955-.84 1.955-1.875zm-3.225-.017c0-.709.59-1.283 1.315-1.283s1.315.574 1.315 1.283-.588 1.283-1.315 1.283-1.315-.575-1.315-1.283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.848 10.117-.571.53c.027.235.027.472 0 .706l.57.53c.165.153.2.392.086.583l-.644 1.07a.506.506 0 0 1-.568.22l-.785-.216c-.19.13-.395.242-.61.33l-.2.768a.493.493 0 0 1-.482.362H4.356a.494.494 0 0 1-.483-.36l-.21-.807a3.286 3.286 0 0 1-.543-.308l-.842.23a.508.508 0 0 1-.567-.22l-.645-1.07a.464.464 0 0 1 .086-.582l.644-.597a2.962 2.962 0 0 1 0-.57l-.644-.599a.462.462 0 0 1-.085-.581l.644-1.071a.505.505 0 0 1 .568-.22l.841.23c.17-.119.353-.222.543-.308l.21-.804A.494.494 0 0 1 4.356 7h1.29c.228.001.426.15.48.362l.2.768c.216.09.42.2.61.33l.785-.215c.22-.06.454.03.568.22l.645 1.071c.113.19.078.43-.086.581zm-2.035 2.798.81.236.567-1-.592-.584a.243.243 0 0 1-.07-.21c.04-.258.04-.522 0-.78a.243.243 0 0 1 .07-.21l.592-.583-.568-1-.808.236a.233.233 0 0 1-.211-.042 2.463 2.463 0 0 0-.644-.37.24.24 0 0 1-.145-.167L5.607 7.6H4.473l-.215.873a.24.24 0 0 1-.138.163c-.21.09-.41.21-.589.355a.233.233 0 0 1-.212.043l-.861-.25-.568 1 .656.645c.054.053.08.13.07.205-.03.22-.03.445 0 .666a.243.243 0 0 1-.07.205l-.656.645.568 1 .861-.25a.233.233 0 0 1 .213.043c.179.145.377.265.588.355.07.029.12.09.138.163l.215.872h1.134l.207-.84a.24.24 0 0 1 .145-.166 2.47 2.47 0 0 0 .643-.37.233.233 0 0 1 .211-.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.231 5.403 8.448 1.34a.53.53 0 0 0-.49-.34.53.53 0 0 0-.493.347L5.783 5.405 1.5 5.881a.533.533 0 0 0-.466.346.544.544 0 0 0 .127.573l.005.005L2.846 8.4l.274.075c.17-.119.353-.222.543-.308l.064-.242-1.255-1.192 3.971-.442 1.526-3.68 1.616 3.682 3.943.423-2.936 2.805.831 4.054-2.439-1.466a.461.461 0 0 1-.051.356l-.32.532 3.112 1.871a.52.52 0 0 0 .611.003.537.537 0 0 0 .205-.57l-.914-4.453 3.203-3.06.009-.009a.544.544 0 0 0 .127-.574.533.533 0 0 0-.468-.345l-4.267-.457z"
  })));
};

var SvgPointsAdjust24X24 = function SvgPointsAdjust24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-adjust",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.263 8.235-2.787-6.352a.583.583 0 0 0-.54-.383.584.584 0 0 0-.544.39l-2.63 6.347-6.704.746a.587.587 0 0 0-.52.38.602.602 0 0 0 .142.635l.005.005 3.333 3.165-1.1-.301a.758.758 0 0 0-.85.33L2.1 14.803a.693.693 0 0 0 .127.873l.966.897a4.443 4.443 0 0 0 0 .856l-.966.895a.696.696 0 0 0-.128.873l.967 1.606c.172.284.522.42.851.33l1.263-.346c.255.18.528.334.815.463l.314 1.209a.741.741 0 0 0 .725.541h1.932a.74.74 0 0 0 .723-.543l.3-1.151c.323-.133.63-.3.914-.496l1.178.324a.76.76 0 0 0 .851-.33l.626-1.04 4.278 2.573c.2.15.472.155.676.008a.593.593 0 0 0 .223-.635l-1.427-6.956 5.002-4.78.01-.009a.602.602 0 0 0 .142-.635.587.587 0 0 0-.522-.38l-6.678-.715ZM14 18.865l3.58 2.151-1.355-6.604 4.769-4.558-6.407-.686-2.64-6.016-2.492 6.014-6.447.717 2.995 2.844.308-1.183A.74.74 0 0 1 7.035 11h1.934a.74.74 0 0 1 .72.543l.302 1.152c.322.134.629.3.914.496l1.177-.323a.759.759 0 0 1 .852.33l.967 1.606a.695.695 0 0 1-.128.872l-.857.795c.041.352.041.707 0 1.059l.856.796a.7.7 0 0 1 .227.538ZM10.932 17c0-1.553-1.312-2.812-2.932-2.812-1.619 0-2.931 1.259-2.931 2.812 0 1.554 1.312 2.813 2.931 2.813 1.62 0 2.932-1.26 2.932-2.813ZM5.95 17c0-1.105.918-2 2.05-2 1.133 0 2.05.895 2.05 2S9.133 19 8 19c-1.132 0-2.05-.895-2.05-2Zm6.14 3.176-1.285-.354a.387.387 0 0 0-.335.063 3.98 3.98 0 0 1-1.021.555.366.366 0 0 0-.23.25l-.329 1.26h-1.8l-.34-1.308a.365.365 0 0 0-.22-.245 3.972 3.972 0 0 1-.934-.533.387.387 0 0 0-.337-.064l-1.367.375-.902-1.5 1.042-.967a.352.352 0 0 0 .111-.308 3.59 3.59 0 0 1 0-.998.353.353 0 0 0-.11-.308l-1.042-.968.901-1.5L5.259 14a.387.387 0 0 0 .337-.064c.285-.218.6-.397.935-.532a.365.365 0 0 0 .219-.245l.34-1.309h1.8l.33 1.262c.03.114.115.207.23.25.367.134.711.321 1.021.555.095.07.22.094.335.062l1.284-.353.9 1.5-.94.873a.352.352 0 0 0-.11.315c.064.389.064.784 0 1.172a.352.352 0 0 0 .11.315l.94.875-.9 1.5Z",
    fill: "currentColor"
  }));
};

var SvgPointsEarn104X104 = function SvgPointsEarn104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-earn",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.72 51.956.307 40.951a1 1 0 0 1 .586-1.714l35.308-3.86L51.08.607c.347-.81 1.493-.81 1.84 0l14.88 34.77 35.309 3.86a1 1 0 0 1 .585 1.714L77.646 66.07l7.446 36.731c.174.856-.756 1.508-1.501 1.052L57.179 87.72c-4.721 10.163-15.02 17.21-26.964 17.21C13.804 104.93.5 91.626.5 75.215c0-9.42 4.383-17.815 11.22-23.259zm46.247 33.902 24.71 15.093-7.1-35.021a1 1 0 0 1 .286-.919l24.907-24.018-33.766-3.69a1 1 0 0 1-.811-.602L52 3.541 37.81 36.702a1 1 0 0 1-.811.601L3.232 40.993l10.116 9.755A29.578 29.578 0 0 1 30.215 45.5c16.411 0 29.715 13.304 29.715 29.715 0 3.75-.695 7.338-1.963 10.643zM30.35 47.7c-15.188 0-27.5 12.312-27.5 27.5s12.312 27.5 27.5 27.5 27.5-12.312 27.5-27.5-12.312-27.5-27.5-27.5zm.15 11.8a1 1 0 0 1 1 1V74h15a1 1 0 1 1 0 2h-15v15.5a1 1 0 1 1-2 0V76h-14a1 1 0 1 1 0-2h14V60.5a1 1 0 0 1 1-1z",
    clipRule: "evenodd"
  }));
};

var SvgPointsEarn16X16 = function SvgPointsEarn16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-earn",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.448 1.34 1.783 4.063 4.267.457a.533.533 0 0 1 .468.345.544.544 0 0 1-.127.574l-.009.009-3.203 3.06.914 4.452a.537.537 0 0 1-.205.57.52.52 0 0 1-.61-.002L8.69 13.044a4.001 4.001 0 1 1-6.012-4.802L1.166 6.805 1.161 6.8a.544.544 0 0 1-.127-.573.533.533 0 0 1 .466-.346l4.283-.476 1.682-4.058A.53.53 0 0 1 7.958 1a.53.53 0 0 1 .49.34zM3.561 7.767 2.47 6.733l3.972-.442 1.526-3.68 1.616 3.682 3.943.422-2.936 2.806.831 4.054-2.467-1.482A4 4 0 0 0 3.56 7.767zm1.389.603a3.15 3.15 0 1 0 0 6.3 3.15 3.15 0 0 0 0-6.3zM7 11.5c0-.276-.1-.5-.222-.5H5.5V9.722l-.008-.04C5.45 9.58 5.245 9.5 5 9.5c-.276 0-.5.1-.5.222V11H3.222l-.04.008C3.08 11.05 3 11.255 3 11.5c0 .276.1.5.222.5H4.5v1.278l.008.04c.042.103.247.182.492.182.276 0 .5-.1.5-.222V12h1.278l.04-.008C6.92 11.95 7 11.745 7 11.5z",
    clipRule: "evenodd"
  }));
};

var SvgPointsEarn24X24 = function SvgPointsEarn24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-earn",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.476 1.883 2.787 6.352 6.678.715a.587.587 0 0 1 .522.38c.089.24.01.482-.143.635l-.009.01-5.002 4.779 1.427 6.956a.593.593 0 0 1-.223.635.569.569 0 0 1-.676-.008l-4.846-2.914a6.001 6.001 0 1 1-9.036-7.264l-2.27-2.156-.005-.005a.602.602 0 0 1-.143-.635.587.587 0 0 1 .52-.38l6.705-.746 2.63-6.347a.584.584 0 0 1 .543-.39c.293 0 .47.206.541.383Zm-7.638 9.739-1.83-1.739 6.446-.717 2.492-6.014 2.64 6.016 6.407.686-4.77 4.558 1.355 6.604-4.256-2.559a6 6 0 0 0-8.484-6.836ZM7.5 12a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm3 4.5c.208 0 .376.224.376.5 0 .245-.133.45-.308.492l-.067.008H8V20c0 .207-.224.375-.5.375-.246 0-.45-.133-.492-.308L7 20v-2.5H4.5c-.207 0-.375-.224-.375-.5 0-.245.133-.45.308-.492L4.5 16.5H7V14c0-.207.224-.375.5-.375.246 0 .45.133.492.308L8 14v2.5h2.5Z",
    fill: "currentColor"
  }));
};

var SvgPointsExpire104X104 = function SvgPointsExpire104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-expire",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.307 40.95 11.72 51.957C4.883 57.4.5 65.796.5 75.215c0 16.411 13.304 29.715 29.715 29.715 11.944 0 22.242-7.047 26.964-17.21l26.412 16.133c.745.456 1.675-.196 1.501-1.052L77.646 66.07l26.049-25.12a1 1 0 0 0-.585-1.713l-35.308-3.86L52.92.607c-.346-.81-1.493-.81-1.84 0l-14.88 34.77-35.308 3.86a1 1 0 0 0-.586 1.714zm82.37 60.001-24.71-15.093a29.646 29.646 0 0 0 1.963-10.643c0-16.411-13.304-29.715-29.715-29.715a29.578 29.578 0 0 0-16.867 5.248L3.232 40.993 37 37.303a1 1 0 0 0 .81-.602l14.192-33.16 14.192 33.16a1 1 0 0 0 .81.601l33.767 3.691-24.907 24.018a1 1 0 0 0-.286.919l7.1 35.021zM2.85 75.2c0-15.188 12.312-27.5 27.5-27.5s27.5 12.312 27.5 27.5-12.312 27.5-27.5 27.5-27.5-12.312-27.5-27.5zM30.5 63.5a1 1 0 1 0-2 0v16.051l.466.294 9.5 6a1 1 0 0 0 1.068-1.69L30.5 78.449V63.5z",
    clipRule: "evenodd"
  }));
};

var SvgPointsExpire16X16 = function SvgPointsExpire16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-expire",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.231 5.403 8.448 1.34a.53.53 0 0 0-.49-.34.53.53 0 0 0-.493.347L5.783 5.405 1.5 5.881a.533.533 0 0 0-.466.346.544.544 0 0 0 .127.573l.005.005 1.513 1.437a4 4 0 1 0 6.012 4.803l3.034 1.823a.52.52 0 0 0 .611.003.537.537 0 0 0 .205-.57l-.914-4.453 3.203-3.06.009-.009a.544.544 0 0 0 .127-.574.533.533 0 0 0-.468-.345l-4.267-.457zm-7.76 1.33 1.09 1.034a4 4 0 0 1 5.396 4.326l2.466 1.483-.831-4.055 2.936-2.805-3.943-.423-1.616-3.682-1.526 3.68-3.971.442zM1.8 11.52a3.15 3.15 0 1 1 6.3 0 3.15 3.15 0 0 1-6.3 0zm3.7-1.77a.5.5 0 0 0-1 0v2.396l.179.15 1 .837a.5.5 0 0 0 .642-.766l-.821-.688V9.75z",
    clipRule: "evenodd"
  }));
};

var SvgPointsExpire24X24 = function SvgPointsExpire24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-expire",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.263 8.235-2.787-6.352a.583.583 0 0 0-.54-.383.584.584 0 0 0-.544.39l-2.63 6.347-6.704.746a.587.587 0 0 0-.52.38.602.602 0 0 0 .142.635l.005.005 2.27 2.156A5.991 5.991 0 0 0 1.5 17a5.978 5.978 0 0 0 2.188 4.633 6.001 6.001 0 0 0 9.303-2.21l4.846 2.914c.2.15.472.155.676.008a.593.593 0 0 0 .223-.635l-1.427-6.956 5.002-4.78.01-.009a.602.602 0 0 0 .142-.635.587.587 0 0 0-.522-.38l-6.678-.715ZM3.007 9.883l1.83 1.739a6 6 0 0 1 8.485 6.836l4.256 2.558-1.354-6.604 4.769-4.558-6.407-.686-2.64-6.016-2.492 6.014-6.447.717ZM2.5 17a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm4.93-3.375c.236 0 .428.172.428.385v2.84L9 17.5l.89.5c.203.11.171.456.05.638a.457.457 0 0 1-.589.132L7.21 17.615a.379.379 0 0 1-.209-.33V14.01c0-.213.192-.385.43-.385Z",
    fill: "currentColor"
  }));
};

var SvgPointsRedeem104X104 = function SvgPointsRedeem104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-redeem",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.41 103.301c-.173.856.756 1.508 1.502 1.052l31.59-19.296 31.589 19.296c.745.456 1.675-.196 1.501-1.052L78.146 66.57l26.049-25.12a1 1 0 0 0-.585-1.713l-35.308-3.86L53.42 1.107c-.346-.81-1.493-.81-1.84 0l-14.88 34.77-35.308 3.86a1 1 0 0 0-.586 1.714l26.05 25.119-7.447 36.731zm32.57-20.27-30.154 18.42 7.1-35.021a1 1 0 0 0-.287-.919L3.732 41.493l33.767-3.69a1 1 0 0 0 .81-.602l14.192-33.16 14.192 33.16a1 1 0 0 0 .81.601l33.767 3.691-24.907 24.018a1 1 0 0 0-.286.919l7.1 35.021-30.154-18.42a1 1 0 0 0-1.043 0zm20.814-53.238a1 1 0 0 1 0-1.414L85.38 15.793a1 1 0 0 1 1.414 1.414L74.208 29.793a1 1 0 0 1-1.414 0zm-41.586-1.414a1 1 0 0 1-1.414 1.414L17.208 17.207a1 1 0 0 1 1.414-1.414l12.586 12.586zm52.789 40.985a1 1 0 0 0 .36 1.367l15.37 8.974a1 1 0 0 0 1.009-1.727l-15.371-8.974a1 1 0 0 0-1.368.36zM19.744 70.73a1 1 0 0 0-1.008-1.727L3.365 77.978a1 1 0 1 0 1.008 1.727l15.371-8.974z",
    clipRule: "evenodd"
  }));
};

var SvgPointsRedeem16X16 = function SvgPointsRedeem16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-redeem",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.23 5.403 8.447 1.34a.53.53 0 0 0-.49-.34.53.53 0 0 0-.493.347L5.782 5.405 1.5 5.881a.533.533 0 0 0-.467.346.544.544 0 0 0 .128.573l.004.005 3.23 3.066-.907 4.535v.047c0 .25.165.4.26.46.101.064.31.142.532.03l.019-.009 3.714-2.297 3.711 2.231a.52.52 0 0 0 .612.003.537.537 0 0 0 .204-.57l-.913-4.453 3.203-3.06.008-.009a.544.544 0 0 0 .127-.574.533.533 0 0 0-.467-.345l-4.268-.457zm-.646.89L7.968 2.611 6.443 6.29l-3.972.442 2.957 2.808-.815 4.08 3.393-2.1 3.417 2.054-.832-4.054 2.937-2.806-3.944-.422zm3.55-4.134a.5.5 0 0 0-.707.024l-1.364 1.463a.5.5 0 1 0 .73.682l1.365-1.462a.5.5 0 0 0-.024-.707zm2.153 9.566a.5.5 0 0 1-.664.24l-1.812-.847a.5.5 0 0 1 .424-.906l1.812.848a.5.5 0 0 1 .24.665zm-13.91.24a.5.5 0 0 1-.425-.905l1.812-.848a.5.5 0 1 1 .424.906l-1.812.848zM2.864 2.16a.5.5 0 0 1 .707.024l1.364 1.463a.5.5 0 0 1-.731.682L2.84 2.866a.5.5 0 0 1 .025-.707z",
    clipRule: "evenodd"
  }));
};

var SvgPointsRedeem24X24 = function SvgPointsRedeem24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-redeem",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.476 1.883 2.787 6.352 6.678.715a.587.587 0 0 1 .522.38c.089.24.01.482-.143.635l-.009.01-5.002 4.779 1.427 6.956a.593.593 0 0 1-.223.635.569.569 0 0 1-.676-.008l-5.817-3.498-5.805 3.59-.02.01a.603.603 0 0 1-.59-.036.608.608 0 0 1-.29-.51v-.049l1.41-7.055-5.04-4.786-.005-.005a.602.602 0 0 1-.143-.635.587.587 0 0 1 .52-.38l6.705-.746 2.63-6.347a.584.584 0 0 1 .543-.39c.293 0 .47.206.541.383Zm-.53 1.27 2.64 6.015 6.407.686-4.77 4.558 1.355 6.604-5.566-3.346L6.48 21.09l1.329-6.649-4.8-4.559 6.446-.717 2.492-6.014Zm6.736 1.506a.5.5 0 0 0-.707.024L16.61 6.146a.5.5 0 1 0 .732.682l1.364-1.462a.5.5 0 0 0-.024-.707Zm-12.61.024a.5.5 0 1 0-.73.683l1.364 1.462a.5.5 0 0 0 .731-.682L6.073 4.683Zm15.434 12.042a.5.5 0 0 1-.665.24l-1.812-.847a.5.5 0 0 1 .424-.906l1.812.848a.5.5 0 0 1 .24.665Zm-18.629.24a.5.5 0 0 1-.424-.905l1.812-.848a.5.5 0 1 1 .424.906l-1.812.848Z",
    fill: "currentColor"
  }));
};

var SvgPointsRefund104X104 = function SvgPointsRefund104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-refund",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.307 40.95 11.72 51.957C4.883 57.4.5 65.796.5 75.215c0 16.411 13.304 29.715 29.715 29.715 11.944 0 22.242-7.047 26.964-17.21l26.412 16.133c.745.456 1.675-.196 1.501-1.052L77.646 66.07l26.049-25.12a1 1 0 0 0-.585-1.713l-35.308-3.86L52.92.607c-.346-.81-1.493-.81-1.84 0l-14.88 34.77-35.308 3.86a1 1 0 0 0-.586 1.714zm82.37 60.001-24.71-15.093a29.646 29.646 0 0 0 1.963-10.643c0-16.411-13.304-29.715-29.715-29.715a29.578 29.578 0 0 0-16.867 5.248L3.232 40.993 37 37.303a1 1 0 0 0 .81-.602l14.192-33.16 14.192 33.16a1 1 0 0 0 .81.601l33.767 3.691-24.907 24.018a1 1 0 0 0-.286.919l7.1 35.021zM2.85 75.2c0-15.188 12.312-27.5 27.5-27.5s27.5 12.312 27.5 27.5-12.312 27.5-27.5 27.5-27.5-12.312-27.5-27.5zm41.857-.907-6.364-6.364a1 1 0 0 0-1.414 1.414L41.586 74H16a1 1 0 1 0 0 2h25.586l-4.657 4.657a1 1 0 0 0 1.414 1.414l6.364-6.364a1 1 0 0 0 0-1.414z",
    clipRule: "evenodd"
  }));
};

var SvgPointsRefund16X16 = function SvgPointsRefund16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-refund",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.231 5.403 8.448 1.34a.53.53 0 0 0-.49-.34.53.53 0 0 0-.493.347L5.783 5.405 1.5 5.881a.533.533 0 0 0-.466.346.544.544 0 0 0 .127.573l.005.005 1.513 1.437a4 4 0 1 0 6.012 4.803l3.034 1.823a.52.52 0 0 0 .611.003.537.537 0 0 0 .205-.57l-.914-4.453 3.203-3.06.009-.009a.544.544 0 0 0 .127-.574.533.533 0 0 0-.468-.345l-4.267-.457Zm-7.76 1.33 1.09 1.034a4 4 0 0 1 5.396 4.326l2.466 1.482-.831-4.054 2.936-2.806-3.943-.422-1.616-3.682-1.526 3.68-3.971.442ZM1.8 11.52a3.15 3.15 0 1 1 6.3 0 3.15 3.15 0 0 1-6.3 0Zm4.054-1.874a.5.5 0 1 0-.708.708L5.5 10l-.354.354h.001l.001.001.001.001.001.001.001.001v.001h.001l.001.001.001.001.001.001.001.001v.001h.001l.001.001.001.001v.001h.002v.001l.001.001.001.002h.001v.001h.002v.002h.001l.001.001.002.002.001.002h.001l.001.001.001.001.001.001.001.001v.001l.002.001v.001l.002.001v.001l.002.001v.001l.002.001.001.001.001.001.001.001.001.002h.002v.002h.002l.001.002.001.001.001.002h.002v.002l.002.001.001.001.002.002v.001l.002.001.002.002.002.002.002.002v.001l.002.001.002.002.001.001.002.002v.001l.002.002.002.001.001.001.002.002.001.001.002.002.001.002.002.001.001.002.002.001.002.002.001.001.002.002.001.002.002.001.002.002.001.002.002.001.002.002.002.002.001.001.002.002.002.002.001.002.002.001.002.002.002.002.002.002.001.002.002.001.002.002.002.002.002.002.002.002.002.002.002.002.001.002.002.002.002.002.002.001.002.002.002.002.002.002.002.002.002.002.002.002.002.002.002.003.003.002.002.002.002.002.002.002.002.002.002.002.002.002.002.003.003.002.002.002.002.002.002.002.002.002.003.003.002.002.002.002.002.002.003.003.002.002.002.002.002.003.003.002.002.002.002.003.003.002.002.002.003.003.002.002.002.003.003.002.002.002.003.003.002.002.003.003.002.002.002.003.003.002.002.003.003.002.003.003.002.002.003.003.002.002.003.003.002.002.003.003.002.003.003.002.003.003.002.002.003.003.003.003.002.002.003.003.003.003.002.002.003.003.003.003.003.003.002.002.003.003.003.003.003.003.002.002.003.003.003.003.003.003.003.003.002.003.003.002.003.003.003.003.003.003.003.003.003.003.003.003.002.003.003.003.003.002.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.004.003.003.004.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.004.004.003.003.003.003.003.003.003.003.003.003.004.004.003.003.003.003.003.003.004.004.003.003.003.003.003.003.004.004.003.003.003.003.004.004.003.003.003.003.003.004.004.003.003.003.004.004.003.003.003.003.004.004.003.003.003.004.004.003.003.003.004.004.003.003.004.004.003.003.004.004.003.003.003.004.004.003.003.004.004.003.003.004.004.003.004.004.003.003.004.004.003.003.004.004.003.003.004.004.003.003.004.004.004.004.003.003.004.004.003.004.004.003.004.004.003.003.004.004.004.004.003.003.004.004.004.004.003.003.002.002H3v.5-.5a.5.5 0 0 0 0 1v-.5.5H5.793v.002l-.004.003-.004.004-.004.004-.003.003-.004.004-.004.004-.003.003-.004.004-.004.003-.003.004-.004.004-.003.003-.004.004-.004.004-.003.003-.004.004-.003.003-.004.004-.003.003-.004.004-.003.003-.004.004-.004.003-.003.004-.004.003-.003.004-.004.003-.003.004-.003.003-.004.004-.003.003-.004.004-.003.003-.004.004-.003.003-.004.003-.003.004-.003.003-.004.004-.003.003-.003.003-.004.004-.003.003-.003.003-.004.004-.003.003-.003.003-.004.004-.003.003-.003.003-.004.004-.003.003-.003.003-.003.003-.004.004-.003.003-.003.003-.003.003-.004.004-.003.003-.003.003-.003.003-.003.003-.003.003-.004.004-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.004.003-.003.003-.003.004-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.002-.003.003-.002.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.002-.002.003-.003.003-.003.003-.003.003-.003.002-.002.003-.003.003-.003.003-.003.003-.002.002-.003.003-.003.003-.003.003-.002.002-.003.003-.003.003-.002.002-.003.003-.003.003-.002.002-.003.003-.003.002-.002.003-.003.003-.002.002-.003.003-.002.002-.003.003-.002.002-.003.003-.003.002-.002.003-.003.002-.002.003-.002.002-.003.003-.002.002-.003.003-.002.002-.003.002-.002.003-.002.002-.003.003-.002.002-.003.002-.002.003-.002.002-.003.002-.002.003-.002.002-.002.002-.003.003-.002.002-.002.002-.002.002-.003.003-.002.002-.002.002-.002.002-.002.002-.003.002-.002.003-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.003.002-.002.002-.002.003-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.001-.001.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.001-.001.002-.002.002-.002.002-.002.002-.002.001-.001.002-.002.002-.002.002-.001.001-.002.002-.002.002-.002.001-.001.002-.002.002-.002.001-.001.002-.002.002-.001.001-.002.002-.002.001-.001.002-.002.002-.001.001-.002.002-.001.001-.002.002-.001.001-.002.002h-.001l-.001.002-.002.002-.001.001-.002.002-.001.001-.001.001-.002.002-.001.001-.002.001v.002l-.002.001-.001.001-.002.002-.002.002-.001.001-.002.002-.002.002-.001.001-.001.001-.001.001-.002.002-.002.002-.002.002h-.001l-.001.002-.001.001-.001.001-.001.001-.001.001-.001.001h-.001l-.001.002-.002.002-.002.002-.001.001-.001.001h-.001v.002h-.002v.001l-.001.001-.002.002h-.001v.002H5.16l-.001.001-.001.001-.002.001v.001l-.001.001-.001.001-.001.001-.001.001-.001.001-.001.001H5.15v.001l-.001.001h-.001v.001h-.001v.001L5.5 13l-.354-.354a.5.5 0 0 0 .708.708L5.5 13l.354.354v-.001l.001-.001.001-.001.001-.001.001-.001h.001v-.001l.001-.001.001-.001.001-.001.001-.001h.001v-.002h.001l.001-.001h.001v-.002h.001l.001-.001.001-.001.001-.001h.001v-.002h.002v-.001l.001-.001.002-.002.002-.001v-.001l.001-.001.001-.001.001-.001.001-.001h.001l.001-.002h.001l.001-.002h.001l.001-.002.001-.001.001-.001.001-.001.001-.001.001-.001.002-.001v-.002h.002v-.002l.002-.001.001-.001.001-.001.002-.002.002-.002.001-.001.002-.002h.001l.001-.002.002-.002.002-.002.002-.002h.001l.001-.002.002-.002.001-.001.002-.002h.001l.002-.002.001-.002.001-.001.002-.002.001-.001.002-.002.001-.001.002-.002.002-.002.001-.001.002-.002.001-.001.002-.002.002-.002.001-.001.002-.002.002-.001.001-.002.002-.002.002-.002.001-.001.002-.002.002-.002.002-.002.001-.001.002-.002.002-.002.002-.002.002-.001.001-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.001.001-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.003-.002.002-.003.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.002-.002.003-.002.002-.003.002-.002.002-.002.002-.002.003-.002.002-.003.002-.002.002-.002.003-.003.002-.002.002-.002.003-.002.002-.003.002-.002.003-.002.002-.003.002-.002.003-.003.002-.002.002-.002.003-.003.002-.002.003-.003.002-.002.003-.002.002-.003.003-.002.002-.003.003-.002.002-.003.003-.003.002-.002.003-.003.002-.002.003-.003.002-.002.003-.003.003-.002.002-.003.003-.003.002-.002.003-.003.003-.003.002-.002.003-.003.003-.003.003-.002.002-.003.003-.003.003-.003.002-.002.003-.003.003-.003.003-.003.002-.002.003-.003.003-.003.003-.003.003-.003.003-.002.002-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.002.002-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.004-.003.003-.004.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.003-.003.004-.004.003-.003.003-.003.003-.003.003-.003.004-.003.003-.004.003-.003.003-.003.003-.003.004-.004.003-.003.003-.003.003-.003.004-.004.003-.003.003-.003.004-.004.003-.003.003-.003.004-.004.003-.003.003-.003.004-.004.003-.003.003-.003.004-.004.003-.003.004-.004.003-.003.003-.003.004-.004.003-.003.004-.004.003-.003.004-.004.003-.003.004-.003.003-.004.004-.003.003-.004.004-.004.003-.003.004-.004.003-.003.004-.004.003-.003.004-.004.003-.003.004-.004.004-.003.003-.004.004-.004.003-.003.004-.004.004-.003.003-.004.004-.004.003-.003.004-.004.004-.004.003-.003.004-.004.004-.004.003-.003.004-.004.004-.004.004-.003.003-.004.004-.004.004-.004.003-.003.004-.004.004-.004.004-.004.003-.003.004-.004.004-.004.004-.004.004-.004.003-.003.004-.004.004-.004.004-.004.004-.004.004-.003.003-.004.004-.004.004-.004.004-.004.004-.004.004-.004.004-.003.003-.004.004-.004.004-.004.004-.004.004-.004.004-.004.004-.004.004-.004.004-.004.004-.004.004-.004.004-.003.004-.004.004-.005.004-.003.004-.004.004-.004.004-.004.003-.004.005-.004.004-.004.004-.004.004-.005.004-.003.004-.004.004-.005.004-.004.004-.004.004-.004.004-.004.004-.004.004-.004.004-.004.004-.004.004-.004.004-.004.005-.004.004-.005.004-.004.004-.004.004-.004.004-.004.004-.004.004-.004.005-.004.004-.005.004-.004.004-.004.004-.004.004-.004.005-.004.004-.005.004-.004.004-.004.004-.004.004-.004.005-.005.004-.004.004-.004.004-.004.005-.004.004-.005.004-.004.004-.004.005-.004.004-.005.004-.004.004-.004.005-.004.004-.005.004-.004.004-.004.005-.005.004-.004.004-.004.004-.004.005-.005.004-.004.004-.004.005-.005.004-.004.004-.004.005-.005.004-.004.004-.004.005-.005.004-.004.004-.004.005-.005.004-.004.004-.004.005-.005.004-.004.004-.004.005-.005.004-.004.005-.005.004-.004.004-.004.005-.005.004-.004.005-.005.004-.004.004-.004.005-.005.004-.004.005-.005.004-.004.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.004-.004.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.004-.004.005-.004.004-.005.005-.004.004-.005.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.005-.004.004-.005.005-.004.004-.005.005-.005.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.005-.004.004-.005.005-.005.004-.004.005-.005.004-.004.005-.005.004-.004.005-.005.005-.004.004-.005.005-.005.004-.004.005-.005.004-.004.005-.005.005-.004a.5.5 0 0 0 0-.708l-.005-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.005-.005-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.005-.005-.004-.004-.005-.005-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.004-.005-.005-.004-.004-.004-.005-.005-.004-.004-.005-.005-.004-.004-.004-.005-.005-.004-.004-.004-.005-.005-.004-.004-.004-.005-.005-.004-.004-.004-.005-.005-.004-.004-.004-.005-.005-.004L7 10.792l-.005-.005-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.004-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.005-.005-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.005-.004-.004-.005-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.005-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.005-.004-.003-.004-.004-.004-.004-.004-.004-.004-.004-.003-.004-.005-.004-.004-.004-.003-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.003-.004-.004-.003-.004-.004-.004-.004-.004-.004-.004-.004-.004-.004-.003-.004-.004-.003-.004-.004-.004-.004-.004-.004-.004-.004-.003-.004-.004-.003-.004-.004-.004-.004-.004-.004-.003-.003-.004-.004-.004-.004-.004-.004-.003-.003-.004-.004-.004-.004-.003-.004-.004-.003-.004-.004-.004-.004-.003-.003-.004-.004-.004-.004-.003-.003-.004-.004-.004-.004-.003-.003-.004-.004-.003-.004-.004-.003-.004-.004-.003-.003-.004-.004-.003-.004-.004-.003-.004-.004-.003-.003-.004-.004-.003-.003-.004-.004-.003-.003-.004-.004-.003-.003-.004-.004-.003-.004-.004-.003-.003-.004-.004-.003-.003-.004-.004-.003-.003-.003-.004-.004-.003-.003-.004-.004-.003-.003-.003-.003-.004-.004-.003-.003-.004-.004-.003-.003-.003-.003-.004-.004-.003-.003-.003-.004-.004-.003-.003-.003-.003-.004-.004-.003-.003-.003-.003-.003-.004-.004-.003-.003-.003-.003-.003-.003-.004-.004-.003-.003-.003-.003-.003-.003-.003-.004-.004-.003-.003-.003-.003-.003-.003-.003-.003-.003-.004-.004-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.004-.003-.003-.004-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.002-.003-.003-.002-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.003-.002-.003-.003-.002-.003-.003-.003-.003-.003-.003-.003-.003-.002-.002-.003-.003-.003-.003-.003-.003-.002-.002-.003-.003-.003-.003-.002-.003-.003-.002-.003-.003-.003-.003-.002-.002-.003-.003-.003-.003-.002-.002-.003-.003-.002-.002-.003-.003-.003-.003-.002-.002-.003-.003-.002-.002-.003-.003-.002-.002-.003-.003-.002-.003-.003-.002-.002-.003-.003-.002-.002-.002-.003-.003-.002-.002-.003-.003-.002-.002-.003-.003-.002-.002-.002-.002-.003-.003-.002-.002-.002-.003-.003-.002-.002-.002-.002-.003-.003-.002-.002-.002-.002-.002-.003-.003-.002-.002-.002-.002-.002-.002-.003-.003-.002-.002-.002-.002-.002-.002-.002-.002-.003-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.003-.002-.002-.002-.002-.002-.002-.002L6 9.792l-.002-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.002-.002-.001-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.001-.002-.002-.001-.002-.002-.002-.002-.002-.002-.001-.002-.002-.001-.002-.002-.002-.002-.001-.001-.002-.002-.002-.002-.001-.002-.002-.001-.002-.002-.001-.002-.002-.001-.002-.002-.001-.001-.002-.002-.001-.002-.002-.001-.002-.002-.001-.001-.002-.002-.001-.001-.002-.002-.001-.001-.002-.002-.001-.001-.001-.001-.002-.002-.001-.001-.002-.002-.001-.001-.001-.001-.002-.002-.001-.001-.001-.002H5.91l-.001-.002-.001-.001-.002-.002-.002-.002-.001-.001-.002-.002-.002-.002-.001-.001-.001-.001-.001-.001-.002-.002-.002-.002-.002-.002v-.001l-.002-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001v-.001l-.002-.001-.002-.002-.002-.002-.001-.001-.001-.001v-.001h-.002v-.002h-.001l-.001-.001-.002-.002v-.001h-.002V9.66l-.001-.001-.001-.001-.001-.002h-.001l-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001-.001V9.65h-.001l-.001-.001-.001-.001v-.001h-.001L5.5 10l.354-.354Z",
    fill: "currentColor"
  }));
};

var SvgPointsRefund24X24 = function SvgPointsRefund24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -points-refund",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.263 8.235-2.787-6.352a.583.583 0 0 0-.54-.383.584.584 0 0 0-.544.39l-2.63 6.347-6.704.746a.587.587 0 0 0-.52.38.602.602 0 0 0 .142.635l.005.005 2.27 2.156A5.991 5.991 0 0 0 1.5 17a5.978 5.978 0 0 0 2.188 4.633 6.001 6.001 0 0 0 9.303-2.21l4.846 2.914c.2.15.472.155.676.008a.593.593 0 0 0 .223-.635l-1.427-6.956 5.002-4.78.01-.009a.602.602 0 0 0 .142-.635.587.587 0 0 0-.522-.38l-6.678-.715ZM3.007 9.883l1.83 1.739a6 6 0 0 1 8.485 6.836l4.256 2.558-1.354-6.604 4.769-4.558-6.407-.686-2.64-6.016-2.492 6.014-6.447.717ZM2.5 17a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm8.387-.288-2.475-2.593a.377.377 0 0 0-.55 0 .421.421 0 0 0 0 .576l1.81 1.898H4.39A.398.398 0 0 0 4 17c0 .225.175.407.39.407h5.283l-1.811 1.898a.421.421 0 0 0 0 .576c.152.159.398.159.55 0l2.475-2.593a.421.421 0 0 0 0-.576Z",
    fill: "currentColor"
  }));
};

var SvgPresentation104X104 = function SvgPresentation104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -presentation",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.045 64.6h58.654a11.958 11.958 0 0 1-.615-3.796c0-6.611 5.359-11.97 11.97-11.97 6.61 0 11.97 5.359 11.97 11.97 0 1.327-.217 2.603-.615 3.796h8.546A5.044 5.044 0 0 0 102 59.556V7.044A5.044 5.044 0 0 0 96.955 2H7.045A5.044 5.044 0 0 0 2 7.044v52.512A5.044 5.044 0 0 0 7.045 64.6zm60.973.424c.062.087.11.184.14.288a9.968 9.968 0 0 0 8.895 5.462 9.97 9.97 0 0 0 8.892-5.456.997.997 0 0 1 .147-.3 9.932 9.932 0 0 0 .931-4.214c0-5.507-4.463-9.97-9.97-9.97-5.506 0-9.969 4.464-9.969 9.97 0 1.508.335 2.938.934 4.22zM7.045 66.6h59.533a11.966 11.966 0 0 0 10.475 6.174c4.509 0 8.435-2.492 10.476-6.174h9.426A7.044 7.044 0 0 0 104 59.556V7.044A7.044 7.044 0 0 0 96.955 0H7.045A7.044 7.044 0 0 0 0 7.044v52.512A7.044 7.044 0 0 0 7.045 66.6zm43.456-17.613-14.88-14.88-17.113 17.114a1 1 0 0 1-1.415-1.414l17.82-17.82a1 1 0 0 1 1.415 0l14.88 14.878L82.694 15.38a1 1 0 0 1 1.415 1.415L51.915 48.987a1 1 0 0 1-1.415 0zm26.553 30.33c-13.08 0-23.683 10.604-23.683 23.683a1 1 0 0 1-2 0c0-14.184 11.499-25.682 25.683-25.682 14.182 0 25.681 11.499 25.681 25.682a1 1 0 0 1-2 0c0-13.079-10.603-23.682-23.681-23.682z",
    clipRule: "evenodd"
  }));
};

var SvgPresentation16X16 = function SvgPresentation16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -presentation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.388 9.5H9.58a2.113 2.113 0 1 1 4.207 0h.824A.39.39 0 0 0 15 9.111V1.389A.39.39 0 0 0 14.611 1H1.388A.389.389 0 0 0 1 1.389v7.722c0 .215.174.389.388.389zm9.277.245a1.114 1.114 0 1 0 2.036-.902 1.114 1.114 0 0 0-2.036.902zm-9.277.755h8.56c.322.464.826.792 1.41.883A4.13 4.13 0 0 0 7.553 15.5a.5.5 0 0 0 1 0 3.13 3.13 0 0 1 6.26 0 .5.5 0 0 0 1 0c0-2.17-1.675-3.95-3.803-4.117a2.113 2.113 0 0 0 1.41-.883h1.19A1.39 1.39 0 0 0 16 9.111V1.389A1.39 1.39 0 0 0 14.611 0H1.388C.622 0 0 .622 0 1.389v7.722C0 9.878.622 10.5 1.388 10.5zM7.53 7.807 5.59 5.867 3.324 8.135a.5.5 0 1 1-.707-.707l2.62-2.621a.5.5 0 0 1 .708 0l1.938 1.94 4.38-4.381a.5.5 0 0 1 .708.707L8.237 7.807a.5.5 0 0 1-.707 0z",
    clipRule: "evenodd"
  }));
};

var SvgPresentation24X24 = function SvgPresentation24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -presentation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.626 14.033h10.527a2.543 2.543 0 1 1 5.027 0h1.194c.346 0 .626-.28.626-.626V3.626A.626.626 0 0 0 20.374 3H3.626A.626.626 0 0 0 3 3.626v9.781c0 .346.28.626.626.626Zm11.631.236c.018.029.033.06.045.092a1.544 1.544 0 1 0-.045-.092Zm-11.631.764h10.912a2.542 2.542 0 0 0 4.257 0h1.579c.898 0 1.626-.728 1.626-1.626V3.626C22 2.728 21.272 2 20.374 2H3.626C2.728 2 2 2.728 2 3.626v9.781c0 .898.728 1.626 1.626 1.626Zm8.58-3.372a.5.5 0 0 1-.707 0L8.95 9.11l-2.966 2.965a.5.5 0 0 1-.707-.707l3.32-3.319a.5.5 0 0 1 .706 0l2.55 2.55 5.644-5.644a.5.5 0 0 1 .707.707l-5.996 5.998Zm4.461 5.74A4.098 4.098 0 0 0 12.57 21.5a.5.5 0 0 1-1 0 5.099 5.099 0 0 1 10.195 0 .5.5 0 0 1-1 0 4.098 4.098 0 0 0-4.097-4.098Z",
    fill: "currentColor"
  }));
};

var SvgPrevidence104X104 = function SvgPrevidence104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -previdence",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M53 102c.612-13.717 13.491-24.468 30-25-.457 15.63-11.316 24.686-30 25zM21 77c16.51.532 29.388 11.283 30 25-18.683-.314-29.543-9.37-30-25zM52 2C33.804 2 19 16.803 19 35s14.804 33 33 33c18.196 0 33-14.803 33-33S70.196 2 52 2zm32.157 73.352h.008a.998.998 0 0 1 .996 1c0 17.309-12.394 27.644-33.155 27.648h-.013c-20.76-.004-33.154-10.339-33.154-27.648a1 1 0 0 1 .294-.709 1.08 1.08 0 0 1 .71-.291c14.508.098 26.562 7.513 31.16 18.073V70.208C32.165 69.676 17 54.145 17 35.117 17 15.754 32.701 0 52 0s35 15.754 35 35.117c0 19.028-15.165 34.559-34.004 35.091v23.217c4.599-10.56 16.652-17.975 31.162-18.073zm-31.67-23.128v4.779c0 .55-.44.997-.987.997s-.987-.447-.987-.997v-4.789c-4.776-.5-8.513-4.591-8.513-9.546 0-.55.442-.998.988-.998s.987.447.987.998c0 4.192 3.376 7.603 7.525 7.603 4.36 0 7.525-2.896 7.525-6.887 0-3.415-2.605-5.74-7.742-6.91C43.611 34.701 42 30.678 42 27.614c0-4.832 3.523-8.42 8.513-8.838v-4.78c0-.55.441-.997.987-.997s.988.446.988.998v4.791c4.213.437 7.662 3.64 8.38 7.944a.997.997 0 0 1-.808 1.15.985.985 0 0 1-1.138-.818c-.615-3.67-3.734-6.334-7.418-6.335h-.001a.006.006 0 0 1-.005 0h-.002c-4.358.002-7.521 2.896-7.521 6.885 0 3.4 2.606 5.726 7.745 6.912 7.67 1.748 9.28 5.781 9.28 8.857 0 4.834-3.523 8.422-8.512 8.84z",
    clipRule: "evenodd"
  }));
};

var SvgPrevidence16X16 = function SvgPrevidence16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -previdence",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.545 14.982c.277-1.511 1.755-2.676 3.658-2.872-.263 2.211-2.19 2.772-3.658 2.872zm-4.75-2.872c1.905.196 3.382 1.361 3.66 2.872-1.468-.1-3.396-.661-3.66-2.872zM8 1C5.516 1 3.497 3.026 3.497 5.517c0 2.491 2.02 4.517 4.503 4.517s4.503-2.026 4.503-4.517C12.503 3.026 10.483 1 8 1zm4.729 10.081h.002a.5.5 0 0 1 .499.5C13.23 14.348 11.274 16 8 16c-3.275 0-5.23-1.652-5.23-4.419a.5.5 0 0 1 .147-.355c.093-.094.19-.178.354-.145 1.764.012 3.288.729 4.23 1.827v-1.899A5.517 5.517 0 0 1 2.5 5.517C2.5 2.475 4.967 0 8 0c3.032 0 5.5 2.475 5.5 5.517a5.517 5.517 0 0 1-5.002 5.492v1.899c.942-1.098 2.466-1.815 4.23-1.827zm-4.23-2.81v.416a.5.5 0 1 1-.997 0v-.426a1.765 1.765 0 0 1-1.265-1.687.499.499 0 1 1 .997 0c0 .423.344.768.767.768.368 0 .765-.208.765-.663 0-.117 0-.476-.875-.674-1.438-.329-1.654-1.175-1.654-1.65 0-.782.52-1.398 1.265-1.592v-.415a.499.499 0 1 1 .997 0v.423a1.756 1.756 0 0 1 1.24 1.395.502.502 0 0 1-.409.577.506.506 0 0 1-.575-.41.764.764 0 0 0-.754-.64c-.37 0-.767.207-.767.662 0 .117 0 .474.877.675 1.437.325 1.652 1.173 1.652 1.65 0 .781-.52 1.397-1.264 1.591z",
    clipRule: "evenodd"
  }));
};

var SvgPrevidence24X24 = function SvgPrevidence24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -previdence",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M12.501 13.053a.5.5 0 0 1-1 0v-.848a2.45 2.45 0 0 1-1.946-2.392.5.5 0 1 1 1 0c.001.796.648 1.444 1.446 1.444.696 0 1.445-.4 1.445-1.282 0-.627-.523-1.062-1.555-1.295-1.932-.44-2.336-1.477-2.336-2.269 0-1.14.807-2.034 1.946-2.238v-.84a.5.5 0 1 1 1 0v.851c.971.202 1.74.97 1.912 1.981a.5.5 0 0 1-.987.167 1.442 1.442 0 0 0-1.424-1.203H12c-.694.001-1.443.402-1.443 1.282 0 .232 0 .938 1.556 1.294 2.032.458 2.335 1.62 2.335 2.27 0 1.14-.807 2.034-1.946 2.238v.84zm.026 9.937c3.774-.151 6.01-1.94 6.236-4.98-3.343.218-5.942 2.3-6.236 4.98zM5.26 18.01c.226 3.04 2.462 4.829 6.237 4.98-.294-2.68-2.893-4.762-6.237-4.98zM4.8 8.193c0 3.966 3.23 7.193 7.2 7.193s7.2-3.227 7.2-7.193C19.2 4.227 15.97 1 12 1S4.8 4.227 4.8 8.193zm14.48 8.798c.155.04.261.052.356.146a.5.5 0 0 1 .147.354c0 4.067-2.899 6.497-7.752 6.508h-.038c-4.854-.011-7.752-2.441-7.752-6.508a.504.504 0 0 1 .5-.5h.004c2.928.02 5.426 1.318 6.755 3.262V16.36c-4.288-.26-7.7-3.82-7.7-8.168C3.8 3.676 7.479 0 12 0c4.521 0 8.2 3.676 8.2 8.193 0 4.349-3.412 7.908-7.7 8.168v3.924c1.324-1.962 3.834-3.274 6.78-3.294z"
  }));
};

var SvgPrinter104X104 = function SvgPrinter104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -printer",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M32 75a1 1 0 0 1 1-1h38a1 1 0 1 1 0 2H33a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 88a1 1 0 1 0 0 2h38a1 1 0 1 0 0-2H33Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8v18H8a8 8 0 0 0-8 8v36a8 8 0 0 0 8 8h12v18a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V78h12a8 8 0 0 0 8-8V34a8 8 0 0 0-8-8H84V8a8 8 0 0 0-8-8H28a8 8 0 0 0-8 8Zm56-6H28a6 6 0 0 0-6 6v18h60V8a6 6 0 0 0-6-6Zm8 74h12a6 6 0 0 0 6-6V34a6 6 0 0 0-6-6H8a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h12V60h64v16ZM22 62h60v34a6 6 0 0 1-6 6H28a6 6 0 0 1-6-6V62Z",
    fill: "currentColor"
  }));
};

var SvgPrinter16X16 = function SvgPrinter16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -printer",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1v3H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h1v3a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3h1a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1V1a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Zm9 0H4v3h8V1Zm1 10h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1V9h10v2Zm-9-1h8v5H4v-5Z",
    fill: "currentColor"
  }));
};

var SvgPrinter24X24 = function SvgPrinter24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -printer",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 18.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4v3H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2v3a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2Zm10-1H8a1 1 0 0 0-1 1v3h10V4a1 1 0 0 0-1-1Zm2 13h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2v-4h12v4ZM7 13h10v7a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-7Z",
    fill: "currentColor"
  }));
};

var SvgPrinter64X64 = function SvgPrinter64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -printer",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 45.5a.5.5 0 0 1 .5-.5h23a.5.5 0 0 1 0 1h-23a.5.5 0 0 1-.5-.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 54a.5.5 0 0 0 0 1h23a.5.5 0 0 0 0-1h-23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4v12H4a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h8v12a4 4 0 0 0 4 4h32a4 4 0 0 0 4-4V48h8a4 4 0 0 0 4-4V20a4 4 0 0 0-4-4h-8V4a4 4 0 0 0-4-4H16a4 4 0 0 0-4 4Zm36-3H16a3 3 0 0 0-3 3v12h38V4a3 3 0 0 0-3-3Zm4 46h8a3 3 0 0 0 3-3V20a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h8V36h40v11ZM13 37h38v23a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V37Z",
    fill: "currentColor"
  }));
};

var SvgQrCode104X104 = function SvgQrCode104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -qr-code",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10h18a1 1 0 1 0 0-2H9a1 1 0 0 0-1 1v19a1 1 0 1 0 2 0V10Zm52 12a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v19a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V22Zm13 16a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3ZM41 82a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2v3Zm35-72h18v18a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1H76a1 1 0 1 0 0 2ZM10 94h18a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1V76a1 1 0 1 1 2 0v18Zm65 1a1 1 0 0 1 1-1h18V76a1 1 0 1 1 2 0v19a1 1 0 0 1-1 1H76a1 1 0 0 1-1-1ZM56 24a4 4 0 0 0-4-4H25a4 4 0 0 0-4 4v27a4 4 0 0 0 4 4h27a4 4 0 0 0 4-4V24Zm-31-2h27a2 2 0 0 1 2 2v27a2 2 0 0 1-2 2H25a2 2 0 0 1-2-2V24a2 2 0 0 1 2-2Zm56 37a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H64a4 4 0 0 1-4-4V63a4 4 0 0 1 4-4h17Zm0 2H64a2 2 0 0 0-2 2v17a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V63a2 2 0 0 0-2-2Z",
    fill: "currentColor"
  }));
};

var SvgQrCode24X24 = function SvgQrCode24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -qr-code",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2h3.5a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V2Zm10 3.5c0-.828-.768-1.5-1.714-1.5H5.714C4.768 4 4 4.672 4 5.5v5c0 .828.768 1.5 1.714 1.5h4.572c.947 0 1.714-.672 1.714-1.5v-5ZM5.6 5h4.8c.331 0 .6.224.6.5v5c0 .276-.269.5-.6.5H5.6c-.331 0-.6-.224-.6-.5v-5c0-.276.269-.5.6-.5Zm8.4-.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4Zm4 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm-8 12a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1Zm9.25-6.5c.966 0 1.75.784 1.75 1.75v3.5A1.75 1.75 0 0 1 19.25 20h-3.5A1.75 1.75 0 0 1 14 18.25v-3.5c0-.966.784-1.75 1.75-1.75h3.5Zm.125 1h-3.75a.625.625 0 0 0-.625.625v3.75c0 .345.28.625.625.625h3.75c.345 0 .625-.28.625-.625v-3.75a.625.625 0 0 0-.625-.625ZM18.5 2H22v3.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1ZM2 22h3.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0V22Zm16.5 0H22v-3.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1 0-1Z",
    fill: "currentColor"
  }));
};

var SvgRadio24X24 = function SvgRadio24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -radio",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z",
    fill: "currentColor"
  }));
};

var SvgRadioFilled24X24 = function SvgRadioFilled24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -radio-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-1a9 9 0 1 1 0-18 9 9 0 0 1 0 18z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  })));
};

var SvgReceipt104X104 = function SvgReceipt104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -receipt",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.34.55c.82-.624 1.845-.722 2.735-.27l8.73 4.43 6.777-4.3a2.53 2.53 0 0 1 2.763 0l6.637 4.21L50.618.41a2.53 2.53 0 0 1 2.764 0l6.636 4.21L66.655.41a2.53 2.53 0 0 1 2.763 0l6.778 4.3L84.925.28c.89-.452 1.915-.354 2.735.27.824.628 1.34 1.714 1.34 2.902v82.544c0 3.272-.002 6.074-.26 8.313-.28 2.416-.907 4.69-2.484 6.523-1.571 1.826-3.507 2.545-5.563 2.866-1.915.299-4.314.302-7.132.302H30.439c-2.818 0-5.217-.003-7.132-.302-2.056-.321-3.992-1.04-5.563-2.866-1.577-1.834-2.204-4.107-2.483-6.523-.26-2.24-.261-5.04-.261-8.313V3.452c0-1.188.516-2.274 1.34-2.902Zm1.95 1.991a.809.809 0 0 0-.851.07c-.255.185-.409.501-.409.841v82.313c0 3.439 0 6.118.242 8.205.246 2.127.757 3.79 1.88 5.096 1.127 1.311 2.57 1.911 4.415 2.2 1.801.281 4.111.281 7.063.281H73.37c2.952 0 5.262 0 7.063-.281 1.845-.289 3.288-.889 4.415-2.2 1.124-1.306 1.634-2.969 1.88-5.096.242-2.087.242-4.767.242-8.205V3.452c0-.34-.154-.656-.408-.84a.809.809 0 0 0-.851-.071L76.1 7.418l-7.625-4.836a.808.808 0 0 0-.878 0l-7.58 4.807-7.579-4.807a.808.808 0 0 0-.877 0l-7.58 4.807-7.58-4.807a.808.808 0 0 0-.877 0L27.9 7.418l-9.61-4.877Zm33.656 32.845a1.215 1.215 0 0 1 1.673-.098c.469.403.507 1.078.102 1.526l-18.824 20.8c-.225.248-.56.395-.92.386a1.19 1.19 0 0 1-.895-.434l-7.843-9.706a1.057 1.057 0 0 1 .191-1.52 1.213 1.213 0 0 1 1.665.187l6.966 8.622 17.885-19.763ZM62 41a1 1 0 0 1 1-1h15a1 1 0 1 1 0 2H63a1 1 0 0 1-1-1Zm-9 13a1 1 0 1 0 0 2h25a1 1 0 1 0 0-2H53ZM25 69a1 1 0 0 1 1-1h52a1 1 0 1 1 0 2H26a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  }));
};

var SvgReceipt16X16 = function SvgReceipt16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -receipt",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.588.145a.92.92 0 0 0-.859-.07l-1.385.593-1.043-.56a.92.92 0 0 0-.868 0l-1 .536-1-.535a.92.92 0 0 0-.867 0l-1 .535L5.568.11a.92.92 0 0 0-.868 0l-1.043.56L2.27.073a.92.92 0 0 0-.859.071.892.892 0 0 0-.412.75v12.02c0 .483 0 .931.05 1.297.055.405.187.84.552 1.198.364.358.806.487 1.217.541.372.05.827.049 1.319.049h7.724c.492 0 .947 0 1.32-.049.41-.054.852-.183 1.216-.54.365-.359.497-.794.552-1.2.05-.365.05-.813.05-1.295V.896a.892.892 0 0 0-.412-.75ZM2.055 12.861V1.118l1.587.68a.146.146 0 0 0 .127-.005l1.364-.73 1.364.73a.147.147 0 0 0 .139 0L8 1.063l1.364.73a.147.147 0 0 0 .139 0l1.364-.73 1.364.73c.04.021.086.023.127.006l1.587-.68V12.86c0 .533 0 .918-.04 1.211-.04.289-.116.467-.25.6-.136.132-.318.207-.614.246-.299.04-.691.04-1.234.04H4.193c-.543 0-.935 0-1.234-.04-.296-.04-.478-.114-.613-.247-.135-.132-.21-.31-.25-.599-.04-.293-.04-.678-.04-1.21ZM7.831 5.12a.518.518 0 0 0-.706.042l-2.427 2.62-.805-.974a.517.517 0 0 0-.702-.08.461.461 0 0 0-.084.67l1.177 1.421c.092.111.23.178.379.182a.512.512 0 0 0 .388-.161L7.875 5.79a.46.46 0 0 0-.044-.672ZM10.5 5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2ZM8 8.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM3.5 11a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z",
    fill: "currentColor"
  }));
};

var SvgReceipt24X24 = function SvgReceipt24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -receipt",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1.143c0-.386-.189-.745-.503-.956a1.085 1.085 0 0 0-1.053-.092l-2.115.95L16.715.14a1.084 1.084 0 0 0-1.064 0l-1.56.875L12.533.14a1.084 1.084 0 0 0-1.064 0l-1.56.875L8.35.14a1.084 1.084 0 0 0-1.064 0l-1.614.905-2.115-.95a1.085 1.085 0 0 0-1.053.092C2.189.397 2 .757 2 1.143v18.356c0 .748 0 1.42.07 1.963.079.593.259 1.202.744 1.701.485.499 1.077.684 1.654.764C4.996 24 5.649 24 6.376 24h11.248c.727 0 1.38 0 1.908-.073.578-.08 1.17-.265 1.654-.764.485-.499.666-1.108.743-1.701.071-.544.071-1.215.071-1.963V1.143Zm-5.817 0 2.091 1.174 2.615-1.174v18.286c0 1.616 0 2.424-.488 2.926-.488.502-1.274.502-2.845.502H6.444c-1.57 0-2.357 0-2.845-.502s-.488-1.31-.488-2.926V1.143l2.615 1.174 2.091-1.174 2.091 1.174L12 1.143l2.091 1.174 2.092-1.174ZM11.797 7.35a.6.6 0 0 1 .053.847l-4.235 4.8a.6.6 0 0 1-.922-.025l-1.764-2.24a.6.6 0 1 1 .942-.743l1.32 1.675 3.76-4.26a.6.6 0 0 1 .846-.054Zm6.77 1.45h-3.566A.6.6 0 1 0 15 10h3.566a.6.6 0 1 0 0-1.199ZM5.455 15.6c-.362 0-.655.269-.655.6 0 .332.293.6.655.6h13.09c.362 0 .655-.268.655-.6 0-.331-.293-.6-.654-.6H5.455Zm6.544-3a.6.6 0 0 1 .6-.6h6a.6.6 0 1 1 0 1.2h-6a.6.6 0 0 1-.6-.6Z",
    fill: "currentColor"
  }));
};

var SvgReceipt64X64 = function SvgReceipt64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -receipt",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.795.169A1.96 1.96 0 0 0 6.91.33 2.06 2.06 0 0 0 6 2.048v50.95c0 2.015.002 3.732.183 5.102.195 1.476.631 2.855 1.726 3.967 1.093 1.11 2.444 1.55 3.889 1.748 1.345.183 3.031.185 5.017.185h30.37c1.985 0 3.672-.002 5.017-.185 1.445-.198 2.796-.638 3.889-1.748 1.095-1.112 1.53-2.491 1.726-3.967.181-1.37.183-3.087.183-5.103V2.047A2.06 2.06 0 0 0 57.09.33 1.96 1.96 0 0 0 55.204.17l-6.167 2.734L44.246.247a1.959 1.959 0 0 0-1.904 0l-4.695 2.602L32.952.247a1.959 1.959 0 0 0-1.904 0l-4.695 2.602L21.658.247a1.959 1.959 0 0 0-1.904 0l-4.792 2.656L8.795.17Zm-1.34 1.04a1 1 0 0 1 .95-.075l6.604 2.928 5.212-2.889a1 1 0 0 1 .97 0l5.162 2.861 5.162-2.86a1 1 0 0 1 .97 0l5.162 2.86 5.162-2.86a1 1 0 0 1 .97 0l5.212 2.888 6.604-2.928A1 1 0 0 1 57 2.048v50.835c0 2.093 0 3.764-.173 5.074-.18 1.353-.56 2.471-1.432 3.358-.876.89-1.983 1.278-3.322 1.461-1.293.177-2.94.177-4.998.177h-30.15c-2.058 0-3.705 0-4.998-.177-1.34-.183-2.447-.572-3.322-1.46-.873-.888-1.253-2.006-1.432-3.359C7 56.647 7 54.976 7 52.883V2.048a1 1 0 0 1 .455-.838ZM29.983 20.2a.572.572 0 0 1 .816-.052c.245.219.27.603.052.854L19.674 33.8a.576.576 0 0 1-.889-.026l-4.657-5.973a.611.611 0 0 1 .098-.85.572.572 0 0 1 .813.1l4.226 5.421L29.983 20.2ZM39.5 24a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1h-12ZM33 33.5a.5.5 0 0 1 .5-.5h18a.5.5 0 0 1 0 1h-18a.5.5 0 0 1-.5-.5ZM14.5 42a.5.5 0 0 0 0 1h37a.5.5 0 0 0 0-1h-37Z",
    fill: "currentColor"
  }));
};

var SvgRefresh104X104 = function SvgRefresh104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -refresh",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M102.264 51.58a1 1 0 0 1 1.472 1.354L89.118 68.822c-.009.01-.02.017-.03.023a.155.155 0 0 0-.026.018 1 1 0 0 1-.216.156c-.033.017-.063.034-.097.048a.973.973 0 0 1-.307.07c-.014 0-.025.008-.038.008h-.019l-.002.001a.983.983 0 0 1-.331-.058c-.009-.003-.015-.01-.023-.013a.717.717 0 0 1-.142-.08l-.04-.028a1.16 1.16 0 0 0-.051-.032c-.036-.02-.071-.042-.1-.07l-.01-.005c-.003-.002-.007-.004-.01-.008L76.32 57.497a.999.999 0 1 1 1.414-1.414l10.182 10.181c4.112-13.699.365-30.747-9.065-40.315C67.46 14.304 49.528 11.632 35.24 19.452a1 1 0 1 1-.96-1.755c15.07-8.248 33.986-5.43 45.999 6.851 9.35 9.486 13.39 25.952 10.197 39.845l11.789-12.813zM26.891 78.182c11.314 11.465 29.12 14.136 43.3 6.493a1 1 0 1 1 .949 1.76A38.291 38.291 0 0 1 52.958 91c-10.1 0-20.106-3.93-27.49-11.414-9.599-9.734-13.817-26.37-10.588-40.166L1.707 52.59a.997.997 0 0 1-1.414 0 .998.998 0 0 1 0-1.414l15.888-15.883a.265.265 0 0 1 .062-.043.386.386 0 0 0 .045-.027l.01-.008c.063-.049.124-.096.196-.127.026-.01.053-.016.08-.022a.847.847 0 0 0 .044-.01.98.98 0 0 1 .252-.05.07.07 0 0 0 .02-.003c.006-.001.012-.003.02-.003.03 0 .06.01.09.018a.505.505 0 0 0 .122.023.35.35 0 0 1 .097.016c.008.002.014.007.02.011.005.004.01.008.017.01.049.02.09.048.133.077a2.22 2.22 0 0 0 .07.046c.046.029.091.058.13.096.005.005.011.01.017.013.006.004.013.007.018.013l11.54 12.539a1 1 0 1 1-1.473 1.353L17.333 37.96c-3.986 13.5-.039 30.49 9.558 40.222z",
    clipRule: "evenodd"
  }));
};

var SvgRefresh16X16 = function SvgRefresh16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -refresh",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.132 7.677a.509.509 0 0 1 .707-.03.485.485 0 0 1 .03.694l-2.15 2.292c-.01.011-.023.019-.036.027l-.025.016a.496.496 0 0 1-.297.116h-.01a.487.487 0 0 1-.165-.028l-.008-.005a.306.306 0 0 1-.07-.039l-.023-.014a.45.45 0 0 0-.029-.018c-.017-.01-.034-.02-.05-.034l-.003-.003a.02.02 0 0 1-.005-.003l-1.67-1.638a.483.483 0 0 1 0-.694.507.507 0 0 1 .707 0l1.05 1.031c.316-1.741-.218-3.727-1.387-4.89-1.566-1.57-4.03-1.93-5.993-.877a.504.504 0 0 1-.68-.195.486.486 0 0 1 .2-.665c2.354-1.264 5.31-.832 7.186 1.05 1.202 1.196 1.843 3.118 1.75 4.942l.97-1.035zM4.559 11.561c1.554 1.546 4.002 1.905 5.949.875a.503.503 0 0 1 .677.2.484.484 0 0 1-.202.663c-.892.471-1.87.7-2.842.7a6.096 6.096 0 0 1-4.294-1.75c-1.249-1.243-1.908-3.22-1.798-5.066L.854 8.355a.504.504 0 0 1-.707 0 .483.483 0 0 1 0-.693L2.483 5.37c.01-.01.023-.017.035-.023l.024-.015.017-.013a.362.362 0 0 1 .079-.049c.016-.007.034-.01.051-.015a.532.532 0 0 0 .046-.01.39.39 0 0 1 .093-.015l.01-.002.009-.002c.014 0 .028.005.042.009a.234.234 0 0 0 .062.011.182.182 0 0 1 .051.008l.01.005a.034.034 0 0 0 .009.005c.024.01.045.024.066.039l.016.01.014.009c.025.015.05.03.071.051l.008.006c.003.002.006.003.008.006l1.698 1.809c.187.199.174.509-.03.692a.503.503 0 0 1-.706-.028L3.104 6.726c-.266 1.698.297 3.683 1.455 4.835z",
    clipRule: "evenodd"
  }));
};

var SvgRefresh24X24 = function SvgRefresh24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    role: "img",
    className: "icon -refresh"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M4.074 7.94h.04a.504.504 0 0 1 .08.012c.013.003.028.007.041.012.005 0 .01.002.014.003l.032.014a.5.5 0 0 1 .033.015l-.065-.029a.5.5 0 0 1 .128.068l.007.006c.032.022.06.049.084.078l2.585 2.804a.498.498 0 0 1-.03.705.5.5 0 0 1-.706-.03L4.318 9.432c-.64 2.841.243 6.31 2.216 8.307a7.968 7.968 0 0 0 9.438 1.413.498.498 0 1 1 .475.878 8.97 8.97 0 0 1-10.625-1.59c-2.03-2.055-3.02-5.427-2.624-8.413L.854 12.366a.5.5 0 0 1-.708 0 .498.498 0 0 1 0-.706L3.73 8.086l.013-.012a.498.498 0 0 1 .037-.031l-.05.043a.502.502 0 0 1 .134-.096l.023-.01a.446.446 0 0 1 .06-.022l.025-.005a.42.42 0 0 1 .066-.012h.018l.019-.002zm14.498-2.354c1.982 2.007 2.922 5.304 2.545 8.276l2.015-2.187a.5.5 0 0 1 .706-.03.498.498 0 0 1 .03.705l-3.295 3.575-.032.031a.498.498 0 0 1-.02.017l.052-.048a.5.5 0 0 1-.104.086l-.017.01a.362.362 0 0 1-.058.029c-.007.001-.015.004-.022.007a.373.373 0 0 1-.062.018l-.02.003a.401.401 0 0 1-.065.008h-.021c-.022 0-.043-.001-.064-.004l-.029-.005a.39.39 0 0 1-.053-.013l-.02-.006-.014-.005a.495.495 0 0 1-.048-.022l.063.027a.503.503 0 0 1-.188-.118l-2.56-2.555a.498.498 0 0 1 0-.705.5.5 0 0 1 .707 0l1.964 1.959c.684-2.88-.142-6.368-2.104-8.354a7.967 7.967 0 0 0-9.506-1.412.498.498 0 1 1-.48-.875 8.968 8.968 0 0 1 10.7 1.588z"
  }));
};

var SvgRefreshWeb104X104 = function SvgRefreshWeb104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -refresh-web",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M66.273 16.084 56.089 26.266a1 1 0 0 0 1.414 1.414l11.358-11.356c.005-.005.007-.013.013-.02.035-.036.06-.08.085-.124l.03-.05a1.27 1.27 0 0 1 .032-.048.529.529 0 0 0 .07-.124.028.028 0 0 0 .006-.01.424.424 0 0 0 .02-.116c0-.021.002-.042.005-.063l.015-.066c.009-.035.018-.07.017-.107 0-.007-.005-.013-.005-.02a.797.797 0 0 0-.044-.209l-.01-.03c-.005-.018-.009-.037-.012-.055-.006-.03-.012-.059-.025-.086a.979.979 0 0 0-.18-.25.172.172 0 0 1-.021-.03.14.14 0 0 0-.026-.035l-.005-.004v-.001L52.941.264a1 1 0 0 0-1.356 1.472L64.4 13.524c-13.894-3.192-30.363.848-39.85 10.198C12.267 35.735 9.45 54.65 17.698 69.72a1 1 0 1 0 1.754-.96c-7.82-14.287-5.149-32.22 6.499-43.612 9.568-9.43 26.617-13.178 40.322-9.065zM79.98 78.533c12.1-11.934 14.917-30.715 6.853-45.673a1 1 0 0 0-1.761.949c7.645 14.18 4.973 31.986-6.497 43.3-9.738 9.598-26.735 13.545-40.241 9.558l11.26-10.36a1 1 0 1 0-1.354-1.47L35.695 86.376a.057.057 0 0 0-.008.01.21.21 0 0 0-.005.007.074.074 0 0 1-.013.018.713.713 0 0 0-.093.124l-.026.04-.024.038c-.029.042-.056.083-.075.13-.002.007-.006.012-.01.018a.063.063 0 0 0-.012.02.34.34 0 0 0-.016.098c-.001.02-.002.039-.006.059-.004.02-.01.039-.015.058a.342.342 0 0 0-.02.095c0 .008.002.015.004.023a.086.086 0 0 1 .004.019c.001.062.015.12.03.18l.008.033.012.05c.008.04.016.079.032.116.027.06.066.111.106.163l.02.026a.418.418 0 0 1 .03.05.295.295 0 0 0 .047.068l15.89 15.888a.993.993 0 0 0 .708.293.999.999 0 0 0 .707-1.707L39.817 89.142c3.071.717 6.281 1.07 9.526 1.07 11.332 0 23.071-4.223 30.637-11.68zM42.57 50.167c.148-8.735 2.216-16.075 5.245-19.716-9.262 1.961-16.284 9.992-16.741 19.716H42.57zm19.274 0H73.34c-.457-9.724-7.48-17.755-16.74-19.716 3.028 3.641 5.096 10.981 5.244 19.716zm0 2c-.148 8.735-2.216 16.076-5.245 19.717 9.262-1.96 16.284-9.993 16.741-19.717H61.844zm-9.637 20.181c3.518 0 7.417-8.243 7.627-20.18H44.58c.211 11.937 4.109 20.18 7.627 20.18zm7.627-22.18c-.21-11.939-4.109-20.18-7.627-20.18s-7.416 8.241-7.627 20.18h15.254zm-17.264 2H31.074c.457 9.723 7.48 17.755 16.74 19.716-3.028-3.64-5.096-10.982-5.244-19.717zm32.821-1c0 12.781-10.4 23.18-23.184 23.18S29.023 63.95 29.023 51.168c0-12.782 10.4-23.18 23.184-23.18s23.184 10.398 23.184 23.18z",
    clipRule: "evenodd"
  }));
};

var SvgRefreshWeb16X16 = function SvgRefreshWeb16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -refresh-web",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.488 5.018a6.058 6.058 0 0 1-1.067 7.136c-1.173 1.16-2.993 1.817-4.75 1.817-.085 0-.17-.01-.255-.018a3.685 3.685 0 0 0-.16-.015l1.206 1.209A.501.501 0 0 1 8.11 16a.493.493 0 0 1-.352-.147l-2.33-2.336a.142.142 0 0 1-.024-.035l-.014-.024-.014-.018c-.019-.025-.037-.05-.05-.077-.008-.02-.012-.04-.016-.06l-.005-.024-.001-.003a.46.46 0 0 1-.018-.102l-.002-.01-.002-.011c0-.016.004-.031.009-.046l.008-.031a.278.278 0 0 0 .003-.032.168.168 0 0 1 .008-.046l.005-.01a.059.059 0 0 0 .006-.01c.01-.024.026-.047.04-.07l.01-.012.008-.014a.379.379 0 0 1 .057-.079l.006-.008 1.48-1.365A3.753 3.753 0 0 1 4.35 7.878a3.762 3.762 0 0 1 3.752-3.762c.041 0 .08.005.12.01.03.005.06.009.09.01a.519.519 0 0 1 .11-.17l1.049-1.05c-1.772-.316-3.79.217-4.972 1.387a5.044 5.044 0 0 0-.892 5.993.5.5 0 0 1-.874.48A6.047 6.047 0 0 1 3.799 3.59c1.216-1.202 3.17-1.843 5.025-1.751L7.772.869a.499.499 0 1 1 .675-.737l2.328 2.148.002.002c.005.004.009.01.012.016l.01.013c.036.039.07.08.092.128.007.015.01.031.013.047l.005.025.005.016c.01.034.021.067.022.102l.001.004.002.007a.217.217 0 0 1-.009.052.328.328 0 0 0-.007.036c-.002.01-.003.02-.003.031-.002.019-.003.038-.01.057l-.003.004a.026.026 0 0 0-.003.005.252.252 0 0 1-.03.055.645.645 0 0 0-.028.046c-.015.024-.03.048-.048.069l-.001.002c-.001.002-.002.004-.005.006L9.43 4.37a3.76 3.76 0 0 1 2.424 3.507 3.761 3.761 0 0 1-3.752 3.762l-.01-.001-.01-.001a.49.49 0 0 1-.125.197l-1.151 1.063c1.727.266 3.744-.297 4.916-1.456a5.049 5.049 0 0 0 .89-5.95.502.502 0 0 1 .202-.677.497.497 0 0 1 .675.203zm-4.637 2.36c-.092-1.482-.571-2.262-.75-2.262-.178 0-.657.78-.75 2.262h1.5zm-2.14-1.87c-.196.544-.316 1.194-.356 1.87h-.957a2.754 2.754 0 0 1 1.312-1.87zm-1.313 2.87h.957c.04.677.159 1.326.355 1.87a2.758 2.758 0 0 1-1.312-1.87zm4.45-1h.957a2.752 2.752 0 0 0-1.313-1.87c.196.544.316 1.194.356 1.87zm-.356 2.87c.197-.544.316-1.193.356-1.87h.957a2.756 2.756 0 0 1-1.313 1.87zm-2.14-1.87h1.5c-.093 1.482-.572 2.262-.75 2.262-.18 0-.658-.78-.75-2.262z",
    clipRule: "evenodd"
  }));
};

var SvgRefreshWeb24X24 = function SvgRefreshWeb24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -refresh-web",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M7.557 12.313h2.008c.052 1.384.32 2.731.793 3.68a4.492 4.492 0 0 1-2.801-3.68m2.8-4.68c-.473.948-.74 2.295-.792 3.68H7.557a4.49 4.49 0 0 1 2.8-3.68m6.09 3.68h-2.009c-.052-1.386-.32-2.733-.792-3.68a4.491 4.491 0 0 1 2.8 3.68m-2.8 4.68c.473-.949.74-2.296.792-3.68h2.009a4.493 4.493 0 0 1-2.8 3.68M12.001 7.31c.553 0 1.33 1.55 1.428 4.002h-2.856c.097-2.451.874-4.001 1.428-4.001m-1.428 5.002h2.856c-.097 2.451-.875 4-1.428 4-.554 0-1.33-1.548-1.428-4m7.873 5.865c2.811-2.777 3.465-7.145 1.592-10.625a.5.5 0 0 0-.879.475c1.664 3.091 1.083 6.972-1.414 9.438-1.976 1.95-5.463 2.83-8.299 2.2l2.152-1.983a.493.493 0 0 0 .156-.382c.082.004.164.012.247.012a5.503 5.503 0 0 0 5.494-5.5 5.508 5.508 0 0 0-3.937-5.274l2.386-2.39.005-.008c.025-.026.041-.059.06-.09.016-.028.036-.052.048-.08l.005-.01c.01-.029.007-.059.012-.088.005-.03.017-.058.016-.088l-.002-.01c-.002-.042-.015-.08-.026-.118-.008-.024-.009-.05-.019-.073a.546.546 0 0 0-.093-.127c-.009-.009-.012-.02-.02-.03l-.003-.002L12.351.132a.499.499 0 1 0-.675.736l2.217 2.042c-3.002-.389-6.318.55-8.31 2.517a8.993 8.993 0 0 0-1.593 10.7.499.499 0 1 0 .876-.48A7.99 7.99 0 0 1 6.283 6.14c1.983-1.957 5.435-2.779 8.345-2.086l-1.946 1.948a.503.503 0 0 0-.143.335 5.602 5.602 0 0 0-.537-.027c-3.03 0-5.494 2.468-5.494 5.502a5.504 5.504 0 0 0 4.193 5.34L8.1 19.548c-.006.005-.008.013-.014.018-.023.024-.04.053-.057.08-.02.028-.039.055-.052.086-.002.007-.008.012-.01.018-.01.026-.007.052-.011.08-.005.024-.017.05-.018.076 0 .007.004.013.004.021.001.036.011.07.019.105.008.03.011.057.022.084.016.035.04.064.063.095.014.02.022.041.039.058l3.577 3.583a.498.498 0 0 0 .706 0 .499.499 0 0 0 0-.707l-2.348-2.35c.438.057.882.093 1.33.093 2.625 0 5.345-.98 7.098-2.71"
  }));
};

var SvgRelationship104X104 = function SvgRelationship104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -relationship",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M101.84 35.66a7.34 7.34 0 0 1 2.156 5.218 7.335 7.335 0 0 1-2.155 5.217l-5.925 5.945 1.678 1.683c3.08 3.159 3.08 8.287.007 11.439a8.118 8.118 0 0 1-6.634 2.414c2.16 3.181 1.84 7.56-.97 10.38a8.128 8.128 0 0 1-10.469.89c.031.342.05.69.037 1.04a8.128 8.128 0 0 1-2.583 5.694 8.116 8.116 0 0 1-5.563 2.193 8.147 8.147 0 0 1-4.004-1.057c.053.415.084.835.073 1.262a8.13 8.13 0 0 1-2.532 5.718 8.114 8.114 0 0 1-5.616 2.253 8.116 8.116 0 0 1-5.612-2.248l-1.535-1.543-1.522 1.525a8.1 8.1 0 0 1-11.337.01c-1.925-1.865-2.726-4.457-2.407-6.933a8.104 8.104 0 0 1-9.618-1.181 8.18 8.18 0 0 1-2.493-6.736 8.116 8.116 0 0 1-10.186-.877c-2.896-2.782-3.29-7.204-1.139-10.44-.269.029-.54.044-.81.044a8.103 8.103 0 0 1-5.63-2.273c-3.247-3.118-3.36-8.304-.252-11.56l1.682-1.687-6.33-6.35c-2.868-2.877-2.868-7.558 0-10.435l24.148-24.226c.197-.197.464-.322.745-.293a1 1 0 0 1 .72.348c.98 1.142 4.013 4.102 6.257 4.102 3.191 0 4.003-.821 5.962-2.806l.002-.002.48-.485c4.17-4.186 10.115-3.96 15.025.457C58.995 9.423 62.026 8 66.072 8h7.76c.265 0 .52.105.707.294L101.84 35.66zm-7.338 14.96L73.585 29.631c-2.454-2.461-5.007-3.69-7.59-3.69-2.71 0-5.453 1.354-8.15 4.06l-1.487 1.473c-1.187 1.14-2.76 1.78-4.388 1.71a6.103 6.103 0 0 1-4.309-1.902c-2.283-2.392-2.283-6.14-.015-8.515l5.06-5.066a69.505 69.505 0 0 1 3.431-3.25.124.124 0 0 1 .021-.014.103.103 0 0 0 .024-.016.043.043 0 0 0 .008-.011.047.047 0 0 1 .006-.01c3.815-3.326 6.411-4.394 9.876-4.394h7.346l27.008 27.072a5.342 5.342 0 0 1 1.57 3.8 5.343 5.343 0 0 1-1.569 3.799l-5.925 5.943zm1.67 4.513c2.318 2.378 2.318 6.248 0 8.626-2.373 2.433-6.275 2.475-8.69.105l-9.704-9.74a.994.994 0 0 0-.714-.292.996.996 0 0 0-.72.292 1.006 1.006 0 0 0 0 1.418L88.58 67.808c2.4 2.406 2.4 6.322.002 8.73a6.147 6.147 0 0 1-8.703.001l-2.517-2.525-.009-.012-8.627-8.655a.993.993 0 0 0-.707-.294 1.004 1.004 0 0 0-.708 1.712l8.62 8.649a6.135 6.135 0 0 1 1.635 4.403 6.14 6.14 0 0 1-1.949 4.299c-2.352 2.202-6.039 2.204-8.369.026l-4.417-4.431-.085-.087-.552-.553a.999.999 0 0 0-1.414 0 1.004 1.004 0 0 0 0 1.418l.603.606 2.415 2.427a6.14 6.14 0 0 1 1.691 4.406 6.139 6.139 0 0 1-1.91 4.315c-2.375 2.265-6.097 2.266-8.455.022l-1.538-1.547a8.12 8.12 0 0 0 1.966-5.316 8.13 8.13 0 0 0-2.388-5.78 8.087 8.087 0 0 0-5.763-2.395H47.4c-.68 0-1.344.093-1.988.254.986-2.933.272-6.306-2.114-8.565a8.127 8.127 0 0 0-7.77-1.931c.237-.772.36-1.585.36-2.416a8.134 8.134 0 0 0-2.389-5.78 8.133 8.133 0 0 0-7.937-2.09c.838-2.718.245-5.802-1.83-8.021-3.077-3.287-8.245-3.454-11.522-.37-.126.118-.248.24-.345.345l-1.97 1.977-6.33-6.348a5.393 5.393 0 0 1 0-7.599l23.414-23.488c1.35 1.386 4.267 4.007 7.043 4.007 4.026 0 5.363-1.354 7.386-3.403l.473-.477c3.358-3.371 8.023-3.196 12.101.364a83.033 83.033 0 0 0-2.69 2.596l-5.074 5.082a8.175 8.175 0 0 0 0 11.305 8.09 8.09 0 0 0 5.71 2.52c2.17.03 4.241-.757 5.825-2.277l1.503-1.49c4.47-4.482 8.693-4.605 12.916-.373L93.68 52.632a.97.97 0 0 0 .232.232l2.26 2.269zM40.722 92.25a6.116 6.116 0 0 0 8.547 0l1.68-1.683a.987.987 0 0 1 .275-.804.988.988 0 0 1 .78-.28 6.123 6.123 0 0 0 1.547-4.081c0-1.65-.64-3.198-1.802-4.363a6.104 6.104 0 0 0-4.349-1.807c-1.6 0-3.104.614-4.254 1.721l-2.614 2.622c-2.31 2.437-2.237 6.322.19 8.675zm-3.563-8.127a6.137 6.137 0 0 1-8.473 0c-2.459-2.344-2.559-6.256-.24-8.703l4.352-4.367.69-.692a6.146 6.146 0 0 1 8.435.011 6.192 6.192 0 0 1 .258 8.713l-.439.44a1.21 1.21 0 0 1-.05.046c-.02.017-.039.033-.057.051l-2.5 2.51a.346.346 0 0 0-.032.036l-.015.018a.47.47 0 0 1-.017.018l-1.912 1.919zm-21.147-7.609a6.122 6.122 0 0 0 8.507.001l7.566-7.583a6.138 6.138 0 0 0 1.801-4.363 6.142 6.142 0 0 0-1.803-4.362 6.121 6.121 0 0 0-4.348-1.803c-1.574 0-3.146.6-4.344 1.8l-.013.012-.005.005-5.036 5.059c-.014.014-.03.027-.045.04a.819.819 0 0 0-.035.03l-2.45 2.457c-2.329 2.442-2.244 6.356.205 8.707zm-7.58-12.667c-2.45-2.353-2.535-6.266-.204-8.707l2.37-2.38.003-.002.002-.002.001-.002L13.3 50.05a6.12 6.12 0 0 1 4.484-1.946c1.641 0 3.28.654 4.49 1.946 2.318 2.48 2.194 6.392-.277 8.719l-.025.022-5.083 5.098a6.123 6.123 0 0 1-8.455-.041z",
    clipRule: "evenodd"
  }));
};

var SvgRelationship16X16 = function SvgRelationship16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -relationship",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.565 1.346 4.015 4.01c.56.559.56 1.468 0 2.028l-.622.621c.586.602.585 1.571.002 2.17-.204.208-.454.34-.717.409.029.12.05.243.05.37 0 .415-.162.805-.455 1.098-.302.303-.7.454-1.098.454-.131 0-.261-.023-.389-.057a1.54 1.54 0 0 1-1.494 1.145c-.057 0-.112-.014-.167-.028a1.256 1.256 0 0 0-.092-.02 1.545 1.545 0 0 1-2.572.83 1.56 1.56 0 0 1-1.057.424c-.388 0-.775-.147-1.076-.439-.23-.22-.38-.501-.441-.81a1.269 1.269 0 0 0-.093.022.683.683 0 0 1-.167.028 1.55 1.55 0 0 1-1.496-1.155 1.542 1.542 0 0 1-1.435-.387 1.539 1.539 0 0 1-.478-1.086 1.517 1.517 0 0 1 .053-.411 1.523 1.523 0 0 1-.69-.36 1.547 1.547 0 0 1-.047-2.192l.003-.004-.681-.681A1.42 1.42 0 0 1 0 6.314c0-.384.149-.744.421-1.016l3.551-3.55a.503.503 0 0 1 .733.028c.209.241.532.478.652.478.321 0 .356-.035.625-.305l.073-.075c.683-.682 1.655-.716 2.475-.124.482-.352.947-.55 1.54-.55h1.141a.5.5 0 0 1 .354.146zm3.308 5.331-.622.622-2.826-2.826c-.43-.43-.895-.644-1.365-.644-.489 0-.984.233-1.448.697l-.214.212c-.107.1-.233.14-.394.153a.554.554 0 0 1-.394-.926l.744-.741c.881-.883 1.228-1.025 1.716-1.025h.934l3.869 3.864a.436.436 0 0 1 0 .614zm-.628 2.8a.55.55 0 0 1-.776.011l-1.427-1.427a.502.502 0 0 0-.711.707l1.8 1.798a.549.549 0 0 1 0 .78.552.552 0 0 1-.78 0l-.371-.37-.001-.002-1.269-1.269a.498.498 0 0 0-.707 0 .5.5 0 0 0 0 .707l1.258 1.258a.548.548 0 0 1-.027.777.55.55 0 0 1-.741.013l-.444-.443-.218-.22H9.83l-.081-.08a.5.5 0 0 0-.707.707l.08.079.001.002.357.356a.552.552 0 0 1-.769.79l-.026-.025a1.534 1.534 0 0 0-1.239-2.27c0-.008 0-.016.002-.023 0-.01.002-.02.001-.029a1.536 1.536 0 0 0-.486-1.082 1.54 1.54 0 0 0-.979-.42 1.546 1.546 0 0 0-.454-1.057c-.273-.272-.641-.404-1.014-.423a1.542 1.542 0 0 0-.415-1.05c-.585-.624-1.569-.656-2.252-.012l-.04.04-.682-.683a.429.429 0 0 1 .001-.612l3.203-3.203c.269.222.64.452 1.026.452.738 0 1.015-.28 1.405-.673.269-.27.616-.306.967-.14l-.04.037c-.014.012-.027.024-.042.04l-.751.749a1.545 1.545 0 0 0-.001 2.143c.287.3.673.47 1.087.479.415.049.808-.143 1.113-.436l.222-.219c.604-.602.997-.458 1.401-.055l3.149 3.148.029.033.01.01a.424.424 0 0 0 .022.02l.317.315a.556.556 0 0 1 0 .771zM6.42 13.255a.55.55 0 0 0 .934.389l.168-.168a.482.482 0 0 1 .116-.195.472.472 0 0 1 .14-.092.542.542 0 0 0 .098-.296.549.549 0 0 0-.941-.39l-.368.368a.542.542 0 0 0-.147.384zm-1.604-.805a.548.548 0 0 1-.029-.77l.384-.385.353-.352a.553.553 0 0 1 .926.39.548.548 0 0 1-.147.389l-.073.073h-.001l-.002.002-.372.372-.002.002-.001.002-.277.276a.55.55 0 0 1-.759 0zm-1.863-1.115a.552.552 0 0 0 .763.001l1.107-1.105a.552.552 0 0 0-.78-.78l-.135.134-.607.61h-.002l-.005.003-.366.367a.541.541 0 0 0-.145.384.546.546 0 0 0 .17.386zM1.813 8.71l.349-.348h.001l.001-.002.428-.43a.546.546 0 0 1 .377-.148h.018a.555.555 0 0 1 .534.57.552.552 0 0 1-.186.394l-.137.138-.602.602a.553.553 0 0 1-.783-.776z",
    clipRule: "evenodd"
  }));
};

var SvgRelationship24X24 = function SvgRelationship24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -relationship",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.434 8.196a1.876 1.876 0 0 1 0 2.69l-1.142 1.122.185.181c.799.806.799 2.11.003 2.91-.347.35-.79.543-1.248.599.299.747.144 1.63-.469 2.232a2.117 2.117 0 0 1-1.494.61 2.14 2.14 0 0 1-.806-.156 2.038 2.038 0 0 1-.641 1.239 2.124 2.124 0 0 1-1.442.556c-.212 0-.423-.039-.627-.1-.041.51-.261.982-.641 1.337a2.123 2.123 0 0 1-1.455.572c-.524 0-1.047-.19-1.455-.571l-.158-.155-.149.146a2.131 2.131 0 0 1-2.94.006 2.044 2.044 0 0 1-.628-1.326 2.128 2.128 0 0 1-.631.104c-.523 0-1.045-.19-1.451-.571a2.053 2.053 0 0 1-.642-1.247 2.127 2.127 0 0 1-2.218-.437 2.058 2.058 0 0 1-.51-2.248 2.109 2.109 0 0 1-1.199-.554 2.058 2.058 0 0 1-.066-2.938l.19-.186-1.233-1.214a1.873 1.873 0 0 1 0-2.689l5.445-5.357c.098-.097.236-.169.371-.143.139.005.27.066.361.17.288.328.87.813 1.203.813.605 0 .732-.126 1.149-.54l.002-.001.108-.108a2.5 2.5 0 0 1 1.913-.735c.581.034 1.15.275 1.672.685.763-.588 1.472-.892 2.383-.892h1.75c.133 0 .26.052.354.144l6.156 6.052Zm-.707 1.994-1.142 1.123-4.522-4.451c-.608-.597-1.253-.896-1.905-.896-.682 0-1.37.326-2.032.977l-.332.322a1.126 1.126 0 0 1-1.573-.034 1.076 1.076 0 0 1-.008-1.505l1.142-1.12c1.277-1.258 1.91-1.622 2.819-1.622h1.543l6.01 5.907a.907.907 0 0 1 0 1.298Zm-.962 4.221c-.429.431-1.133.44-1.569.021l-2.188-2.153a.488.488 0 0 0-.17-.108.506.506 0 0 0-.542.107.486.486 0 0 0 0 .695l2.76 2.713a1.083 1.083 0 0 1 0 1.548c-.21.208-.49.322-.787.322-.297 0-.577-.114-.787-.32l-.569-.56v-.001h-.001l-1.945-1.915a.503.503 0 0 0-.707 0 .486.486 0 0 0 0 .696l1.934 1.902a1.078 1.078 0 0 1-.054 1.546 1.125 1.125 0 0 1-1.506.012l-.735-.722-.28-.277h-.001l-.001-.001-.123-.121a.506.506 0 0 0-.707 0 .486.486 0 0 0 0 .695l.123.121v.001h.001l.552.544a1.08 1.08 0 0 1-.04 1.547 1.122 1.122 0 0 1-1.523.01l-.177-.175a2.058 2.058 0 0 0-.265-2.622 2.127 2.127 0 0 0-1.593-.597 2.052 2.052 0 0 0-.638-1.776 2.1 2.1 0 0 0-1.596-.56 2.054 2.054 0 0 0-.608-1.673 2.123 2.123 0 0 0-1.645-.593l.008-.055c.006-.03.01-.062.012-.094a2.046 2.046 0 0 0-.571-1.488 2.141 2.141 0 0 0-2.987-.093l-.019.018c-.027.026-.052.05-.064.064l-.25.246L1.274 10.1a.906.906 0 0 1 0-1.297l5.087-5.006c.38.343.979.776 1.586.776 1.022 0 1.391-.366 1.86-.83l.001-.002.106-.104c.324-.32.726-.474 1.144-.45.323.019.65.147.966.362-.123.115-.246.232-.376.36l-1.149 1.128a2.047 2.047 0 0 0 0 2.874 2.142 2.142 0 0 0 2.993.059l.339-.33c.901-.887 1.679-.914 2.525-.084l4.837 4.76a.337.337 0 0 0 .036.04.683.683 0 0 0 .041.036l.496.488c.426.429.425 1.1-.001 1.53ZM9.613 19.17a1.082 1.082 0 0 0 .036 1.537c.433.413 1.113.41 1.546 0l.312-.305a.469.469 0 0 1 .126-.24.485.485 0 0 1 .195-.114c.337-.43.323-1.042-.077-1.435a1.122 1.122 0 0 0-1.569-.002l-.569.56Zm-2.679-.262a1.075 1.075 0 0 1-.346-.765c-.008-.292.1-.57.296-.772l.878-.864.257-.251a1.125 1.125 0 0 1 1.522.004c.444.413.466 1.103.049 1.542l-.111.11a.027.027 0 0 1-.006.004l-.003.002-.567.559-.008.01-.429.421a1.125 1.125 0 0 1-1.532 0Zm-2.857-1.681c.43.405 1.107.405 1.538 0l1.702-1.673a1.084 1.084 0 0 0-.001-1.548 1.114 1.114 0 0 0-.786-.319c-.285 0-.57.107-.787.32l-.005.005-1.133 1.117a.053.053 0 0 1-.008.007l-.004.002-.003.002-.555.547a1.08 1.08 0 0 0 .042 1.54Zm-1.752-4.341.533-.524.002-.002h.001l.001-.002.001-.001.662-.653c.215-.197.488-.296.762-.296.296 0 .592.116.811.346.42.44.397 1.134-.051 1.547l-.007.007a.265.265 0 0 1-.004.004l-.17.167-.968.952c-.431.398-1.101.4-1.531-.005a1.082 1.082 0 0 1-.042-1.54Z",
    fill: "currentColor"
  }));
};

var SvgReport104X104 = function SvgReport104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -report",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.962.209C55.243-.872 60.399 2.347 61.858 7.48h3.09a9.763 9.763 0 0 1 6.53 2.105h14.534c3.86 0 6.988 3.153 6.988 7.043v80.326c0 3.891-3.129 7.045-6.988 7.045H17.988c-3.86 0-6.988-3.154-6.988-7.045V16.63c0-3.89 3.129-7.044 6.988-7.044h14.306c.048 0 .096.004.143.01a9.56 9.56 0 0 1 6.597-2.114h3.113C43.196 3.8 46.195.98 49.962.209Zm20.622 11.23a.998.998 0 0 1-.235-.2 7.78 7.78 0 0 0-5.33-1.76l-.048.002h-3.89a.994.994 0 0 1-.973-.801c-.909-4.513-5.274-7.427-9.752-6.511-3.254.666-5.798 3.23-6.46 6.51a.994.994 0 0 1-.971.802l-3.95-.002c-4.278-.26-7.955 3.024-8.213 7.337-.019.313-.019.626.002 1.002v4.6h42.478V17.77a7.93 7.93 0 0 0-2.658-6.33Zm15.428.146H73.385a9.844 9.844 0 0 1 1.84 6.233v5.6c0 .553-.444 1-.991 1H29.772a.996.996 0 0 1-.992-1l.002-5.538a9.676 9.676 0 0 1 0-1.186 9.845 9.845 0 0 1 1.787-5.109h-12.58c-2.764 0-5.005 2.258-5.005 5.044v80.326c0 2.787 2.24 5.045 5.004 5.045h68.024c2.763 0 5.004-2.258 5.004-5.045V16.63c0-2.786-2.24-5.044-5.004-5.044ZM74.35 45.404h-44.7a.996.996 0 0 1-.992-1c0-.553.444-1 .992-1h44.7c.548 0 .992.447.992 1 0 .552-.444 1-.992 1ZM29.65 64.07h44.7a.996.996 0 0 0 .992-1c0-.553-.444-1-.992-1h-44.7a.996.996 0 0 0-.992 1c0 .552.444 1 .992 1Zm44.7 18.666h-44.7a.996.996 0 0 1-.992-1c0-.553.444-1 .992-1h44.7c.548 0 .992.447.992 1 0 .552-.444 1-.992 1Z",
    fill: "currentColor"
  }));
};

var SvgReport16X16 = function SvgReport16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -report",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.624.038A1.898 1.898 0 0 1 9.725 1.1h.207a1.843 1.843 0 0 1 1.103.31h2.06c.776 0 1.405.622 1.405 1.39V14.61c0 .767-.63 1.39-1.405 1.39H2.905A1.398 1.398 0 0 1 1.5 14.61V2.8c0-.767.63-1.39 1.405-1.39h2.044a1.769 1.769 0 0 1 1.108-.31h.22A1.89 1.89 0 0 1 7.623.039Zm2.942 2.277a.82.82 0 0 0-.598-.216H9.36a.504.504 0 0 1-.495-.4.881.881 0 0 0-1.04-.681.878.878 0 0 0-.69.682.504.504 0 0 1-.495.4l-.613-.001a.803.803 0 0 0-.852.874v.324h5.651v-.348a.805.805 0 0 0-.26-.634Zm2.53.094H11.77c.052.18.075.37.065.564v.824c0 .276-.226.5-.505.5H4.67a.503.503 0 0 1-.505-.5v-.795a1.84 1.84 0 0 1 .065-.593H2.905a.392.392 0 0 0-.394.39v11.813c0 .213.177.389.394.389h10.19a.393.393 0 0 0 .394-.39V2.8a.392.392 0 0 0-.394-.39Zm-1.748 4.974H4.652a.503.503 0 0 1-.505-.5c0-.276.226-.5.505-.5h6.696c.28 0 .505.224.505.5s-.226.5-.505.5Zm-6.696 2.745h6.696c.28 0 .505-.224.505-.5s-.226-.5-.505-.5H4.652a.503.503 0 0 0-.505.5c0 .276.226.5.505.5Zm6.696 2.745H4.652a.503.503 0 0 1-.505-.5c0-.276.226-.5.505-.5h6.696c.28 0 .505.224.505.5s-.226.5-.505.5Z",
    fill: "currentColor"
  }));
};

var SvgReport24X24 = function SvgReport24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -report",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.555 2.046a2.236 2.236 0 0 1 2.516 1.347h.348a2.15 2.15 0 0 1 1.337.392h2.62c.897 0 1.624.728 1.624 1.626v14.963c0 .898-.727 1.626-1.624 1.626H5.624A1.625 1.625 0 0 1 4 20.374V5.411c0-.898.727-1.626 1.624-1.626h2.603c.38-.273.849-.422 1.342-.392h.361a2.233 2.233 0 0 1 1.625-1.347Zm3.732 2.644a1.157 1.157 0 0 0-.828-.297h-.756a.5.5 0 0 1-.49-.4 1.238 1.238 0 0 0-2.426 0 .5.5 0 0 1-.489.4H9.54a1.142 1.142 0 0 0-1.207 1.24v.542h7.337v-.567a1.16 1.16 0 0 0-.382-.918Zm3.09.095h-1.843c.1.264.148.55.134.847v1.043a.5.5 0 0 1-.5.5H7.833a.5.5 0 0 1-.5-.5l.002-1.012a2.137 2.137 0 0 1 .13-.878H5.623a.625.625 0 0 0-.625.626v14.963c0 .346.28.626.625.626h12.752c.346 0 .625-.28.625-.626V5.411a.625.625 0 0 0-.625-.626Zm-2.187 6.3H7.81a.5.5 0 0 1 0-1h8.38a.5.5 0 0 1 0 1ZM7.81 14.56h8.38a.5.5 0 0 0 0-1H7.81a.5.5 0 0 0 0 1Zm8.38 3.478H7.81a.5.5 0 0 1 0-1h8.38a.5.5 0 0 1 0 1Z",
    fill: "currentColor"
  }));
};

var SvgReportMedical104X104 = function SvgReportMedical104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -report-medical",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.858 7.48C60.4 2.348 55.243-.871 49.962.21c-3.767.77-6.766 3.592-7.815 7.272h-3.113a9.56 9.56 0 0 0-6.597 2.115.991.991 0 0 0-.143-.01H17.988c-3.86 0-6.988 3.153-6.988 7.043v80.326c0 3.891 3.129 7.045 6.988 7.045h68.024c3.86 0 6.988-3.154 6.988-7.045V16.63c0-3.89-3.129-7.044-6.988-7.044H71.477a9.763 9.763 0 0 0-6.53-2.104h-3.089Zm8.49 3.76a.998.998 0 0 0 .236.2 7.93 7.93 0 0 1 2.659 6.33l-.001 4.649H30.764v-4.601a8.279 8.279 0 0 1-.002-1.002c.258-4.313 3.935-7.598 8.212-7.337l3.95.002a.994.994 0 0 0 .973-.801c.66-3.28 3.205-5.845 6.46-6.511 4.477-.916 8.842 1.998 9.75 6.51.095.467.501.802.973.802h3.891l.048-.001a7.78 7.78 0 0 1 5.33 1.76Zm3.037.345h12.627c2.763 0 5.004 2.258 5.004 5.044v80.326c0 2.787-2.24 5.045-5.004 5.045H17.988c-2.763 0-5.004-2.258-5.004-5.045V16.63c0-2.786 2.24-5.044 5.004-5.044h12.58a9.845 9.845 0 0 0-1.786 5.109c-.024.394-.024.79 0 1.186l-.002 5.539c0 .552.444 1 .992 1h44.462a.996.996 0 0 0 .992-1v-5.601a9.844 9.844 0 0 0-1.841-6.233ZM60.556 53.97h12.527a2.502 2.502 0 0 1 2.492 2.51v11.205a2.501 2.501 0 0 1-2.492 2.511H60.556a.509.509 0 0 0-.507.51v12.627a2.501 2.501 0 0 1-2.491 2.512H46.442a2.502 2.502 0 0 1-2.491-2.512V70.707a.509.509 0 0 0-.507-.511H30.917a2.501 2.501 0 0 1-2.492-2.511V56.481a2.502 2.502 0 0 1 2.492-2.511h12.527a.51.51 0 0 0 .507-.512V40.832a2.5 2.5 0 0 1 2.491-2.51h11.116a2.5 2.5 0 0 1 2.491 2.51v12.626a.51.51 0 0 0 .507.512Zm13.034 2.51a.51.51 0 0 0-.507-.51H60.556a2.502 2.502 0 0 1-2.491-2.512V40.832a.508.508 0 0 0-.507-.51H46.442a.508.508 0 0 0-.507.51v12.626a2.502 2.502 0 0 1-2.491 2.512H30.917a.51.51 0 0 0-.507.51v11.205c0 .282.227.511.507.511h12.527a2.501 2.501 0 0 1 2.491 2.511v12.626a.51.51 0 0 0 .507.512h11.116a.51.51 0 0 0 .507-.512V70.707a2.501 2.501 0 0 1 2.491-2.511h12.527c.28 0 .507-.229.507-.511V56.481Z",
    fill: "currentColor"
  }));
};

var SvgReportMedical16X16 = function SvgReportMedical16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -report-medical",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.725 1.1a1.898 1.898 0 0 0-2.1-1.062A1.89 1.89 0 0 0 6.275 1.1h-.219a1.769 1.769 0 0 0-1.108.31H2.905c-.776 0-1.405.622-1.405 1.39V14.61c0 .767.63 1.39 1.405 1.39h10.19c.775 0 1.405-.623 1.405-1.39V2.8c0-.767-.63-1.39-1.405-1.39h-2.06a1.843 1.843 0 0 0-1.103-.31h-.207Zm.782 1.166a.805.805 0 0 1 .32.683v.348H5.174v-.324a.803.803 0 0 1 .852-.874h.613c.24 0 .448-.166.496-.4a.878.878 0 0 1 .69-.681.881.881 0 0 1 1.039.681c.048.233.255.4.495.4h.607a.82.82 0 0 1 .54.166Zm1.264.143h1.324c.218 0 .394.175.394.39v11.813a.393.393 0 0 1-.394.389H2.905a.393.393 0 0 1-.394-.39V2.8c0-.215.176-.39.394-.39h1.324a1.79 1.79 0 0 0-.064.593v.795c0 .276.225.5.504.5h6.662c.28 0 .505-.224.505-.5v-.824a1.725 1.725 0 0 0-.065-.564ZM8.833 5.636c.402 0 .73.324.73.722v1.579h1.595c.404 0 .731.324.731.723v1.647c0 .4-.328.722-.73.722H9.563v1.579a.727.727 0 0 1-.73.723H7.167a.727.727 0 0 1-.73-.723v-1.58H4.841a.726.726 0 0 1-.73-.721V8.66c0-.4.327-.723.73-.723h1.596v-1.58c0-.397.328-.721.73-.721h1.666Zm.45 4.393h1.596V8.937H9.283a.727.727 0 0 1-.731-.722v-1.58H7.448v1.58a.727.727 0 0 1-.73.722H5.12v1.092h1.596c.403 0 .731.322.731.722v1.58h1.104v-1.58c0-.4.328-.722.73-.722Z",
    fill: "currentColor"
  }));
};

var SvgReportMedical24X24 = function SvgReportMedical24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -report-medical",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.071 3.393a2.236 2.236 0 0 0-4.14 0h-.362a2.076 2.076 0 0 0-1.342.392H5.624C4.727 3.785 4 4.513 4 5.411v14.963C4 21.272 4.727 22 5.624 22h12.752c.897 0 1.624-.728 1.624-1.626V5.411c0-.898-.727-1.626-1.624-1.626h-2.62a2.15 2.15 0 0 0-1.337-.392h-.348Zm1.16 1.25a1.16 1.16 0 0 1 .438.966v.566H8.332v-.543a1.142 1.142 0 0 1 1.207-1.24l.76.001a.5.5 0 0 0 .488-.4 1.237 1.237 0 0 1 2.427 0 .5.5 0 0 0 .489.4h.757a1.157 1.157 0 0 1 .772.25Zm1.303.142h1.842c.346 0 .625.28.625.626v14.963c0 .346-.28.626-.625.626H5.624a.625.625 0 0 1-.625-.626V5.411c0-.346.28-.626.625-.626h1.84a2.149 2.149 0 0 0-.13.878v1.012a.5.5 0 0 0 .499.5h8.335a.5.5 0 0 0 .5-.5V5.632a2.1 2.1 0 0 0-.134-.847ZM13.041 9.14c.43 0 .78.35.78.78v2.134h2.13c.432 0 .78.35.78.782v2.087a.78.78 0 0 1-.78.78h-2.13v2.135a.78.78 0 0 1-.78.78h-2.084a.78.78 0 0 1-.78-.78v-2.134h-2.13a.78.78 0 0 1-.78-.781v-2.087c0-.433.348-.782.78-.782h2.13V9.92a.78.78 0 0 1 .78-.781h2.084Zm.562 5.564h2.13v-1.65h-2.13a.78.78 0 0 1-.78-.781v-2.133h-1.648v2.133a.78.78 0 0 1-.78.78h-2.13v1.65h2.13c.431 0 .78.35.78.783v2.133h1.648v-2.133a.78.78 0 0 1 .78-.782Z",
    fill: "currentColor"
  }));
};

var SvgResultChartNegative104X104 = function SvgResultChartNegative104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -result-chart-negative",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 102H7.044A5.044 5.044 0 0 1 2 96.955V1a1 1 0 0 0-2 0v95.955A7.044 7.044 0 0 0 7.044 104H103a1 1 0 0 0 0-2ZM90.089 74.464a1 1 0 1 0 0 2h12.891a.997.997 0 0 0 1.02-1m-13.911-1h10.497-10.497Zm10.497 0-27.95-27.951-19.468 9.733a1 1 0 0 1-1.111-.147L21.89 29.284a1 1 0 0 1 1.328-1.494L52.88 54.154 72.386 44.4a1 1 0 0 1 1.154.188L102 73.049V62.554a1 1 0 0 1 2 0v12.909",
    fill: "currentColor"
  }));
};

var SvgResultChartNegative16X16 = function SvgResultChartNegative16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -result-chart-negative",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 15H1.389A.389.389 0 0 1 1 14.611V.5a.5.5 0 0 0-1 0v14.111C0 15.378.622 16 1.389 16H15.5a.5.5 0 0 0 0-1Zm-1.898-4.05a.5.5 0 1 0 0 1h1.875a.499.499 0 0 0 .524-.519v-1.88a.5.5 0 0 0-1 0v.692l-3.584-3.582a.5.5 0 0 0-.577-.094L8.186 7.895l-4.184-3.72a.5.5 0 1 0-.664.748l4.437 3.944a.5.5 0 0 0 .556.074l2.634-1.318 3.328 3.327h-.691Z",
    fill: "currentColor"
  }));
};

var SvgResultChartNegative24X24 = function SvgResultChartNegative24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -result-chart-negative",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.626 21H21.5a.5.5 0 0 1 0 1H3.626A1.627 1.627 0 0 1 2 20.374V2.5a.5.5 0 0 1 1 0v17.874c0 .345.281.626.626.626ZM21 13.966a.5.5 0 0 1 1 0v2.405a.5.5 0 0 1-.5.5h-2.405a.5.5 0 1 1 0-1h1.198l-4.511-4.511-3.424 1.71a.498.498 0 0 1-.556-.072L6.183 8.003a.499.499 0 1 1 .664-.747l5.366 4.77 3.444-1.722a.502.502 0 0 1 .577.094L21 15.164v-1.198Z",
    fill: "currentColor"
  }));
};

var SvgResultChartPositive104X104 = function SvgResultChartPositive104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -result-chart-positive",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 102H7.044A5.044 5.044 0 0 1 2 96.955V1a1 1 0 0 0-2 0v95.955A7.044 7.044 0 0 0 7.044 104H103a1 1 0 0 0 0-2Zm-1-60.055a1 1 0 0 0 2 0V28.537a1 1 0 0 0-1-1H89.592a1 1 0 1 0 0 2h10.994l-27.95 27.95-19.468-9.733a1 1 0 0 0-1.112.147L21.89 74.716a1 1 0 0 0 1.33 1.495l29.66-26.366 19.506 9.753a1 1 0 0 0 1.155-.187L102 30.951v10.994Z",
    fill: "currentColor"
  }));
};

var SvgResultChartPositive16X16 = function SvgResultChartPositive16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -result-chart-positive",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 15H1.389A.389.389 0 0 1 1 14.611V.5a.5.5 0 0 0-1 0v14.111C0 15.378.622 16 1.389 16H15.5a.5.5 0 0 0 0-1ZM15 6.521a.5.5 0 0 0 1 0V4.56a.499.499 0 0 0-.51-.51h-1.962a.5.5 0 0 0 0 1h.765l-3.328 3.329L8.33 7.06a.5.5 0 0 0-.556.073l-4.437 3.943a.5.5 0 1 0 .665.748l4.183-3.718 2.655 1.327a.5.5 0 0 0 .577-.093L15 5.756v.765Z",
    fill: "currentColor"
  }));
};

var SvgResultChartPositive24X24 = function SvgResultChartPositive24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -result-chart-positive",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.626 21H21.5a.5.5 0 0 1 0 1H3.626A1.627 1.627 0 0 1 2 20.374V2.5a.5.5 0 0 1 1 0v17.874c0 .345.281.626.626.626ZM21.69 7.168a.497.497 0 0 1 .31.462v2.497a.5.5 0 1 1-1 0v-1.29l-4.767 4.765a.505.505 0 0 1-.577.095l-3.443-1.722-5.367 4.77a.501.501 0 0 1-.664-.748l5.62-4.995a.5.5 0 0 1 .555-.074l3.424 1.712 4.512-4.51h-1.29a.5.5 0 0 1 0-1H21.5a.5.5 0 0 1 .19.038Z",
    fill: "currentColor"
  }));
};

var SvgRobot104X104 = function SvgRobot104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "currentColor",
    className: "icon -robot",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.978 7.28a1 1 0 0 0-1.414.027 13.203 13.203 0 0 0-3.696 9.18c0 2.977.982 5.727 2.64 7.938a1 1 0 1 0 1.6-1.2 11.193 11.193 0 0 1-2.24-6.738c0-3.027 1.194-5.773 3.138-7.794a1 1 0 0 0-.028-1.414Zm5.406 2.81a1 1 0 0 0-1.38.311 13.191 13.191 0 0 0-2.038 7.065c0 1.607.287 3.15.812 4.577a1 1 0 1 0 1.877-.69 11.227 11.227 0 0 1-.689-3.887c0-2.207.634-4.263 1.73-5.997a1 1 0 0 0-.312-1.38Zm30.589-2.81a1 1 0 0 1 1.414.027 13.203 13.203 0 0 1 3.697 9.18c0 2.977-.983 5.727-2.64 7.938a1 1 0 0 1-1.6-1.2 11.193 11.193 0 0 0 2.24-6.738c0-3.027-1.195-5.773-3.138-7.794a1 1 0 0 1 .027-1.414Zm-5.406 2.81a1 1 0 0 1 1.38.311 13.191 13.191 0 0 1 2.038 7.065c0 1.607-.287 3.15-.812 4.577a1 1 0 1 1-1.877-.69 11.23 11.23 0 0 0 .689-3.887c0-2.207-.634-4.263-1.73-5.997a1 1 0 0 1 .312-1.38ZM51.975 23.37c3.409 0 6.179-2.77 6.179-6.196 0-3.425-2.77-6.195-6.179-6.195-3.408 0-6.178 2.77-6.178 6.195 0 3.426 2.77 6.196 6.178 6.196ZM53 25.306a8.191 8.191 0 0 0 7.155-8.132c0-4.526-3.662-8.195-8.179-8.195s-8.178 3.669-8.178 8.195A8.191 8.191 0 0 0 51 25.312l-.013 8.253H40c-12.873 0-23.853 8.109-28.11 19.498l-2.083.017C4.343 53.127-.047 57.594 0 63.058c.048 5.464 4.516 9.856 9.98 9.81l.796-.007c3.082 13.29 14.997 23.196 29.225 23.196h23.83c14.23 0 26.144-9.906 29.226-23.198l.962.009c5.465.046 9.933-4.346 9.981-9.81.047-5.464-4.344-9.931-9.808-9.978l-2.25-.019c-4.258-11.388-15.237-19.496-28.11-19.496H52.986l.012-8.259Zm-12.998 10.26h23.83c15.465 0 28 12.535 28 28v2.49c0 15.465-12.535 28-28 28h-23.83c-15.464 0-28-12.535-28-28v-2.49c0-15.465 12.536-28 28-28Zm-28.78 19.502-1.396.012A7.892 7.892 0 0 0 2 63.041a7.896 7.896 0 0 0 7.963 7.827l.421-.004a30.217 30.217 0 0 1-.383-4.807v-2.492c0-2.951.426-5.803 1.22-8.497ZM93.45 70.863l.588.005A7.896 7.896 0 0 0 102 63.04a7.892 7.892 0 0 0-7.825-7.96l-1.564-.014a30.007 30.007 0 0 1 1.22 8.498v2.492c0 1.635-.13 3.24-.382 4.806ZM45.195 57.677c.033.551.507.972 1.058.94a.998.998 0 0 0 .938-1.057c-.153-2.55-1.191-4.483-2.726-5.753-1.519-1.256-3.456-1.81-5.338-1.749-3.747.121-7.586 2.736-7.589 7.566 0 .552.447 1 1 1.002a.998.998 0 0 0 1-.998c.003-3.499 2.716-5.476 5.657-5.57 1.462-.048 2.903.385 3.996 1.289 1.076.89 1.881 2.292 2.004 4.33Zm26.58 0c.033.551.507.972 1.058.94a.998.998 0 0 0 .939-1.057c-.153-2.55-1.192-4.483-2.727-5.753-1.518-1.256-3.455-1.81-5.337-1.749-3.747.121-7.586 2.736-7.59 7.566 0 .552.448 1 1 1.002a.998.998 0 0 0 1-.998c.003-3.499 2.716-5.476 5.657-5.57 1.462-.048 2.903.385 3.996 1.289 1.076.89 1.882 2.292 2.004 4.33Zm-34.79 12.03a1 1 0 0 1 1.29.582c.972 2.568 3.058 4.536 5.796 5.867 2.74 1.333 6.078 1.996 9.411 1.97 3.334-.028 6.599-.746 9.197-2.108 2.593-1.36 4.466-3.325 5.185-5.848a.999.999 0 1 1 1.924.55c-.909 3.185-3.243 5.53-6.18 7.07-2.931 1.537-6.52 2.306-10.108 2.335-3.588.03-7.24-.681-10.302-2.17-3.065-1.49-5.594-3.791-6.793-6.959a1 1 0 0 1 .58-1.288Z"
  }));
};

var SvgRobot16X16 = function SvgRobot16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    className: "icon -robot",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.996.653a.5.5 0 1 0-.72.694c.267.278.43.655.43 1.072 0 .348-.114.668-.307.927a.5.5 0 1 0 .8.6c.319-.426.508-.955.508-1.527a2.54 2.54 0 0 0-.711-1.766Zm-2.763.424a.5.5 0 0 1 .69.156 2.538 2.538 0 0 1 .236 2.239.5.5 0 0 1-.939-.346 1.544 1.544 0 0 0-.143-1.359.5.5 0 0 1 .156-.69ZM8.321 2.37c0 .206-.167.37-.368.37a.369.369 0 0 1-.367-.37c0-.206.167-.37.367-.37.201 0 .368.164.368.37Zm1 0a1.37 1.37 0 0 1-.823 1.257v1.447H9.77a5.225 5.225 0 0 1 4.844 3.266A1.562 1.562 0 0 1 16 9.906l-.001.148a1.564 1.564 0 0 1-1.158 1.496 5.225 5.225 0 0 1-5.071 3.97H6.202a5.225 5.225 0 0 1-5.073-3.978A1.563 1.563 0 0 1 0 10.054v-.148a1.562 1.562 0 0 1 1.356-1.562 5.225 5.225 0 0 1 4.845-3.27h1.296V3.662A1.37 1.37 0 0 1 7.953 1c.755 0 1.368.613 1.368 1.37Zm.449 3.704H6.202a4.223 4.223 0 0 0 0 8.446H9.77a4.223 4.223 0 0 0 0-8.446ZM5.567 1.077a.5.5 0 0 0-.69.156 2.538 2.538 0 0 0-.236 2.239.5.5 0 1 0 .939-.346 1.544 1.544 0 0 1 .143-1.359.5.5 0 0 0-.156-.69ZM2.911.653a.5.5 0 1 1 .72.694A1.54 1.54 0 0 0 3.2 2.419c0 .348.115.668.308.927a.5.5 0 0 1-.8.6A2.538 2.538 0 0 1 2.2 2.418c0-.685.271-1.308.711-1.766Zm3.62 8.47a.5.5 0 0 0 .997-.058c-.03-.511-.243-.923-.576-1.198a1.664 1.664 0 0 0-1.115-.369c-.76.025-1.59.568-1.59 1.597a.5.5 0 0 0 1 .002c0-.364.266-.588.624-.6a.664.664 0 0 1 .444.14c.104.085.2.231.215.487Zm4.442 0a.5.5 0 0 0 .999-.058c-.031-.511-.243-.923-.576-1.198a1.664 1.664 0 0 0-1.116-.369c-.76.025-1.59.568-1.59 1.597a.5.5 0 0 0 1 .002c0-.364.266-.588.624-.6a.664.664 0 0 1 .445.14c.103.085.2.231.214.487Zm-5.6 1.68a.5.5 0 0 1 .644.292c.125.33.4.603.803.799.404.197.91.3 1.425.296.515-.005 1.007-.116 1.385-.315.377-.197.613-.462.702-.774a.5.5 0 1 1 .961.275c-.183.643-.65 1.098-1.198 1.385-.545.286-1.2.423-1.841.429-.643.005-1.305-.122-1.87-.397-.567-.275-1.064-.715-1.302-1.345a.5.5 0 0 1 .29-.644Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))));
};

var SvgRobot24X24 = function SvgRobot24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: "icon -robot",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.193 2.153a.5.5 0 0 0-.72.694c.402.418.648.985.648 1.612 0 .523-.172 1.005-.463 1.393a.5.5 0 1 0 .8.6 3.314 3.314 0 0 0 .663-1.993c0-.895-.354-1.709-.928-2.306Zm-2.562.602a.5.5 0 0 1 .69.155c.324.514.512 1.123.512 1.774 0 .403-.072.79-.204 1.15a.5.5 0 1 1-.939-.346c.092-.25.143-.52.143-.804 0-.457-.131-.881-.358-1.24a.5.5 0 0 1 .156-.69Zm-1.733 1.862a.89.89 0 0 1-.887.891.89.89 0 0 1-.888-.89c0-.495.4-.892.888-.892a.89.89 0 0 1 .887.891Zm1 0c0 .875-.593 1.611-1.398 1.827V8.4h1.943a7.213 7.213 0 0 1 6.683 4.498l.61.005a2.283 2.283 0 1 1-.04 4.566l-.284-.002a7.214 7.214 0 0 1-6.97 5.354H9.52a7.214 7.214 0 0 1-6.97-5.354l-.246.002a2.284 2.284 0 0 1-.04-4.566l.572-.005A7.213 7.213 0 0 1 9.52 8.4H11.5V6.438a1.892 1.892 0 0 1 .51-3.712 1.89 1.89 0 0 1 1.888 1.891Zm.545 4.783H9.519a6.21 6.21 0 1 0 0 12.42h4.924a6.21 6.21 0 0 0 0-12.42ZM2.272 13.903l.24-.002a7.228 7.228 0 0 0-.153 2.568h-.065a1.284 1.284 0 0 1-.022-2.566Zm19.433 2.566h-.102a7.283 7.283 0 0 0-.153-2.568l.278.002a1.283 1.283 0 1 1-.023 2.566ZM9.39 2.755a.5.5 0 0 0-.69.155 3.313 3.313 0 0 0-.511 1.774c0 .404.072.79.204 1.15a.5.5 0 1 0 .938-.346 2.322 2.322 0 0 1-.142-.804c0-.457.13-.881.357-1.24a.5.5 0 0 0-.156-.69Zm-2.562-.602a.5.5 0 1 1 .72.694A2.316 2.316 0 0 0 6.9 4.459c0 .523.172 1.005.463 1.393a.5.5 0 0 1-.8.6A3.314 3.314 0 0 1 5.9 4.459c0-.895.354-1.709.928-2.306Zm3.333 11.827a.5.5 0 0 0 .998-.059c-.04-.657-.31-1.175-.727-1.519a2.106 2.106 0 0 0-1.412-.465c-.973.031-2.01.72-2.011 2.014a.501.501 0 0 0 1 .002c0-.628.475-.998 1.045-1.017.28-.009.547.075.742.236.186.154.34.406.365.808Zm6.134 0a.5.5 0 0 0 .998-.059c-.04-.657-.31-1.175-.727-1.519a2.106 2.106 0 0 0-1.412-.465c-.973.031-2.01.72-2.011 2.014a.501.501 0 0 0 1 .002c0-.628.475-.998 1.045-1.017.28-.009.547.075.742.236.186.154.34.406.365.808ZM8.44 16.488a.5.5 0 0 1 .644.291c.194.512.616.921 1.204 1.207.589.287 1.317.433 2.052.427.735-.006 1.444-.164 2-.455.552-.29.921-.692 1.062-1.185a.5.5 0 1 1 .962.275c-.235.824-.836 1.416-1.56 1.796-.721.378-1.593.562-2.455.57-.863.006-1.748-.164-2.498-.529-.75-.365-1.394-.94-1.702-1.752a.5.5 0 0 1 .29-.645Z"
  }));
};

var SvgRobot64X64 = function SvgRobot64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "currentColor",
    className: "icon -robot",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.143 2.153a.5.5 0 0 0-.72.694 7.66 7.66 0 0 1 2.145 5.328c0 1.73-.57 3.324-1.532 4.607a.5.5 0 0 0 .8.6 8.652 8.652 0 0 0 1.732-5.207 8.66 8.66 0 0 0-2.425-6.022Zm-5.485 6.481a4.474 4.474 0 0 1-4.468 4.48 4.474 4.474 0 0 1-4.469-4.48 4.474 4.474 0 0 1 4.469-4.48 4.474 4.474 0 0 1 4.468 4.48Zm1 0a5.475 5.475 0 0 1-5.168 5.472v5.489h6.588c8.772 0 16.281 5.405 19.378 13.067A6.248 6.248 0 0 1 64 38.925l-.005.592a6.254 6.254 0 0 1-4.628 5.983c-2.246 9.118-10.477 15.88-20.288 15.88H24.81c-9.823 0-18.062-6.779-20.296-15.913a6.254 6.254 0 0 1-4.509-5.95L0 38.925a6.249 6.249 0 0 1 5.426-6.249c3.094-7.67 10.607-13.082 19.384-13.082h6.68V14.07a5.477 5.477 0 0 1-4.769-5.436 5.474 5.474 0 0 1 5.469-5.48 5.474 5.474 0 0 1 5.468 5.48Zm1.42 11.96H24.81c-10.986 0-19.893 8.907-19.893 19.893 0 10.987 8.906 19.893 19.893 19.893h14.268c10.987 0 19.893-8.906 19.893-19.893 0-10.986-8.906-19.893-19.893-19.893ZM1 38.916a5.25 5.25 0 0 1 4.022-5.15 20.867 20.867 0 0 0-1.105 6.721c0 1.31.12 2.593.352 3.837a5.252 5.252 0 0 1-3.264-4.816L1 38.916Zm61.994.592a5.253 5.253 0 0 1-3.383 4.863c.236-1.258.36-2.557.36-3.884 0-2.361-.392-4.63-1.114-6.748A5.25 5.25 0 0 1 63 38.917l-.005.591ZM38.951 4.04a.5.5 0 0 1 .69.156 8.652 8.652 0 0 1 1.336 4.633 8.677 8.677 0 0 1-.532 3.003.5.5 0 1 1-.939-.346 7.676 7.676 0 0 0 .471-2.657 7.652 7.652 0 0 0-1.182-4.1.5.5 0 0 1 .156-.69Zm-13.595.654a.5.5 0 0 0-.69.156 8.652 8.652 0 0 0-1.337 4.634c0 1.054.188 2.066.533 3.002a.5.5 0 0 0 .938-.345 7.676 7.676 0 0 1-.47-2.657c0-1.509.433-2.914 1.182-4.1a.5.5 0 0 0-.156-.69Zm-3.193-1.886a.5.5 0 1 1 .721.693 7.66 7.66 0 0 0-2.145 5.328c0 1.73.57 3.324 1.531 4.607a.5.5 0 1 1-.8.6 8.653 8.653 0 0 1-1.731-5.207 8.66 8.66 0 0 1 2.424-6.021Zm5.455 32.9a.5.5 0 0 0 .998-.06c-.1-1.661-.774-2.909-1.762-3.726-.98-.81-2.233-1.17-3.456-1.13-2.437.078-4.91 1.773-4.911 4.89a.501.501 0 0 0 1 .002c.001-2.452 1.91-3.828 3.945-3.893 1.013-.033 2.019.266 2.785.9.758.628 1.317 1.61 1.401 3.016Zm17.773 0a.501.501 0 0 0 .998-.06c-.1-1.661-.774-2.909-1.762-3.726-.98-.81-2.233-1.17-3.456-1.13-2.437.078-4.91 1.773-4.911 4.89a.5.5 0 0 0 1 .002c.001-2.452 1.91-3.828 3.945-3.893 1.013-.033 2.019.266 2.785.9.758.628 1.316 1.61 1.401 3.016Zm-23.37 8.211a.5.5 0 0 1 .644.291c.67 1.767 2.102 3.111 3.96 4.015 1.86.904 4.117 1.352 6.368 1.333 2.25-.018 4.46-.502 6.226-1.428 1.763-.924 3.054-2.27 3.55-4.013a.5.5 0 1 1 .963.275c-.592 2.074-2.114 3.61-4.048 4.624-1.932 1.013-4.305 1.523-6.682 1.542-2.378.02-4.794-.451-6.814-1.434-2.021-.983-3.675-2.493-4.458-4.56a.5.5 0 0 1 .29-.645Z"
  }));
};

var SvgSac104X104 = function SvgSac104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sac",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M101 66.28c0 3.932-3.213 7.12-7.178 7.12h-6.546c-.244 10.204-4.245 16.912-10.772 20.689-2.356 1.362-4.871 2.236-7.386 2.72-.881.17-1.7.28-2.439.341l-.017.002c-.473 3.858-3.788 6.848-7.807 6.848H52c-4.343 0-7.864-3.493-7.864-7.8 0-4.308 3.52-7.8 7.863-7.8h6.856c3.984 0 7.274 2.936 7.794 6.745a21.053 21.053 0 0 0 2.084-.298c2.306-.445 4.61-1.245 6.755-2.486 6.117-3.539 9.783-9.903 9.783-19.961 0-.552.452-1 1.009-1h7.542c2.851 0 5.162-2.292 5.162-5.12V47.92c0-2.828-2.31-5.12-5.162-5.12H86.28a1.004 1.004 0 0 1-1.009-1V35c0-18.588-13.526-33-31.556-33h-3.43C32.254 2 18.729 16.41 18.729 35v6.8c0 .552-.452 1-1.009 1h-7.541c-2.851 0-5.162 2.292-5.162 5.12v18.36c0 2.828 2.31 5.12 5.162 5.12h4.113c.557 0 1.009.448 1.009 1s-.452 1-1.009 1h-4.113C6.213 73.4 3 70.212 3 66.28V47.92c0-3.932 3.213-7.12 7.178-7.12h6.533V35c0-19.663 14.395-35 33.575-35h3.428c19.178 0 33.574 15.338 33.574 35v5.8h6.534c3.965 0 7.178 3.188 7.178 7.12v18.36zM64.703 96.2c0 3.203-2.618 5.8-5.848 5.8H52c-3.23 0-5.847-2.597-5.847-5.8 0-3.204 2.617-5.8 5.846-5.8h6.856c3.23 0 5.848 2.596 5.848 5.8z",
    clipRule: "evenodd"
  }));
};

var SvgSac16X16 = function SvgSac16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sac",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.5 10.1a1.4 1.4 0 0 1-1.4 1.4h-.62c-.117 1.435-.747 2.422-1.728 2.994a3.736 3.736 0 0 1-1.326.473A1.5 1.5 0 0 1 9 16H8a1.5 1.5 0 1 1 0-3h1a1.5 1.5 0 0 1 1.396.95c.292-.06.583-.163.852-.32.784-.456 1.252-1.276 1.252-2.63a.5.5 0 0 1 .5-.5h1.1a.4.4 0 0 0 .4-.4V7.4a.4.4 0 0 0-.4-.4H13a.5.5 0 0 1-.5-.5v-1c0-2.544-1.82-4.5-4.25-4.5h-.5C5.32 1 3.5 2.956 3.5 5.5v1A.5.5 0 0 1 3 7H1.9a.4.4 0 0 0-.4.4v2.7c0 .22.18.4.4.4h.6a.5.5 0 0 1 0 1h-.6a1.4 1.4 0 0 1-1.4-1.4V7.4A1.4 1.4 0 0 1 1.9 6h.6v-.5C2.5 2.419 4.752 0 7.75 0h.5c2.998 0 5.25 2.419 5.25 5.5V6h.6a1.4 1.4 0 0 1 1.4 1.4v2.7zm-6 4.4A.5.5 0 0 0 9 14H8a.5.5 0 1 0 0 1h1a.5.5 0 0 0 .5-.5z",
    clipRule: "evenodd"
  }));
};

var SvgSac24X24 = function SvgSac24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sac",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 14.66c0 .905-.784 1.639-1.751 1.639h-.97c-.127 1.841-.96 3.092-2.277 3.812a5.116 5.116 0 0 1-1.831.593c-.22.747-.951 1.296-1.82 1.296H12c-1.041 0-1.887-.791-1.887-1.767 0-.976.846-1.767 1.887-1.767h1.352c.839 0 1.55.513 1.795 1.222l.09-.015a4.09 4.09 0 0 0 1.227-.426c1.104-.603 1.764-1.686 1.764-3.448 0-.276.239-.5.534-.5h1.487c.378 0 .683-.286.683-.639v-3.42c0-.354-.305-.64-.683-.64h-1.487c-.295 0-.534-.224-.534-.5V8.833c0-3.294-2.524-5.833-5.89-5.833h-.676c-3.367 0-5.89 2.54-5.89 5.833V10.1c0 .276-.239.5-.534.5H3.75c-.378 0-.682.286-.682.64v3.42c0 .353.305.639.682.639h.811c.295 0 .534.224.534.5s-.239.5-.534.5H3.75c-.967 0-1.75-.734-1.75-1.639v-3.42c0-.906.783-1.64 1.75-1.64h.954v-.767C4.704 5.003 7.688 2 11.662 2h.675c3.974 0 6.959 3.002 6.959 6.833V9.6h.953c.968 0 1.751.734 1.751 1.64v3.42Zm-7.83 5.573c0-.424-.366-.767-.818-.767H12c-.452 0-.819.343-.819.767S11.548 21 12 21h1.352c.452 0 .819-.343.819-.767Z",
    fill: "currentColor"
  }));
};

var SvgSafe104X104 = function SvgSafe104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -safe",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.003 41.366H19.999c-3.865 0-6.999 3.155-6.999 7.045v48.544c0 3.891 3.133 7.045 7 7.045h64c3.866 0 7-3.154 7-7.045V48.411c0-3.89-3.134-7.045-7-7.045H71.996V20.125C71.996 9.01 63.043 0 52 0 40.956 0 32.003 9.01 32.003 20.125v21.241zm1.987 0h36.02V20.125C70.01 10.115 61.945 2 52 2c-9.947 0-18.01 8.115-18.01 18.125v21.241zm37.013 2H19.999c-2.768 0-5.012 2.259-5.012 5.045v48.544c0 2.787 2.244 5.045 5.012 5.045h64c2.77 0 5.014-2.258 5.014-5.045V48.411c0-2.786-2.245-5.045-5.013-5.045H71.003zm-34.146 28.61a.99.99 0 0 0-1.406 0 1.005 1.005 0 0 0 0 1.415l11.525 11.597a.99.99 0 0 0 1.45-.049l20.167-23.195a1.004 1.004 0 0 0-.094-1.41.99.99 0 0 0-1.402.093L47.63 82.817l-10.773-10.84z",
    clipRule: "evenodd"
  }));
};

var SvgSafe16X16 = function SvgSafe16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -safe",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.755 6.083H3.361C2.609 6.083 2 6.705 2 7.473v7.138C2 15.378 2.61 16 3.36 16h9.28c.751 0 1.36-.622 1.36-1.389V7.473c0-.768-.609-1.39-1.36-1.39h-1.395V3.312C11.245 1.482 9.793 0 8.001 0 6.208 0 4.755 1.483 4.755 3.312v2.771zm.98 0h4.53V3.312C10.266 2.035 9.253 1 8.002 1 6.749 1 5.735 2.035 5.735 3.312v2.771zm5.02 1H3.361a.385.385 0 0 0-.381.39v7.138c0 .215.17.389.38.389h9.28c.21 0 .38-.174.38-.389V7.473c0-.216-.17-.39-.38-.39h-1.885zM6.05 10.688a.483.483 0 0 0-.693 0 .508.508 0 0 0 0 .707l1.67 1.706c.2.204.529.193.715-.025l2.924-3.41a.507.507 0 0 0-.046-.706.483.483 0 0 0-.691.047l-2.58 3.008-1.3-1.327z",
    clipRule: "evenodd"
  }));
};

var SvgSafe24X24 = function SvgSafe24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -safe",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.738 9.705H5.706c-.942 0-1.706.729-1.706 1.626v9.043C4 21.272 4.764 22 5.706 22h12.588c.942 0 1.706-.728 1.706-1.626v-9.043c0-.897-.764-1.626-1.706-1.626h-2.032V6.062C16.262 3.819 14.354 2 12.001 2 9.646 2 7.738 3.819 7.738 6.062v3.643Zm1.049 0h6.426V6.062c0-1.69-1.438-3.062-3.212-3.062-1.775 0-3.214 1.371-3.214 3.062v3.643Zm6.95 1H5.707c-.362 0-.657.28-.657.626v9.043c0 .346.294.626.657.626h12.588c.363 0 .657-.28.657-.626v-9.043c0-.345-.294-.626-.657-.626h-2.556Zm-6.482 4.794a.543.543 0 0 0-.742 0 .484.484 0 0 0 0 .707l2.266 2.16a.542.542 0 0 0 .766-.024l3.966-4.32a.484.484 0 0 0-.049-.706.543.543 0 0 0-.74.047l-3.598 3.918-1.87-1.782Z",
    fill: "currentColor"
  }));
};

var SvgSafeBox104X104 = function SvgSafeBox104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -safe-box",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M102 90.156a5.05 5.05 0 0 1-5.045 5.044H7.045A5.05 5.05 0 0 1 2 90.156V7.045A5.05 5.05 0 0 1 7.045 2h89.91A5.05 5.05 0 0 1 102 7.045v83.11zM96.955 0H7.045A7.053 7.053 0 0 0 0 7.045v83.11C0 94.04 3.16 97.2 7.045 97.2H13.6v5.8a1 1 0 1 0 2 0v-5.8h72.8v5.8a1 1 0 0 0 2 0v-5.8h6.555c3.885 0 7.045-3.16 7.045-7.044V7.045A7.053 7.053 0 0 0 96.955 0zM55.424 27.223H55.4a21.262 21.262 0 0 0-15.115 6.25c-3.81 3.8-5.984 8.788-6.235 14.127H28.2a1 1 0 0 0 0 2h23.967A3.388 3.388 0 0 0 55.4 52a3.4 3.4 0 0 0 0-6.8 3.388 3.388 0 0 0-3.234 2.4H36.05c.249-4.803 2.218-9.288 5.647-12.71A19.276 19.276 0 0 1 55.4 29.223h.022a19.27 19.27 0 0 1 13.71 5.698A19.272 19.272 0 0 1 74.8 48.645a19.273 19.273 0 0 1-5.697 13.71A19.273 19.273 0 0 1 55.4 68.024h-.023A19.455 19.455 0 0 1 38.586 58.3a1 1 0 1 0-1.732.998 21.455 21.455 0 0 0 18.522 10.724h.025a21.256 21.256 0 0 0 15.114-6.251A21.26 21.26 0 0 0 76.8 48.647a21.26 21.26 0 0 0-6.251-15.14 21.256 21.256 0 0 0-15.125-6.284zM83.355 81.6a5.05 5.05 0 0 0 5.045-5.044V20.645a5.05 5.05 0 0 0-5.045-5.045h-62.71a5.05 5.05 0 0 0-5.046 5.045V30.6H18a1 1 0 0 1 0 2h-2.4v32H18a1 1 0 0 1 0 2h-2.4v9.956a5.05 5.05 0 0 0 5.044 5.044h62.711zm-62.71-68h62.71a7.053 7.053 0 0 1 7.045 7.045v55.91c0 3.885-3.16 7.045-7.045 7.045h-62.71c-3.886 0-7.046-3.16-7.046-7.044V66.6H11.2a1 1 0 1 1 0-2h2.4v-32h-2.4a1 1 0 1 1 0-2h2.4v-9.955a7.053 7.053 0 0 1 7.044-7.045z",
    clipRule: "evenodd"
  }));
};

var SvgSafeBox16X16 = function SvgSafeBox16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -safe-box",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.61 0H1.39C.623 0 0 .623 0 1.392v12.217c0 .769.623 1.392 1.391 1.392H2v.496a.503.503 0 0 0 1.006 0v-.496h9.99v.496a.503.503 0 1 0 1.006 0v-.496h.609A1.39 1.39 0 0 0 16 13.609V1.392A1.39 1.39 0 0 0 14.61 0zM2.502 13.994H14.61a.385.385 0 0 0 .384-.385V1.392a.385.385 0 0 0-.384-.386H1.39a.386.386 0 0 0-.385.386v12.217c0 .213.173.386.385.386h1.111zM2 3.391A1.39 1.39 0 0 1 3.39 2h9.22A1.39 1.39 0 0 1 14 3.39v8.22A1.39 1.39 0 0 1 12.61 13H3.39A1.39 1.39 0 0 1 2 11.611v-1.109c-.668-.002-.668-1.004 0-1.006V5.505c-.668-.002-.668-1.004 0-1.006V3.39zm1.006 2.114v3.991c.667.003.667 1.003 0 1.006v1.108c0 .213.172.385.384.385h9.22a.385.385 0 0 0 .385-.385V3.391a.385.385 0 0 0-.385-.385H3.39a.385.385 0 0 0-.384.385V4.5c.667.003.667 1.003 0 1.006zm2.108 2.499h-.613a.503.503 0 1 1 0-1.006h.533a3.502 3.502 0 1 1 .43 2.253l-.05-.122-.3-1.125zm1.042 0 .213.799a2.496 2.496 0 1 0-.314-1.805h1.578a1.003 1.003 0 1 1 0 1.006H6.156z",
    clipRule: "evenodd"
  }));
};

var SvgSafeBox24X24 = function SvgSafeBox24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -safe-box",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.374 2H3.626C2.728 2 2 2.728 2 3.626v15.481c0 .898.728 1.626 1.626 1.626h.907v.767a.5.5 0 0 0 1 0v-.767h12.934v.767a.5.5 0 0 0 1 0v-.767h.907c.898 0 1.626-.728 1.626-1.626V3.626C22 2.728 21.272 2 20.374 2ZM3 3.626C3 3.28 3.28 3 3.626 3h16.748c.346 0 .626.28.626.626v15.481c0 .346-.28.626-.626.626H3.626A.626.626 0 0 1 3 19.107V3.626ZM4.4 8.7c-.667 0-.667-1 0-1h.133V6.159c0-.898.728-1.625 1.626-1.625h11.682c.898 0 1.626.727 1.626 1.625v10.416c0 .897-.728 1.625-1.626 1.625H6.159a1.626 1.626 0 0 1-1.626-1.625v-1.541H4.4c-.667 0-.667-1 0-1h.133V8.7H4.4Zm1.133-.477a.56.56 0 0 0 0-.047V6.159c0-.345.28-.625.626-.625h11.682c.346 0 .626.28.626.625v10.416c0 .345-.28.625-.626.625H6.159a.626.626 0 0 1-.626-.625v-2.018a.56.56 0 0 0 0-.047V8.223Zm.134-.523v1c.667 0 .667-1 0-1Zm0 6.334c.667 0 .667 1 0 1v-1Zm2.782-2.167h-.882a.5.5 0 0 1 0-1h.795a4.302 4.302 0 0 1 8.572.508 4.3 4.3 0 0 1-8.027 2.141l-.05-.12-.408-1.53Zm1.035 0 .322 1.205a3.3 3.3 0 1 0-.434-2.205h2.244a1.134 1.134 0 1 1 0 1H9.484Z",
    fill: "currentColor"
  }));
};

var SvgSatisfactionDissatisfied104X104 = function SvgSatisfactionDissatisfied104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-dissatisfied",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M104 52c0-28.72-23.28-52-52-52S0 23.28 0 52c0 8.834 2.207 17.351 6.357 24.934a52.228 52.228 0 0 0 12.6 15.22C28.197 99.767 39.774 104 52 104c28.72 0 52-23.28 52-52zM2 52C2 24.385 24.385 2 52 2s50 22.385 50 50-22.385 50-50 50c-11.758 0-22.886-4.07-31.771-11.39A50.229 50.229 0 0 1 8.11 75.974C4.121 68.684 2 60.496 2 52zm33.111-12.57a7.463 7.463 0 0 0 7.463-7.463 1 1 0 1 1 2 0 9.463 9.463 0 0 1-9.463 9.463 9.463 9.463 0 0 1-9.463-9.463 1 1 0 1 1 2 0 7.463 7.463 0 0 0 7.463 7.463zm33.778 0a7.463 7.463 0 0 0 7.463-7.463 1 1 0 1 1 2 0 9.463 9.463 0 0 1-9.463 9.463 9.463 9.463 0 0 1-9.463-9.463 1 1 0 1 1 2 0 7.463 7.463 0 0 0 7.463 7.463zm1.875 38.877C62.54 65.643 45.606 62.045 32.942 70.27a1 1 0 1 1-1.09-1.677c13.591-8.827 31.763-4.965 40.59 8.625a1 1 0 0 1-1.678 1.09z",
    clipRule: "evenodd"
  }));
};

var SvgSatisfactionDissatisfied16X16 = function SvgSatisfactionDissatisfied16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-dissatisfied",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 8c0-4.42-3.58-8-8-8a7.999 7.999 0 0 0-5.084 14.177A7.966 7.966 0 0 0 8 16c4.42 0 8-3.58 8-8zM1 8c0-3.867 3.133-7 7-7s7 3.133 7 7-3.133 7-7 7a6.966 6.966 0 0 1-4.448-1.595 7.025 7.025 0 0 1-1.697-2.05A6.96 6.96 0 0 1 1 8zm4.517-2.201c.41 0 .744-.334.744-.745a.5.5 0 0 1 1 0 1.745 1.745 0 1 1-3.49 0 .5.5 0 0 1 1 0c0 .411.334.745.746.745zm4.966 0c.411 0 .745-.334.745-.745a.5.5 0 0 1 1 0 1.744 1.744 0 1 1-3.489 0 .5.5 0 0 1 1 0c0 .411.333.745.744.745zm-.02 6.263a3.668 3.668 0 0 0-5.073-1.08.5.5 0 0 1-.545-.838 4.668 4.668 0 0 1 6.458 1.373.5.5 0 1 1-.84.545z",
    clipRule: "evenodd"
  }));
};

var SvgSatisfactionDissatisfied24X24 = function SvgSatisfactionDissatisfied24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-dissatisfied",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.96 9.96 0 0 0 1.222 4.795 10.069 10.069 0 0 0 2.423 2.927A9.965 9.965 0 0 0 12 22c5.523 0 10-4.477 10-10ZM3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 8.965 8.965 0 0 1-5.72-2.05 9.07 9.07 0 0 1-2.18-2.635A8.96 8.96 0 0 1 3 12Zm5.855-2.655c.594 0 1.076-.483 1.076-1.076a.5.5 0 0 1 1 0 2.077 2.077 0 0 1-4.153 0 .5.5 0 0 1 1 0c0 .594.482 1.076 1.077 1.076Zm6.29 0c.596 0 1.078-.482 1.078-1.076a.5.5 0 0 1 1 0 2.077 2.077 0 0 1-4.153 0 .5.5 0 0 1 1 0c0 .593.482 1.076 1.076 1.076Zm.087 7.726a4.779 4.779 0 0 0-6.611-1.405.5.5 0 0 1-.545-.838 5.779 5.779 0 0 1 7.995 1.699.5.5 0 0 1-.839.544Z",
    fill: "currentColor"
  }));
};

var SvgSatisfactionDissatisfied64X64 = function SvgSatisfactionDissatisfied64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-dissatisfied",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 32C0 14.326 14.326 0 32 0s32 14.326 32 32-14.326 32-32 32a31.885 31.885 0 0 1-20.336-7.29 32.231 32.231 0 0 1-7.753-9.367A31.867 31.867 0 0 1 0 32zM32 .954C14.853.954.954 14.853.954 32c0 5.274 1.318 10.36 3.794 14.885a31.274 31.274 0 0 0 7.523 9.088A30.932 30.932 0 0 0 32 63.047c17.147 0 31.046-13.899 31.046-31.046S49.147.954 32 .954zM15.761 20.18a.477.477 0 0 1 .955 0 4.493 4.493 0 0 0 8.985 0 .477.477 0 1 1 .954 0 5.447 5.447 0 0 1-10.894 0zm21.672 0a.477.477 0 1 1 .955 0 4.492 4.492 0 0 0 8.985 0 .477.477 0 0 1 .954 0 5.447 5.447 0 0 1-10.894 0zM19.92 42.169c7.93-5.151 18.533-2.898 23.681 5.032a.477.477 0 0 1-.8.52c-4.862-7.489-14.874-9.616-22.361-4.753a.477.477 0 0 1-.52-.8z",
    clipRule: "evenodd"
  }));
};

var SvgSatisfactionNeutral104X104 = function SvgSatisfactionNeutral104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-neutral",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52 0c28.72 0 52 23.28 52 52s-23.28 52-52 52c-12.226 0-23.803-4.233-33.043-11.846a52.228 52.228 0 0 1-12.6-15.22C2.207 69.351 0 60.834 0 52 0 23.28 23.28 0 52 0zm0 2C24.385 2 2 24.385 2 52c0 8.496 2.121 16.684 6.111 23.974A50.229 50.229 0 0 0 20.23 90.61C29.114 97.93 40.242 102 52 102c27.615 0 50-22.385 50-50S79.615 2 52 2zm14.556 70.306-28.982 1.89a1 1 0 1 1-.13-1.997l28.982-1.889a1 1 0 1 1 .13 1.996zM36.509 31.47v13.582a1 1 0 1 0 2 0V31.47a1 1 0 1 0-2 0zM65.49 45.052V31.47a1 1 0 1 1 2 0v13.582a1 1 0 1 1-2 0z",
    clipRule: "evenodd"
  }));
};

var SvgSatisfactionNeutral16X16 = function SvgSatisfactionNeutral16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-neutral",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0c4.42 0 8 3.58 8 8s-3.58 8-8 8a7.966 7.966 0 0 1-5.084-1.823 8.025 8.025 0 0 1-1.938-2.34A7.999 7.999 0 0 1 8 0zm0 1a6.999 6.999 0 0 0-4.448 12.405A6.966 6.966 0 0 0 8 15c3.867 0 7-3.133 7-7s-3.133-7-7-7zm2.163 10.34-4.261.276a.5.5 0 1 1-.065-.998l4.262-.277a.5.5 0 1 1 .064.998zM5.37 4.98v1.998a.5.5 0 0 0 1 0V4.982a.5.5 0 0 0-1 0zm4.262 1.998V4.982a.5.5 0 0 1 1 0v1.998a.5.5 0 0 1-1 0z",
    clipRule: "evenodd"
  }));
};

var SvgSatisfactionNeutral24X24 = function SvgSatisfactionNeutral24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-neutral",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.965 9.965 0 0 1-6.355-2.278 10.069 10.069 0 0 1-2.423-2.927A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2Zm0 1a9 9 0 0 0-9 9 8.96 8.96 0 0 0 1.1 4.315 9.07 9.07 0 0 0 2.18 2.635A8.965 8.965 0 0 0 12 21a9 9 0 0 0 9-9 9 9 0 0 0-9-9Zm2.731 13.095-5.398.352a.5.5 0 1 1-.065-.998l5.398-.352a.5.5 0 1 1 .065.998Zm-5.93-7.92v2.53a.5.5 0 0 0 1 0v-2.53a.5.5 0 0 0-1 0Zm5.398 2.53v-2.53a.5.5 0 0 1 1 0v2.53a.5.5 0 0 1-1 0Z",
    fill: "currentColor"
  }));
};

var SvgSatisfactionNeutral64X64 = function SvgSatisfactionNeutral64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-neutral",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32 0C14.326 0 0 14.326 0 32c0 5.436 1.358 10.68 3.91 15.343a32.231 32.231 0 0 0 7.754 9.367A31.885 31.885 0 0 0 32 64c17.674 0 32-14.326 32-32S49.674 0 32 0zM.954 32C.954 14.853 14.853.954 32 .954S63.046 14.853 63.046 32 49.147 63.046 32 63.046a30.932 30.932 0 0 1-19.73-7.073 31.274 31.274 0 0 1-7.522-9.088A30.913 30.913 0 0 1 .954 32zm40.428 11.852a.465.465 0 0 0-.495-.434L23.052 44.58a.465.465 0 1 0 .06.929l17.836-1.163a.465.465 0 0 0 .434-.494zM22.617 19.366a.465.465 0 1 1 .931 0v8.358a.465.465 0 1 1-.93 0v-8.358zm18.3-.466a.465.465 0 0 0-.466.466v8.358a.465.465 0 1 0 .93 0v-8.358a.465.465 0 0 0-.464-.466z",
    clipRule: "evenodd"
  }));
};

var SvgSatisfactionSatisfied104X104 = function SvgSatisfactionSatisfied104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-satisfied",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M104 52c0-28.72-23.28-52-52-52S0 23.28 0 52c0 8.834 2.207 17.351 6.357 24.934a52.228 52.228 0 0 0 12.6 15.22C28.197 99.767 39.774 104 52 104c28.72 0 52-23.28 52-52zM2 52C2 24.385 24.385 2 52 2s50 22.385 50 50-22.385 50-50 50c-11.758 0-22.886-4.07-31.771-11.39A50.229 50.229 0 0 1 8.11 75.974C4.121 68.684 2 60.496 2 52zm33.111-19.033a7.463 7.463 0 0 0-7.463 7.463 1 1 0 1 1-2 0 9.463 9.463 0 0 1 9.463-9.463 9.463 9.463 0 0 1 9.463 9.463 1 1 0 1 1-2 0 7.463 7.463 0 0 0-7.463-7.463zm33.778 0a7.463 7.463 0 0 0-7.463 7.463 1 1 0 1 1-2 0 9.463 9.463 0 0 1 9.463-9.463 9.463 9.463 0 0 1 9.463 9.463 1 1 0 1 1-2 0 7.463 7.463 0 0 0-7.463-7.463zM41.725 81.043c14.494 4.339 29.76-3.894 34.098-18.387a1 1 0 1 1 1.916.573c-4.654 15.552-21.036 24.386-36.588 19.73a1 1 0 1 1 .574-1.916z",
    clipRule: "evenodd"
  }));
};

var SvgSatisfactionSatisfied16X16 = function SvgSatisfactionSatisfied16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-satisfied",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 8c0-4.42-3.58-8-8-8a7.999 7.999 0 0 0-5.084 14.177A7.966 7.966 0 0 0 8 16c4.42 0 8-3.58 8-8zM1 8c0-3.867 3.133-7 7-7s7 3.133 7 7-3.133 7-7 7a6.966 6.966 0 0 1-4.448-1.595 7.025 7.025 0 0 1-1.697-2.05A6.96 6.96 0 0 1 1 8zm4.516-2.446a.746.746 0 0 0-.745.745.5.5 0 0 1-1 0 1.744 1.744 0 1 1 3.489 0 .5.5 0 0 1-1 0 .744.744 0 0 0-.744-.745zm4.967 0a.745.745 0 0 0-.744.745.5.5 0 0 1-1 0 1.745 1.745 0 1 1 3.49 0 .5.5 0 0 1-1 0 .745.745 0 0 0-.746-.745zm-3.892 6.38a3.675 3.675 0 0 0 4.574-2.468.5.5 0 1 1 .958.287 4.675 4.675 0 0 1-5.819 3.138.5.5 0 1 1 .287-.958z",
    clipRule: "evenodd"
  }));
};

var SvgSatisfactionSatisfied24X24 = function SvgSatisfactionSatisfied24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-satisfied",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.96 9.96 0 0 0 1.222 4.795 10.069 10.069 0 0 0 2.423 2.927A9.965 9.965 0 0 0 12 22c5.523 0 10-4.477 10-10ZM3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 8.965 8.965 0 0 1-5.72-2.05 9.07 9.07 0 0 1-2.18-2.635A8.96 8.96 0 0 1 3 12Zm5.854-3.231c-.595 0-1.077.481-1.077 1.076a.5.5 0 0 1-1 0 2.076 2.076 0 0 1 4.153 0 .5.5 0 0 1-1 0c0-.595-.481-1.076-1.076-1.076Zm6.291 0c-.594 0-1.076.481-1.076 1.076a.5.5 0 0 1-1 0 2.076 2.076 0 1 1 4.153 0 .5.5 0 0 1-1 0c0-.595-.482-1.076-1.077-1.076Zm-4.97 8.341a4.79 4.79 0 0 0 5.962-3.215.5.5 0 0 1 .958.287 5.79 5.79 0 0 1-7.206 3.886.5.5 0 1 1 .286-.958Z",
    fill: "currentColor"
  }));
};

var SvgSatisfactionSatisfied64X64 = function SvgSatisfactionSatisfied64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -satisfaction-satisfied",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32 0C14.326 0 0 14.326 0 32c0 5.436 1.358 10.68 3.91 15.343a32.231 32.231 0 0 0 7.754 9.367A31.885 31.885 0 0 0 32 64c17.674 0 32-14.326 32-32S49.674 0 32 0zM.954 32C.954 14.853 14.853.954 32 .954S63.046 14.853 63.046 32 49.147 63.046 32 63.046a30.932 30.932 0 0 1-19.73-7.073 31.274 31.274 0 0 1-7.522-9.088A30.913 30.913 0 0 1 .954 32zm46.563 6.17a.464.464 0 0 0-.579.321c-2.694 9.193-12.18 14.42-21.189 11.666a.464.464 0 0 0-.579.321.481.481 0 0 0 .314.597c9.496 2.903 19.502-2.604 22.346-12.308a.481.481 0 0 0-.313-.597zM15.934 24.88a5.673 5.673 0 1 1 11.346 0 .465.465 0 0 1-.93 0 4.743 4.743 0 1 0-9.486 0 .465.465 0 0 1-.93 0zm26.458-5.674a5.673 5.673 0 0 0-5.673 5.674.465.465 0 1 0 .93 0 4.743 4.743 0 0 1 9.486 0 .465.465 0 1 0 .93 0 5.673 5.673 0 0 0-5.673-5.674z",
    clipRule: "evenodd"
  }));
};

var SvgSavings104X104 = function SvgSavings104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -savings",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M80.695 18.864c5.288 4.82 9.307 10.728 11.767 17.279h3.431c4.481 0 8.085 3.882 8.107 8.678v12.231c0 4.717-3.616 8.59-8.087 8.59H92.72c-2.304 6.45-6.143 12.345-11.16 17.152a1.507 1.507 0 0 1-.168.163l-.016.014-.003.003-.006.006.004-.004.001-.001.003-.003-.053.054-.005.005a9.904 9.904 0 0 1-.207.192l-.1.09c-.14.126-.2.181-.258.237-1.645 1.606-2.745 3.43-3.398 5.356-.435 1.28-.617 2.424-.637 3.234v5.537c0 3.463-2.67 6.323-5.97 6.323H27.126a.987.987 0 0 1-.205-.021h-3.919c-3.063 0-5.631-2.474-5.942-5.66-.02-.135-.022-.336-.026-1.051l-.002-.925v-1.344c-.182-4.23-1.569-8.75-4.796-12.309-3.079-3.409-5.78-7.781-7.988-12.93a43.372 43.372 0 0 1-3.123-8.935 1.416 1.416 0 0 1-.108-.382A42.227 42.227 0 0 1 0 51.179c0-12.09 5.005-23.442 14.082-31.946 8.982-8.406 20.875-13.029 33.512-13.029 4.668 0 9.266.63 13.722 1.877C64.745 3.854 69.704.937 76.392.05c.322-.035.528-.05.764-.05 2.266 0 4.352 1.332 5.447 3.44a6.858 6.858 0 0 1-.166 6.665c-1.824 3.122-2.398 6.053-1.743 8.76zm-.806 62.77.007-.008a2.43 2.43 0 0 1 .027-.03l.01-.01c.053-.057.105-.104.156-.147l.032-.03c5.017-4.812 8.772-10.68 10.94-17.088a1 1 0 0 1 .948-.679h3.904c3.335 0 6.087-2.948 6.087-6.59V44.826c-.017-3.724-2.763-6.683-6.107-6.683h-4.13a1 1 0 0 1-.942-.664c-2.357-6.6-6.363-12.546-11.703-17.344a1 1 0 0 1-.326-.635c-.85-3.292-.187-6.8 1.917-10.403a4.86 4.86 0 0 0 .12-4.732C80.07 2.9 78.659 2 77.157 2a4.95 4.95 0 0 0-.526.035c-6.398.85-11.02 3.69-14.147 7.799a1 1 0 0 1-1.078.353 48.786 48.786 0 0 0-13.811-1.983c-12.133 0-23.537 4.433-32.145 12.489C6.773 28.822 2 39.646 2 51.179c0 3.015.327 5.997.982 8.887l.003.023c.025.066.052.15.08.257a41.744 41.744 0 0 0 3.004 8.588c2.142 4.993 4.728 9.179 7.65 12.414 3.593 3.962 5.11 8.912 5.313 13.608v1.387a168.672 168.672 0 0 0 .008 1.51v.007c.001.035.005.18-.013.099l.02.134c.2 2.202 1.938 3.886 3.955 3.886h4.124c.07 0 .139.007.205.021h43.416c2.164 0 3.97-1.935 3.97-4.323v-5.561c.025-1.027.239-2.37.743-3.853.75-2.212 2.014-4.308 3.904-6.153.085-.08.154-.143.306-.281l.096-.086.033-.03c.053-.05.09-.083.09-.079zM2.986 60.097a.67.67 0 0 1 .021.189l-.021-.19zm42.533-21.433.035-.001c4.131.025 7.663 3.179 8.358 7.496a.987.987 0 0 0 1.13.825.996.996 0 0 0 .815-1.146c-.796-4.947-4.673-8.665-9.37-9.124v-5.717A.992.992 0 0 0 45.5 30a.992.992 0 0 0-.985.998v5.709C39.055 37.147 35 41.23 35 46.833c0 5.407 3.922 8.613 10.274 10.138 5.55 1.316 8.756 3.941 8.756 8.197 0 4.792-3.63 8.17-8.529 8.17-4.703 0-8.53-4.023-8.53-9.003a.992.992 0 0 0-.985-.998.992.992 0 0 0-.986.997c0 5.72 4.172 10.43 9.516 10.951v5.717c0 .552.44.998.985.998a.992.992 0 0 0 .985-.998v-5.708C51.946 74.854 56 70.77 56 65.168c0-5.41-3.941-8.638-10.274-10.14-5.567-1.336-8.755-3.943-8.755-8.195 0-4.775 3.604-8.145 8.476-8.17a.955.955 0 0 0 .072.002z",
    clipRule: "evenodd"
  }));
};

var SvgSavings16X16 = function SvgSavings16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -savings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.777 2.42c-.196.313-.27.59-.235.84a6.496 6.496 0 0 1 1.643 2.212h.27c.855 0 1.54.69 1.545 1.541v1.682c0 .84-.689 1.53-1.542 1.53h-.23a6.492 6.492 0 0 1-1.637 2.263h-.001l-.036.033-.004.004-.034.03-.022.018-.027.023c-.343.313-.473.671-.479.925v.762c0 .667-.55 1.217-1.231 1.217H4.342c-.015 0-.03 0-.045-.002h-.562c-.635 0-1.165-.481-1.212-1.027-.004-.017-.007-.024-.01-.03l-.002-.005a.766.766 0 0 1-.005-.166v-.041l-.001-.13v-.168c-.024-.51-.202-1.05-.607-1.47-.482-.496-.9-1.13-1.236-1.862a6.088 6.088 0 0 1-.48-1.273A5.777 5.777 0 0 1 0 7.887c0-1.764.78-3.42 2.189-4.653 1.386-1.214 3.219-1.88 5.162-1.88.644 0 1.28.072 1.901.217.55-.557 1.311-.94 2.302-1.063a1.271 1.271 0 0 1 1.255.645c.224.399.21.877-.032 1.267zm-.223 10.1c.006-.004.014-.013.042-.04l-.011.009.012-.013-.014.014-.09.077.033-.023a.42.42 0 0 0 .03-.026l-.002.003zm.03-.03v-.001l-.023.025-.004.004.026-.028zm-.725-.667.022-.02a5.5 5.5 0 0 0 1.531-2.224.5.5 0 0 1 .472-.325h.574a.553.553 0 0 0 .542-.56V7.016a.56.56 0 0 0-.545-.573h-.607a.5.5 0 0 1-.469-.316 5.504 5.504 0 0 0-1.62-2.244.482.482 0 0 1-.165-.279c-.145-.547-.027-1.119.327-1.686a.288.288 0 0 0 .009-.302.269.269 0 0 0-.264-.143c-.848.106-1.445.45-1.849.946a.509.509 0 0 1-.528.166 7.298 7.298 0 0 0-1.938-.26c-1.699 0-3.292.58-4.492 1.63C1.658 5.007 1 6.402 1 7.887c0 .387.044.769.133 1.137l.013.042c.095.381.233.753.42 1.12.302.655.66 1.198 1.06 1.61.596.616.843 1.37.879 2.112V14.2c0-.055.003.094 0 .108a.24.24 0 0 0 .23.22h.607c.015 0 .03 0 .045.002h6.37c.122 0 .231-.11.231-.247v-.773c.012-.503.23-1.107.797-1.624l.034-.03.022-.018c.01-.008.015-.012.011-.007-.019.02-.029.03-.034.037l.025-.026a.265.265 0 0 0 .01-.011l.006-.008zM7.612 5.54c.71.185 1.268.758 1.395 1.49a.487.487 0 0 1-.41.559.499.499 0 0 1-.576-.398.912.912 0 0 0-.931-.744c-.534.009-.897.327-.897.779 0 .379.342.637 1.03.79 1.09.239 1.81.784 1.81 1.737 0 .857-.595 1.506-1.42 1.693v.49c0 .268-.225.485-.5.485s-.5-.217-.5-.485v-.499c-.819-.213-1.42-.938-1.42-1.8 0-.267.223-.485.5-.485s.5.218.5.486c0 .494.41.893.92.893.547 0 .92-.321.92-.778 0-.38-.343-.64-1.032-.791-1.09-.242-1.808-.784-1.808-1.736 0-.857.594-1.507 1.42-1.695v-.488c0-.268.223-.485.5-.485s.5.217.5.485v.497z",
    clipRule: "evenodd"
  }));
};

var SvgSavings24X24 = function SvgSavings24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -savings",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.94 4.354c-.28.48-.378.915-.308 1.31a8.636 8.636 0 0 1 2.12 3.068h.424c1.014 0 1.819.867 1.824 1.93v2.278c0 1.048-.809 1.914-1.82 1.914h-.377a8.584 8.584 0 0 1-2.098 3.124l.009-.01.022-.024-.083.083.031-.027-.008.009-.03.027-.024.022-.047.043c-.468.458-.648.986-.657 1.376v1.031c0 .814-.633 1.492-1.426 1.492H7.366a.512.512 0 0 1-.064-.004H6.6a1.44 1.44 0 0 1-1.414-1.302l-.004-.018-.003-.013c-.004-.023-.004-.047-.005-.208V20.023c-.03-.72-.268-1.496-.812-2.096-.598-.66-1.119-1.504-1.54-2.485a8.442 8.442 0 0 1-.6-1.71.458.458 0 0 1-.02-.079A8.193 8.193 0 0 1 2 11.847c0-2.34.969-4.537 2.722-6.18 1.732-1.62 4.025-2.512 6.458-2.512.829 0 1.649.104 2.446.309.68-.763 1.632-1.287 2.873-1.452a1.465 1.465 0 0 1 1.479.796 1.59 1.59 0 0 1-.037 1.546Zm-.918 12.896.002-.002.005-.004-.006.006Zm0 0a.258.258 0 0 0-.03.029l-.01.008a.438.438 0 0 0-.018.02c.005-.006 0-.001-.012.01l-.029.025-.04.037c-.687.671-.95 1.446-.965 2.087v1.042c0 .276-.201.492-.426.492H7.43a.512.512 0 0 0-.064-.004h-.767c-.21 0-.402-.186-.425-.44v-.13l-.001-.167v-.258c-.04-.954-.344-1.944-1.07-2.746-.52-.573-.983-1.323-1.37-2.225a7.537 7.537 0 0 1-.543-1.547 1.604 1.604 0 0 0-.016-.059l-.005-.013A7.19 7.19 0 0 1 3 11.847c.001-2.061.854-3.995 2.407-5.45C6.95 4.95 8.999 4.155 11.18 4.155c.845 0 1.679.12 2.484.357a.5.5 0 0 0 .539-.177c.533-.7 1.32-1.185 2.427-1.331A.449.449 0 0 1 16.686 3c.16 0 .317.1.405.271a.59.59 0 0 1-.014.58c-.428.731-.568 1.462-.394 2.156a.5.5 0 0 0 .159.29A7.625 7.625 0 0 1 18.936 9.4a.5.5 0 0 0 .471.332h.769c.445 0 .821.406.824.933v2.275c0 .51-.377.914-.82.914h-.727a.5.5 0 0 0-.474.34 7.646 7.646 0 0 1-1.957 3.056ZM3.188 13.543a3.212 3.212 0 0 0-.014-.118l.002.008.012.11Zm8.188-4.748c.9.205 1.611.955 1.768 1.92a.5.5 0 1 1-.987.16c-.106-.655-.644-1.13-1.269-1.136a.535.535 0 0 1-.024 0c-.752.005-1.286.5-1.286 1.211 0 .613.485 1.004 1.412 1.225 1.323.308 2.186 1.006 2.186 2.197 0 1.117-.756 1.96-1.8 2.165v.792a.5.5 0 0 1-1 0v-.8c-1.032-.236-1.798-1.184-1.798-2.313a.5.5 0 0 1 1 0c0 .752.572 1.355 1.274 1.368a.48.48 0 0 1 .05 0c.745-.01 1.274-.504 1.274-1.211 0-.614-.49-1.009-1.415-1.225-1.326-.316-2.183-1.007-2.183-2.197 0-1.116.755-1.96 1.798-2.165v-.791a.5.5 0 0 1 1 0v.8Z",
    fill: "currentColor"
  }));
};

var SvgSearch104X104 = function SvgSearch104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -search",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.696 0c21.37 0 38.695 17.325 38.695 38.695 0 10.326-4.044 19.707-10.635 26.646l36.951 36.952a.999.999 0 1 1-1.414 1.414L65.342 66.756c-6.939 6.591-16.32 10.636-26.646 10.636C17.325 77.392 0 60.067 0 38.695 0 17.325 17.325 0 38.696 0zm0 2C18.429 2 2 18.43 2 38.695c0 20.268 16.43 36.697 36.696 36.697s36.695-16.43 36.695-36.697C75.391 18.429 58.961 2 38.696 2z",
    clipRule: "evenodd"
  }));
};

var SvgSearch16X16 = function SvgSearch16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.043 0a6.042 6.042 0 0 1 4.612 9.949l5.198 5.197a.5.5 0 0 1-.707.707l-5.198-5.197A6.043 6.043 0 0 1 0 6.044 6.042 6.042 0 0 1 6.043 0zm0 1A5.042 5.042 0 0 0 1 6.044a5.043 5.043 0 1 0 10.086 0A5.042 5.042 0 0 0 6.043 1z",
    clipRule: "evenodd"
  }));
};

var SvgSearch24X24 = function SvgSearch24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -search",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m15.182 14.475 6.671 6.671a.5.5 0 1 1-.707.708l-6.67-6.672A7.523 7.523 0 1 1 9.522 2a7.521 7.521 0 0 1 5.66 12.475zM9.522 3a6.522 6.522 0 1 0 0 13.044A6.522 6.522 0 0 0 9.522 3z"
  }));
};

var SvgSettings104X104 = function SvgSettings104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -settings",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M92.388 57.688a40.215 40.215 0 0 0 0-11.375l8.359-8.044a4.079 4.079 0 0 0 .703-4.986l-8.442-14.557a4.116 4.116 0 0 0-4.688-1.888l-11.428 3.26a40.242 40.242 0 0 0-9.548-5.372L64.421 3.098A4.106 4.106 0 0 0 60.443 0H43.559a4.105 4.105 0 0 0-3.986 3.098l-3.034 12.088a40.253 40.253 0 0 0-8.675 5.112l-12.181-3.47a4.117 4.117 0 0 0-4.69 1.888L2.554 33.28a4.078 4.078 0 0 0 .7 4.99l9.288 8.94a39.078 39.078 0 0 0 0 9.588l-9.287 8.934a4.079 4.079 0 0 0-.704 4.986l8.442 14.558a4.119 4.119 0 0 0 4.689 1.887l12.182-3.46a40.283 40.283 0 0 0 8.677 5.117l3.035 12.088A4.104 4.104 0 0 0 43.559 104h16.882a4.107 4.107 0 0 0 3.98-3.098l2.916-11.616a40.219 40.219 0 0 0 9.548-5.374l11.427 3.26a4.117 4.117 0 0 0 4.69-1.887l8.441-14.557a4.078 4.078 0 0 0-.704-4.986l-8.35-8.054zm-2.062.207c-.05.321.06.646.294.872l8.723 8.412c.694.667.842 1.718.36 2.55l-8.441 14.556a2.104 2.104 0 0 1-2.397.965l-11.915-3.4a1.008 1.008 0 0 0-.896.174 38.21 38.21 0 0 1-9.923 5.584 1.002 1.002 0 0 0-.616.692l-3.042 12.116A2.099 2.099 0 0 1 60.439 102h-16.88a2.097 2.097 0 0 1-2.036-1.58l-3.155-12.568a1.002 1.002 0 0 0-.587-.68 38.27 38.27 0 0 1-9.073-5.354 1.008 1.008 0 0 0-.902-.18L15.129 85.24a2.106 2.106 0 0 1-2.398-.964L4.29 69.717a2.085 2.085 0 0 1 .36-2.548l9.65-9.283a.997.997 0 0 0 .297-.854 37.081 37.081 0 0 1 0-10.058.998.998 0 0 0-.297-.854l-9.65-9.289a2.085 2.085 0 0 1-.359-2.551l8.442-14.564a2.105 2.105 0 0 1 2.398-.966l12.674 3.611c.312.09.648.022.902-.179a38.249 38.249 0 0 1 9.073-5.348c.292-.122.51-.374.587-.68l3.155-12.57A2.098 2.098 0 0 1 43.559 2h16.882c.96.002 1.798.654 2.031 1.584l3.05 12.129c.08.317.31.575.616.691a38.228 38.228 0 0 1 9.923 5.583c.253.197.586.262.895.173l11.917-3.4a2.104 2.104 0 0 1 2.395.966l8.442 14.557c.482.83.334 1.882-.36 2.548l-8.729 8.401a.997.997 0 0 0-.294.873c.61 3.907.61 7.883 0 11.79zM52 28.9c12.813 0 23.2 10.342 23.2 23.1 0 12.758-10.386 23.1-23.2 23.1S28.8 64.758 28.8 52c0-12.758 10.387-23.1 23.2-23.1zm0 2C40.296 30.9 30.81 40.347 30.81 52c0 11.654 9.487 21.1 21.191 21.1 11.704 0 21.191-9.446 21.191-21.1 0-11.653-9.487-21.1-21.19-21.1z",
    clipRule: "evenodd"
  }));
};

var SvgSettings16X16 = function SvgSettings16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.099 7.295 1.107-1.06a.948.948 0 0 0 .166-1.163l-1.25-2.141a.967.967 0 0 0-1.1-.44l-1.52.43a6.31 6.31 0 0 0-1.181-.66L9.931.722A.96.96 0 0 0 9.002 0H6.502a.961.961 0 0 0-.935.725l-.407 1.61c-.37.17-.722.377-1.052.615l-1.63-.46a.965.965 0 0 0-1.1.44L.13 5.07a.946.946 0 0 0 .164 1.163L1.542 7.43c-.035.38-.035.762 0 1.142L.294 9.765a.95.95 0 0 0-.166 1.164l1.25 2.141a.97.97 0 0 0 1.099.44l1.631-.46c.33.238.682.445 1.052.616l.407 1.612a.962.962 0 0 0 .935.722H9a.96.96 0 0 0 .933-.724l.388-1.535c.417-.178.812-.4 1.18-.66l1.521.43a.967.967 0 0 0 1.1-.439l1.249-2.141a.948.948 0 0 0-.165-1.163l-1.106-1.062c.053-.469.053-.942 0-1.411zm-.405 5.246-1.784-.49a.539.539 0 0 0-.465.086 5.54 5.54 0 0 1-1.42.77.508.508 0 0 0-.319.346L9.25 15H6.75l-.472-1.813a.507.507 0 0 0-.305-.34 5.517 5.517 0 0 1-1.298-.738.539.539 0 0 0-.468-.09l-1.9.52-1.252-2.079 1.447-1.34a.488.488 0 0 0 .155-.427 4.965 4.965 0 0 1 0-1.384.488.488 0 0 0-.155-.426L1.055 5.54l1.252-2.08 1.899.52a.539.539 0 0 0 .467-.09 5.55 5.55 0 0 1 1.3-.737.507.507 0 0 0 .304-.34L6.749 1H9.25l.457 1.75c.042.158.161.287.32.345.51.187.988.446 1.419.77a.539.539 0 0 0 .465.087l1.783-.49 1.252 2.078-1.306 1.212a.488.488 0 0 0-.153.436 5.056 5.056 0 0 1 0 1.625c-.026.16.03.323.153.436l1.305 1.213-1.251 2.079zM8 4.25c2.159 0 3.91 1.678 3.91 3.75 0 2.07-1.751 3.75-3.91 3.75-2.16 0-3.91-1.68-3.91-3.75 0-2.072 1.75-3.75 3.91-3.75zm0 1C6.416 5.25 5.133 6.48 5.133 8S6.416 10.75 8 10.75c1.583 0 2.866-1.232 2.866-2.75S9.583 5.25 8 5.25z",
    clipRule: "evenodd"
  }));
};

var SvgSettings24X24 = function SvgSettings24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    role: "img",
    className: "icon -settings"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M12 7.383c2.526 0 4.575 2.067 4.575 4.617S14.526 16.616 12 16.616c-2.526 0-4.575-2.067-4.575-4.616 0-2.55 2.049-4.617 4.575-4.617zm0 1c-1.979 0-3.584 1.62-3.584 3.617 0 1.997 1.605 3.616 3.584 3.616s3.584-1.62 3.584-3.616c0-1.997-1.605-3.617-3.584-3.617zm7.751 2.674c.075.627.075 1.26 0 1.887l1.422 1.39c.353.342.428.885.182 1.311l-1.55 2.711a1.061 1.061 0 0 1-1.217.497l-1.952-.564a7.692 7.692 0 0 1-1.554.886l-.497 2.01A1.07 1.07 0 0 1 13.55 22H10.45a1.07 1.07 0 0 1-1.035-.815l-.52-2.103A7.705 7.705 0 0 1 7.5 18.25l-2.089.601a1.06 1.06 0 0 1-1.217-.495l-1.552-2.713a1.084 1.084 0 0 1 .184-1.311l1.596-1.557a7.696 7.696 0 0 1 0-1.55L2.825 9.669a1.083 1.083 0 0 1-.181-1.312l1.55-2.714a1.062 1.062 0 0 1 1.217-.495l2.089.602c.434-.325.9-.603 1.393-.83l.521-2.103C9.532 2.336 9.96 2 10.45 2h3.102c.49 0 .915.336 1.034.814l.498 2.011c.55.234 1.071.531 1.554.887l1.952-.564c.47-.137.972.069 1.217.496l1.552 2.712c.244.427.168.967-.183 1.311l-1.424 1.389zm-1.015 1.993a6.899 6.899 0 0 0 0-2.1.503.503 0 0 1 .146-.436l1.604-1.565a.077.077 0 0 0 .013-.092l-1.552-2.712a.074.074 0 0 0-.085-.035l-2.19.633a.492.492 0 0 1-.441-.087 6.687 6.687 0 0 0-1.743-.993.498.498 0 0 1-.305-.346l-.56-2.26a.075.075 0 0 0-.072-.056H10.45a.075.075 0 0 0-.073.057l-.58 2.34a.499.499 0 0 1-.29.34 6.727 6.727 0 0 0-1.593.953.492.492 0 0 1-.445.09l-2.331-.673a.075.075 0 0 0-.085.035l-1.55 2.714a.076.076 0 0 0 .012.092l1.774 1.73c.113.11.168.27.146.427a6.685 6.685 0 0 0 0 1.789.503.503 0 0 1-.146.427l-1.774 1.729a.077.077 0 0 0-.013.092l1.552 2.713c.017.03.051.044.086.034l2.33-.67a.492.492 0 0 1 .444.09c.485.39 1.021.71 1.595.952a.499.499 0 0 1 .289.34l.578 2.34c.009.034.04.059.074.059h3.1a.077.077 0 0 0 .074-.059l.56-2.257a.498.498 0 0 1 .303-.346 6.703 6.703 0 0 0 1.744-.993.492.492 0 0 1 .441-.087l2.19.633a.074.074 0 0 0 .086-.035l1.55-2.713a.075.075 0 0 0-.012-.091l-1.604-1.567a.503.503 0 0 1-.145-.436z"
  }));
};

var SvgShare104X104 = function SvgShare104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -share",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M104 18c0-9.941-8.059-18-18-18S68 8.059 68 18c0 2.565.536 5.004 1.503 7.212L33.594 43.004C30.482 37.62 24.664 34 18 34 8.059 34 0 42.059 0 52s8.059 18 18 18c6.664 0 12.482-3.621 15.594-9.004l35.909 17.792A17.94 17.94 0 0 0 68 86c0 9.941 8.059 18 18 18s18-8.059 18-18-8.059-18-18-18c-6.664 0-12.482 3.621-15.594 9.003L34.497 59.212A17.94 17.94 0 0 0 36 52a17.94 17.94 0 0 0-1.503-7.212l35.909-17.792C73.518 32.38 79.336 36 86 36c9.941 0 18-8.059 18-18zM71.584 79.05a1 1 0 0 0 .273-.54C74.544 73.449 79.87 70 86 70c8.837 0 16 7.163 16 16s-7.163 16-16 16-16-7.163-16-16c0-2.49.57-4.848 1.584-6.95zm.182-53.844c.045.092.076.187.091.283C74.544 30.552 79.87 34 86 34c8.837 0 16-7.163 16-16S94.837 2 86 2 70 9.163 70 18c0 2.49.569 4.848 1.584 6.95a1 1 0 0 1 .182.256zM32.143 44.512C29.457 39.447 24.131 36 18 36 9.163 36 2 43.163 2 52s7.163 16 16 16c6.131 0 11.457-3.448 14.143-8.511a1 1 0 0 1 .273-.539A15.937 15.937 0 0 0 34 52c0-2.49-.57-4.849-1.585-6.95a1 1 0 0 1-.272-.538z",
    clipRule: "evenodd"
  }));
};

var SvgShare16X16 = function SvgShare16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -share",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 3a3 3 0 1 0-5.867.885L5.417 6.222a3 3 0 1 0 0 3.556l4.716 2.337A3.003 3.003 0 0 0 13 16a3 3 0 1 0-2.417-4.778L5.867 8.885a3 3 0 0 0 0-1.77l4.716-2.337A3 3 0 0 0 16 3zm-4.82 9.168a.506.506 0 0 0 .071-.14A2 2 0 0 1 15 13a2 2 0 1 1-3.82-.832zm.043-8.265c.012.023.02.046.028.069A2 2 0 0 0 15 3a2 2 0 1 0-3.82.832c.017.022.03.046.043.071zM4.748 7.027A2 2 0 0 0 1 8a2 2 0 0 0 3.748.973.503.503 0 0 1 .072-.142 1.993 1.993 0 0 0 0-1.662.503.503 0 0 1-.072-.142z",
    clipRule: "evenodd"
  }));
};

var SvgShare24X24 = function SvgShare24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -share"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M15.315 16.25a3.666 3.666 0 1 1-.45.893l-6.18-3.061a3.667 3.667 0 1 1 0-4.164l6.18-3.062a3.666 3.666 0 1 1 .45.893l-6.18 3.062a3.664 3.664 0 0 1 0 2.378l6.18 3.062zm.678.805a.504.504 0 0 1-.077.151 2.666 2.666 0 1 0 .076-.151zm0-10.11a2.666 2.666 0 1 0-.077-.153.503.503 0 0 1 .077.154zm-7.91 3.928a.503.503 0 0 1-.075-.15 2.667 2.667 0 1 0 0 2.556.504.504 0 0 1 .076-.153c.16-.342.249-.724.249-1.126 0-.403-.09-.785-.25-1.127z"
  }));
};

var SvgShip104X104 = function SvgShip104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -ship",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30.6 24.007v11.588A237.251 237.251 0 0 0 19 38.129V24.007h11.6zm2-1.004V35.22c8.592-1.573 17.06-2.604 25.07-2.9a122.91 122.91 0 0 1 4.53-.085c.195 0 .385.057.548.164l17.77 11.664a307.462 307.462 0 0 1 22.389-2.954 1.002 1.002 0 0 1 1.093.999c0 12.984-5.59 25.168-20.884 39.62a.998.998 0 0 1-.686.273H1c-.552 0-1-.45-1-1.003V67.863c0-.4.237-.762.602-.92a173.199 173.199 0 0 1 2.803-1.165 281.38 281.38 0 0 1 6.795-2.646V41.254c0-.442.288-.832.71-.96a98.97 98.97 0 0 1 1.197-.35 170.33 170.33 0 0 1 3.342-.913c.51-.134 1.026-.268 1.551-.402V23.003c0-.554.448-1.003 1-1.003h13.6c.552 0 1 .45 1 1.003zM11.097 64.938a.996.996 0 0 0 .83-.31l.072-.026c8.463-3.143 17.92-6.287 28.138-9.221 13.254-3.807 26.667-6.943 40.033-9.225a1 1 0 0 0 .747-.126 306.57 306.57 0 0 1 21.069-2.818c-.31 11.923-5.706 23.237-19.954 36.781H2V68.527l.096-.04c.582-.245 1.269-.53 2.059-.85a281.073 281.073 0 0 1 6.942-2.7zm66.53-20.375c-12.71 2.257-25.447 5.272-38.04 8.889A395.18 395.18 0 0 0 12.2 62.389V42.005l.454-.13c.954-.272 2.06-.576 3.302-.903 3.553-.935 7.49-1.87 11.703-2.744 10.313-2.137 20.541-3.551 30.084-3.903 1.41-.052 2.796-.08 4.16-.084l15.723 10.322z",
    clipRule: "evenodd"
  }));
};

var SvgShip16X16 = function SvgShip16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -ship",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.453 5.95a.483.483 0 0 1 .384.134c.103.1.163.241.163.39 0 1.386-.33 3.555-3.183 6.383a.49.49 0 0 1-.343.143H.5a.513.513 0 0 1-.5-.526v-2.027c0-.21.118-.399.3-.482.017-.008.451-.203 1.2-.5V6.341c0-.231.144-.437.354-.504.037-.012.273-.085.646-.19V3.526c0-.29.223-.526.5-.526h2c.276 0 .5.236.5.526v1.441c1.22-.216 2.622-.388 4-.388.097 0 .192.03.273.086l2.504 1.724a42.379 42.379 0 0 1 3.176-.44zM3.5 4.052h1v1.11c-.363.075-.698.152-1 .225V4.053zm5.851 1.579c-2.843.027-5.842.817-6.851 1.108v2.339a57.052 57.052 0 0 1 8.346-2.417l-1.495-1.03zM1 11.947h11.274c2.062-2.09 2.59-3.68 2.7-4.89a43.267 43.267 0 0 0-2.72.403l-.013.002c-4.302.77-8.018 2.062-10.003 2.834a.47.47 0 0 1-.119.047c-.495.194-.88.354-1.119.456v1.148z",
    clipRule: "evenodd"
  }));
};

var SvgShip24X24 = function SvgShip24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -ship",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M2.3 14.306V9.591c0-.22.144-.414.355-.477l.274-.08a38.917 38.917 0 0 1 .904-.244V5.499a.5.5 0 0 1 .5-.499H7.4a.5.5 0 0 1 .5.499V7.91c1.84-.322 3.65-.534 5.371-.596.349-.013.692-.02 1.029-.02a.5.5 0 0 1 .274.082l3.916 2.557a69.884 69.884 0 0 1 4.963-.648.5.5 0 0 1 .547.497c0 2.99-1.293 5.792-4.796 9.083a.5.5 0 0 1-.343.135H.5a.5.5 0 0 1-.5-.499v-2.945c0-.198.118-.378.301-.457a30.2 30.2 0 0 1 .639-.264c.403-.163.858-.34 1.36-.529zm.525.87A62.974 62.974 0 0 0 1 15.887v2.115h17.662c2.977-2.835 4.17-5.205 4.321-7.67-1.45.149-2.91.347-4.372.591a.503.503 0 0 1-.257.043A84.23 84.23 0 0 0 9.4 13.021a88.53 88.53 0 0 0-6.294 2.05.498.498 0 0 1-.282.104zm.475-1.238a90.175 90.175 0 0 1 5.825-1.876 86.446 86.446 0 0 1 7.927-1.876l-2.9-1.894c-.277.002-.559.008-.844.018-2.136.079-4.429.394-6.742.87a51.38 51.38 0 0 0-3.266.786v3.972zm1.533-5.396A53.76 53.76 0 0 1 6.9 8.096V5.998H4.833v2.544z"
  }));
};

var SvgSmartphone104X104 = function SvgSmartphone104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -smartphone",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M82 96.956c0 3.89-3.164 7.044-7.068 7.044H29.07C25.164 104 22 100.846 22 96.956V7.045C22 3.154 25.164 0 29.069 0h45.863C78.836 0 82 3.154 82 7.045v89.911zM79.993 7.045c0-2.787-2.265-5.045-5.06-5.045H29.068c-2.796 0-5.062 2.258-5.062 5.045v89.911c0 2.786 2.266 5.044 5.062 5.044h45.863c2.795 0 5.061-2.258 5.061-5.044V7.045zM52 93.405c2.733 0 4.948-2.209 4.948-4.933S54.733 83.54 52 83.54c-2.732 0-4.948 2.208-4.948 4.932s2.216 4.932 4.948 4.932z",
    clipRule: "evenodd"
  }));
};

var SvgSmartphone16X16 = function SvgSmartphone16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -smartphone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.361 15a.39.39 0 0 0 .389-.389V1.388A.389.389 0 0 0 11.361 1H4.639a.389.389 0 0 0-.389.388v13.223a.39.39 0 0 0 .389.389h6.722zM4.639 0h6.722a1.39 1.39 0 0 1 1.389 1.388v13.223A1.39 1.39 0 0 1 11.361 16H4.639a1.39 1.39 0 0 1-1.389-1.389V1.388A1.39 1.39 0 0 1 4.639 0zm2.636 13.363a.726.726 0 1 1 1.451 0 .726.726 0 0 1-1.451 0z",
    clipRule: "evenodd"
  }));
};

var SvgSmartphone24X24 = function SvgSmartphone24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -smartphone",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M19 22.137A1.86 1.86 0 0 1 17.141 24H6.86A1.86 1.86 0 0 1 5 22.137V1.863A1.86 1.86 0 0 1 6.859 0H17.14A1.86 1.86 0 0 1 19 1.863v20.274zm-.998-20.274a.862.862 0 0 0-.86-.863H6.858a.862.862 0 0 0-.861.863v20.274c0 .477.385.863.86.863h10.283a.862.862 0 0 0 .861-.863V1.863zM13.11 20.224A1.11 1.11 0 1 1 12 19.112c.613 0 1.11.498 1.11 1.112z"
  }));
};

var SvgSmartphoneAdd104X104 = function SvgSmartphoneAdd104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -smartphone-add",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M70 96.955v-45.03C83.425 50.902 94 39.686 94 26 94 12.13 83.138.796 69.457.04a1.006 1.006 0 0 0-.283-.04H17.068C13.164 0 10 3.154 10 7.045v89.91c0 3.891 3.164 7.045 7.068 7.045H62.93c3.905 0 7.069-3.154 7.069-7.045zm-2.007 0V52C53.637 51.997 42 40.357 42 26c0-10.81 6.596-20.078 15.983-24H17.068c-2.796 0-5.061 2.258-5.061 5.045v89.91c0 2.787 2.265 5.045 5.06 5.045h45.864c2.796 0 5.062-2.258 5.062-5.045zM43.99 26c0-13.027 10.374-23.63 23.312-24h1.396c12.937.37 23.312 10.973 23.312 24 0 13.26-10.75 24.01-24.01 24.01-13.26 0-24.01-10.75-24.01-24.01zm11.995-1H67V13.985c0-.544.448-.985 1-.985s1 .441 1 .985V25h11.015c.544 0 .985.447.985.999a.992.992 0 0 1-.985.998H69v11.018c0 .544-.448.985-1 .985s-1-.44-1-.984V26.997H55.985A.992.992 0 0 1 55 26c0-.552.44-.999.985-.999zM39.999 93A5 5 0 1 0 40 83a5 5 0 0 0 0 10z",
    clipRule: "evenodd"
  }));
};

var SvgSmartphoneAdd16X16 = function SvgSmartphoneAdd16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -smartphone-add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.9 14.612v-6.25A4.195 4.195 0 1 0 9.651.067.498.498 0 0 0 9.401 0H2.788C2.022 0 1.4.622 1.4 1.389v13.223c0 .767.622 1.388 1.39 1.388h6.72c.768 0 1.39-.621 1.39-1.388zm-1 0v-6.25A4.197 4.197 0 0 1 7.682 1H2.789a.389.389 0 0 0-.389.389v13.223c0 .214.174.388.39.388h6.72c.216 0 .39-.174.39-.388zm.5-13.611a3.195 3.195 0 1 1 0 6.39 3.196 3.196 0 1 1 0-6.39zM8.57 3.697H9.9V2.366a.5.5 0 1 1 1 0v1.33h1.33a.5.5 0 0 1 0 1H10.9v1.33a.5.5 0 0 1-1 0v-1.33H8.57a.5.5 0 0 1 0-1zM6.15 14.09a.726.726 0 1 0-.001-1.452.726.726 0 0 0 .001 1.452z",
    clipRule: "evenodd"
  }));
};

var SvgSmartphoneAdd24X24 = function SvgSmartphoneAdd24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    role: "img",
    className: "icon -smartphone-add"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M16.184 6.667v2.307a.5.5 0 1 1-1 0V6.667h-2.307a.5.5 0 1 1 0-1h2.307V3.361a.5.5 0 1 1 1 0v2.306h2.307a.5.5 0 1 1 0 1h-2.307zm0 5.647v9.823c0 1.03-.834 1.863-1.863 1.863H4.013a1.863 1.863 0 0 1-1.863-1.863V1.863C2.15.833 2.984 0 4.013 0H14.15c.123 0 .236.045.323.119a6.167 6.167 0 1 1 1.71 12.195zM12.316 1H4.013a.863.863 0 0 0-.863.863v20.274c0 .477.386.863.863.863h10.308a.863.863 0 0 0 .863-.863v-9.823A6.168 6.168 0 0 1 12.316 1zm8.535 5.167a5.167 5.167 0 1 0-10.335 0 5.167 5.167 0 0 0 10.335 0zM10.279 20.224a1.112 1.112 0 1 1-2.225 0 1.112 1.112 0 0 1 2.225 0z"
  }));
};

var SvgSmartwatch104X104 = function SvgSmartwatch104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -smartwatch",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M73.909 20.7h9.109v62.6H20.982V20.7h52.927zM72.918 2v16.7H31.082V2h41.836zM29.1 1.2v17.5h-8.316c-.985 0-1.784.805-1.784 1.8v63c0 .994.798 1.8 1.784 1.8H29.1v17.5c0 .664.534 1.2 1.19 1.2h43.42c.656 0 1.19-.536 1.19-1.2V85.3h8.316c.986 0 1.784-.806 1.784-1.8v-63c0-.995-.798-1.8-1.784-1.8H74.9V1.2c0-.664-.534-1.2-1.19-1.2H30.29c-.657 0-1.19.536-1.19 1.2zm43.817 84.1H31.082V102h41.836V85.3z",
    clipRule: "evenodd"
  }));
};

var SvgSmartwatch16X16 = function SvgSmartwatch16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -smartwatch",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.75 2.75V.7a.7.7 0 0 0-.7-.7H4.95a.7.7 0 0 0-.7.7v2.05H4.05a1.3 1.3 0 0 0-1.3 1.3v7.9a1.3 1.3 0 0 0 1.3 1.3h.2v2.05a.7.7 0 0 0 .698.7h6.103a.7.7 0 0 0 .7-.7v-2.05h.199a1.3 1.3 0 0 0 1.3-1.3v-7.9a1.3 1.3 0 0 0-1.3-1.3h-.2zm-.999 10.5H5.25V15h5.502v-1.75zm.5-1h.699a.3.3 0 0 0 .3-.3v-7.9a.3.3 0 0 0-.3-.3h-7.9a.3.3 0 0 0-.3.3v7.9a.3.3 0 0 0 .3.3h7.201zm-.5-9.5H5.249V1h5.502v1.75z",
    clipRule: "evenodd"
  }));
};

var SvgSmartwatch24X24 = function SvgSmartwatch24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -smartwatch",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.496.7v3.517h1a1.3 1.3 0 0 1 1.303 1.3v12.966c0 .718-.583 1.3-1.302 1.3h-1V23.3a.7.7 0 0 1-.702.7h-9.59a.7.7 0 0 1-.702-.7v-3.517H5.502c-.72 0-1.303-.582-1.303-1.3V5.516a1.3 1.3 0 0 1 1.303-1.299h1V.7c0-.386.315-.7.702-.7h9.59a.7.7 0 0 1 .702.7Zm-.487 18.083H7.004a.68.68 0 0 0-.014 0H5.502a.3.3 0 0 1-.3-.3V5.516a.3.3 0 0 1 .3-.299h12.995a.3.3 0 0 1 .3.3v12.966a.3.3 0 0 1-.3.3h-1.488Zm-9.504 1V23h8.989v-3.217H7.505ZM7.505 1h8.989v3.217h-8.99V1Z",
    fill: "currentColor"
  }));
};

var SvgSocialCapital104X104 = function SvgSocialCapital104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -social-capital",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.11 5.73a34 34 0 0 1 52.401 34.014A34 34 0 1 1 52 98.844a34.003 34.003 0 0 1-42.042-4.803 34 34 0 0 1 8.53-54.297A34 34 0 0 1 33.112 5.73Zm36.668 1.663a32 32 0 1 0-35.556 53.215A32 32 0 0 0 69.778 7.393Zm-23.82 86.649a33.995 33.995 0 0 0 4.209 3.574 32 32 0 1 1-31.264-55.831 34 34 0 0 0 17.586 22.47 34 34 0 0 0 9.47 29.787ZM38.37 65.148a31.994 31.994 0 0 0 5.023 22.63 32 32 0 1 0 41.704-45.993A34 34 0 0 1 38.37 65.148ZM52 12.42a1 1 0 0 1 1 1v3.914a9.59 9.59 0 0 1 8.436 7.928 1 1 0 0 1-1.972.336A7.59 7.59 0 0 0 52 19.28c-4.305 0-7.58 2.793-7.58 6.87 0 2.014.886 3.45 2.287 4.537 1.44 1.117 3.424 1.852 5.52 2.339 2.215.514 4.525 1.338 6.299 2.717 1.812 1.408 3.065 3.4 3.065 6.127 0 5.052-3.869 8.41-8.59 8.826V54.6a1 1 0 1 1-2 0v-3.912a9.581 9.581 0 0 1-8.58-9.528 1 1 0 1 1 2 0A7.58 7.58 0 0 0 52 48.74c4.298 0 7.59-2.795 7.59-6.87 0-2.014-.887-3.456-2.292-4.548-1.444-1.121-3.43-1.862-5.524-2.348-2.214-.514-4.521-1.333-6.293-2.706-1.81-1.404-3.061-3.392-3.061-6.118 0-5.051 3.85-8.41 8.58-8.826V13.42a1 1 0 0 1 1-1Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  }))));
};

var SvgSocialCapital16X16 = function SvgSocialCapital16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -social-capital",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.084.881A5.23 5.23 0 0 1 7.99 0a5.24 5.24 0 0 1 5.155 6.114A5.238 5.238 0 0 1 16 10.77a5.23 5.23 0 0 1-8 4.436 5.226 5.226 0 0 1-3.79.694 5.23 5.23 0 0 1-1.374-9.78A5.23 5.23 0 0 1 5.084.881Zm5.253.837A4.23 4.23 0 0 0 7.99 1a4.24 4.24 0 0 0-4.24 4.23 4.23 4.23 0 1 0 6.587-3.512Zm-3.265 12.75.07.07A4.232 4.232 0 0 1 .99 10.77a4.23 4.23 0 0 1 2.118-3.665A5.23 5.23 0 0 0 5.615 9.89a5.23 5.23 0 0 0 1.457 4.58Zm-.511-4.207a4.23 4.23 0 1 0 6.311-3.156 5.228 5.228 0 0 1-6.311 3.156ZM7.99 1.57a.5.5 0 0 1 .5.5v.352a1.83 1.83 0 0 1 1.292 1.44.5.5 0 1 1-.985.174.83.83 0 0 0-.844-.688.73.73 0 0 0-.783.683c.003.18.077.305.22.416.164.128.413.227.71.295.363.082.774.223 1.104.48A1.5 1.5 0 0 1 9.81 6.44v.007a1.73 1.73 0 0 1-1.32 1.657V8.4a.5.5 0 0 1-1 0v-.32a1.82 1.82 0 0 1-1.32-1.75.5.5 0 0 1 1 0 .82.82 0 0 0 .857.821.73.73 0 0 0 .783-.714.502.502 0 0 0-.22-.425c-.164-.128-.413-.227-.71-.294-.363-.083-.774-.224-1.105-.48a1.5 1.5 0 0 1-.605-1.24 1.73 1.73 0 0 1 1.32-1.602V2.07a.5.5 0 0 1 .5-.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
};

var SvgSocialCapital24X24 = function SvgSocialCapital24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -social-capital",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.183 2.658A6.87 6.87 0 0 1 12 1.5a6.86 6.86 0 0 1 6.772 8.025A6.878 6.878 0 0 1 22.5 15.63a6.87 6.87 0 0 1-10.508 5.828 6.872 6.872 0 0 1-8.476-.977 6.87 6.87 0 0 1 1.71-10.97 6.87 6.87 0 0 1 2.957-6.853Zm7.078.831A5.87 5.87 0 0 0 12 2.5a5.88 5.88 0 0 0-5.87 5.87 5.87 5.87 0 1 0 9.131-4.88Zm-4.489 16.999c.111.11.226.218.344.32a5.869 5.869 0 0 1-5.643-10.293 6.87 6.87 0 0 0 3.384 3.964 6.87 6.87 0 0 0 1.915 6.009ZM9.81 14.88a5.87 5.87 0 1 0 8.715-4.358 6.868 6.868 0 0 1-8.715 4.358ZM12 3.69a.5.5 0 0 1 .5.5v.56a2.25 2.25 0 0 1 1.703 1.804.5.5 0 0 1-.985.172 1.25 1.25 0 0 0-1.254-1.037 1.12 1.12 0 0 0-1.203 1.095c0 .323.13.529.346.693.24.182.592.31 1.006.406.465.107.982.286 1.39.61.43.342.728.837.728 1.507v.02a2.112 2.112 0 0 1-1.73 1.99v.49a.5.5 0 1 1-1 0v-.514A2.231 2.231 0 0 1 9.76 9.81a.5.5 0 0 1 1 0 1.23 1.23 0 0 0 1.237 1.23l.04.001A1.11 1.11 0 0 0 13.23 9.99a.86.86 0 0 0-.35-.714c-.24-.19-.588-.326-.992-.419-.457-.105-.975-.272-1.387-.584A1.804 1.804 0 0 1 9.76 6.78v-.008A2.12 2.12 0 0 1 11.5 4.72v-.53a.5.5 0 0 1 .5-.5Z",
    fill: "currentColor"
  }));
};

var SvgSocialCapital64X64 = function SvgSocialCapital64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -social-capital",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 1a19.93 19.93 0 1 1-19.94 19.93A20 20 0 0 1 32 1Zm0-1a20.93 20.93 0 0 0-20.632 24.452A20.93 20.93 0 1 0 32 60.833a20.93 20.93 0 1 0 20.632-36.381A20.93 20.93 0 0 0 32 0Zm-.927 60.22a20.933 20.933 0 0 1-8.635-20.672 20.927 20.927 0 0 1-10.864-14.053A19.995 19.995 0 0 0 .99 43.07a19.93 19.93 0 0 0 30.083 17.15ZM23.13 43.07c.004-1.034.087-2.06.248-3.069a20.922 20.922 0 0 0 16.632.266A20.93 20.93 0 0 0 52.43 25.48a19.937 19.937 0 0 1 9.043 9.963A19.93 19.93 0 1 1 23.13 43.07Zm8.97-22.63c4.67 1.07 5.67 3.49 5.67 5.33a5.32 5.32 0 0 1-5.28 5.32v2.51a.5.5 0 1 1-1 0v-2.52a5.78 5.78 0 0 1-5.28-5.75.5.5 0 1 1 1 0 4.78 4.78 0 0 0 4.78 4.78c2.78 0 4.78-1.82 4.78-4.34 0-2.15-1.64-3.61-4.89-4.35-4.67-1.07-5.67-3.49-5.67-5.33a5.32 5.32 0 0 1 5.28-5.32V8.26a.5.5 0 0 1 1 0v2.56a5.74 5.74 0 0 1 5.2 4.77.479.479 0 0 1-.41.57.489.489 0 0 1-.57-.41 4.79 4.79 0 0 0-4.72-4c-2.78 0-4.78 1.83-4.78 4.34 0 2.15 1.65 3.61 4.89 4.35Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  }))));
};

var SvgSofa104X104 = function SvgSofa104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sofa",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 26.012c.074-.008.149-.012.225-.012h16.661c.648 0 1.16.282 1.526.682.35.383.588.9.588 1.54l-.132 48.97c-.011 4.28-3.265 7.808-7.277 7.808H77.185l7.737 17.654c.219.499-.037 1.069-.572 1.273-.534.204-1.144-.035-1.363-.534l-7.909-18.047A.92.92 0 0 1 75 85H29a.92.92 0 0 1-.078.346l-7.909 18.047c-.219.499-.829.738-1.363.534-.535-.204-.79-.774-.572-1.273L26.815 85H7.277C3.239 85 0 81.477 0 77.17V28.71C0 27.23 1.13 26 2.569 26h16.218c.072 0 .143.004.213.01V7.793C19 3.505 22.228 0 26.253 0h51.494C81.772 0 85 3.505 85 7.792v18.22Zm-1.985 30.12a1.011 1.011 0 0 1-.009-.13V7.792c0-3.218-2.373-5.796-5.26-5.796H26.254c-2.887 0-5.26 2.578-5.26 5.796v48.21a.996.996 0 0 1-.003.081c.532 3.614 3.386 6.352 6.794 6.352h48.444c3.393 0 6.236-2.714 6.787-6.303Zm18.853 21.06.132-48.98a.259.259 0 0 0-.062-.18c-.02-.022-.039-.032-.052-.032H85.225c-.044 0-.114.076-.114.21v26.652c0 5.274-3.958 9.581-8.883 9.581H27.784c-4.925 0-8.883-4.307-8.883-9.581V28.209c0-.133-.07-.209-.114-.209H2.569c-.296 0-.569.298-.569.704v48.47C2 80.41 4.381 83 7.277 83h89.314c2.872 0 5.268-2.6 5.277-5.808Z",
    fill: "currentColor"
  }));
};

var SvgSofa16X16 = function SvgSofa16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sofa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.335 3.927c.185 0 .357.075.484.212a.685.685 0 0 1 .181.466l-.02 7.18c-.002.825-.641 1.497-1.423 1.497H12.23l.83 2.029a.5.5 0 0 1-.926.379l-.986-2.408H4.851l-.986 2.408a.5.5 0 0 1-.926-.38l.831-2.028H1.422C.638 13.282 0 12.608 0 11.78V4.677c0-.414.328-.75.73-.75h2.049V1.5C2.779.674 3.417 0 4.202 0H11.8c.784 0 1.423.674 1.423 1.5v2.427h2.112zM3.779 1.5c0-.276.19-.501.423-.501H11.8c.233 0 .423.225.423.5v3.097l-.001.007V8.51c0 .417-.296.756-.659.756H4.438c-.363 0-.659-.34-.659-.756V1.5zM14.98 11.78c0 .272-.194.5-.423.5H1.422c-.233 0-.422-.224-.422-.5V4.927h1.779v3.677c0 .018.005.035.01.052l.007.032c.085.885.785 1.579 1.642 1.579h7.125c.853 0 1.549-.688 1.641-1.566l.008-.033c.005-.021.011-.042.011-.064V4.927h1.776l-.019 6.855z",
    clipRule: "evenodd"
  }));
};

var SvgSofa24X24 = function SvgSofa24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sofa",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.484 7.973v4.792a.5.5 0 0 1-.015.12c-.11 1.036-.936 1.853-1.955 1.853H7.49c-1.026 0-1.857-.828-1.958-1.874a.501.501 0 0 1-.01-.099v-.059l-.001-.06V7.973H3v8.815c0 .433.31.768.67.768h16.637c.356 0 .668-.337.669-.765l.023-8.818h-2.515Zm0-1h2.809c.222 0 .392.095.516.23A.725.725 0 0 1 22 7.7l-.024 9.093c-.003.962-.743 1.762-1.669 1.762h-3.148l1.127 2.755a.5.5 0 0 1-.925.379l-1.282-3.134H7.922L6.64 21.69a.5.5 0 0 1-.925-.379l1.127-2.755H3.67c-.931 0-1.67-.8-1.67-1.768V7.79c0-.442.346-.817.793-.817h2.729V3.768C5.522 2.8 6.259 2 7.19 2h9.624c.93 0 1.669.8 1.669 1.768v3.205Zm-1 .674V3.768c0-.432-.31-.768-.67-.768H7.192c-.36 0-.67.335-.67.768v8.923c.022.59.456 1.047.969 1.047h9.024c.525 0 .968-.48.968-1.092V7.698c0-.017 0-.034.002-.051Z",
    fill: "currentColor"
  }));
};

var SvgSolarPower104X104 = function SvgSolarPower104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -solar-power",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M51 1a1 1 0 0 1 2 0v14.859a1 1 0 1 1-2 0V1zM11.916 16.638a1 1 0 0 0 0 1.414l10.4 10.401a1 1 0 0 0 1.415-1.414l-10.4-10.401a1 1 0 0 0-1.415 0zm80.168 0a1 1 0 0 0-1.414 0l-10.401 10.4a1 1 0 0 0 1.414 1.415l10.401-10.4a1 1 0 0 0 0-1.415zM11.137 55.722a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2h10.137zm92.863 1a1 1 0 0 0-1-1H92.863a1 1 0 0 0 0 2H103a1 1 0 0 0 1-1zm-79.976 0c0 9.807 5.085 18.737 13.271 23.804a1 1 0 0 1 .411 1.2A80.605 80.605 0 0 1 52 80.458c4.733 0 9.369.407 13.836 1.185a1 1 0 0 1 .487-.886c8.4-5.016 13.653-14.071 13.653-24.036 0-15.45-12.525-27.976-27.976-27.976-15.45 0-27.976 12.526-27.976 27.976zm-2 0c0 10.399 5.338 19.88 13.95 25.336C21.03 85.106 8.168 92.347.216 102.38a1 1 0 1 0 1.568 1.242C12.067 90.647 31.034 82.459 52 82.459c20.965 0 39.933 8.188 50.216 21.162a1 1 0 1 0 1.568-1.242c-7.952-10.032-20.815-17.273-35.758-20.32a29.952 29.952 0 0 0 13.95-25.337c0-16.555-13.42-29.976-29.976-29.976-16.555 0-29.976 13.421-29.976 29.976zm22.129 13.922a1 1 0 0 1-.15-1.406l10.635-13.183h-7.865a1 1 0 0 1-.781-1.624l12.446-15.558A1 1 0 0 1 60 40.123L48.853 54.054h7.877a1 1 0 0 1 .778 1.628L45.56 70.493a1 1 0 0 1-1.406.15z",
    clipRule: "evenodd"
  }));
};

var SvgSolarPower16X16 = function SvgSolarPower16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -solar-power",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 3.185a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-1 0v2.185a.5.5 0 0 0 .5.5zm4.261 1.748a.502.502 0 0 0 .354-.146l1.53-1.53a.5.5 0 0 0-.708-.707l-1.53 1.529a.502.502 0 0 0 .354.854zm1.748 4.261a.5.5 0 0 1 0-1H15.5a.5.5 0 0 1 0 1h-1.49zM3.385 4.786a.498.498 0 0 0 .707 0 .5.5 0 0 0 0-.706L2.563 2.55a.499.499 0 0 0-.707 0 .499.499 0 0 0 0 .708l1.53 1.529zM1.991 9.195H.5a.5.5 0 0 1 0-1h1.491a.5.5 0 0 1 0 1zm4.136 2.798-.004-.004a.46.46 0 0 0-.1-.093 3.743 3.743 0 0 1-1.784-3.2c0-2.075 1.687-3.762 3.76-3.762s3.762 1.687 3.762 3.761a3.78 3.78 0 0 1-1.836 3.232c-.018.011-.033.026-.046.041l-.023.023A11.979 11.979 0 0 0 8 11.832c-.637 0-1.261.063-1.873.16zm5.01.27a4.78 4.78 0 0 0 1.624-3.568A4.766 4.766 0 0 0 8 3.934a4.767 4.767 0 0 0-4.761 4.76c0 1.39.597 2.672 1.618 3.568-1.96.537-3.661 1.554-4.75 2.927a.5.5 0 0 0 .785.621c1.456-1.837 4.18-2.978 7.108-2.978s5.652 1.141 7.108 2.978a.5.5 0 1 0 .784-.62c-1.09-1.375-2.792-2.392-4.754-2.929zM8.672 5.848a.501.501 0 0 1 .781.625l-1.18 1.475h.423a.5.5 0 0 1 .389.814L7.328 10.94a.499.499 0 0 1-.704.076.502.502 0 0 1-.075-.704L7.65 8.949h-.419a.499.499 0 0 1-.39-.812l1.83-2.288z",
    clipRule: "evenodd"
  }));
};

var SvgSolarPower24X24 = function SvgSolarPower24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -solar-power",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.5 2.5a.5.5 0 0 1 1 0v2.768a.5.5 0 1 1-1 0V2.5zM6.311 5.192a.5.5 0 0 0 0 .707L8.25 7.836a.5.5 0 1 0 .706-.708L7.018 5.191a.5.5 0 0 0-.707 0zm15.378 0a.5.5 0 0 0-.707 0l-1.937 1.936a.5.5 0 1 0 .707.708l1.937-1.937a.5.5 0 0 0 0-.708zM6.388 12.378a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1 0-1h1.888zm17.612.5a.5.5 0 0 0-.5-.5h-1.888a.5.5 0 0 0 0 1H23.5a.5.5 0 0 0 .5-.5zm-14.898 0c0 1.718.89 3.281 2.324 4.168.058.036.105.08.142.132A15.37 15.37 0 0 1 14 16.987c.818 0 1.622.064 2.4.187a.498.498 0 0 1 .108-.086 4.897 4.897 0 1 0-7.406-4.209zm-1 0c0 1.803.815 3.465 2.167 4.569-2.561.653-4.755 1.968-6.16 3.741a.5.5 0 0 0 .783.622c1.852-2.338 5.295-3.824 9.108-3.824 3.813 0 7.256 1.486 9.108 3.824a.5.5 0 1 0 .784-.622c-1.406-1.773-3.6-3.088-6.16-3.74a5.897 5.897 0 1 0-9.629-4.569zm4.24 2.838a.5.5 0 0 1-.075-.703l1.568-1.945h-.808a.5.5 0 0 1-.39-.812l2.317-2.898a.5.5 0 1 1 .781.624l-1.668 2.086h.814a.5.5 0 0 1 .389.814l-2.225 2.759a.5.5 0 0 1-.703.075z",
    clipRule: "evenodd"
  }));
};

var SvgSound104X104 = function SvgSound104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sound",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M85.876 95.707c24.165-24.137 24.165-63.275 0-87.414a.998.998 0 1 0-1.414 1.413c23.383 23.359 23.383 61.231 0 84.589a.998.998 0 1 0 1.414 1.412zM67.751 77.602c14.156-14.14 14.156-37.063 0-51.204a.998.998 0 1 0-1.414 1.413c13.374 13.36 13.374 35.019 0 48.378a1 1 0 0 0 1.414 1.413zM36.847 14.829l-33.18 18.94A7.266 7.266 0 0 0 0 40.08v23.84a7.27 7.27 0 0 0 3.667 6.312l33.18 18.94a1 1 0 0 0 .496.132h5.192a1 1 0 0 0 1-1V15.697a1 1 0 0 0-1-.999h-5.192a1 1 0 0 0-.496.132zm4.688 1.866v70.61h-3.926L4.659 68.498A5.272 5.272 0 0 1 2 63.92V40.08a5.269 5.269 0 0 1 2.659-4.577l32.95-18.808h3.926z",
    clipRule: "evenodd"
  }));
};

var SvgSound16X16 = function SvgSound16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sound",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.232 14.85c3.691-3.783 3.691-9.917 0-13.7a.492.492 0 0 0-.707 0 .522.522 0 0 0 0 .725c3.3 3.383 3.3 8.867 0 12.25a.522.522 0 0 0 0 .725c.195.2.511.2.707 0zm-2.665-2.731c2.218-2.275 2.218-5.963 0-8.237a.491.491 0 0 0-.708 0 .522.522 0 0 0 0 .724c1.828 1.874 1.828 4.914 0 6.788a.522.522 0 0 0 0 .725c.196.2.512.2.708 0zM5.596 2.077.717 4.935A1.47 1.47 0 0 0 0 6.202v3.597c0 .523.273 1.005.716 1.265l4.881 2.858a.49.49 0 0 0 .248.068h.764c.276 0 .5-.23.5-.513V2.522a.506.506 0 0 0-.5-.512h-.764a.49.49 0 0 0-.248.067zm.38.958h.132v9.93h-.131l-4.765-2.79A.437.437 0 0 1 1 9.8V6.202c0-.155.082-.3.214-.378l4.764-2.789z",
    clipRule: "evenodd"
  }));
};

var SvgSound24X24 = function SvgSound24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -sound"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M19.833 22.054a.5.5 0 0 1-.707-.707c5.165-5.162 5.165-13.532 0-18.694a.5.5 0 1 1 .707-.707c5.555 5.553 5.555 14.555 0 20.108zm-4.087-4.084a.5.5 0 0 1-.707-.707 7.439 7.439 0 0 0 0-10.526.5.5 0 1 1 .707-.706 8.438 8.438 0 0 1 0 11.939zM8.447 3.376a.5.5 0 0 1 .248-.065h1.171a.5.5 0 0 1 .5.5v16.38a.5.5 0 0 1-.5.499h-1.17a.5.5 0 0 1-.249-.066L.965 16.35A1.914 1.914 0 0 1 0 14.689V9.312c0-.688.369-1.323.965-1.663l7.482-4.273zm.92.934h-.539L1.461 8.516a.916.916 0 0 0-.46.796v5.377c0 .328.175.631.46.794l7.367 4.207h.538V4.31z"
  }));
};

var SvgStackedCash104X104 = function SvgStackedCash104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -stacked-cash",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.014 16C3.14 16 0 19.172 0 23.086v44.151c0 3.913 3.14 7.085 7.014 7.085H14v6.593C14 84.828 17.14 88 21.014 88h75.973c3.873 0 7.013-3.172 7.013-7.085V36.764c0-3.914-3.14-7.086-7.013-7.086H90v-6.592C90 19.172 86.86 16 82.987 16H7.014zM90 31.69v35.547c0 3.913-3.14 7.085-7.013 7.085H15.991v6.593c0 2.802 2.249 5.073 5.023 5.073h75.973c2.774 0 5.022-2.271 5.022-5.073V36.764c0-2.803-2.248-5.074-5.022-5.074H90zM7.014 72.31c-2.774 0-5.023-2.27-5.023-5.073V23.086c0-2.803 2.248-5.074 5.023-5.074h75.973c2.774 0 5.022 2.271 5.022 5.074v44.151c0 2.802-2.248 5.073-5.022 5.073H7.014zm37.87-39.994c-3.688.418-6.413 3.145-6.413 6.86 0 3.707 2.772 5.875 7.189 6.892 3.617.833 5.635 2.412 5.635 4.932 0 2.864-2.265 4.89-5.378 4.906h-.065c-2.974-.017-5.381-2.447-5.381-5.443 0-.555-.448-1.006-1-1.006s-1 .45-1 1.006c0 3.776 2.792 6.897 6.414 7.387v2.712c0 .556.448 1.006 1 1.006s1-.45 1-1.006v-2.701c3.686-.42 6.41-3.146 6.41-6.86 0-3.708-2.771-5.876-7.19-6.893-3.615-.833-5.634-2.412-5.634-4.931 0-2.874 2.282-4.906 5.412-4.906 2.64.002 4.896 1.919 5.339 4.537a1 1 0 1 0 1.972-.337 7.44 7.44 0 0 0-6.31-6.143v-2.714c0-.556-.447-1.006-1-1.006-.552 0-1 .45-1 1.006v2.702z",
    clipRule: "evenodd"
  }));
};

var SvgStackedCash16X16 = function SvgStackedCash16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -stacked-cash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.37 2.5h11.26c.757 0 1.37.627 1.37 1.401V4.5h.63c.757 0 1.37.627 1.37 1.401V12.1c0 .773-.613 1.4-1.37 1.4H3.369C2.613 13.5 2 12.873 2 12.1v-.6h-.63C.612 11.5 0 10.873 0 10.1V3.9C0 3.127.613 2.5 1.37 2.5zm1.616 9v.6c0 .215.172.391.382.391h11.263a.388.388 0 0 0 .383-.391V5.9a.388.388 0 0 0-.383-.392H14v4.59c0 .774-.613 1.401-1.37 1.401H2.987zM1.37 3.509a.388.388 0 0 0-.384.392V10.1c0 .215.172.391.384.391H12.63a.388.388 0 0 0 .384-.391V3.9a.388.388 0 0 0-.384-.392H1.37zm5.23 1.29v-.112a.499.499 0 0 1 1 0v.123c.474.174.836.588.924 1.108a.5.5 0 0 1-.986.166.443.443 0 0 0-.437-.368.496.496 0 0 1-.008 0c-.27.003-.435.151-.435.364 0 .158.164.285.555.374.79.18 1.331.6 1.331 1.347 0 .618-.39 1.098-.943 1.28v.111a.499.499 0 0 1-1 0V9.07a1.437 1.437 0 0 1-.943-1.348.499.499 0 0 1 1 0c0 .244.198.44.443.44.275 0 .443-.147.443-.361 0-.16-.164-.287-.554-.376-.791-.18-1.332-.599-1.332-1.345 0-.619.39-1.1.943-1.28z",
    clipRule: "evenodd"
  }));
};

var SvgStackedCash24X24 = function SvgStackedCash24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -stacked-cash",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.158 4H1.842A1.842 1.842 0 0 0 0 5.842v9.316C0 16.174.825 17 1.842 17H3v1.157C3 19.175 3.823 20 4.84 20h17.32c1.016 0 1.84-.825 1.84-1.843V8.842A1.842 1.842 0 0 0 22.16 7H21V5.842A1.842 1.842 0 0 0 19.158 4ZM3.988 18.157V17h15.17A1.842 1.842 0 0 0 21 15.158V7.989h1.16c.47 0 .851.382.851.853v9.315a.853.853 0 0 1-.852.854H4.841a.852.852 0 0 1-.852-.854Zm-3-12.315c0-.47.383-.853.853-.853h17.317c.471 0 .853.382.853.853v9.316a.853.853 0 0 1-.853.853H1.84a.854.854 0 0 1-.853-.853V5.841ZM9 9.247c0-.896.606-1.576 1.445-1.77v-.374a.5.5 0 0 1 1 0v.383c.723.192 1.29.79 1.42 1.557a.5.5 0 1 1-.986.167.947.947 0 0 0-.933-.789c-.561 0-.946.34-.946.826 0 .403.352.677 1.057.838 1.106.252 1.835.82 1.835 1.812 0 .897-.606 1.577-1.447 1.77v.375a.5.5 0 1 1-1 0v-.384A1.946 1.946 0 0 1 9 11.778a.5.5 0 1 1 1 0c0 .517.415.937.93.945h.032c.553-.006.93-.345.93-.826 0-.402-.352-.676-1.057-.837C9.729 10.807 9 10.24 9 9.247Z",
    fill: "currentColor"
  }));
};

var SvgStar104X104 = function SvgStar104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -star",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.908 102.801c-.173.856.756 1.508 1.502 1.052L53 84.557l31.589 19.296c.745.456 1.675-.196 1.501-1.052L78.644 66.07l26.049-25.12a1 1 0 0 0-.585-1.713L68.8 35.377 53.919.607c-.346-.81-1.493-.81-1.839 0l-14.881 34.77-35.308 3.86a1 1 0 0 0-.586 1.714l26.05 25.119-7.447 36.731zm32.57-20.27-30.154 18.42 7.1-35.021a1 1 0 0 0-.286-.919L4.23 40.993l33.767-3.69a1 1 0 0 0 .81-.602L53 3.541l14.192 33.16a1 1 0 0 0 .81.601l33.767 3.691-24.907 24.018a1 1 0 0 0-.286.919l7.1 35.021-30.154-18.42a1 1 0 0 0-1.043 0z",
    clipRule: "evenodd"
  }));
};

var SvgStar16X16 = function SvgStar16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.448 1.34 1.783 4.063 4.267.457a.533.533 0 0 1 .468.345.544.544 0 0 1-.127.574l-.009.009-3.203 3.06.914 4.452a.537.537 0 0 1-.205.57.52.52 0 0 1-.61-.002l-3.712-2.23-3.715 2.296-.018.01a.542.542 0 0 1-.532-.03.547.547 0 0 1-.26-.46v-.048l.906-4.535-3.229-3.066-.005-.005a.544.544 0 0 1-.127-.573.533.533 0 0 1 .466-.346l4.283-.476 1.682-4.058A.53.53 0 0 1 7.958 1a.53.53 0 0 1 .49.34zm-.48 1.27 1.617 3.683 3.943.422-2.936 2.806.831 4.054-3.416-2.053-3.394 2.098.815-4.08-2.956-2.807 3.972-.442 1.525-3.68z",
    clipRule: "evenodd"
  }));
};

var SvgStar24X24 = function SvgStar24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -star"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M6.28 21.927a.5.5 0 0 1-.75-.526l1.352-6.673-4.728-4.56a.5.5 0 0 1 .292-.857l6.395-.7 2.7-6.308a.5.5 0 0 1 .92 0l2.7 6.309 6.394.699a.5.5 0 0 1 .293.857l-4.729 4.56 1.353 6.673a.5.5 0 0 1-.751.526l-5.72-3.495-5.72 3.495zm5.46-4.508a.5.5 0 0 1 .521 0l5.003 3.057-1.18-5.819a.5.5 0 0 1 .144-.459l4.157-4.009-5.624-.615a.5.5 0 0 1-.405-.3L12.001 3.77 9.645 9.274a.5.5 0 0 1-.405.3l-5.624.615 4.158 4.01a.5.5 0 0 1 .143.458l-1.18 5.819 5.003-3.057z"
  }));
};

var SvgStar64X64 = function SvgStar64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -star",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m31.81 2.42-8.28 19.984-21.25 2.364 15.83 15.036-4.4 22.029L32.046 50.49l18.427 11.081-4.484-21.864L61.72 24.67l-21.144-2.264L31.81 2.42zm.705-.88c-.1-.274-.343-.54-.712-.54-.371 0-.615.27-.714.545l-8.256 19.93L1.767 23.82a.778.778 0 0 0-.719.498.805.805 0 0 0 .2.85l.005.005L17.021 40.15l-4.39 21.977v.05c0 .337.23.572.407.683.183.115.498.217.81.06l.02-.01 18.185-11.248 18.32 11.017c.267.223.63.233.899.04a.781.781 0 0 0 .28-.864l-4.473-21.807 15.664-14.972.01-.008a.805.805 0 0 0 .2-.85.778.778 0 0 0-.72-.498l-20.974-2.246-8.744-19.935z",
    clipRule: "evenodd"
  }));
};

var SvgStarFilled104X104 = function SvgStarFilled104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -star-filled",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.412 103.853c-.746.456-1.675-.196-1.502-1.052l7.446-36.731L.307 40.95a1 1 0 0 1 .586-1.713l35.308-3.86L51.08.607c.347-.81 1.493-.81 1.84 0l14.88 34.77 35.309 3.86a1 1 0 0 1 .585 1.714L77.646 66.07l7.446 36.731c.174.856-.756 1.508-1.501 1.052l-31.59-19.296-31.59 19.296z"
  }));
};

var SvgStarFilled16X16 = function SvgStarFilled16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -star-filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.887.075 5.595 5.437a.038.038 0 0 1-.031.024L.11 6.058a.123.123 0 0 0-.072.21l4.023 3.885c.009.009.013.022.01.035l-1.146 5.664a.123.123 0 0 0 .185.13l4.87-2.98a.038.038 0 0 1 .04 0l4.87 2.98a.123.123 0 0 0 .185-.13l-1.147-5.664a.039.039 0 0 1 .011-.035l4.023-3.885a.123.123 0 0 0-.072-.21l-5.454-.597a.038.038 0 0 1-.03-.024L8.112.075a.123.123 0 0 0-.226 0z"
  }));
};

var SvgStarFilled24X24 = function SvgStarFilled24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -star-filled",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.476 1.883 2.787 6.352 6.678.715a.587.587 0 0 1 .522.38c.089.24.01.482-.143.635l-.009.01-5.002 4.779 1.427 6.956a.593.593 0 0 1-.223.635.569.569 0 0 1-.676-.008l-5.817-3.498-5.805 3.59-.02.01a.603.603 0 0 1-.59-.036.608.608 0 0 1-.29-.51v-.049l1.41-7.055-5.04-4.786-.005-.005a.602.602 0 0 1-.143-.635.587.587 0 0 1 .52-.38l6.705-.746 2.63-6.347a.584.584 0 0 1 .543-.39c.293 0 .47.206.541.383Z",
    fill: "currentColor"
  }));
};

var SvgStarFilled64X64 = function SvgStarFilled64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -star-filled",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.515 1.54c-.1-.274-.343-.54-.712-.54-.371 0-.615.27-.714.545l-8.256 19.93L1.767 23.82a.778.778 0 0 0-.719.498.805.805 0 0 0 .2.85l.005.005L17.021 40.15l-4.39 21.977v.05c0 .337.23.572.407.683.183.115.498.217.81.06l.02-.01 18.185-11.248 18.32 11.017c.267.223.63.233.899.04a.781.781 0 0 0 .28-.864l-4.473-21.807 15.664-14.972.01-.008a.805.805 0 0 0 .2-.85.778.778 0 0 0-.72-.498l-20.974-2.246-8.744-19.935z",
    clipRule: "evenodd"
  }));
};

var SvgStarServices104X104 = function SvgStarServices104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -start-services",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.232 37.285h12.723c3.885 0 7.045 3.165 7.045 7.056v52.604c0 3.89-3.16 7.055-7.045 7.055H7.045C3.16 104 0 100.835 0 96.945V44.341c0-3.891 3.16-7.056 7.045-7.056h12.723l-6.486-6.265a1.001 1.001 0 0 1 .586-1.713l26.176-2.867L51.08.607a1.001 1.001 0 0 1 1.84 0L63.956 26.44l26.176 2.867a1.001 1.001 0 0 1 .586 1.713l-6.486 6.265Zm-43.39-8.92c.359-.04.669-.269.811-.601L52 3.546l10.347 24.218c.142.332.452.561.811.601l24.637 2.698-6.729 6.5a.536.536 0 0 1-.034.033L69.613 48.627a1.001 1.001 0 0 0-.286.918l5.178 25.587-21.983-13.453a1.001 1.001 0 0 0-1.044 0L29.495 75.132l5.178-25.587a1.001 1.001 0 0 0-.286-.918L16.205 31.063l24.637-2.698ZM102 96.922c0 2.8-2.263 5.078-5.045 5.078H7.045C4.263 102 2 99.723 2 96.922V44.08C2 41.28 4.263 39 7.045 39h14.793l10.766 10.447-5.525 27.424c-.078.391.081.793.407 1.022a.997.997 0 0 0 1.095.033L52 63.53l23.419 14.396a.995.995 0 0 0 1.095-.033c.326-.229.485-.63.407-1.022l-5.525-27.423L82.162 39h14.793C99.737 39 102 41.28 102 44.08v52.842Z",
    fill: "currentColor"
  }));
};

var SvgStarServices16X16 = function SvgStarServices16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -start-services",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.614 5.465h.997c.766 0 1.389.625 1.389 1.393v7.749c0 .768-.623 1.393-1.389 1.393H1.389A1.393 1.393 0 0 1 0 14.607v-7.75c0-.767.623-1.392 1.389-1.392h.997l-.325-.314a.499.499 0 0 1-.125-.523.497.497 0 0 1 .418-.336l3.644-.4L7.54.276c.158-.368.762-.368.92 0l1.542 3.616 3.644.4a.497.497 0 0 1 .418.336.499.499 0 0 1-.125.523l-.325.314zm-7.217-.609a.503.503 0 0 0 .406-.301L8 1.748l1.197 2.807a.503.503 0 0 0 .406.301l2.875.316-.453.436-.006.006-1.674 1.621a.506.506 0 0 0-.143.46l.601 2.973L8.261 9.11a.498.498 0 0 0-.522 0l-2.542 1.558.601-2.973a.506.506 0 0 0-.143-.46L3.522 5.172l2.875-.316zM15 14.606a.391.391 0 0 1-.389.392H1.389A.391.391 0 0 1 1 14.607v-7.75a.39.39 0 0 1 .389-.39h2.032l1.343 1.298-.775 3.832a.502.502 0 0 0 .751.526L8 10.125l3.26 1.997a.501.501 0 0 0 .548-.017.503.503 0 0 0 .203-.508l-.775-3.832 1.343-1.298h2.032a.39.39 0 0 1 .389.39v7.75z",
    clipRule: "evenodd"
  }));
};

var SvgStarServices24X24 = function SvgStarServices24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -start-services",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.78 8.927h1.594A1.63 1.63 0 0 1 22 10.557v9.813A1.63 1.63 0 0 1 20.374 22H3.626A1.63 1.63 0 0 1 2 20.37v-9.813c0-.898.729-1.63 1.626-1.63H5.22l-.651-.629a.5.5 0 0 1 .293-.857l4.695-.515 1.983-4.649c.158-.37.762-.37.92 0l1.983 4.65 4.695.514a.5.5 0 0 1 .293.857l-.651.63ZM9.956 7.89a.498.498 0 0 0 .405-.302L12 3.748l1.639 3.84a.498.498 0 0 0 .405.302l3.925.43-.777.751-.005.006-2.124 2.054a.501.501 0 0 0-.143.46l.822 4.065-3.481-2.132a.489.489 0 0 0-.522 0l-3.481 2.132.822-4.065a.501.501 0 0 0-.143-.46l-2.906-2.81 3.925-.431ZM21 20.37a.628.628 0 0 1-.626.629H3.626a.628.628 0 0 1-.626-.63v-9.812c0-.346.281-.628.626-.628h2.629l1.791 1.732-.996 4.924a.5.5 0 0 0 .751.526L12 14.537l4.199 2.572a.5.5 0 0 0 .751-.525l-.996-4.924 1.791-1.732h2.629c.345 0 .626.282.626.628v9.813Z",
    fill: "currentColor"
  }));
};

var SvgStepperDecrease16X16 = function SvgStepperDecrease16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -stepper-decrease",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm4.5 7.5A.5.5 0 0 0 12 8H4l-.09.008A.5.5 0 0 0 4 9h8l.09-.008a.5.5 0 0 0 .41-.492z",
    clipRule: "evenodd"
  }));
};

var SvgStepperDecrease24X24 = function SvgStepperDecrease24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -stepper-decrease",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm5.5 9a.5.5 0 0 0-.5-.5H7l-.09.008A.5.5 0 0 0 7 12.5h10l.09-.008A.5.5 0 0 0 17.5 12Z",
    fill: "currentColor"
  }));
};

var SvgStepperIncrease16X16 = function SvgStepperIncrease16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -stepper-increase",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zM1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8zm11-.5a.5.5 0 0 1 .09.992L12 8.5H8.5V12a.5.5 0 0 1-.992.09L7.5 12V8.5H4a.5.5 0 0 1-.09-.992L4 7.5h3.5V4a.5.5 0 0 1 .992-.09L8.5 4v3.5H12z",
    clipRule: "evenodd"
  }));
};

var SvgStepperIncrease24X24 = function SvgStepperIncrease24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -stepper-increase"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 3.5a.5.5 0 0 1 .492.41L12.5 7v4.5H17a.5.5 0 0 1 .09.992L17 12.5h-4.5V17a.5.5 0 0 1-.992.09L11.5 17v-4.5H7a.5.5 0 0 1-.09-.992L7 11.5h4.5V7a.5.5 0 0 1 .5-.5z"
  }));
};

var SvgStore104X104 = function SvgStore104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -store",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M44.314 42.944c-1.833 4.209-5.992 7.146-10.829 7.146-4.836 0-8.995-2.937-10.828-7.146-1.833 4.209-5.992 7.146-10.829 7.146-.393 0-.782-.02-1.166-.057v33.839c0 2.819 2.258 5.104 5.044 5.104H22.6V62.562c0-1.404 1.123-2.541 2.51-2.541h17.693c1.387 0 2.512 1.137 2.512 2.54v26.415h31.372l-5.009-11.742c-11.659-3.583-18.946-15.028-17.576-27.19-4.387-.386-8.087-3.196-9.788-7.1zm34.651 46.032h.007a.156.156 0 0 0 .14-.096l5.49-12.775c.12-.278.357-.487.645-.57 9.924-2.848 16.768-12.025 16.752-22.467.044-14.705-13.167-25.837-27.773-22.903-8.175 1.642-15.032 7.998-17.34 16.085-3.641 12.761 3.531 25.656 15.796 29.174.29.083.527.293.646.572l5.495 12.883a.156.156 0 0 0 .14.097h.002zm0 2.024h.004c.801 0 1.603-.437 1.979-1.313l5.303-12.341C96.788 74.104 104.016 64.253 104 53.07c.036-12.727-9.068-22.993-20.785-25.033l-6.554-11.444A7.026 7.026 0 0 0 70.544 13H18.085a7.029 7.029 0 0 0-6.121 3.6L.131 37.62a1.021 1.021 0 0 0-.131.5c0 5.502 3.667 10.137 8.662 11.538v34.215c0 3.937 3.154 7.128 7.044 7.128h63.26zm-4.038-73.398 5.802 10.13a25.622 25.622 0 0 0-6.891.448c-8.908 1.789-16.357 8.694-18.872 17.508-.224.784-.41 1.568-.56 2.35-5.084-.38-9.092-4.675-9.092-9.918 0-1.35-2-1.35-2 0 0 5.493-4.4 9.946-9.829 9.946-5.428 0-9.828-4.453-9.828-9.946 0-1.35-2-1.35-2 0 0 5.493-4.4 9.946-9.829 9.946-5.341 0-9.687-4.312-9.825-9.684l11.699-20.78a5.033 5.033 0 0 1 4.383-2.578h52.459c1.813 0 3.486.984 4.383 2.578zm-31.612 44.96v26.414H24.6V62.562c0-.286.228-.517.51-.517h17.693c.283 0 .512.231.512.517zM78.966 40.36c4.016 0 7.718 1.921 10.073 5.116 2.23 3.023 3.037 6.884 2.11 10.757-1.1 4.59-4.9 8.294-9.487 9.263-7.974 1.685-15.258-4.374-15.258-12.425 0-7.02 5.625-12.711 12.562-12.711zm0 2.024c-5.833 0-10.562 4.784-10.562 10.687 0 6.772 6.123 11.865 12.849 10.444 3.833-.81 7.035-3.93 7.952-7.759.785-3.281.107-6.526-1.77-9.07-1.98-2.688-5.091-4.303-8.469-4.303z",
    clipRule: "evenodd"
  }));
};

var SvgStore16X16 = function SvgStore16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.472 11.351a.495.495 0 0 1 .321-.281A3.036 3.036 0 0 0 15 8.156v-.002a3.01 3.01 0 0 0-1.106-2.345 3.041 3.041 0 0 0-1.937-.688 2.999 2.999 0 0 0-2.899 2.144 3.037 3.037 0 0 0 .254 2.346 3.008 3.008 0 0 0 1.827 1.443.5.5 0 0 1 .322.282l.506 1.17.505-1.155zM6.37 13.003H4.323V9.806H6.37v3.197zM2.274 8.054v4.562a.39.39 0 0 0 .389.387h.66V9.53c0-.396.324-.72.723-.72h2.601c.399 0 .723.324.723.72v3.474h3.724l-.46-1.063a3.976 3.976 0 0 1-2.685-3.934 2.098 2.098 0 0 1-1.079-.665 2.094 2.094 0 0 1-3.185 0 2.084 2.084 0 0 1-1.411.713zm.739-5.057a.39.39 0 0 0-.338.195L1.007 6.11a1.092 1.092 0 0 0 2.178-.12.5.5 0 0 1 1 0 1.092 1.092 0 0 0 2.185 0 .5.5 0 0 1 1 0c0 .47.305.862.724 1.014a.027.027 0 0 0 .002-.008l.001-.008a4.006 4.006 0 0 1 3.046-2.783c.112-.022.225-.027.337-.033.05-.003.1-.005.149-.01l-.563-.967a.391.391 0 0 0-.339-.198H3.013zm9.809 1.23c.62.134 1.206.402 1.707.813A4 4 0 0 1 16 8.156a4.04 4.04 0 0 1-2.702 3.8l-.718 1.642a.67.67 0 0 1-.614.402H2.663c-.766 0-1.389-.62-1.389-1.384V7.909A2.09 2.09 0 0 1 0 5.989c0-.086.022-.171.065-.246L1.806 2.7A1.392 1.392 0 0 1 3.013 2h7.714c.498 0 .96.267 1.207.699l.888 1.527zm-.592 5.096c.427-.088.796-.443.898-.862a1.197 1.197 0 0 0-1.162-1.502c-.662 0-1.2.537-1.2 1.196a1.202 1.202 0 0 0 1.464 1.168zM9.766 8.155c0-1.21.987-2.192 2.2-2.192.689 0 1.349.329 1.764.88.393.528.528 1.203.37 1.852a2.206 2.206 0 0 1-1.665 1.604 2.326 2.326 0 0 1-.466.048c-.505 0-.994-.17-1.39-.49a2.185 2.185 0 0 1-.813-1.702z",
    clipRule: "evenodd"
  }));
};

var SvgStore24X24 = function SvgStore24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -store",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.267 10.543a2.935 2.935 0 0 1-4.883 0 2.936 2.936 0 0 1-2.43 1.305v7.282c0 .479.386.866.863.866h1.279v-5.633c0-.467.377-.844.841-.844h3.989c.465 0 .841.377.841.844v5.633h6.383l-.914-2.126c-2.6-.854-4.245-3.362-4.058-6.07a2.943 2.943 0 0 1-1.91-1.257ZM18.081 21l.037-.001a.75.75 0 0 0 .661-.456l1.147-2.648a5.94 5.94 0 0 0 4.075-5.655 5.928 5.928 0 0 0-4.789-5.849L17.8 3.942A1.86 1.86 0 0 0 16.182 3H4.353c-.67 0-1.287.36-1.62.945L.067 8.646A.503.503 0 0 0 0 8.895c0 1.283.815 2.375 1.954 2.783v7.452c0 1.033.833 1.87 1.863 1.87H18.08ZM16.93 4.442l1.063 1.84a6.16 6.16 0 0 0-1.123.119 5.906 5.906 0 0 0-4.542 4.406 1.949 1.949 0 0 1-1.562-1.912c0-.67-1-.67-1 0 0 1.077-.869 1.95-1.941 1.95a1.945 1.945 0 0 1-1.942-1.95c0-.67-1-.67-1 0 0 1.077-.87 1.95-1.942 1.95A1.945 1.945 0 0 1 1.004 9.02l2.598-4.579a.864.864 0 0 1 .751-.438h11.829c.31 0 .596.167.75.438ZM9.767 19.996H6.096v-5.473h3.671v5.473Zm7.296-2.737 1.02 2.373 1.018-2.35a.5.5 0 0 1 .322-.283 4.935 4.935 0 0 0 3.578-4.758v-.003a4.932 4.932 0 0 0-5.935-4.853 4.904 4.904 0 0 0-3.7 3.405c-.778 2.708.753 5.439 3.374 6.185a.5.5 0 0 1 .323.284Zm1.018-8.138c.993 0 1.91.471 2.492 1.255.55.742.75 1.689.522 2.635a3.105 3.105 0 0 1-2.35 2.278 3.113 3.113 0 0 1-3.77-3.05c0-1.722 1.39-3.118 3.106-3.118Zm0 1.004a2.11 2.11 0 0 0-2.106 2.115c0 1.34 1.22 2.348 2.565 2.066a2.104 2.104 0 0 0 1.583-1.53 2.136 2.136 0 0 0-.352-1.8 2.1 2.1 0 0 0-1.69-.851Z",
    fill: "currentColor"
  }));
};

var SvgSwitch24X24 = function SvgSwitch24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 46,
    height: 24,
    viewBox: "0 0 46 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.373 5.373 0 12 0h22c6.627 0 12 5.373 12 12s-5.373 12-12 12H12C5.373 24 0 18.627 0 12Z",
    fill: "#cdd3cd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "white"
  }));
};

var SvgSync104X104 = function SvgSync104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sync",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M96.955 37.4H82.76a30.103 30.103 0 0 0-3.471-11.565 1 1 0 0 0-1.76.949c5.939 11.015 3.863 24.847-5.045 33.636-7.48 7.373-20.476 10.46-30.916 7.54l11.153-10.261a1 1 0 0 0-1.354-1.472L38.931 67.669c-.011.009-.015.024-.026.034-.048.049-.082.108-.12.166-.036.056-.074.107-.1.167-.004.014-.016.023-.021.037-.018.052-.012.104-.022.156-.009.052-.034.1-.035.154 0 .015.008.028.008.042.002.074.022.142.039.212.014.057.02.114.043.168.031.07.08.128.126.19.028.037.044.083.077.116l12.437 12.437a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-9.797-9.797c2.206.46 4.486.71 6.799.71 8.927-.001 18.176-3.33 24.136-9.203 6.091-6.01 9.181-14.222 8.974-22.444h14.092A5.05 5.05 0 0 1 102 44.444v52.512A5.05 5.05 0 0 1 96.955 102H7.045A5.05 5.05 0 0 1 2 96.956V44.444A5.05 5.05 0 0 1 7.045 39.4h14.093c-.169 5.287 1.007 10.644 3.664 15.496a.998.998 0 0 0 1.357.398c.484-.266.662-.873.397-1.358-6.074-11.1-3.999-25.03 5.048-33.878 7.355-7.251 20.404-10.182 30.996-7.15L51.337 24.172a.999.999 0 1 0 1.414 1.414l12.436-12.436c.006-.006.008-.014.013-.02.048-.05.078-.114.115-.174.034-.055.075-.103.097-.163.003-.008.009-.012.012-.02.02-.058.015-.118.024-.177.01-.06.033-.114.032-.174 0-.008-.004-.014-.004-.021-.003-.082-.031-.157-.053-.235-.015-.048-.017-.1-.038-.145a.997.997 0 0 0-.201-.278c-.011-.011-.016-.026-.027-.036l-.003-.003-.004-.004L52.721.264a1 1 0 0 0-1.354 1.472l9.431 8.676c-10.773-2.182-23.302 1.03-30.595 8.218-5.228 5.114-8.259 11.817-8.937 18.77H7.045C3.16 37.4 0 40.56 0 44.444v52.512C0 100.84 3.16 104 7.045 104h89.91c3.885 0 7.045-3.16 7.045-7.044V44.444c0-3.884-3.16-7.044-7.045-7.044Z",
    fill: "currentColor"
  }));
};

var SvgSync16X16 = function SvgSync16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sync",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.611 5.5h-1.779a4.723 4.723 0 0 0-.508-1.515.5.5 0 1 0-.881.474 3.833 3.833 0 0 1-.68 4.528c-.844.834-2.265 1.257-3.53 1.135l1.112-1.024a.5.5 0 1 0-.677-.736l-1.829 1.682c-.005.005-.007.012-.012.017-.026.025-.043.056-.062.086-.017.027-.036.052-.049.081-.001.007-.007.012-.01.02-.009.025-.007.052-.011.078-.005.026-.017.05-.018.076 0 .008.004.014.004.021.001.036.011.07.02.105.007.03.01.058.021.085.016.035.04.064.063.095.014.02.022.041.039.058l1.829 1.83a.502.502 0 0 0 .707 0 .5.5 0 0 0 0-.708l-.739-.739.039.003c1.407 0 2.866-.526 3.806-1.453a4.817 4.817 0 0 0 1.41-3.199h1.735a.39.39 0 0 1 .389.39v7.721a.39.39 0 0 1-.389.39H1.388A.389.389 0 0 1 1 14.61V6.89c0-.215.174-.389.388-.389h1.73c.03.72.212 1.437.572 2.096a.499.499 0 0 0 .679.198.5.5 0 0 0 .198-.679 3.83 3.83 0 0 1 .681-4.56c.842-.83 2.294-1.237 3.589-1.08L7.653 3.658a.5.5 0 0 0 .707.707l1.828-1.829c.003-.002.003-.006.006-.009.024-.025.04-.058.06-.09.016-.026.036-.05.046-.08.002-.003.005-.005.006-.009.011-.029.008-.059.013-.088.005-.03.017-.057.016-.088l-.002-.01c-.002-.042-.016-.082-.029-.122-.006-.023-.007-.047-.017-.068a.514.514 0 0 0-.092-.127c-.008-.009-.012-.02-.021-.03l-.002-.002h-.001L8.345.132a.5.5 0 1 0-.677.735l.626.576c-1.401 0-2.833.495-3.746 1.396A4.81 4.81 0 0 0 3.173 5.5H1.388A1.39 1.39 0 0 0 0 6.89v7.721a1.39 1.39 0 0 0 1.388 1.39h13.223A1.39 1.39 0 0 0 16 14.61V6.89A1.39 1.39 0 0 0 14.611 5.5z"
  }));
};

var SvgSync24X24 = function SvgSync24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -sync",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.374 8.967h-2.375a5.9 5.9 0 0 0-.64-1.99.5.5 0 0 0-.881.475 4.992 4.992 0 0 1-.882 5.893c-1.164 1.146-3.163 1.702-4.874 1.442l1.625-1.494a.502.502 0 0 0-.678-.737l-2.316 2.132-.013.017c-.025.025-.041.054-.061.084-.017.028-.036.053-.049.082-.002.008-.007.012-.01.019-.009.027-.007.053-.011.079-.005.026-.017.05-.018.077 0 .007.004.013.004.02.001.037.011.07.02.106.007.028.01.057.021.085.016.034.04.063.063.094.014.019.022.04.039.058l2.316 2.317a.5.5 0 1 0 .707-.707l-1.191-1.191c.136.008.267.032.403.032 1.746 0 3.557-.652 4.725-1.803a5.974 5.974 0 0 0 1.754-4.09h2.322c.345 0 .626.28.626.626v9.78a.627.627 0 0 1-.626.627H3.626A.627.627 0 0 1 3 20.374v-9.781c0-.345.281-.626.626-.626h2.311c.02.933.253 1.868.721 2.723a.498.498 0 0 0 .679.199.499.499 0 0 0 .198-.678 4.99 4.99 0 0 1 .886-5.938c1.174-1.156 3.175-1.682 4.93-1.374l-1.697 1.695a.5.5 0 0 0 .707.707l2.318-2.316.005-.008c.025-.026.042-.06.06-.091.017-.027.036-.051.047-.08.002-.003.005-.006.006-.01.01-.028.008-.058.013-.087.003-.03.016-.057.015-.088l-.002-.01a.468.468 0 0 0-.028-.123c-.007-.023-.008-.046-.018-.067a.46.46 0 0 0-.085-.118c-.01-.012-.016-.028-.028-.04l-2.317-2.131a.5.5 0 0 0-.678.736l1.038.955c-1.841-.087-3.779.547-4.986 1.737a5.96 5.96 0 0 0-1.726 3.407H3.626C2.729 8.967 2 9.696 2 10.593v9.78C2 21.272 2.729 22 3.626 22h16.748C21.27 22 22 21.27 22 20.374v-9.781c0-.897-.73-1.626-1.626-1.626Z",
    fill: "currentColor"
  }));
};

var SvgTarget104X104 = function SvgTarget104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -target",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 0c25.405 0 46 20.646 46 46.115 0 15.467-7.595 29.155-19.25 37.52l11.281 18.85c.284.474.13 1.088-.342 1.372a.996.996 0 0 1-1.368-.343L77.1 84.767A45.704 45.704 0 0 1 52 92.23a45.704 45.704 0 0 1-25.1-7.463l-11.22 18.747a.996.996 0 0 1-1.37.343 1.001 1.001 0 0 1-.341-1.372l11.281-18.85C13.595 75.27 6 61.583 6 46.116 6 20.646 26.595 0 52 0Zm0 2C27.696 2 7.995 21.75 7.995 46.115 7.995 70.48 27.696 90.23 52 90.23c24.304 0 44.005-19.75 44.005-44.115C96.005 21.751 76.304 2 52 2Zm0 15.654c15.68 0 28.39 12.742 28.39 28.46 0 15.72-12.71 28.463-28.39 28.463S23.61 61.834 23.61 46.115 36.32 17.654 52 17.654Zm0 2c-14.578 0-26.395 11.847-26.395 26.46 0 14.616 11.817 26.463 26.395 26.463S78.395 60.73 78.395 46.115C78.395 31.5 66.578 19.654 52 19.654Zm8.824 26.461c0-4.885-3.95-8.846-8.824-8.846-4.873 0-8.824 3.96-8.824 8.846s3.95 8.847 8.824 8.847c4.873 0 8.824-3.96 8.824-8.847Zm-15.653 0c0-3.78 3.058-6.846 6.829-6.846s6.829 3.065 6.829 6.846c0 3.782-3.058 6.847-6.829 6.847s-6.829-3.065-6.829-6.847Z",
    fill: "currentColor"
  }));
};

var SvgTarget16X16 = function SvgTarget16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -target",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0a7 7 0 0 1 4.228 12.579l1.569 2.664a.505.505 0 0 1-.169.686.485.485 0 0 1-.673-.172l-1.553-2.638A6.968 6.968 0 0 1 8 14a6.967 6.967 0 0 1-3.403-.882l-1.554 2.64a.485.485 0 0 1-.673.17.505.505 0 0 1-.168-.685l1.569-2.665A7 7 0 0 1 8 0zm0 .981a6.019 6.019 0 1 0 0 12.038A6.019 6.019 0 0 0 8 .98zm0 1.615a4.5 4.5 0 1 1-.001 9.001 4.5 4.5 0 0 1 .001-9zm-.001.992a3.509 3.509 0 1 0 0 7.018 3.509 3.509 0 0 0 0-7.018zM9.5 6.98a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm-2.094 0a.594.594 0 1 1 1.187 0 .594.594 0 0 1-1.187 0z",
    clipRule: "evenodd"
  }));
};

var SvgTarget24X24 = function SvgTarget24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -target",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2a9 9 0 0 1 5.43 16.178l1.837 3.064a.5.5 0 0 1-.857.515l-1.81-3.02A8.958 8.958 0 0 1 12 20a8.958 8.958 0 0 1-4.746-1.352L5.39 21.757a.5.5 0 1 1-.857-.515l1.9-3.17A9 9 0 0 1 12 2Zm4.615 15.523a2.49 2.49 0 0 0-.115.066c-.093.055-.178.11-.239.17a7.99 7.99 0 1 1 .354-.237ZM12 5.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm-.001.98a4.52 4.52 0 1 0 0 9.04 4.52 4.52 0 0 0 0-9.04ZM14 11a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm-2.98 0a.98.98 0 1 1 1.96 0 .98.98 0 0 1-1.96 0Z",
    fill: "currentColor"
  }));
};

var SvgTools104X104 = function SvgTools104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -tools",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M96.133 22.363c.259-.079.475-.258.599-.497l7.156-13.77a.994.994 0 0 0-.182-1.164L97.034.292a1.007 1.007 0 0 0-1.17-.18L82.034 7.24a1 1 0 0 0-.502.608l-5.477 18.776L57.64 44.953 39.165 26.476c.714-2.105 1.09-4.217 1.09-6.348l-.134-1.388C39.408 8.227 30.711 0 20.128 0c-2.98 0-5.887.699-8.63 2.01a1.003 1.003 0 0 0-.277 1.615l11.995 11.996-7.594 7.588-11.997-11.99a1.003 1.003 0 0 0-1.615.278C.698 14.245 0 17.149 0 20.128c0 10.583 8.227 19.28 18.771 19.997l1.257.125c2.22.005 4.339-.369 6.447-1.08l38.35 38.357c-.706 2.113-1.079 4.222-1.079 6.347l.006.105.134 1.287C64.586 95.775 73.284 104 83.873 104c3.003 0 5.922-.697 8.635-2.012.621-.301.76-1.124.272-1.612L80.786 88.38l7.594-7.594 11.995 11.995c.489.49 1.315.348 1.614-.276 1.315-2.743 2.011-5.645 2.011-8.63-.006-10.586-8.234-19.284-18.778-19.999l-1.256-.126c-2.222-.004-4.342.371-6.448 1.085L59.054 46.368 77.48 28.031l18.655-5.668zM77.48 28.03l-.24.073.416-.249-.177.176zm18.655-25.81L83.339 8.817l-4.912 16.839 16.716-5.08 6.626-12.748-5.634-5.607zM10.445 104a10.356 10.356 0 0 1-7.386-3.088c-4.078-4.123-4.079-10.799 0-14.92v-.001l.002-.002.003-.003.001-.002 26.88-26.697a.984.984 0 0 1 1.396.006l13.368 13.498a1.01 1.01 0 0 1-.005 1.423L17.83 100.91A10.35 10.35 0 0 1 10.445 104zm20.189-42.587L4.459 87.41c-3.302 3.339-3.3 8.745.003 12.084a8.383 8.383 0 0 0 5.983 2.501 8.384 8.384 0 0 0 5.989-2.507L42.6 73.494 30.634 61.413zm53.24 40.581c-9.529 0-17.356-7.402-17.989-16.9l-.132-1.27c.006-2.066.41-4.13 1.17-6.217a1.003 1.003 0 0 0-.233-1.053l-39.242-39.25a1.004 1.004 0 0 0-1.056-.231c-2.098.771-4.178 1.176-6.264 1.176l-1.189-.123C9.411 37.477 2.007 29.65 2.007 20.128c0-2.201.427-4.363 1.242-6.448l11.663 11.657a1.003 1.003 0 0 0 1.419 0l9.013-9.006a1.003 1.003 0 0 0 0-1.42L13.682 3.248c2.082-.815 4.244-1.241 6.447-1.241 9.522 0 17.35 7.404 17.994 16.9l.131 1.32c-.005 1.99-.411 4.07-1.186 6.163-.136.367-.045.78.232 1.057l39.248 39.255c.277.277.69.368 1.058.231 2.092-.775 4.173-1.181 6.261-1.181l1.189.123c9.527.647 16.933 8.475 16.938 18a17.58 17.58 0 0 1-1.24 6.446L89.09 78.658a1.004 1.004 0 0 0-1.42 0l-9.013 9.013a1.003 1.003 0 0 0 0 1.418l11.667 11.668a17.547 17.547 0 0 1-6.45 1.237z",
    clipRule: "evenodd"
  }));
};

var SvgTools16X16 = function SvgTools16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -tools",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m13.71 11.634 1.273 1.273a2.25 2.25 0 0 0 .016-.259 2.306 2.306 0 0 0-2.149-2.286l-.204-.02a2.315 2.315 0 0 0-.746.153.499.499 0 0 1-.527-.115L5.62 4.626a.5.5 0 0 1-.115-.527c.1-.27.151-.538.151-.796l-.016-.14c-.089-1.307-1.261-2.3-2.546-2.147l1.273 1.273a.502.502 0 0 1 0 .707L3.046 4.317a.5.5 0 0 1-.707 0L1.066 3.044c-.01.087-.016.173-.016.259 0 1.2.944 2.205 2.148 2.286l.204.02c.211-.002.472-.052.748-.153a.496.496 0 0 1 .525.116l5.752 5.753a.5.5 0 0 1 .116.525c-.101.277-.15.537-.15.798l.017.137c.088 1.311 1.269 2.293 2.545 2.151l-1.273-1.274a.499.499 0 0 1 0-.707l1.321-1.321a.5.5 0 0 1 .707 0zm.68-10.486-1.513.783-.496 1.709 1.685-.514.784-1.517-.46-.461zm-1.695 8.196.237.021a3.306 3.306 0 0 1 3.067 3.282c0 .486-.11.963-.33 1.419a.5.5 0 0 1-.804.137l-1.508-1.509-.615.614 1.509 1.509a.5.5 0 0 1-.136.803c-.451.22-.929.331-1.419.331a3.303 3.303 0 0 1-3.282-3.081l-.018-.171a3.299 3.299 0 0 1 .11-.881L4.183 6.494a3.19 3.19 0 0 1-.83.113l-.237-.021A3.303 3.303 0 0 1 .05 3.303c0-.483.111-.96.329-1.417a.5.5 0 0 1 .805-.138l1.508 1.508.615-.613-1.509-1.509a.5.5 0 0 1 .138-.805A3.273 3.273 0 0 1 3.353 0a3.306 3.306 0 0 1 3.283 3.081l.017.174c.002.31-.035.598-.111.879l2.324 2.325 2.333-2.333.778-2.679a.498.498 0 0 1 .25-.305l2.027-1.05a.496.496 0 0 1 .583.09l.979.978c.154.154.19.39.091.583l-1.049 2.029a.5.5 0 0 1-.299.249l-2.65.809-2.336 2.336 2.291 2.292a3.2 3.2 0 0 1 .831-.114zM1.263 14.737a.926.926 0 0 0 1.275 0l3.63-3.569-1.276-1.274-3.63 3.57a.904.904 0 0 0 0 1.273zm3.282-5.903a.499.499 0 0 1 .704.003l1.983 1.981a.498.498 0 0 1-.003.71l-3.986 3.918A1.884 1.884 0 0 1 1.9 16a1.903 1.903 0 0 1-1.345-3.245l.003-.003 3.986-3.918z",
    clipRule: "evenodd"
  }));
};

var SvgTools24X24 = function SvgTools24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -tools",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m13.099 10.236 3.074-3.073.994-3.427a.5.5 0 0 1 .25-.305l2.568-1.33a.5.5 0 0 1 .584.09l1.239 1.24a.5.5 0 0 1 .09.583l-1.329 2.57a.5.5 0 0 1-.298.248l-3.389 1.035-3.076 3.077 3.052 3.052a3.98 3.98 0 0 1 1.14-.158l.223.023A4.041 4.041 0 0 1 22 17.887a3.99 3.99 0 0 1-.405 1.738.5.5 0 0 1-.804.137l-2.004-2.005-.966.967 2.004 2.005a.5.5 0 0 1-.136.804 3.98 3.98 0 0 1-1.74.405 4.031 4.031 0 0 1-4.022-3.76l-.027-.291c0-.366.054-.729.158-1.091L7.206 9.943a3.995 3.995 0 0 1-1.14.156l-.223-.022A4.04 4.04 0 0 1 2.066 6.05c0-.601.14-1.186.403-1.738a.5.5 0 0 1 .805-.138L5.28 6.18l.965-.965L4.24 3.208a.5.5 0 0 1 .138-.804A4.016 4.016 0 0 1 6.116 2a4.035 4.035 0 0 1 4.023 3.762l.027.289c0 .368-.055.732-.16 1.092l3.093 3.093zM2.666 21.333a2.276 2.276 0 0 1 .002-3.218.5.5 0 1 1-.005.706.501.501 0 0 1 .006-.707l5.05-4.963a.5.5 0 0 1 .703.002l2.512 2.51a.5.5 0 0 1-.002.71l-5.047 4.96A2.267 2.267 0 0 1 4.276 22a2.27 2.27 0 0 1-1.61-.667zm5.4-7.122-4.694 4.614a1.275 1.275 0 1 0 1.808 1.799l4.69-4.61-1.804-1.803zm8.905-6.432-.208.125.12-.037.088-.088zm1.097-3.558-.713 2.456 2.423-.74 1.064-2.058-.722-.721-2.052 1.063zm-.118 16.717c.204 0 .407-.022.606-.064l-1.796-1.797a.5.5 0 0 1 0-.707l1.673-1.674a.5.5 0 0 1 .707 0l1.795 1.796c.043-.198.065-.4.065-.605-.001-1.603-1.247-2.92-2.862-3.03l-.19-.021c-.348 0-.698.068-1.053.2a.5.5 0 0 1-.527-.116L9.081 7.632a.5.5 0 0 1-.115-.528c.131-.352.2-.703.202-1.003l-.025-.255A3.04 3.04 0 0 0 6.116 3c-.204 0-.406.022-.606.065L7.306 4.86a.5.5 0 0 1 0 .707L5.633 7.24a.5.5 0 0 1-.707 0L3.13 5.446c-.042.2-.064.402-.064.606 0 1.602 1.246 2.92 2.86 3.03l.19.02c.348 0 .698-.067 1.054-.198a.5.5 0 0 1 .526.115l7.285 7.287a.5.5 0 0 1 .117.524c-.13.36-.198.71-.201 1.006l.026.258a3.036 3.036 0 0 0 3.027 2.845z"
  }));
};

var SvgTractor104X104 = function SvgTractor104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -tractor",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M48.041 47.9a35 35 0 0 1 11.484 21.8h38.387l3.893-21.8H48.041zm-3.924-.591a1 1 0 0 0 .78.582c1.21.931 2.37 1.958 3.47 3.08a33 33 0 0 1 9.263 19.754 1 1 0 0 0 .015.15c.104 1.066.156 2.143.155 3.224a1 1 0 1 0 2 .002c0-.804-.026-1.605-.08-2.401h17.678A12.89 12.89 0 0 0 71.4 82.6c0 7.124 5.775 12.9 12.9 12.9 7.124 0 12.9-5.776 12.9-12.9A12.89 12.89 0 0 0 91.2 71.7h7.549a1 1 0 0 0 .984-.825l4.25-23.8A1 1 0 0 0 103 45.9H76.8V22.59a5.29 5.29 0 0 1 5.29-5.29h.51a1 1 0 1 0 0-2h-.51a7.29 7.29 0 0 0-7.29 7.29V45.9H56.234L49.584 9.32A1 1 0 0 0 48.6 8.5H17.244a7.044 7.044 0 0 0-7.044 7.044v26.707a34.937 34.937 0 0 0-9.9 6.825 1 1 0 1 0 1.4 1.428 32.935 32.935 0 0 1 9.508-6.514.997.997 0 0 0 .72-.315c10.468-4.43 22.741-3.202 32.189 3.634zm1.462-1.41c-9.746-7.206-22.406-8.718-33.379-4.491V15.544a5.044 5.044 0 0 1 5.044-5.044h30.521l6.437 35.4h-8.623zM24.798 52.7c11.82 0 21.4 9.58 21.4 21.4 0 11.82-9.58 21.4-21.4 21.4-11.819 0-21.4-9.58-21.4-21.4 0-11.82 9.581-21.4 21.4-21.4zm0 2c-10.714 0-19.4 8.685-19.4 19.4 0 10.715 8.686 19.4 19.4 19.4 10.715 0 19.4-8.685 19.4-19.4 0-10.715-8.685-19.4-19.4-19.4zm59.5 17c-6.02 0-10.9 4.88-10.9 10.9s4.88 10.9 10.9 10.9 10.9-4.88 10.9-10.9-4.88-10.9-10.9-10.9z",
    clipRule: "evenodd"
  }));
};

var SvgTractor16X16 = function SvgTractor16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -tractor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.404 10.25h5.053l.446-2.5h-6.69a5.44 5.44 0 0 1 1.19 2.5zm3.346 3.5a1.251 1.251 0 0 0 0-2.5c-.69 0-1.25.561-1.25 1.25s.56 1.25 1.25 1.25zM2.5 2.639v3.316a5.51 5.51 0 0 1 4.65.795h.752l-.82-4.5H2.89a.39.39 0 0 0-.39.389zm13 4.111a.5.5 0 0 1 .493.588l-.625 3.5a.5.5 0 0 1-.493.412h-.255a2.252 2.252 0 0 1-1.87 3.5 2.253 2.253 0 0 1-2.25-2.25c0-.462.14-.892.38-1.25H9.5a.5.5 0 0 1-1 0 4.475 4.475 0 0 0-1.286-3.154 4.494 4.494 0 0 0-.462-.405.5.5 0 0 1-.141-.104 4.515 4.515 0 0 0-4.324-.503.506.506 0 0 1-.182.08c-.453.21-.878.499-1.254.868a.5.5 0 0 1-.701-.714c.41-.401.865-.725 1.35-.972V2.639c0-.766.624-1.389 1.389-1.389h4.61a.5.5 0 0 1 .493.411l.925 5.089H11V3.675c0-.786.64-1.425 1.425-1.425.277 0 .538.224.538.5s-.186.5-.463.5c-.31 0-.5.19-.5.425V6.75h3.5zm-14 4.5c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5-2.5 1.122-2.5 2.5zm-1 0c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z",
    clipRule: "evenodd"
  }));
};

var SvgTractor24X24 = function SvgTractor24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -tractor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M19.327 15.686h2.796l.78-4.33H11.786a8.074 8.074 0 0 1 2.15 4.33h5.303a3.275 3.275 0 0 1 .088 0zm2.274.991c.537.566.866 1.327.866 2.165 0 1.744-1.426 3.158-3.184 3.158-1.758 0-3.183-1.414-3.183-3.158 0-.838.33-1.6.866-2.165H14.03c.003.088.004.177.004.265a.498.498 0 0 1-.5.495.498.498 0 0 1-.5-.496 7.047 7.047 0 0 0-.038-.732 7.083 7.083 0 0 0-2.718-4.877.5.5 0 0 1-.262-.194 7.228 7.228 0 0 0-6.901-.767.5.5 0 0 1-.242.104A7.156 7.156 0 0 0 .85 11.86a.503.503 0 0 1-.707-.007.493.493 0 0 1 .007-.701A8.158 8.158 0 0 1 2.3 9.647V3.848C2.3 2.828 3.134 2 4.163 2h7.07c.242 0 .45.171.493.407l1.458 7.956h3.683v-4.94a1.91 1.91 0 0 1 1.918-1.902h.115c.276 0 .5.222.5.496s-.224.495-.5.495h-.115a.914.914 0 0 0-.918.91v4.941H23.5c.311 0 .547.28.492.583l-.958 5.323a.499.499 0 0 1-.492.408H21.6zm-2.281 0h-.073a2.173 2.173 0 0 0-2.147 2.165c0 1.196.978 2.166 2.183 2.166 1.206 0 2.184-.97 2.184-2.166a2.174 2.174 0 0 0-2.147-2.165zm-7.152-6.314-1.352-7.372H4.163a.86.86 0 0 0-.863.857v5.396a8.234 8.234 0 0 1 7.342 1.12h1.526zm-6.301 1.52c2.817 0 5.1 2.265 5.1 5.058 0 2.794-2.283 5.058-5.1 5.058-2.817 0-5.1-2.264-5.1-5.058 0-2.793 2.283-5.057 5.1-5.057zm0 .993c-2.265 0-4.1 1.82-4.1 4.065 0 2.247 1.835 4.066 4.1 4.066s4.1-1.82 4.1-4.066c0-2.245-1.836-4.065-4.1-4.065z"
  }));
};

var SvgTrash104X104 = function SvgTrash104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -trash",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M62 0a8 8 0 0 1 8 8v7h16a4 4 0 0 1 4 4v7a4.002 4.002 0 0 1-3 3.874V96a8 8 0 0 1-8 8H25a8 8 0 0 1-8-8V29.874A4.002 4.002 0 0 1 14 26v-7a4 4 0 0 1 4-4h16V8a8 8 0 0 1 8-8h20zM36 15h32V8a6 6 0 0 0-5.775-5.996L62 2H42a6 6 0 0 0-5.996 5.775L36 8v7zM19 30h66v66l-.004.225A6 6 0 0 1 79 102H25l-.225-.004A6 6 0 0 1 19 96V30zm69-4a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h68a2 2 0 0 1 2 2v7zM53.993 43.55a1 1 0 0 0-1.993.117v42.666l.007.117A1 1 0 0 0 54 86.333V43.667l-.007-.117zM69 42.667a1 1 0 0 1 .993.883l.007.117v42.666a1 1 0 0 1-1.993.117L68 86.333V43.667a1 1 0 0 1 1-1zm-31.007.883a1 1 0 0 0-1.993.117v42.666l.007.117A1 1 0 0 0 38 86.333V43.667l-.007-.117z",
    clipRule: "evenodd"
  }));
};

var SvgTrash16X16 = function SvgTrash16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -trash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.667 0C10.403 0 11 .597 11 1.333V2h1.667C13.403 2 14 2.597 14 3.333V4c0 .621-.425 1.143-1 1.291v9.376c0 .736-.597 1.333-1.333 1.333H4.333A1.333 1.333 0 0 1 3 14.667V5.29C2.425 5.143 2 4.621 2 4v-.667C2 2.597 2.597 2 3.333 2H5v-.667C5 .597 5.597 0 6.333 0h3.334zM10 1.333V2H6v-.667l.007-.067A.333.333 0 0 1 6.333 1h3.334l.067.007a.333.333 0 0 1 .266.326zM13 4c0 .184-.15.333-.333.333H3.333A.333.333 0 0 1 3 4v-.667C3 3.15 3.15 3 3.333 3h9.334c.184 0 .333.15.333.333V4zm-1 1.334H4v9.333c0 .16.114.295.266.326l.067.007h7.334a.333.333 0 0 0 .326-.266l.007-.067V5.334zM8.492 6.651a.5.5 0 0 0-.992.09v6.518l.008.09a.5.5 0 0 0 .992-.09V6.741l-.008-.09zM10 6.24a.5.5 0 0 1 .492.41l.008.09v6.518a.5.5 0 0 1-.992.09l-.008-.09V6.741a.5.5 0 0 1 .5-.5zm-3.508.41a.5.5 0 0 0-.992.09v6.518l.008.09a.5.5 0 0 0 .992-.09V6.741l-.008-.09z",
    clipRule: "evenodd"
  }));
};

var SvgTrash24X24 = function SvgTrash24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -trash",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 0a2 2 0 0 1 2 2v1h3.5A1.5 1.5 0 0 1 21 4.5v1a1.5 1.5 0 0 1-1 1.415V22a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6.915A1.5 1.5 0 0 1 3 5.5v-1A1.5 1.5 0 0 1 4.5 3H8V2a2 2 0 0 1 2-2h4Zm1 2v1H9V2l.007-.117A1 1 0 0 1 10 1h4l.117.007A1 1 0 0 1 15 2ZM5 7h14v15l-.007.117A1 1 0 0 1 18 23H6l-.117-.007A1 1 0 0 1 5 22V7Zm15-1.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v1Zm-7.508 4.521a.5.5 0 0 0-.992.09v9.778l.008.09a.5.5 0 0 0 .992-.09V10.11l-.008-.09ZM15 9.611a.5.5 0 0 1 .492.41l.008.09v9.778a.5.5 0 0 1-.992.09l-.008-.09V10.11a.5.5 0 0 1 .5-.5Zm-5.508.41a.5.5 0 0 0-.992.09v9.778l.008.09a.5.5 0 0 0 .992-.09V10.11l-.008-.09Z",
    clipRule: "evenodd"
  }));
};

var SvgTrophy104X104 = function SvgTrophy104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -trophy",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M73.635 46.525C77.96 40.973 80.2 33.487 80.2 25.14V8.27c3.41-2.692 8.788-3.622 13.354-2.254C98.771 7.579 102 11.727 102 18c0 14.532-10.098 25.384-28.365 28.525zm-3.132.551c-.131.084-.24.196-.32.328C65.82 51.793 59.72 54.4 52 54.4c-7.759 0-13.873-2.628-18.236-7.075a1.008 1.008 0 0 0-.186-.191C28.452 41.787 25.8 33.889 25.8 24.799V7.045A5.044 5.044 0 0 1 30.844 2h42.312A5.044 5.044 0 0 1 78.2 7.045V25.14c0 8.867-2.63 16.636-7.697 21.936zM23.893 5.892C19.99 3.423 14.57 2.694 9.873 4.1 3.825 5.912 0 10.826 0 18c0 16.199 11.753 28.147 32.449 30.863 4.504 4.535 10.723 7.307 18.55 7.524v23.259H27.445A7.044 7.044 0 0 0 20.4 86.69v10.265A7.044 7.044 0 0 0 27.444 104h49.111a7.045 7.045 0 0 0 7.045-7.044V86.69a7.044 7.044 0 0 0-7.045-7.045H53v-23.26c7.835-.217 14.068-2.999 18.58-7.527C92.257 46.136 104 34.192 104 17.999c0-7.173-3.825-12.087-9.872-13.898-4.697-1.407-10.118-.678-14.022 1.791A7.046 7.046 0 0 0 73.156 0H30.844c-3.498 0-6.4 2.55-6.95 5.892zm-.093 2.38c-3.41-2.693-8.788-3.623-13.354-2.255C5.229 7.579 2 11.727 2 18 2 32.542 12.111 43.399 30.401 46.53 26.048 40.924 23.8 33.327 23.8 24.8V8.27zM52 81.645h24.555A5.044 5.044 0 0 1 81.6 86.69v10.265A5.045 5.045 0 0 1 76.555 102h-49.11a5.044 5.044 0 0 1-5.045-5.044V86.69a5.044 5.044 0 0 1 5.044-5.045H52z",
    clipRule: "evenodd"
  }));
};

var SvgTrophy16X16 = function SvgTrophy16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -trophy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.931 6.662c.376-.756.569-1.65.569-2.612V1.748C13.49 1.102 15 1.633 15 3c0 1.736-1.066 3.079-3.069 3.662zm-1.464.365a.492.492 0 0 0-.047.048c-.58.58-1.388.923-2.41.925A.51.51 0 0 0 8 8a.51.51 0 0 0-.01 0C5.71 7.995 4.5 6.3 4.5 4V1.503a.574.574 0 0 0 0-.006V1.39c0-.215.174-.389.389-.389h6.222c.215 0 .389.174.389.389V4.05c0 1.214-.352 2.265-1.033 2.977zM12.323.71C13.9.011 16 .908 16 3c0 2.535-1.819 4.417-4.953 4.871-.645.612-1.498 1.01-2.547 1.107v2.735h3.112c.766 0 1.388.621 1.388 1.389v1.509c0 .767-.622 1.389-1.388 1.389H4.389a1.389 1.389 0 0 1-1.39-1.39v-1.508c0-.768.622-1.39 1.39-1.39H7.5V8.979c-1.048-.096-1.9-.494-2.544-1.106C1.82 7.418 0 5.536 0 3 0 .908 2.101.011 3.677.71 3.915.286 4.368 0 4.889 0h6.222c.52 0 .974.286 1.212.71zM3.5 1.748C2.51 1.102 1 1.633 1 3c0 1.738 1.069 3.082 3.076 3.664C3.696 5.897 3.5 4.985 3.5 4V1.748zM8 12.713h3.612c.214 0 .388.174.388.389v1.509a.389.389 0 0 1-.388.389H4.389a.389.389 0 0 1-.39-.39v-1.508c0-.215.174-.39.39-.39H8z",
    clipRule: "evenodd"
  }));
};

var SvgTrophy24X24 = function SvgTrophy24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -trophy",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.717 10.515c.561-.992.85-2.203.85-3.518V4.01C18.897 3.077 21 3.788 21 5.667c0 2.346-1.499 4.143-4.283 4.848Zm-1.558.411c-.76.76-1.82 1.208-3.159 1.208-2.983 0-4.567-2.217-4.567-5.2V3.626c0-.345.28-.626.626-.626h7.882c.345 0 .626.28.626.626v3.371c0 1.57-.458 2.935-1.343 3.862a.499.499 0 0 0-.065.067Zm2.257-7.984C19.343 1.994 22 3.076 22 5.667c0 3.153-2.27 5.49-6.203 6.045-.825.795-1.93 1.305-3.297 1.404v3.72h4.074c.898 0 1.626.728 1.626 1.626v1.912c0 .898-.728 1.626-1.626 1.626H7.426A1.626 1.626 0 0 1 5.8 20.374v-1.912c0-.898.728-1.626 1.626-1.626H11.5v-3.72c-1.365-.1-2.468-.607-3.292-1.403C4.271 11.159 2 8.82 2 5.667c0-2.59 2.658-3.673 4.584-2.725A1.627 1.627 0 0 1 8.059 2h7.882c.653 0 1.217.386 1.475.942ZM6.433 4.01v2.923c0 1.345.291 2.578.859 3.584C4.502 9.814 3 8.015 3 5.667c0-1.88 2.103-2.59 3.433-1.656ZM12 17.836h4.574c.346 0 .626.28.626.626v1.912c0 .346-.28.626-.626.626H7.426a.626.626 0 0 1-.626-.626v-1.912c0-.346.28-.626.626-.626H12Z",
    fill: "currentColor"
  }));
};

var SvgTruck104X104 = function SvgTruck104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -truck",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.985 15.973V62.5h64.03V15.973a.505.505 0 0 0-.506-.504H2.492a.506.506 0 0 0-.507.504zM0 62.515c0 .175.046.34.126.482-.08.139-.126.3-.126.47V80.07c0 1.342 1.125 2.43 2.511 2.43h6.607c.719 4.534 4.646 8 9.383 8 4.737 0 8.665-3.469 9.382-8.005.034.003.067.005.102.005h47.133c.719 4.534 4.646 8 9.382 8 4.737 0 8.666-3.469 9.383-8.005.035.003.07.005.105.005h7.501c1.386 0 2.511-1.089 2.511-2.43V63.468c0-.17-.045-.33-.125-.47a.965.965 0 0 0 .125-.477v-10.85a.976.976 0 0 0-.337-.737L86.151 35.742a.992.992 0 0 0-.65-.242H68V15.973a2.482 2.482 0 0 0-2.49-2.473H2.491A2.483 2.483 0 0 0 0 15.973v46.542zM76.964 81.77a1.013 1.013 0 0 0-.038-.65V81a7.575 7.575 0 1 1 .038.77zm-1.951-1.27H27.987c-.26-5.014-4.408-9-9.487-9-5.1 0-9.262 4.02-9.49 9.064H2.51A.504.504 0 0 1 2 80.07V64.436h100V80.07a.503.503 0 0 1-.511.494H93.99C93.762 75.52 89.6 71.5 84.5 71.5c-5.079 0-9.227 3.986-9.487 9zm27.013-28.386V62.5H68V37.457h17.13l16.896 14.657zM18.501 73.425a7.576 7.576 0 1 0 0 15.151 7.576 7.576 0 0 0 0-15.15z",
    clipRule: "evenodd"
  }));
};

var SvgTruck16X16 = function SvgTruck16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -truck",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.783 2.993H1v6.129h8.782v-6.13zM0 2.717v6.879A.5.5 0 0 0 0 9.618v2.505a.72.72 0 0 0 .723.717h.697c.257.678.916 1.16 1.689 1.16.82 0 1.514-.543 1.733-1.288h6.317c.22.744.912 1.288 1.733 1.288.773 0 1.432-.482 1.689-1.16h.697c.4 0 .722-.32.722-.717V8a.495.495 0 0 0-.17-.373L13.222 5.36a.502.502 0 0 0-.33-.123h-2.11v-2.52a.719.719 0 0 0-.72-.717H.723A.72.72 0 0 0 0 2.717zm12.086 9.512a.439.439 0 0 0 0-.036.802.802 0 0 1 .805-.783c.441 0 .8.353.804.79a.492.492 0 0 0-.02.184.803.803 0 0 1-.784.623.802.802 0 0 1-.805-.778zm-.93-.517H4.844a1.804 1.804 0 0 0-1.735-1.295c-.872 0-1.599.614-1.767 1.43H1v-1.732h9.262a.45.45 0 0 0 .04 0H15v1.732h-.34a1.802 1.802 0 0 0-1.768-1.43c-.824 0-1.518.547-1.735 1.295zm-7.243.485a.802.802 0 0 0-.805-.787.802.802 0 0 0-.799.891.802.802 0 0 0 .799.706.802.802 0 0 0 .805-.81zM15 9.122h-4.218V6.23h1.922L15 8.226v.896z",
    clipRule: "evenodd"
  }));
};

var SvgTruck24X24 = function SvgTruck24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -truck",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M6.95 19a2.502 2.502 0 0 1-4.848.209H.84A.84.84 0 0 1 0 18.367V3.84A.84.84 0 0 1 .841 3h14.318a.84.84 0 0 1 .841.841V8h3.5a.5.5 0 0 1 .33.124l4 3.5A.5.5 0 0 1 24 12v6.367a.84.84 0 0 1-.841.841h-1.26A2.502 2.502 0 0 1 17.05 19H6.95zm0-1h10.1a2.502 2.502 0 0 1 4.933.209H23V15H1v3.208h1.017A2.501 2.501 0 0 1 6.95 18zM23 14v-1.773L19.312 9H16v5h7zM1 14h14V4H1v10zm20 4.532V18.5a1.5 1.5 0 1 0-.027.283.504.504 0 0 1 .027-.25zM4.5 17a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 4.5 17z"
  }));
};

var SvgUmbrella104X104 = function SvgUmbrella104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -umbrella"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.258 4.18c14.24-5.722 33.679-7.566 54.481 7.681 20.8 15.249 25.097 34.487 24.137 49.933-.957 15.39-7.124 27.025-7.28 27.311l-.001.002a6.791 6.791 0 0 1-4.445 3.37h-.005a6.709 6.709 0 0 1-5.444-1.136L45.756 61.328a1 1 0 0 1-.107.175l-32.256 42.105a1 1 0 0 1-1.587-1.216l32.255-42.105a.999.999 0 0 1 .11-.122L2.785 29.828A6.82 6.82 0 0 1 .032 24.96a6.844 6.844 0 0 1 1.781-5.307l.007-.007.006-.007.008-.008C2.201 19.248 11.2 9.83 25.258 4.18ZM3.277 21.017a4.844 4.844 0 0 0-1.255 3.753v.003a4.82 4.82 0 0 0 1.946 3.442l20.725 15.193c.014-.02.03-.039.045-.057l.749.639-.748-.64.002-.003.007-.007.024-.028.023-.027.07-.08a67.733 67.733 0 0 1 1.722-1.873 93.762 93.762 0 0 1 5.068-4.913c4.308-3.877 10.37-8.635 17.347-12.092 6.961-3.45 14.811-5.765 20.897-7.217 3.048-.727 5.664-1.24 7.52-1.571a101.496 101.496 0 0 1 2.757-.454l.113-.017a1.005 1.005 0 0 1 .34-.017 72.81 72.81 0 0 0-2.073-1.577C58.421-1.284 39.739.517 26.003 6.036 12.357 11.519 3.6 20.678 3.277 21.016Zm78.188-5.295C99.095 30.085 102.76 47.5 101.88 61.67c-.465 7.477-2.199 14.053-3.835 18.79a68.19 68.19 0 0 1-2.201 5.594 45.965 45.965 0 0 1-.924 1.942 19.96 19.96 0 0 1-.058.11l-.016.031-.005.01a4.791 4.791 0 0 1-3.131 2.379 4.709 4.709 0 0 1-3.826-.796v-.001l-22.931-16.81a54.804 54.804 0 0 0 1.362-1.733 81.352 81.352 0 0 0 3.764-5.458c2.966-4.683 6.578-11.356 9.148-19.304 2.581-7.98 3.144-15.613 3.065-21.242-.04-2.817-.24-5.14-.432-6.762a46.03 46.03 0 0 0-.34-2.364 1.012 1.012 0 0 0-.054-.334Zm-1.788 1.463c.058.383.126.877.196 1.47.184 1.563.38 3.816.418 6.555.077 5.482-.473 12.884-2.968 20.598-2.505 7.746-6.031 14.265-8.934 18.85a79.377 79.377 0 0 1-3.671 5.324 52.879 52.879 0 0 1-1.382 1.753L26.31 44.592l.06-.07a65.796 65.796 0 0 1 1.664-1.81 91.748 91.748 0 0 1 4.96-4.806c4.233-3.81 10.143-8.44 16.897-11.787 6.769-3.355 14.455-5.628 20.473-7.063a133.243 133.243 0 0 1 7.407-1.549c.783-.14 1.427-.246 1.907-.322ZM26.26 44.649 25.5 44l.76.65Z"
  }));
};

var SvgUmbrella16X16 = function SvgUmbrella16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -umbrella"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.935.642C6.12-.238 9.112-.518 12.29 1.82c3.175 2.336 3.839 5.302 3.692 7.674-.145 2.344-1.078 4.114-1.113 4.177-.185.339-.506.586-.885.673h-.003a1.348 1.348 0 0 1-1.086-.227m0 0L6.996 9.777 2.479 15.8a.5.5 0 1 1-.8-.6L6.19 9.185.553 5.037a1.36 1.36 0 0 1-.547-.969C-.03 3.683.097 3.3.36 3.014l.006-.007.007-.006.016-.017A7.51 7.51 0 0 1 .64 2.74c.168-.156.41-.368.718-.605A10.999 10.999 0 0 1 3.935.642M1.093 3.694a.364.364 0 0 0-.091.28v.001a.36.36 0 0 0 .144.257L4.077 6.39l.043-.053a12.703 12.703 0 0 1 .858-.93c.575-.564 1.401-1.27 2.386-1.812.982-.54 2.08-.898 2.919-1.12.344-.091.648-.16.889-.21C8.531.566 6.12.84 4.308 1.57c-1.9.766-3.135 2.04-3.216 2.124Zm10.565-.508-.138.027c-.24.047-.583.122-.981.227-.802.213-1.812.545-2.693 1.03-.877.482-1.63 1.123-2.168 1.65a11.7 11.7 0 0 0-.794.862l4.63 3.406a.498.498 0 0 1 .086-.133l.008-.01a8.595 8.595 0 0 0 .612-.856c.358-.575.8-1.414 1.122-2.461.318-1.034.39-2.031.38-2.774a9.04 9.04 0 0 0-.064-.968Zm-1.684 7.4.373.332a.523.523 0 0 1-.048.048l3.187 2.344a.34.34 0 0 0 .504-.118c.008-.016.22-.42.448-1.08.233-.679.48-1.617.545-2.68.114-1.837-.306-4.048-2.293-5.97.016.193.028.422.032.68.01.811-.067 1.918-.424 3.08a11.532 11.532 0 0 1-1.23 2.697 9.6 9.6 0 0 1-.657.925l-.045.053-.012.014-.004.005-.002.001v.001l-.374-.332Z"
  }));
};

var SvgUmbrella24X24 = function SvgUmbrella24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -umbrella"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.901 2.804c2.732-1.102 6.473-1.453 10.452 1.474 3.978 2.927 4.807 6.636 4.623 9.605-.182 2.942-1.354 5.163-1.393 5.235a1.58 1.58 0 0 1-1.034.786l-.003.001a1.57 1.57 0 0 1-1.269-.266l-7.576-5.574L4.9 21.8a.5.5 0 0 1-.8-.6l5.795-7.727L2.647 8.14a1.589 1.589 0 0 1-.64-1.133c-.043-.451.106-.9.413-1.233l.007-.007a.97.97 0 0 0 .008-.008l.02-.02c.016-.018.039-.04.068-.07a13.272 13.272 0 0 1 1.145-.994A13.798 13.798 0 0 1 6.9 2.804Zm-3.747 3.65a.595.595 0 0 0-.151.459v.001c.016.17.102.323.236.42l3.823 2.813a.502.502 0 0 1 .043-.066l.395.306-.395-.306.002-.003.005-.005.016-.021a7.813 7.813 0 0 1 .288-.344c.198-.227.486-.542.85-.898.723-.71 1.76-1.596 2.993-2.275 1.23-.676 2.608-1.126 3.667-1.406A21.595 21.595 0 0 1 16.36 4.8c-3.492-2.374-6.698-2.032-9.086-1.07-2.446.987-4.03 2.628-4.121 2.724Zm14.622-.541c.032.294.064.706.071 1.2.014 1.02-.083 2.408-.53 3.862a14.47 14.47 0 0 1-1.545 3.385c-.248.397-.469.705-.63.915a7.823 7.823 0 0 1-.246.307l-.015.018-.005.005-.001.002h-.001l-.363-.322.363.323a.498.498 0 0 1-.202.137l4.198 3.089a.562.562 0 0 0 .834-.193c.005-.008.073-.138.176-.37a13.186 13.186 0 0 0 1.098-4.45c.151-2.434-.43-5.387-3.203-7.908ZM14 15.25a.498.498 0 0 1 .125-.307l.002-.002.01-.011.042-.05a10.984 10.984 0 0 0 .744-1.05 13.47 13.47 0 0 0 1.436-3.15c.409-1.327.5-2.604.487-3.554a11.585 11.585 0 0 0-.1-1.38 20.594 20.594 0 0 0-1.565.35c-1.021.269-2.312.694-3.441 1.315-1.126.619-2.09 1.44-2.776 2.112a14.937 14.937 0 0 0-1.003 1.087l-.052.064-.012.015-.003.004a.521.521 0 0 1-.035.04L14 15.251Z"
  }));
};

var SvgUmbrella64X64 = function SvgUmbrella64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon -umbrella"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.523 2.625C24.292-.968 36.257-2.127 49.067 7.45 61.874 17.027 64.514 29.1 63.923 38.791c-.589 9.667-4.387 16.977-4.48 17.15a4.088 4.088 0 0 1-2.668 2.062h-.003a3.98 3.98 0 0 1-3.273-.696m0 0L27.722 38.035l-19.66 25.77a.5.5 0 0 1-.794-.607L26.92 37.435 1.669 18.554a4.184 4.184 0 0 1-1.65-2.972 4.228 4.228 0 0 1 1.066-3.238l.007-.007.005-.005c.222-.238 5.766-6.157 14.426-9.707M1.824 13.018c-.6.664-.896 1.56-.81 2.47v.002c.084.907.54 1.73 1.254 2.263l12.772 9.55a.501.501 0 0 1 .082-.13l.378.327-.378-.327.001-.002.004-.005.015-.017.058-.065a44.213 44.213 0 0 1 1.079-1.162 60.924 60.924 0 0 1 3.168-3.056c2.689-2.416 6.457-5.382 10.75-7.552 4.291-2.169 9.229-3.62 13.08-4.528a84.253 84.253 0 0 1 4.77-.981 63.707 63.707 0 0 1 1.756-.283l.078-.01a.518.518 0 0 1 .188-.008 44.935 44.935 0 0 0-1.6-1.253C35.994-1.075 24.414.063 15.902 3.551 7.437 7.02 2.011 12.818 1.824 13.018Zm48.65-3.176c10.75 9.046 12.994 19.98 12.451 28.888-.288 4.727-1.362 8.882-2.375 11.875a43.635 43.635 0 0 1-1.364 3.536 29.532 29.532 0 0 1-.574 1.23l-.036.07-.01.02-.004.007a3.088 3.088 0 0 1-2.012 1.56 2.979 2.979 0 0 1-2.452-.521L39.852 45.855a.523.523 0 0 0 .032-.034L39.5 45.5l.384.32.001-.001.004-.005.013-.016.05-.06.188-.236c.162-.206.396-.51.686-.906a51.12 51.12 0 0 0 2.289-3.415c1.805-2.932 4.008-7.114 5.59-12.107 1.587-5.003 2.031-9.786 2.08-13.314.024-1.765-.051-3.219-.132-4.234a31.279 31.279 0 0 0-.154-1.489.5.5 0 0 0-.025-.195Zm-.917.728c.029.255.064.604.099 1.036.079.988.152 2.411.129 4.14-.048 3.463-.484 8.142-2.032 13.026-1.553 4.895-3.715 9.001-5.49 11.885a50.113 50.113 0 0 1-2.243 3.347 33.205 33.205 0 0 1-.875 1.14l-.015.018-.01.014-.003.002a.508.508 0 0 0-.057.085L15.819 27.885a.51.51 0 0 0 .06-.058m0 0 .003-.005.013-.014.054-.061.214-.24c.19-.209.472-.513.837-.892a59.966 59.966 0 0 1 3.116-3.006c2.652-2.383 6.346-5.287 10.533-7.403 4.19-2.117 9.04-3.546 12.858-4.447a83.24 83.24 0 0 1 4.713-.97c.567-.099 1.021-.171 1.337-.22"
  }));
};

var SvgUndo104X104 = function SvgUndo104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -undo",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M52 14.843c-5.3 0-10.5.909-15.4 2.726L52.7 1.717c.4-.404.4-1.01 0-1.414a.96.96 0 0 0-1.4 0L32.8 18.478c-.2.202-.3.404-.3.706s.1.505.3.707l14.4 13.127c.414.417 1.2.302 1.5-.102.3-.403.3-1.01-.1-1.413l-12.7-11.51c5-2.02 10.5-3.13 16.1-3.13 23.7 0 43 18.982 43 42.508S75.7 102 52 102 9 82.897 9 59.37c0-.605-.4-1.009-1-1.009s-1 .404-1 1.01C7 84.008 27.2 104 52 104s45-19.992 45-44.528c0-24.637-20.2-44.63-45-44.63z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h104v104H0z"
  }))));
};

var SvgUndo16X16 = function SvgUndo16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -undo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 2.143c-.4 0-.7 0-1 .1L8.3.847c.2-.199.2-.498 0-.697-.2-.2-.5-.2-.7 0L5 2.94c-.1.1-.1.2-.1.3 0 .1.1.299.2.399l2.1 1.794c.1.1.2.1.3.1.1 0 .3-.1.4-.2.1-.1.1-.398-.1-.598L6.3 3.44c.5-.1 1-.2 1.7-.2 3.3 0 5.9 2.692 5.9 5.883 0 3.19-2.6 5.881-5.9 5.881-3.3 0-5.9-2.692-5.9-5.881 0-.3-.2-.499-.5-.499s-.5.2-.5.499C1.1 12.91 4.2 16 8 16c3.8 0 6.9-3.09 6.9-6.878 0-3.789-3.1-6.979-6.9-6.979z"
  }));
};

var SvgUndo24X24 = function SvgUndo24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    role: "img",
    className: "icon -undo"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.803c-.567 0-1.228.095-1.794.19l2.172-2.185a.461.461 0 0 0 0-.665.455.455 0 0 0-.661 0L8.3 5.598a.537.537 0 0 0-.172.362c0 .138.078.257.172.353l2.567 2.385c.094.095.189.095.283.095.094 0 .283-.095.378-.19a.461.461 0 0 0 0-.665L9.544 6.133c.756-.285 1.606-.38 2.456-.38 4.156 0 7.5 3.42 7.5 7.6C19.5 17.56 16.156 21 12 21c-4.156 0-7.5-3.32-7.5-7.5 0-.348-.258-.5-.5-.5-.3 0-.5.215-.5.5 0 4.75 3.872 8.5 8.5 8.5 4.722 0 8.5-3.895 8.5-8.551 0-4.75-3.778-8.646-8.5-8.646Z"
  }));
};

var SvgUndo64X64 = function SvgUndo64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -undo",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32 9.243c-3.4 0-6.7.6-9.7 1.598L32.3.85c.2-.2.2-.5 0-.7-.2-.199-.5-.199-.7 0L20.3 11.423c-.1.1-.22.285-.22.478s.12.34.22.44l8.845 7.82c.199.2.583.172.755 0 .2-.2.2-.525 0-.725l-8.1-7.294.2-.1c3.1-1.2 6.4-1.799 10-1.799 14.6 0 26.5 11.79 26.5 26.28C58.5 51.11 46.6 63 32 63S5.5 51.11 5.5 36.52c0-.263-.2-.5-.5-.5s-.5.2-.5.5C4.5 51.71 16.8 64 32 64s27.5-12.29 27.5-27.479C59.5 21.534 47.2 9.244 32 9.244z"
  }));
};

var SvgUpload104X104 = function SvgUpload104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -upload",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M41.14 22.681c-8.936 4.059-15.322 12.245-17.154 21.901C13.795 42.345 3.528 48.507.718 58.762c-2.907 10.615 3.274 21.595 13.807 24.525 1.56.433 3.162.672 4.774.713H80.8C93.614 84 104 73.533 104 60.62c0-12.912-10.386-23.38-23.2-23.38h-.215c-7.008-14.819-24.523-21.338-39.446-14.559zM51 81.984H19.324a17.673 17.673 0 0 1-4.266-.64C5.589 78.71.032 68.841 2.647 59.3 5.26 49.757 15.054 44.158 24.521 46.79a1 1 0 0 0 1.255-.818c1.443-9.451 7.534-17.525 16.184-21.454 14.113-6.412 30.712-.08 37.074 14.143a1 1 0 0 0 .911.594h.854c11.71 0 21.2 9.565 21.2 21.365 0 11.8-9.49 21.363-21.2 21.363H53V48.081L68.924 62.15a.995.995 0 0 0 1.411-.094 1.013 1.013 0 0 0-.092-1.422L52.66 45.1a.994.994 0 0 0-1.346.025L33.732 61.84a1.013 1.013 0 0 0-.04 1.425.995.995 0 0 0 1.413.041L51 48.193v33.792z",
    clipRule: "evenodd"
  }));
};

var SvgUpload16X16 = function SvgUpload16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -upload",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.259 3.42A4.752 4.752 0 0 0 3.61 6.521 3.264 3.264 0 0 0 .119 8.887c-.48 1.73.54 3.52 2.277 3.997.255.07.519.109.785.116h9.054A3.757 3.757 0 0 0 16 9.251a3.756 3.756 0 0 0-3.578-3.743A4.779 4.779 0 0 0 6.26 3.42zM12.235 12h-9.04a2.261 2.261 0 0 1-.534-.08 2.247 2.247 0 0 1-1.579-2.766 2.265 2.265 0 0 1 2.784-1.57.5.5 0 0 0 .627-.406 3.748 3.748 0 0 1 2.175-2.845 3.777 3.777 0 0 1 4.986 1.877.5.5 0 0 0 .455.294h.126A2.757 2.757 0 0 1 15 9.25a2.757 2.757 0 0 1-2.765 2.75zm-1.245-1.985a.458.458 0 0 0 0-.696L8.365 6.985l-.062-.047-.011-.007a.56.56 0 0 0-.657.055L5.01 9.318l-.054.056-.008.011a.457.457 0 0 0 .062.63l.062.047.01.007a.56.56 0 0 0 .658-.054L7.5 8.45V12h1V8.45l1.76 1.565.062.047.01.007a.56.56 0 0 0 .658-.054z",
    clipRule: "evenodd"
  }));
};

var SvgUpload24X24 = function SvgUpload24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -upload",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.438 5.13a7.09 7.09 0 0 0-3.967 4.874C3.123 9.63.82 11.087.17 13.454c-.695 2.543.785 5.173 3.306 5.875.375.104.758.16 1.143.17l13.875.001c3.04 0 5.506-2.486 5.506-5.554 0-3.027-2.399-5.487-5.383-5.553-1.693-3.37-5.731-4.831-9.18-3.263ZM11.5 18.491H4.633a3.77 3.77 0 0 1-.892-.134c-1.987-.554-3.154-2.629-2.605-4.635.55-2.007 2.607-3.184 4.596-2.63a.5.5 0 0 0 .627-.41 6.09 6.09 0 0 1 3.49-4.632c3.044-1.385 6.624-.018 7.998 3.053a.5.5 0 0 0 .456.297h.192C20.984 9.4 23 11.435 23 13.946s-2.017 4.545-4.506 4.545H12.5v-6.094l2.646 2.94.07.065c.195.15.464.128.638-.065a.6.6 0 0 0 0-.785l-3.5-3.89-.07-.064a.464.464 0 0 0-.638.065l-3.5 3.889-.057.076a.603.603 0 0 0 .057.71l.07.064c.195.15.464.128.638-.065l2.646-2.94v6.094Z",
    clipRule: "evenodd"
  }));
};

var SvgUser104X104 = function SvgUser104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -user",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M73.885 22.046c0 12.175-9.799 22.046-21.885 22.046-12.086 0-21.885-9.87-21.885-22.046S39.913 0 52 0c12.087 0 21.885 9.87 21.885 22.046zm-1.986 0C71.9 10.975 62.99 2 52 2s-19.9 8.975-19.9 20.046c0 11.07 8.91 20.046 19.9 20.046s19.9-8.975 19.9-20.046zM52.001 56.647C26.587 56.647 5.985 77.4 5.985 103c0 .552-.444 1-.992 1A.997.997 0 0 1 4 103c0-26.704 21.49-48.353 48-48.353S100 76.296 100 103c0 .552-.444 1-.993 1a.997.997 0 0 1-.992-1c0-25.6-20.602-46.353-46.014-46.353z",
    clipRule: "evenodd"
  }));
};

var SvgUser16X16 = function SvgUser16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.525 3.5A2.53 2.53 0 0 0 8 .974 2.53 2.53 0 0 0 5.473 3.5a2.53 2.53 0 0 0 2.526 2.526A2.53 2.53 0 0 0 10.526 3.5zm.975 0C11.5 5.43 9.93 7 8 7S4.5 5.43 4.5 3.5 6.07 0 8 0s3.5 1.57 3.5 3.5zM0 15.498C0 11.363 3.59 8 8 8s8 3.363 8 7.498c0 .277-.24.502-.536.502-.297 0-.536-.225-.536-.502 0-3.58-3.108-6.493-6.928-6.493s-6.928 2.913-6.928 6.493c0 .277-.24.502-.536.502C.24 16 0 15.775 0 15.498z",
    clipRule: "evenodd"
  }));
};

var SvgUser24X24 = function SvgUser24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -user",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-1.018 0a3.482 3.482 0 1 0-6.964 0 3.482 3.482 0 0 0 6.964 0ZM12 13.018c-4.93 0-8.927 3.793-8.927 8.473 0 .28-.24.509-.537.509A.523.523 0 0 1 2 21.49C2 16.25 6.477 12 12 12c5.522 0 10 4.249 10 9.49 0 .282-.24.51-.537.51a.523.523 0 0 1-.536-.51c0-4.679-3.997-8.472-8.928-8.472Z",
    fill: "currentColor"
  }));
};

var SvgUser32X32 = function SvgUser32X32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -user",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 30,
    height: 32,
    viewBox: "0 0 30 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 7c0 3.865-3.147 7-7.005 7S8 10.865 8 7.01C8 3.145 11.127 0 14.995 0 18.863 0 22 3.145 22 7Zm-1.015.01c0-3.297-2.69-5.985-5.99-5.985-3.3 0-5.98 2.688-5.98 5.985s2.68 5.986 5.98 5.986c3.3 0 5.99-2.689 5.99-5.986ZM0 31.513C0 23.51 6.73 17 15 17s15 6.51 15 14.513c0 .273-.222.487-.504.487s-.503-.214-.503-.487c0-7.466-6.276-13.538-13.993-13.538-7.717 0-13.993 6.072-13.993 13.538A.49.49 0 0 1 .504 32 .49.49 0 0 1 0 31.513Z",
    clipRule: "evenodd"
  }));
};

var SvgUser40X40 = function SvgUser40X40(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -user",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 38,
    height: 40,
    viewBox: "0 0 38 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 8.995C10 13.966 14.042 18 19 18s9-4.023 9-8.995C28 4.034 23.968 0 19 0s-9 4.023-9 8.995Zm1.053.01c0-4.381 3.568-7.952 7.947-7.952s7.947 3.57 7.947 7.952S23.38 16.957 19 16.957s-7.947-3.57-7.947-7.952Zm25.916 30.498c0 .278.224.497.51.497.286 0 .51-.219.521-.497C38 29.302 29.475 21 19 21S0 29.302 0 39.503c0 .278.225.497.51.497s.511-.219.511-.497c0-9.654 8.055-17.509 17.969-17.509s17.979 7.855 17.979 17.509Z",
    clipRule: "evenodd"
  }));
};

var SvgUser56X56 = function SvgUser56X56(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -user",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 52,
    height: 56,
    viewBox: "0 0 52 56"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M37.83 11.85c0 6.54-5.314 11.85-11.835 11.85-6.521 0-11.834-5.31-11.834-11.85S19.464 0 25.995 0 37.83 5.31 37.83 11.85Zm-1 0C36.83 5.87 31.967 1 25.995 1S15.16 5.87 15.16 11.85c0 5.98 4.853 10.85 10.835 10.85 5.982 0 10.835-4.87 10.835-10.85ZM0 55.5c0-14.35 11.664-26.03 25.995-26.03C40.335 29.47 52 41.15 52 55.5c0 .28-.22.5-.5.5s-.499-.22-.499-.5c0-13.8-11.224-25.03-25.006-25.03C12.214 30.47.999 41.7.999 55.5c0 .28-.22.5-.5.5S0 55.78 0 55.5Z",
    clipRule: "evenodd"
  }));
};

var SvgUserTie104X104 = function SvgUserTie104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -user-tie",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 44.092c12.086 0 21.885-9.87 21.885-22.046S64.087 0 52 0C39.913 0 30.115 9.87 30.115 22.046c0 12.175 9.799 22.046 21.885 22.046ZM52 2c10.99 0 19.9 8.975 19.9 20.046 0 11.07-8.91 20.046-19.9 20.046-10.99 0-19.9-8.975-19.9-20.046S41.01 2 52 2ZM41.42 57.878C21.106 62.694 5.985 81.068 5.985 103c0 .552-.444 1-.992 1A.997.997 0 0 1 4 103c0-26.704 21.49-48.353 48-48.353S100 76.296 100 103c0 .552-.444 1-.993 1a.997.997 0 0 1-.992-1c0-21.933-15.123-40.308-35.436-45.122l-9.366 12.334 11.212 17.362c.256.396.201.918-.13 1.252l-11.593 11.678a.987.987 0 0 1-1.404 0L39.705 88.826a1.005 1.005 0 0 1-.13-1.252l11.21-17.362-9.365-12.334Zm19.005-.456L51.999 68.52l-8.426-11.096a45.945 45.945 0 0 1 8.428-.776c2.877 0 5.693.266 8.424.775Zm1.897 30.563L51.999 71.999 41.68 87.985 52 98.383l10.322-10.398Z"
  }));
};

var SvgUserTie16X16 = function SvgUserTie16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -user-tie",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.525 3.5A2.53 2.53 0 0 0 8 .974 2.53 2.53 0 0 0 5.473 3.5a2.53 2.53 0 0 0 2.526 2.526A2.53 2.53 0 0 0 10.525 3.5Zm.975 0C11.5 5.43 9.93 7 8 7S4.5 5.43 4.5 3.5 6.07 0 8 0s3.5 1.57 3.5 3.5ZM7.357 9.035 8 9.82l.642-.785A7.544 7.544 0 0 0 8 9.005c-.216 0-.43.012-.642.03Zm-.511 4.197L8 14.314l1.154-1.082L8 11.57l-1.154 1.663ZM0 15.498C0 11.364 3.59 8 8 8s8 3.364 8 7.498c0 .278-.24.502-.536.502-.297 0-.536-.224-.536-.502 0-2.988-2.168-5.505-5.105-6.258L8.655 10.67l1.636 2.354a.479.479 0 0 1-.071.63L8.38 15.38a.557.557 0 0 1-.38.147.557.557 0 0 1-.38-.147l-1.84-1.726a.479.479 0 0 1-.07-.629l1.635-2.354L6.177 9.24c-2.937.753-5.105 3.27-5.105 6.258 0 .278-.24.502-.536.502C.24 16 0 15.776 0 15.498Z",
    fill: "currentColor"
  }));
};

var SvgUserTie24X24 = function SvgUserTie24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -user-tie",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7.982a3.482 3.482 0 1 1 0 6.964 3.482 3.482 0 0 1 0-6.964ZM9.619 13.323c-3.775.989-6.546 4.271-6.546 8.168 0 .281-.24.509-.537.509A.523.523 0 0 1 2 21.49C2 16.25 6.477 12 12 12c5.522 0 10 4.25 10 9.49 0 .282-.24.51-.537.51a.523.523 0 0 1-.536-.51c0-3.896-2.772-7.178-6.546-8.167l-1.796 2.263 1.84 3.25a.598.598 0 0 1-.062.672l-2.033 2.335a.426.426 0 0 1-.66 0l-2.033-2.335a.598.598 0 0 1-.061-.673l1.838-3.248-1.795-2.264Zm3.625-.223L12 14.668 10.756 13.1a9.471 9.471 0 0 1 2.488 0ZM12 20.704l1.435-1.648-1.435-2.535-1.435 2.535 1.435 1.648Z",
    fill: "currentColor"
  }));
};

var SvgVehicle104X104 = function SvgVehicle104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -vehicle",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.956 0A7.044 7.044 0 0 1 104 7.044V35.04c-.702 30.332-20.998 57.38-51.66 68.896a1.002 1.002 0 0 1-.703 0C20.982 92.415.696 65.368 0 35.017V7.044A7.044 7.044 0 0 1 7.045 0h89.911ZM102 35.017V7.044A5.044 5.044 0 0 0 96.956 2H7.045A5.044 5.044 0 0 0 2 7.044v27.95c.673 29.374 20.276 55.622 49.99 66.937C81.707 90.621 101.32 64.372 102 35.017ZM31.45 46.506a8.053 8.053 0 0 0-7.473 5.048h-5.631a135.865 135.865 0 0 1 .208-5.938c.058-1.002.127-1.923.207-2.742a42.96 42.96 0 0 1 4.978-13.79 3.591 3.591 0 0 1 2.402-1.385h29.907l10.124 9.144a1 1 0 0 0 .532.249 544.49 544.49 0 0 0 2.34.323 954.442 954.442 0 0 0 6.155.822c3.642.473 6.319.79 7.653.892 1.378.108 2.144.551 2.53 1.201.23.386.3.8.284 1.098l-.034.358a354.05 354.05 0 0 1-.37 3.685c-.039.37-.077.72-.114 1.049a81.16 81.16 0 0 1-.212 1.743c-.273 2.015-1.28 3.291-2.545 3.291H78.87a8.054 8.054 0 0 0-14.946 0h-25a8.053 8.053 0 0 0-7.473-5.048Zm31.957 7.048H39.439a8.051 8.051 0 1 1-15.978 0h-6.127a1 1 0 0 1-1-1.005c0-.111.003-.319.006-.608.006-.482.015-1.018.028-1.596.038-1.65.099-3.301.189-4.845a67.49 67.49 0 0 1 .224-2.896 44.991 44.991 0 0 1 5.252-14.567l.064-.098a5.591 5.591 0 0 1 3.874-2.234l.111-.006h30.351a1 1 0 0 1 .67.258l10.181 9.196.334.046a981.953 981.953 0 0 0 7.838 1.055c3.605.468 6.263.782 7.55.881 2.005.157 3.365.942 4.096 2.174a3.938 3.938 0 0 1 .556 2.299l-.002.018-.033.35-.088.918a311.211 311.211 0 0 1-.4 3.85c-.079.705-.152 1.307-.217 1.787-.392 2.894-2.073 5.023-4.527 5.023h-3.005a8.052 8.052 0 1 1-15.98 0Zm-38.008 1.003a6.05 6.05 0 1 1 12.102 0 6.051 6.051 0 1 1-12.102 0Zm45.998-6.051a6.051 6.051 0 1 0-.001 12.103 6.051 6.051 0 0 0 0-12.103Z",
    fill: "currentColor"
  }));
};

var SvgVehicle16X16 = function SvgVehicle16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -vehicle",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.998 14.965C12.163 13.328 14.904 9.628 15 5.49V1.389a.39.39 0 0 0-.389-.39H1.389A.39.39 0 0 0 1 1.39v4.114c.095 4.125 2.835 7.824 6.998 9.462ZM1.389 0h13.222A1.39 1.39 0 0 1 16 1.389v4.114c-.107 4.617-3.179 8.72-7.826 10.466a.506.506 0 0 1-.352 0C3.176 14.222.106 10.118 0 5.514V1.389a1.39 1.39 0 0 1 1.389-1.39Zm11.077 7.529a.812.812 0 0 0 .028-.126c.032-.236.072-.65.093-.859l.008-.079c-.009.002-.023 0-.042-.002a1.323 1.323 0 0 0-.043-.004c-.522-.04-2.32-.29-2.396-.302a.5.5 0 0 1-.266-.124L8.46 4.78H4.189c.003.001-.003.006-.014.015a.319.319 0 0 0-.052.052 5.948 5.948 0 0 0-.664 1.883c-.026.261-.04.586-.048.852h.258c.27-.443.753-.742 1.309-.742.556 0 1.039.3 1.309.742h3.257a1.53 1.53 0 0 1 1.309-.742 1.53 1.53 0 0 1 1.308.742h.3c-.01-.002-.005-.02.005-.052Zm-2.15.847a.538.538 0 1 0 1.075-.001.538.538 0 0 0-1.075.001Zm-5.875 0a.538.538 0 1 0 1.075-.001.538.538 0 0 0-1.075.001Zm5.963-3.188c.45.062 1.776.242 2.183.274.429.033.669.221.795.372.24.29.219.616.213.68 0 0-.064.685-.11 1.023-.084.624-.492 1.044-1.015 1.044h-.101a1.535 1.535 0 0 1-1.516 1.332 1.534 1.534 0 0 1-1.516-1.332H6.494a1.535 1.535 0 0 1-1.516 1.332 1.535 1.535 0 0 1-1.516-1.332h-.56a.499.499 0 0 1-.5-.502c0-.035.005-.863.067-1.485A6.942 6.942 0 0 1 3.287 4.3c.226-.31.522-.48.846-.518l4.519-.003a.5.5 0 0 1 .335.13l1.417 1.28Z",
    fill: "currentColor"
  }));
};

var SvgVehicle24X24 = function SvgVehicle24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -vehicle",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M13.804 12.603H9.981a1.813 1.813 0 0 1-3.618 0h-.82a.5.5 0 0 1-.5-.502 25.79 25.79 0 0 1 .042-1.33c.011-.195.025-.376.046-.575A8.72 8.72 0 0 1 6.178 7.33c.225-.303.565-.499.994-.543h5.653a.5.5 0 0 1 .336.129l1.824 1.649a191.583 191.583 0 0 0 1.262.17l.162.02c.666.087 1.158.145 1.392.163.47.037.817.237 1.007.557.123.207.158.414.148.595l-.002.026c-.018.19-.045.475-.076.76l-.02.183c-.015.14-.03.26-.042.358-.094.677-.512 1.206-1.155 1.206h-.24a1.813 1.813 0 0 1-3.617 0zm.22-1a1.813 1.813 0 0 1 3.179 0h.458c.049 0 .131-.104.164-.34.011-.087.025-.2.04-.335l.019-.178c.03-.28.057-.56.075-.753l-.001.017s-.003-.018-.01-.028c-.017-.03-.067-.059-.224-.071-.257-.02-.758-.079-1.443-.167l-.163-.022a175.198 175.198 0 0 1-1.423-.192.5.5 0 0 1-.266-.124l-1.796-1.623-5.406-.003a.39.39 0 0 0-.213.092 7.704 7.704 0 0 0-.893 2.455c-.015.148-.027.316-.038.5a24.09 24.09 0 0 0-.032.772h.531a1.812 1.812 0 0 1 3.18 0h4.261zM20.373 2C21.272 2 22 2.728 22 3.626v5.222c-.134 5.782-3.998 10.931-9.826 13.12a.5.5 0 0 1-.352 0C5.995 19.778 2.132 14.628 2 8.836v-5.21C2 2.728 2.728 2 3.626 2h16.748zM21 8.836v-5.21A.626.626 0 0 0 20.374 3H3.626A.626.626 0 0 0 3 3.626v5.199c.122 5.304 3.642 10.054 8.998 12.14 5.357-2.086 8.88-6.835 9.002-12.129zM8.172 11.663a.813.813 0 1 0-.001 1.625.813.813 0 0 0 0-1.625zm7.44 0a.813.813 0 1 0 .001 1.626.813.813 0 0 0 0-1.626z"
  }));
};

var SvgViewer104X104 = function SvgViewer104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -viewer",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M103.661 57.995c.105.177.176.302.213.37.269.487.095 1.1-.388 1.371s-1.092.095-1.36-.391a36.808 36.808 0 0 0-.767-1.275 58.171 58.171 0 0 0-2.35-3.435 70.625 70.625 0 0 0-9.428-10.454c-10.454-9.484-22.976-15.165-37.58-15.165-14.606 0-27.128 5.68-37.582 15.165a70.624 70.624 0 0 0-9.428 10.454 58.468 58.468 0 0 0-2.35 3.435 36.68 36.68 0 0 0-.767 1.275.996.996 0 0 1-1.36.391 1.012 1.012 0 0 1-.388-1.37c.038-.069.109-.194.213-.371.171-.292.376-.628.614-1.006a60.476 60.476 0 0 1 2.431-3.554 72.628 72.628 0 0 1 9.697-10.753C23.878 32.887 36.855 27 52.001 27c15.144 0 28.122 5.887 38.918 15.682a72.614 72.614 0 0 1 9.697 10.753 60.389 60.389 0 0 1 2.432 3.554c.238.378.442.714.613 1.006zM52.001 31c12.702 0 23 10.298 23 23.001 0 12.702-10.298 23-23 23S29 66.702 29 54c0-12.703 10.296-23 23-23zm0 1.991c-11.604 0-21.01 9.407-21.01 21.01 0 11.603 9.406 21.008 21.01 21.008 11.602 0 21.008-9.405 21.008-21.008S63.603 32.991 52 32.991z",
    clipRule: "evenodd"
  }));
};

var SvgViewer16X16 = function SvgViewer16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -viewer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.433 8c.248.334.416.598.504.757a.5.5 0 0 1-.874.486 6.558 6.558 0 0 0-.433-.649 9.982 9.982 0 0 0-1.34-1.472c-.854-.77-1.803-1.358-2.849-1.719a3.75 3.75 0 1 1-4.883 0c-1.045.36-1.994.95-2.848 1.719-.52.468-.968.97-1.34 1.472-.22.298-.365.526-.433.649a.5.5 0 1 1-.874-.486C.151 8.598.319 8.334.567 8c.41-.553.9-1.105 1.474-1.62C3.689 4.894 5.678 4 8 4c2.322 0 4.31.895 5.959 2.378A10.974 10.974 0 0 1 15.433 8zM8 5.5A2.75 2.75 0 1 0 8 11a2.75 2.75 0 0 0 0-5.5z",
    clipRule: "evenodd"
  }));
};

var SvgViewer24X24 = function SvgViewer24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -viewer"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M14.103 7.212c1.985.843 3.38 2.845 3.38 5.18 0 3.098-2.455 5.609-5.483 5.609-3.028 0-5.483-2.511-5.483-5.608 0-2.336 1.395-4.338 3.38-5.181-2.336.427-4.397 1.56-6.188 3.209a15.801 15.801 0 0 0-2.089 2.35c-.202.279-.375.538-.518.769a6.26 6.26 0 0 0-.165.277.494.494 0 0 1-.68.199.518.518 0 0 1-.194-.696c.035-.063.1-.175.195-.329.156-.25.342-.53.559-.83a16.81 16.81 0 0 1 2.223-2.5C5.522 7.375 8.51 6 12 6c3.49 0 6.478 1.375 8.96 3.66a16.81 16.81 0 0 1 2.223 2.5c.217.3.403.58.56.83.095.154.16.266.194.33a.518.518 0 0 1-.194.695.494.494 0 0 1-.68-.199 6.26 6.26 0 0 0-.165-.277c-.143-.231-.316-.49-.518-.77-.58-.8-1.277-1.602-2.09-2.35-1.79-1.647-3.851-2.781-6.187-3.208zM12 7.807c-2.476 0-4.483 2.053-4.483 4.586 0 2.532 2.007 4.585 4.483 4.585 2.476 0 4.483-2.053 4.483-4.585 0-2.533-2.007-4.586-4.483-4.586z"
  }));
};

var SvgViewerOff104X104 = function SvgViewerOff104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -viewer-off",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M90.285 12.294 71.893 30.687C65.74 28.297 59.109 27 52 27c-15.145 0-28.122 5.887-38.919 15.682a72.628 72.628 0 0 0-9.697 10.753A60.476 60.476 0 0 0 .953 56.99a38.673 38.673 0 0 0-.827 1.376c-.268.487-.094 1.1.389 1.371a.996.996 0 0 0 1.36-.391 36.68 36.68 0 0 1 .767-1.275 58.468 58.468 0 0 1 2.35-3.435 70.624 70.624 0 0 1 9.427-10.454C24.873 34.697 37.395 29.016 52 29.016c6.525 0 12.634 1.134 18.33 3.234l-3.867 3.866A22.903 22.903 0 0 0 52 31c-12.703 0-23 10.298-23 23.001 0 5.48 1.917 10.512 5.116 14.463L12.294 90.285a1.005 1.005 0 0 0 1.42 1.42L35.45 69.972A22.933 22.933 0 0 0 52 77.001c12.703 0 23-10.298 23-23 0-6.499-2.695-12.369-7.029-16.552l4.399-4.398c6.254 2.605 11.99 6.393 17.211 11.13a70.625 70.625 0 0 1 9.428 10.454 58.171 58.171 0 0 1 2.35 3.435 36.808 36.808 0 0 1 .767 1.275.996.996 0 0 0 1.36.391c.483-.27.657-.884.388-1.37a37.943 37.943 0 0 0-.826-1.376 60.389 60.389 0 0 0-2.432-3.555 72.614 72.614 0 0 0-9.697-10.753c-5.17-4.691-10.842-8.486-17.013-11.167l17.8-17.8a1.005 1.005 0 0 0-1.42-1.42zM65.047 37.533A20.919 20.919 0 0 0 52 32.992c-11.603 0-21.008 9.406-21.008 21.01 0 4.929 1.697 9.462 4.54 13.045l29.515-29.514zm-28.19 31.03 29.706-29.705A20.95 20.95 0 0 1 73.009 54c0 11.603-9.406 21.008-21.009 21.008-5.949 0-11.32-2.473-15.142-6.446z",
    clipRule: "evenodd"
  }));
};

var SvgViewerOff16X16 = function SvgViewerOff16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -viewer-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.832 4.485 2.343-2.343a.483.483 0 0 1 .684.683L11.792 4.89c.778.387 1.5.89 2.168 1.49a10.963 10.963 0 0 1 1.473 1.618c.248.334.416.598.504.757a.499.499 0 1 1-.874.485 6.548 6.548 0 0 0-.433-.648 9.973 9.973 0 0 0-1.34-1.47 8.56 8.56 0 0 0-2.25-1.48l-.182.182c.556.653.892 1.5.892 2.424A3.747 3.747 0 0 1 8 11.994c-.924 0-1.77-.334-2.424-.887l-2.751 2.752a.483.483 0 0 1-.683-.684l2.782-2.783A3.724 3.724 0 0 1 4.25 8.25c0-1.137.508-2.155 1.309-2.842-1.046.36-1.995.948-2.85 1.716-.52.467-.967.97-1.338 1.47-.221.298-.366.526-.434.648a.5.5 0 0 1-.874-.485c.088-.159.256-.423.504-.757.41-.552.9-1.103 1.474-1.618C3.689 4.899 5.678 4.006 8 4.006a8.45 8.45 0 0 1 2.831.479zM9.42 5.897A2.748 2.748 0 0 0 5.647 9.67L9.42 5.897zm-3.134 4.5a2.748 2.748 0 0 0 3.862-3.862l-3.862 3.862z",
    clipRule: "evenodd"
  }));
};

var SvgViewerOff24X24 = function SvgViewerOff24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -viewer-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M15.602 7.576a11.27 11.27 0 0 0-1.498-.383 5.44 5.44 0 0 1 1.19.7l.308-.317zm1.029.395-.595.611a5.692 5.692 0 0 1 1.447 3.812c0 3.109-2.455 5.629-5.483 5.629a5.386 5.386 0 0 1-3.712-1.486L3.6 21.35a.49.49 0 0 1-.707 0 .523.523 0 0 1 0-.726l4.723-4.85a5.703 5.703 0 0 1-1.099-3.38c0-2.345 1.395-4.354 3.38-5.2-2.336.428-4.397 1.566-6.188 3.22a15.842 15.842 0 0 0-2.089 2.359c-.202.28-.375.54-.518.772a6.29 6.29 0 0 0-.165.278.493.493 0 0 1-.68.2.52.52 0 0 1-.194-.698c.035-.064.1-.176.195-.33.156-.253.342-.533.559-.833A16.853 16.853 0 0 1 3.04 9.65C5.522 7.358 8.51 5.978 12 5.978c1.564 0 3.027.277 4.39.79L20.4 2.65a.49.49 0 0 1 .706 0c.196.2.196.526 0 .726l-3.718 3.818c1.289.615 2.48 1.448 3.572 2.457.864.799 1.605 1.655 2.223 2.51.217.301.403.581.56.834.095.154.16.266.194.33a.52.52 0 0 1-.194.698.493.493 0 0 1-.68-.2 6.29 6.29 0 0 0-.165-.278 13.158 13.158 0 0 0-.518-.772 15.842 15.842 0 0 0-2.09-2.359c-1.114-1.03-2.334-1.86-3.659-2.443zm-2.053.656A4.384 4.384 0 0 0 12 7.791c-2.476 0-4.483 2.06-4.483 4.603 0 .985.301 1.897.815 2.646l6.246-6.413zm.75.682L8.996 15.81A4.402 4.402 0 0 0 12 16.996c2.476 0 4.483-2.06 4.483-4.602a4.655 4.655 0 0 0-1.155-3.085z"
  }));
};

var SvgWallet104X104 = function SvgWallet104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -wallet",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M90.4 14.245C90.4 10.243 87.142 7 83.123 7H7.8C3.492 7 0 10.477 0 14.765V90.927C0 94.28 2.731 97 6.1 97h85.001c3.368 0 6.1-2.72 6.1-6.073V73.635h2.4c2.429 0 4.399-1.962 4.399-4.381V48.285c0-2.42-1.97-4.38-4.4-4.38h-2.4v-16.12c0-3.842-3.003-6.985-6.8-7.23v-6.31zm5.8 57.399h3.401c1.324 0 2.399-1.07 2.399-2.39V48.285c0-1.32-1.074-2.39-2.4-2.39H64.936c-1.326 0-2.4 1.07-2.4 2.39v20.969c0 1.32 1.074 2.39 2.4 2.39H96.2zm-31.265-27.74H95.2v-16.12c0-2.9-2.363-5.253-5.277-5.253H7.8A7.796 7.796 0 0 1 2 19.958v70.969c0 2.254 1.836 4.082 4.1 4.082h85.001c2.263 0 4.1-1.828 4.1-4.082V73.635H64.934c-2.43 0-4.4-1.962-4.4-4.381V48.285c0-2.42 1.97-4.38 4.4-4.38zM2 14.835c.037 3.158 2.62 5.706 5.8 5.706h80.6v-6.295c0-2.902-2.362-5.254-5.277-5.254H7.8c-3.194 0-5.786 2.571-5.8 5.748v.095zm74.624 38.318c3.117 0 5.643 2.515 5.643 5.617 0 3.104-2.526 5.619-5.643 5.619-3.116 0-5.643-2.515-5.643-5.619 0-3.102 2.527-5.617 5.643-5.617z",
    clipRule: "evenodd"
  }));
};

var SvgWallet16X16 = function SvgWallet16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -wallet",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 3.064v-.641C14 1.637 13.363 1 12.577 1H1.5A1.5 1.5 0 0 0 0 2.5v11.25C0 14.44.56 15 1.25 15H13.75c.69 0 1.25-.56 1.25-1.25v-2.2a1 1 0 0 0 1-1V7.45a1 1 0 0 0-1-1V4.423c0-.639-.42-1.18-1-1.36zm.5 7.485a.45.45 0 0 1 .02 0H15V7.451H9.902v3.098h4.578a.45.45 0 0 1 .02 0zm-.5 3.2v-2.2H9.902a1 1 0 0 1-1-1V7.451a1 1 0 0 1 1-1H14V4.423A.423.423 0 0 0 13.577 4H1.5c-.175 0-.343-.03-.5-.085v9.835c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25zM1 2.49A.5.5 0 0 1 1.5 2h11.077c.234 0 .423.19.423.423V3H1.5a.5.5 0 0 1-.5-.486V2.49zM11.621 8.17a.83.83 0 1 1 0 1.661.83.83 0 0 1 0-1.661z",
    clipRule: "evenodd"
  }));
};

var SvgWallet24X24 = function SvgWallet24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -wallet",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M19.733 16.37H14.41a1.134 1.134 0 0 1-1.133-1.135v-3.932c0-.627.507-1.135 1.133-1.135h5.325V7.46c0-.37-.3-.67-.67-.67H3.767c-.275 0-.535-.063-.767-.175v12.682c0 .25.201.45.45.45h11.365l.02.001h4.448a.45.45 0 0 0 .45-.452V16.37zm1 0v2.926c0 .803-.648 1.454-1.45 1.454H3.45A1.45 1.45 0 0 1 2 19.297V5.038a1.812 1.812 0 0 1 0-.019c0-.977.79-1.769 1.767-1.769h14.03a1.67 1.67 0 0 1 1.67 1.672v.915c.727.18 1.267.838 1.267 1.623v2.708h.133c.626 0 1.133.508 1.133 1.135v3.932c0 .626-.508 1.135-1.133 1.135h-.134zM3 5.032a.767.767 0 0 0 .767.756h14.7v-.866c0-.37-.3-.67-.67-.67H3.768a.767.767 0 0 0-.767.76.512.512 0 0 1 0 .008v.012zm11.41 6.138a.133.133 0 0 0-.134.133v3.932c0 .073.06.133.133.133h6.458c.073 0 .133-.06.133-.133v-3.932a.133.133 0 0 0-.133-.133H14.41zm3.228 2.099a1.052 1.052 0 1 1-2.104.002 1.052 1.052 0 0 1 2.104-.002z"
  }));
};

var SvgWeb104X104 = function SvgWeb104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -web",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M104 52a51.692 51.692 0 0 1-4.312 20.703.96.96 0 0 1-.083.185C91.544 91.187 73.245 104 52 104c-21.246 0-39.545-12.813-47.606-31.112a.96.96 0 0 1-.083-.185A51.69 51.69 0 0 1 0 52a51.684 51.684 0 0 1 4.311-20.703.933.933 0 0 1 .083-.185C12.455 12.812 30.754 0 52 0c21.245 0 39.544 12.812 47.605 31.112.034.06.062.118.083.185A51.684 51.684 0 0 1 104 52zM51 2.048C40.922 2.766 32.274 14.247 28.172 30.6H51V2.048zm-8.293.831C35.341 7.575 29.35 17.683 26.154 30.6H6.821C13.574 16.401 26.825 5.878 42.707 2.879zM25.686 32.6H5.918A49.724 49.724 0 0 0 2 52a49.724 49.724 0 0 0 3.918 19.4h19.768c-1.322-5.999-2.057-12.544-2.057-19.4 0-6.857.735-13.401 2.057-19.4zM6.821 73.4h19.333c3.196 12.916 9.187 23.026 16.553 27.721C26.825 98.122 13.574 87.599 6.821 73.4zm54.471 27.721c7.366-4.695 13.357-14.805 16.553-27.721h19.333c-6.753 14.199-20.004 24.722-35.886 27.721zM77.845 30.6h19.333C90.425 16.401 77.174 5.878 61.292 2.879 68.658 7.575 74.649 17.683 77.845 30.6zM53 71.4V32.6h23.303c1.33 5.968 2.067 12.524 2.067 19.4 0 6.876-.737 13.432-2.067 19.4H53zm22.827 2H53v28.552c10.077-.718 18.725-12.199 22.827-28.552zM51 73.4v28.552c-10.078-.718-18.726-12.199-22.828-28.552H51zm0-40.8v38.8H27.696c-1.33-5.968-2.067-12.524-2.067-19.4 0-6.876.737-13.432 2.067-19.4H51zm24.827-2C71.725 14.247 63.077 2.766 53 2.048V30.6h22.827zm22.254 40.8H78.313c1.322-5.999 2.057-12.544 2.057-19.4 0-6.857-.735-13.401-2.057-19.4h19.768A49.725 49.725 0 0 1 102 52a49.725 49.725 0 0 1-3.919 19.4z",
    clipRule: "evenodd"
  }));
};

var SvgWeb16X16 = function SvgWeb16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -web",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 8a7.946 7.946 0 0 1-.684 3.226C14.072 14.033 11.263 16 8 16S1.928 14.033.685 11.226l-.007-.013A7.946 7.946 0 0 1 0 8a7.946 7.946 0 0 1 .685-3.226C1.928 1.967 4.737 0 8 0c3.263 0 6.072 1.967 7.316 4.774A7.946 7.946 0 0 1 16 8zM7.5 4.5V1.082C6.433 1.399 5.506 2.704 4.968 4.5H7.5zm-3.578 0c.318-1.184.794-2.196 1.385-2.96a7.053 7.053 0 0 0-3.36 2.96h1.975zm-1.975 7h1.975c.318 1.184.794 2.196 1.385 2.96a7.053 7.053 0 0 1-3.36-2.96zm8.746 2.96c.591-.764 1.067-1.776 1.386-2.96h1.974a7.048 7.048 0 0 1-3.36 2.96zm3.36-9.96h-1.974c-.319-1.184-.795-2.196-1.386-2.96a7.048 7.048 0 0 1 3.36 2.96zm.477 1h-2.225c.142.784.22 1.622.22 2.5 0 .878-.078 1.716-.22 2.5h2.225c.299-.777.47-1.618.47-2.5 0-.882-.171-1.723-.47-2.5zm-3.251 5H8.5v-5h2.779c.157.781.246 1.624.246 2.5 0 .876-.089 1.719-.246 2.5zm-2.779 1v3.418c1.067-.317 1.994-1.622 2.532-3.418H8.5zm-1 0v3.418c-1.067-.317-1.994-1.622-2.532-3.418H7.5zm1-10.418c1.067.317 1.994 1.622 2.532 3.418H8.5V1.082zM4.721 5.5a12.807 12.807 0 0 0 0 5H7.5v-5H4.721zM1 8c0-.882.171-1.723.47-2.5h2.225c-.142.784-.22 1.622-.22 2.5 0 .878.078 1.716.22 2.5H1.47A6.943 6.943 0 0 1 1 8z",
    clipRule: "evenodd"
  }));
};

var SvgWeb24X24 = function SvgWeb24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -web",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0 1.411-.297 2.75-.825 3.968-.009.024-.02.043-.031.065l-.001.001C19.589 19.542 16.079 22 12 22c-4.079 0-7.589-2.458-9.143-5.966v-.001c-.012-.022-.023-.042-.032-.065a9.946 9.946 0 0 1 .031-8l.001-.001C4.411 4.458 7.921 2 12 2c4.079 0 7.589 2.458 9.143 5.967v.001a.49.49 0 0 1 .032.065A9.937 9.937 0 0 1 22 12ZM11.5 7.701V3.059c-1.497.335-2.803 2.142-3.518 4.642H11.5Zm-4.566 0c.451-1.73 1.167-3.173 2.064-4.175a9.04 9.04 0 0 0-4.902 4.175h2.838ZM4.096 16.3h2.838c.451 1.73 1.167 3.173 2.064 4.175A9.04 9.04 0 0 1 4.096 16.3Zm10.906 4.175c.897-1.002 1.613-2.445 2.064-4.175h2.838a9.04 9.04 0 0 1-4.902 4.175Zm4.902-12.774h-2.838c-.451-1.73-1.167-3.173-2.064-4.175a9.04 9.04 0 0 1 4.902 4.175Zm.461 1h-3.074c.196 1.03.307 2.136.307 3.299 0 1.163-.111 2.27-.307 3.3h3.074A8.941 8.941 0 0 0 21 12c0-1.166-.23-2.276-.635-3.299ZM12.5 15.3V8.701h3.762c.214 1.028.336 2.141.336 3.299 0 1.159-.122 2.272-.336 3.3H12.5Zm0 1v4.642c1.497-.335 2.803-2.142 3.518-4.642H12.5Zm-1 0v4.642c-1.497-.335-2.803-2.142-3.518-4.642H11.5Zm1-13.241c1.497.335 2.803 2.142 3.518 4.642H12.5V3.059ZM7.738 8.701A16.246 16.246 0 0 0 7.402 12c0 1.159.122 2.272.336 3.3H11.5V8.701H7.738ZM3 12c0-1.166.23-2.276.635-3.299h3.074A17.664 17.664 0 0 0 6.402 12c0 1.163.111 2.27.307 3.3H3.635A8.941 8.941 0 0 1 3 12Z",
    fill: "currentColor"
  }));
};

var SvgWebChannel104X104 = function SvgWebChannel104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -web-channel",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 23.742h100V7.045A5.05 5.05 0 0 0 96.955 2H7.045A5.05 5.05 0 0 0 2 7.045v16.697zM96.955 81.6A5.05 5.05 0 0 0 102 76.556V25.742H2v50.814A5.05 5.05 0 0 0 7.045 81.6h44.207L41.246 52.324a1 1 0 0 1 1.27-1.27L88.275 66.66a1 1 0 0 1 .384 1.654l-8.6 8.6 4.685 4.686h12.211zm-29.142 6.145 13.841 13.841 10.124-10.123-8.153-8.154-.002-.002-.002-.002-5.683-5.684a.999.999 0 0 1 0-1.414l8.171-8.172-42.312-14.431L58.229 95.83l8.174-8.089a.997.997 0 0 1 1.41.004zM7.045 0h89.91A7.052 7.052 0 0 1 104 7.045v69.511c0 3.884-3.16 7.044-7.045 7.044H86.744l7.155 7.156a.997.997 0 0 1 0 1.414l-11.538 11.537a.993.993 0 0 1-.707.293.995.995 0 0 1-.707-.293L67.103 89.863l-8.601 8.511a1 1 0 0 1-1.649-.387L51.936 83.6H7.045C3.16 83.6 0 80.44 0 76.556V7.045A7.052 7.052 0 0 1 7.045 0zM9.5 12.871a3.374 3.374 0 1 1 6.749.001 3.374 3.374 0 0 1-6.749 0zm16.088-3.374a3.375 3.375 0 1 0 0 6.75 3.375 3.375 0 0 0 0-6.75zm9.34 3.374a3.374 3.374 0 1 1 6.748 0 3.374 3.374 0 0 1-6.747 0z",
    clipRule: "evenodd"
  }));
};

var SvgWebChannel16X16 = function SvgWebChannel16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -web-channel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 3.491h14V1.388A.39.39 0 0 0 14.611 1H1.389A.39.39 0 0 0 1 1.388v2.103zM14.611 12a.39.39 0 0 0 .389-.389v-7.12H1v7.12a.39.39 0 0 0 .389.389h6.007L6.085 8.161a.497.497 0 0 1 .634-.634l6.729 2.295a.497.497 0 0 1 .193.826l-1.016 1.016.336.336h1.65zm-4.036 1.007 1.786 1.786.99-.99-1.787-1.786a.5.5 0 0 1 0-.707l.802-.801L7.36 8.802l1.707 4.997.803-.794a.498.498 0 0 1 .705.002zM1.389 0h13.222A1.39 1.39 0 0 1 16 1.388v10.223A1.39 1.39 0 0 1 14.611 13h-.65l.45.449a.502.502 0 0 1 0 .708l-1.696 1.696a.5.5 0 0 1-.707 0l-1.788-1.788-1.016 1.006a.5.5 0 0 1-.824-.194L7.738 13H1.389A1.39 1.39 0 0 1 0 11.611V1.388A1.39 1.39 0 0 1 1.389 0zm.361 2.245a.496.496 0 1 1 .992 0 .496.496 0 0 1-.992 0zm2.366-.496a.496.496 0 1 0 0 .992.496.496 0 0 0 0-.992zm1.373.496a.497.497 0 1 1 .994.001.497.497 0 0 1-.994 0z",
    clipRule: "evenodd"
  }));
};

var SvgWebChannel24X24 = function SvgWebChannel24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -web-channel",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.422h18V3.626A.626.626 0 0 0 20.374 3H3.626A.626.626 0 0 0 3 3.626v2.796ZM20.374 17.2a.627.627 0 0 0 .626-.626V7.422H3v9.152c0 .345.281.626.626.626h7.796L9.7 12.161a.5.5 0 0 1 .634-.635l8.524 2.908a.5.5 0 0 1 .193.826l-1.381 1.38.559.56h2.145Zm-5.207 1.236 2.356 2.357 1.443-1.443-1.296-1.296-.002-.001-1.059-1.059a.504.504 0 0 1 0-.707l1.166-1.166-6.799-2.32 2.319 6.788 1.167-1.155a.5.5 0 0 1 .705.002ZM3.626 2h16.748C21.271 2 22 2.729 22 3.626v12.948c0 .896-.729 1.626-1.626 1.626h-1.145l.797.797a.499.499 0 0 1 0 .707l-2.149 2.149a.5.5 0 0 1-.707 0l-2.358-2.358-1.38 1.366a.5.5 0 0 1-.825-.194l-.843-2.467H3.626C2.729 18.2 2 17.47 2 16.574V3.626C2 2.729 2.729 2 3.626 2Zm.457 2.71a.628.628 0 1 1 1.256 0 .628.628 0 0 1-1.256 0Zm2.997-.627a.629.629 0 1 0 0 1.257.629.629 0 0 0 0-1.257Zm1.74.628a.628.628 0 1 1 1.256 0 .628.628 0 0 1-1.256 0Z",
    fill: "currentColor"
  }));
};

var SvgWhatsapp104X104 = function SvgWhatsapp104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -whatsapp",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.585 77.88c-.298-.04-.695-.1-1.083-.16l-1.62-.249A53.382 53.382 0 0 1 40.477 66.24c-1.054-.918-2.018-1.866-3.041-2.873l-.577-.569c-4.84-4.738-8.645-9.955-11-15.073A18.75 18.75 0 0 1 24 39.904a15.04 15.04 0 0 1 3.18-9.328l.199-.26c.348-.448.706-.907 1.272-1.436.765-.708 1.203-1.047 1.68-1.277a5.757 5.757 0 0 1 1.768-.529l.358-.03c.696-.05 1.431-.06 2.256-.02.328.02.616.06.934.09.467.05.954.22 1.371.47.457.269.785.618.964.997 1.67 3.73 3.3 7.491 4.83 11.183.358.877.169 2.015-.527 3.112a24.985 24.985 0 0 1-1.48 2.055c-.309.389-.805.958-1.233 1.436l-.805.918c-.04.07-.099.16-.149.28-.129.309-.159.608-.08.897.06.23.24.589.547 1.068l.328.518c1.471 2.414 3.37 4.729 5.645 6.913l.507.49c.487.468.983.947 1.5 1.406a33.237 33.237 0 0 0 8.686 5.447l.467.199c.238.11.497.22.904.39l.05.019c.357.15.705.27 1.033.35a1.755 1.755 0 0 0 1.829-.63 253.218 253.218 0 0 1 3.726-4.379c.199-.229.338-.379.438-.488l.288-.27c.298-.27.646-.479 1.033-.608.408-.13.805-.17 1.213-.13.407.03.745.11 1.043.23a564.78 564.78 0 0 0 5.008 2.204l6.013 2.634c.328.16.606.389.815.668.218.29.357.639.367.948.02.359.06.957-.07 2.075-.188 1.486-.635 3.192-1.063 4.08a6.52 6.52 0 0 1-1.172 1.676l-.03.03a13.615 13.615 0 0 1-1.858 1.606c-.229.17-.457.329-.686.488-.725.45-1.441.858-2.166 1.227a11.409 11.409 0 0 1-4.71 1.277l-.438.03c-.745.04-1.411.07-2.087.07l-1.113-.12Zm.706-1.905c.745.03 1.52-.01 2.335-.05l.497-.03a9.464 9.464 0 0 0 3.905-1.057c.686-.35 1.362-.728 1.998-1.127.179-.12.387-.27.596-.42a11.38 11.38 0 0 0 1.61-1.376c.348-.36.636-.758.844-1.197.289-.599.706-2.055.875-3.442.1-.828.08-1.287.07-1.606l-.04-.04-5.963-2.603A458.217 458.217 0 0 1 67 60.812c-.04-.02-.15-.05-.378-.07-.189-.02-.328 0-.447.04-.11.04-.228.1-.318.19l-.238.22c-.04.039-.17.189-.358.398-.716.808-1.948 2.265-3.667 4.31a3.696 3.696 0 0 1-1.71 1.217c-.695.239-1.44.279-2.156.1-.397-.1-.805-.24-1.222-.41l-.1-.04c-.447-.19-.715-.309-.973-.418l-.428-.18a35.34 35.34 0 0 1-9.242-5.786 37.37 37.37 0 0 1-1.58-1.476l-.556-.539c-2.385-2.284-4.373-4.728-5.903-7.252l-.318-.499c-.288-.459-.646-1.067-.785-1.636-.239-.898-.03-1.686.179-2.185 0-.01.01-.02.01-.03l.844-1.207.467-.518c.408-.45.865-.978 1.153-1.337.487-.609.944-1.247 1.362-1.886.427-.678.427-1.137.367-1.276a475.79 475.79 0 0 0-4.8-11.123c.01.01-.05-.05-.168-.12a1.424 1.424 0 0 0-.577-.2c-.288-.03-.566-.06-.825-.08-.715-.03-1.38-.02-1.987.02l-.308.02c-.348.05-.736.16-1.103.34-.239.12-.527.319-1.213.957-.447.42-.735.789-1.063 1.207l-.199.26a13.08 13.08 0 0 0-2.752 8.07 16.91 16.91 0 0 0 1.66 6.983c2.265 4.928 5.922 9.936 10.593 14.515l.566.558c1.004.988 1.948 1.916 2.961 2.793a51.183 51.183 0 0 0 20.6 10.814l1.422.21c.388.06.775.12 1.073.16l.408.049ZM78.01 65.55s0 .01 0 0c0 .01 0 0 0 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 104c-8.789 0-20.67-4.18-27.994-8.06L3.011 99.9l5.005-19.78C4.018 73.07 0 61.65 0 52 0 23.33 23.325 0 52 0s52 23.33 52 52-23.325 52-52 52ZM24.332 93.84l.64.34C32.308 98.07 43.945 102 52.01 102c27.546 0 49.966-22.43 49.966-50S79.556 2 52.01 2 2.034 24.43 2.034 52c0 9.29 3.886 20.33 7.741 27.14l.387.69-4.425 17.51 18.595-3.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  }))));
};

var SvgWhatsapp16X16 = function SvgWhatsapp16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -whatsapp",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16c-1.354 0-3.186-.64-4.305-1.24l-3.237.61.774-3.04C.62 11.24 0 9.48 0 8c0-4.41 3.593-8 8-8s8 3.59 8 8-3.583 8-8 8Zm-4.142-2.29.315.17C5.221 14.44 6.88 15 8 15c3.857 0 6.982-3.14 6.982-7S11.847 1 8 1C4.153 1 1.018 4.14 1.018 8c0 1.31.55 2.87 1.099 3.84l.193.34-.478 1.91 2.026-.38Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.188 4.519H4.867c-.042 0-.083.02-.114.03-.01 0-.042.02-.146.112a.749.749 0 0 0-.145.163c-.01.01-.02.031-.03.041-.26.336-.395.744-.395 1.151.01.347.093.693.249 1.009v.01c.332.713.902 1.498 1.66 2.221l.093.092c.166.153.31.295.466.428a8.051 8.051 0 0 0 3.215 1.66c.01 0 .031 0 .052.01l.176.031c.063.01.125.02.177.03.02 0 .041.01.052.01.103 0 .217 0 .352-.01h.073c.186-.01.373-.06.539-.142a4.31 4.31 0 0 0 .3-.163.571.571 0 0 0 .084-.061s.01 0 .01-.01a2.06 2.06 0 0 0 .228-.194.387.387 0 0 0 .094-.132 2.42 2.42 0 0 0 .124-.469c0-.03.01-.061.01-.082l-.383-.162h-.01c-.011 0-.011-.01-.021-.01-.021-.01-.052-.021-.094-.042-.083-.03-.197-.081-.321-.132-.25-.102-.55-.234-.778-.336l-.052.05c-.093.103-.26.296-.58.673a.848.848 0 0 1-.86.285 1.642 1.642 0 0 1-.24-.081c-.073-.03-.124-.051-.166-.071-.02-.01-.041-.02-.062-.02h-.01a5.97 5.97 0 0 1-1.546-.948c-.093-.082-.186-.173-.27-.245l-.072-.071a5.592 5.592 0 0 1-.996-1.202L5.48 7.86c-.032-.05-.114-.183-.156-.315a.725.725 0 0 1 .042-.49.772.772 0 0 1 .103-.173l.042-.081s.052-.051.083-.092c.072-.071.135-.153.176-.204.073-.091.145-.183.207-.275.01-.02.021-.03.021-.04-.228-.55-.477-1.09-.715-1.63a.128.128 0 0 0-.094-.041ZM6.381 7.35l.01.02c.208.326.488.673.83.999l.093.091c.083.072.145.133.218.194.373.326.809.58 1.265.784h.01c.032.01.052.02.084.031.03.01.072.03.124.051.28-.326.436-.5.529-.611.052-.051.083-.092.114-.123l.052-.05c.01-.01.02-.02.041-.031a.838.838 0 0 1 .301-.153c.125-.04.26-.05.384-.04.093.01.207.02.321.07.239.103.55.235.799.347.124.051.238.102.321.133.042.02.073.03.094.04.01 0 .02.01.02.01h.01l-.207.47.208-.47.518.225s.01 0 .01.01c.125.06.229.153.312.244a.807.807 0 0 1 .155.418c0 .082.01.204-.01.408-.031.254-.114.58-.218.794a1.727 1.727 0 0 1-.28.397 2.593 2.593 0 0 1-.363.306l-.124.092c-.01 0-.01.01-.02.01-.125.071-.25.143-.385.214a2.42 2.42 0 0 1-.964.255h-.062a3.76 3.76 0 0 1-.488.01h-.062c-.01 0-.041-.01-.062-.01a6.009 6.009 0 0 0-.177-.031c-.062-.01-.124-.02-.176-.03-.02 0-.041-.01-.062-.01h-.02l.082-.5-.083.5c-.02 0-.03-.01-.052-.01a9.067 9.067 0 0 1-4.18-2.364l-.082-.082c-.84-.805-1.483-1.68-1.877-2.527A3.343 3.343 0 0 1 3 6.027v-.01c0-.642.218-1.264.622-1.773.01-.01.021-.02.021-.03a2.61 2.61 0 0 1 .26-.286c.124-.112.238-.204.383-.285.166-.082.342-.123.529-.143H5.25c.063 0 .115.01.156.01.145.02.29.061.415.143.124.071.27.193.352.377.27.59.53 1.182.789 1.783.145.346.03.692-.125.937-.083.122-.176.244-.27.367-.04.071-.124.163-.186.234Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
};

var SvgWhatsapp24X24 = function SvgWhatsapp24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -whatsapp",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22c-1.69 0-3.98-.8-5.38-1.55l-4.04.76.96-3.8C2.77 16.05 2 13.86 2 12 2 6.49 6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm-5.22-2.6.31.16C8.43 20.28 10.55 21 12 21c4.96 0 9-4.04 9-9s-4.04-9-9-9-9 4.04-9 9c0 1.67.71 3.67 1.41 4.91l.2.35-.68 2.68 2.85-.54Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.727 17.5h-.16l-.678-.102a11.043 11.043 0 0 1-4.478-2.324c-.21-.182-.409-.375-.608-.578l-.12-.122c-.997-.975-1.785-2.05-2.274-3.116A4.141 4.141 0 0 1 6 9.522c-.01-.771.25-1.532.728-2.141.12-.153.21-.264.34-.386.159-.142.289-.254.438-.325a1.75 1.75 0 0 1 .599-.162c.17-.01.329-.01.498 0l.21.02c.28.03.668.193.828.558.329.731.648 1.472.957 2.213.13.315.08.7-.14 1.055-.1.153-.209.305-.319.447-.08.101-.22.254-.309.355l.06.102c.27.436.628.873 1.047 1.279l.11.111c.09.082.18.173.27.244a5.953 5.953 0 0 0 1.595.995l.28.121c.04.02.089.03.139.051.469-.609.698-.903.838-1.035v-.01a1.061 1.061 0 0 1 .787-.254c.08.01.21.02.35.081.578.264 1.536.67 1.536.67l.648.284c.299.142.498.437.508.741 0 .071.01.213-.02.477-.04.295-.13.7-.259.954-.08.173-.19.325-.329.457a2.93 2.93 0 0 1-.429.366l-.15.101c-.169.102-.319.193-.478.274-.34.173-.728.284-1.117.305-.19.02-.35.03-.489.03Zm-.638-1.106c.01 0 .508.07.568.08.13.011.28 0 .43-.01l.099-.01c.25-.01.498-.08.718-.192.14-.071.26-.142.389-.224l.1-.07c.11-.082.21-.163.299-.254a.86.86 0 0 0 .14-.193c.05-.102.13-.376.16-.63.01-.08.01-.142.01-.192l-.55-.244s-.957-.406-1.545-.67l-.2.183s-.359.365-.708.781a.956.956 0 0 1-.389.285c-.17.06-.349.06-.509.02-.09-.02-.19-.05-.279-.091l-.24-.102a7.225 7.225 0 0 1-2.213-1.462l-.11-.101a7.36 7.36 0 0 1-1.207-1.472l-.06-.091a2.06 2.06 0 0 1-.18-.366.877.877 0 0 1 .17-.75c.02-.021.26-.285.38-.427.09-.112.179-.233.259-.355a.364.364 0 0 0 .05-.132c-.3-.71-.619-1.441-.948-2.162l-.18.01h-.388c-.09 0-.16.02-.23.061-.04.02-.1.071-.21.162-.089.082-.139.153-.199.224a2.495 2.495 0 0 0-.548 1.542c.01.447.11.894.309 1.31.439.954 1.157 1.928 2.064 2.822l.13.121c.19.183.37.366.569.528a10.426 10.426 0 0 0 4.049 2.07Zm2.902-1.807v.02-.02Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))));
};

var SvgWhatsapp64X64 = function SvgWhatsapp64X64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -whatsapp",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 64c-5.411 0-12.725-2.57-17.23-4.96L1.85 61.48l3.072-12.17C2.472 44.97 0 37.94 0 32 0 14.35 14.352 0 32 0s32 14.35 32 32-14.362 32-32 32Zm-17.068-6.01.315.17C19.652 60.49 26.762 63 32 63c17.078 0 30.983-13.91 30.983-31S49.088 1 32 1 1.017 14.91 1.017 32c0 5.76 2.41 12.6 4.791 16.81l.193.34-2.787 11.04 11.718-2.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.765 47.695c-4.944-1.252-9.587-3.616-13.431-6.857-.666-.561-1.302-1.172-1.918-1.763l-.353-.345c-3.037-2.896-5.429-6.078-6.902-9.201A11.134 11.134 0 0 1 15 24.79a8.942 8.942 0 0 1 1.977-5.635l.121-.158c.212-.266.434-.552.787-.867.465-.424.737-.62 1.03-.768a3.772 3.772 0 0 1 1.08-.316l.221-.02c.434-.029.888-.039 1.403-.01.202.01.383.03.575.06.283.03.565.128.818.276.262.148.454.354.555.561 1.05 2.276 2.068 4.581 3.037 6.847.212.502.091 1.152-.323 1.803-.282.433-.595.847-.918 1.25-.192.237-.505.582-.777.878l-.434.463-.07.078c-.051.089-.091.148-.122.227a.982.982 0 0 0-.06.63c.04.158.161.385.353.69l.202.315c.928 1.488 2.129 2.916 3.572 4.256l.323.296c.303.285.626.58.949.867a21.467 21.467 0 0 0 5.5 3.359l.898.374c.212.089.434.158.666.217.232.059.484.05.716-.03a1.27 1.27 0 0 0 .565-.394 170.249 170.249 0 0 1 2.341-2.68l.455-.453c.171-.157.383-.275.615-.354.242-.079.474-.099.717-.079.242.02.444.06.615.128.939.414 2.16.936 3.149 1.35l3.784 1.605c.182.09.343.217.464.375.121.157.202.345.202.512.01.207.04.572-.05 1.251-.111.897-.394 1.931-.656 2.463-.182.374-.434.71-.737 1.015-.353.354-.737.68-1.16.965l-.424.296c-.455.276-.899.522-1.353.739a7.273 7.273 0 0 1-2.916.768l-.283.02c-.403.02-.777.039-1.15.039l-2.493-.305Zm2.09-.68c.484.03.978 0 1.503-.03l.303-.02a6.285 6.285 0 0 0 2.502-.66c.444-.216.858-.453 1.272-.699.12-.079.252-.167.383-.266a7.931 7.931 0 0 0 1.03-.857c.232-.226.413-.483.555-.758.212-.434.464-1.38.565-2.148.07-.591.05-.887.04-1.064-.04-.03-.07-.05-.08-.06l-3.765-1.605c-.999-.423-2.23-.945-3.158-1.35a.834.834 0 0 0-.273-.049.893.893 0 0 0-.333.03.733.733 0 0 0-.242.138l-.383.384c-.374.404-1.05 1.182-2.311 2.64a2.205 2.205 0 0 1-1.02.71 2.395 2.395 0 0 1-1.291.059 6.411 6.411 0 0 1-.808-.266l-.888-.375a22.46 22.46 0 0 1-5.792-3.527c-.343-.285-.676-.6-.99-.896l-.312-.296c-1.514-1.398-2.765-2.896-3.734-4.452l-.202-.306c-.181-.276-.393-.63-.484-.965a1.926 1.926 0 0 1 .101-1.261c.01-.03.03-.069.04-.099l.333-.482.424-.463c.253-.276.545-.601.737-.828.313-.374.595-.768.858-1.162.272-.424.302-.749.242-.887a282.03 282.03 0 0 0-3.028-6.817c-.01-.01-.05-.059-.151-.118a1.027 1.027 0 0 0-.414-.138c-.181-.02-.353-.04-.524-.05-.465-.019-.878-.01-1.272.01l-.192.01a2.61 2.61 0 0 0-.736.217c-.162.079-.354.207-.787.601a5.738 5.738 0 0 0-.687.759l-.12.157a7.889 7.889 0 0 0-1.757 5.015c.03 1.507.384 2.955 1.06 4.324 1.433 3.034 3.744 6.108 6.7 8.925l.354.345c.625.601 1.22 1.172 1.867 1.714 3.723 3.143 8.224 5.438 13.018 6.65l1.846.266Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  }))));
};

var SvgWheelchair104X104 = function SvgWheelchair104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -wheelchair",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M68.334 94.5c0 4.136 3.371 7.5 7.516 7.5s7.516-3.364 7.516-7.5S79.995 87 75.85 87s-7.516 3.364-7.516 7.5zM33.26 102c14.478 0 26.255-11.753 26.255-26.2S47.737 49.6 33.26 49.6c-14.478 0-26.256 11.753-26.256 26.2S18.782 102 33.26 102zm52.075-6.8h12.663a1 1 0 1 1 0 2H84.973c-1.17 3.927-4.814 6.8-9.123 6.8-5.25 0-9.52-4.262-9.52-9.5S70.6 85 75.85 85a9.48 9.48 0 0 1 5.812 1.992V59.744c0-2.781-2.268-5.044-5.054-5.044H51.98c5.846 5.17 9.539 12.711 9.539 21.1 0 15.55-12.677 28.2-28.26 28.2C17.677 104 5 91.35 5 75.8c0-15.123 11.992-27.5 26.985-28.168L21.51 5.82A5.046 5.046 0 0 0 16.606 2H6.002a1 1 0 1 1 0-2h10.604a7.046 7.046 0 0 1 6.848 5.336l7.339 29.294h38.919a1 1 0 1 1 0 2H31.294l2.753 10.989A28.128 28.128 0 0 1 49.44 52.7h27.168c3.892 0 7.059 3.16 7.059 7.044v29.348A9.428 9.428 0 0 1 85.37 94.5c0 .205-.014.409-.029.61l-.006.09zM18.37 75.8c0 8.193 6.68 14.86 14.89 14.86S48.15 83.992 48.15 75.8c0-8.194-6.68-14.86-14.89-14.86S18.37 67.606 18.37 75.8zm-2.004 0c0-9.296 7.58-16.86 16.895-16.86s16.895 7.564 16.895 16.86-7.58 16.86-16.895 16.86-16.895-7.564-16.895-16.86z",
    clipRule: "evenodd"
  }));
};

var SvgWheelchair16X16 = function SvgWheelchair16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    className: "icon -wheelchair"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.75 14.25c0 .413.337.75.75.75s.75-.337.75-.75a.752.752 0 0 0-.75-.75.752.752 0 0 0-.75.75Zm-9-2.75c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5S7.18 8 5.25 8s-3.5 1.57-3.5 3.5ZM13.225 14h1.525a.5.5 0 0 1 0 1h-1.676c-.282.589-.879 1-1.574 1-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75c.175 0 .341.033.5.082V9.139a.39.39 0 0 0-.389-.389H8.786c.595.763.964 1.71.964 2.75 0 2.481-2.019 4.5-4.5 4.5a4.505 4.505 0 0 1-4.5-4.5c0-2.268 1.691-4.129 3.875-4.437L3.183 1.294A.388.388 0 0 0 2.806 1H1.25a.5.5 0 0 1 0-1h1.556c.638 0 1.193.433 1.347 1.052l1.011 4.041H10.6a.5.5 0 1 1 0 1H5.414l.236.948a4.468 4.468 0 0 1 2.079.709h3.882A1.39 1.39 0 0 1 13 9.139v4.224c.114.193.191.407.225.637Zm-9.807-2.5c0 1.01.822 1.832 1.832 1.832 1.01 0 1.832-.822 1.832-1.832 0-1.01-.822-1.832-1.832-1.832-1.01 0-1.832.822-1.832 1.832Zm-1 0A2.835 2.835 0 0 1 5.25 8.668 2.835 2.835 0 0 1 8.082 11.5a2.835 2.835 0 0 1-2.832 2.832A2.835 2.835 0 0 1 2.418 11.5Z",
    clipRule: "evenodd"
  }));
};

var SvgWheelchair24X24 = function SvgWheelchair24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -wheelchair",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M8.323 8.45h6.951c.275 0 .497.224.497.5s-.222.5-.497.5H8.572l.355 1.43c.997.07 1.921.405 2.703.936h4.92a1.62 1.62 0 0 1 1.616 1.626v5.37c.17.271.278.585.307.921h2.03c.275 0 .497.224.497.5s-.222.5-.497.5h-2.187A2.072 2.072 0 0 1 16.409 22a2.078 2.078 0 0 1-2.072-2.083c0-1.151.928-2.084 2.072-2.084.27 0 .527.052.762.145v-4.536a.623.623 0 0 0-.621-.626h-3.806a5.564 5.564 0 0 1 1.327 3.617c0 3.075-2.478 5.567-5.535 5.567s-5.535-2.492-5.535-5.567c0-2.86 2.145-5.218 4.907-5.531L6.06 3.474A.623.623 0 0 0 5.458 3h-1.96A.499.499 0 0 1 3 2.5c0-.276.223-.5.497-.5h1.96c.742 0 1.39.508 1.569 1.232L8.323 8.45zm8.92 10.782a1.072 1.072 0 0 0-.834-.399 1.08 1.08 0 0 0-1.078 1.084A1.08 1.08 0 0 0 16.41 21a1.08 1.08 0 0 0 1.078-1.083c0-.226-.07-.437-.187-.61a.502.502 0 0 1-.056-.075zm-8.707-7.366c-2.508 0-4.54 2.045-4.54 4.567 0 2.522 2.032 4.567 4.54 4.567s4.54-2.045 4.54-4.567c0-2.522-2.032-4.567-4.54-4.567zm0 1.113a3.444 3.444 0 0 1 3.435 3.455c0 1.907-1.538 3.453-3.435 3.453s-3.435-1.546-3.435-3.454a3.444 3.444 0 0 1 3.435-3.454zm0 1a2.447 2.447 0 0 0-2.44 2.455c0 1.355 1.092 2.453 2.44 2.453s2.44-1.098 2.44-2.454a2.447 2.447 0 0 0-2.44-2.454z"
  }));
};

var SvgWifi104X104 = function SvgWifi104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -wifi",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 104 104",
    width: 104,
    height: 104
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M103.707 46.302C75.151 17.9 28.85 17.9.293 46.302a.99.99 0 0 0 0 1.407c.39.388 1.024.388 1.414 0 27.777-27.626 72.81-27.626 100.586 0 .39.388 1.024.388 1.414 0a.99.99 0 0 0 0-1.407zm-15 14.977c-20.273-20.372-53.14-20.372-73.413 0a1.012 1.012 0 0 0 0 1.425 1 1 0 0 0 1.418 0c19.49-19.585 51.087-19.585 70.576 0a1 1 0 0 0 1.418 0 1.012 1.012 0 0 0 0-1.425zm-58.411 15.95c11.987-12.306 31.422-12.306 43.408 0a1.057 1.057 0 0 1 0 1.467.992.992 0 0 1-1.428 0c-11.198-11.496-29.353-11.496-40.551 0a.992.992 0 0 1-1.43 0 1.057 1.057 0 0 1 0-1.467z",
    clipRule: "evenodd"
  }));
};

var SvgWifi16X16 = function SvgWifi16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -wifi",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.854 7.044c-4.338-4.059-11.37-4.059-15.708 0a.447.447 0 0 0 0 .661.525.525 0 0 0 .708 0c3.946-3.693 10.346-3.693 14.292 0a.525.525 0 0 0 .707 0 .447.447 0 0 0 0-.661zM13.63 9.123c-3.11-2.91-8.153-2.91-11.263 0a.447.447 0 0 0 0 .661.525.525 0 0 0 .707 0c2.72-2.544 7.13-2.544 9.85 0a.525.525 0 0 0 .706 0 .447.447 0 0 0 0-.661zm-9.04 2.079c1.882-1.761 4.936-1.761 6.818 0a.447.447 0 0 1 0 .661.525.525 0 0 1-.707 0c-1.492-1.395-3.912-1.395-5.404 0-.195.183-.512.183-.707 0s-.195-.479 0-.661z",
    clipRule: "evenodd"
  }));
};

var SvgWifi24X24 = function SvgWifi24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    className: "icon -wifi"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M23.854 10.685a.462.462 0 0 1 0 .674.517.517 0 0 1-.708 0C16.991 5.486 7.01 5.486.854 11.36a.517.517 0 0 1-.708 0 .462.462 0 0 1 0-.674c6.548-6.247 17.161-6.247 23.708 0zm-3.408 3.25a.462.462 0 0 1 0 .675.517.517 0 0 1-.707 0c-4.274-4.078-11.204-4.078-15.479 0a.517.517 0 0 1-.707 0 .462.462 0 0 1 0-.675c4.666-4.45 12.228-4.45 16.893 0zm-3.407 3.25a.462.462 0 0 1 0 .675.517.517 0 0 1-.708 0c-2.391-2.282-6.27-2.282-8.662 0a.517.517 0 0 1-.707 0 .462.462 0 0 1 0-.674c2.782-2.656 7.294-2.656 10.077 0z"
  }));
};

var SvgWifiError104X104 = function SvgWifiError104X104(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -wifi-error",
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.293 47.015a.989.989 0 0 1 0-1.405C13.808 32.185 31.298 25.113 49 24.395v1.989c-17.19.716-34.168 7.594-47.293 20.631a1.005 1.005 0 0 1-1.414 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.707 47.015a1.004 1.004 0 0 1-1.414 0C89.168 33.977 72.19 27.1 55 26.384v-1.989c17.702.718 35.192 7.79 48.707 21.215a.988.988 0 0 1 0 1.405Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.294 61.992a1.01 1.01 0 0 1 0-1.424C24.667 51.161 36.732 46.103 49 45.395v2.016a49.634 49.634 0 0 0-32.288 14.581 1 1 0 0 1-1.418 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.706 61.992a1 1 0 0 1-1.418 0A49.634 49.634 0 0 0 55 47.412v-2.017c12.268.708 24.333 5.766 33.706 15.173a1.01 1.01 0 0 1 0 1.424Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.296 77.964a1.054 1.054 0 0 1 0-1.465c5.23-5.362 11.877-8.385 18.704-9.068v2.082c-6.309.676-12.44 3.493-17.276 8.45a.993.993 0 0 1-1.428 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.704 77.964a.993.993 0 0 1-1.428 0c-4.835-4.957-10.966-7.774-17.274-8.451l-.004-2.082c6.829.683 13.476 3.705 18.706 9.068.395.404.395 1.06 0 1.465Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 73.738V16.932c0-.882-.448-1.597-1-1.597s-1 .715-1 1.597v56.806c0 .882.448 1.597 1 1.597s1-.715 1-1.597Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 86.668a2 2 0 1 0 4 .001 2 2 0 0 0-4-.001Z",
    fill: "currentColor"
  }));
};

var SvgWifiError16X16 = function SvgWifiError16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -wifi-error",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.146 7.815a.447.447 0 0 1 0-.661c1.808-1.691 4.083-2.678 6.437-2.96v.944c-2.096.277-4.117 1.169-5.73 2.677a.525.525 0 0 1-.707 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.854 7.815a.525.525 0 0 1-.708 0c-1.612-1.508-3.633-2.4-5.729-2.677v-.944c2.354.282 4.63 1.269 6.437 2.96a.447.447 0 0 1 0 .661Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37 9.894a.447.447 0 0 1 0-.661 8.124 8.124 0 0 1 4.224-2.066v.953a7.09 7.09 0 0 0-3.518 1.774.525.525 0 0 1-.707 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.632 9.894a.525.525 0 0 1-.707 0A7.09 7.09 0 0 0 9.407 8.12v-.953a8.124 8.124 0 0 1 4.225 2.066.447.447 0 0 1 0 .661Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.592 11.973a.447.447 0 0 1 0-.662A4.873 4.873 0 0 1 6.6 10.184v.99a3.84 3.84 0 0 0-1.301.799.525.525 0 0 1-.707 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.41 11.973a.525.525 0 0 1-.707 0 3.84 3.84 0 0 0-1.302-.8v-.989a4.874 4.874 0 0 1 2.009 1.127.447.447 0 0 1 0 .662Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.683 2.3a.382.382 0 0 1 .32-.19c.16 0 .267.102.321.19.057.09.083.198.083.306v8.739a.58.58 0 0 1-.083.306.382.382 0 0 1-.32.19.382.382 0 0 1-.321-.19.58.58 0 0 1-.083-.306v-8.74a.58.58 0 0 1 .083-.306Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45 13.334a.558.558 0 1 1 1.114 0 .558.558 0 0 1-1.115 0Z",
    fill: "currentColor"
  }));
};

var SvgWifiError24X24 = function SvgWifiError24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    className: "icon -wifi-error",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.146 10.65a.462.462 0 0 1 0-.675c2.892-2.759 6.577-4.3 10.354-4.621v.958c-3.52.32-6.95 1.765-9.646 4.337a.517.517 0 0 1-.708 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.854 10.65a.517.517 0 0 1-.708 0c-2.696-2.573-6.126-4.02-9.648-4.338v-.958c3.778.321 7.464 1.862 10.356 4.62a.462.462 0 0 1 0 .675Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.553 13.9a.462.462 0 0 1 0-.675c1.95-1.86 4.407-2.944 6.947-3.248v.962a11.104 11.104 0 0 0-6.24 2.96.517.517 0 0 1-.707 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.446 13.9a.517.517 0 0 1-.707 0 11.104 11.104 0 0 0-6.24-2.961v-.962c2.54.304 4.996 1.387 6.947 3.248a.461.461 0 0 1 0 .675Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.961 17.15a.462.462 0 0 1 0-.674 7.198 7.198 0 0 1 3.538-1.84v.98a6.176 6.176 0 0 0-2.83 1.534.517.517 0 0 1-.708 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.038 17.15a.517.517 0 0 1-.707 0 6.175 6.175 0 0 0-2.832-1.535v-.98a7.198 7.198 0 0 1 3.54 1.84.462.462 0 0 1-.001.675Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.625 3.515A.448.448 0 0 1 12 3.29c.181 0 .307.116.375.225.07.113.106.252.106.393v13.11c0 .14-.035.28-.106.393a.448.448 0 0 1-.375.225.448.448 0 0 1-.375-.225.747.747 0 0 1-.105-.393V3.908c0-.14.035-.28.105-.393Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.29 20.002a.711.711 0 1 1 1.422 0 .711.711 0 0 1-1.423 0Z",
    fill: "currentColor"
  }));
};

export { SvgActions16X16 as Actions16X16, SvgActions24X24 as Actions24X24, SvgAgency104X104 as Agency104X104, SvgAgency16X16 as Agency16X16, SvgAgency24X24 as Agency24X24, SvgAgriculture104X104 as Agriculture104X104, SvgAgriculture16X16 as Agriculture16X16, SvgAgriculture24X24 as Agriculture24X24, SvgAlert104X104 as Alert104X104, SvgAlert16X16 as Alert16X16, SvgAlert24X24 as Alert24X24, SvgApps104X104 as Apps104X104, SvgApps16X16 as Apps16X16, SvgApps24X24 as Apps24X24, SvgArrowDownRight104X104 as ArrowDownRight104X104, SvgArrowDownRight16X16 as ArrowDownRight16X16, SvgArrowDownRight24X24 as ArrowDownRight24X24, SvgArrowDownUp104X104 as ArrowDownUp104X104, SvgArrowDownUp16X16 as ArrowDownUp16X16, SvgArrowDownUp24X24 as ArrowDownUp24X24, SvgArrowLeft104X104 as ArrowLeft104X104, SvgArrowLeft16X16 as ArrowLeft16X16, SvgArrowLeft24X24 as ArrowLeft24X24, SvgArrowLeftRight104X104 as ArrowLeftRight104X104, SvgArrowLeftRight16X16 as ArrowLeftRight16X16, SvgArrowLeftRight24X24 as ArrowLeftRight24X24, SvgArrowRight104X104 as ArrowRight104X104, SvgArrowRight16X16 as ArrowRight16X16, SvgArrowRight24X24 as ArrowRight24X24, SvgArrowUpLeft104X104 as ArrowUpLeft104X104, SvgArrowUpLeft16X16 as ArrowUpLeft16X16, SvgArrowUpLeft24X24 as ArrowUpLeft24X24, SvgAssembly104X104 as Assembly104X104, SvgAssembly16X16 as Assembly16X16, SvgAssembly24X24 as Assembly24X24, SvgAt104X104 as At104X104, SvgAt16X16 as At16X16, SvgAt24X24 as At24X24, SvgAtm104X104 as Atm104X104, SvgAtm16X16 as Atm16X16, SvgAtm24X24 as Atm24X24, SvgBadge104X104 as Badge104X104, SvgBadge16X16 as Badge16X16, SvgBadge24X24 as Badge24X24, SvgBarChart104X104 as BarChart104X104, SvgBarChart16X16 as BarChart16X16, SvgBarChart24X24 as BarChart24X24, SvgBarCode104X104 as BarCode104X104, SvgBarCode16X16 as BarCode16X16, SvgBarCode24X24 as BarCode24X24, SvgBarCode64X64 as BarCode64X64, SvgBasket104X104 as Basket104X104, SvgBasket16X16 as Basket16X16, SvgBasket24X24 as Basket24X24, SvgBasket64X64 as Basket64X64, SvgBinoculars104X104 as Binoculars104X104, SvgBinoculars16X16 as Binoculars16X16, SvgBinoculars24X24 as Binoculars24X24, SvgBiometry104X104 as Biometry104X104, SvgBiometry16X16 as Biometry16X16, SvgBiometry24X24 as Biometry24X24, SvgBook104X104 as Book104X104, SvgBook16X16 as Book16X16, SvgBook24X24 as Book24X24, SvgBuilding104X104 as Building104X104, SvgBuilding16X16 as Building16X16, SvgBuilding24X24 as Building24X24, SvgBusiness104X104 as Business104X104, SvgBusiness16X16 as Business16X16, SvgBusiness24X24 as Business24X24, SvgCake104X104 as Cake104X104, SvgCake16X16 as Cake16X16, SvgCake24X24 as Cake24X24, SvgCalculator104X104 as Calculator104X104, SvgCalculator16X16 as Calculator16X16, SvgCalculator24X24 as Calculator24X24, SvgCalendar104X104 as Calendar104X104, SvgCalendar16X16 as Calendar16X16, SvgCalendar24X24 as Calendar24X24, SvgCalendarCash104X104 as CalendarCash104X104, SvgCalendarCash16X16 as CalendarCash16X16, SvgCalendarCash24X24 as CalendarCash24X24, SvgCalendarChecked104X104 as CalendarChecked104X104, SvgCalendarChecked16X16 as CalendarChecked16X16, SvgCalendarChecked24X24 as CalendarChecked24X24, SvgCameraDefault104X104 as CameraDefault104X104, SvgCameraDefault16X16 as CameraDefault16X16, SvgCameraDefault24X24 as CameraDefault24X24, SvgCameraUpdate104X104 as CameraUpdate104X104, SvgCameraUpdate16X16 as CameraUpdate16X16, SvgCameraUpdate24X24 as CameraUpdate24X24, SvgCar104X104 as Car104X104, SvgCar16X16 as Car16X16, SvgCar24X24 as Car24X24, SvgCard104X104 as Card104X104, SvgCard16X16 as Card16X16, SvgCard24X24 as Card24X24, SvgCardAdd104X104 as CardAdd104X104, SvgCardAdd16X16 as CardAdd16X16, SvgCardAdd24X24 as CardAdd24X24, SvgCardMachine104X104 as CardMachine104X104, SvgCardMachine16X16 as CardMachine16X16, SvgCardMachine24X24 as CardMachine24X24, SvgCards104X104 as Cards104X104, SvgCards16X16 as Cards16X16, SvgCards24X24 as Cards24X24, SvgCart104X104 as Cart104X104, SvgCart16X16 as Cart16X16, SvgCart24X24 as Cart24X24, SvgCash104X104 as Cash104X104, SvgCash16X16 as Cash16X16, SvgCash24X24 as Cash24X24, SvgCashCoins104X104 as CashCoins104X104, SvgCashCoins16X16 as CashCoins16X16, SvgCashCoins24X24 as CashCoins24X24, SvgCashHome104X104 as CashHome104X104, SvgCashHome16X16 as CashHome16X16, SvgCashHome24X24 as CashHome24X24, SvgCashHome64X64 as CashHome64X64, SvgCashOut104X104 as CashOut104X104, SvgCashOut16X16 as CashOut16X16, SvgCashOut24X24 as CashOut24X24, SvgCheck104X104 as Check104X104, SvgCheck16X16 as Check16X16, SvgCheck24X24 as Check24X24, SvgCheck64X64 as Check64X64, SvgCheckbook104X104 as Checkbook104X104, SvgCheckbook16X16 as Checkbook16X16, SvgCheckbook24X24 as Checkbook24X24, SvgCheckbookHand104X104 as CheckbookHand104X104, SvgCheckbookHand24X24 as CheckbookHand24X24, SvgCheckbooks104X104 as Checkbooks104X104, SvgCheckbooks16X16 as Checkbooks16X16, SvgCheckbooks24X24 as Checkbooks24X24, SvgCheckbox24X24 as Checkbox24X24, SvgCheckboxFilled24X24 as CheckboxFilled24X24, SvgChecked104X104 as Checked104X104, SvgChecked16X16 as Checked16X16, SvgChecked24X24 as Checked24X24, SvgChevronDown104X104 as ChevronDown104X104, SvgChevronDown16X16 as ChevronDown16X16, SvgChevronDown24X24 as ChevronDown24X24, SvgChevronDown8X8 as ChevronDown8X8, SvgChevronLeft104X104 as ChevronLeft104X104, SvgChevronLeft16X16 as ChevronLeft16X16, SvgChevronLeft24X24 as ChevronLeft24X24, SvgChevronLeft8X8 as ChevronLeft8X8, SvgChevronLeftRight24X24 as ChevronLeftRight24X24, SvgChevronRight104X104 as ChevronRight104X104, SvgChevronRight16X16 as ChevronRight16X16, SvgChevronRight24X24 as ChevronRight24X24, SvgChevronRight8X8 as ChevronRight8X8, SvgChevronUp104X104 as ChevronUp104X104, SvgChevronUp16X16 as ChevronUp16X16, SvgChevronUp24X24 as ChevronUp24X24, SvgChevronUp8X8 as ChevronUp8X8, SvgCircle24X24 as Circle24X24, SvgCircleFilled24X24 as CircleFilled24X24, SvgClipboard104X104 as Clipboard104X104, SvgClipboard16X16 as Clipboard16X16, SvgClipboard24X24 as Clipboard24X24, SvgClips104X104 as Clips104X104, SvgClips16X16 as Clips16X16, SvgClips24X24 as Clips24X24, SvgClips64X64 as Clips64X64, SvgClock104X104 as Clock104X104, SvgClock16X16 as Clock16X16, SvgClock24X24 as Clock24X24, SvgClose104X104 as Close104X104, SvgClose16X16 as Close16X16, SvgClose24X24 as Close24X24, SvgClose8X8 as Close8X8, SvgCloud104X104 as Cloud104X104, SvgCloud16X16 as Cloud16X16, SvgCloud24X24 as Cloud24X24, SvgCollaboration104X104 as Collaboration104X104, SvgCollaboration16X16 as Collaboration16X16, SvgCollaboration24X24 as Collaboration24X24, SvgCompass104X104 as Compass104X104, SvgCompass16X16 as Compass16X16, SvgCompass24X24 as Compass24X24, SvgContrastDay104X104 as ContrastDay104X104, SvgContrastDay16X16 as ContrastDay16X16, SvgContrastDay24X24 as ContrastDay24X24, SvgContrastDay64X64 as ContrastDay64X64, SvgContrastNight104X104 as ContrastNight104X104, SvgContrastNight16X16 as ContrastNight16X16, SvgContrastNight24X24 as ContrastNight24X24, SvgContrastNight64X64 as ContrastNight64X64, SvgCoop104X104 as Coop104X104, SvgCoop16X16 as Coop16X16, SvgCoop24X24 as Coop24X24, SvgCopy104X104 as Copy104X104, SvgCopy16X16 as Copy16X16, SvgCopy24X24 as Copy24X24, SvgCup104X104 as Cup104X104, SvgCup16X16 as Cup16X16, SvgCup24X24 as Cup24X24, SvgCurrency104X104 as Currency104X104, SvgCurrency16X16 as Currency16X16, SvgCurrency24X24 as Currency24X24, SvgCutlery104X104 as Cutlery104X104, SvgCutlery16X16 as Cutlery16X16, SvgCutlery24X24 as Cutlery24X24, SvgCutlery64X64 as Cutlery64X64, SvgDataSafety104X104 as DataSafety104X104, SvgDataSafety16X16 as DataSafety16X16, SvgDataSafety24X24 as DataSafety24X24, SvgDateChecked104X104 as DateChecked104X104, SvgDateChecked16X16 as DateChecked16X16, SvgDateChecked24X24 as DateChecked24X24, SvgDialogChat104X104 as DialogChat104X104, SvgDialogChat16X16 as DialogChat16X16, SvgDialogChat24X24 as DialogChat24X24, SvgDialogInfo104X104 as DialogInfo104X104, SvgDialogInfo16X16 as DialogInfo16X16, SvgDialogInfo24X24 as DialogInfo24X24, SvgDialogQuestion104X104 as DialogQuestion104X104, SvgDialogQuestion16X16 as DialogQuestion16X16, SvgDialogQuestion24X24 as DialogQuestion24X24, SvgDialogWarning104X104 as DialogWarning104X104, SvgDialogWarning16X16 as DialogWarning16X16, SvgDialogWarning24X24 as DialogWarning24X24, SvgDigitalWallet104X104 as DigitalWallet104X104, SvgDigitalWallet64X64 as DigitalWallet64X64, SvgDigitalWalletPayment104X104 as DigitalWalletPayment104X104, SvgDigitalWalletPayment64X64 as DigitalWalletPayment64X64, SvgDislike104X104 as Dislike104X104, SvgDislike16X16 as Dislike16X16, SvgDislike24X24 as Dislike24X24, SvgDislike64X64 as Dislike64X64, SvgDocument104X104 as Document104X104, SvgDocument16X16 as Document16X16, SvgDocument24X24 as Document24X24, SvgDocumentAdd104X104 as DocumentAdd104X104, SvgDocumentAdd16X16 as DocumentAdd16X16, SvgDocumentAdd24X24 as DocumentAdd24X24, SvgDocumentCash104X104 as DocumentCash104X104, SvgDocumentCash16X16 as DocumentCash16X16, SvgDocumentCash24X24 as DocumentCash24X24, SvgDocumentChecked104X104 as DocumentChecked104X104, SvgDocumentChecked16X16 as DocumentChecked16X16, SvgDocumentChecked24X24 as DocumentChecked24X24, SvgDocumentError104X104 as DocumentError104X104, SvgDocumentError16X16 as DocumentError16X16, SvgDocumentError24X24 as DocumentError24X24, SvgDownload104X104 as Download104X104, SvgDownload16X16 as Download16X16, SvgDownload24X24 as Download24X24, SvgEcology104X104 as Ecology104X104, SvgEcology16X16 as Ecology16X16, SvgEcology24X24 as Ecology24X24, SvgEdit104X104 as Edit104X104, SvgEdit16X16 as Edit16X16, SvgEdit24X24 as Edit24X24, SvgExclamation16X16 as Exclamation16X16, SvgExclamation24X24 as Exclamation24X24, SvgExit16X16 as Exit16X16, SvgExit24X24 as Exit24X24, SvgExpand104X104 as Expand104X104, SvgExpand16X16 as Expand16X16, SvgExpand24X24 as Expand24X24, SvgExpand64X64 as Expand64X64, SvgFashion104X104 as Fashion104X104, SvgFashion16X16 as Fashion16X16, SvgFashion24X24 as Fashion24X24, SvgFashion64X64 as Fashion64X64, SvgFastFood104X104 as FastFood104X104, SvgFastFood16X16 as FastFood16X16, SvgFastFood24X24 as FastFood24X24, SvgFastFood64X64 as FastFood64X64, SvgFeedbackError104X104 as FeedbackError104X104, SvgFeedbackError16X16 as FeedbackError16X16, SvgFeedbackError24X24 as FeedbackError24X24, SvgFeedbackInfo104X104 as FeedbackInfo104X104, SvgFeedbackInfo16X16 as FeedbackInfo16X16, SvgFeedbackInfo24X24 as FeedbackInfo24X24, SvgFeedbackQuestion104X104 as FeedbackQuestion104X104, SvgFeedbackQuestion16X16 as FeedbackQuestion16X16, SvgFeedbackQuestion24X24 as FeedbackQuestion24X24, SvgFeedbackSuccess104X104 as FeedbackSuccess104X104, SvgFeedbackSuccess16X16 as FeedbackSuccess16X16, SvgFeedbackSuccess24X24 as FeedbackSuccess24X24, SvgFeedbackSuccess64X64 as FeedbackSuccess64X64, SvgFilter104X104 as Filter104X104, SvgFilter16X16 as Filter16X16, SvgFilter24X24 as Filter24X24, SvgFinancialFeedbackError104X104 as FinancialFeedbackError104X104, SvgFinancialFeedbackError16X16 as FinancialFeedbackError16X16, SvgFinancialFeedbackError24X24 as FinancialFeedbackError24X24, SvgFinancialFeedbackError64X64 as FinancialFeedbackError64X64, SvgFinancialFeedbackSuccess104X104 as FinancialFeedbackSuccess104X104, SvgFinancialFeedbackSuccess16X16 as FinancialFeedbackSuccess16X16, SvgFinancialFeedbackSuccess24X24 as FinancialFeedbackSuccess24X24, SvgFinancialFeedbackSuccess64X64 as FinancialFeedbackSuccess64X64, SvgFinancialFeedbackWaiting104X104 as FinancialFeedbackWaiting104X104, SvgFinancialFeedbackWaiting16X16 as FinancialFeedbackWaiting16X16, SvgFinancialFeedbackWaiting24X24 as FinancialFeedbackWaiting24X24, SvgFinancialFeedbackWaiting64X64 as FinancialFeedbackWaiting64X64, SvgFirstAidKit104X104 as FirstAidKit104X104, SvgFirstAidKit16X16 as FirstAidKit16X16, SvgFirstAidKit24X24 as FirstAidKit24X24, SvgFlash104X104 as Flash104X104, SvgFlash16X16 as Flash16X16, SvgFlash24X24 as Flash24X24, SvgFlashOff104X104 as FlashOff104X104, SvgFlashOff16X16 as FlashOff16X16, SvgFlashOff24X24 as FlashOff24X24, SvgFlow104X104 as Flow104X104, SvgFlow16X16 as Flow16X16, SvgFlow24X24 as Flow24X24, SvgFolder104X104 as Folder104X104, SvgFolder16X16 as Folder16X16, SvgFolder24X24 as Folder24X24, SvgFolder64X64 as Folder64X64, SvgFootprint104X104 as Footprint104X104, SvgFootprint16X16 as Footprint16X16, SvgFootprint24X24 as Footprint24X24, SvgFootprint64X64 as Footprint64X64, SvgGallery104X104 as Gallery104X104, SvgGallery16X16 as Gallery16X16, SvgGallery24X24 as Gallery24X24, SvgGallery40X40 as Gallery40X40, SvgGallery56X56 as Gallery56X56, SvgGallery72X72 as Gallery72X72, SvgGift104X104 as Gift104X104, SvgGift16X16 as Gift16X16, SvgGift24X24 as Gift24X24, SvgGoal104X104 as Goal104X104, SvgGoal16X16 as Goal16X16, SvgGoal24X24 as Goal24X24, SvgGraduation104X104 as Graduation104X104, SvgGraduation16X16 as Graduation16X16, SvgGraduation24X24 as Graduation24X24, SvgHanger104X104 as Hanger104X104, SvgHanger16X16 as Hanger16X16, SvgHanger24X24 as Hanger24X24, SvgHanger64X64 as Hanger64X64, SvgHealthcare104X104 as Healthcare104X104, SvgHealthcare16X16 as Healthcare16X16, SvgHealthcare24X24 as Healthcare24X24, SvgHeart104X104 as Heart104X104, SvgHeart16X16 as Heart16X16, SvgHeart24X24 as Heart24X24, SvgHeartFilled104X104 as HeartFilled104X104, SvgHeartFilled16X16 as HeartFilled16X16, SvgHeartFilled24X24 as HeartFilled24X24, SvgHome104X104 as Home104X104, SvgHome16X16 as Home16X16, SvgHome24X24 as Home24X24, SvgHouse104X104 as House104X104, SvgHouse16X16 as House16X16, SvgHouse24X24 as House24X24, SvgKey104X104 as Key104X104, SvgKey16X16 as Key16X16, SvgKey24X24 as Key24X24, SvgLamp104X104 as Lamp104X104, SvgLamp16X16 as Lamp16X16, SvgLamp24X24 as Lamp24X24, SvgLeaf104X104 as Leaf104X104, SvgLeaf16X16 as Leaf16X16, SvgLeaf24X24 as Leaf24X24, SvgLike104X104 as Like104X104, SvgLike16X16 as Like16X16, SvgLike24X24 as Like24X24, SvgLike64X64 as Like64X64, SvgListBullet104X104 as ListBullet104X104, SvgListBullet16X16 as ListBullet16X16, SvgListBullet24X24 as ListBullet24X24, SvgLocation104X104 as Location104X104, SvgLocation16X16 as Location16X16, SvgLocation24X24 as Location24X24, SvgMailClosed104X104 as MailClosed104X104, SvgMailClosed16X16 as MailClosed16X16, SvgMailClosed24X24 as MailClosed24X24, SvgMailOpen104X104 as MailOpen104X104, SvgMailOpen16X16 as MailOpen16X16, SvgMailOpen24X24 as MailOpen24X24, SvgMailOpen64X64 as MailOpen64X64, SvgMedal104X104 as Medal104X104, SvgMedal16X16 as Medal16X16, SvgMedal24X24 as Medal24X24, SvgMenu104X104 as Menu104X104, SvgMenu16X16 as Menu16X16, SvgMenu24X24 as Menu24X24, SvgMicrophone104X104 as Microphone104X104, SvgMicrophone16X16 as Microphone16X16, SvgMicrophone24X24 as Microphone24X24, SvgMoney104X104 as Money104X104, SvgMoney16X16 as Money16X16, SvgMoney24X24 as Money24X24, SvgMotorcycle104X104 as Motorcycle104X104, SvgMotorcycle16X16 as Motorcycle16X16, SvgMotorcycle24X24 as Motorcycle24X24, SvgNotebook104X104 as Notebook104X104, SvgNotebook16X16 as Notebook16X16, SvgNotebook24X24 as Notebook24X24, SvgNotification104X104 as Notification104X104, SvgNotification16X16 as Notification16X16, SvgNotification24X24 as Notification24X24, SvgOpenFinance104X104 as OpenFinance104X104, SvgOpenFinance24X24 as OpenFinance24X24, SvgOpenFinanceFilled104X104 as OpenFinanceFilled104X104, SvgOpenFinanceFilled24X24 as OpenFinanceFilled24X24, SvgOperationCardIn104X104 as OperationCardIn104X104, SvgOperationCardIn16X16 as OperationCardIn16X16, SvgOperationCardIn24X24 as OperationCardIn24X24, SvgOperationCardOut104X104 as OperationCardOut104X104, SvgOperationCardOut16X16 as OperationCardOut16X16, SvgOperationCardOut24X24 as OperationCardOut24X24, SvgOrderDown16X16 as OrderDown16X16, SvgOrderDown24X24 as OrderDown24X24, SvgOrderNoPosition16X16 as OrderNoPosition16X16, SvgOrderNoPosition24X24 as OrderNoPosition24X24, SvgOrderUp16X16 as OrderUp16X16, SvgOrderUp24X24 as OrderUp24X24, SvgPadlockClosed104X104 as PadlockClosed104X104, SvgPadlockClosed16X16 as PadlockClosed16X16, SvgPadlockClosed24X24 as PadlockClosed24X24, SvgPadlockOpen104X104 as PadlockOpen104X104, SvgPadlockOpen16X16 as PadlockOpen16X16, SvgPadlockOpen24X24 as PadlockOpen24X24, SvgPassword104X104 as Password104X104, SvgPassword16X16 as Password16X16, SvgPassword24X24 as Password24X24, SvgPatrimony104X104 as Patrimony104X104, SvgPatrimony16X16 as Patrimony16X16, SvgPatrimony24X24 as Patrimony24X24, SvgPay104X104 as Pay104X104, SvgPay16X16 as Pay16X16, SvgPay24X24 as Pay24X24, SvgPayment104X104 as Payment104X104, SvgPayment16X16 as Payment16X16, SvgPayment24X24 as Payment24X24, SvgPaymentCheckbook104X104 as PaymentCheckbook104X104, SvgPaymentCheckbook16X16 as PaymentCheckbook16X16, SvgPaymentCheckbook24X24 as PaymentCheckbook24X24, SvgPeople104X104 as People104X104, SvgPeople16X16 as People16X16, SvgPeople24X24 as People24X24, SvgPercent104X104 as Percent104X104, SvgPercent16X16 as Percent16X16, SvgPercent24X24 as Percent24X24, SvgPhone104X104 as Phone104X104, SvgPhone16X16 as Phone16X16, SvgPhone24X24 as Phone24X24, SvgPieChart104X104 as PieChart104X104, SvgPieChart16X16 as PieChart16X16, SvgPieChart24X24 as PieChart24X24, SvgPin104X104 as Pin104X104, SvgPin16X16 as Pin16X16, SvgPin24X24 as Pin24X24, SvgPinFilled104X104 as PinFilled104X104, SvgPinFilled16X16 as PinFilled16X16, SvgPinFilled24X24 as PinFilled24X24, SvgPix104X104 as Pix104X104, SvgPix24X24 as Pix24X24, SvgPixFilled104X104 as PixFilled104X104, SvgPixFilled24X24 as PixFilled24X24, SvgPlane104X104 as Plane104X104, SvgPlane16X16 as Plane16X16, SvgPlane24X24 as Plane24X24, SvgPlay104X104 as Play104X104, SvgPlay16X16 as Play16X16, SvgPlay24X24 as Play24X24, SvgPlus104X104 as Plus104X104, SvgPlus16X16 as Plus16X16, SvgPlus24X24 as Plus24X24, SvgPointsAdjust104X104 as PointsAdjust104X104, SvgPointsAdjust16X16 as PointsAdjust16X16, SvgPointsAdjust24X24 as PointsAdjust24X24, SvgPointsEarn104X104 as PointsEarn104X104, SvgPointsEarn16X16 as PointsEarn16X16, SvgPointsEarn24X24 as PointsEarn24X24, SvgPointsExpire104X104 as PointsExpire104X104, SvgPointsExpire16X16 as PointsExpire16X16, SvgPointsExpire24X24 as PointsExpire24X24, SvgPointsRedeem104X104 as PointsRedeem104X104, SvgPointsRedeem16X16 as PointsRedeem16X16, SvgPointsRedeem24X24 as PointsRedeem24X24, SvgPointsRefund104X104 as PointsRefund104X104, SvgPointsRefund16X16 as PointsRefund16X16, SvgPointsRefund24X24 as PointsRefund24X24, SvgPresentation104X104 as Presentation104X104, SvgPresentation16X16 as Presentation16X16, SvgPresentation24X24 as Presentation24X24, SvgPrevidence104X104 as Previdence104X104, SvgPrevidence16X16 as Previdence16X16, SvgPrevidence24X24 as Previdence24X24, SvgPrinter104X104 as Printer104X104, SvgPrinter16X16 as Printer16X16, SvgPrinter24X24 as Printer24X24, SvgPrinter64X64 as Printer64X64, SvgQrCode104X104 as QrCode104X104, SvgQrCode24X24 as QrCode24X24, SvgRadio24X24 as Radio24X24, SvgRadioFilled24X24 as RadioFilled24X24, SvgReceipt104X104 as Receipt104X104, SvgReceipt16X16 as Receipt16X16, SvgReceipt24X24 as Receipt24X24, SvgReceipt64X64 as Receipt64X64, SvgRefresh104X104 as Refresh104X104, SvgRefresh16X16 as Refresh16X16, SvgRefresh24X24 as Refresh24X24, SvgRefreshWeb104X104 as RefreshWeb104X104, SvgRefreshWeb16X16 as RefreshWeb16X16, SvgRefreshWeb24X24 as RefreshWeb24X24, SvgRelationship104X104 as Relationship104X104, SvgRelationship16X16 as Relationship16X16, SvgRelationship24X24 as Relationship24X24, SvgReport104X104 as Report104X104, SvgReport16X16 as Report16X16, SvgReport24X24 as Report24X24, SvgReportMedical104X104 as ReportMedical104X104, SvgReportMedical16X16 as ReportMedical16X16, SvgReportMedical24X24 as ReportMedical24X24, SvgResultChartNegative104X104 as ResultChartNegative104X104, SvgResultChartNegative16X16 as ResultChartNegative16X16, SvgResultChartNegative24X24 as ResultChartNegative24X24, SvgResultChartPositive104X104 as ResultChartPositive104X104, SvgResultChartPositive16X16 as ResultChartPositive16X16, SvgResultChartPositive24X24 as ResultChartPositive24X24, SvgRobot104X104 as Robot104X104, SvgRobot16X16 as Robot16X16, SvgRobot24X24 as Robot24X24, SvgRobot64X64 as Robot64X64, SvgSac104X104 as Sac104X104, SvgSac16X16 as Sac16X16, SvgSac24X24 as Sac24X24, SvgSafe104X104 as Safe104X104, SvgSafe16X16 as Safe16X16, SvgSafe24X24 as Safe24X24, SvgSafeBox104X104 as SafeBox104X104, SvgSafeBox16X16 as SafeBox16X16, SvgSafeBox24X24 as SafeBox24X24, SvgSatisfactionDissatisfied104X104 as SatisfactionDissatisfied104X104, SvgSatisfactionDissatisfied16X16 as SatisfactionDissatisfied16X16, SvgSatisfactionDissatisfied24X24 as SatisfactionDissatisfied24X24, SvgSatisfactionDissatisfied64X64 as SatisfactionDissatisfied64X64, SvgSatisfactionNeutral104X104 as SatisfactionNeutral104X104, SvgSatisfactionNeutral16X16 as SatisfactionNeutral16X16, SvgSatisfactionNeutral24X24 as SatisfactionNeutral24X24, SvgSatisfactionNeutral64X64 as SatisfactionNeutral64X64, SvgSatisfactionSatisfied104X104 as SatisfactionSatisfied104X104, SvgSatisfactionSatisfied16X16 as SatisfactionSatisfied16X16, SvgSatisfactionSatisfied24X24 as SatisfactionSatisfied24X24, SvgSatisfactionSatisfied64X64 as SatisfactionSatisfied64X64, SvgSavings104X104 as Savings104X104, SvgSavings16X16 as Savings16X16, SvgSavings24X24 as Savings24X24, SvgSearch104X104 as Search104X104, SvgSearch16X16 as Search16X16, SvgSearch24X24 as Search24X24, SvgSettings104X104 as Settings104X104, SvgSettings16X16 as Settings16X16, SvgSettings24X24 as Settings24X24, SvgShare104X104 as Share104X104, SvgShare16X16 as Share16X16, SvgShare24X24 as Share24X24, SvgShip104X104 as Ship104X104, SvgShip16X16 as Ship16X16, SvgShip24X24 as Ship24X24, SvgSmartphone104X104 as Smartphone104X104, SvgSmartphone16X16 as Smartphone16X16, SvgSmartphone24X24 as Smartphone24X24, SvgSmartphoneAdd104X104 as SmartphoneAdd104X104, SvgSmartphoneAdd16X16 as SmartphoneAdd16X16, SvgSmartphoneAdd24X24 as SmartphoneAdd24X24, SvgSmartwatch104X104 as Smartwatch104X104, SvgSmartwatch16X16 as Smartwatch16X16, SvgSmartwatch24X24 as Smartwatch24X24, SvgSocialCapital104X104 as SocialCapital104X104, SvgSocialCapital16X16 as SocialCapital16X16, SvgSocialCapital24X24 as SocialCapital24X24, SvgSocialCapital64X64 as SocialCapital64X64, SvgSofa104X104 as Sofa104X104, SvgSofa16X16 as Sofa16X16, SvgSofa24X24 as Sofa24X24, SvgSolarPower104X104 as SolarPower104X104, SvgSolarPower16X16 as SolarPower16X16, SvgSolarPower24X24 as SolarPower24X24, SvgSound104X104 as Sound104X104, SvgSound16X16 as Sound16X16, SvgSound24X24 as Sound24X24, SvgStackedCash104X104 as StackedCash104X104, SvgStackedCash16X16 as StackedCash16X16, SvgStackedCash24X24 as StackedCash24X24, SvgStar104X104 as Star104X104, SvgStar16X16 as Star16X16, SvgStar24X24 as Star24X24, SvgStar64X64 as Star64X64, SvgStarFilled104X104 as StarFilled104X104, SvgStarFilled16X16 as StarFilled16X16, SvgStarFilled24X24 as StarFilled24X24, SvgStarFilled64X64 as StarFilled64X64, SvgStarServices104X104 as StarServices104X104, SvgStarServices16X16 as StarServices16X16, SvgStarServices24X24 as StarServices24X24, SvgStepperDecrease16X16 as StepperDecrease16X16, SvgStepperDecrease24X24 as StepperDecrease24X24, SvgStepperIncrease16X16 as StepperIncrease16X16, SvgStepperIncrease24X24 as StepperIncrease24X24, SvgStore104X104 as Store104X104, SvgStore16X16 as Store16X16, SvgStore24X24 as Store24X24, SvgSwitch24X24 as Switch24X24, SvgSync104X104 as Sync104X104, SvgSync16X16 as Sync16X16, SvgSync24X24 as Sync24X24, SvgTarget104X104 as Target104X104, SvgTarget16X16 as Target16X16, SvgTarget24X24 as Target24X24, SvgTools104X104 as Tools104X104, SvgTools16X16 as Tools16X16, SvgTools24X24 as Tools24X24, SvgTractor104X104 as Tractor104X104, SvgTractor16X16 as Tractor16X16, SvgTractor24X24 as Tractor24X24, SvgTrash104X104 as Trash104X104, SvgTrash16X16 as Trash16X16, SvgTrash24X24 as Trash24X24, SvgTrophy104X104 as Trophy104X104, SvgTrophy16X16 as Trophy16X16, SvgTrophy24X24 as Trophy24X24, SvgTruck104X104 as Truck104X104, SvgTruck16X16 as Truck16X16, SvgTruck24X24 as Truck24X24, SvgUmbrella104X104 as Umbrella104X104, SvgUmbrella16X16 as Umbrella16X16, SvgUmbrella24X24 as Umbrella24X24, SvgUmbrella64X64 as Umbrella64X64, SvgUndo104X104 as Undo104X104, SvgUndo16X16 as Undo16X16, SvgUndo24X24 as Undo24X24, SvgUndo64X64 as Undo64X64, SvgUpload104X104 as Upload104X104, SvgUpload16X16 as Upload16X16, SvgUpload24X24 as Upload24X24, SvgUser104X104 as User104X104, SvgUser16X16 as User16X16, SvgUser24X24 as User24X24, SvgUser32X32 as User32X32, SvgUser40X40 as User40X40, SvgUser56X56 as User56X56, SvgUserTie104X104 as UserTie104X104, SvgUserTie16X16 as UserTie16X16, SvgUserTie24X24 as UserTie24X24, SvgVehicle104X104 as Vehicle104X104, SvgVehicle16X16 as Vehicle16X16, SvgVehicle24X24 as Vehicle24X24, SvgViewer104X104 as Viewer104X104, SvgViewer16X16 as Viewer16X16, SvgViewer24X24 as Viewer24X24, SvgViewerOff104X104 as ViewerOff104X104, SvgViewerOff16X16 as ViewerOff16X16, SvgViewerOff24X24 as ViewerOff24X24, SvgWallet104X104 as Wallet104X104, SvgWallet16X16 as Wallet16X16, SvgWallet24X24 as Wallet24X24, SvgWeb104X104 as Web104X104, SvgWeb16X16 as Web16X16, SvgWeb24X24 as Web24X24, SvgWebChannel104X104 as WebChannel104X104, SvgWebChannel16X16 as WebChannel16X16, SvgWebChannel24X24 as WebChannel24X24, SvgWhatsapp104X104 as Whatsapp104X104, SvgWhatsapp16X16 as Whatsapp16X16, SvgWhatsapp24X24 as Whatsapp24X24, SvgWhatsapp64X64 as Whatsapp64X64, SvgWheelchair104X104 as Wheelchair104X104, SvgWheelchair16X16 as Wheelchair16X16, SvgWheelchair24X24 as Wheelchair24X24, SvgWifi104X104 as Wifi104X104, SvgWifi16X16 as Wifi16X16, SvgWifi24X24 as Wifi24X24, SvgWifiError104X104 as WifiError104X104, SvgWifiError16X16 as WifiError16X16, SvgWifiError24X24 as WifiError24X24 };
